import * as m_ from "vue";
import { defineComponent as Tt, toRef as aa, computed as oe, resolveDynamicComponent as Sl, h as Ct, toValue as xn, unref as j, onMounted as Mt, getCurrentInstance as ui, provide as Dr, isRef as Si, watch as dn, onBeforeUnmount as qw, inject as qn, ref as fe, reactive as Uo, onUnmounted as Bn, nextTick as $a, resolveComponent as je, openBlock as I, createElementBlock as W, createVNode as Ae, normalizeClass as ze, createElementVNode as K, toDisplayString as ke, createTextVNode as Xt, createCommentVNode as ee, withDirectives as Ni, vModelText as dm, Fragment as Ge, renderList as Nt, useSlots as fm, mergeProps as zn, createSlots as Or, withCtx as Ve, renderSlot as Ee, normalizeProps as Wr, guardReactiveProps as ua, createBlock as Oe, Teleport as Kw, withKeys as _t, withModifiers as nr, Transition as Wo, normalizeStyle as ca, vShow as Ol, onBeforeUpdate as nI, getCurrentScope as rI, onScopeDispose as iI, watchEffect as _r, cloneVNode as aI, shallowRef as su, vModelCheckbox as oI, vModelSelect as sI, effectScope as lI, onBeforeMount as uI, Text as cI, createStaticVNode as dI, resolveDirective as fI } from "vue";
var hI = Object.create, Xw = Object.defineProperty, pI = Object.getOwnPropertyDescriptor, hm = Object.getOwnPropertyNames, mI = Object.getPrototypeOf, gI = Object.prototype.hasOwnProperty, vI = (e, t) => function() {
  return e && (t = (0, e[hm(e)[0]])(e = 0)), t;
}, _I = (e, t) => function() {
  return t || (0, e[hm(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, yI = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let i of hm(t))
      !gI.call(e, i) && i !== n && Xw(e, i, { get: () => t[i], enumerable: !(r = pI(t, i)) || r.enumerable });
  return e;
}, bI = (e, t, n) => (n = e != null ? hI(mI(e)) : {}, yI(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Xw(n, "default", { value: e, enumerable: !0 }),
  e
)), lu = vI({
  "../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.0_@types+node@22.10.1__@swc+core@1.5.29_jiti@2.0.0_p_swvvp2d4pgn6xuiiec4l4x2i7a/node_modules/tsup/assets/esm_shims.js"() {
  }
}), wI = _I({
  "../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js"(e, t) {
    lu(), t.exports = r;
    function n(a) {
      return a instanceof Buffer ? Buffer.from(a) : new a.constructor(a.buffer.slice(), a.byteOffset, a.length);
    }
    function r(a) {
      if (a = a || {}, a.circles) return i(a);
      const o = /* @__PURE__ */ new Map();
      if (o.set(Date, (p) => new Date(p)), o.set(Map, (p, m) => new Map(u(Array.from(p), m))), o.set(Set, (p, m) => new Set(u(Array.from(p), m))), a.constructorHandlers)
        for (const p of a.constructorHandlers)
          o.set(p[0], p[1]);
      let s = null;
      return a.proto ? f : d;
      function u(p, m) {
        const g = Object.keys(p), v = new Array(g.length);
        for (let b = 0; b < g.length; b++) {
          const w = g[b], T = p[w];
          typeof T != "object" || T === null ? v[w] = T : T.constructor !== Object && (s = o.get(T.constructor)) ? v[w] = s(T, m) : ArrayBuffer.isView(T) ? v[w] = n(T) : v[w] = m(T);
        }
        return v;
      }
      function d(p) {
        if (typeof p != "object" || p === null) return p;
        if (Array.isArray(p)) return u(p, d);
        if (p.constructor !== Object && (s = o.get(p.constructor)))
          return s(p, d);
        const m = {};
        for (const g in p) {
          if (Object.hasOwnProperty.call(p, g) === !1) continue;
          const v = p[g];
          typeof v != "object" || v === null ? m[g] = v : v.constructor !== Object && (s = o.get(v.constructor)) ? m[g] = s(v, d) : ArrayBuffer.isView(v) ? m[g] = n(v) : m[g] = d(v);
        }
        return m;
      }
      function f(p) {
        if (typeof p != "object" || p === null) return p;
        if (Array.isArray(p)) return u(p, f);
        if (p.constructor !== Object && (s = o.get(p.constructor)))
          return s(p, f);
        const m = {};
        for (const g in p) {
          const v = p[g];
          typeof v != "object" || v === null ? m[g] = v : v.constructor !== Object && (s = o.get(v.constructor)) ? m[g] = s(v, f) : ArrayBuffer.isView(v) ? m[g] = n(v) : m[g] = f(v);
        }
        return m;
      }
    }
    function i(a) {
      const o = [], s = [], u = /* @__PURE__ */ new Map();
      if (u.set(Date, (g) => new Date(g)), u.set(Map, (g, v) => new Map(f(Array.from(g), v))), u.set(Set, (g, v) => new Set(f(Array.from(g), v))), a.constructorHandlers)
        for (const g of a.constructorHandlers)
          u.set(g[0], g[1]);
      let d = null;
      return a.proto ? m : p;
      function f(g, v) {
        const b = Object.keys(g), w = new Array(b.length);
        for (let T = 0; T < b.length; T++) {
          const S = b[T], x = g[S];
          if (typeof x != "object" || x === null)
            w[S] = x;
          else if (x.constructor !== Object && (d = u.get(x.constructor)))
            w[S] = d(x, v);
          else if (ArrayBuffer.isView(x))
            w[S] = n(x);
          else {
            const O = o.indexOf(x);
            O !== -1 ? w[S] = s[O] : w[S] = v(x);
          }
        }
        return w;
      }
      function p(g) {
        if (typeof g != "object" || g === null) return g;
        if (Array.isArray(g)) return f(g, p);
        if (g.constructor !== Object && (d = u.get(g.constructor)))
          return d(g, p);
        const v = {};
        o.push(g), s.push(v);
        for (const b in g) {
          if (Object.hasOwnProperty.call(g, b) === !1) continue;
          const w = g[b];
          if (typeof w != "object" || w === null)
            v[b] = w;
          else if (w.constructor !== Object && (d = u.get(w.constructor)))
            v[b] = d(w, p);
          else if (ArrayBuffer.isView(w))
            v[b] = n(w);
          else {
            const T = o.indexOf(w);
            T !== -1 ? v[b] = s[T] : v[b] = p(w);
          }
        }
        return o.pop(), s.pop(), v;
      }
      function m(g) {
        if (typeof g != "object" || g === null) return g;
        if (Array.isArray(g)) return f(g, m);
        if (g.constructor !== Object && (d = u.get(g.constructor)))
          return d(g, m);
        const v = {};
        o.push(g), s.push(v);
        for (const b in g) {
          const w = g[b];
          if (typeof w != "object" || w === null)
            v[b] = w;
          else if (w.constructor !== Object && (d = u.get(w.constructor)))
            v[b] = d(w, m);
          else if (ArrayBuffer.isView(w))
            v[b] = n(w);
          else {
            const T = o.indexOf(w);
            T !== -1 ? v[b] = s[T] : v[b] = m(w);
          }
        }
        return o.pop(), s.pop(), v;
      }
    }
  }
});
lu();
lu();
lu();
var Zw = typeof navigator < "u", Le = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : {};
typeof Le.chrome < "u" && Le.chrome.devtools;
Zw && (Le.self, Le.top);
var g_;
typeof navigator < "u" && ((g_ = navigator.userAgent) == null || g_.toLowerCase().includes("electron"));
lu();
var xI = bI(wI()), EI = /(?:^|[-_/])(\w)/g;
function TI(e, t) {
  return t ? t.toUpperCase() : "";
}
function kI(e) {
  return e && `${e}`.replace(EI, TI);
}
function SI(e, t) {
  let n = e.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
  n.endsWith(`index${t}`) && (n = n.replace(`/index${t}`, t));
  const r = n.lastIndexOf("/"), i = n.substring(r + 1);
  {
    const a = i.lastIndexOf(t);
    return i.substring(0, a);
  }
}
var v_ = (0, xI.default)({ circles: !0 });
const OI = {
  trailing: !0
};
function bs(e, t = 25, n = {}) {
  if (n = { ...OI, ...n }, !Number.isFinite(t))
    throw new TypeError("Expected `wait` to be a finite number");
  let r, i, a = [], o, s;
  const u = (d, f) => (o = CI(e, d, f), o.finally(() => {
    if (o = null, n.trailing && s && !i) {
      const p = u(d, s);
      return s = null, p;
    }
  }), o);
  return function(...d) {
    return o ? (n.trailing && (s = d), o) : new Promise((f) => {
      const p = !i && n.leading;
      clearTimeout(i), i = setTimeout(() => {
        i = null;
        const m = n.leading ? r : u(this, d);
        for (const g of a)
          g(m);
        a = [];
      }, t), p ? (r = u(this, d), f(r)) : a.push(f);
    });
  };
}
async function CI(e, t, n) {
  return await e.apply(t, n);
}
function up(e, t = {}, n) {
  for (const r in e) {
    const i = e[r], a = n ? `${n}:${r}` : r;
    typeof i == "object" && i !== null ? up(i, t, a) : typeof i == "function" && (t[a] = i);
  }
  return t;
}
const AI = { run: (e) => e() }, DI = () => AI, Qw = typeof console.createTask < "u" ? console.createTask : DI;
function PI(e, t) {
  const n = t.shift(), r = Qw(n);
  return e.reduce(
    (i, a) => i.then(() => r.run(() => a(...t))),
    Promise.resolve()
  );
}
function MI(e, t) {
  const n = t.shift(), r = Qw(n);
  return Promise.all(e.map((i) => r.run(() => i(...t))));
}
function xh(e, t) {
  for (const n of [...e])
    n(t);
}
class II {
  constructor() {
    this._hooks = {}, this._before = void 0, this._after = void 0, this._deprecatedMessages = void 0, this._deprecatedHooks = {}, this.hook = this.hook.bind(this), this.callHook = this.callHook.bind(this), this.callHookWith = this.callHookWith.bind(this);
  }
  hook(t, n, r = {}) {
    if (!t || typeof n != "function")
      return () => {
      };
    const i = t;
    let a;
    for (; this._deprecatedHooks[t]; )
      a = this._deprecatedHooks[t], t = a.to;
    if (a && !r.allowDeprecated) {
      let o = a.message;
      o || (o = `${i} hook has been deprecated` + (a.to ? `, please use ${a.to}` : "")), this._deprecatedMessages || (this._deprecatedMessages = /* @__PURE__ */ new Set()), this._deprecatedMessages.has(o) || (console.warn(o), this._deprecatedMessages.add(o));
    }
    if (!n.name)
      try {
        Object.defineProperty(n, "name", {
          get: () => "_" + t.replace(/\W+/g, "_") + "_hook_cb",
          configurable: !0
        });
      } catch {
      }
    return this._hooks[t] = this._hooks[t] || [], this._hooks[t].push(n), () => {
      n && (this.removeHook(t, n), n = void 0);
    };
  }
  hookOnce(t, n) {
    let r, i = (...a) => (typeof r == "function" && r(), r = void 0, i = void 0, n(...a));
    return r = this.hook(t, i), r;
  }
  removeHook(t, n) {
    if (this._hooks[t]) {
      const r = this._hooks[t].indexOf(n);
      r !== -1 && this._hooks[t].splice(r, 1), this._hooks[t].length === 0 && delete this._hooks[t];
    }
  }
  deprecateHook(t, n) {
    this._deprecatedHooks[t] = typeof n == "string" ? { to: n } : n;
    const r = this._hooks[t] || [];
    delete this._hooks[t];
    for (const i of r)
      this.hook(t, i);
  }
  deprecateHooks(t) {
    Object.assign(this._deprecatedHooks, t);
    for (const n in t)
      this.deprecateHook(n, t[n]);
  }
  addHooks(t) {
    const n = up(t), r = Object.keys(n).map(
      (i) => this.hook(i, n[i])
    );
    return () => {
      for (const i of r.splice(0, r.length))
        i();
    };
  }
  removeHooks(t) {
    const n = up(t);
    for (const r in n)
      this.removeHook(r, n[r]);
  }
  removeAllHooks() {
    for (const t in this._hooks)
      delete this._hooks[t];
  }
  callHook(t, ...n) {
    return n.unshift(t), this.callHookWith(PI, t, ...n);
  }
  callHookParallel(t, ...n) {
    return n.unshift(t), this.callHookWith(MI, t, ...n);
  }
  callHookWith(t, n, ...r) {
    const i = this._before || this._after ? { name: n, args: r, context: {} } : void 0;
    this._before && xh(this._before, i);
    const a = t(
      n in this._hooks ? [...this._hooks[n]] : [],
      r
    );
    return a instanceof Promise ? a.finally(() => {
      this._after && i && xh(this._after, i);
    }) : (this._after && i && xh(this._after, i), a);
  }
  beforeEach(t) {
    return this._before = this._before || [], this._before.push(t), () => {
      if (this._before !== void 0) {
        const n = this._before.indexOf(t);
        n !== -1 && this._before.splice(n, 1);
      }
    };
  }
  afterEach(t) {
    return this._after = this._after || [], this._after.push(t), () => {
      if (this._after !== void 0) {
        const n = this._after.indexOf(t);
        n !== -1 && this._after.splice(n, 1);
      }
    };
  }
}
function Jw() {
  return new II();
}
var NI = Object.create, ex = Object.defineProperty, LI = Object.getOwnPropertyDescriptor, pm = Object.getOwnPropertyNames, RI = Object.getPrototypeOf, FI = Object.prototype.hasOwnProperty, $I = (e, t) => function() {
  return e && (t = (0, e[pm(e)[0]])(e = 0)), t;
}, tx = (e, t) => function() {
  return t || (0, e[pm(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, VI = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let i of pm(t))
      !FI.call(e, i) && i !== n && ex(e, i, { get: () => t[i], enumerable: !(r = LI(t, i)) || r.enumerable });
  return e;
}, BI = (e, t, n) => (n = e != null ? NI(RI(e)) : {}, VI(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  ex(n, "default", { value: e, enumerable: !0 }),
  e
)), ye = $I({
  "../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.0_@types+node@22.10.1__@swc+core@1.5.29_jiti@2.0.0_p_swvvp2d4pgn6xuiiec4l4x2i7a/node_modules/tsup/assets/esm_shims.js"() {
  }
}), UI = tx({
  "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js"(e, t) {
    ye(), function(n) {
      var r = {
        // latin
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "Ae",
        Å: "A",
        Æ: "AE",
        Ç: "C",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        Ð: "D",
        Ñ: "N",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "Oe",
        Ő: "O",
        Ø: "O",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "Ue",
        Ű: "U",
        Ý: "Y",
        Þ: "TH",
        ß: "ss",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "ae",
        å: "a",
        æ: "ae",
        ç: "c",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        ð: "d",
        ñ: "n",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "oe",
        ő: "o",
        ø: "o",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "ue",
        ű: "u",
        ý: "y",
        þ: "th",
        ÿ: "y",
        "ẞ": "SS",
        // language specific
        // Arabic
        ا: "a",
        أ: "a",
        إ: "i",
        آ: "aa",
        ؤ: "u",
        ئ: "e",
        ء: "a",
        ب: "b",
        ت: "t",
        ث: "th",
        ج: "j",
        ح: "h",
        خ: "kh",
        د: "d",
        ذ: "th",
        ر: "r",
        ز: "z",
        س: "s",
        ش: "sh",
        ص: "s",
        ض: "dh",
        ط: "t",
        ظ: "z",
        ع: "a",
        غ: "gh",
        ف: "f",
        ق: "q",
        ك: "k",
        ل: "l",
        م: "m",
        ن: "n",
        ه: "h",
        و: "w",
        ي: "y",
        ى: "a",
        ة: "h",
        ﻻ: "la",
        ﻷ: "laa",
        ﻹ: "lai",
        ﻵ: "laa",
        // Persian additional characters than Arabic
        گ: "g",
        چ: "ch",
        پ: "p",
        ژ: "zh",
        ک: "k",
        ی: "y",
        // Arabic diactrics
        "َ": "a",
        "ً": "an",
        "ِ": "e",
        "ٍ": "en",
        "ُ": "u",
        "ٌ": "on",
        "ْ": "",
        // Arabic numbers
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        // Persian numbers
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        // Burmese consonants
        က: "k",
        ခ: "kh",
        ဂ: "g",
        ဃ: "ga",
        င: "ng",
        စ: "s",
        ဆ: "sa",
        ဇ: "z",
        "စျ": "za",
        ည: "ny",
        ဋ: "t",
        ဌ: "ta",
        ဍ: "d",
        ဎ: "da",
        ဏ: "na",
        တ: "t",
        ထ: "ta",
        ဒ: "d",
        ဓ: "da",
        န: "n",
        ပ: "p",
        ဖ: "pa",
        ဗ: "b",
        ဘ: "ba",
        မ: "m",
        ယ: "y",
        ရ: "ya",
        လ: "l",
        ဝ: "w",
        သ: "th",
        ဟ: "h",
        ဠ: "la",
        အ: "a",
        // consonant character combos
        "ြ": "y",
        "ျ": "ya",
        "ွ": "w",
        "ြွ": "yw",
        "ျွ": "ywa",
        "ှ": "h",
        // independent vowels
        ဧ: "e",
        "၏": "-e",
        ဣ: "i",
        ဤ: "-i",
        ဉ: "u",
        ဦ: "-u",
        ဩ: "aw",
        "သြော": "aw",
        ဪ: "aw",
        // numbers
        "၀": "0",
        "၁": "1",
        "၂": "2",
        "၃": "3",
        "၄": "4",
        "၅": "5",
        "၆": "6",
        "၇": "7",
        "၈": "8",
        "၉": "9",
        // virama and tone marks which are silent in transliteration
        "္": "",
        "့": "",
        "း": "",
        // Czech
        č: "c",
        ď: "d",
        ě: "e",
        ň: "n",
        ř: "r",
        š: "s",
        ť: "t",
        ů: "u",
        ž: "z",
        Č: "C",
        Ď: "D",
        Ě: "E",
        Ň: "N",
        Ř: "R",
        Š: "S",
        Ť: "T",
        Ů: "U",
        Ž: "Z",
        // Dhivehi
        ހ: "h",
        ށ: "sh",
        ނ: "n",
        ރ: "r",
        ބ: "b",
        ޅ: "lh",
        ކ: "k",
        އ: "a",
        ވ: "v",
        މ: "m",
        ފ: "f",
        ދ: "dh",
        ތ: "th",
        ލ: "l",
        ގ: "g",
        ޏ: "gn",
        ސ: "s",
        ޑ: "d",
        ޒ: "z",
        ޓ: "t",
        ޔ: "y",
        ޕ: "p",
        ޖ: "j",
        ޗ: "ch",
        ޘ: "tt",
        ޙ: "hh",
        ޚ: "kh",
        ޛ: "th",
        ޜ: "z",
        ޝ: "sh",
        ޞ: "s",
        ޟ: "d",
        ޠ: "t",
        ޡ: "z",
        ޢ: "a",
        ޣ: "gh",
        ޤ: "q",
        ޥ: "w",
        "ަ": "a",
        "ާ": "aa",
        "ި": "i",
        "ީ": "ee",
        "ު": "u",
        "ޫ": "oo",
        "ެ": "e",
        "ޭ": "ey",
        "ޮ": "o",
        "ޯ": "oa",
        "ް": "",
        // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
        // National system (2002)
        ა: "a",
        ბ: "b",
        გ: "g",
        დ: "d",
        ე: "e",
        ვ: "v",
        ზ: "z",
        თ: "t",
        ი: "i",
        კ: "k",
        ლ: "l",
        მ: "m",
        ნ: "n",
        ო: "o",
        პ: "p",
        ჟ: "zh",
        რ: "r",
        ს: "s",
        ტ: "t",
        უ: "u",
        ფ: "p",
        ქ: "k",
        ღ: "gh",
        ყ: "q",
        შ: "sh",
        ჩ: "ch",
        ც: "ts",
        ძ: "dz",
        წ: "ts",
        ჭ: "ch",
        ხ: "kh",
        ჯ: "j",
        ჰ: "h",
        // Greek
        α: "a",
        β: "v",
        γ: "g",
        δ: "d",
        ε: "e",
        ζ: "z",
        η: "i",
        θ: "th",
        ι: "i",
        κ: "k",
        λ: "l",
        μ: "m",
        ν: "n",
        ξ: "ks",
        ο: "o",
        π: "p",
        ρ: "r",
        σ: "s",
        τ: "t",
        υ: "y",
        φ: "f",
        χ: "x",
        ψ: "ps",
        ω: "o",
        ά: "a",
        έ: "e",
        ί: "i",
        ό: "o",
        ύ: "y",
        ή: "i",
        ώ: "o",
        ς: "s",
        ϊ: "i",
        ΰ: "y",
        ϋ: "y",
        ΐ: "i",
        Α: "A",
        Β: "B",
        Γ: "G",
        Δ: "D",
        Ε: "E",
        Ζ: "Z",
        Η: "I",
        Θ: "TH",
        Ι: "I",
        Κ: "K",
        Λ: "L",
        Μ: "M",
        Ν: "N",
        Ξ: "KS",
        Ο: "O",
        Π: "P",
        Ρ: "R",
        Σ: "S",
        Τ: "T",
        Υ: "Y",
        Φ: "F",
        Χ: "X",
        Ψ: "PS",
        Ω: "O",
        Ά: "A",
        Έ: "E",
        Ί: "I",
        Ό: "O",
        Ύ: "Y",
        Ή: "I",
        Ώ: "O",
        Ϊ: "I",
        Ϋ: "Y",
        // Latvian
        ā: "a",
        // 'č': 'c', // duplicate
        ē: "e",
        ģ: "g",
        ī: "i",
        ķ: "k",
        ļ: "l",
        ņ: "n",
        // 'š': 's', // duplicate
        ū: "u",
        // 'ž': 'z', // duplicate
        Ā: "A",
        // 'Č': 'C', // duplicate
        Ē: "E",
        Ģ: "G",
        Ī: "I",
        Ķ: "k",
        Ļ: "L",
        Ņ: "N",
        // 'Š': 'S', // duplicate
        Ū: "U",
        // 'Ž': 'Z', // duplicate
        // Macedonian
        Ќ: "Kj",
        ќ: "kj",
        Љ: "Lj",
        љ: "lj",
        Њ: "Nj",
        њ: "nj",
        Тс: "Ts",
        тс: "ts",
        // Polish
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        // 'ó': 'o', // duplicate
        ś: "s",
        ź: "z",
        ż: "z",
        Ą: "A",
        Ć: "C",
        Ę: "E",
        Ł: "L",
        Ń: "N",
        Ś: "S",
        Ź: "Z",
        Ż: "Z",
        // Ukranian
        Є: "Ye",
        І: "I",
        Ї: "Yi",
        Ґ: "G",
        є: "ye",
        і: "i",
        ї: "yi",
        ґ: "g",
        // Romanian
        ă: "a",
        Ă: "A",
        ș: "s",
        Ș: "S",
        // 'ş': 's', // duplicate
        // 'Ş': 'S', // duplicate
        ț: "t",
        Ț: "T",
        ţ: "t",
        Ţ: "T",
        // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
        // ICAO
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "yo",
        ж: "zh",
        з: "z",
        и: "i",
        й: "i",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "c",
        ч: "ch",
        ш: "sh",
        щ: "sh",
        ъ: "",
        ы: "y",
        ь: "",
        э: "e",
        ю: "yu",
        я: "ya",
        А: "A",
        Б: "B",
        В: "V",
        Г: "G",
        Д: "D",
        Е: "E",
        Ё: "Yo",
        Ж: "Zh",
        З: "Z",
        И: "I",
        Й: "I",
        К: "K",
        Л: "L",
        М: "M",
        Н: "N",
        О: "O",
        П: "P",
        Р: "R",
        С: "S",
        Т: "T",
        У: "U",
        Ф: "F",
        Х: "Kh",
        Ц: "C",
        Ч: "Ch",
        Ш: "Sh",
        Щ: "Sh",
        Ъ: "",
        Ы: "Y",
        Ь: "",
        Э: "E",
        Ю: "Yu",
        Я: "Ya",
        // Serbian
        ђ: "dj",
        ј: "j",
        // 'љ': 'lj',  // duplicate
        // 'њ': 'nj', // duplicate
        ћ: "c",
        џ: "dz",
        Ђ: "Dj",
        Ј: "j",
        // 'Љ': 'Lj', // duplicate
        // 'Њ': 'Nj', // duplicate
        Ћ: "C",
        Џ: "Dz",
        // Slovak
        ľ: "l",
        ĺ: "l",
        ŕ: "r",
        Ľ: "L",
        Ĺ: "L",
        Ŕ: "R",
        // Turkish
        ş: "s",
        Ş: "S",
        ı: "i",
        İ: "I",
        // 'ç': 'c', // duplicate
        // 'Ç': 'C', // duplicate
        // 'ü': 'u', // duplicate, see langCharMap
        // 'Ü': 'U', // duplicate, see langCharMap
        // 'ö': 'o', // duplicate, see langCharMap
        // 'Ö': 'O', // duplicate, see langCharMap
        ğ: "g",
        Ğ: "G",
        // Vietnamese
        ả: "a",
        Ả: "A",
        ẳ: "a",
        Ẳ: "A",
        ẩ: "a",
        Ẩ: "A",
        đ: "d",
        Đ: "D",
        ẹ: "e",
        Ẹ: "E",
        ẽ: "e",
        Ẽ: "E",
        ẻ: "e",
        Ẻ: "E",
        ế: "e",
        Ế: "E",
        ề: "e",
        Ề: "E",
        ệ: "e",
        Ệ: "E",
        ễ: "e",
        Ễ: "E",
        ể: "e",
        Ể: "E",
        ỏ: "o",
        ọ: "o",
        Ọ: "o",
        ố: "o",
        Ố: "O",
        ồ: "o",
        Ồ: "O",
        ổ: "o",
        Ổ: "O",
        ộ: "o",
        Ộ: "O",
        ỗ: "o",
        Ỗ: "O",
        ơ: "o",
        Ơ: "O",
        ớ: "o",
        Ớ: "O",
        ờ: "o",
        Ờ: "O",
        ợ: "o",
        Ợ: "O",
        ỡ: "o",
        Ỡ: "O",
        Ở: "o",
        ở: "o",
        ị: "i",
        Ị: "I",
        ĩ: "i",
        Ĩ: "I",
        ỉ: "i",
        Ỉ: "i",
        ủ: "u",
        Ủ: "U",
        ụ: "u",
        Ụ: "U",
        ũ: "u",
        Ũ: "U",
        ư: "u",
        Ư: "U",
        ứ: "u",
        Ứ: "U",
        ừ: "u",
        Ừ: "U",
        ự: "u",
        Ự: "U",
        ữ: "u",
        Ữ: "U",
        ử: "u",
        Ử: "ư",
        ỷ: "y",
        Ỷ: "y",
        ỳ: "y",
        Ỳ: "Y",
        ỵ: "y",
        Ỵ: "Y",
        ỹ: "y",
        Ỹ: "Y",
        ạ: "a",
        Ạ: "A",
        ấ: "a",
        Ấ: "A",
        ầ: "a",
        Ầ: "A",
        ậ: "a",
        Ậ: "A",
        ẫ: "a",
        Ẫ: "A",
        // 'ă': 'a', // duplicate
        // 'Ă': 'A', // duplicate
        ắ: "a",
        Ắ: "A",
        ằ: "a",
        Ằ: "A",
        ặ: "a",
        Ặ: "A",
        ẵ: "a",
        Ẵ: "A",
        "⓪": "0",
        "①": "1",
        "②": "2",
        "③": "3",
        "④": "4",
        "⑤": "5",
        "⑥": "6",
        "⑦": "7",
        "⑧": "8",
        "⑨": "9",
        "⑩": "10",
        "⑪": "11",
        "⑫": "12",
        "⑬": "13",
        "⑭": "14",
        "⑮": "15",
        "⑯": "16",
        "⑰": "17",
        "⑱": "18",
        "⑲": "18",
        "⑳": "18",
        "⓵": "1",
        "⓶": "2",
        "⓷": "3",
        "⓸": "4",
        "⓹": "5",
        "⓺": "6",
        "⓻": "7",
        "⓼": "8",
        "⓽": "9",
        "⓾": "10",
        "⓿": "0",
        "⓫": "11",
        "⓬": "12",
        "⓭": "13",
        "⓮": "14",
        "⓯": "15",
        "⓰": "16",
        "⓱": "17",
        "⓲": "18",
        "⓳": "19",
        "⓴": "20",
        "Ⓐ": "A",
        "Ⓑ": "B",
        "Ⓒ": "C",
        "Ⓓ": "D",
        "Ⓔ": "E",
        "Ⓕ": "F",
        "Ⓖ": "G",
        "Ⓗ": "H",
        "Ⓘ": "I",
        "Ⓙ": "J",
        "Ⓚ": "K",
        "Ⓛ": "L",
        "Ⓜ": "M",
        "Ⓝ": "N",
        "Ⓞ": "O",
        "Ⓟ": "P",
        "Ⓠ": "Q",
        "Ⓡ": "R",
        "Ⓢ": "S",
        "Ⓣ": "T",
        "Ⓤ": "U",
        "Ⓥ": "V",
        "Ⓦ": "W",
        "Ⓧ": "X",
        "Ⓨ": "Y",
        "Ⓩ": "Z",
        "ⓐ": "a",
        "ⓑ": "b",
        "ⓒ": "c",
        "ⓓ": "d",
        "ⓔ": "e",
        "ⓕ": "f",
        "ⓖ": "g",
        "ⓗ": "h",
        "ⓘ": "i",
        "ⓙ": "j",
        "ⓚ": "k",
        "ⓛ": "l",
        "ⓜ": "m",
        "ⓝ": "n",
        "ⓞ": "o",
        "ⓟ": "p",
        "ⓠ": "q",
        "ⓡ": "r",
        "ⓢ": "s",
        "ⓣ": "t",
        "ⓤ": "u",
        "ⓦ": "v",
        "ⓥ": "w",
        "ⓧ": "x",
        "ⓨ": "y",
        "ⓩ": "z",
        // symbols
        "“": '"',
        "”": '"',
        "‘": "'",
        "’": "'",
        "∂": "d",
        ƒ: "f",
        "™": "(TM)",
        "©": "(C)",
        œ: "oe",
        Œ: "OE",
        "®": "(R)",
        "†": "+",
        "℠": "(SM)",
        "…": "...",
        "˚": "o",
        º: "o",
        ª: "a",
        "•": "*",
        "၊": ",",
        "။": ".",
        // currency
        $: "USD",
        "€": "EUR",
        "₢": "BRN",
        "₣": "FRF",
        "£": "GBP",
        "₤": "ITL",
        "₦": "NGN",
        "₧": "ESP",
        "₩": "KRW",
        "₪": "ILS",
        "₫": "VND",
        "₭": "LAK",
        "₮": "MNT",
        "₯": "GRD",
        "₱": "ARS",
        "₲": "PYG",
        "₳": "ARA",
        "₴": "UAH",
        "₵": "GHS",
        "¢": "cent",
        "¥": "CNY",
        元: "CNY",
        円: "YEN",
        "﷼": "IRR",
        "₠": "EWE",
        "฿": "THB",
        "₨": "INR",
        "₹": "INR",
        "₰": "PF",
        "₺": "TRY",
        "؋": "AFN",
        "₼": "AZN",
        лв: "BGN",
        "៛": "KHR",
        "₡": "CRC",
        "₸": "KZT",
        ден: "MKD",
        zł: "PLN",
        "₽": "RUB",
        "₾": "GEL"
      }, i = [
        // burmese
        "်",
        // Dhivehi
        "ް"
      ], a = {
        // Burmese
        // dependent vowels
        "ာ": "a",
        "ါ": "a",
        "ေ": "e",
        "ဲ": "e",
        "ိ": "i",
        "ီ": "i",
        "ို": "o",
        "ု": "u",
        "ူ": "u",
        "ေါင်": "aung",
        "ော": "aw",
        "ော်": "aw",
        "ေါ": "aw",
        "ေါ်": "aw",
        "်": "်",
        // this is special case but the character will be converted to latin in the code
        "က်": "et",
        "ိုက်": "aik",
        "ောက်": "auk",
        "င်": "in",
        "ိုင်": "aing",
        "ောင်": "aung",
        "စ်": "it",
        "ည်": "i",
        "တ်": "at",
        "ိတ်": "eik",
        "ုတ်": "ok",
        "ွတ်": "ut",
        "ေတ်": "it",
        "ဒ်": "d",
        "ိုဒ်": "ok",
        "ုဒ်": "ait",
        "န်": "an",
        "ာန်": "an",
        "ိန်": "ein",
        "ုန်": "on",
        "ွန်": "un",
        "ပ်": "at",
        "ိပ်": "eik",
        "ုပ်": "ok",
        "ွပ်": "ut",
        "န်ုပ်": "nub",
        "မ်": "an",
        "ိမ်": "ein",
        "ုမ်": "on",
        "ွမ်": "un",
        "ယ်": "e",
        "ိုလ်": "ol",
        "ဉ်": "in",
        "ံ": "an",
        "ိံ": "ein",
        "ုံ": "on",
        // Dhivehi
        "ައް": "ah",
        "ަށް": "ah"
      }, o = {
        en: {},
        // default language
        az: {
          // Azerbaijani
          ç: "c",
          ə: "e",
          ğ: "g",
          ı: "i",
          ö: "o",
          ş: "s",
          ü: "u",
          Ç: "C",
          Ə: "E",
          Ğ: "G",
          İ: "I",
          Ö: "O",
          Ş: "S",
          Ü: "U"
        },
        cs: {
          // Czech
          č: "c",
          ď: "d",
          ě: "e",
          ň: "n",
          ř: "r",
          š: "s",
          ť: "t",
          ů: "u",
          ž: "z",
          Č: "C",
          Ď: "D",
          Ě: "E",
          Ň: "N",
          Ř: "R",
          Š: "S",
          Ť: "T",
          Ů: "U",
          Ž: "Z"
        },
        fi: {
          // Finnish
          // 'å': 'a', duplicate see charMap/latin
          // 'Å': 'A', duplicate see charMap/latin
          ä: "a",
          // ok
          Ä: "A",
          // ok
          ö: "o",
          // ok
          Ö: "O"
          // ok
        },
        hu: {
          // Hungarian
          ä: "a",
          // ok
          Ä: "A",
          // ok
          // 'á': 'a', duplicate see charMap/latin
          // 'Á': 'A', duplicate see charMap/latin
          ö: "o",
          // ok
          Ö: "O",
          // ok
          // 'ő': 'o', duplicate see charMap/latin
          // 'Ő': 'O', duplicate see charMap/latin
          ü: "u",
          Ü: "U",
          ű: "u",
          Ű: "U"
        },
        lt: {
          // Lithuanian
          ą: "a",
          č: "c",
          ę: "e",
          ė: "e",
          į: "i",
          š: "s",
          ų: "u",
          ū: "u",
          ž: "z",
          Ą: "A",
          Č: "C",
          Ę: "E",
          Ė: "E",
          Į: "I",
          Š: "S",
          Ų: "U",
          Ū: "U"
        },
        lv: {
          // Latvian
          ā: "a",
          č: "c",
          ē: "e",
          ģ: "g",
          ī: "i",
          ķ: "k",
          ļ: "l",
          ņ: "n",
          š: "s",
          ū: "u",
          ž: "z",
          Ā: "A",
          Č: "C",
          Ē: "E",
          Ģ: "G",
          Ī: "i",
          Ķ: "k",
          Ļ: "L",
          Ņ: "N",
          Š: "S",
          Ū: "u",
          Ž: "Z"
        },
        pl: {
          // Polish
          ą: "a",
          ć: "c",
          ę: "e",
          ł: "l",
          ń: "n",
          ó: "o",
          ś: "s",
          ź: "z",
          ż: "z",
          Ą: "A",
          Ć: "C",
          Ę: "e",
          Ł: "L",
          Ń: "N",
          Ó: "O",
          Ś: "S",
          Ź: "Z",
          Ż: "Z"
        },
        sv: {
          // Swedish
          // 'å': 'a', duplicate see charMap/latin
          // 'Å': 'A', duplicate see charMap/latin
          ä: "a",
          // ok
          Ä: "A",
          // ok
          ö: "o",
          // ok
          Ö: "O"
          // ok
        },
        sk: {
          // Slovak
          ä: "a",
          Ä: "A"
        },
        sr: {
          // Serbian
          љ: "lj",
          њ: "nj",
          Љ: "Lj",
          Њ: "Nj",
          đ: "dj",
          Đ: "Dj"
        },
        tr: {
          // Turkish
          Ü: "U",
          Ö: "O",
          ü: "u",
          ö: "o"
        }
      }, s = {
        ar: {
          "∆": "delta",
          "∞": "la-nihaya",
          "♥": "hob",
          "&": "wa",
          "|": "aw",
          "<": "aqal-men",
          ">": "akbar-men",
          "∑": "majmou",
          "¤": "omla"
        },
        az: {},
        ca: {
          "∆": "delta",
          "∞": "infinit",
          "♥": "amor",
          "&": "i",
          "|": "o",
          "<": "menys que",
          ">": "mes que",
          "∑": "suma dels",
          "¤": "moneda"
        },
        cs: {
          "∆": "delta",
          "∞": "nekonecno",
          "♥": "laska",
          "&": "a",
          "|": "nebo",
          "<": "mensi nez",
          ">": "vetsi nez",
          "∑": "soucet",
          "¤": "mena"
        },
        de: {
          "∆": "delta",
          "∞": "unendlich",
          "♥": "Liebe",
          "&": "und",
          "|": "oder",
          "<": "kleiner als",
          ">": "groesser als",
          "∑": "Summe von",
          "¤": "Waehrung"
        },
        dv: {
          "∆": "delta",
          "∞": "kolunulaa",
          "♥": "loabi",
          "&": "aai",
          "|": "noonee",
          "<": "ah vure kuda",
          ">": "ah vure bodu",
          "∑": "jumula",
          "¤": "faisaa"
        },
        en: {
          "∆": "delta",
          "∞": "infinity",
          "♥": "love",
          "&": "and",
          "|": "or",
          "<": "less than",
          ">": "greater than",
          "∑": "sum",
          "¤": "currency"
        },
        es: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amor",
          "&": "y",
          "|": "u",
          "<": "menos que",
          ">": "mas que",
          "∑": "suma de los",
          "¤": "moneda"
        },
        fa: {
          "∆": "delta",
          "∞": "bi-nahayat",
          "♥": "eshgh",
          "&": "va",
          "|": "ya",
          "<": "kamtar-az",
          ">": "bishtar-az",
          "∑": "majmooe",
          "¤": "vahed"
        },
        fi: {
          "∆": "delta",
          "∞": "aarettomyys",
          "♥": "rakkaus",
          "&": "ja",
          "|": "tai",
          "<": "pienempi kuin",
          ">": "suurempi kuin",
          "∑": "summa",
          "¤": "valuutta"
        },
        fr: {
          "∆": "delta",
          "∞": "infiniment",
          "♥": "Amour",
          "&": "et",
          "|": "ou",
          "<": "moins que",
          ">": "superieure a",
          "∑": "somme des",
          "¤": "monnaie"
        },
        ge: {
          "∆": "delta",
          "∞": "usasruloba",
          "♥": "siqvaruli",
          "&": "da",
          "|": "an",
          "<": "naklebi",
          ">": "meti",
          "∑": "jami",
          "¤": "valuta"
        },
        gr: {},
        hu: {
          "∆": "delta",
          "∞": "vegtelen",
          "♥": "szerelem",
          "&": "es",
          "|": "vagy",
          "<": "kisebb mint",
          ">": "nagyobb mint",
          "∑": "szumma",
          "¤": "penznem"
        },
        it: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amore",
          "&": "e",
          "|": "o",
          "<": "minore di",
          ">": "maggiore di",
          "∑": "somma",
          "¤": "moneta"
        },
        lt: {
          "∆": "delta",
          "∞": "begalybe",
          "♥": "meile",
          "&": "ir",
          "|": "ar",
          "<": "maziau nei",
          ">": "daugiau nei",
          "∑": "suma",
          "¤": "valiuta"
        },
        lv: {
          "∆": "delta",
          "∞": "bezgaliba",
          "♥": "milestiba",
          "&": "un",
          "|": "vai",
          "<": "mazak neka",
          ">": "lielaks neka",
          "∑": "summa",
          "¤": "valuta"
        },
        my: {
          "∆": "kwahkhyaet",
          "∞": "asaonasme",
          "♥": "akhyait",
          "&": "nhin",
          "|": "tho",
          "<": "ngethaw",
          ">": "kyithaw",
          "∑": "paungld",
          "¤": "ngwekye"
        },
        mk: {},
        nl: {
          "∆": "delta",
          "∞": "oneindig",
          "♥": "liefde",
          "&": "en",
          "|": "of",
          "<": "kleiner dan",
          ">": "groter dan",
          "∑": "som",
          "¤": "valuta"
        },
        pl: {
          "∆": "delta",
          "∞": "nieskonczonosc",
          "♥": "milosc",
          "&": "i",
          "|": "lub",
          "<": "mniejsze niz",
          ">": "wieksze niz",
          "∑": "suma",
          "¤": "waluta"
        },
        pt: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amor",
          "&": "e",
          "|": "ou",
          "<": "menor que",
          ">": "maior que",
          "∑": "soma",
          "¤": "moeda"
        },
        ro: {
          "∆": "delta",
          "∞": "infinit",
          "♥": "dragoste",
          "&": "si",
          "|": "sau",
          "<": "mai mic ca",
          ">": "mai mare ca",
          "∑": "suma",
          "¤": "valuta"
        },
        ru: {
          "∆": "delta",
          "∞": "beskonechno",
          "♥": "lubov",
          "&": "i",
          "|": "ili",
          "<": "menshe",
          ">": "bolshe",
          "∑": "summa",
          "¤": "valjuta"
        },
        sk: {
          "∆": "delta",
          "∞": "nekonecno",
          "♥": "laska",
          "&": "a",
          "|": "alebo",
          "<": "menej ako",
          ">": "viac ako",
          "∑": "sucet",
          "¤": "mena"
        },
        sr: {},
        tr: {
          "∆": "delta",
          "∞": "sonsuzluk",
          "♥": "ask",
          "&": "ve",
          "|": "veya",
          "<": "kucuktur",
          ">": "buyuktur",
          "∑": "toplam",
          "¤": "para birimi"
        },
        uk: {
          "∆": "delta",
          "∞": "bezkinechnist",
          "♥": "lubov",
          "&": "i",
          "|": "abo",
          "<": "menshe",
          ">": "bilshe",
          "∑": "suma",
          "¤": "valjuta"
        },
        vn: {
          "∆": "delta",
          "∞": "vo cuc",
          "♥": "yeu",
          "&": "va",
          "|": "hoac",
          "<": "nho hon",
          ">": "lon hon",
          "∑": "tong",
          "¤": "tien te"
        }
      }, u = [";", "?", ":", "@", "&", "=", "+", "$", ",", "/"].join(""), d = [";", "?", ":", "@", "&", "=", "+", "$", ","].join(""), f = [".", "!", "~", "*", "'", "(", ")"].join(""), p = function(w, T) {
        var S = "-", x = "", O = "", C = !0, P = {}, k, M, N, X, Z, te, ce, we, G, Q, y, H, ie, ne, J = "";
        if (typeof w != "string")
          return "";
        if (typeof T == "string" && (S = T), ce = s.en, we = o.en, typeof T == "object") {
          k = T.maintainCase || !1, P = T.custom && typeof T.custom == "object" ? T.custom : P, N = +T.truncate > 1 && T.truncate || !1, X = T.uric || !1, Z = T.uricNoSlash || !1, te = T.mark || !1, C = !(T.symbols === !1 || T.lang === !1), S = T.separator || S, X && (J += u), Z && (J += d), te && (J += f), ce = T.lang && s[T.lang] && C ? s[T.lang] : C ? s.en : {}, we = T.lang && o[T.lang] ? o[T.lang] : T.lang === !1 || T.lang === !0 ? {} : o.en, T.titleCase && typeof T.titleCase.length == "number" && Array.prototype.toString.call(T.titleCase) ? (T.titleCase.forEach(function(me) {
            P[me + ""] = me + "";
          }), M = !0) : M = !!T.titleCase, T.custom && typeof T.custom.length == "number" && Array.prototype.toString.call(T.custom) && T.custom.forEach(function(me) {
            P[me + ""] = me + "";
          }), Object.keys(P).forEach(function(me) {
            var xe;
            me.length > 1 ? xe = new RegExp("\\b" + g(me) + "\\b", "gi") : xe = new RegExp(g(me), "gi"), w = w.replace(xe, P[me]);
          });
          for (y in P)
            J += y;
        }
        for (J += S, J = g(J), w = w.replace(/(^\s+|\s+$)/g, ""), ie = !1, ne = !1, Q = 0, H = w.length; Q < H; Q++)
          y = w[Q], v(y, P) ? ie = !1 : we[y] ? (y = ie && we[y].match(/[A-Za-z0-9]/) ? " " + we[y] : we[y], ie = !1) : y in r ? (Q + 1 < H && i.indexOf(w[Q + 1]) >= 0 ? (O += y, y = "") : ne === !0 ? (y = a[O] + r[y], O = "") : y = ie && r[y].match(/[A-Za-z0-9]/) ? " " + r[y] : r[y], ie = !1, ne = !1) : y in a ? (O += y, y = "", Q === H - 1 && (y = a[O]), ne = !0) : /* process symbol chars */ ce[y] && !(X && u.indexOf(y) !== -1) && !(Z && d.indexOf(y) !== -1) ? (y = ie || x.substr(-1).match(/[A-Za-z0-9]/) ? S + ce[y] : ce[y], y += w[Q + 1] !== void 0 && w[Q + 1].match(/[A-Za-z0-9]/) ? S : "", ie = !0) : (ne === !0 ? (y = a[O] + y, O = "", ne = !1) : ie && (/[A-Za-z0-9]/.test(y) || x.substr(-1).match(/A-Za-z0-9]/)) && (y = " " + y), ie = !1), x += y.replace(new RegExp("[^\\w\\s" + J + "_-]", "g"), S);
        return M && (x = x.replace(/(\w)(\S*)/g, function(me, xe, U) {
          var $ = xe.toUpperCase() + (U !== null ? U : "");
          return Object.keys(P).indexOf($.toLowerCase()) < 0 ? $ : $.toLowerCase();
        })), x = x.replace(/\s+/g, S).replace(new RegExp("\\" + S + "+", "g"), S).replace(new RegExp("(^\\" + S + "+|\\" + S + "+$)", "g"), ""), N && x.length > N && (G = x.charAt(N) === S, x = x.slice(0, N), G || (x = x.slice(0, x.lastIndexOf(S)))), !k && !M && (x = x.toLowerCase()), x;
      }, m = function(w) {
        return function(S) {
          return p(S, w);
        };
      }, g = function(w) {
        return w.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
      }, v = function(b, w) {
        for (var T in w)
          if (w[T] === b)
            return !0;
      };
      if (typeof t < "u" && t.exports)
        t.exports = p, t.exports.createSlug = m;
      else if (typeof define < "u" && define.amd)
        define([], function() {
          return p;
        });
      else
        try {
          if (n.getSlug || n.createSlug)
            throw "speakingurl: globals exists /(getSlug|createSlug)/";
          n.getSlug = p, n.createSlug = m;
        } catch {
        }
    }(e);
  }
}), WI = tx({
  "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js"(e, t) {
    ye(), t.exports = UI();
  }
});
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
function HI(e) {
  var t;
  const n = e.name || e._componentTag || e.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || e.__name;
  return n === "index" && ((t = e.__file) != null && t.endsWith("index.vue")) ? "" : n;
}
function jI(e) {
  const t = e.__file;
  if (t)
    return kI(SI(t, ".vue"));
}
function __(e, t) {
  return e.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = t, t;
}
function Sd(e) {
  if (e.__VUE_DEVTOOLS_NEXT_APP_RECORD__)
    return e.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
  if (e.root)
    return e.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function YI(e) {
  const { app: t, uid: n, instance: r } = e;
  try {
    if (r.__VUE_DEVTOOLS_NEXT_UID__)
      return r.__VUE_DEVTOOLS_NEXT_UID__;
    const i = await Sd(t);
    if (!i)
      return null;
    const a = i.rootInstance === r;
    return `${i.id}:${a ? "root" : n}`;
  } catch {
  }
}
function nx(e) {
  var t, n;
  const r = (t = e.subTree) == null ? void 0 : t.type, i = Sd(e);
  return i ? ((n = i == null ? void 0 : i.types) == null ? void 0 : n.Fragment) === r : !1;
}
function Od(e) {
  var t, n, r;
  const i = HI((e == null ? void 0 : e.type) || {});
  if (i)
    return i;
  if ((e == null ? void 0 : e.root) === e)
    return "Root";
  for (const o in (n = (t = e.parent) == null ? void 0 : t.type) == null ? void 0 : n.components)
    if (e.parent.type.components[o] === (e == null ? void 0 : e.type))
      return __(e, o);
  for (const o in (r = e.appContext) == null ? void 0 : r.components)
    if (e.appContext.components[o] === (e == null ? void 0 : e.type))
      return __(e, o);
  const a = jI((e == null ? void 0 : e.type) || {});
  return a || "Anonymous Component";
}
function cp(e, t) {
  return t = t || `${e.id}:root`, e.instanceMap.get(t) || e.instanceMap.get(":root");
}
function zI() {
  const e = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    get width() {
      return e.right - e.left;
    },
    get height() {
      return e.bottom - e.top;
    }
  };
  return e;
}
var yc;
function GI(e) {
  return yc || (yc = document.createRange()), yc.selectNode(e), yc.getBoundingClientRect();
}
function qI(e) {
  const t = zI();
  if (!e.children)
    return t;
  for (let n = 0, r = e.children.length; n < r; n++) {
    const i = e.children[n];
    let a;
    if (i.component)
      a = Do(i.component);
    else if (i.el) {
      const o = i.el;
      o.nodeType === 1 || o.getBoundingClientRect ? a = o.getBoundingClientRect() : o.nodeType === 3 && o.data.trim() && (a = GI(o));
    }
    a && KI(t, a);
  }
  return t;
}
function KI(e, t) {
  return (!e.top || t.top < e.top) && (e.top = t.top), (!e.bottom || t.bottom > e.bottom) && (e.bottom = t.bottom), (!e.left || t.left < e.left) && (e.left = t.left), (!e.right || t.right > e.right) && (e.right = t.right), e;
}
var y_ = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: 0,
  height: 0
};
function Do(e) {
  const t = e.subTree.el;
  return typeof window > "u" ? y_ : nx(e) ? qI(e.subTree) : (t == null ? void 0 : t.nodeType) === 1 ? t == null ? void 0 : t.getBoundingClientRect() : e.subTree.component ? Do(e.subTree.component) : y_;
}
ye();
function mm(e) {
  return nx(e) ? XI(e.subTree) : e.subTree ? [e.subTree.el] : [];
}
function XI(e) {
  if (!e.children)
    return [];
  const t = [];
  return e.children.forEach((n) => {
    n.component ? t.push(...mm(n.component)) : n != null && n.el && t.push(n.el);
  }), t;
}
var rx = "__vue-devtools-component-inspector__", ix = "__vue-devtools-component-inspector__card__", ax = "__vue-devtools-component-inspector__name__", ox = "__vue-devtools-component-inspector__indicator__", sx = {
  display: "block",
  zIndex: 2147483640,
  position: "fixed",
  backgroundColor: "#42b88325",
  border: "1px solid #42b88350",
  borderRadius: "5px",
  transition: "all 0.1s ease-in",
  pointerEvents: "none"
}, ZI = {
  fontFamily: "Arial, Helvetica, sans-serif",
  padding: "5px 8px",
  borderRadius: "4px",
  textAlign: "left",
  position: "absolute",
  left: 0,
  color: "#e9e9e9",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  backgroundColor: "#42b883",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
}, QI = {
  display: "inline-block",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "12px",
  opacity: 0.7
};
function $s() {
  return document.getElementById(rx);
}
function JI() {
  return document.getElementById(ix);
}
function eN() {
  return document.getElementById(ox);
}
function tN() {
  return document.getElementById(ax);
}
function gm(e) {
  return {
    left: `${Math.round(e.left * 100) / 100}px`,
    top: `${Math.round(e.top * 100) / 100}px`,
    width: `${Math.round(e.width * 100) / 100}px`,
    height: `${Math.round(e.height * 100) / 100}px`
  };
}
function vm(e) {
  var t;
  const n = document.createElement("div");
  n.id = (t = e.elementId) != null ? t : rx, Object.assign(n.style, {
    ...sx,
    ...gm(e.bounds),
    ...e.style
  });
  const r = document.createElement("span");
  r.id = ix, Object.assign(r.style, {
    ...ZI,
    top: e.bounds.top < 35 ? 0 : "-35px"
  });
  const i = document.createElement("span");
  i.id = ax, i.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`;
  const a = document.createElement("i");
  return a.id = ox, a.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`, Object.assign(a.style, QI), r.appendChild(i), r.appendChild(a), n.appendChild(r), document.body.appendChild(n), n;
}
function _m(e) {
  const t = $s(), n = JI(), r = tN(), i = eN();
  t && (Object.assign(t.style, {
    ...sx,
    ...gm(e.bounds)
  }), Object.assign(n.style, {
    top: e.bounds.top < 35 ? 0 : "-35px"
  }), r.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`, i.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`);
}
function nN(e) {
  const t = Do(e);
  if (!t.width && !t.height)
    return;
  const n = Od(e);
  $s() ? _m({ bounds: t, name: n }) : vm({ bounds: t, name: n });
}
function lx() {
  const e = $s();
  e && (e.style.display = "none");
}
var dp = null;
function fp(e) {
  const t = e.target;
  if (t) {
    const n = t.__vueParentComponent;
    if (n && (dp = n, n.vnode.el)) {
      const i = Do(n), a = Od(n);
      $s() ? _m({ bounds: i, name: a }) : vm({ bounds: i, name: a });
    }
  }
}
function rN(e, t) {
  var n;
  if (e.preventDefault(), e.stopPropagation(), dp) {
    const r = (n = tr.value) == null ? void 0 : n.app;
    YI({
      app: r,
      uid: r.uid,
      instance: dp
    }).then((i) => {
      t(i);
    });
  }
}
var Jc = null;
function iN() {
  lx(), window.removeEventListener("mouseover", fp), window.removeEventListener("click", Jc, !0), Jc = null;
}
function aN() {
  return window.addEventListener("mouseover", fp), new Promise((e) => {
    function t(n) {
      n.preventDefault(), n.stopPropagation(), rN(n, (r) => {
        window.removeEventListener("click", t, !0), Jc = null, window.removeEventListener("mouseover", fp);
        const i = $s();
        i && (i.style.display = "none"), e(JSON.stringify({ id: r }));
      });
    }
    Jc = t, window.addEventListener("click", t, !0);
  });
}
function oN(e) {
  const t = cp(tr.value, e.id);
  if (t) {
    const [n] = mm(t);
    if (typeof n.scrollIntoView == "function")
      n.scrollIntoView({
        behavior: "smooth"
      });
    else {
      const r = Do(t), i = document.createElement("div"), a = {
        ...gm(r),
        position: "absolute"
      };
      Object.assign(i.style, a), document.body.appendChild(i), i.scrollIntoView({
        behavior: "smooth"
      }), setTimeout(() => {
        document.body.removeChild(i);
      }, 2e3);
    }
    setTimeout(() => {
      const r = Do(t);
      if (r.width || r.height) {
        const i = Od(t), a = $s();
        a ? _m({ ...e, name: i, bounds: r }) : vm({ ...e, name: i, bounds: r }), setTimeout(() => {
          a && (a.style.display = "none");
        }, 1500);
      }
    }, 1200);
  }
}
ye();
var b_, w_;
(w_ = (b_ = Le).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null || (b_.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = !0);
function sN(e) {
  let t = 0;
  const n = setInterval(() => {
    Le.__VUE_INSPECTOR__ && (clearInterval(n), t += 30, e()), t >= /* 5s */
    5e3 && clearInterval(n);
  }, 30);
}
function lN() {
  const e = Le.__VUE_INSPECTOR__, t = e.openInEditor;
  e.openInEditor = async (...n) => {
    e.disable(), t(...n);
  };
}
function uN() {
  return new Promise((e) => {
    function t() {
      lN(), e(Le.__VUE_INSPECTOR__);
    }
    Le.__VUE_INSPECTOR__ ? t() : sN(() => {
      t();
    });
  });
}
ye();
ye();
function cN(e) {
  return !!(e && e.__v_isReadonly);
}
function ux(e) {
  return cN(e) ? ux(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Eh(e) {
  return !!(e && e.__v_isRef === !0);
}
function wl(e) {
  const t = e && e.__v_raw;
  return t ? wl(t) : e;
}
var dN = class {
  constructor() {
    this.refEditor = new fN();
  }
  set(e, t, n, r) {
    const i = Array.isArray(t) ? t : t.split(".");
    for (; i.length > 1; ) {
      const s = i.shift();
      e instanceof Map && (e = e.get(s)), e instanceof Set ? e = Array.from(e.values())[s] : e = e[s], this.refEditor.isRef(e) && (e = this.refEditor.get(e));
    }
    const a = i[0], o = this.refEditor.get(e)[a];
    r ? r(e, a, n) : this.refEditor.isRef(o) ? this.refEditor.set(o, n) : e[a] = n;
  }
  get(e, t) {
    const n = Array.isArray(t) ? t : t.split(".");
    for (let r = 0; r < n.length; r++)
      if (e instanceof Map ? e = e.get(n[r]) : e = e[n[r]], this.refEditor.isRef(e) && (e = this.refEditor.get(e)), !e)
        return;
    return e;
  }
  has(e, t, n = !1) {
    if (typeof e > "u")
      return !1;
    const r = Array.isArray(t) ? t.slice() : t.split("."), i = n ? 2 : 1;
    for (; e && r.length > i; ) {
      const a = r.shift();
      e = e[a], this.refEditor.isRef(e) && (e = this.refEditor.get(e));
    }
    return e != null && Object.prototype.hasOwnProperty.call(e, r[0]);
  }
  createDefaultSetCallback(e) {
    return (t, n, r) => {
      if ((e.remove || e.newKey) && (Array.isArray(t) ? t.splice(n, 1) : wl(t) instanceof Map ? t.delete(n) : wl(t) instanceof Set ? t.delete(Array.from(t.values())[n]) : Reflect.deleteProperty(t, n)), !e.remove) {
        const i = t[e.newKey || n];
        this.refEditor.isRef(i) ? this.refEditor.set(i, r) : wl(t) instanceof Map ? t.set(e.newKey || n, r) : wl(t) instanceof Set ? t.add(r) : t[e.newKey || n] = r;
      }
    };
  }
}, fN = class {
  set(e, t) {
    if (Eh(e))
      e.value = t;
    else {
      if (e instanceof Set && Array.isArray(t)) {
        e.clear(), t.forEach((i) => e.add(i));
        return;
      }
      const n = Object.keys(t);
      if (e instanceof Map) {
        const i = new Set(e.keys());
        n.forEach((a) => {
          e.set(a, Reflect.get(t, a)), i.delete(a);
        }), i.forEach((a) => e.delete(a));
        return;
      }
      const r = new Set(Object.keys(e));
      n.forEach((i) => {
        Reflect.set(e, i, Reflect.get(t, i)), r.delete(i);
      }), r.forEach((i) => Reflect.deleteProperty(e, i));
    }
  }
  get(e) {
    return Eh(e) ? e.value : e;
  }
  isRef(e) {
    return Eh(e) || ux(e);
  }
};
ye();
ye();
ye();
var hN = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function pN() {
  if (!Zw || typeof localStorage > "u" || localStorage === null)
    return {
      recordingState: !1,
      mouseEventEnabled: !1,
      keyboardEventEnabled: !1,
      componentEventEnabled: !1,
      performanceEventEnabled: !1,
      selected: ""
    };
  const e = localStorage.getItem(hN);
  return e ? JSON.parse(e) : {
    recordingState: !1,
    mouseEventEnabled: !1,
    keyboardEventEnabled: !1,
    componentEventEnabled: !1,
    performanceEventEnabled: !1,
    selected: ""
  };
}
ye();
ye();
ye();
var x_, E_;
(E_ = (x_ = Le).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null || (x_.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = []);
var mN = new Proxy(Le.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
  get(e, t, n) {
    return Reflect.get(e, t, n);
  }
});
function gN(e, t) {
  In.timelineLayersState[t.id] = !1, mN.push({
    ...e,
    descriptorId: t.id,
    appRecord: Sd(t.app)
  });
}
var T_, k_;
(k_ = (T_ = Le).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null || (T_.__VUE_DEVTOOLS_KIT_INSPECTOR__ = []);
var ym = new Proxy(Le.__VUE_DEVTOOLS_KIT_INSPECTOR__, {
  get(e, t, n) {
    return Reflect.get(e, t, n);
  }
}), cx = bs(() => {
  Vs.hooks.callHook("sendInspectorToClient", dx());
});
function vN(e, t) {
  var n, r;
  ym.push({
    options: e,
    descriptor: t,
    treeFilterPlaceholder: (n = e.treeFilterPlaceholder) != null ? n : "Search tree...",
    stateFilterPlaceholder: (r = e.stateFilterPlaceholder) != null ? r : "Search state...",
    treeFilter: "",
    selectedNodeId: "",
    appRecord: Sd(t.app)
  }), cx();
}
function dx() {
  return ym.filter((e) => e.descriptor.app === tr.value.app).filter((e) => e.descriptor.id !== "components").map((e) => {
    var t;
    const n = e.descriptor, r = e.options;
    return {
      id: r.id,
      label: r.label,
      logo: n.logo,
      icon: `custom-ic-baseline-${(t = r == null ? void 0 : r.icon) == null ? void 0 : t.replace(/_/g, "-")}`,
      packageName: n.packageName,
      homepage: n.homepage,
      pluginId: n.id
    };
  });
}
function zc(e, t) {
  return ym.find((n) => n.options.id === e && (t ? n.descriptor.app === t : !0));
}
function _N() {
  const e = Jw();
  e.hook("addInspector", ({ inspector: r, plugin: i }) => {
    vN(r, i.descriptor);
  });
  const t = bs(async ({ inspectorId: r, plugin: i }) => {
    var a;
    if (!r || !((a = i == null ? void 0 : i.descriptor) != null && a.app) || In.highPerfModeEnabled)
      return;
    const o = zc(r, i.descriptor.app), s = {
      app: i.descriptor.app,
      inspectorId: r,
      filter: (o == null ? void 0 : o.treeFilter) || "",
      rootNodes: []
    };
    await new Promise((u) => {
      e.callHookWith(
        async (d) => {
          await Promise.all(d.map((f) => f(s))), u();
        },
        "getInspectorTree"
        /* GET_INSPECTOR_TREE */
      );
    }), e.callHookWith(
      async (u) => {
        await Promise.all(u.map((d) => d({
          inspectorId: r,
          rootNodes: s.rootNodes
        })));
      },
      "sendInspectorTreeToClient"
      /* SEND_INSPECTOR_TREE_TO_CLIENT */
    );
  }, 120);
  e.hook("sendInspectorTree", t);
  const n = bs(async ({ inspectorId: r, plugin: i }) => {
    var a;
    if (!r || !((a = i == null ? void 0 : i.descriptor) != null && a.app) || In.highPerfModeEnabled)
      return;
    const o = zc(r, i.descriptor.app), s = {
      app: i.descriptor.app,
      inspectorId: r,
      nodeId: (o == null ? void 0 : o.selectedNodeId) || "",
      state: null
    }, u = {
      currentTab: `custom-inspector:${r}`
    };
    s.nodeId && await new Promise((d) => {
      e.callHookWith(
        async (f) => {
          await Promise.all(f.map((p) => p(s, u))), d();
        },
        "getInspectorState"
        /* GET_INSPECTOR_STATE */
      );
    }), e.callHookWith(
      async (d) => {
        await Promise.all(d.map((f) => f({
          inspectorId: r,
          nodeId: s.nodeId,
          state: s.state
        })));
      },
      "sendInspectorStateToClient"
      /* SEND_INSPECTOR_STATE_TO_CLIENT */
    );
  }, 120);
  return e.hook("sendInspectorState", n), e.hook("customInspectorSelectNode", ({ inspectorId: r, nodeId: i, plugin: a }) => {
    const o = zc(r, a.descriptor.app);
    o && (o.selectedNodeId = i);
  }), e.hook("timelineLayerAdded", ({ options: r, plugin: i }) => {
    gN(r, i.descriptor);
  }), e.hook("timelineEventAdded", ({ options: r, plugin: i }) => {
    var a;
    const o = ["performance", "component-event", "keyboard", "mouse"];
    In.highPerfModeEnabled || !((a = In.timelineLayersState) != null && a[i.descriptor.id]) && !o.includes(r.layerId) || e.callHookWith(
      async (s) => {
        await Promise.all(s.map((u) => u(r)));
      },
      "sendTimelineEventToClient"
      /* SEND_TIMELINE_EVENT_TO_CLIENT */
    );
  }), e.hook("getComponentInstances", async ({ app: r }) => {
    const i = r.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    if (!i)
      return null;
    const a = i.id.toString();
    return [...i.instanceMap].filter(([s]) => s.split(":")[0] === a).map(([, s]) => s);
  }), e.hook("getComponentBounds", async ({ instance: r }) => Do(r)), e.hook("getComponentName", ({ instance: r }) => Od(r)), e.hook("componentHighlight", ({ uid: r }) => {
    const i = tr.value.instanceMap.get(r);
    i && nN(i);
  }), e.hook("componentUnhighlight", () => {
    lx();
  }), e;
}
var S_, O_;
(O_ = (S_ = Le).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null || (S_.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = []);
var C_, A_;
(A_ = (C_ = Le).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null || (C_.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {});
var D_, P_;
(P_ = (D_ = Le).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null || (D_.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "");
var M_, I_;
(I_ = (M_ = Le).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null || (M_.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = []);
var N_, L_;
(L_ = (N_ = Le).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null || (N_.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = []);
var xo = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function yN() {
  return {
    connected: !1,
    clientConnected: !1,
    vitePluginDetected: !0,
    appRecords: [],
    activeAppRecordId: "",
    tabs: [],
    commands: [],
    highPerfModeEnabled: !0,
    devtoolsClientDetected: {},
    perfUniqueGroupId: 0,
    timelineLayersState: pN()
  };
}
var R_, F_;
(F_ = (R_ = Le)[xo]) != null || (R_[xo] = yN());
var bN = bs((e) => {
  Vs.hooks.callHook("devtoolsStateUpdated", { state: e });
});
bs((e, t) => {
  Vs.hooks.callHook("devtoolsConnectedUpdated", { state: e, oldState: t });
});
var Cd = new Proxy(Le.__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
  get(e, t, n) {
    return t === "value" ? Le.__VUE_DEVTOOLS_KIT_APP_RECORDS__ : Le.__VUE_DEVTOOLS_KIT_APP_RECORDS__[t];
  }
}), tr = new Proxy(Le.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
  get(e, t, n) {
    return t === "value" ? Le.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ : t === "id" ? Le.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ : Le.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[t];
  }
});
function fx() {
  bN({
    ...Le[xo],
    appRecords: Cd.value,
    activeAppRecordId: tr.id,
    tabs: Le.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
    commands: Le.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
  });
}
function wN(e) {
  Le.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = e, fx();
}
function xN(e) {
  Le.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = e, fx();
}
var In = new Proxy(Le[xo], {
  get(e, t) {
    return t === "appRecords" ? Cd : t === "activeAppRecordId" ? tr.id : t === "tabs" ? Le.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ : t === "commands" ? Le.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ : Le[xo][t];
  },
  deleteProperty(e, t) {
    return delete e[t], !0;
  },
  set(e, t, n) {
    return { ...Le[xo] }, e[t] = n, Le[xo][t] = n, !0;
  }
});
function EN(e = {}) {
  var t, n, r;
  const { file: i, host: a, baseUrl: o = window.location.origin, line: s = 0, column: u = 0 } = e;
  if (i) {
    if (a === "chrome-extension") {
      const d = i.replace(/\\/g, "\\\\"), f = (n = (t = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : t.openInEditorHost) != null ? n : "/";
      fetch(`${f}__open-in-editor?file=${encodeURI(i)}`).then((p) => {
        if (!p.ok) {
          const m = `Opening component ${d} failed`;
          console.log(`%c${m}`, "color:red");
        }
      });
    } else if (In.vitePluginDetected) {
      const d = (r = Le.__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? r : o;
      Le.__VUE_INSPECTOR__.openInEditor(d, i, s, u);
    }
  }
}
ye();
ye();
ye();
ye();
ye();
var $_, V_;
(V_ = ($_ = Le).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null || ($_.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = []);
var bm = new Proxy(Le.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
  get(e, t, n) {
    return Reflect.get(e, t, n);
  }
});
function hp(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = e[n].defaultValue;
  }), t;
}
function wm(e) {
  return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${e}__`;
}
function TN(e) {
  var t, n, r;
  const i = (n = (t = bm.find((a) => {
    var o;
    return a[0].id === e && !!((o = a[0]) != null && o.settings);
  })) == null ? void 0 : t[0]) != null ? n : null;
  return (r = i == null ? void 0 : i.settings) != null ? r : null;
}
function hx(e, t) {
  var n, r, i;
  const a = wm(e);
  if (a) {
    const o = localStorage.getItem(a);
    if (o)
      return JSON.parse(o);
  }
  if (e) {
    const o = (r = (n = bm.find((s) => s[0].id === e)) == null ? void 0 : n[0]) != null ? r : null;
    return hp((i = o == null ? void 0 : o.settings) != null ? i : {});
  }
  return hp(t);
}
function kN(e, t) {
  const n = wm(e);
  localStorage.getItem(n) || localStorage.setItem(n, JSON.stringify(hp(t)));
}
function SN(e, t, n) {
  const r = wm(e), i = localStorage.getItem(r), a = JSON.parse(i || "{}"), o = {
    ...a,
    [t]: n
  };
  localStorage.setItem(r, JSON.stringify(o)), Vs.hooks.callHookWith(
    (s) => {
      s.forEach((u) => u({
        pluginId: e,
        key: t,
        oldValue: a[t],
        newValue: n,
        settings: o
      }));
    },
    "setPluginSettings"
    /* SET_PLUGIN_SETTINGS */
  );
}
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
var B_, U_, Br = (U_ = (B_ = Le).__VUE_DEVTOOLS_HOOK) != null ? U_ : B_.__VUE_DEVTOOLS_HOOK = Jw(), ON = {
  vueAppInit(e) {
    Br.hook("app:init", e);
  },
  vueAppUnmount(e) {
    Br.hook("app:unmount", e);
  },
  vueAppConnected(e) {
    Br.hook("app:connected", e);
  },
  componentAdded(e) {
    return Br.hook("component:added", e);
  },
  componentEmit(e) {
    return Br.hook("component:emit", e);
  },
  componentUpdated(e) {
    return Br.hook("component:updated", e);
  },
  componentRemoved(e) {
    return Br.hook("component:removed", e);
  },
  setupDevtoolsPlugin(e) {
    Br.hook("devtools-plugin:setup", e);
  },
  perfStart(e) {
    return Br.hook("perf:start", e);
  },
  perfEnd(e) {
    return Br.hook("perf:end", e);
  }
}, px = {
  on: ON,
  setupDevToolsPlugin(e, t) {
    return Br.callHook("devtools-plugin:setup", e, t);
  }
}, CN = class {
  constructor({ plugin: e, ctx: t }) {
    this.hooks = t.hooks, this.plugin = e;
  }
  get on() {
    return {
      // component inspector
      visitComponentTree: (e) => {
        this.hooks.hook("visitComponentTree", e);
      },
      inspectComponent: (e) => {
        this.hooks.hook("inspectComponent", e);
      },
      editComponentState: (e) => {
        this.hooks.hook("editComponentState", e);
      },
      // custom inspector
      getInspectorTree: (e) => {
        this.hooks.hook("getInspectorTree", e);
      },
      getInspectorState: (e) => {
        this.hooks.hook("getInspectorState", e);
      },
      editInspectorState: (e) => {
        this.hooks.hook("editInspectorState", e);
      },
      // timeline
      inspectTimelineEvent: (e) => {
        this.hooks.hook("inspectTimelineEvent", e);
      },
      timelineCleared: (e) => {
        this.hooks.hook("timelineCleared", e);
      },
      // settings
      setPluginSettings: (e) => {
        this.hooks.hook("setPluginSettings", e);
      }
    };
  }
  // component inspector
  notifyComponentUpdate(e) {
    var t;
    if (In.highPerfModeEnabled)
      return;
    const n = dx().find((r) => r.packageName === this.plugin.descriptor.packageName);
    if (n != null && n.id) {
      if (e) {
        const r = [
          e.appContext.app,
          e.uid,
          (t = e.parent) == null ? void 0 : t.uid,
          e
        ];
        Br.callHook("component:updated", ...r);
      } else
        Br.callHook(
          "component:updated"
          /* COMPONENT_UPDATED */
        );
      this.hooks.callHook("sendInspectorState", { inspectorId: n.id, plugin: this.plugin });
    }
  }
  // custom inspector
  addInspector(e) {
    this.hooks.callHook("addInspector", { inspector: e, plugin: this.plugin }), this.plugin.descriptor.settings && kN(e.id, this.plugin.descriptor.settings);
  }
  sendInspectorTree(e) {
    In.highPerfModeEnabled || this.hooks.callHook("sendInspectorTree", { inspectorId: e, plugin: this.plugin });
  }
  sendInspectorState(e) {
    In.highPerfModeEnabled || this.hooks.callHook("sendInspectorState", { inspectorId: e, plugin: this.plugin });
  }
  selectInspectorNode(e, t) {
    this.hooks.callHook("customInspectorSelectNode", { inspectorId: e, nodeId: t, plugin: this.plugin });
  }
  visitComponentTree(e) {
    return this.hooks.callHook("visitComponentTree", e);
  }
  // timeline
  now() {
    return In.highPerfModeEnabled ? 0 : Date.now();
  }
  addTimelineLayer(e) {
    this.hooks.callHook("timelineLayerAdded", { options: e, plugin: this.plugin });
  }
  addTimelineEvent(e) {
    In.highPerfModeEnabled || this.hooks.callHook("timelineEventAdded", { options: e, plugin: this.plugin });
  }
  // settings
  getSettings(e) {
    return hx(e ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
  }
  // utilities
  getComponentInstances(e) {
    return this.hooks.callHook("getComponentInstances", { app: e });
  }
  getComponentBounds(e) {
    return this.hooks.callHook("getComponentBounds", { instance: e });
  }
  getComponentName(e) {
    return this.hooks.callHook("getComponentName", { instance: e });
  }
  highlightElement(e) {
    const t = e.__VUE_DEVTOOLS_NEXT_UID__;
    return this.hooks.callHook("componentHighlight", { uid: t });
  }
  unhighlightElement() {
    return this.hooks.callHook(
      "componentUnhighlight"
      /* COMPONENT_UNHIGHLIGHT */
    );
  }
}, AN = CN;
ye();
ye();
ye();
ye();
var DN = "__vue_devtool_undefined__", PN = "__vue_devtool_infinity__", MN = "__vue_devtool_negative_infinity__", IN = "__vue_devtool_nan__";
ye();
ye();
var NN = {
  [DN]: "undefined",
  [IN]: "NaN",
  [PN]: "Infinity",
  [MN]: "-Infinity"
};
Object.entries(NN).reduce((e, [t, n]) => (e[n] = t, e), {});
ye();
ye();
ye();
ye();
ye();
var W_, H_;
(H_ = (W_ = Le).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null || (W_.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set());
function LN(e, t) {
  return px.setupDevToolsPlugin(e, t);
}
function RN(e, t) {
  const [n, r] = e;
  if (n.app !== t)
    return;
  const i = new AN({
    plugin: {
      setupFn: r,
      descriptor: n
    },
    ctx: Vs
  });
  n.packageName === "vuex" && i.on.editInspectorState((a) => {
    i.sendInspectorState(a.inspectorId);
  }), r(i);
}
function mx(e) {
  Le.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(e) || In.highPerfModeEnabled || (Le.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(e), bm.forEach((t) => {
    RN(t, e);
  }));
}
ye();
ye();
var Hl = "__VUE_DEVTOOLS_ROUTER__", ws = "__VUE_DEVTOOLS_ROUTER_INFO__", j_, Y_;
(Y_ = (j_ = Le)[ws]) != null || (j_[ws] = {
  currentRoute: null,
  routes: []
});
var z_, G_;
(G_ = (z_ = Le)[Hl]) != null || (z_[Hl] = {});
new Proxy(Le[ws], {
  get(e, t) {
    return Le[ws][t];
  }
});
new Proxy(Le[Hl], {
  get(e, t) {
    if (t === "value")
      return Le[Hl];
  }
});
function FN(e) {
  const t = /* @__PURE__ */ new Map();
  return ((e == null ? void 0 : e.getRoutes()) || []).filter((n) => !t.has(n.path) && t.set(n.path, 1));
}
function xm(e) {
  return e.map((t) => {
    let { path: n, name: r, children: i, meta: a } = t;
    return i != null && i.length && (i = xm(i)), {
      path: n,
      name: r,
      children: i,
      meta: a
    };
  });
}
function $N(e) {
  if (e) {
    const { fullPath: t, hash: n, href: r, path: i, name: a, matched: o, params: s, query: u } = e;
    return {
      fullPath: t,
      hash: n,
      href: r,
      path: i,
      name: a,
      params: s,
      query: u,
      matched: xm(o)
    };
  }
  return e;
}
function VN(e, t) {
  function n() {
    var r;
    const i = (r = e.app) == null ? void 0 : r.config.globalProperties.$router, a = $N(i == null ? void 0 : i.currentRoute.value), o = xm(FN(i)), s = console.warn;
    console.warn = () => {
    }, Le[ws] = {
      currentRoute: a ? v_(a) : {},
      routes: v_(o)
    }, Le[Hl] = i, console.warn = s;
  }
  n(), px.on.componentUpdated(bs(() => {
    var r;
    ((r = t.value) == null ? void 0 : r.app) === e.app && (n(), !In.highPerfModeEnabled && Vs.hooks.callHook("routerInfoUpdated", { state: Le[ws] }));
  }, 200));
}
function BN(e) {
  return {
    // get inspector tree
    async getInspectorTree(t) {
      const n = {
        ...t,
        app: tr.value.app,
        rootNodes: []
      };
      return await new Promise((r) => {
        e.callHookWith(
          async (i) => {
            await Promise.all(i.map((a) => a(n))), r();
          },
          "getInspectorTree"
          /* GET_INSPECTOR_TREE */
        );
      }), n.rootNodes;
    },
    // get inspector state
    async getInspectorState(t) {
      const n = {
        ...t,
        app: tr.value.app,
        state: null
      }, r = {
        currentTab: `custom-inspector:${t.inspectorId}`
      };
      return await new Promise((i) => {
        e.callHookWith(
          async (a) => {
            await Promise.all(a.map((o) => o(n, r))), i();
          },
          "getInspectorState"
          /* GET_INSPECTOR_STATE */
        );
      }), n.state;
    },
    // edit inspector state
    editInspectorState(t) {
      const n = new dN(), r = {
        ...t,
        app: tr.value.app,
        set: (i, a = t.path, o = t.state.value, s) => {
          n.set(i, a, o, s || n.createDefaultSetCallback(t.state));
        }
      };
      e.callHookWith(
        (i) => {
          i.forEach((a) => a(r));
        },
        "editInspectorState"
        /* EDIT_INSPECTOR_STATE */
      );
    },
    // send inspector state
    sendInspectorState(t) {
      const n = zc(t);
      e.callHook("sendInspectorState", { inspectorId: t, plugin: {
        descriptor: n.descriptor,
        setupFn: () => ({})
      } });
    },
    // inspect component inspector
    inspectComponentInspector() {
      return aN();
    },
    // cancel inspect component inspector
    cancelInspectComponentInspector() {
      return iN();
    },
    // get component render code
    getComponentRenderCode(t) {
      const n = cp(tr.value, t);
      if (n)
        return (n == null ? void 0 : n.type) instanceof Function ? n.type.toString() : n.render.toString();
    },
    // scroll to component
    scrollToComponent(t) {
      return oN({ id: t });
    },
    // open in editor
    openInEditor: EN,
    // get vue inspector
    getVueInspector: uN,
    // toggle app
    toggleApp(t) {
      const n = Cd.value.find((r) => r.id === t);
      n && (xN(t), wN(n), VN(n, tr), cx(), mx(n.app));
    },
    // inspect dom
    inspectDOM(t) {
      const n = cp(tr.value, t);
      if (n) {
        const [r] = mm(n);
        r && (Le.__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = r);
      }
    },
    updatePluginSettings(t, n, r) {
      SN(t, n, r);
    },
    getPluginSettings(t) {
      return {
        options: TN(t),
        values: hx(t)
      };
    }
  };
}
ye();
var q_, K_;
(K_ = (q_ = Le).__VUE_DEVTOOLS_ENV__) != null || (q_.__VUE_DEVTOOLS_ENV__ = {
  vitePluginDetected: !1
});
var X_ = _N(), Z_, Q_;
(Q_ = (Z_ = Le).__VUE_DEVTOOLS_KIT_CONTEXT__) != null || (Z_.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
  hooks: X_,
  get state() {
    return {
      ...In,
      activeAppRecordId: tr.id,
      activeAppRecord: tr.value,
      appRecords: Cd.value
    };
  },
  api: BN(X_)
});
var Vs = Le.__VUE_DEVTOOLS_KIT_CONTEXT__;
ye();
BI(WI());
var J_, ey;
(ey = (J_ = Le).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null || (J_.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
  id: 0,
  appIds: /* @__PURE__ */ new Set()
});
ye();
function UN(e) {
  In.highPerfModeEnabled = e ?? !In.highPerfModeEnabled, !e && tr.value && mx(tr.value.app);
}
ye();
ye();
ye();
function WN(e) {
  In.devtoolsClientDetected = {
    ...In.devtoolsClientDetected,
    ...e
  };
  const t = Object.values(In.devtoolsClientDetected).some(Boolean);
  UN(!t);
}
var ty, ny;
(ny = (ty = Le).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null || (ty.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = WN);
ye();
ye();
ye();
ye();
ye();
ye();
ye();
var HN = class {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, t) {
    this.keyToValue.set(e, t), this.valueToKey.set(t, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}, gx = class {
  constructor(t) {
    this.generateIdentifier = t, this.kv = new HN();
  }
  register(t, n) {
    this.kv.getByValue(t) || (n || (n = this.generateIdentifier(t)), this.kv.set(n, t));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(t) {
    return this.kv.getByValue(t);
  }
  getValue(t) {
    return this.kv.getByKey(t);
  }
}, jN = class extends gx {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, t) {
    typeof t == "object" ? (t.allowProps && this.classToAllowedProps.set(e, t.allowProps), super.register(e, t.identifier)) : super.register(e, t);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
};
ye();
ye();
function YN(e) {
  if ("values" in Object)
    return Object.values(e);
  const t = [];
  for (const n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function zN(e, t) {
  const n = YN(e);
  if ("find" in n)
    return n.find(t);
  const r = n;
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (t(a))
      return a;
  }
}
function xs(e, t) {
  Object.entries(e).forEach(([n, r]) => t(r, n));
}
function Gc(e, t) {
  return e.indexOf(t) !== -1;
}
function ry(e, t) {
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (t(r))
      return r;
  }
}
var GN = class {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return zN(this.transfomers, (t) => t.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
};
ye();
ye();
var qN = (e) => Object.prototype.toString.call(e).slice(8, -1), vx = (e) => typeof e > "u", KN = (e) => e === null, jl = (e) => typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype, pp = (e) => jl(e) && Object.keys(e).length === 0, Va = (e) => Array.isArray(e), XN = (e) => typeof e == "string", ZN = (e) => typeof e == "number" && !isNaN(e), QN = (e) => typeof e == "boolean", JN = (e) => e instanceof RegExp, Yl = (e) => e instanceof Map, zl = (e) => e instanceof Set, _x = (e) => qN(e) === "Symbol", eL = (e) => e instanceof Date && !isNaN(e.valueOf()), tL = (e) => e instanceof Error, iy = (e) => typeof e == "number" && isNaN(e), nL = (e) => QN(e) || KN(e) || vx(e) || ZN(e) || XN(e) || _x(e), rL = (e) => typeof e == "bigint", iL = (e) => e === 1 / 0 || e === -1 / 0, aL = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView), oL = (e) => e instanceof URL;
ye();
var yx = (e) => e.replace(/\./g, "\\."), Th = (e) => e.map(String).map(yx).join("."), Cl = (e) => {
  const t = [];
  let n = "";
  for (let i = 0; i < e.length; i++) {
    let a = e.charAt(i);
    if (a === "\\" && e.charAt(i + 1) === ".") {
      n += ".", i++;
      continue;
    }
    if (a === ".") {
      t.push(n), n = "";
      continue;
    }
    n += a;
  }
  const r = n;
  return t.push(r), t;
};
ye();
function Ti(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var bx = [
  Ti(vx, "undefined", () => null, () => {
  }),
  Ti(rL, "bigint", (e) => e.toString(), (e) => typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e)),
  Ti(eL, "Date", (e) => e.toISOString(), (e) => new Date(e)),
  Ti(tL, "Error", (e, t) => {
    const n = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach((r) => {
      n[r] = e[r];
    }), n;
  }, (e, t) => {
    const n = new Error(e.message);
    return n.name = e.name, n.stack = e.stack, t.allowedErrorProps.forEach((r) => {
      n[r] = e[r];
    }), n;
  }),
  Ti(JN, "regexp", (e) => "" + e, (e) => {
    const t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  Ti(
    zl,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (e) => [...e.values()],
    (e) => new Set(e)
  ),
  Ti(Yl, "map", (e) => [...e.entries()], (e) => new Map(e)),
  Ti((e) => iy(e) || iL(e), "number", (e) => iy(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity", Number),
  Ti((e) => e === 0 && 1 / e === -1 / 0, "number", () => "-0", Number),
  Ti(oL, "URL", (e) => e.toString(), (e) => new URL(e))
];
function Ad(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var wx = Ad((e, t) => _x(e) ? !!t.symbolRegistry.getIdentifier(e) : !1, (e, t) => ["symbol", t.symbolRegistry.getIdentifier(e)], (e) => e.description, (e, t, n) => {
  const r = n.symbolRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), sL = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((e, t) => (e[t.name] = t, e), {}), xx = Ad(aL, (e) => ["typed-array", e.constructor.name], (e) => [...e], (e, t) => {
  const n = sL[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function Ex(e, t) {
  return e != null && e.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
}
var Tx = Ad(Ex, (e, t) => ["class", t.classRegistry.getIdentifier(e.constructor)], (e, t) => {
  const n = t.classRegistry.getAllowedProps(e.constructor);
  if (!n)
    return { ...e };
  const r = {};
  return n.forEach((i) => {
    r[i] = e[i];
  }), r;
}, (e, t, n) => {
  const r = n.classRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(r.prototype), e);
}), kx = Ad((e, t) => !!t.customTransformerRegistry.findApplicable(e), (e, t) => ["custom", t.customTransformerRegistry.findApplicable(e).name], (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e), (e, t, n) => {
  const r = n.customTransformerRegistry.findByName(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(e);
}), lL = [Tx, wx, kx, xx], ay = (e, t) => {
  const n = ry(lL, (i) => i.isApplicable(e, t));
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation(e, t)
    };
  const r = ry(bx, (i) => i.isApplicable(e, t));
  if (r)
    return {
      value: r.transform(e, t),
      type: r.annotation
    };
}, Sx = {};
bx.forEach((e) => {
  Sx[e.annotation] = e;
});
var uL = (e, t, n) => {
  if (Va(t))
    switch (t[0]) {
      case "symbol":
        return wx.untransform(e, t, n);
      case "class":
        return Tx.untransform(e, t, n);
      case "custom":
        return kx.untransform(e, t, n);
      case "typed-array":
        return xx.untransform(e, t, n);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    const r = Sx[t];
    if (!r)
      throw new Error("Unknown transformation: " + t);
    return r.untransform(e, n);
  }
};
ye();
var gs = (e, t) => {
  const n = e.keys();
  for (; t > 0; )
    n.next(), t--;
  return n.next().value;
};
function Ox(e) {
  if (Gc(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (Gc(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (Gc(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var cL = (e, t) => {
  Ox(t);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (zl(e))
      e = gs(e, +r);
    else if (Yl(e)) {
      const i = +r, a = +t[++n] == 0 ? "key" : "value", o = gs(e, i);
      switch (a) {
        case "key":
          e = o;
          break;
        case "value":
          e = e.get(o);
          break;
      }
    } else
      e = e[r];
  }
  return e;
}, mp = (e, t, n) => {
  if (Ox(t), t.length === 0)
    return n(e);
  let r = e;
  for (let a = 0; a < t.length - 1; a++) {
    const o = t[a];
    if (Va(r)) {
      const s = +o;
      r = r[s];
    } else if (jl(r))
      r = r[o];
    else if (zl(r)) {
      const s = +o;
      r = gs(r, s);
    } else if (Yl(r)) {
      if (a === t.length - 2)
        break;
      const u = +o, d = +t[++a] == 0 ? "key" : "value", f = gs(r, u);
      switch (d) {
        case "key":
          r = f;
          break;
        case "value":
          r = r.get(f);
          break;
      }
    }
  }
  const i = t[t.length - 1];
  if (Va(r) ? r[+i] = n(r[+i]) : jl(r) && (r[i] = n(r[i])), zl(r)) {
    const a = gs(r, +i), o = n(a);
    a !== o && (r.delete(a), r.add(o));
  }
  if (Yl(r)) {
    const a = +t[t.length - 2], o = gs(r, a);
    switch (+i == 0 ? "key" : "value") {
      case "key": {
        const u = n(o);
        r.set(u, r.get(o)), u !== o && r.delete(o);
        break;
      }
      case "value": {
        r.set(o, n(r.get(o)));
        break;
      }
    }
  }
  return e;
};
function gp(e, t, n = []) {
  if (!e)
    return;
  if (!Va(e)) {
    xs(e, (a, o) => gp(a, t, [...n, ...Cl(o)]));
    return;
  }
  const [r, i] = e;
  i && xs(i, (a, o) => {
    gp(a, t, [...n, ...Cl(o)]);
  }), t(r, n);
}
function dL(e, t, n) {
  return gp(t, (r, i) => {
    e = mp(e, i, (a) => uL(a, r, n));
  }), e;
}
function fL(e, t) {
  function n(r, i) {
    const a = cL(e, Cl(i));
    r.map(Cl).forEach((o) => {
      e = mp(e, o, () => a);
    });
  }
  if (Va(t)) {
    const [r, i] = t;
    r.forEach((a) => {
      e = mp(e, Cl(a), () => e);
    }), i && xs(i, n);
  } else
    xs(t, n);
  return e;
}
var hL = (e, t) => jl(e) || Va(e) || Yl(e) || zl(e) || Ex(e, t);
function pL(e, t, n) {
  const r = n.get(e);
  r ? r.push(t) : n.set(e, [t]);
}
function mL(e, t) {
  const n = {};
  let r;
  return e.forEach((i) => {
    if (i.length <= 1)
      return;
    t || (i = i.map((s) => s.map(String)).sort((s, u) => s.length - u.length));
    const [a, ...o] = i;
    a.length === 0 ? r = o.map(Th) : n[Th(a)] = o.map(Th);
  }), r ? pp(n) ? [r] : [r, n] : pp(n) ? void 0 : n;
}
var Cx = (e, t, n, r, i = [], a = [], o = /* @__PURE__ */ new Map()) => {
  var s;
  const u = nL(e);
  if (!u) {
    pL(e, i, t);
    const v = o.get(e);
    if (v)
      return r ? {
        transformedValue: null
      } : v;
  }
  if (!hL(e, n)) {
    const v = ay(e, n), b = v ? {
      transformedValue: v.value,
      annotations: [v.type]
    } : {
      transformedValue: e
    };
    return u || o.set(e, b), b;
  }
  if (Gc(a, e))
    return {
      transformedValue: null
    };
  const d = ay(e, n), f = (s = d == null ? void 0 : d.value) != null ? s : e, p = Va(f) ? [] : {}, m = {};
  xs(f, (v, b) => {
    if (b === "__proto__" || b === "constructor" || b === "prototype")
      throw new Error(`Detected property ${b}. This is a prototype pollution risk, please remove it from your object.`);
    const w = Cx(v, t, n, r, [...i, b], [...a, e], o);
    p[b] = w.transformedValue, Va(w.annotations) ? m[b] = w.annotations : jl(w.annotations) && xs(w.annotations, (T, S) => {
      m[yx(b) + "." + S] = T;
    });
  });
  const g = pp(m) ? {
    transformedValue: p,
    annotations: d ? [d.type] : void 0
  } : {
    transformedValue: p,
    annotations: d ? [d.type, m] : m
  };
  return u || o.set(e, g), g;
};
ye();
ye();
function Ax(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function oy(e) {
  return Ax(e) === "Array";
}
function gL(e) {
  if (Ax(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function vL(e, t, n, r, i) {
  const a = {}.propertyIsEnumerable.call(r, t) ? "enumerable" : "nonenumerable";
  a === "enumerable" && (e[t] = n), i && a === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function vp(e, t = {}) {
  if (oy(e))
    return e.map((i) => vp(i, t));
  if (!gL(e))
    return e;
  const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertySymbols(e);
  return [...n, ...r].reduce((i, a) => {
    if (oy(t.props) && !t.props.includes(a))
      return i;
    const o = e[a], s = vp(o, t);
    return vL(i, a, s, e, t.nonenumerable), i;
  }, {});
}
var en = class {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new jN(), this.symbolRegistry = new gx((t) => {
      var n;
      return (n = t.description) != null ? n : "";
    }), this.customTransformerRegistry = new GN(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const t = /* @__PURE__ */ new Map(), n = Cx(e, t, this, this.dedupe), r = {
      json: n.transformedValue
    };
    n.annotations && (r.meta = {
      ...r.meta,
      values: n.annotations
    });
    const i = mL(t, this.dedupe);
    return i && (r.meta = {
      ...r.meta,
      referentialEqualities: i
    }), r;
  }
  deserialize(e) {
    const { json: t, meta: n } = e;
    let r = vp(t);
    return n != null && n.values && (r = dL(r, n.values, this)), n != null && n.referentialEqualities && (r = fL(r, n.referentialEqualities)), r;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e));
  }
  registerClass(e, t) {
    this.classRegistry.register(e, t);
  }
  registerSymbol(e, t) {
    this.symbolRegistry.register(e, t);
  }
  registerCustom(e, t) {
    this.customTransformerRegistry.register({
      name: t,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
};
en.defaultInstance = new en();
en.serialize = en.defaultInstance.serialize.bind(en.defaultInstance);
en.deserialize = en.defaultInstance.deserialize.bind(en.defaultInstance);
en.stringify = en.defaultInstance.stringify.bind(en.defaultInstance);
en.parse = en.defaultInstance.parse.bind(en.defaultInstance);
en.registerClass = en.defaultInstance.registerClass.bind(en.defaultInstance);
en.registerSymbol = en.defaultInstance.registerSymbol.bind(en.defaultInstance);
en.registerCustom = en.defaultInstance.registerCustom.bind(en.defaultInstance);
en.allowErrorProps = en.defaultInstance.allowErrorProps.bind(en.defaultInstance);
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
ye();
var sy, ly;
(ly = (sy = Le).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null || (sy.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = []);
var uy, cy;
(cy = (uy = Le).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null || (uy.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null);
var dy, fy;
(fy = (dy = Le).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null || (dy.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null);
var hy, py;
(py = (hy = Le).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null || (hy.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null);
var my, gy;
(gy = (my = Le).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null || (my.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null);
var vy, _y;
(_y = (vy = Le).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null || (vy.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null);
ye();
ye();
ye();
ye();
ye();
ye();
ye();
/**
  * vee-validate v4.14.7
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
function _i(e) {
  return typeof e == "function";
}
function _L(e) {
  return e == null;
}
const Es = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function Dx(e) {
  return Number(e) >= 0;
}
function yL(e) {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}
function bL(e) {
  const t = e.split(".");
  if (!t.length)
    return "";
  let n = String(t[0]);
  for (let r = 1; r < t.length; r++) {
    if (Dx(t[r])) {
      n += `[${t[r]}]`;
      continue;
    }
    n += `.${t[r]}`;
  }
  return n;
}
const wL = {};
function xL(e) {
  return wL[e];
}
function yy(e, t, n) {
  typeof n.value == "object" && (n.value = Eo(n.value)), !n.enumerable || n.get || n.set || !n.configurable || !n.writable || t === "__proto__" ? Object.defineProperty(e, t, n) : e[t] = n.value;
}
function Eo(e) {
  if (typeof e != "object") return e;
  var t = 0, n, r, i, a = Object.prototype.toString.call(e);
  if (a === "[object Object]" ? i = Object.create(e.__proto__ || null) : a === "[object Array]" ? i = Array(e.length) : a === "[object Set]" ? (i = /* @__PURE__ */ new Set(), e.forEach(function(o) {
    i.add(Eo(o));
  })) : a === "[object Map]" ? (i = /* @__PURE__ */ new Map(), e.forEach(function(o, s) {
    i.set(Eo(s), Eo(o));
  })) : a === "[object Date]" ? i = /* @__PURE__ */ new Date(+e) : a === "[object RegExp]" ? i = new RegExp(e.source, e.flags) : a === "[object DataView]" ? i = new e.constructor(Eo(e.buffer)) : a === "[object ArrayBuffer]" ? i = e.slice(0) : a.slice(-6) === "Array]" && (i = new e.constructor(e)), i) {
    for (r = Object.getOwnPropertySymbols(e); t < r.length; t++)
      yy(i, r[t], Object.getOwnPropertyDescriptor(e, r[t]));
    for (t = 0, r = Object.getOwnPropertyNames(e); t < r.length; t++)
      Object.hasOwnProperty.call(i, n = r[t]) && i[n] === e[n] || yy(i, n, Object.getOwnPropertyDescriptor(e, n));
  }
  return i || e;
}
const Px = Symbol("vee-validate-form"), EL = Symbol("vee-validate-field-instance"), ed = Symbol("Default empty value"), TL = typeof window < "u";
function _p(e) {
  return _i(e) && !!e.__locatorRef;
}
function Al(e) {
  return !!e && _i(e.parse) && e.__type === "VVTypedSchema";
}
function yp(e) {
  return !!e && _i(e.validate);
}
function uu(e) {
  return e === "checkbox" || e === "radio";
}
function kL(e) {
  return Es(e) || Array.isArray(e);
}
function Em(e) {
  return /^\[.+\]$/i.test(e);
}
function SL(e) {
  return Mx(e) && e.multiple;
}
function Mx(e) {
  return e.tagName === "SELECT";
}
function OL(e, t) {
  const n = ![!1, null, void 0, 0].includes(t.multiple) && !Number.isNaN(t.multiple);
  return e === "select" && "multiple" in t && n;
}
function CL(e, t) {
  return !OL(e, t) && t.type !== "file" && !uu(t.type);
}
function AL(e) {
  return e ? !!(typeof Event < "u" && _i(Event) && e instanceof Event || e && e.srcElement) : !1;
}
function by(e, t) {
  return t in e && e[t] !== ed;
}
function Yr(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Yr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      for (r of e.entries())
        if (!Yr(r[1], t.get(r[0])))
          return !1;
      return !0;
    }
    if (xy(e) && xy(t))
      return !(e.size !== t.size || e.name !== t.name || e.lastModified !== t.lastModified || e.type !== t.type);
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length - wy(e, i), n !== Object.keys(t).length - wy(t, Object.keys(t)))
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      var a = i[r];
      if (!Yr(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function wy(e, t) {
  let n = 0;
  for (let i = t.length; i-- !== 0; ) {
    var r = t[i];
    e[r] === void 0 && n++;
  }
  return n;
}
function xy(e) {
  return TL ? e instanceof File : !1;
}
function Ix(e) {
  return Em(e) ? e.replace(/\[|\]/gi, "") : e;
}
function Ts(e, t, n) {
  return e ? Em(t) ? e[Ix(t)] : (t || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((i, a) => kL(i) && a in i ? i[a] : n, e) : n;
}
function DL(e, t, n) {
  if (Em(t)) {
    e[Ix(t)] = n;
    return;
  }
  const r = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let i = e;
  for (let a = 0; a < r.length; a++) {
    if (a === r.length - 1) {
      i[r[a]] = n;
      return;
    }
    (!(r[a] in i) || _L(i[r[a]])) && (i[r[a]] = Dx(r[a + 1]) ? [] : {}), i = i[r[a]];
  }
}
function Nx(e) {
  return Object.keys(e);
}
function Lx(e, t = void 0) {
  const n = ui();
  return (n == null ? void 0 : n.provides[e]) || qn(e, t);
}
function Ey(e, t, n) {
  if (Array.isArray(e)) {
    const r = [...e], i = r.findIndex((a) => Yr(a, t));
    return i >= 0 ? r.splice(i, 1) : r.push(t), r;
  }
  return Yr(e, t) ? n : t;
}
function PL(e, t) {
  let n, r;
  return function(...i) {
    const a = this;
    return n || (n = !0, setTimeout(() => n = !1, t), r = e.apply(a, i)), r;
  };
}
function ML(e, t) {
  return Es(t) && t.number ? yL(e) : e;
}
function Ty(e, t) {
  let n;
  return async function(...i) {
    const a = e(...i);
    n = a;
    const o = await a;
    return a !== n ? o : (n = void 0, t(o, i));
  };
}
function IL(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
}
function NL(e, t, n) {
  return t.slots.default ? typeof e == "string" || !e ? t.slots.default(n()) : {
    default: () => {
      var r, i;
      return (i = (r = t.slots).default) === null || i === void 0 ? void 0 : i.call(r, n());
    }
  } : t.slots.default;
}
function kh(e) {
  if (Rx(e))
    return e._value;
}
function Rx(e) {
  return "_value" in e;
}
function LL(e) {
  return e.type === "number" || e.type === "range" ? Number.isNaN(e.valueAsNumber) ? e.value : e.valueAsNumber : e.value;
}
function Fx(e) {
  if (!AL(e))
    return e;
  const t = e.target;
  if (uu(t.type) && Rx(t))
    return kh(t);
  if (t.type === "file" && t.files) {
    const n = Array.from(t.files);
    return t.multiple ? n : n[0];
  }
  if (SL(t))
    return Array.from(t.options).filter((n) => n.selected && !n.disabled).map(kh);
  if (Mx(t)) {
    const n = Array.from(t.options).find((r) => r.selected);
    return n ? kh(n) : t.value;
  }
  return LL(t);
}
function $x(e) {
  const t = {};
  return Object.defineProperty(t, "_$$isNormalized", {
    value: !0,
    writable: !1,
    enumerable: !1,
    configurable: !1
  }), e ? Es(e) && e._$$isNormalized ? e : Es(e) ? Object.keys(e).reduce((n, r) => {
    const i = RL(e[r]);
    return e[r] !== !1 && (n[r] = ky(i)), n;
  }, t) : typeof e != "string" ? t : e.split("|").reduce((n, r) => {
    const i = FL(r);
    return i.name && (n[i.name] = ky(i.params)), n;
  }, t) : t;
}
function RL(e) {
  return e === !0 ? [] : Array.isArray(e) || Es(e) ? e : [e];
}
function ky(e) {
  const t = (n) => typeof n == "string" && n[0] === "@" ? $L(n.slice(1)) : n;
  return Array.isArray(e) ? e.map(t) : e instanceof RegExp ? [e] : Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {});
}
const FL = (e) => {
  let t = [];
  const n = e.split(":")[0];
  return e.includes(":") && (t = e.split(":").slice(1).join(":").split(",")), { name: n, params: t };
};
function $L(e) {
  const t = (n) => {
    var r;
    return (r = Ts(n, e)) !== null && r !== void 0 ? r : n[e];
  };
  return t.__locatorRef = e, t;
}
function VL(e) {
  return Array.isArray(e) ? e.filter(_p) : Nx(e).filter((t) => _p(e[t])).map((t) => e[t]);
}
const BL = {
  generateMessage: ({ field: e }) => `${e} is not valid.`,
  bails: !0,
  validateOnBlur: !0,
  validateOnChange: !0,
  validateOnInput: !1,
  validateOnModelUpdate: !0
};
let UL = Object.assign({}, BL);
const Tm = () => UL;
async function WL(e, t, n = {}) {
  const r = n == null ? void 0 : n.bails, i = {
    name: (n == null ? void 0 : n.name) || "{field}",
    rules: t,
    label: n == null ? void 0 : n.label,
    bails: r ?? !0,
    formData: (n == null ? void 0 : n.values) || {}
  }, a = await HL(i, e);
  return Object.assign(Object.assign({}, a), { valid: !a.errors.length });
}
async function HL(e, t) {
  const n = e.rules;
  if (Al(n) || yp(n))
    return zL(t, Object.assign(Object.assign({}, e), { rules: n }));
  if (_i(n) || Array.isArray(n)) {
    const s = {
      field: e.label || e.name,
      name: e.name,
      label: e.label,
      form: e.formData,
      value: t
    }, u = Array.isArray(n) ? n : [n], d = u.length, f = [];
    for (let p = 0; p < d; p++) {
      const m = u[p], g = await m(t, s);
      if (!(typeof g != "string" && !Array.isArray(g) && g)) {
        if (Array.isArray(g))
          f.push(...g);
        else {
          const b = typeof g == "string" ? g : Vx(s);
          f.push(b);
        }
        if (e.bails)
          return {
            errors: f
          };
      }
    }
    return {
      errors: f
    };
  }
  const r = Object.assign(Object.assign({}, e), { rules: $x(n) }), i = [], a = Object.keys(r.rules), o = a.length;
  for (let s = 0; s < o; s++) {
    const u = a[s], d = await GL(r, t, {
      name: u,
      params: r.rules[u]
    });
    if (d.error && (i.push(d.error), e.bails))
      return {
        errors: i
      };
  }
  return {
    errors: i
  };
}
function jL(e) {
  return !!e && e.name === "ValidationError";
}
function YL(e) {
  return {
    __type: "VVTypedSchema",
    async parse(n, r) {
      var i;
      try {
        return {
          output: await e.validate(n, { abortEarly: !1, context: (r == null ? void 0 : r.formData) || {} }),
          errors: []
        };
      } catch (a) {
        if (!jL(a))
          throw a;
        if (!(!((i = a.inner) === null || i === void 0) && i.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const o = a.inner.reduce((s, u) => {
          const d = u.path || "";
          return s[d] || (s[d] = { errors: [], path: d }), s[d].errors.push(...u.errors), s;
        }, {});
        return { errors: Object.values(o) };
      }
    }
  };
}
async function zL(e, t) {
  const r = await (Al(t.rules) ? t.rules : YL(t.rules)).parse(e, { formData: t.formData }), i = [];
  for (const a of r.errors)
    a.errors.length && i.push(...a.errors);
  return {
    value: r.value,
    errors: i
  };
}
async function GL(e, t, n) {
  const r = xL(n.name);
  if (!r)
    throw new Error(`No such validator '${n.name}' exists.`);
  const i = qL(n.params, e.formData), a = {
    field: e.label || e.name,
    name: e.name,
    label: e.label,
    value: t,
    form: e.formData,
    rule: Object.assign(Object.assign({}, n), { params: i })
  }, o = await r(t, i, a);
  return typeof o == "string" ? {
    error: o
  } : {
    error: o ? void 0 : Vx(a)
  };
}
function Vx(e) {
  const t = Tm().generateMessage;
  return t ? t(e) : "Field is invalid";
}
function qL(e, t) {
  const n = (r) => _p(r) ? r(t) : r;
  return Array.isArray(e) ? e.map(n) : Object.keys(e).reduce((r, i) => (r[i] = n(e[i]), r), {});
}
let Sy = 0;
function KL(e, t) {
  const { value: n, initialValue: r, setInitialValue: i } = XL(e, t.modelValue, t.form);
  if (!t.form) {
    let m = function(g) {
      var v;
      "value" in g && (n.value = g.value), "errors" in g && d(g.errors), "touched" in g && (p.touched = (v = g.touched) !== null && v !== void 0 ? v : p.touched), "initialValue" in g && i(g.initialValue);
    };
    const { errors: u, setErrors: d } = JL(), f = Sy >= Number.MAX_SAFE_INTEGER ? 0 : ++Sy, p = QL(n, r, u, t.schema);
    return {
      id: f,
      path: e,
      value: n,
      initialValue: r,
      meta: p,
      flags: { pendingUnmount: { [f]: !1 }, pendingReset: !1 },
      errors: u,
      setState: m
    };
  }
  const a = t.form.createPathState(e, {
    bails: t.bails,
    label: t.label,
    type: t.type,
    validate: t.validate,
    schema: t.schema
  }), o = oe(() => a.errors);
  function s(u) {
    var d, f, p;
    "value" in u && (n.value = u.value), "errors" in u && ((d = t.form) === null || d === void 0 || d.setFieldError(j(e), u.errors)), "touched" in u && ((f = t.form) === null || f === void 0 || f.setFieldTouched(j(e), (p = u.touched) !== null && p !== void 0 ? p : !1)), "initialValue" in u && i(u.initialValue);
  }
  return {
    id: Array.isArray(a.id) ? a.id[a.id.length - 1] : a.id,
    path: e,
    value: n,
    errors: o,
    meta: a,
    initialValue: r,
    flags: a.__flags,
    setState: s
  };
}
function XL(e, t, n) {
  const r = fe(j(t));
  function i() {
    return n ? Ts(n.initialValues.value, j(e), j(r)) : j(r);
  }
  function a(d) {
    if (!n) {
      r.value = d;
      return;
    }
    n.setFieldInitialValue(j(e), d, !0);
  }
  const o = oe(i);
  if (!n)
    return {
      value: fe(i()),
      initialValue: o,
      setInitialValue: a
    };
  const s = ZL(t, n, o, e);
  return n.stageInitialValue(j(e), s, !0), {
    value: oe({
      get() {
        return Ts(n.values, j(e));
      },
      set(d) {
        n.setFieldValue(j(e), d, !1);
      }
    }),
    initialValue: o,
    setInitialValue: a
  };
}
function ZL(e, t, n, r) {
  return Si(e) ? j(e) : e !== void 0 ? e : Ts(t.values, j(r), j(n));
}
function QL(e, t, n, r) {
  const i = oe(() => {
    var o, s, u;
    return (u = (s = (o = xn(r)) === null || o === void 0 ? void 0 : o.describe) === null || s === void 0 ? void 0 : s.call(o).required) !== null && u !== void 0 ? u : !1;
  }), a = Uo({
    touched: !1,
    pending: !1,
    valid: !0,
    required: i,
    validated: !!j(n).length,
    initialValue: oe(() => j(t)),
    dirty: oe(() => !Yr(j(e), j(t)))
  });
  return dn(n, (o) => {
    a.valid = !o.length;
  }, {
    immediate: !0,
    flush: "sync"
  }), a;
}
function JL() {
  const e = fe([]);
  return {
    errors: e,
    setErrors: (t) => {
      e.value = IL(t);
    }
  };
}
const Bx = {}, Dl = {}, Pl = "vee-validate-inspector", Sr = {
  error: 12405579,
  success: 448379,
  unknown: 5522283,
  white: 16777215,
  black: 0,
  blue: 218007,
  purple: 12157168,
  orange: 16099682,
  gray: 12304330
};
let Cn = null, Da;
function eR(e) {
  process.env.NODE_ENV !== "production" && LN({
    id: "vee-validate-devtools-plugin",
    label: "VeeValidate Plugin",
    packageName: "vee-validate",
    homepage: "https://vee-validate.logaretm.com/v4",
    app: e,
    logo: "https://vee-validate.logaretm.com/v4/logo.png"
  }, (t) => {
    Da = t, t.addInspector({
      id: Pl,
      icon: "rule",
      label: "vee-validate",
      noSelectionText: "Select a vee-validate node to inspect",
      actions: [
        {
          icon: "done_outline",
          tooltip: "Validate selected item",
          action: async () => {
            if (!Cn) {
              console.error("There is not a valid selected vee-validate node or component");
              return;
            }
            if (Cn.type === "field") {
              await Cn.field.validate();
              return;
            }
            if (Cn.type === "form") {
              await Cn.form.validate();
              return;
            }
            Cn.type === "pathState" && await Cn.form.validateField(Cn.state.path);
          }
        },
        {
          icon: "delete_sweep",
          tooltip: "Clear validation state of the selected item",
          action: () => {
            if (!Cn) {
              console.error("There is not a valid selected vee-validate node or component");
              return;
            }
            if (Cn.type === "field") {
              Cn.field.resetField();
              return;
            }
            Cn.type === "form" && Cn.form.resetForm(), Cn.type === "pathState" && Cn.form.resetField(Cn.state.path);
          }
        }
      ]
    }), t.on.getInspectorTree((n) => {
      if (n.inspectorId !== Pl)
        return;
      const r = Object.values(Bx), i = Object.values(Dl);
      n.rootNodes = [
        ...r.map(nR),
        ...i.map((a) => iR(a))
      ];
    }), t.on.getInspectorState((n) => {
      if (n.inspectorId !== Pl)
        return;
      const { form: r, field: i, state: a, type: o } = aR(n.nodeId);
      if (t.unhighlightElement(), r && o === "form") {
        n.state = oR(r), Cn = { type: "form", form: r }, t.highlightElement(r._vm);
        return;
      }
      if (a && o === "pathState" && r) {
        n.state = Oy(a), Cn = { type: "pathState", state: a, form: r };
        return;
      }
      if (i && o === "field") {
        n.state = Oy({
          errors: i.errors.value,
          dirty: i.meta.dirty,
          valid: i.meta.valid,
          touched: i.meta.touched,
          value: i.value.value,
          initialValue: i.meta.initialValue
        }), Cn = { field: i, type: "field" }, t.highlightElement(i._vm);
        return;
      }
      Cn = null, t.unhighlightElement();
    });
  });
}
const bp = PL(() => {
  setTimeout(async () => {
    await $a(), Da == null || Da.sendInspectorState(Pl), Da == null || Da.sendInspectorTree(Pl);
  }, 100);
}, 100);
function tR(e) {
  const t = ui();
  if (!Da) {
    const n = t == null ? void 0 : t.appContext.app;
    if (!n)
      return;
    eR(n);
  }
  Dl[e.id] = Object.assign({}, e), Dl[e.id]._vm = t, Bn(() => {
    delete Dl[e.id], bp();
  }), bp();
}
function nR(e) {
  const { textColor: t, bgColor: n } = Wx(e.meta.value.valid), r = {};
  Object.values(e.getAllPathStates()).forEach((o) => {
    DL(r, xn(o.path), rR(o, e));
  });
  function i(o, s = []) {
    const u = [...s].pop();
    return "id" in o ? Object.assign(Object.assign({}, o), { label: u || o.label }) : Es(o) ? {
      id: `${s.join(".")}`,
      label: u || "",
      children: Object.keys(o).map((d) => i(o[d], [...s, d]))
    } : Array.isArray(o) ? {
      id: `${s.join(".")}`,
      label: `${u}[]`,
      children: o.map((d, f) => i(d, [...s, String(f)]))
    } : { id: "", label: "", children: [] };
  }
  const { children: a } = i(r);
  return {
    id: km(e),
    label: e.name,
    children: a,
    tags: [
      {
        label: "Form",
        textColor: t,
        backgroundColor: n
      },
      {
        label: `${e.getAllPathStates().length} fields`,
        textColor: Sr.white,
        backgroundColor: Sr.unknown
      }
    ]
  };
}
function rR(e, t) {
  return {
    id: km(t, e),
    label: xn(e.path),
    tags: Ux(e.multiple, e.fieldsCount, e.type, e.valid, t)
  };
}
function iR(e, t) {
  return {
    id: km(t, e),
    label: j(e.name),
    tags: Ux(!1, 1, e.type, e.meta.valid, t)
  };
}
function Ux(e, t, n, r, i) {
  const { textColor: a, bgColor: o } = Wx(r);
  return [
    e ? void 0 : {
      label: "Field",
      textColor: a,
      backgroundColor: o
    },
    i ? void 0 : {
      label: "Standalone",
      textColor: Sr.black,
      backgroundColor: Sr.gray
    },
    n === "checkbox" ? {
      label: "Checkbox",
      textColor: Sr.white,
      backgroundColor: Sr.blue
    } : void 0,
    n === "radio" ? {
      label: "Radio",
      textColor: Sr.white,
      backgroundColor: Sr.purple
    } : void 0,
    e ? {
      label: "Multiple",
      textColor: Sr.black,
      backgroundColor: Sr.orange
    } : void 0
  ].filter(Boolean);
}
function km(e, t) {
  const n = t ? "path" in t ? "pathState" : "field" : "form", r = t ? "path" in t ? t == null ? void 0 : t.path : xn(t == null ? void 0 : t.name) : "", i = { f: e == null ? void 0 : e.formId, ff: (t == null ? void 0 : t.id) || r, type: n };
  return btoa(encodeURIComponent(JSON.stringify(i)));
}
function aR(e) {
  try {
    const t = JSON.parse(decodeURIComponent(atob(e))), n = Bx[t.f];
    if (!n && t.ff) {
      const i = Dl[t.ff];
      return i ? {
        type: t.type,
        field: i
      } : {};
    }
    if (!n)
      return {};
    const r = n.getPathState(t.ff);
    return {
      type: t.type,
      form: n,
      state: r
    };
  } catch {
  }
  return {};
}
function Oy(e) {
  return {
    "Field state": [
      { key: "errors", value: e.errors },
      {
        key: "initialValue",
        value: e.initialValue
      },
      {
        key: "currentValue",
        value: e.value
      },
      {
        key: "touched",
        value: e.touched
      },
      {
        key: "dirty",
        value: e.dirty
      },
      {
        key: "valid",
        value: e.valid
      }
    ]
  };
}
function oR(e) {
  const { errorBag: t, meta: n, values: r, isSubmitting: i, isValidating: a, submitCount: o } = e;
  return {
    "Form state": [
      {
        key: "submitCount",
        value: o.value
      },
      {
        key: "isSubmitting",
        value: i.value
      },
      {
        key: "isValidating",
        value: a.value
      },
      {
        key: "touched",
        value: n.value.touched
      },
      {
        key: "dirty",
        value: n.value.dirty
      },
      {
        key: "valid",
        value: n.value.valid
      },
      {
        key: "initialValues",
        value: n.value.initialValues
      },
      {
        key: "currentValues",
        value: r
      },
      {
        key: "errors",
        value: Nx(t.value).reduce((s, u) => {
          var d;
          const f = (d = t.value[u]) === null || d === void 0 ? void 0 : d[0];
          return f && (s[u] = f), s;
        }, {})
      }
    ]
  };
}
function Wx(e) {
  return {
    bgColor: e ? Sr.success : Sr.error,
    textColor: e ? Sr.black : Sr.white
  };
}
function sR(e, t, n) {
  return uu(n == null ? void 0 : n.type) ? uR(e, t, n) : Hx(e, t, n);
}
function Hx(e, t, n) {
  const { initialValue: r, validateOnMount: i, bails: a, type: o, checkedValue: s, label: u, validateOnValueUpdate: d, uncheckedValue: f, controlled: p, keepValueOnUnmount: m, syncVModel: g, form: v } = lR(n), b = p ? Lx(Px) : void 0, w = v || b, T = oe(() => bL(xn(e))), S = oe(() => {
    if (xn(w == null ? void 0 : w.schema))
      return;
    const Re = j(t);
    return yp(Re) || Al(Re) || _i(Re) || Array.isArray(Re) ? Re : $x(Re);
  }), x = !_i(S.value) && Al(xn(t)), { id: O, value: C, initialValue: P, meta: k, setState: M, errors: N, flags: X } = KL(T, {
    modelValue: r,
    form: w,
    bails: a,
    label: u,
    type: o,
    validate: S.value ? Q : void 0,
    schema: x ? t : void 0
  }), Z = oe(() => N.value[0]);
  g && cR({
    value: C,
    prop: g,
    handleChange: y,
    shouldValidate: () => d && !X.pendingReset
  });
  const te = (Y, Re = !1) => {
    k.touched = !0, Re && we();
  };
  async function ce(Y) {
    var Re, it;
    if (w != null && w.validateSchema) {
      const { results: He } = await w.validateSchema(Y);
      return (Re = He[xn(T)]) !== null && Re !== void 0 ? Re : { valid: !0, errors: [] };
    }
    return S.value ? WL(C.value, S.value, {
      name: xn(T),
      label: xn(u),
      values: (it = w == null ? void 0 : w.values) !== null && it !== void 0 ? it : {},
      bails: a
    }) : { valid: !0, errors: [] };
  }
  const we = Ty(async () => (k.pending = !0, k.validated = !0, ce("validated-only")), (Y) => (X.pendingUnmount[U.id] || (M({ errors: Y.errors }), k.pending = !1, k.valid = Y.valid), Y)), G = Ty(async () => ce("silent"), (Y) => (k.valid = Y.valid, Y));
  function Q(Y) {
    return (Y == null ? void 0 : Y.mode) === "silent" ? G() : we();
  }
  function y(Y, Re = !0) {
    const it = Fx(Y);
    J(it, Re);
  }
  Mt(() => {
    if (i)
      return we();
    (!w || !w.validateSchema) && G();
  });
  function H(Y) {
    k.touched = Y;
  }
  function ie(Y) {
    var Re;
    const it = Y && "value" in Y ? Y.value : P.value;
    M({
      value: Eo(it),
      initialValue: Eo(it),
      touched: (Re = Y == null ? void 0 : Y.touched) !== null && Re !== void 0 ? Re : !1,
      errors: (Y == null ? void 0 : Y.errors) || []
    }), k.pending = !1, k.validated = !1, G();
  }
  const ne = ui();
  function J(Y, Re = !0) {
    C.value = ne && g ? ML(Y, ne.props.modelModifiers) : Y, (Re ? we : G)();
  }
  function me(Y) {
    M({ errors: Array.isArray(Y) ? Y : [Y] });
  }
  const xe = oe({
    get() {
      return C.value;
    },
    set(Y) {
      J(Y, d);
    }
  }), U = {
    id: O,
    name: T,
    label: u,
    value: xe,
    meta: k,
    errors: N,
    errorMessage: Z,
    type: o,
    checkedValue: s,
    uncheckedValue: f,
    bails: a,
    keepValueOnUnmount: m,
    resetField: ie,
    handleReset: () => ie(),
    validate: Q,
    handleChange: y,
    handleBlur: te,
    setState: M,
    setTouched: H,
    setErrors: me,
    setValue: J
  };
  if (Dr(EL, U), Si(t) && typeof j(t) != "function" && dn(t, (Y, Re) => {
    Yr(Y, Re) || (k.validated ? we() : G());
  }, {
    deep: !0
  }), process.env.NODE_ENV !== "production" && (U._vm = ui(), dn(() => Object.assign(Object.assign({ errors: N.value }, k), { value: C.value }), bp, {
    deep: !0
  }), w || tR(U)), !w)
    return U;
  const $ = oe(() => {
    const Y = S.value;
    return !Y || _i(Y) || yp(Y) || Al(Y) || Array.isArray(Y) ? {} : Object.keys(Y).reduce((Re, it) => {
      const He = VL(Y[it]).map((Vt) => Vt.__locatorRef).reduce((Vt, Bt) => {
        const Be = Ts(w.values, Bt) || w.values[Bt];
        return Be !== void 0 && (Vt[Bt] = Be), Vt;
      }, {});
      return Object.assign(Re, He), Re;
    }, {});
  });
  return dn($, (Y, Re) => {
    if (!Object.keys(Y).length)
      return;
    !Yr(Y, Re) && (k.validated ? we() : G());
  }), qw(() => {
    var Y;
    const Re = (Y = xn(U.keepValueOnUnmount)) !== null && Y !== void 0 ? Y : xn(w.keepValuesOnUnmount), it = xn(T);
    if (Re || !w || X.pendingUnmount[U.id]) {
      w == null || w.removePathState(it, O);
      return;
    }
    X.pendingUnmount[U.id] = !0;
    const He = w.getPathState(it);
    if (Array.isArray(He == null ? void 0 : He.id) && (He != null && He.multiple) ? He != null && He.id.includes(U.id) : (He == null ? void 0 : He.id) === U.id) {
      if (He != null && He.multiple && Array.isArray(He.value)) {
        const Bt = He.value.findIndex((Be) => Yr(Be, xn(U.checkedValue)));
        if (Bt > -1) {
          const Be = [...He.value];
          Be.splice(Bt, 1), w.setFieldValue(it, Be);
        }
        Array.isArray(He.id) && He.id.splice(He.id.indexOf(U.id), 1);
      } else
        w.unsetPathValue(xn(T));
      w.removePathState(it, O);
    }
  }), U;
}
function lR(e) {
  const t = () => ({
    initialValue: void 0,
    validateOnMount: !1,
    bails: !0,
    label: void 0,
    validateOnValueUpdate: !0,
    keepValueOnUnmount: void 0,
    syncVModel: !1,
    controlled: !0
  }), n = !!(e != null && e.syncVModel), r = typeof (e == null ? void 0 : e.syncVModel) == "string" ? e.syncVModel : (e == null ? void 0 : e.modelPropName) || "modelValue", i = n && !("initialValue" in (e || {})) ? wp(ui(), r) : e == null ? void 0 : e.initialValue;
  if (!e)
    return Object.assign(Object.assign({}, t()), { initialValue: i });
  const a = "valueProp" in e ? e.valueProp : e.checkedValue, o = "standalone" in e ? !e.standalone : e.controlled, s = (e == null ? void 0 : e.modelPropName) || (e == null ? void 0 : e.syncVModel) || !1;
  return Object.assign(Object.assign(Object.assign({}, t()), e || {}), {
    initialValue: i,
    controlled: o ?? !0,
    checkedValue: a,
    syncVModel: s
  });
}
function uR(e, t, n) {
  const r = n != null && n.standalone ? void 0 : Lx(Px), i = n == null ? void 0 : n.checkedValue, a = n == null ? void 0 : n.uncheckedValue;
  function o(s) {
    const u = s.handleChange, d = oe(() => {
      const p = xn(s.value), m = xn(i);
      return Array.isArray(p) ? p.findIndex((g) => Yr(g, m)) >= 0 : Yr(m, p);
    });
    function f(p, m = !0) {
      var g, v;
      if (d.value === ((g = p == null ? void 0 : p.target) === null || g === void 0 ? void 0 : g.checked)) {
        m && s.validate();
        return;
      }
      const b = xn(e), w = r == null ? void 0 : r.getPathState(b), T = Fx(p);
      let S = (v = xn(i)) !== null && v !== void 0 ? v : T;
      r && (w != null && w.multiple) && w.type === "checkbox" ? S = Ey(Ts(r.values, b) || [], S, void 0) : (n == null ? void 0 : n.type) === "checkbox" && (S = Ey(xn(s.value), S, xn(a))), u(S, m);
    }
    return Object.assign(Object.assign({}, s), {
      checked: d,
      checkedValue: i,
      uncheckedValue: a,
      handleChange: f
    });
  }
  return o(Hx(e, t, n));
}
function cR({ prop: e, value: t, handleChange: n, shouldValidate: r }) {
  const i = ui();
  if (!i || !e) {
    process.env.NODE_ENV !== "production" && console.warn("Failed to setup model events because `useField` was not called in setup.");
    return;
  }
  const a = typeof e == "string" ? e : "modelValue", o = `update:${a}`;
  a in i.props && (dn(t, (s) => {
    Yr(s, wp(i, a)) || i.emit(o, s);
  }), dn(() => wp(i, a), (s) => {
    if (s === ed && t.value === void 0)
      return;
    const u = s === ed ? void 0 : s;
    Yr(u, t.value) || n(u, r());
  }));
}
function wp(e, t) {
  if (e)
    return e.props[t];
}
const dR = /* @__PURE__ */ Tt({
  name: "Field",
  inheritAttrs: !1,
  props: {
    as: {
      type: [String, Object],
      default: void 0
    },
    name: {
      type: String,
      required: !0
    },
    rules: {
      type: [Object, String, Function],
      default: void 0
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    },
    validateOnBlur: {
      type: Boolean,
      default: void 0
    },
    validateOnChange: {
      type: Boolean,
      default: void 0
    },
    validateOnInput: {
      type: Boolean,
      default: void 0
    },
    validateOnModelUpdate: {
      type: Boolean,
      default: void 0
    },
    bails: {
      type: Boolean,
      default: () => Tm().bails
    },
    label: {
      type: String,
      default: void 0
    },
    uncheckedValue: {
      type: null,
      default: void 0
    },
    modelValue: {
      type: null,
      default: ed
    },
    modelModifiers: {
      type: null,
      default: () => ({})
    },
    "onUpdate:modelValue": {
      type: null,
      default: void 0
    },
    standalone: {
      type: Boolean,
      default: !1
    },
    keepValue: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e, t) {
    const n = aa(e, "rules"), r = aa(e, "name"), i = aa(e, "label"), a = aa(e, "uncheckedValue"), o = aa(e, "keepValue"), { errors: s, value: u, errorMessage: d, validate: f, handleChange: p, handleBlur: m, setTouched: g, resetField: v, handleReset: b, meta: w, checked: T, setErrors: S, setValue: x } = sR(r, n, {
      validateOnMount: e.validateOnMount,
      bails: e.bails,
      standalone: e.standalone,
      type: t.attrs.type,
      initialValue: hR(e, t),
      // Only for checkboxes and radio buttons
      checkedValue: t.attrs.value,
      uncheckedValue: a,
      label: i,
      validateOnValueUpdate: e.validateOnModelUpdate,
      keepValueOnUnmount: o,
      syncVModel: !0
    }), O = function(X, Z = !0) {
      p(X, Z);
    }, C = oe(() => {
      const { validateOnInput: N, validateOnChange: X, validateOnBlur: Z, validateOnModelUpdate: te } = fR(e);
      function ce(y) {
        m(y, Z), _i(t.attrs.onBlur) && t.attrs.onBlur(y);
      }
      function we(y) {
        O(y, N), _i(t.attrs.onInput) && t.attrs.onInput(y);
      }
      function G(y) {
        O(y, X), _i(t.attrs.onChange) && t.attrs.onChange(y);
      }
      const Q = {
        name: e.name,
        onBlur: ce,
        onInput: we,
        onChange: G
      };
      return Q["onUpdate:modelValue"] = (y) => O(y, te), Q;
    }), P = oe(() => {
      const N = Object.assign({}, C.value);
      uu(t.attrs.type) && T && (N.checked = T.value);
      const X = Cy(e, t);
      return CL(X, t.attrs) && (N.value = u.value), N;
    }), k = oe(() => Object.assign(Object.assign({}, C.value), { modelValue: u.value }));
    function M() {
      return {
        field: P.value,
        componentField: k.value,
        value: u.value,
        meta: w,
        errors: s.value,
        errorMessage: d.value,
        validate: f,
        resetField: v,
        handleChange: O,
        handleInput: (N) => O(N, !1),
        handleReset: b,
        handleBlur: C.value.onBlur,
        setTouched: g,
        setErrors: S,
        setValue: x
      };
    }
    return t.expose({
      value: u,
      meta: w,
      errors: s,
      errorMessage: d,
      setErrors: S,
      setTouched: g,
      setValue: x,
      reset: v,
      validate: f,
      handleChange: p
    }), () => {
      const N = Sl(Cy(e, t)), X = NL(N, t, M);
      return N ? Ct(N, Object.assign(Object.assign({}, t.attrs), P.value), X) : X;
    };
  }
});
function Cy(e, t) {
  let n = e.as || "";
  return !e.as && !t.slots.default && (n = "input"), n;
}
function fR(e) {
  var t, n, r, i;
  const { validateOnInput: a, validateOnChange: o, validateOnBlur: s, validateOnModelUpdate: u } = Tm();
  return {
    validateOnInput: (t = e.validateOnInput) !== null && t !== void 0 ? t : a,
    validateOnChange: (n = e.validateOnChange) !== null && n !== void 0 ? n : o,
    validateOnBlur: (r = e.validateOnBlur) !== null && r !== void 0 ? r : s,
    validateOnModelUpdate: (i = e.validateOnModelUpdate) !== null && i !== void 0 ? i : u
  };
}
function hR(e, t) {
  return uu(t.attrs.type) ? by(e, "modelValue") ? e.modelValue : void 0 : by(e, "modelValue") ? e.modelValue : t.attrs.value;
}
const Dd = dR, pt = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, pR = {
  components: {
    Field: Dd
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    name: {
      type: String,
      required: !0
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: !1
    },
    checkedValue: {
      type: [String, Number, Boolean],
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      // TODO: display required field & add validation
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    fieldClass: {
      type: String,
      default: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, mR = { class: "flex items-center sm:pt-1.5" }, gR = ["for"];
function vR(e, t, n, r, i, a) {
  const o = je("Field");
  return I(), W("div", mR, [
    Ae(o, {
      class: ze(["cursor-pointer h-4 w-4 border-gray-300 rounded text-primary-dark focus:ring-primary", n.disabled ? "bg-gray-200" : ""]),
      id: n.id,
      name: n.name,
      type: "checkbox",
      disabled: n.disabled,
      value: n.checkedValue,
      "unchecked-value": n.uncheckedValue,
      modelValue: a.internalValue,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s)
    }, null, 8, ["class", "id", "name", "disabled", "value", "unchecked-value", "modelValue"]),
    K("label", {
      for: n.id,
      class: ze(`ml-3 text-sm ${n.labelClass}`)
    }, ke(e.$t(n.label)), 11, gR)
  ]);
}
const Aee = /* @__PURE__ */ pt(pR, [["render", vR]]), _R = {
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: [String, null],
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      searchKeyword: "",
      debounce: null
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  watch: {
    options(e) {
      e.length === 1 && (this.internalValue = e[0].label);
    }
  }
}, yR = ["for"], bR = {
  key: 0,
  class: "text-red-600"
}, wR = ["list", "id", "name"], xR = ["id"], ER = ["value"];
function TR(e, t, n, r, i, a) {
  return I(), W("div", null, [
    K("label", {
      for: n.name,
      class: "block text-sm font-semibold leading-6 text-gray-900 sm:pt-1.5 mb-2"
    }, [
      Xt(ke(n.label) + " ", 1),
      n.required ? (I(), W("span", bR, "*")) : ee("", !0)
    ], 8, yR),
    Ni(K("input", {
      list: `${n.name}-list`,
      id: n.name,
      name: n.name,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
      class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 pl-3"
    }, null, 8, wR), [
      [dm, a.internalValue]
    ]),
    K("datalist", {
      id: `${n.name}-list`
    }, [
      (I(!0), W(Ge, null, Nt(n.options, (o) => (I(), W("option", {
        key: o.value,
        value: o.label
      }, ke(o.label), 9, ER))), 128))
    ], 8, xR)
  ]);
}
const Dee = /* @__PURE__ */ pt(_R, [["render", TR]]);
function ci(e) {
  "@babel/helpers - typeof";
  return ci = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ci(e);
}
function Je(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function We(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function et(e) {
  We(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || ci(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function pa(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Pi(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var i = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var o = a.getDate();
  return i >= o ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), i), n);
}
function jx(e, t) {
  if (We(2, arguments), !t || ci(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = t.years ? Je(t.years) : 0, r = t.months ? Je(t.months) : 0, i = t.weeks ? Je(t.weeks) : 0, a = t.days ? Je(t.days) : 0, o = t.hours ? Je(t.hours) : 0, s = t.minutes ? Je(t.minutes) : 0, u = t.seconds ? Je(t.seconds) : 0, d = et(e), f = r || n ? Pi(d, r + n * 12) : d, p = a || i ? pa(f, a + i * 7) : f, m = s + o * 60, g = u + m * 60, v = g * 1e3, b = new Date(p.getTime() + v);
  return b;
}
function kR(e, t) {
  We(2, arguments);
  var n = et(e).getTime(), r = Je(t);
  return new Date(n + r);
}
var SR = {};
function qa() {
  return SR;
}
function Po(e, t) {
  var n, r, i, a, o, s, u, d;
  We(1, arguments);
  var f = qa(), p = Je((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = et(e), g = m.getDay(), v = (g < p ? 7 : 0) + g - p;
  return m.setDate(m.getDate() - v), m.setHours(0, 0, 0, 0), m;
}
function td(e) {
  return We(1, arguments), Po(e, {
    weekStartsOn: 1
  });
}
function OR(e) {
  We(1, arguments);
  var t = et(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var i = td(r), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  var o = td(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function CR(e) {
  We(1, arguments);
  var t = OR(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = td(n);
  return r;
}
function nd(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Ay(e) {
  We(1, arguments);
  var t = et(e);
  return t.setHours(0, 0, 0, 0), t;
}
var AR = 864e5;
function DR(e, t) {
  We(2, arguments);
  var n = Ay(e), r = Ay(t), i = n.getTime() - nd(n), a = r.getTime() - nd(r);
  return Math.round((i - a) / AR);
}
function PR(e, t) {
  We(2, arguments);
  var n = Je(t), r = n * 7;
  return pa(e, r);
}
function Yx(e, t) {
  We(2, arguments);
  var n = Je(t);
  return Pi(e, n * 12);
}
var Sm = 6e4, Om = 36e5, MR = 1e3;
function zx(e) {
  return We(1, arguments), e instanceof Date || ci(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ml(e) {
  if (We(1, arguments), !zx(e) && typeof e != "number")
    return !1;
  var t = et(e);
  return !isNaN(Number(t));
}
function Cm(e) {
  We(1, arguments);
  var t = et(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Dy(e, t) {
  var n;
  We(1, arguments);
  var r = e || {}, i = et(r.start), a = et(r.end), o = a.getTime();
  if (!(i.getTime() <= o))
    throw new RangeError("Invalid interval");
  var s = [], u = i;
  u.setHours(0, 0, 0, 0);
  var d = Number((n = void 0) !== null && n !== void 0 ? n : 1);
  if (d < 1 || isNaN(d)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; u.getTime() <= o; )
    s.push(et(u)), u.setDate(u.getDate() + d), u.setHours(0, 0, 0, 0);
  return s;
}
function cu(e) {
  We(1, arguments);
  var t = et(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Gx(e) {
  We(1, arguments);
  var t = et(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Am(e, t) {
  var n, r, i, a, o, s, u, d;
  We(1, arguments);
  var f = qa(), p = Je((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = et(e), g = m.getDay(), v = (g < p ? -7 : 0) + 6 - (g - p);
  return m.setDate(m.getDate() + v), m.setHours(23, 59, 59, 999), m;
}
function qx(e, t) {
  We(2, arguments);
  var n = Je(t);
  return kR(e, -n);
}
var IR = 864e5;
function NR(e) {
  We(1, arguments);
  var t = et(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), i = n - r;
  return Math.floor(i / IR) + 1;
}
function ks(e) {
  We(1, arguments);
  var t = 1, n = et(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function Kx(e) {
  We(1, arguments);
  var t = et(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = ks(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = ks(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function LR(e) {
  We(1, arguments);
  var t = Kx(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = ks(n);
  return r;
}
var RR = 6048e5;
function Xx(e) {
  We(1, arguments);
  var t = et(e), n = ks(t).getTime() - LR(t).getTime();
  return Math.round(n / RR) + 1;
}
function Mo(e, t) {
  var n, r, i, a, o, s, u, d;
  We(1, arguments);
  var f = qa(), p = Je((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = et(e), g = m.getUTCDay(), v = (g < p ? 7 : 0) + g - p;
  return m.setUTCDate(m.getUTCDate() - v), m.setUTCHours(0, 0, 0, 0), m;
}
function Dm(e, t) {
  var n, r, i, a, o, s, u, d;
  We(1, arguments);
  var f = et(e), p = f.getUTCFullYear(), m = qa(), g = Je((n = (r = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : m.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = m.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(p + 1, 0, g), v.setUTCHours(0, 0, 0, 0);
  var b = Mo(v, t), w = /* @__PURE__ */ new Date(0);
  w.setUTCFullYear(p, 0, g), w.setUTCHours(0, 0, 0, 0);
  var T = Mo(w, t);
  return f.getTime() >= b.getTime() ? p + 1 : f.getTime() >= T.getTime() ? p : p - 1;
}
function FR(e, t) {
  var n, r, i, a, o, s, u, d;
  We(1, arguments);
  var f = qa(), p = Je((n = (r = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), m = Dm(e, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(m, 0, p), g.setUTCHours(0, 0, 0, 0);
  var v = Mo(g, t);
  return v;
}
var $R = 6048e5;
function Zx(e, t) {
  We(1, arguments);
  var n = et(e), r = Mo(n, t).getTime() - FR(n, t).getTime();
  return Math.round(r / $R) + 1;
}
function Wt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Sa = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return Wt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : Wt(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return Wt(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return Wt(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return Wt(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return Wt(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return Wt(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, r - 3));
    return Wt(a, n.length);
  }
}, cs = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, VR = {
  // Era
  G: function(t, n, r) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Sa.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, i) {
    var a = Dm(t, i), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var s = o % 100;
      return Wt(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : Wt(o, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = Kx(t);
    return Wt(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return Wt(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return Wt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return Wt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Sa.M(t, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return Wt(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, i) {
    var a = Zx(t, i);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : Wt(a, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var i = Xx(t);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : Wt(i, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Sa.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var i = NR(t);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : Wt(i, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var i = t.getUTCDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return Wt(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return Wt(o, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Wt(a, n.length);
      // 2nd
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      // Tue
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = cs.noon : i === 0 ? a = cs.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = cs.evening : i >= 12 ? a = cs.afternoon : i >= 4 ? a = cs.morning : a = cs.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Sa.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Sa.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : Wt(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : Wt(i, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Sa.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Sa.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Sa.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return My(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return _o(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return _o(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return My(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return _o(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return _o(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Py(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + _o(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Py(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + _o(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return Wt(o, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTime();
    return Wt(o, n.length);
  }
};
function Py(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(i);
  var o = t;
  return n + String(i) + o + Wt(a, 2);
}
function My(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Wt(Math.abs(e) / 60, 2);
  }
  return _o(e, t);
}
function _o(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), a = Wt(Math.floor(i / 60), 2), o = Wt(i % 60, 2);
  return r + a + n + o;
}
var Iy = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Qx = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, BR = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], i = r[1], a = r[2];
  if (!a)
    return Iy(t, n);
  var o;
  switch (i) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Iy(i, n)).replace("{{time}}", Qx(a, n));
}, xp = {
  p: Qx,
  P: BR
}, UR = ["D", "DD"], WR = ["YY", "YYYY"];
function Jx(e) {
  return UR.indexOf(e) !== -1;
}
function eE(e) {
  return WR.indexOf(e) !== -1;
}
function rd(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var HR = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, jR = function(t, n, r) {
  var i, a = HR[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
function _s(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var YR = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, zR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, GR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qR = {
  date: _s({
    formats: YR,
    defaultWidth: "full"
  }),
  time: _s({
    formats: zR,
    defaultWidth: "full"
  }),
  dateTime: _s({
    formats: GR,
    defaultWidth: "full"
  })
}, KR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, XR = function(t, n, r, i) {
  return KR[t];
};
function Oi(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[u] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
var ZR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, QR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, JR = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, eF = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, tF = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, nF = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, rF = function(t, n) {
  var r = Number(t), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, iF = {
  ordinalNumber: rF,
  era: Oi({
    values: ZR,
    defaultWidth: "wide"
  }),
  quarter: Oi({
    values: QR,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Oi({
    values: JR,
    defaultWidth: "wide"
  }),
  day: Oi({
    values: eF,
    defaultWidth: "wide"
  }),
  dayPeriod: Oi({
    values: tF,
    defaultWidth: "wide",
    formattingValues: nF,
    defaultFormattingWidth: "wide"
  })
};
function Ci(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? oF(s, function(p) {
      return p.test(o);
    }) : aF(s, function(p) {
      return p.test(o);
    }), d;
    d = e.valueCallback ? e.valueCallback(u) : u, d = n.valueCallback ? n.valueCallback(d) : d;
    var f = t.slice(o.length);
    return {
      value: d,
      rest: f
    };
  };
}
function aF(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function oF(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function tE(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r) return null;
    var i = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = t.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var sF = /^(\d+)(th|st|nd|rd)?/i, lF = /\d+/i, uF = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, cF = {
  any: [/^b/i, /^(a|c)/i]
}, dF = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hF = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, pF = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, mF = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gF = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vF = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, _F = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yF = {
  ordinalNumber: tE({
    matchPattern: sF,
    parsePattern: lF,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ci({
    matchPatterns: uF,
    defaultMatchWidth: "wide",
    parsePatterns: cF,
    defaultParseWidth: "any"
  }),
  quarter: Ci({
    matchPatterns: dF,
    defaultMatchWidth: "wide",
    parsePatterns: fF,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ci({
    matchPatterns: hF,
    defaultMatchWidth: "wide",
    parsePatterns: pF,
    defaultParseWidth: "any"
  }),
  day: Ci({
    matchPatterns: mF,
    defaultMatchWidth: "wide",
    parsePatterns: gF,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ci({
    matchPatterns: vF,
    defaultMatchWidth: "any",
    parsePatterns: _F,
    defaultParseWidth: "any"
  })
}, nE = {
  code: "en-US",
  formatDistance: jR,
  formatLong: qR,
  formatRelative: XR,
  localize: iF,
  match: yF,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, bF = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, wF = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, xF = /^'([^]*?)'?$/, EF = /''/g, TF = /[a-zA-Z]/;
function Li(e, t, n) {
  var r, i, a, o, s, u, d, f, p, m, g, v, b, w, T, S, x, O;
  We(2, arguments);
  var C = String(t), P = qa(), k = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : P.locale) !== null && r !== void 0 ? r : nE, M = Je((a = (o = (s = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (d = n.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && s !== void 0 ? s : P.firstWeekContainsDate) !== null && o !== void 0 ? o : (p = P.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(M >= 1 && M <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var N = Je((g = (v = (b = (w = n == null ? void 0 : n.weekStartsOn) !== null && w !== void 0 ? w : n == null || (T = n.locale) === null || T === void 0 || (S = T.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && b !== void 0 ? b : P.weekStartsOn) !== null && v !== void 0 ? v : (x = P.locale) === null || x === void 0 || (O = x.options) === null || O === void 0 ? void 0 : O.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(N >= 0 && N <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!k.localize)
    throw new RangeError("locale must contain localize property");
  if (!k.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var X = et(e);
  if (!Ml(X))
    throw new RangeError("Invalid time value");
  var Z = nd(X), te = qx(X, Z), ce = {
    firstWeekContainsDate: M,
    weekStartsOn: N,
    locale: k,
    _originalDate: X
  }, we = C.match(wF).map(function(G) {
    var Q = G[0];
    if (Q === "p" || Q === "P") {
      var y = xp[Q];
      return y(G, k.formatLong);
    }
    return G;
  }).join("").match(bF).map(function(G) {
    if (G === "''")
      return "'";
    var Q = G[0];
    if (Q === "'")
      return kF(G);
    var y = VR[Q];
    if (y)
      return !(n != null && n.useAdditionalWeekYearTokens) && eE(G) && rd(G, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Jx(G) && rd(G, t, String(e)), y(te, G, k.localize, ce);
    if (Q.match(TF))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Q + "`");
    return G;
  }).join("");
  return we;
}
function kF(e) {
  var t = e.match(xF);
  return t ? t[1].replace(EF, "'") : e;
}
function SF(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function OF(e) {
  We(1, arguments);
  var t = et(e), n = t.getDay();
  return n;
}
function CF(e) {
  We(1, arguments);
  var t = et(e), n = t.getFullYear(), r = t.getMonth(), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(n, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function oa(e) {
  We(1, arguments);
  var t = et(e), n = t.getHours();
  return n;
}
var AF = 6048e5;
function DF(e) {
  We(1, arguments);
  var t = et(e), n = td(t).getTime() - CR(t).getTime();
  return Math.round(n / AF) + 1;
}
function sa(e) {
  We(1, arguments);
  var t = et(e), n = t.getMinutes();
  return n;
}
function on(e) {
  We(1, arguments);
  var t = et(e), n = t.getMonth();
  return n;
}
function Ss(e) {
  We(1, arguments);
  var t = et(e), n = t.getSeconds();
  return n;
}
function sn(e) {
  return We(1, arguments), et(e).getFullYear();
}
function Pm(e, t) {
  We(2, arguments);
  var n = et(e), r = et(t);
  return n.getTime() > r.getTime();
}
function Mm(e, t) {
  We(2, arguments);
  var n = et(e), r = et(t);
  return n.getTime() < r.getTime();
}
function rE(e, t) {
  We(2, arguments);
  var n = et(e), r = et(t);
  return n.getTime() === r.getTime();
}
function Ny(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function PF(e, t) {
  if (e) {
    if (typeof e == "string") return Ny(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ny(e, t) : void 0;
  }
}
function Ly(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = PF(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(d) {
          throw d;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var d = n.next();
      return o = d.done, d;
    },
    e: function(d) {
      s = !0, a = d;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function Ie(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ep(e, t) {
  return Ep = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Ep(e, t);
}
function At(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ep(e, t);
}
function id(e) {
  return id = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, id(e);
}
function iE() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (iE = function() {
    return !!e;
  })();
}
function MF(e, t) {
  if (t && (ci(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Ie(e);
}
function Dt(e) {
  var t = iE();
  return function() {
    var n, r = id(e);
    if (t) {
      var i = id(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return MF(this, n);
  };
}
function kt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function IF(e, t) {
  if (ci(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ci(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function aE(e) {
  var t = IF(e, "string");
  return ci(t) == "symbol" ? t : t + "";
}
function NF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, aE(r.key), r);
  }
}
function St(e, t, n) {
  return t && NF(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function De(e, t, n) {
  return (t = aE(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var LF = 10, oE = /* @__PURE__ */ function() {
  function e() {
    kt(this, e), De(this, "priority", void 0), De(this, "subPriority", 0);
  }
  return St(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), RF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n(r, i, a, o, s) {
    var u;
    return kt(this, n), u = t.call(this), u.value = r, u.validateValue = i, u.setValue = a, u.priority = o, s && (u.subPriority = s), u;
  }
  return St(n, [{
    key: "validate",
    value: function(i, a) {
      return this.validateValue(i, this.value, a);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return this.setValue(i, a, this.value, o);
    }
  }]), n;
}(oE), FF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", LF), De(Ie(r), "subPriority", -1), r;
  }
  return St(n, [{
    key: "set",
    value: function(i, a) {
      if (a.timestampIsSet)
        return i;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
    }
  }]), n;
}(oE), Rt = /* @__PURE__ */ function() {
  function e() {
    kt(this, e), De(this, "incompatibleTokens", void 0), De(this, "priority", void 0), De(this, "subPriority", void 0);
  }
  return St(e, [{
    key: "run",
    value: function(n, r, i, a) {
      var o = this.parse(n, r, i, a);
      return o ? {
        setter: new RF(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, i) {
      return !0;
    }
  }]), e;
}(), $F = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 140), De(Ie(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return o.era(i, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return o.era(i, {
            width: "wide"
          }) || o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.era = o, i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), Tn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ai = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function kn(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function hn(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Di(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (i * Om + a * Sm + o * MR),
    rest: t.slice(n[0].length)
  };
}
function sE(e) {
  return hn(Tn.anyDigitsSigned, e);
}
function yn(e, t) {
  switch (e) {
    case 1:
      return hn(Tn.singleDigit, t);
    case 2:
      return hn(Tn.twoDigits, t);
    case 3:
      return hn(Tn.threeDigits, t);
    case 4:
      return hn(Tn.fourDigits, t);
    default:
      return hn(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function ad(e, t) {
  switch (e) {
    case 1:
      return hn(Tn.singleDigitSigned, t);
    case 2:
      return hn(Tn.twoDigitsSigned, t);
    case 3:
      return hn(Tn.threeDigitsSigned, t);
    case 4:
      return hn(Tn.fourDigitsSigned, t);
    default:
      return hn(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Im(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function lE(e, t) {
  var n = t > 0, r = n ? t : 1 - t, i;
  if (r <= 50)
    i = e || 100;
  else {
    var a = r + 50, o = Math.floor(a / 100) * 100, s = e >= a % 100;
    i = e + o - (s ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function uE(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var VF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 130), De(Ie(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return kn(yn(4, i), s);
        case "yo":
          return kn(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return kn(yn(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = lE(o.year, s);
        return i.setUTCFullYear(u, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
      }
      var d = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(d, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), BF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 130), De(Ie(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return {
          year: d,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return kn(yn(4, i), s);
        case "Yo":
          return kn(o.ordinalNumber(i, {
            unit: "year"
          }), s);
        default:
          return kn(yn(a.length, i), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      var u = Dm(i, s);
      if (o.isTwoDigitYear) {
        var d = lE(o.year, u);
        return i.setUTCFullYear(d, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), Mo(i, s);
      }
      var f = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(f, 0, s.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), Mo(i, s);
    }
  }]), n;
}(Rt), UF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 130), De(Ie(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a) {
      return ad(a === "R" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), ks(s);
    }
  }]), n;
}(Rt), WF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 130), De(Ie(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a) {
      return ad(a === "u" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), HF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 120), De(Ie(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return yn(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return o.quarter(i, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), jF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 120), De(Ie(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return yn(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return o.quarter(i, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), YF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), De(Ie(r), "priority", 110), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "M":
          return kn(hn(Tn.month, i), s);
        // 01, 02, ..., 12
        case "MM":
          return kn(yn(2, i), s);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return kn(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "MMM":
          return o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return o.month(i, {
            width: "wide",
            context: "formatting"
          }) || o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), zF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 110), De(Ie(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "L":
          return kn(hn(Tn.month, i), s);
        // 01, 02, ..., 12
        case "LL":
          return kn(yn(2, i), s);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return kn(o.ordinalNumber(i, {
            unit: "month"
          }), s);
        // Jan, Feb, ..., Dec
        case "LLL":
          return o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return o.month(i, {
            width: "wide",
            context: "standalone"
          }) || o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt);
function GF(e, t, n) {
  We(2, arguments);
  var r = et(e), i = Je(t), a = Zx(r, n) - i;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var qF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 100), De(Ie(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "w":
          return hn(Tn.week, i);
        case "wo":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return Mo(GF(i, o, s), s);
    }
  }]), n;
}(Rt);
function KF(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t), i = Xx(n) - r;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var XF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 100), De(Ie(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "I":
          return hn(Tn.week, i);
        case "Io":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return ks(KF(i, o));
    }
  }]), n;
}(Rt), ZF = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], QF = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], JF = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 90), De(Ie(r), "subPriority", 1), De(Ie(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "d":
          return hn(Tn.date, i);
        case "do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = uE(o), u = i.getUTCMonth();
      return s ? a >= 1 && a <= QF[u] : a >= 1 && a <= ZF[u];
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCDate(o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), e$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 90), De(Ie(r), "subpriority", 1), De(Ie(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return hn(Tn.dayOfYear, i);
        case "Do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), s = uE(o);
      return s ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(0, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt);
function Nm(e, t, n) {
  var r, i, a, o, s, u, d, f;
  We(2, arguments);
  var p = qa(), m = Je((r = (i = (a = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : p.weekStartsOn) !== null && i !== void 0 ? i : (d = p.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = et(e), v = Je(t), b = g.getUTCDay(), w = v % 7, T = (w + 7) % 7, S = (T < m ? 7 : 0) + v - b;
  return g.setUTCDate(g.getUTCDate() + S), g;
}
var t$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 90), De(Ie(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = Nm(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), n$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 90), De(Ie(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o, s) {
      var u = function(f) {
        var p = Math.floor((f - 1) / 7) * 7;
        return (f + s.weekStartsOn + 6) % 7 + p;
      };
      switch (a) {
        // 3
        case "e":
        case "ee":
          return kn(yn(a.length, i), u);
        // 3rd
        case "eo":
          return kn(o.ordinalNumber(i, {
            unit: "day"
          }), u);
        // Tue
        case "eee":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = Nm(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), r$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 90), De(Ie(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o, s) {
      var u = function(f) {
        var p = Math.floor((f - 1) / 7) * 7;
        return (f + s.weekStartsOn + 6) % 7 + p;
      };
      switch (a) {
        // 3
        case "c":
        case "cc":
          return kn(yn(a.length, i), u);
        // 3rd
        case "co":
          return kn(o.ordinalNumber(i, {
            unit: "day"
          }), u);
        // Tue
        case "ccc":
          return o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return o.day(i, {
            width: "wide",
            context: "standalone"
          }) || o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, s) {
      return i = Nm(i, o, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt);
function i$(e, t) {
  We(2, arguments);
  var n = Je(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, i = et(e), a = i.getUTCDay(), o = n % 7, s = (o + 7) % 7, u = (s < r ? 7 : 0) + n - a;
  return i.setUTCDate(i.getUTCDate() + u), i;
}
var a$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 90), De(Ie(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      var s = function(d) {
        return d === 0 ? 7 : d;
      };
      switch (a) {
        // 2
        case "i":
        case "ii":
          return yn(a.length, i);
        // 2nd
        case "io":
          return o.ordinalNumber(i, {
            unit: "day"
          });
        // Tue
        case "iii":
          return kn(o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // T
        case "iiiii":
          return kn(o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tu
        case "iiiiii":
          return kn(o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
        // Tuesday
        case "iiii":
        default:
          return kn(o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i = i$(i, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Rt), o$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 80), De(Ie(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(Im(o), 0, 0, 0), i;
    }
  }]), n;
}(Rt), s$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 80), De(Ie(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(Im(o), 0, 0, 0), i;
    }
  }]), n;
}(Rt), l$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 80), De(Ie(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(Im(o), 0, 0, 0), i;
    }
  }]), n;
}(Rt), u$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 70), De(Ie(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "h":
          return hn(Tn.hour12h, i);
        case "ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
}(Rt), c$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 70), De(Ie(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "H":
          return hn(Tn.hour23h, i);
        case "Ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
}(Rt), d$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 70), De(Ie(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "K":
          return hn(Tn.hour11h, i);
        case "Ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = i.getUTCHours() >= 12;
      return s && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
}(Rt), f$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 70), De(Ie(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "k":
          return hn(Tn.hour24h, i);
        case "ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var s = o <= 24 ? o % 24 : o;
      return i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), n;
}(Rt), h$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 60), De(Ie(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "m":
          return hn(Tn.minute, i);
        case "mo":
          return o.ordinalNumber(i, {
            unit: "minute"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMinutes(o, 0, 0), i;
    }
  }]), n;
}(Rt), p$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 50), De(Ie(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "s":
          return hn(Tn.second, i);
        case "so":
          return o.ordinalNumber(i, {
            unit: "second"
          });
        default:
          return yn(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCSeconds(o, 0), i;
    }
  }]), n;
}(Rt), m$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 30), De(Ie(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a) {
      var o = function(u) {
        return Math.floor(u * Math.pow(10, -a.length + 3));
      };
      return kn(yn(a.length, i), o);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMilliseconds(o), i;
    }
  }]), n;
}(Rt), g$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 10), De(Ie(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "X":
          return Di(Ai.basicOptionalMinutes, i);
        case "XX":
          return Di(Ai.basic, i);
        case "XXXX":
          return Di(Ai.basicOptionalSeconds, i);
        case "XXXXX":
          return Di(Ai.extendedOptionalSeconds, i);
        case "XXX":
        default:
          return Di(Ai.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), n;
}(Rt), v$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 10), De(Ie(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "x":
          return Di(Ai.basicOptionalMinutes, i);
        case "xx":
          return Di(Ai.basic, i);
        case "xxxx":
          return Di(Ai.basicOptionalSeconds, i);
        case "xxxxx":
          return Di(Ai.extendedOptionalSeconds, i);
        case "xxx":
        default:
          return Di(Ai.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), n;
}(Rt), _$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 40), De(Ie(r), "incompatibleTokens", "*"), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i) {
      return sE(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Rt), y$ = /* @__PURE__ */ function(e) {
  At(n, e);
  var t = Dt(n);
  function n() {
    var r;
    kt(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(a)), De(Ie(r), "priority", 20), De(Ie(r), "incompatibleTokens", "*"), r;
  }
  return St(n, [{
    key: "parse",
    value: function(i) {
      return sE(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Rt), b$ = {
  G: new $F(),
  y: new VF(),
  Y: new BF(),
  R: new UF(),
  u: new WF(),
  Q: new HF(),
  q: new jF(),
  M: new YF(),
  L: new zF(),
  w: new qF(),
  I: new XF(),
  d: new JF(),
  D: new e$(),
  E: new t$(),
  e: new n$(),
  c: new r$(),
  i: new a$(),
  a: new o$(),
  b: new s$(),
  B: new l$(),
  h: new u$(),
  H: new c$(),
  K: new d$(),
  k: new f$(),
  m: new h$(),
  s: new p$(),
  S: new m$(),
  X: new g$(),
  x: new v$(),
  t: new _$(),
  T: new y$()
}, w$ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, x$ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, E$ = /^'([^]*?)'?$/, T$ = /''/g, k$ = /\S/, S$ = /[a-zA-Z]/;
function Tp(e, t, n, r) {
  var i, a, o, s, u, d, f, p, m, g, v, b, w, T;
  We(3, arguments);
  var S = String(e), x = String(t), O = qa(), C = (i = (a = void 0) !== null && a !== void 0 ? a : O.locale) !== null && i !== void 0 ? i : nE;
  if (!C.match)
    throw new RangeError("locale must contain match property");
  var P = Je((o = (s = (u = (d = void 0) !== null && d !== void 0 ? d : void 0) !== null && u !== void 0 ? u : O.firstWeekContainsDate) !== null && s !== void 0 ? s : (f = O.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(P >= 1 && P <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = Je((m = (g = (v = (b = void 0) !== null && b !== void 0 ? b : void 0) !== null && v !== void 0 ? v : O.weekStartsOn) !== null && g !== void 0 ? g : (w = O.locale) === null || w === void 0 || (T = w.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(k >= 0 && k <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (x === "")
    return S === "" ? et(n) : /* @__PURE__ */ new Date(NaN);
  var M = {
    firstWeekContainsDate: P,
    weekStartsOn: k,
    locale: C
  }, N = [new FF()], X = x.match(x$).map(function(U) {
    var $ = U[0];
    if ($ in xp) {
      var Y = xp[$];
      return Y(U, C.formatLong);
    }
    return U;
  }).join("").match(w$), Z = [], te = Ly(X), ce;
  try {
    var we = function() {
      var $ = ce.value;
      !(r != null && r.useAdditionalWeekYearTokens) && eE($) && rd($, x, e), !(r != null && r.useAdditionalDayOfYearTokens) && Jx($) && rd($, x, e);
      var Y = $[0], Re = b$[Y];
      if (Re) {
        var it = Re.incompatibleTokens;
        if (Array.isArray(it)) {
          var He = Z.find(function(Bt) {
            return it.includes(Bt.token) || Bt.token === Y;
          });
          if (He)
            throw new RangeError("The format string mustn't contain `".concat(He.fullToken, "` and `").concat($, "` at the same time"));
        } else if (Re.incompatibleTokens === "*" && Z.length > 0)
          throw new RangeError("The format string mustn't contain `".concat($, "` and any other token at the same time"));
        Z.push({
          token: Y,
          fullToken: $
        });
        var Vt = Re.run(S, $, C.match, M);
        if (!Vt)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        N.push(Vt.setter), S = Vt.rest;
      } else {
        if (Y.match(S$))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
        if ($ === "''" ? $ = "'" : Y === "'" && ($ = O$($)), S.indexOf($) === 0)
          S = S.slice($.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (te.s(); !(ce = te.n()).done; ) {
      var G = we();
      if (ci(G) === "object") return G.v;
    }
  } catch (U) {
    te.e(U);
  } finally {
    te.f();
  }
  if (S.length > 0 && k$.test(S))
    return /* @__PURE__ */ new Date(NaN);
  var Q = N.map(function(U) {
    return U.priority;
  }).sort(function(U, $) {
    return $ - U;
  }).filter(function(U, $, Y) {
    return Y.indexOf(U) === $;
  }).map(function(U) {
    return N.filter(function($) {
      return $.priority === U;
    }).sort(function($, Y) {
      return Y.subPriority - $.subPriority;
    });
  }).map(function(U) {
    return U[0];
  }), y = et(n);
  if (isNaN(y.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var H = qx(y, nd(y)), ie = {}, ne = Ly(Q), J;
  try {
    for (ne.s(); !(J = ne.n()).done; ) {
      var me = J.value;
      if (!me.validate(H, M))
        return /* @__PURE__ */ new Date(NaN);
      var xe = me.set(H, ie, M);
      Array.isArray(xe) ? (H = xe[0], SF(ie, xe[1])) : H = xe;
    }
  } catch (U) {
    ne.e(U);
  } finally {
    ne.f();
  }
  return H;
}
function O$(e) {
  return e.match(E$)[1].replace(T$, "'");
}
function Lm(e, t) {
  We(2, arguments);
  var n = Je(t);
  return pa(e, -n);
}
function kp(e, t) {
  var n;
  We(1, arguments);
  var r = Je((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = P$(e), a;
  if (i.date) {
    var o = M$(i.date, r);
    a = I$(o.restDateString, o.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = a.getTime(), u = 0, d;
  if (i.time && (u = N$(i.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (i.timezone) {
    if (d = L$(i.timezone), isNaN(d))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var f = new Date(s + u), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate()), p.setHours(f.getUTCHours(), f.getUTCMinutes(), f.getUTCSeconds(), f.getUTCMilliseconds()), p;
  }
  return new Date(s + u + d);
}
var bc = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, C$ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, A$ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, D$ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function P$(e) {
  var t = {}, n = e.split(bc.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], bc.timeZoneDelimiter.test(t.date) && (t.date = e.split(bc.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var i = bc.timezone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timezone = i[1]) : t.time = r;
  }
  return t;
}
function M$(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r) return {
    year: NaN,
    restDateString: ""
  };
  var i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function I$(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  var n = e.match(C$);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], i = sl(n[1]), a = sl(n[2]) - 1, o = sl(n[3]), s = sl(n[4]), u = sl(n[5]) - 1;
  if (r)
    return B$(t, s, u) ? R$(t, s, u) : /* @__PURE__ */ new Date(NaN);
  var d = /* @__PURE__ */ new Date(0);
  return !$$(t, a, o) || !V$(t, i) ? /* @__PURE__ */ new Date(NaN) : (d.setUTCFullYear(t, a, Math.max(i, o)), d);
}
function sl(e) {
  return e ? parseInt(e) : 1;
}
function N$(e) {
  var t = e.match(A$);
  if (!t) return NaN;
  var n = Sh(t[1]), r = Sh(t[2]), i = Sh(t[3]);
  return U$(n, r, i) ? n * Om + r * Sm + i * 1e3 : NaN;
}
function Sh(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function L$(e) {
  if (e === "Z") return 0;
  var t = e.match(D$);
  if (!t) return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return W$(r, i) ? n * (r * Om + i * Sm) : NaN;
}
function R$(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var i = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
var F$ = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function cE(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function $$(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (F$[t] || (cE(e) ? 29 : 28));
}
function V$(e, t) {
  return t >= 1 && t <= (cE(e) ? 366 : 365);
}
function B$(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function U$(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function W$(e, t) {
  return t >= 0 && t <= 59;
}
function Il(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t), i = n.getFullYear(), a = n.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(i, r, 15), o.setHours(0, 0, 0, 0);
  var s = CF(o);
  return n.setMonth(r, Math.min(a, s)), n;
}
function mr(e, t) {
  if (We(2, arguments), ci(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var n = et(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = Il(n, t.month)), t.date != null && n.setDate(Je(t.date)), t.hours != null && n.setHours(Je(t.hours)), t.minutes != null && n.setMinutes(Je(t.minutes)), t.seconds != null && n.setSeconds(Je(t.seconds)), t.milliseconds != null && n.setMilliseconds(Je(t.milliseconds)), n);
}
function dE(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  return n.setHours(r), n;
}
function Rm(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  return n.setMilliseconds(r), n;
}
function fE(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  return n.setMinutes(r), n;
}
function hE(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  return n.setSeconds(r), n;
}
function Oo(e, t) {
  We(2, arguments);
  var n = et(e), r = Je(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function li(e, t) {
  We(2, arguments);
  var n = Je(t);
  return Pi(e, -n);
}
function H$(e, t) {
  if (We(2, arguments), !t || ci(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = t.years ? Je(t.years) : 0, r = t.months ? Je(t.months) : 0, i = t.weeks ? Je(t.weeks) : 0, a = t.days ? Je(t.days) : 0, o = t.hours ? Je(t.hours) : 0, s = t.minutes ? Je(t.minutes) : 0, u = t.seconds ? Je(t.seconds) : 0, d = li(e, r + n * 12), f = Lm(d, a + i * 7), p = s + o * 60, m = u + p * 60, g = m * 1e3, v = new Date(f.getTime() - g);
  return v;
}
function Os(e, t) {
  We(2, arguments);
  var n = Je(t);
  return PR(e, -n);
}
function j$(e, t) {
  We(2, arguments);
  var n = Je(t);
  return Yx(e, -n);
}
const Ho = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, Y$ = {}, z$ = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, G$ = /* @__PURE__ */ K("path", { d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z" }, null, -1), q$ = /* @__PURE__ */ K("path", { d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }, null, -1), K$ = /* @__PURE__ */ K("path", { d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }, null, -1), X$ = /* @__PURE__ */ K("path", { d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z" }, null, -1), Z$ = [
  G$,
  q$,
  K$,
  X$
];
function Q$(e, t) {
  return I(), W("svg", z$, Z$);
}
const Pd = /* @__PURE__ */ Ho(Y$, [["render", Q$]]), J$ = {}, e3 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, t3 = /* @__PURE__ */ K("path", { d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z" }, null, -1), n3 = /* @__PURE__ */ K("path", { d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z" }, null, -1), r3 = [
  t3,
  n3
];
function i3(e, t) {
  return I(), W("svg", e3, r3);
}
const a3 = /* @__PURE__ */ Ho(J$, [["render", i3]]), o3 = {}, s3 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, l3 = /* @__PURE__ */ K("path", { d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z" }, null, -1), u3 = [
  l3
];
function c3(e, t) {
  return I(), W("svg", s3, u3);
}
const Ry = /* @__PURE__ */ Ho(o3, [["render", c3]]), d3 = {}, f3 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, h3 = /* @__PURE__ */ K("path", { d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z" }, null, -1), p3 = [
  h3
];
function m3(e, t) {
  return I(), W("svg", f3, p3);
}
const Fy = /* @__PURE__ */ Ho(d3, [["render", m3]]), g3 = {}, v3 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, _3 = /* @__PURE__ */ K("path", { d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z" }, null, -1), y3 = /* @__PURE__ */ K("path", { d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }, null, -1), b3 = [
  _3,
  y3
];
function w3(e, t) {
  return I(), W("svg", v3, b3);
}
const pE = /* @__PURE__ */ Ho(g3, [["render", w3]]), x3 = {}, E3 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, T3 = /* @__PURE__ */ K("path", { d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z" }, null, -1), k3 = [
  T3
];
function S3(e, t) {
  return I(), W("svg", E3, k3);
}
const mE = /* @__PURE__ */ Ho(x3, [["render", S3]]), O3 = {}, C3 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, A3 = /* @__PURE__ */ K("path", { d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z" }, null, -1), D3 = [
  A3
];
function P3(e, t) {
  return I(), W("svg", C3, D3);
}
const gE = /* @__PURE__ */ Ho(O3, [["render", P3]]), $y = (e, t) => {
  const n = Tp(e, t.slice(0, e.length), /* @__PURE__ */ new Date());
  return Ml(n) && zx(n) ? n : null;
}, M3 = (e, t) => {
  if (typeof t == "string")
    return $y(e, t);
  if (Array.isArray(t)) {
    let n = null;
    for (const r of t)
      if (n = $y(e, r), n)
        break;
    return n;
  }
  return typeof t == "function" ? t(e) : null;
}, be = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), I3 = (e, t) => {
  if (t) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), i = e.getDate().toString().padStart(2, "0"), a = e.getHours().toString().padStart(2, "0"), o = e.getMinutes().toString().padStart(2, "0");
    return `${e.getFullYear()}-${r}-${i}T${a}:${o}:00.000Z`;
  }
  const n = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(n).toISOString();
}, Fi = (e) => {
  let t = be(JSON.parse(JSON.stringify(e)));
  return t = dE(t, 0), t = fE(t, 0), t = hE(t, 0), t = Rm(t, 0), t;
}, ii = (e, t, n, r) => {
  let i = e ? be(e) : be();
  return (t || t === 0) && (i = dE(i, +t)), (n || n === 0) && (i = fE(i, +n)), (r || r === 0) && (i = hE(i, +r)), Rm(i, 0);
}, rr = (e, t) => !e || !t ? !1 : Mm(Fi(e), Fi(t)), un = (e, t) => !e || !t ? !1 : rE(Fi(e), Fi(t)), vr = (e, t) => !e || !t ? !1 : Pm(Fi(e), Fi(t)), vE = (e, t, n) => e && e[0] && e[1] ? vr(n, e[0]) && rr(n, e[1]) : e && e[0] && t ? vr(n, e[0]) && rr(n, t) || rr(n, e[0]) && vr(n, t) : !1, ll = Uo({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), _E = () => {
  const e = (n) => {
    ll.menuFocused = n;
  }, t = (n) => {
    ll.shiftKeyInMenu !== n && (ll.shiftKeyInMenu = n);
  };
  return {
    control: oe(() => ({ shiftKeyInMenu: ll.shiftKeyInMenu, menuFocused: ll.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
};
function Fm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var od = {}, N3 = {
  get exports() {
    return od;
  },
  set exports(e) {
    od = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var i = Number(r);
    return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
  }
  e.exports = t.default;
})(N3, od);
const L3 = /* @__PURE__ */ Fm(od);
var sd = {}, R3 = {
  get exports() {
    return sd;
  },
  set exports(e) {
    sd = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    var i = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return i.setUTCFullYear(r.getFullYear()), r.getTime() - i.getTime();
  }
  e.exports = t.default;
})(R3, sd);
const Vy = /* @__PURE__ */ Fm(sd);
function F3(e, t) {
  var n = U3(t);
  return n.formatToParts ? V3(n, e) : B3(n, e);
}
var $3 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function V3(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], i = 0; i < n.length; i++) {
      var a = $3[n[i].type];
      a >= 0 && (r[a] = parseInt(n[i].value, 10));
    }
    return r;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function B3(e, t) {
  var n = e.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Oh = {};
function U3(e) {
  if (!Oh[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Oh[e] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Oh[e];
}
function $m(e, t, n, r, i, a, o) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, n), s.setUTCHours(r, i, a, o), s;
}
var By = 36e5, W3 = 6e4, Ch = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Vm(e, t, n) {
  var r, i;
  if (!e || (r = Ch.timezoneZ.exec(e), r))
    return 0;
  var a;
  if (r = Ch.timezoneHH.exec(e), r)
    return a = parseInt(r[1], 10), Uy(a) ? -(a * By) : NaN;
  if (r = Ch.timezoneHHMM.exec(e), r) {
    a = parseInt(r[1], 10);
    var o = parseInt(r[2], 10);
    return Uy(a, o) ? (i = Math.abs(a) * By + o * W3, a > 0 ? -i : i) : NaN;
  }
  if (Y3(e)) {
    t = new Date(t || Date.now());
    var s = n ? t : H3(t), u = Sp(s, e), d = n ? u : j3(t, u, e);
    return -d;
  }
  return NaN;
}
function H3(e) {
  return $m(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function Sp(e, t) {
  var n = F3(e, t), r = $m(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), i = e.getTime(), a = i % 1e3;
  return i -= a >= 0 ? a : 1e3 + a, r - i;
}
function j3(e, t, n) {
  var r = e.getTime(), i = r - t, a = Sp(new Date(i), n);
  if (t === a)
    return t;
  i -= a - t;
  var o = Sp(new Date(i), n);
  return a === o ? a : Math.max(a, o);
}
function Uy(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Wy = {};
function Y3(e) {
  if (Wy[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Wy[e] = !0, !0;
  } catch {
    return !1;
  }
}
var z3 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const yE = z3;
var Ah = 36e5, Hy = 6e4, G3 = 2, gr = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: yE
};
function Op(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t || {}, r = n.additionalDigits == null ? G3 : L3(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = q3(e), a = K3(i.date, r), o = a.year, s = a.restDateString, u = X3(s, o);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var d = u.getTime(), f = 0, p;
    if (i.time && (f = Z3(i.time), isNaN(f)))
      return /* @__PURE__ */ new Date(NaN);
    if (i.timeZone || n.timeZone) {
      if (p = Vm(i.timeZone || n.timeZone, new Date(d + f)), isNaN(p))
        return /* @__PURE__ */ new Date(NaN);
    } else
      p = Vy(new Date(d + f)), p = Vy(new Date(d + f + p));
    return new Date(d + f + p);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function q3(e) {
  var t = {}, n = gr.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = gr.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    var i = gr.timeZone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
  }
  return t;
}
function K3(e, t) {
  var n = gr.YYY[t], r = gr.YYYYY[t], i;
  if (i = gr.YYYY.exec(e) || r.exec(e), i) {
    var a = i[1];
    return {
      year: parseInt(a, 10),
      restDateString: e.slice(a.length)
    };
  }
  if (i = gr.YY.exec(e) || n.exec(e), i) {
    var o = i[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function X3(e, t) {
  if (t === null)
    return null;
  var n, r, i, a;
  if (e.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  if (n = gr.MM.exec(e), n)
    return r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1, Yy(t, i) ? (r.setUTCFullYear(t, i), r) : /* @__PURE__ */ new Date(NaN);
  if (n = gr.DDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0);
    var o = parseInt(n[1], 10);
    return eV(t, o) ? (r.setUTCFullYear(t, 0, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = gr.MMDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1;
    var s = parseInt(n[2], 10);
    return Yy(t, i, s) ? (r.setUTCFullYear(t, i, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = gr.Www.exec(e), n)
    return a = parseInt(n[1], 10) - 1, zy(t, a) ? jy(t, a) : /* @__PURE__ */ new Date(NaN);
  if (n = gr.WwwD.exec(e), n) {
    a = parseInt(n[1], 10) - 1;
    var u = parseInt(n[2], 10) - 1;
    return zy(t, a, u) ? jy(t, a, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Z3(e) {
  var t, n, r;
  if (t = gr.HH.exec(e), t)
    return n = parseFloat(t[1].replace(",", ".")), Dh(n) ? n % 24 * Ah : NaN;
  if (t = gr.HHMM.exec(e), t)
    return n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), Dh(n, r) ? n % 24 * Ah + r * Hy : NaN;
  if (t = gr.HHMMSS.exec(e), t) {
    n = parseInt(t[1], 10), r = parseInt(t[2], 10);
    var i = parseFloat(t[3].replace(",", "."));
    return Dh(n, r, i) ? n % 24 * Ah + r * Hy + i * 1e3 : NaN;
  }
  return null;
}
function jy(e, t, n) {
  t = t || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var i = r.getUTCDay() || 7, a = t * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
var Q3 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], J3 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function bE(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Yy(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = bE(e);
    if (r && n > J3[t] || !r && n > Q3[t])
      return !1;
  }
  return !0;
}
function eV(e, t) {
  if (t < 1)
    return !1;
  var n = bE(e);
  return !(n && t > 366 || !n && t > 365);
}
function zy(e, t, n) {
  return !(t < 0 || t > 52 || n != null && (n < 0 || n > 6));
}
function Dh(e, t, n) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
var ld = {}, tV = {
  get exports() {
    return ld;
  },
  set exports(e) {
    ld = e;
  }
}, ud = {}, nV = {
  get exports() {
    return ud;
  },
  set exports(e) {
    ud = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r, i) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var a in i)
      Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    return r;
  }
  e.exports = t.default;
})(nV, ud);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(ud);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    return (0, n.default)({}, a);
  }
  e.exports = t.default;
})(tV, ld);
const rV = /* @__PURE__ */ Fm(ld);
function iV(e, t, n) {
  var r = Op(e, n), i = Vm(t, r, !0), a = new Date(r.getTime() - i), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
}
function aV(e, t, n) {
  if (typeof e == "string" && !e.match(yE)) {
    var r = rV(n);
    return r.timeZone = t, Op(e, r);
  }
  var i = Op(e, n), a = $m(
    i.getFullYear(),
    i.getMonth(),
    i.getDate(),
    i.getHours(),
    i.getMinutes(),
    i.getSeconds(),
    i.getMilliseconds()
  ).getTime(), o = Vm(t, new Date(a));
  return new Date(a + o);
}
const oV = (e, t = 3) => {
  const n = [];
  for (let r = 0; r < e.length; r += t)
    n.push([e[r], e[r + 1], e[r + 2]]);
  return n;
}, sV = (e, t) => {
  const n = [1, 2, 3, 4, 5, 6, 7].map((a) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`)).slice(0, 2)), r = n.slice(0, t), i = n.slice(t + 1, n.length);
  return [n[t]].concat(...i).concat(...r);
}, lV = (e) => {
  const t = [];
  for (let n = +e[0]; n <= +e[1]; n++)
    t.push({ value: +n, text: `${n}` });
  return t;
}, uV = (e, t) => {
  const n = new Intl.DateTimeFormat(e, { month: t, timeZone: "UTC" });
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const i = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
  }).map((r, i) => ({
    text: n.format(r),
    value: i
  }));
}, cV = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Nn = (e) => {
  const t = j(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, dV = (e) => Object.assign({ type: "dot" }, e), wE = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, cd = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Jn = (e) => e, Gy = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, qy = (e) => Object.assign(
  {
    menuAppear: "dp-menu-appear",
    open: "dp-slide-down",
    close: "dp-slide-up",
    next: "calendar-next",
    previous: "calendar-prev",
    vNext: "dp-slide-up",
    vPrevious: "dp-slide-down"
  },
  e
), fV = (e) => Object.assign(
  {
    toggleOverlay: "Toggle overlay",
    menu: "Datepicker menu",
    input: "Datepicker input",
    calendarWrap: "Calendar wrapper",
    calendarDays: "Calendar days",
    openTimePicker: "Open time picker",
    closeTimePicker: "Close time Picker",
    incrementValue: (t) => `Increment ${t}`,
    decrementValue: (t) => `Decrement ${t}`,
    openTpOverlay: (t) => `Open ${t} overlay`,
    amPmButton: "Switch AM/PM mode",
    openYearsOverlay: "Open years overlay",
    openMonthsOverlay: "Open months overlay",
    nextMonth: "Next month",
    prevMonth: "Previous month",
    day: () => ""
  },
  e
), hV = (e) => e === null ? 0 : typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2, pV = (e, t, n) => e || (typeof n == "string" ? n : t), mV = (e) => typeof e == "boolean" ? e ? qy({}) : !1 : qy(e), gV = () => ({
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: !0,
  rangeSeparator: " - "
}), vV = (e) => Object.assign({ months: [], years: [], times: { hours: [], minutes: [], seconds: [] } }, e), Gr = (e) => {
  const t = () => {
    if (e.partialRange)
      return null;
    throw new Error(cd.prop("partial-range"));
  }, n = oe(() => ({
    ariaLabels: fV(e.ariaLabels),
    textInputOptions: Object.assign(gV(), e.textInputOptions),
    multiCalendars: hV(e.multiCalendars),
    previewFormat: pV(e.previewFormat, e.format, a()),
    filters: vV(e.filters),
    transitions: mV(e.transitions),
    startTime: m()
  })), r = (y) => {
    if (e.range)
      return y();
    throw new Error(cd.prop("range"));
  }, i = () => {
    const y = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${y}` : `hh:mm${y} aa`;
  }, a = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? i() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${i()}` : "MM/dd/yyyy", o = (y, H) => {
    if (typeof e.format == "function")
      return e.format(y);
    const ie = H || a(), ne = e.formatLocale ? { locale: e.formatLocale } : void 0;
    return Array.isArray(y) ? `${Li(y[0], ie, ne)} ${e.modelAuto && !y[1] ? "" : n.value.textInputOptions.rangeSeparator || "-"} ${y[1] ? Li(y[1], ie, ne) : ""}` : Li(y, ie, ne);
  }, s = (y) => e.timezone ? iV(y, e.timezone) : y, u = (y) => e.timezone ? aV(y, e.timezone) : y, d = oe(() => (y) => {
    var H;
    return (H = e.hideNavigation) == null ? void 0 : H.includes(y);
  }), f = (y) => {
    const H = e.maxDate ? vr(s(y), s(be(e.maxDate))) : !1, ie = e.minDate ? rr(s(y), s(be(e.minDate))) : !1, ne = T(y, e.disabledDates), J = n.value.filters.months.map((Y) => +Y).includes(on(y)), me = e.disabledWeekDays.length ? e.disabledWeekDays.some((Y) => +Y === OF(y)) : !1, xe = e.allowedDates.length ? !e.allowedDates.some((Y) => un(s(be(Y)), s(y))) : !1, U = sn(y), $ = U < +e.yearRange[0] || U > +e.yearRange[1];
    return !(H || ie || ne || J || $ || me || xe);
  }, p = (y) => {
    const H = {
      hours: oa(be()),
      minutes: sa(be()),
      seconds: Ss(be())
    };
    return Object.assign(H, y);
  }, m = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [p(e.startTime[0]), p(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? p(e.startTime) : null, g = (y) => !f(y), v = (y) => Array.isArray(y) ? Ml(y[0]) && (y[1] ? Ml(y[1]) : !0) : y ? Ml(y) : !1, b = (y) => y instanceof Date ? y : kp(y), w = (y) => {
    const H = Po(s(y), { weekStartsOn: +e.weekStart }), ie = Am(s(y), { weekStartsOn: +e.weekStart });
    return [H, ie];
  }, T = (y, H) => Array.isArray(H) ? H.some((ie) => un(s(be(ie)), s(y))) : H(y), S = (y, H, ie) => {
    let ne = y ? be(y) : be();
    return (H || H === 0) && (ne = Il(ne, H)), ie && (ne = Oo(ne, ie)), ne;
  }, x = (y) => mr(be(), { hours: oa(y), minutes: sa(y), seconds: Ss(y) }), O = (y) => mr(be(), {
    hours: +y.hours || 0,
    minutes: +y.minutes || 0,
    seconds: +y.seconds || 0
  }), C = (y, H, ie, ne) => {
    if (!y)
      return !0;
    if (ne) {
      const J = ie === "max" ? Mm(y, H) : Pm(y, H), me = { seconds: 0, milliseconds: 0 };
      return J || rE(mr(y, me), mr(H, me));
    }
    return ie === "max" ? y.getTime() <= H.getTime() : y.getTime() >= H.getTime();
  }, P = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, k = (y) => Array.isArray(y) ? [y[0] ? x(y[0]) : null, y[1] ? x(y[1]) : null] : x(y), M = (y) => {
    const H = e.maxTime ? O(e.maxTime) : be(e.maxDate);
    return Array.isArray(y) ? C(y[0], H, "max", !!e.maxDate) && C(y[1], H, "max", !!e.maxDate) : C(y, H, "max", !!e.maxDate);
  }, N = (y, H) => {
    const ie = e.minTime ? O(e.minTime) : be(e.minDate);
    return Array.isArray(y) ? C(y[0], ie, "min", !!e.minDate) && C(y[1], ie, "min", !!e.minDate) && H : C(y, ie, "min", !!e.minDate) && H;
  }, X = (y) => {
    let H = !0;
    if (!y || P())
      return !0;
    const ie = !e.minDate && !e.maxDate ? k(y) : y;
    return (e.maxTime || e.maxDate) && (H = M(Jn(ie))), (e.minTime || e.minDate) && (H = N(Jn(ie), H)), H;
  }, Z = (y, H) => {
    const ie = be(JSON.parse(JSON.stringify(y))), ne = [];
    for (let J = 0; J < 7; J++) {
      const me = pa(ie, J), xe = on(me) !== H;
      ne.push({
        text: e.hideOffsetDates && xe ? "" : me.getDate(),
        value: me,
        current: !xe,
        classData: {}
      });
    }
    return ne;
  }, te = (y, H) => {
    const ie = [], ne = be(s(new Date(H, y))), J = be(s(new Date(H, y + 1, 0))), me = Po(ne, { weekStartsOn: e.weekStart }), xe = (U) => {
      const $ = Z(U, y);
      if (ie.push({ days: $ }), !ie[ie.length - 1].days.some(
        (Y) => un(Fi(Y.value), Fi(J))
      )) {
        const Y = pa(U, 7);
        xe(Y);
      }
    };
    if (xe(me), e.sixWeeks && ie.length < 6) {
      const U = 6 - ie.length;
      for (let $ = 1; $ <= U; $++) {
        const Y = ie[ie.length - 1], Re = Y.days[Y.days.length - 1], it = Z(pa(Re.value, 1), on(ne));
        ie.push({ days: it });
      }
    }
    return ie;
  }, ce = (y, H, ie) => [mr(be(y), { date: 1 }), mr(be(), { month: H, year: ie, date: 1 })], we = (y, H) => rr(...ce(e.minDate, y, H)) || un(...ce(e.minDate, y, H)), G = (y, H) => vr(...ce(e.maxDate, y, H)) || un(...ce(e.maxDate, y, H)), Q = (y, H, ie) => {
    let ne = !1;
    return e.maxDate && ie && G(y, H) && (ne = !0), e.minDate && !ie && we(y, H) && (ne = !0), ne;
  };
  return {
    checkPartialRangeValue: t,
    checkRangeEnabled: r,
    getZonedDate: s,
    getZonedToUtc: u,
    formatDate: o,
    getDefaultPattern: a,
    validateDate: f,
    getDefaultStartTime: m,
    isDisabled: g,
    isValidDate: v,
    sanitizeDate: b,
    getWeekFromDate: w,
    matchDate: T,
    setDateMonthOrYear: S,
    isValidTime: X,
    getCalendarDays: te,
    validateMonthYearInRange: (y, H, ie, ne) => {
      let J = !1;
      return ne ? e.minDate && e.maxDate ? J = Q(y, H, ie) : (e.minDate && we(y, H) || e.maxDate && G(y, H)) && (J = !0) : J = !0, J;
    },
    validateMaxDate: G,
    validateMinDate: we,
    defaults: n,
    hideNavigationButtons: d
  };
}, nn = Uo({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Ph = fe(null), wc = fe(!1), Mh = fe(!1), Ih = fe(!1), Nh = fe(!1), fr = fe(0), Yn = fe(0), Ka = () => {
  const e = oe(() => wc.value ? [...nn.selectionGrid, nn.actionRow].filter((p) => p.length) : Mh.value ? [
    ...nn.timePicker[0],
    ...nn.timePicker[1],
    Nh.value ? [] : [Ph.value],
    nn.actionRow
  ].filter((p) => p.length) : Ih.value ? [...nn.monthPicker, nn.actionRow] : [nn.monthYear, ...nn.calendar, nn.time, nn.actionRow].filter((p) => p.length)), t = (p) => {
    fr.value = p ? fr.value + 1 : fr.value - 1;
    let m = null;
    e.value[Yn.value] && (m = e.value[Yn.value][fr.value]), m || (fr.value = p ? fr.value - 1 : fr.value + 1);
  }, n = (p) => {
    Yn.value === 0 && !p || Yn.value === e.value.length && p || (Yn.value = p ? Yn.value + 1 : Yn.value - 1, e.value[Yn.value] ? e.value[Yn.value] && !e.value[Yn.value][fr.value] && fr.value !== 0 && (fr.value = e.value[Yn.value].length - 1) : Yn.value = p ? Yn.value - 1 : Yn.value + 1);
  }, r = (p) => {
    let m = null;
    e.value[Yn.value] && (m = e.value[Yn.value][fr.value]), m ? m.focus({ preventScroll: !wc.value }) : fr.value = p ? fr.value - 1 : fr.value + 1;
  }, i = () => {
    t(!0), r(!0);
  }, a = () => {
    t(!1), r(!1);
  }, o = () => {
    n(!1), r(!0);
  }, s = () => {
    n(!0), r(!0);
  }, u = (p, m) => {
    nn[m] = p;
  }, d = (p, m) => {
    nn[m] = p;
  }, f = () => {
    fr.value = 0, Yn.value = 0;
  };
  return {
    buildMatrix: u,
    buildMultiLevelMatrix: d,
    setTimePickerBackRef: (p) => {
      Ph.value = p;
    },
    setSelectionGrid: (p) => {
      wc.value = p, f(), p || (nn.selectionGrid = []);
    },
    setTimePicker: (p, m = !1) => {
      Mh.value = p, Nh.value = m, f(), p || (nn.timePicker[0] = [], nn.timePicker[1] = []);
    },
    setTimePickerElements: (p, m = 0) => {
      nn.timePicker[m] = p;
    },
    arrowRight: i,
    arrowLeft: a,
    arrowUp: o,
    arrowDown: s,
    clearArrowNav: () => {
      nn.monthYear = [], nn.calendar = [], nn.time = [], nn.actionRow = [], nn.selectionGrid = [], nn.timePicker[0] = [], nn.timePicker[1] = [], wc.value = !1, Mh.value = !1, Nh.value = !1, Ih.value = !1, f(), Ph.value = null;
    },
    setMonthPicker: (p) => {
      Ih.value = p, f();
    },
    refSets: nn
    // exposed for testing
  };
}, Ky = (e) => Array.isArray(e), fo = (e) => Array.isArray(e), Xy = (e) => Array.isArray(e) && e.length === 2, _V = (e, t, n, r, i) => {
  const {
    getDefaultStartTime: a,
    isDisabled: o,
    sanitizeDate: s,
    getWeekFromDate: u,
    setDateMonthOrYear: d,
    validateMonthYearInRange: f,
    defaults: p
  } = Gr(e), m = oe({
    get: () => e.internalModelValue,
    set: (F) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", F);
    }
  }), g = fe([]);
  dn(m, () => {
    e.multiCalendars || C();
  });
  const v = fe([{ month: on(be()), year: sn(be()) }]), b = Uo({
    hours: e.range ? [oa(be()), oa(be())] : oa(be()),
    minutes: e.range ? [sa(be()), sa(be())] : sa(be()),
    seconds: e.range ? [0, 0] : 0
  }), w = oe(
    () => (F) => v.value[F] ? v.value[F].month : 0
  ), T = oe(
    () => (F) => v.value[F] ? v.value[F].year : 0
  ), S = oe(() => e.flow && e.flow.length ? i.value === e.flow.length : !0), x = (F, se, Pe) => {
    var Ye, gt;
    v.value[F] || (v.value[F] = { month: 0, year: 0 }), v.value[F].month = se === null ? (Ye = v.value[F]) == null ? void 0 : Ye.month : se, v.value[F].year = Pe === null ? (gt = v.value[F]) == null ? void 0 : gt.year : Pe;
  }, O = (F, se) => {
    b[F] = se;
  };
  Mt(() => {
    m.value || (e.startDate && (x(0, on(be(e.startDate)), sn(be(e.startDate))), p.value.multiCalendars && yr(0)), p.value.startTime && G()), C(!0);
  });
  const C = (F = !1) => {
    if (m.value)
      return Array.isArray(m.value) ? (g.value = m.value, X(F)) : k(m.value);
    if (e.timePicker)
      return Z();
    if (e.monthPicker && !e.range)
      return te();
    if (e.yearPicker && !e.range)
      return ce();
    if (p.value.multiCalendars && F && !e.startDate)
      return P(be(), F);
  }, P = (F, se = !1) => {
    if ((!p.value.multiCalendars || !e.multiStatic || se) && x(0, on(F), sn(F)), p.value.multiCalendars)
      for (let Pe = 1; Pe < p.value.multiCalendars; Pe++) {
        const Ye = mr(be(), { month: w.value(Pe - 1), year: T.value(Pe - 1) }), gt = jx(Ye, { months: 1 });
        v.value[Pe] = { month: on(gt), year: sn(gt) };
      }
  }, k = (F) => {
    P(F), O("hours", oa(F)), O("minutes", sa(F)), O("seconds", Ss(F));
  }, M = (F, se) => {
    P(F[0], se);
    const Pe = (Ye, gt) => [
      Ye(F[0]),
      F[1] ? Ye(F[1]) : b[gt][1]
    ];
    O("hours", Pe(oa, "hours")), O("minutes", Pe(sa, "minutes")), O("seconds", Pe(Ss, "seconds"));
  }, N = (F, se) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return M(F, se);
    if (e.multiDates) {
      const Pe = F[F.length - 1];
      return k(Pe);
    }
  }, X = (F) => {
    const se = m.value;
    N(se, F), p.value.multiCalendars && e.multiCalendarsSolo && y();
  }, Z = () => {
    if (G(), !e.range)
      m.value = ii(be(), b.hours, b.minutes, we());
    else {
      const F = b.hours, se = b.minutes;
      m.value = [
        ii(be(), F[0], se[0], we()),
        ii(be(), F[1], se[1], we(!1))
      ];
    }
  }, te = () => {
    m.value = d(be(), w.value(0), T.value(0));
  }, ce = () => {
    m.value = be();
  }, we = (F = !0) => e.enableSeconds ? Array.isArray(b.seconds) ? F ? b.seconds[0] : b.seconds[1] : b.seconds : 0, G = () => {
    const F = a();
    if (F) {
      const se = Array.isArray(F), Pe = se ? [+F[0].hours, +F[1].hours] : +F.hours, Ye = se ? [+F[0].minutes, +F[1].minutes] : +F.minutes, gt = se ? [+F[0].seconds, +F[1].seconds] : +F.seconds;
      O("hours", Pe), O("minutes", Ye), e.enableSeconds && O("seconds", gt);
    }
  }, Q = () => Array.isArray(m.value) && m.value.length ? m.value[m.value.length - 1] : null, y = () => {
    if (Array.isArray(m.value) && m.value.length === 2) {
      const F = be(
        be(m.value[1] ? m.value[1] : Pi(m.value[0], 1))
      ), [se, Pe] = [on(m.value[0]), sn(m.value[0])], [Ye, gt] = [on(m.value[1]), sn(m.value[1])];
      (se !== Ye || se === Ye && Pe !== gt) && e.multiCalendarsSolo && x(1, on(F), sn(F));
    }
  }, H = (F) => {
    const se = Pi(F, 1);
    return { month: on(se), year: sn(se) };
  }, ie = (F) => {
    const se = on(be(F)), Pe = sn(be(F));
    if (x(0, se, Pe), p.value.multiCalendars > 0)
      for (let Ye = 1; Ye < p.value.multiCalendars; Ye++) {
        const gt = H(
          mr(be(F), { year: w.value(Ye - 1), month: T.value(Ye - 1) })
        );
        x(Ye, gt.month, gt.year);
      }
  }, ne = (F) => {
    if (m.value && Array.isArray(m.value))
      if (m.value.some((se) => un(F, se))) {
        const se = m.value.filter((Pe) => !un(Pe, F));
        m.value = se.length ? se : null;
      } else
        (e.multiDatesLimit && +e.multiDatesLimit > m.value.length || !e.multiDatesLimit) && m.value.push(F);
    else
      m.value = [F];
  }, J = (F, se) => {
    const Pe = vr(F, se) ? se : F, Ye = vr(se, F) ? se : F;
    return Dy({ start: Pe, end: Ye });
  }, me = (F) => {
    if (Array.isArray(m.value) && m.value[0]) {
      const se = DR(F, m.value[0]), Pe = J(m.value[0], F), Ye = Pe.length === 1 ? 0 : Pe.filter((mn) => o(mn)).length, gt = Math.abs(se) - Ye;
      if (e.minRange && e.maxRange)
        return gt >= +e.minRange && gt <= +e.maxRange;
      if (e.minRange)
        return gt >= +e.minRange;
      if (e.maxRange)
        return gt <= +e.maxRange;
    }
    return !0;
  }, xe = (F) => Array.isArray(m.value) && m.value.length === 2 ? e.fixedStart && (vr(F, m.value[0]) || un(F, m.value[0])) ? [m.value[0], F] : e.fixedEnd && (rr(F, m.value[1]) || un(F, m.value[1])) ? [F, m.value[1]] : (t("invalid-fixed-range", F), m.value) : [], U = () => {
    e.autoApply && S.value && t("auto-apply");
  }, $ = () => {
    e.autoApply && t("select-date");
  }, Y = (F) => !Dy({ start: F[0], end: F[1] }).some((se) => o(se)), Re = (F) => (m.value = u(be(F.value)), U()), it = (F) => {
    const se = ii(be(F.value), b.hours, b.minutes, we());
    e.multiDates ? ne(se) : m.value = se, n(), U();
  }, He = () => {
    g.value = m.value ? m.value.slice() : [], g.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (g.value = []);
  }, Vt = (F, se) => {
    const Pe = [be(F.value), pa(be(F.value), +e.autoRange)];
    Y(Pe) && (se && ie(F.value), g.value = Pe);
  }, Bt = (F) => {
    Be(F.value) || (g.value = xe(be(F.value)));
  }, Be = (F) => e.noDisabledRange ? J(g.value[0], F).some((se) => o(se)) : !1, Xe = (F, se) => {
    if (He(), e.autoRange)
      return Vt(F, se);
    if (e.fixedStart || e.fixedEnd)
      return Bt(F);
    g.value[0] ? me(be(F.value)) && !Be(F.value) && (rr(be(F.value), be(g.value[0])) ? g.value.unshift(be(F.value)) : g.value[1] = be(F.value)) : g.value[0] = be(F.value);
  }, ue = (F) => {
    g.value[F] = ii(
      g.value[F],
      b.hours[F],
      b.minutes[F],
      we(F !== 1)
    );
  }, Ce = () => {
    g.value.length && (g.value[0] && !g.value[1] ? ue(0) : (ue(0), ue(1), n()), m.value = g.value.slice(), g.value[0] && g.value[1] && e.autoApply && t("auto-apply"), g.value[0] && !g.value[1] && e.modelAuto && e.autoApply && t("auto-apply"));
  }, Pr = (F, se = !1) => {
    if (!(o(F.value) || !F.current && e.hideOffsetDates)) {
      if (e.weekPicker)
        return Re(F);
      if (!e.range)
        return it(F);
      fo(b.hours) && fo(b.minutes) && !e.multiDates && (Xe(F, se), Ce());
    }
  }, qt = (F) => {
    const se = F.find((Pe) => Pe.current);
    return se ? DF(se.value) : "";
  }, yr = (F) => {
    for (let se = F - 1; se >= 0; se--) {
      const Pe = li(mr(be(), { month: w.value(se + 1), year: T.value(se + 1) }), 1);
      x(se, on(Pe), sn(Pe));
    }
    for (let se = F + 1; se <= p.value.multiCalendars - 1; se++) {
      const Pe = Pi(mr(be(), { month: w.value(se - 1), year: T.value(se - 1) }), 1);
      x(se, on(Pe), sn(Pe));
    }
  }, Mr = (F) => d(be(), w.value(F), T.value(F)), R = (F) => ii(F, b.hours, b.minutes, we()), V = (F, se) => {
    const Pe = e.monthPicker ? w.value(F) !== se.month || !se.fromNav : T.value(F) !== se.year;
    if (x(F, se.month, se.year), p.value.multiCalendars && !e.multiCalendarsSolo && yr(F), e.monthPicker || e.yearPicker)
      if (e.range) {
        if (Pe) {
          let Ye = m.value ? m.value.slice() : [];
          Ye.length === 2 && Ye[1] !== null && (Ye = []), Ye.length ? rr(Mr(F), Ye[0]) ? Ye.unshift(Mr(F)) : Ye[1] = Mr(F) : Ye = [Mr(F)], m.value = Ye;
        }
      } else
        m.value = Mr(F);
    t("update-month-year", { instance: F, month: se.month, year: se.year }), r(e.multiCalendarsSolo ? F : void 0);
  }, ge = async (F = !1) => {
    if (e.autoApply && (e.monthPicker || e.yearPicker)) {
      await $a();
      const se = e.monthPicker ? F : !1;
      e.range ? t("auto-apply", se || !m.value || m.value.length === 1) : t("auto-apply", se);
    }
    n();
  }, Fe = (F, se) => {
    const Pe = mr(be(), { month: w.value(se), year: T.value(se) }), Ye = F < 0 ? Pi(Pe, 1) : li(Pe, 1);
    f(on(Ye), sn(Ye), F < 0, e.preventMinMaxNavigation) && (x(se, on(Ye), sn(Ye)), p.value.multiCalendars && !e.multiCalendarsSolo && yr(se), t("update-month-year", { instance: se, month: on(Ye), year: sn(Ye) }), r());
  }, Pt = (F) => {
    Ky(F) && Ky(m.value) && fo(b.hours) && fo(b.minutes) ? (F[0] && m.value[0] && (m.value[0] = ii(F[0], b.hours[0], b.minutes[0], we())), F[1] && m.value[1] && (m.value[1] = ii(F[1], b.hours[1], b.minutes[1], we(!1)))) : e.multiDates && Array.isArray(m.value) ? m.value[m.value.length - 1] = R(F) : !e.range && !Xy(F) && (m.value = R(F)), t("time-update");
  }, mt = (F, se = !0, Pe = !1) => {
    const Ye = se ? F : b.hours, gt = !se && !Pe ? F : b.minutes, mn = Pe ? F : b.seconds;
    if (e.range && Xy(m.value) && fo(Ye) && fo(gt) && fo(mn) && !e.disableTimeRangeValidation) {
      const Ir = (Ne) => ii(m.value[Ne], Ye[Ne], gt[Ne], mn[Ne]), de = (Ne) => Rm(m.value[Ne], 0);
      if (un(m.value[0], m.value[1]) && (Pm(Ir(0), de(1)) || Mm(Ir(1), de(0))))
        return;
    }
    if (O("hours", Ye), O("minutes", gt), O("seconds", mn), m.value)
      if (e.multiDates) {
        const Ir = Q();
        Ir && Pt(Ir);
      } else
        Pt(m.value);
    else
      e.timePicker && Pt(e.range ? [be(), be()] : be());
    n();
  }, wt = (F, se) => {
    e.monthChangeOnScroll && Fe(e.monthChangeOnScroll !== "inverse" ? -F.deltaY : F.deltaY, se);
  }, ae = (F, se, Pe = !1) => {
    e.monthChangeOnArrows && e.vertical === Pe && _e(F, se);
  }, _e = (F, se) => {
    Fe(F === "right" ? -1 : 1, se);
  };
  return {
    time: b,
    month: w,
    year: T,
    modelValue: m,
    calendars: v,
    monthYearSelect: ge,
    isDisabled: o,
    updateTime: mt,
    getWeekNum: qt,
    selectDate: Pr,
    updateMonthYear: V,
    handleScroll: wt,
    getMarker: (F) => e.markers.find((se) => un(s(F.value), s(se.date))),
    handleArrow: ae,
    handleSwipe: _e,
    selectCurrentDate: () => {
      e.range ? m.value && Array.isArray(m.value) && m.value[0] ? m.value = rr(be(), m.value[0]) ? [be(), m.value[0]] : [m.value[0], be()] : m.value = [be()] : m.value = be(), $();
    },
    presetDateRange: (F, se) => {
      se || F.length && F.length <= 2 && e.range && (m.value = F.map((Pe) => be(Pe)), $(), e.multiCalendars && $a().then(() => C(!0)));
    }
  };
}, yV = (e, t, n) => {
  const r = fe(), {
    getZonedToUtc: i,
    getZonedDate: a,
    formatDate: o,
    getDefaultPattern: s,
    checkRangeEnabled: u,
    checkPartialRangeValue: d,
    isValidDate: f,
    setDateMonthOrYear: p,
    defaults: m
  } = Gr(t), g = fe(""), v = aa(t, "format");
  dn(r, () => {
    e("internal-model-change", r.value);
  }), dn(v, () => {
    H();
  });
  const b = (U) => {
    const $ = U || be();
    return t.modelType ? ne($) : {
      hours: oa($),
      minutes: sa($),
      seconds: t.enableSeconds ? Ss($) : 0
    };
  }, w = (U) => t.modelType ? ne(U) : { month: on(U), year: sn(U) }, T = (U) => Array.isArray(U) ? u(() => [
    Oo(be(), U[0]),
    U[1] ? Oo(be(), U[1]) : d()
  ]) : Oo(be(), +U), S = (U, $) => (typeof U == "string" || typeof U == "number") && t.modelType ? ie(U) : $, x = (U) => Array.isArray(U) ? [
    S(
      U[0],
      ii(null, +U[0].hours, +U[0].minutes, U[0].seconds)
    ),
    S(
      U[1],
      ii(null, +U[1].hours, +U[1].minutes, U[1].seconds)
    )
  ] : S(U, ii(null, U.hours, U.minutes, U.seconds)), O = (U) => Array.isArray(U) ? u(() => [
    S(U[0], p(null, +U[0].month, +U[0].year)),
    S(
      U[1],
      U[1] ? p(null, +U[1].month, +U[1].year) : d()
    )
  ]) : S(U, p(null, +U.month, +U.year)), C = (U) => {
    if (Array.isArray(U))
      return U.map(($) => ie($));
    throw new Error(cd.dateArr("multi-dates"));
  }, P = (U) => {
    if (Array.isArray(U))
      return [be(U[0]), be(U[1])];
    throw new Error(cd.dateArr("week-picker"));
  }, k = (U) => t.modelAuto ? Array.isArray(U) ? [ie(U[0]), ie(U[1])] : t.autoApply ? [ie(U)] : [ie(U), null] : Array.isArray(U) ? u(() => [
    ie(U[0]),
    U[1] ? ie(U[1]) : d()
  ]) : ie(U), M = () => {
    Array.isArray(r.value) && t.range && r.value.length === 1 && r.value.push(d());
  }, N = () => {
    const U = r.value;
    return [
      ne(U[0]),
      U[1] ? ne(U[1]) : d()
    ];
  }, X = () => r.value[1] ? N() : ne(Jn(r.value[0])), Z = () => (r.value || []).map((U) => ne(U)), te = () => (M(), t.modelAuto ? X() : t.multiDates ? Z() : Array.isArray(r.value) ? u(() => N()) : ne(Jn(r.value))), ce = (U) => U ? t.timePicker ? x(Jn(U)) : t.monthPicker ? O(Jn(U)) : t.yearPicker ? T(Jn(U)) : t.multiDates ? C(Jn(U)) : t.weekPicker ? P(Jn(U)) : k(Jn(U)) : null, we = (U) => {
    const $ = ce(U);
    f(Jn($)) ? (r.value = Jn($), H()) : (r.value = null, g.value = "");
  }, G = () => {
    var U;
    const $ = (Y) => {
      var Re;
      return Li(Y, (Re = m.value.textInputOptions) == null ? void 0 : Re.format);
    };
    return `${$(r.value[0])} ${(U = m.value.textInputOptions) == null ? void 0 : U.rangeSeparator} ${r.value[1] ? $(r.value[1]) : ""}`;
  }, Q = () => {
    var U;
    return n.value && r.value ? Array.isArray(r.value) ? G() : Li(r.value, (U = m.value.textInputOptions) == null ? void 0 : U.format) : o(r.value);
  }, y = () => {
    var U;
    return r.value ? t.multiDates ? r.value.map(($) => o($)).join("; ") : t.textInput && typeof ((U = m.value.textInputOptions) == null ? void 0 : U.format) == "string" ? Q() : o(r.value) : "";
  }, H = () => {
    !t.format || typeof t.format == "string" ? g.value = y() : g.value = t.format(r.value);
  }, ie = (U) => {
    if (t.utc) {
      const $ = new Date(U);
      return t.utc === "preserve" ? new Date($.getTime() + $.getTimezoneOffset() * 6e4) : $;
    }
    return t.modelType ? t.modelType === "date" || t.modelType === "timestamp" ? a(new Date(U)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? Tp(U, s(), /* @__PURE__ */ new Date()) : a(Tp(U, t.modelType, /* @__PURE__ */ new Date())) : a(new Date(U));
  }, ne = (U) => t.utc ? I3(U, t.utc === "preserve") : t.modelType ? t.modelType === "timestamp" ? +i(U) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? o(i(U)) : o(i(U), t.modelType) : i(U), J = (U) => {
    e("update:model-value", U);
  }, me = (U) => Array.isArray(r.value) ? [
    U(r.value[0]),
    r.value[1] ? U(r.value[1]) : d()
  ] : U(Jn(r.value)), xe = (U) => J(Jn(me(U)));
  return {
    inputValue: g,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? t.range ? t.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: we,
    formatInputValue: H,
    emitModelValue: () => (H(), t.monthPicker ? xe(w) : t.timePicker ? xe(b) : t.yearPicker ? xe(sn) : t.weekPicker ? J(r.value) : J(te()))
  };
}, bV = (e, t) => {
  const { validateMonthYearInRange: n, validateMaxDate: r, validateMinDate: i, defaults: a } = Gr(e), o = (p, m) => {
    let g = p;
    return a.value.filters.months.includes(on(g)) ? (g = m ? Pi(p, 1) : li(p, 1), o(g, m)) : g;
  }, s = (p, m) => {
    let g = p;
    return a.value.filters.years.includes(sn(g)) ? (g = m ? Yx(p, 1) : j$(p, 1), s(g, m)) : g;
  }, u = (p) => {
    const m = mr(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let g = p ? Pi(m, 1) : li(m, 1), v = on(g), b = sn(g);
    a.value.filters.months.includes(v) && (g = o(g, p), v = on(g), b = sn(g)), a.value.filters.years.includes(b) && (g = s(g, p), b = sn(g)), n(v, b, p, e.preventMinMaxNavigation) && d(v, b);
  }, d = (p, m) => {
    t("update-month-year", { month: p, year: m });
  }, f = oe(() => (p) => {
    if (!e.preventMinMaxNavigation || p && !e.maxDate || !p && !e.minDate)
      return !1;
    const m = mr(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }), g = p ? Pi(m, 1) : li(m, 1), v = [on(g), sn(g)];
    return p ? !r(...v) : !i(...v);
  });
  return { handleMonthYearChange: u, isDisabled: f, updateMonthYear: d };
};
var qc = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(qc || {});
const wV = (e, t, n, r) => {
  const i = fe({
    top: "0",
    left: "0",
    transform: "none"
  }), a = fe(!1), o = aa(r, "teleportCenter");
  dn(o, () => {
    w();
  });
  const s = (k) => {
    const M = k.getBoundingClientRect();
    return {
      left: M.left + window.scrollX,
      top: M.top + window.scrollY
    };
  }, u = (k) => {
    const M = k.getBoundingClientRect();
    let N = 0, X = 0;
    for (; k && !isNaN(k.offsetLeft) && !isNaN(k.offsetTop); )
      N += k.offsetLeft - k.scrollLeft, X = M.top + k.scrollTop, k = k.offsetParent;
    return { top: X, left: N };
  }, d = (k, M) => {
    i.value.left = `${k + M}px`, i.value.transform = "translateX(-100%)";
  }, f = (k) => {
    i.value.left = `${k}px`, i.value.transform = "translateX(0)";
  }, p = (k, M, N = !1) => {
    r.position === qc.left && f(k), r.position === qc.right && d(k, M), r.position === qc.center && (i.value.left = `${k + M / 2}px`, i.value.transform = N ? "translate(-50%, -50%)" : "translateX(-50%)");
  }, m = (k) => {
    const { width: M, height: N } = k.getBoundingClientRect(), { top: X, left: Z } = r.altPosition ? u(k) : s(k);
    return { top: X, left: Z, width: M, height: N };
  }, g = () => {
    const k = Nn(t);
    if (k) {
      const { top: M, left: N, width: X, height: Z } = m(k);
      i.value.top = `${M + Z / 2}px`, i.value.transform = "translateY(-50%)", p(N, X, !0);
    }
  }, v = () => {
    i.value.left = "50%", i.value.top = "50%", i.value.transform = "translate(-50%, -50%)", i.value.position = "fixed";
  }, b = () => {
    const k = Nn(t);
    i.value = r.altPosition(k);
  }, w = (k = !0) => {
    if (!r.inline)
      return o.value ? v() : r.altPosition && typeof r.altPosition != "boolean" ? b() : (k && n("recalculate-position"), P());
  }, T = ({
    inputEl: k,
    menuEl: M,
    left: N,
    width: X
  }) => {
    window.screen.width > 768 && p(N, X), O(k, M);
  }, S = (k, M) => {
    const { top: N, left: X, height: Z, width: te } = m(k);
    i.value.top = `${Z + N + +r.offset}px`, T({ inputEl: k, menuEl: M, left: X, width: te }), a.value = !1;
  }, x = (k, M) => {
    const { top: N, left: X, width: Z } = m(k), { height: te } = M.getBoundingClientRect();
    i.value.top = `${N - te - +r.offset}px`, T({ inputEl: k, menuEl: M, left: X, width: Z }), a.value = !0;
  }, O = (k, M) => {
    if (r.autoPosition) {
      const { left: N, width: X } = m(k), { left: Z, right: te } = M.getBoundingClientRect();
      if (Z < 0)
        return f(N);
      if (te > document.documentElement.clientWidth)
        return d(N, X);
    }
  }, C = (k, M) => {
    const { height: N } = M.getBoundingClientRect(), { top: X, height: Z } = k.getBoundingClientRect(), te = window.innerHeight - X - Z, ce = X;
    return N <= te ? S(k, M) : N > te && N <= ce ? x(k, M) : te >= ce ? S(k, M) : x(k, M);
  }, P = () => {
    const k = Nn(t), M = Nn(e);
    if (k && M)
      return r.autoPosition ? C(k, M) : S(k, M);
  };
  return { openOnTop: a, menuPosition: i, setMenuPosition: w, setInitialPosition: g };
}, ds = [
  { name: "clock-icon", use: ["time", "calendar"] },
  { name: "arrow-left", use: ["month-year", "calendar"] },
  { name: "arrow-right", use: ["month-year", "calendar"] },
  { name: "arrow-up", use: ["time", "calendar"] },
  { name: "arrow-down", use: ["time", "calendar"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar"] },
  { name: "day", use: ["calendar"] },
  { name: "month-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay", use: ["month-year"] },
  { name: "month-overlay", use: ["month-year"] },
  { name: "month-overlay-header", use: ["month-year"] },
  { name: "year-overlay-header", use: ["month-year"] },
  { name: "hours-overlay-value", use: ["calendar", "time"] },
  { name: "minutes-overlay-value", use: ["calendar", "time"] },
  { name: "seconds-overlay-value", use: ["calendar", "time"] },
  { name: "hours", use: ["calendar", "time"] },
  { name: "minutes", use: ["calendar", "time"] },
  { name: "month", use: ["calendar", "month-year"] },
  { name: "year", use: ["calendar", "month-year"] },
  { name: "action-select", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar"] },
  { name: "marker-tooltip", use: ["calendar"] },
  { name: "now-button", use: [] },
  { name: "time-picker-overlay", use: ["calendar", "time"] },
  { name: "am-pm-button", use: ["calendar", "time"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year"] },
  { name: "time-picker", use: ["menu"] },
  { name: "action-row", use: ["action"] }
], xV = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], EV = {
  all: () => ds,
  monthYear: () => ds.filter((e) => e.use.includes("month-year")),
  input: () => xV,
  timePicker: () => ds.filter((e) => e.use.includes("time")),
  action: () => ds.filter((e) => e.use.includes("action")),
  calendar: () => ds.filter((e) => e.use.includes("calendar")),
  menu: () => ds.filter((e) => e.use.includes("menu"))
}, To = (e, t, n) => {
  const r = [];
  return EV[t]().forEach((i) => {
    e[i.name] && r.push(i.name);
  }), n && n.length && n.forEach((i) => {
    i.slot && r.push(i.slot);
  }), r;
}, Md = (e) => ({ transitionName: oe(() => (t) => e && typeof e != "boolean" ? t ? e.open : e.close : ""), showTransition: !!e }), Xa = {
  multiCalendars: { type: [Boolean, Number, String], default: null },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: { type: Boolean, default: !1 },
  autoPosition: { type: Boolean, default: !0 },
  closeOnAutoApply: { type: Boolean, default: !0 },
  teleport: { type: [String, Object], default: "body" },
  altPosition: { type: [Boolean, Function], default: !1 },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  multiCalendarsSolo: { type: Boolean, default: !1 },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  monthYearComponent: { type: Object, default: null },
  timePickerComponent: { type: Object, default: null },
  actionRowComponent: { type: Object, default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: () => [] },
  showNowButton: { type: Boolean, default: !1 },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  modeHeight: { type: [Number, String], default: 255 },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetRanges: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  keepActionRow: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  multiStatic: { type: Boolean, default: !0 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: { type: Boolean, default: !1 },
  calendarClassName: { type: String, default: null },
  noSwipe: { type: Boolean, default: !1 },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  inlineWithInput: { type: Boolean, default: !1 },
  textInputOptions: { type: Object, default: () => null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: Boolean, default: !1 },
  textInput: { type: Boolean, default: !1 },
  onClickOutside: { type: Function, default: null },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: Boolean, default: !1 }
}, TV = ["aria-label", "aria-disabled", "aria-readonly"], kV = {
  key: 1,
  class: "dp__input_wrap"
}, SV = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "onKeydown"], OV = {
  key: 2,
  class: "dp__input_icon"
}, CV = {
  key: 4,
  class: "dp__clear_icon"
}, AV = /* @__PURE__ */ Tt({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Xa
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { getDefaultPattern: i, isValidDate: a, defaults: o } = Gr(r), s = fe(), u = fe(null), d = fe(!1), f = oe(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !r.textInput,
        dp__disabled: r.disabled,
        dp__input_readonly: !r.textInput,
        dp__input: !0,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: r.state,
        dp__input_invalid: r.state === !1,
        dp__input_focus: d.value || r.isMenuOpen,
        dp__input_reg: !r.textInput,
        [r.inputClassName]: !!r.inputClassName
      })
    ), p = () => {
      n("set-input-date", null), r.autoApply && (n("set-empty-date"), s.value = null);
    }, m = (k) => {
      var M;
      return M3(k, ((M = o.value.textInputOptions) == null ? void 0 : M.format) || i());
    }, g = (k) => {
      const { rangeSeparator: M } = o.value.textInputOptions, [N, X] = k.split(`${M}`);
      if (N) {
        const Z = m(N.trim()), te = X ? m(X.trim()) : null, ce = Z && te ? [Z, te] : [Z];
        s.value = Z ? ce : null;
      }
    }, v = (k) => {
      if (r.range)
        g(k);
      else if (r.multiDates) {
        const M = k.split(";");
        s.value = M.map((N) => m(N.trim())).filter((N) => N);
      } else
        s.value = m(k);
    }, b = (k) => {
      var M;
      const { value: N } = k.target;
      N !== "" ? ((M = o.value.textInputOptions) != null && M.openMenu && !r.isMenuOpen && n("open"), v(N), n("set-input-date", s.value)) : p(), n("update:input-value", N);
    }, w = () => {
      var k, M;
      (k = o.value.textInputOptions) != null && k.enterSubmit && a(s.value) && r.inputValue !== "" ? (n("set-input-date", s.value, !0), s.value = null) : (M = o.value.textInputOptions) != null && M.enterSubmit && r.inputValue === "" && (s.value = null, n("clear"));
    }, T = () => {
      var k, M;
      (k = o.value.textInputOptions) != null && k.tabSubmit && a(s.value) && r.inputValue !== "" ? (n("set-input-date", s.value, !0), s.value = null) : (M = o.value.textInputOptions) != null && M.tabSubmit && r.inputValue === "" && (s.value = null, n("clear"));
    }, S = () => {
      d.value = !0, n("focus");
    }, x = (k) => {
      var M;
      k.preventDefault(), k.stopImmediatePropagation(), k.stopPropagation(), r.textInput && (M = o.value.textInputOptions) != null && M.openMenu && !r.inlineWithInput ? r.isMenuOpen ? o.value.textInputOptions.enterSubmit && n("select-date") : n("open") : r.textInput || n("toggle");
    }, O = () => {
      d.value = !1, r.isMenuOpen || n("blur"), r.autoApply && r.textInput && s.value && (n("set-input-date", s.value), n("select-date"), s.value = null);
    }, C = () => {
      n("clear");
    }, P = (k) => {
      r.textInput || k.preventDefault();
    };
    return t({
      focusInput: () => {
        u.value && u.value.focus({ preventScroll: !0 });
      }
    }), (k, M) => {
      var N;
      return I(), W("div", {
        onClick: x,
        "aria-label": (N = j(o).ariaLabels) == null ? void 0 : N.input,
        role: "textbox",
        "aria-multiline": "false",
        "aria-disabled": k.disabled,
        "aria-readonly": k.readonly
      }, [
        k.$slots.trigger && !k.$slots["dp-input"] && !k.inline ? Ee(k.$slots, "trigger", { key: 0 }) : ee("", !0),
        !k.$slots.trigger && (!k.inline || k.inlineWithInput) ? (I(), W("div", kV, [
          k.$slots["dp-input"] && !k.$slots.trigger && !k.inline ? Ee(k.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            onInput: b,
            onEnter: w,
            onTab: T,
            onClear: C
          }) : ee("", !0),
          k.$slots["dp-input"] ? ee("", !0) : (I(), W("input", {
            key: 1,
            ref_key: "inputRef",
            ref: u,
            id: k.uid ? `dp-input-${k.uid}` : void 0,
            name: k.name,
            class: ze(j(f)),
            inputmode: k.textInput ? "text" : "none",
            placeholder: k.placeholder,
            disabled: k.disabled,
            readonly: k.readonly,
            required: k.required,
            value: e.inputValue,
            autocomplete: k.autocomplete,
            onInput: b,
            onKeydown: [
              _t(x, ["enter"]),
              _t(T, ["tab"])
            ],
            onBlur: O,
            onFocus: S,
            onKeypress: P
          }, null, 42, SV)),
          k.$slots["input-icon"] && !k.hideInputIcon ? (I(), W("span", OV, [
            Ee(k.$slots, "input-icon")
          ])) : ee("", !0),
          !k.$slots["input-icon"] && !k.hideInputIcon && !k.$slots["dp-input"] ? (I(), Oe(j(Pd), {
            key: 3,
            class: "dp__input_icon dp__input_icons"
          })) : ee("", !0),
          k.$slots["clear-icon"] && e.inputValue && k.clearable && !k.disabled && !k.readonly ? (I(), W("span", CV, [
            Ee(k.$slots, "clear-icon", { clear: C })
          ])) : ee("", !0),
          k.clearable && !k.$slots["clear-icon"] && e.inputValue && !k.disabled && !k.readonly ? (I(), Oe(j(a3), {
            key: 5,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: nr(C, ["stop", "prevent"])
          }, null, 8, ["onClick"])) : ee("", !0)
        ])) : ee("", !0)
      ], 8, TV);
    };
  }
}), DV = { class: "dp__selection_preview" }, PV = { class: "dp__action_buttons" }, MV = ["onKeydown"], IV = /* @__PURE__ */ Tt({
  __name: "ActionRow",
  props: {
    calendarWidth: { type: Number, default: 0 },
    menuMount: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    ...Xa
  },
  emits: ["close-picker", "select-date", "invalid-select"],
  setup(e, { emit: t }) {
    const n = e, { formatDate: r, isValidTime: i, defaults: a } = Gr(n), { buildMatrix: o } = Ka(), s = fe(null), u = fe(null);
    Mt(() => {
      n.arrowNavigation && o([Nn(s), Nn(u)], "actionRow");
    });
    const d = oe(() => n.range && !n.partialRange && n.internalModelValue ? n.internalModelValue.length === 2 : !0), f = oe(() => !m.value || !g.value || !d.value), p = oe(() => ({
      dp__action: !0,
      dp__select: !0,
      dp__action_disabled: f.value
    })), m = oe(() => !n.enableTimePicker || n.ignoreTimeValidation ? !0 : i(n.internalModelValue)), g = oe(() => n.monthPicker ? T(n.internalModelValue) : !0), v = () => {
      const x = a.value.previewFormat;
      return n.timePicker || n.monthPicker, x(Jn(n.internalModelValue));
    }, b = () => {
      const x = n.internalModelValue;
      return a.value.multiCalendars > 0 ? `${r(x[0])} - ${r(x[1])}` : [r(x[0]), r(x[1])];
    }, w = oe(() => !n.internalModelValue || !n.menuMount ? "" : typeof a.value.previewFormat == "string" ? Array.isArray(n.internalModelValue) ? n.internalModelValue.length === 2 && n.internalModelValue[1] ? b() : n.multiDates ? n.internalModelValue.map((x) => `${r(x)}`) : n.modelAuto ? `${r(n.internalModelValue[0])}` : `${r(n.internalModelValue[0])} -` : r(n.internalModelValue) : v()), T = (x) => {
      if (!n.monthPicker)
        return !0;
      let O = !0;
      return n.minDate && n.maxDate ? vr(be(x), be(n.minDate)) && rr(be(x), be(n.maxDate)) : (n.minDate && (O = vr(be(x), be(n.minDate))), n.maxDate && (O = rr(be(x), be(n.maxDate))), O);
    }, S = () => {
      m.value && g.value && d.value ? t("select-date") : t("invalid-select");
    };
    return (x, O) => (I(), W("div", {
      class: "dp__action_row",
      style: ca(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      x.$slots["action-row"] ? Ee(x.$slots, "action-row", Wr(zn({ key: 0 }, {
        internalModelValue: e.internalModelValue,
        disabled: j(f),
        selectDate: () => x.$emit("select-date"),
        closePicker: () => x.$emit("close-picker")
      }))) : (I(), W(Ge, { key: 1 }, [
        K("div", DV, [
          x.$slots["action-preview"] ? Ee(x.$slots, "action-preview", {
            key: 0,
            value: e.internalModelValue
          }) : ee("", !0),
          x.$slots["action-preview"] ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
            Array.isArray(j(w)) ? ee("", !0) : (I(), W(Ge, { key: 0 }, [
              Xt(ke(j(w)), 1)
            ], 64)),
            Array.isArray(j(w)) ? (I(!0), W(Ge, { key: 1 }, Nt(j(w), (C, P) => (I(), W("div", { key: P }, ke(C), 1))), 128)) : ee("", !0)
          ], 64))
        ]),
        K("div", PV, [
          x.$slots["action-select"] ? Ee(x.$slots, "action-select", {
            key: 0,
            value: e.internalModelValue
          }) : ee("", !0),
          x.$slots["action-select"] ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
            x.inline ? ee("", !0) : (I(), W("span", {
              key: 0,
              class: "dp__action dp__cancel",
              ref_key: "cancelButtonRef",
              ref: s,
              tabindex: "0",
              onClick: O[0] || (O[0] = (C) => x.$emit("close-picker")),
              onKeydown: [
                O[1] || (O[1] = _t((C) => x.$emit("close-picker"), ["enter"])),
                O[2] || (O[2] = _t((C) => x.$emit("close-picker"), ["space"]))
              ]
            }, ke(x.cancelText), 545)),
            K("span", {
              class: ze(j(p)),
              tabindex: "0",
              onKeydown: [
                _t(S, ["enter"]),
                _t(S, ["space"])
              ],
              onClick: S,
              "data-test": "select-button",
              ref_key: "selectButtonRef",
              ref: u
            }, ke(x.selectText), 43, MV)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), NV = ["aria-label"], LV = {
  class: "dp__calendar_header",
  role: "row"
}, RV = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, FV = /* @__PURE__ */ K("div", { class: "dp__calendar_header_separator" }, null, -1), $V = ["aria-label"], VV = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, BV = { class: "dp__cell_inner" }, UV = ["aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], WV = /* @__PURE__ */ K("div", { class: "dp__arrow_bottom_tp" }, null, -1), HV = /* @__PURE__ */ Tt({
  __name: "Calendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    getWeekNum: {
      type: Function,
      default: () => ""
    },
    specificMode: { type: Boolean, default: !1 },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Xa
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { buildMultiLevelMatrix: i } = Ka(), { setDateMonthOrYear: a, defaults: o } = Gr(r), s = fe(null), u = fe({ bottom: "", left: "", transform: "" }), d = fe([]), f = fe(null), p = fe(!0), m = fe(""), g = fe({ startX: 0, endX: 0, startY: 0, endY: 0 }), v = oe(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : sV(r.locale, +r.weekStart));
    Mt(() => {
      n("mount", { cmp: "calendar", refs: d }), r.noSwipe || f.value && (f.value.addEventListener("touchstart", N, { passive: !1 }), f.value.addEventListener("touchend", X, { passive: !1 }), f.value.addEventListener("touchmove", Z, { passive: !1 })), r.monthChangeOnScroll && f.value && f.value.addEventListener("wheel", we, { passive: !1 });
    });
    const b = (G) => G ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", w = (G, Q) => {
      if (r.transitions) {
        const y = Fi(a(be(), r.month, r.year));
        m.value = vr(Fi(a(be(), G, Q)), y) ? o.value.transitions[b(!0)] : o.value.transitions[b(!1)], p.value = !1, $a(() => {
          p.value = !0;
        });
      }
    }, T = oe(
      () => ({
        dp__calendar_wrap: !0,
        [r.calendarClassName]: !!r.calendarClassName
      })
    ), S = oe(() => (G) => {
      const Q = dV(G);
      return {
        dp__marker_dot: Q.type === "dot",
        dp__marker_line: Q.type === "line"
      };
    }), x = oe(() => (G) => un(G, s.value)), O = oe(() => ({
      dp__calendar: !0,
      dp__calendar_next: o.value.multiCalendars > 0 && r.instance !== 0
    })), C = oe(() => (G) => r.hideOffsetDates ? G.current : !0), P = oe(() => r.specificMode ? { height: `${r.modeHeight}px` } : void 0), k = (G, Q, y) => {
      var H, ie;
      if (n("set-hover-date", G), (ie = (H = G.marker) == null ? void 0 : H.tooltip) != null && ie.length) {
        const ne = Nn(d.value[Q][y]);
        if (ne) {
          const { width: J, height: me } = ne.getBoundingClientRect();
          u.value = {
            bottom: `${me}px`,
            left: `${J / 2}px`,
            transform: "translateX(-50%)"
          }, s.value = G.value, n("tooltip-open", G.value);
        }
      }
    }, M = (G) => {
      s.value && (s.value = null, n("tooltip-close", G.value));
    }, N = (G) => {
      g.value.startX = G.changedTouches[0].screenX, g.value.startY = G.changedTouches[0].screenY;
    }, X = (G) => {
      g.value.endX = G.changedTouches[0].screenX, g.value.endY = G.changedTouches[0].screenY, te();
    }, Z = (G) => {
      r.vertical && !r.inline && G.preventDefault();
    }, te = () => {
      const G = r.vertical ? "Y" : "X";
      Math.abs(g.value[`start${G}`] - g.value[`end${G}`]) > 10 && n("handle-swipe", g.value[`start${G}`] > g.value[`end${G}`] ? "right" : "left");
    }, ce = (G, Q, y) => {
      G && (Array.isArray(d.value[Q]) ? d.value[Q][y] = G : d.value[Q] = [G]), r.arrowNavigation && i(d.value, "calendar");
    }, we = (G) => {
      r.monthChangeOnScroll && (G.preventDefault(), n("handle-scroll", G));
    };
    return t({ triggerTransition: w }), (G, Q) => {
      var y;
      return I(), W("div", {
        class: ze(j(O))
      }, [
        K("div", {
          style: ca(j(P))
        }, [
          e.specificMode ? ee("", !0) : (I(), W("div", {
            key: 0,
            ref_key: "calendarWrapRef",
            ref: f,
            class: ze(j(T)),
            role: "grid",
            "aria-label": (y = j(o).ariaLabels) == null ? void 0 : y.calendarWrap
          }, [
            K("div", LV, [
              G.weekNumbers ? (I(), W("div", RV, ke(G.weekNumName), 1)) : ee("", !0),
              (I(!0), W(Ge, null, Nt(j(v), (H, ie) => (I(), W("div", {
                class: "dp__calendar_header_item",
                role: "gridcell",
                key: ie,
                "data-test": "calendar-header"
              }, [
                G.$slots["calendar-header"] ? Ee(G.$slots, "calendar-header", {
                  key: 0,
                  day: H,
                  index: ie
                }) : ee("", !0),
                G.$slots["calendar-header"] ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                  Xt(ke(H), 1)
                ], 64))
              ]))), 128))
            ]),
            FV,
            Ae(Wo, {
              name: m.value,
              css: !!G.transitions
            }, {
              default: Ve(() => {
                var H;
                return [
                  p.value ? (I(), W("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "grid",
                    "aria-label": (H = j(o).ariaLabels) == null ? void 0 : H.calendarDays
                  }, [
                    (I(!0), W(Ge, null, Nt(e.mappedDates, (ie, ne) => (I(), W("div", {
                      class: "dp__calendar_row",
                      role: "row",
                      key: ne
                    }, [
                      G.weekNumbers ? (I(), W("div", VV, [
                        K("div", BV, ke(e.getWeekNum(ie.days)), 1)
                      ])) : ee("", !0),
                      (I(!0), W(Ge, null, Nt(ie.days, (J, me) => {
                        var xe, U, $;
                        return I(), W("div", {
                          role: "gridcell",
                          class: "dp__calendar_item",
                          ref_for: !0,
                          ref: (Y) => ce(Y, ne, me),
                          key: me + ne,
                          "aria-selected": J.classData.dp__active_date || J.classData.dp__range_start || J.classData.dp__range_start,
                          "aria-disabled": J.classData.dp__cell_disabled,
                          "aria-label": (U = (xe = j(o).ariaLabels) == null ? void 0 : xe.day) == null ? void 0 : U.call(xe, J),
                          tabindex: "0",
                          "data-test": J.value,
                          onClick: nr((Y) => G.$emit("select-date", J), ["stop", "prevent"]),
                          onKeydown: [
                            _t((Y) => G.$emit("select-date", J), ["enter"]),
                            _t((Y) => G.$emit("handle-space", J), ["space"])
                          ],
                          onMouseenter: (Y) => k(J, ne, me),
                          onMouseleave: (Y) => M(J)
                        }, [
                          K("div", {
                            class: ze(["dp__cell_inner", J.classData])
                          }, [
                            G.$slots.day && j(C)(J) ? Ee(G.$slots, "day", {
                              key: 0,
                              day: +J.text,
                              date: J.value
                            }) : ee("", !0),
                            G.$slots.day ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                              Xt(ke(J.text), 1)
                            ], 64)),
                            J.marker && j(C)(J) ? (I(), W("div", {
                              key: 2,
                              class: ze(j(S)(J.marker)),
                              style: ca(J.marker.color ? { backgroundColor: J.marker.color } : {})
                            }, null, 6)) : ee("", !0),
                            j(x)(J.value) ? (I(), W("div", {
                              key: 3,
                              class: "dp__marker_tooltip",
                              style: ca(u.value)
                            }, [
                              ($ = J.marker) != null && $.tooltip ? (I(), W("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: Q[0] || (Q[0] = nr(() => {
                                }, ["stop"]))
                              }, [
                                (I(!0), W(Ge, null, Nt(J.marker.tooltip, (Y, Re) => (I(), W("div", {
                                  key: Re,
                                  class: "dp__tooltip_text"
                                }, [
                                  G.$slots["marker-tooltip"] ? Ee(G.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: Y,
                                    day: J.value
                                  }) : ee("", !0),
                                  G.$slots["marker-tooltip"] ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                                    K("div", {
                                      class: "dp__tooltip_mark",
                                      style: ca(Y.color ? { backgroundColor: Y.color } : {})
                                    }, null, 4),
                                    K("div", null, ke(Y.text), 1)
                                  ], 64))
                                ]))), 128)),
                                WV
                              ])) : ee("", !0)
                            ], 4)) : ee("", !0)
                          ], 2)
                        ], 40, UV);
                      }), 128))
                    ]))), 128))
                  ], 8, $V)) : ee("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 10, NV))
        ], 4)
      ], 2);
    };
  }
}), jV = ["aria-label", "aria-disabled"], Lh = /* @__PURE__ */ Tt({
  __name: "ActionIcon",
  props: {
    ariaLabel: { type: String, default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const n = fe(null);
    return Mt(() => t("set-ref", n)), (r, i) => (I(), W("div", {
      class: "dp__month_year_col_nav",
      onClick: i[0] || (i[0] = (a) => r.$emit("activate")),
      onKeydown: [
        i[1] || (i[1] = _t((a) => r.$emit("activate"), ["enter"])),
        i[2] || (i[2] = _t((a) => r.$emit("activate"), ["space"]))
      ],
      tabindex: "0",
      role: "button",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled,
      ref_key: "elRef",
      ref: n
    }, [
      K("div", {
        class: ze(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        Ee(r.$slots, "default")
      ], 2)
    ], 40, jV));
  }
}), YV = ["onKeydown"], zV = { class: "dp__selection_grid_header" }, GV = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], qV = ["aria-label", "onKeydown"], Nl = /* @__PURE__ */ Tt({
  __name: "SelectionGrid",
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    multiModelValue: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: [Number, String], default: null },
    maxValue: { type: [Number, String], default: null },
    year: { type: Number, default: 0 },
    skipActive: { type: Boolean, default: !1 },
    headerRefs: { type: Array, default: () => [] },
    skipButtonRef: { type: Boolean, default: !1 },
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "selected", "toggle", "reset-flow"],
  setup(e, { expose: t, emit: n }) {
    const r = e, { setSelectionGrid: i, buildMultiLevelMatrix: a, setMonthPicker: o } = Ka(), { hideNavigationButtons: s } = Gr(r), u = fe(!1), d = fe(null), f = fe(null), p = fe([]), m = fe(), g = fe(null), v = fe(0), b = fe(null);
    nI(() => {
      d.value = null;
    }), Mt(() => {
      $a().then(() => N()), T(), w(!0);
    }), Bn(() => w(!1));
    const w = (Q) => {
      var y;
      r.arrowNavigation && ((y = r.headerRefs) != null && y.length ? o(Q) : i(Q));
    }, T = () => {
      const Q = Nn(f);
      Q && (r.textInput || Q.focus({ preventScroll: !0 }), u.value = Q.clientHeight < Q.scrollHeight);
    }, S = oe(
      () => ({
        dp__overlay: !0
      })
    ), x = oe(() => ({
      dp__overlay_col: !0
    })), O = (Q) => r.skipActive ? !1 : Q.value === r.modelValue, C = oe(() => r.items.map((Q) => Q.filter((y) => y).map((y) => {
      var H, ie, ne;
      const J = r.disabledValues.some((xe) => xe === y.value) || M(y.value), me = (H = r.multiModelValue) != null && H.length ? (ie = r.multiModelValue) == null ? void 0 : ie.some(
        (xe) => un(
          xe,
          Oo(
            r.monthPicker ? Il(/* @__PURE__ */ new Date(), y.value) : /* @__PURE__ */ new Date(),
            r.monthPicker ? r.year : y.value
          )
        )
      ) : O(y);
      return {
        ...y,
        className: {
          dp__overlay_cell_active: me,
          dp__overlay_cell: !me,
          dp__overlay_cell_disabled: J,
          dp__overlay_cell_active_disabled: J && me,
          dp__overlay_cell_pad: !0,
          dp__cell_in_between: (ne = r.multiModelValue) != null && ne.length ? Z(y.value) : !1
        }
      };
    }))), P = oe(
      () => ({
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: u.value,
        dp__button_bottom: r.autoApply
      })
    ), k = oe(() => {
      var Q, y;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((Q = r.items) == null ? void 0 : Q.length) <= 6,
        dp__container_block: ((y = r.items) == null ? void 0 : y.length) > 6
      };
    }), M = (Q) => {
      const y = r.maxValue || r.maxValue === 0, H = r.minValue || r.minValue === 0;
      return !y && !H ? !1 : y && H ? +Q > +r.maxValue || +Q < +r.minValue : y ? +Q > +r.maxValue : H ? +Q < +r.minValue : !1;
    }, N = () => {
      const Q = Nn(d), y = Nn(f), H = Nn(g), ie = Nn(b), ne = H ? H.getBoundingClientRect().height : 0;
      y && (v.value = y.getBoundingClientRect().height - ne), Q && ie && (ie.scrollTop = Q.offsetTop - ie.offsetTop - (v.value / 2 - Q.getBoundingClientRect().height) - ne);
    }, X = (Q) => {
      !r.disabledValues.some((y) => y === Q) && !M(Q) && (n("update:model-value", Q), n("selected"));
    }, Z = (Q) => {
      const y = r.monthPicker ? r.year : Q;
      return vE(
        r.multiModelValue,
        Oo(
          r.monthPicker ? Il(/* @__PURE__ */ new Date(), m.value || 0) : /* @__PURE__ */ new Date(),
          r.monthPicker ? y : m.value || y
        ),
        Oo(r.monthPicker ? Il(/* @__PURE__ */ new Date(), Q) : /* @__PURE__ */ new Date(), y)
      );
    }, te = () => {
      n("toggle"), n("reset-flow");
    }, ce = () => {
      r.escClose && te();
    }, we = (Q, y, H, ie) => {
      Q && (y.value === +r.modelValue && !r.disabledValues.includes(y.value) && (d.value = Q), r.arrowNavigation && (Array.isArray(p.value[H]) ? p.value[H][ie] = Q : p.value[H] = [Q], G()));
    }, G = () => {
      var Q, y;
      const H = (Q = r.headerRefs) != null && Q.length ? [r.headerRefs].concat(p.value) : p.value.concat([r.skipButtonRef ? [] : [g.value]]);
      a(Jn(H), (y = r.headerRefs) != null && y.length ? "monthPicker" : "selectionGrid");
    };
    return t({ focusGrid: T }), (Q, y) => {
      var H;
      return I(), W("div", {
        ref_key: "gridWrapRef",
        ref: f,
        class: ze(j(S)),
        role: "dialog",
        tabindex: "0",
        onKeydown: _t(ce, ["esc"])
      }, [
        K("div", {
          class: ze(j(k)),
          ref_key: "containerRef",
          ref: b,
          role: "grid",
          style: ca({ height: `${v.value}px` })
        }, [
          K("div", zV, [
            Ee(Q.$slots, "header")
          ]),
          Q.$slots.overlay ? Ee(Q.$slots, "overlay", { key: 0 }) : (I(!0), W(Ge, { key: 1 }, Nt(j(C), (ie, ne) => (I(), W("div", {
            class: "dp__overlay_row",
            key: ne,
            role: "row"
          }, [
            (I(!0), W(Ge, null, Nt(ie, (J, me) => (I(), W("div", {
              role: "gridcell",
              class: ze(j(x)),
              key: J.value,
              "aria-selected": J.value === e.modelValue && !e.disabledValues.includes(J.value),
              "aria-disabled": J.className.dp__overlay_cell_disabled,
              ref_for: !0,
              ref: (xe) => we(xe, J, ne, me),
              tabindex: "0",
              "data-test": J.text,
              onClick: (xe) => X(J.value),
              onKeydown: [
                _t((xe) => X(J.value), ["enter"]),
                _t((xe) => X(J.value), ["space"])
              ],
              onMouseover: (xe) => m.value = J.value
            }, [
              K("div", {
                class: ze(J.className)
              }, [
                Q.$slots.item ? Ee(Q.$slots, "item", {
                  key: 0,
                  item: J
                }) : ee("", !0),
                Q.$slots.item ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                  Xt(ke(J.text), 1)
                ], 64))
              ], 2)
            ], 42, GV))), 128))
          ]))), 128))
        ], 6),
        Q.$slots["button-icon"] ? Ni((I(), W("div", {
          key: 0,
          role: "button",
          "aria-label": (H = e.ariaLabels) == null ? void 0 : H.toggleOverlay,
          class: ze(j(P)),
          tabindex: "0",
          ref_key: "toggleButton",
          ref: g,
          onClick: te,
          onKeydown: _t(te, ["enter"])
        }, [
          Ee(Q.$slots, "button-icon")
        ], 42, qV)), [
          [Ol, !j(s)(e.type)]
        ]) : ee("", !0)
      ], 42, YV);
    };
  }
}), KV = ["aria-label"], Zy = /* @__PURE__ */ Tt({
  __name: "RegularPicker",
  props: {
    ariaLabel: { type: String, default: "" },
    showSelectionGrid: { type: Boolean, default: !1 },
    modelValue: { type: Number, default: null },
    items: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    slotName: { type: String, default: "" },
    overlaySlot: { type: String, default: "" },
    headerRefs: { type: Array, default: () => [] },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    transitions: { type: [Object, Boolean], default: !1 },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "toggle", "set-ref"],
  setup(e, { emit: t }) {
    const n = e, { transitionName: r, showTransition: i } = Md(n.transitions), a = fe(null);
    return Mt(() => t("set-ref", a)), (o, s) => (I(), W(Ge, null, [
      K("div", {
        class: "dp__month_year_select",
        onClick: s[0] || (s[0] = (u) => o.$emit("toggle")),
        onKeydown: [
          s[1] || (s[1] = _t((u) => o.$emit("toggle"), ["enter"])),
          s[2] || (s[2] = _t((u) => o.$emit("toggle"), ["space"]))
        ],
        role: "button",
        "aria-label": e.ariaLabel,
        tabindex: "0",
        ref_key: "elRef",
        ref: a
      }, [
        Ee(o.$slots, "default")
      ], 40, KV),
      Ae(Wo, {
        name: j(r)(e.showSelectionGrid),
        css: j(i)
      }, {
        default: Ve(() => [
          e.showSelectionGrid ? (I(), Oe(Nl, zn({ key: 0 }, {
            modelValue: e.modelValue,
            items: e.items,
            disabledValues: e.disabledValues,
            minValue: e.minValue,
            maxValue: e.maxValue,
            escClose: e.escClose,
            type: e.type,
            arrowNavigation: e.arrowNavigation,
            textInput: e.textInput,
            autoApply: e.autoApply,
            ariaLabels: e.ariaLabels,
            hideNavigation: e.hideNavigation
          }, {
            "header-refs": [],
            "onUpdate:modelValue": s[3] || (s[3] = (u) => o.$emit("update:model-value", u)),
            onToggle: s[4] || (s[4] = (u) => o.$emit("toggle"))
          }), Or({
            "button-icon": Ve(() => [
              o.$slots["calendar-icon"] ? Ee(o.$slots, "calendar-icon", { key: 0 }) : ee("", !0),
              o.$slots["calendar-icon"] ? ee("", !0) : (I(), Oe(j(Pd), { key: 1 }))
            ]),
            _: 2
          }, [
            o.$slots[e.slotName] ? {
              name: "item",
              fn: Ve(({ item: u }) => [
                Ee(o.$slots, e.slotName, { item: u })
              ]),
              key: "0"
            } : void 0,
            o.$slots[e.overlaySlot] ? {
              name: "overlay",
              fn: Ve(() => [
                Ee(o.$slots, e.overlaySlot)
              ]),
              key: "1"
            } : void 0,
            o.$slots[`${e.overlaySlot}-header`] ? {
              name: "header",
              fn: Ve(() => [
                Ee(o.$slots, `${e.overlaySlot}-header`)
              ]),
              key: "2"
            } : void 0
          ]), 1040)) : ee("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), XV = { class: "dp__month_year_row" }, ZV = { class: "dp__month_year_wrap" }, QV = { class: "dp__month_picker_header" }, JV = ["aria-label"], e4 = ["aria-label"], t4 = ["aria-label"], n4 = /* @__PURE__ */ Tt({
  __name: "MonthYearPicker",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    internalModelValue: { type: [Date, Array], default: null },
    ...Xa
  },
  emits: ["update-month-year", "month-year-select", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: n }) {
    const r = e, { defaults: i } = Gr(r), { transitionName: a, showTransition: o } = Md(i.value.transitions), { buildMatrix: s } = Ka(), { handleMonthYearChange: u, isDisabled: d, updateMonthYear: f } = bV(r, n), p = fe(!1), m = fe(!1), g = fe([null, null, null, null]), v = fe(null), b = fe(null), w = fe(null);
    Mt(() => {
      n("mount");
    });
    const T = ($) => ({
      get: () => r[$],
      set: (Y) => {
        const Re = $ === "month" ? "year" : "month";
        n("update-month-year", { [$]: Y, [Re]: r[Re] }), n("month-year-select", $ === "year"), $ === "month" ? ne(!0) : J(!0);
      }
    }), S = oe(T("month")), x = oe(T("year")), O = ($) => {
      const Y = sn(be($));
      return r.year === Y;
    }, C = oe(() => r.monthPicker ? Array.isArray(r.disabledDates) ? r.disabledDates.map(($) => be($)).filter(($) => O($)).map(($) => on($)) : [] : []), P = oe(() => ($) => {
      const Y = $ === "month";
      return {
        showSelectionGrid: (Y ? p : m).value,
        items: (Y ? Q : y).value,
        disabledValues: i.value.filters[Y ? "months" : "years"].concat(C.value),
        minValue: (Y ? X : M).value,
        maxValue: (Y ? Z : N).value,
        headerRefs: Y && r.monthPicker ? [v.value, b.value, w.value] : [],
        escClose: r.escClose,
        transitions: i.value.transitions,
        ariaLabels: i.value.ariaLabels,
        textInput: r.textInput,
        autoApply: r.autoApply,
        arrowNavigation: r.arrowNavigation,
        hideNavigation: r.hideNavigation
      };
    }), k = oe(() => ($) => ({
      month: r.month,
      year: r.year,
      items: $ === "month" ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: f,
      toggle: $ === "month" ? ne : J
    })), M = oe(() => r.minDate ? sn(be(r.minDate)) : null), N = oe(() => r.maxDate ? sn(be(r.maxDate)) : null), X = oe(() => {
      if (r.minDate && M.value) {
        if (M.value > r.year)
          return 12;
        if (M.value === r.year)
          return on(be(r.minDate));
      }
      return null;
    }), Z = oe(() => r.maxDate && N.value ? N.value < r.year ? -1 : N.value === r.year ? on(be(r.maxDate)) : null : null), te = oe(() => r.range && r.internalModelValue && (r.monthPicker || r.yearPicker) ? r.internalModelValue : []), ce = ($) => $.reverse(), we = ($, Y = !1) => {
      const Re = [], it = (He) => Y ? ce(He) : He;
      for (let He = 0; He < $.length; He += 3) {
        const Vt = [$[He], $[He + 1], $[He + 2]];
        Re.push(it(Vt));
      }
      return Y ? Re.reverse() : Re;
    }, G = oe(() => r.months.find((Y) => Y.value === r.month) || { text: "", value: 0 }), Q = oe(() => we(r.months)), y = oe(() => we(r.years, r.reverseYears)), H = oe(() => i.value.multiCalendars ? r.multiCalendarsSolo ? !0 : r.instance === 0 : !0), ie = oe(() => i.value.multiCalendars ? r.multiCalendarsSolo ? !0 : r.instance === i.value.multiCalendars - 1 : !0), ne = ($ = !1) => {
      me($), p.value = !p.value, p.value || n("overlay-closed");
    }, J = ($ = !1) => {
      me($), m.value = !m.value, m.value || n("overlay-closed");
    }, me = ($) => {
      $ || n("reset-flow");
    }, xe = ($ = !1) => {
      d.value($) || n("update-month-year", {
        year: $ ? r.year + 1 : r.year - 1,
        month: r.month,
        fromNav: !0
      });
    }, U = ($, Y) => {
      r.arrowNavigation && (g.value[Y] = Nn($), s(g.value, "monthYear"));
    };
    return t({
      toggleMonthPicker: ne,
      toggleYearPicker: J
    }), ($, Y) => {
      var Re, it, He, Vt, Bt;
      return I(), W("div", XV, [
        $.$slots["month-year"] ? Ee($.$slots, "month-year", Wr(zn({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: j(f), handleMonthYearChange: j(u), instance: e.instance }))) : (I(), W(Ge, { key: 1 }, [
          !$.monthPicker && !$.yearPicker ? (I(), W(Ge, { key: 0 }, [
            j(H) && !$.vertical ? (I(), Oe(Lh, {
              key: 0,
              "aria-label": (Re = j(i).ariaLabels) == null ? void 0 : Re.prevMonth,
              disabled: j(d)(!1),
              onActivate: Y[0] || (Y[0] = (Be) => j(u)(!1)),
              onSetRef: Y[1] || (Y[1] = (Be) => U(Be, 0))
            }, {
              default: Ve(() => [
                $.$slots["arrow-left"] ? Ee($.$slots, "arrow-left", { key: 0 }) : ee("", !0),
                $.$slots["arrow-left"] ? ee("", !0) : (I(), Oe(j(Ry), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : ee("", !0),
            K("div", ZV, [
              Ae(Zy, zn({
                type: "month",
                "slot-name": "month-overlay-val",
                "overlay-slot": "overlay-month",
                "aria-label": (it = j(i).ariaLabels) == null ? void 0 : it.openMonthsOverlay,
                modelValue: j(S),
                "onUpdate:modelValue": Y[2] || (Y[2] = (Be) => Si(S) ? S.value = Be : null)
              }, j(P)("month"), {
                onToggle: ne,
                onSetRef: Y[3] || (Y[3] = (Be) => U(Be, 1))
              }), Or({
                default: Ve(() => [
                  $.$slots.month ? Ee($.$slots, "month", Wr(zn({ key: 0 }, j(G)))) : ee("", !0),
                  $.$slots.month ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                    Xt(ke(j(G).text), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                $.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: Ve(() => [
                    Ee($.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                $.$slots["month-overlay-value"] ? {
                  name: "month-overlay-val",
                  fn: Ve(({ item: Be }) => [
                    Ee($.$slots, "month-overlay-value", {
                      text: Be.text,
                      value: Be.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                $.$slots["month-overlay"] ? {
                  name: "overlay-month",
                  fn: Ve(() => [
                    Ee($.$slots, "month-overlay", Wr(ua(j(k)("month"))))
                  ]),
                  key: "2"
                } : void 0,
                $.$slots["month-overlay-header"] ? {
                  name: "overlay-month-header",
                  fn: Ve(() => [
                    Ee($.$slots, "month-overlay-header", { toggle: ne })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"]),
              Ae(Zy, zn({
                type: "year",
                "slot-name": "year-overlay-val",
                "overlay-slot": "overlay-year",
                "aria-label": (He = j(i).ariaLabels) == null ? void 0 : He.openYearsOverlay,
                modelValue: j(x),
                "onUpdate:modelValue": Y[4] || (Y[4] = (Be) => Si(x) ? x.value = Be : null)
              }, j(P)("year"), {
                onToggle: J,
                onSetRef: Y[5] || (Y[5] = (Be) => U(Be, 2))
              }), Or({
                default: Ve(() => [
                  $.$slots.year ? Ee($.$slots, "year", {
                    key: 0,
                    year: e.year
                  }) : ee("", !0),
                  $.$slots.year ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                    Xt(ke(e.year), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                $.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: Ve(() => [
                    Ee($.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                $.$slots["year-overlay-value"] ? {
                  name: "year-overlay-val",
                  fn: Ve(({ item: Be }) => [
                    Ee($.$slots, "year-overlay-value", {
                      text: Be.text,
                      value: Be.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                $.$slots["year-overlay"] ? {
                  name: "overlay-year",
                  fn: Ve(() => [
                    Ee($.$slots, "year-overlay", Wr(ua(j(k)("year"))))
                  ]),
                  key: "2"
                } : void 0,
                $.$slots["year-overlay-header"] ? {
                  name: "overlay-year-header",
                  fn: Ve(() => [
                    Ee($.$slots, "year-overlay-header", { toggle: J })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"])
            ]),
            j(H) && $.vertical ? (I(), Oe(Lh, {
              key: 1,
              "aria-label": (Vt = j(i).ariaLabels) == null ? void 0 : Vt.prevMonth,
              disabled: j(d)(!1),
              onActivate: Y[6] || (Y[6] = (Be) => j(u)(!1))
            }, {
              default: Ve(() => [
                $.$slots["arrow-up"] ? Ee($.$slots, "arrow-up", { key: 0 }) : ee("", !0),
                $.$slots["arrow-up"] ? ee("", !0) : (I(), Oe(j(mE), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : ee("", !0),
            j(ie) ? (I(), Oe(Lh, {
              key: 2,
              ref: "rightIcon",
              disabled: j(d)(!0),
              "aria-label": (Bt = j(i).ariaLabels) == null ? void 0 : Bt.nextMonth,
              onActivate: Y[7] || (Y[7] = (Be) => j(u)(!0)),
              onSetRef: Y[8] || (Y[8] = (Be) => U(Be, 3))
            }, {
              default: Ve(() => [
                $.$slots[$.vertical ? "arrow-down" : "arrow-right"] ? Ee($.$slots, $.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : ee("", !0),
                $.$slots[$.vertical ? "arrow-down" : "arrow-right"] ? ee("", !0) : (I(), Oe(Sl($.vertical ? j(gE) : j(Fy)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label"])) : ee("", !0)
          ], 64)) : ee("", !0),
          $.monthPicker ? (I(), Oe(Nl, zn({ key: 1 }, j(P)("month"), {
            "skip-active": $.range,
            year: e.year,
            "multi-model-value": j(te),
            "month-picker": "",
            modelValue: j(S),
            "onUpdate:modelValue": Y[17] || (Y[17] = (Be) => Si(S) ? S.value = Be : null),
            onToggle: ne,
            onSelected: Y[18] || (Y[18] = (Be) => $.$emit("overlay-closed"))
          }), Or({
            header: Ve(() => {
              var Be, Xe, ue;
              return [
                K("div", QV, [
                  K("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpPrevIconRef",
                    ref: v,
                    onClick: Y[9] || (Y[9] = (Ce) => xe(!1)),
                    onKeydown: Y[10] || (Y[10] = _t((Ce) => xe(!1), ["enter"]))
                  }, [
                    K("div", {
                      class: ze(["dp__inner_nav", { dp__inner_nav_disabled: j(d)(!1) }]),
                      role: "button",
                      "aria-label": (Be = j(i).ariaLabels) == null ? void 0 : Be.prevMonth
                    }, [
                      $.$slots["arrow-left"] ? Ee($.$slots, "arrow-left", { key: 0 }) : ee("", !0),
                      $.$slots["arrow-left"] ? ee("", !0) : (I(), Oe(j(Ry), { key: 1 }))
                    ], 10, JV)
                  ], 544),
                  K("div", {
                    class: "dp__pointer",
                    role: "button",
                    ref_key: "mpYearButtonRef",
                    ref: b,
                    "aria-label": (Xe = j(i).ariaLabels) == null ? void 0 : Xe.openYearsOverlay,
                    tabindex: "0",
                    onClick: Y[11] || (Y[11] = () => J(!1)),
                    onKeydown: Y[12] || (Y[12] = _t(() => J(!1), ["enter"]))
                  }, [
                    $.$slots.year ? Ee($.$slots, "year", {
                      key: 0,
                      year: e.year
                    }) : ee("", !0),
                    $.$slots.year ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                      Xt(ke(e.year), 1)
                    ], 64))
                  ], 40, e4),
                  K("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpNextIconRef",
                    ref: w,
                    onClick: Y[13] || (Y[13] = (Ce) => xe(!0)),
                    onKeydown: Y[14] || (Y[14] = _t((Ce) => xe(!0), ["enter"]))
                  }, [
                    K("div", {
                      class: ze(["dp__inner_nav", { dp__inner_nav_disabled: j(d)(!0) }]),
                      role: "button",
                      "aria-label": (ue = j(i).ariaLabels) == null ? void 0 : ue.nextMonth
                    }, [
                      $.$slots["arrow-right"] ? Ee($.$slots, "arrow-right", { key: 0 }) : ee("", !0),
                      $.$slots["arrow-right"] ? ee("", !0) : (I(), Oe(j(Fy), { key: 1 }))
                    ], 10, t4)
                  ], 544)
                ]),
                Ae(Wo, {
                  name: j(a)(m.value),
                  css: j(o)
                }, {
                  default: Ve(() => [
                    m.value ? (I(), Oe(Nl, zn({ key: 0 }, j(P)("year"), {
                      modelValue: j(x),
                      "onUpdate:modelValue": Y[15] || (Y[15] = (Ce) => Si(x) ? x.value = Ce : null),
                      onToggle: J,
                      onSelected: Y[16] || (Y[16] = (Ce) => $.$emit("overlay-closed"))
                    }), Or({
                      "button-icon": Ve(() => [
                        $.$slots["calendar-icon"] ? Ee($.$slots, "calendar-icon", { key: 0 }) : ee("", !0),
                        $.$slots["calendar-icon"] ? ee("", !0) : (I(), Oe(j(Pd), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      $.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: Ve(({ item: Ce }) => [
                          Ee($.$slots, "year-overlay-value", {
                            text: Ce.text,
                            value: Ce.value
                          })
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1040, ["modelValue"])) : ee("", !0)
                  ]),
                  _: 3
                }, 8, ["name", "css"])
              ];
            }),
            _: 2
          }, [
            $.$slots["month-overlay-value"] ? {
              name: "item",
              fn: Ve(({ item: Be }) => [
                Ee($.$slots, "month-overlay-value", {
                  text: Be.text,
                  value: Be.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["skip-active", "year", "multi-model-value", "modelValue"])) : ee("", !0),
          $.yearPicker ? (I(), Oe(Nl, zn({ key: 2 }, j(P)("year"), {
            modelValue: j(x),
            "onUpdate:modelValue": Y[19] || (Y[19] = (Be) => Si(x) ? x.value = Be : null),
            "multi-model-value": j(te),
            "skip-active": $.range,
            "skip-button-ref": "",
            "year-picker": "",
            onToggle: J,
            onSelected: Y[20] || (Y[20] = (Be) => $.$emit("overlay-closed"))
          }), Or({ _: 2 }, [
            $.$slots["year-overlay-value"] ? {
              name: "item",
              fn: Ve(({ item: Be }) => [
                Ee($.$slots, "year-overlay-value", {
                  text: Be.text,
                  value: Be.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue", "multi-model-value", "skip-active"])) : ee("", !0)
        ], 64))
      ]);
    };
  }
}), r4 = {
  key: 0,
  class: "dp__time_input"
}, i4 = ["aria-label", "onKeydown", "onClick"], a4 = ["aria-label", "data-test", "onKeydown", "onClick"], o4 = ["aria-label", "onKeydown", "onClick"], s4 = { key: 0 }, l4 = ["aria-label", "onKeydown"], u4 = /* @__PURE__ */ Tt({
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    ...Xa
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { setTimePickerElements: i, setTimePickerBackRef: a } = Ka(), { defaults: o } = Gr(r), { transitionName: s, showTransition: u } = Md(o.value.transitions), d = Uo({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), f = fe("AM"), p = fe(null), m = fe([]);
    Mt(() => {
      n("mounted");
    });
    const g = oe(() => (y) => !!(r.maxTime && r.maxTime[y] && r.maxTime[y] < r[y] + +r[`${y}Increment`])), v = oe(() => (y) => !!(r.minTime && r.minTime[y] && r.minTime[y] > r[y] - +r[`${y}Increment`])), b = (y, H) => jx(mr(be(), y), H), w = (y, H) => H$(mr(be(), y), H), T = oe(
      () => ({
        dp__time_col: !0,
        dp__time_col_reg: !r.enableSeconds && r.is24,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), S = oe(() => {
      const y = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return r.enableSeconds ? y.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : y;
    }), x = oe(() => S.value.filter((y) => !y.separator)), O = oe(() => (y) => {
      if (y === "hours") {
        const H = te(r.hours);
        return { text: H < 10 ? `0${H}` : `${H}`, value: H };
      }
      return { text: r[y] < 10 ? `0${r[y]}` : `${r[y]}`, value: r[y] };
    }), C = (y) => {
      const H = r.is24 ? 24 : 12, ie = y === "hours" ? H : 60, ne = +r[`${y}GridIncrement`], J = y === "hours" && !r.is24 ? ne : 0, me = [];
      for (let xe = J; xe < ie; xe += ne)
        me.push({ value: xe, text: xe < 10 ? `0${xe}` : `${xe}` });
      return y === "hours" && !r.is24 && me.push({ value: 0, text: "12" }), oV(me);
    }, P = (y, H) => {
      const ie = r.minTime && r.minTime[H], ne = r.maxTime && r.maxTime[H];
      return ie && ne ? y < ie || y > ne : ie ? y < ie : ne ? y > ne : !1;
    }, k = oe(() => (y) => C(y).flat().map((H) => H.value).filter((H) => P(H, y))), M = (y) => r[`no${y[0].toUpperCase() + y.slice(1)}Overlay`], N = (y) => {
      M(y) || (d[y] = !d[y], d[y] || n("overlay-closed"));
    }, X = (y) => y === "hours" ? oa : y === "minutes" ? sa : Ss, Z = (y, H = !0) => {
      const ie = H ? b : w;
      (H ? g.value(y) : v.value(y)) || n(
        `update:${y}`,
        X(y)(ie({ [y]: +r[y] }, { [y]: +r[`${y}Increment`] }))
      );
    }, te = (y) => r.is24 ? y : (y >= 12 ? f.value = "PM" : f.value = "AM", cV(y)), ce = () => {
      f.value === "PM" ? (f.value = "AM", n("update:hours", r.hours - 12)) : (f.value = "PM", n("update:hours", r.hours + 12));
    }, we = (y) => {
      d[y] = !0;
    }, G = (y, H, ie) => {
      if (y && r.arrowNavigation) {
        Array.isArray(m.value[H]) ? m.value[H][ie] = y : m.value[H] = [y];
        const ne = m.value.reduce(
          (J, me) => me.map((xe, U) => [...J[U] || [], me[U]]),
          []
        );
        a(r.closeTimePickerBtn), p.value && (ne[1] = ne[1].concat(p.value)), i(ne, r.order);
      }
    }, Q = (y, H) => y === "hours" && !r.is24 ? n(`update:${y}`, f.value === "PM" ? H + 12 : H) : n(`update:${y}`, H);
    return t({ openChildCmp: we }), (y, H) => {
      var ie;
      return y.disabled ? ee("", !0) : (I(), W("div", r4, [
        (I(!0), W(Ge, null, Nt(j(S), (ne, J) => {
          var me, xe, U;
          return I(), W("div", {
            key: J,
            class: ze(j(T))
          }, [
            ne.separator ? (I(), W(Ge, { key: 0 }, [
              Xt(" : ")
            ], 64)) : (I(), W(Ge, { key: 1 }, [
              K("div", {
                class: ze({
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: j(g)(ne.type)
                }),
                role: "button",
                "data-test": "time-inc-btn",
                "aria-label": (me = j(o).ariaLabels) == null ? void 0 : me.incrementValue(ne.type),
                tabindex: "0",
                onKeydown: [
                  _t(($) => Z(ne.type), ["enter"]),
                  _t(($) => Z(ne.type), ["space"])
                ],
                onClick: ($) => Z(ne.type),
                ref_for: !0,
                ref: ($) => G($, J, 0)
              }, [
                y.$slots["arrow-up"] ? Ee(y.$slots, "arrow-up", { key: 0 }) : ee("", !0),
                y.$slots["arrow-up"] ? ee("", !0) : (I(), Oe(j(mE), { key: 1 }))
              ], 42, i4),
              K("div", {
                role: "button",
                "aria-label": (xe = j(o).ariaLabels) == null ? void 0 : xe.openTpOverlay(ne.type),
                class: ze(M(ne.type) ? "" : "dp__time_display"),
                tabindex: "0",
                "data-test": `${ne.type}-toggle-overlay-btn`,
                onKeydown: [
                  _t(($) => N(ne.type), ["enter"]),
                  _t(($) => N(ne.type), ["space"])
                ],
                onClick: ($) => N(ne.type),
                ref_for: !0,
                ref: ($) => G($, J, 1)
              }, [
                y.$slots[ne.type] ? Ee(y.$slots, ne.type, {
                  key: 0,
                  text: j(O)(ne.type).text,
                  value: j(O)(ne.type).value
                }) : ee("", !0),
                y.$slots[ne.type] ? ee("", !0) : (I(), W(Ge, { key: 1 }, [
                  Xt(ke(j(O)(ne.type).text), 1)
                ], 64))
              ], 42, a4),
              K("div", {
                class: ze({
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: j(v)(ne.type)
                }),
                role: "button",
                "data-test": "time-dec-btn",
                "aria-label": (U = j(o).ariaLabels) == null ? void 0 : U.decrementValue(ne.type),
                tabindex: "0",
                onKeydown: [
                  _t(($) => Z(ne.type, !1), ["enter"]),
                  _t(($) => Z(ne.type, !1), ["space"])
                ],
                onClick: ($) => Z(ne.type, !1),
                ref_for: !0,
                ref: ($) => G($, J, 2)
              }, [
                y.$slots["arrow-down"] ? Ee(y.$slots, "arrow-down", { key: 0 }) : ee("", !0),
                y.$slots["arrow-down"] ? ee("", !0) : (I(), Oe(j(gE), { key: 1 }))
              ], 42, o4)
            ], 64))
          ], 2);
        }), 128)),
        y.is24 ? ee("", !0) : (I(), W("div", s4, [
          y.$slots["am-pm-button"] ? Ee(y.$slots, "am-pm-button", {
            key: 0,
            toggle: ce,
            value: f.value
          }) : ee("", !0),
          y.$slots["am-pm-button"] ? ee("", !0) : (I(), W("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: p,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (ie = j(o).ariaLabels) == null ? void 0 : ie.amPmButton,
            tabindex: "0",
            onClick: ce,
            onKeydown: [
              _t(nr(ce, ["prevent"]), ["enter"]),
              _t(nr(ce, ["prevent"]), ["space"])
            ]
          }, ke(f.value), 41, l4))
        ])),
        (I(!0), W(Ge, null, Nt(j(x), (ne, J) => (I(), Oe(Wo, {
          key: J,
          name: j(s)(d[ne.type]),
          css: j(u)
        }, {
          default: Ve(() => [
            d[ne.type] ? (I(), Oe(Nl, {
              key: 0,
              items: C(ne.type),
              "disabled-values": j(o).filters.times[ne.type].concat(j(k)(ne.type)),
              "esc-close": y.escClose,
              "aria-labels": j(o).ariaLabels,
              "hide-navigation": y.hideNavigation,
              "onUpdate:modelValue": (me) => Q(ne.type, me),
              onSelected: (me) => N(ne.type),
              onToggle: (me) => N(ne.type),
              onResetFlow: H[0] || (H[0] = (me) => y.$emit("reset-flow")),
              type: ne.type
            }, Or({
              "button-icon": Ve(() => [
                y.$slots["clock-icon"] ? Ee(y.$slots, "clock-icon", { key: 0 }) : ee("", !0),
                y.$slots["clock-icon"] ? ee("", !0) : (I(), Oe(j(pE), { key: 1 }))
              ]),
              _: 2
            }, [
              y.$slots[`${ne.type}-overlay-value`] ? {
                name: "item",
                fn: Ve(({ item: me }) => [
                  Ee(y.$slots, `${ne.type}-overlay-value`, {
                    text: me.text,
                    value: me.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "disabled-values", "esc-close", "aria-labels", "hide-navigation", "onUpdate:modelValue", "onSelected", "onToggle", "type"])) : ee("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), c4 = ["aria-label"], d4 = { class: "dp__overlay_container dp__container_flex dp__time_picker_overlay_container" }, f4 = {
  key: 1,
  class: "dp__overlay_row"
}, h4 = ["aria-label"], p4 = /* @__PURE__ */ Tt({
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    internalModelValue: { type: [Date, Array], default: null },
    ...Xa
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-closed"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { buildMatrix: i, setTimePicker: a } = Ka(), o = fm(), { hideNavigationButtons: s, defaults: u } = Gr(r), { transitionName: d, showTransition: f } = Md(u.value.transitions), p = fe(null), m = fe(null), g = fe([]), v = fe(null);
    Mt(() => {
      n("mount"), !r.timePicker && r.arrowNavigation ? i([Nn(p.value)], "time") : a(!0, r.timePicker);
    });
    const b = oe(() => r.range && r.modelAuto ? wE(r.internalModelValue) : !0), w = fe(!1), T = (Z) => ({
      hours: Array.isArray(r.hours) ? r.hours[Z] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[Z] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[Z] : r.seconds
    }), S = oe(() => {
      const Z = [];
      if (r.range)
        for (let te = 0; te < 2; te++)
          Z.push(T(te));
      else
        Z.push(T(0));
      return Z;
    }), x = (Z, te = !1, ce = "") => {
      te || n("reset-flow"), w.value = Z, r.arrowNavigation && (a(Z), Z || n("overlay-closed")), $a(() => {
        ce !== "" && g.value[0] && g.value[0].openChildCmp(ce);
      });
    }, O = oe(() => ({
      dp__button: !0,
      dp__button_bottom: r.autoApply
    })), C = To(o, "timePicker"), P = (Z, te, ce) => r.range ? te === 0 ? [Z, S.value[1][ce]] : [S.value[0][ce], Z] : Z, k = (Z) => {
      n("update:hours", Z);
    }, M = (Z) => {
      n("update:minutes", Z);
    }, N = (Z) => {
      n("update:seconds", Z);
    }, X = () => {
      v.value && r.arrowNavigation && v.value.focus({ preventScroll: !0 });
    };
    return t({ toggleTimePicker: x }), (Z, te) => {
      var ce;
      return I(), W("div", null, [
        Z.timePicker ? ee("", !0) : Ni((I(), W("div", {
          key: 0,
          class: ze(j(O)),
          role: "button",
          "aria-label": (ce = j(u).ariaLabels) == null ? void 0 : ce.openTimePicker,
          tabindex: "0",
          "data-test": "open-time-picker-btn",
          ref_key: "openTimePickerBtn",
          ref: p,
          onKeydown: [
            te[0] || (te[0] = _t((we) => x(!0), ["enter"])),
            te[1] || (te[1] = _t((we) => x(!0), ["space"]))
          ],
          onClick: te[2] || (te[2] = (we) => x(!0))
        }, [
          Z.$slots["clock-icon"] ? Ee(Z.$slots, "clock-icon", { key: 0 }) : ee("", !0),
          Z.$slots["clock-icon"] ? ee("", !0) : (I(), Oe(j(pE), { key: 1 }))
        ], 42, c4)), [
          [Ol, !j(s)("time")]
        ]),
        Ae(Wo, {
          name: j(d)(w.value),
          css: j(f)
        }, {
          default: Ve(() => {
            var we;
            return [
              w.value || Z.timePicker ? (I(), W("div", {
                key: 0,
                class: "dp__overlay",
                ref_key: "overlayRef",
                ref: v,
                tabindex: "0"
              }, [
                K("div", d4, [
                  Z.$slots["time-picker-overlay"] ? Ee(Z.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: k,
                    setMinutes: M,
                    setSeconds: N
                  }) : ee("", !0),
                  Z.$slots["time-picker-overlay"] ? ee("", !0) : (I(), W("div", f4, [
                    (I(!0), W(Ge, null, Nt(j(S), (G, Q) => Ni((I(), Oe(u4, zn({ key: Q }, {
                      ...Z.$props,
                      order: Q,
                      hours: G.hours,
                      minutes: G.minutes,
                      seconds: G.seconds,
                      closeTimePickerBtn: m.value,
                      disabled: Q === 0 ? Z.fixedStart : Z.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: g,
                      "onUpdate:hours": (y) => k(P(y, Q, "hours")),
                      "onUpdate:minutes": (y) => M(P(y, Q, "minutes")),
                      "onUpdate:seconds": (y) => N(P(y, Q, "seconds")),
                      onMounted: X,
                      onOverlayClosed: X
                    }), Or({ _: 2 }, [
                      Nt(j(C), (y, H) => ({
                        name: y,
                        fn: Ve((ie) => [
                          Ee(Z.$slots, y, Wr(ua(ie)))
                        ])
                      }))
                    ]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Ol, Q === 0 ? !0 : j(b)]
                    ])), 128))
                  ])),
                  Z.timePicker ? ee("", !0) : Ni((I(), W("div", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: m,
                    class: ze(j(O)),
                    role: "button",
                    "aria-label": (we = j(u).ariaLabels) == null ? void 0 : we.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      te[3] || (te[3] = _t((G) => x(!1), ["enter"])),
                      te[4] || (te[4] = _t((G) => x(!1), ["space"]))
                    ],
                    onClick: te[5] || (te[5] = (G) => x(!1))
                  }, [
                    Z.$slots["calendar-icon"] ? Ee(Z.$slots, "calendar-icon", { key: 0 }) : ee("", !0),
                    Z.$slots["calendar-icon"] ? ee("", !0) : (I(), Oe(j(Pd), { key: 1 }))
                  ], 42, h4)), [
                    [Ol, !j(s)("time")]
                  ])
                ])
              ], 512)) : ee("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), m4 = (e, t) => {
  const { isDisabled: n, matchDate: r, getWeekFromDate: i } = Gr(t), a = fe(null), o = fe(be()), s = (y) => {
    !y.current && t.hideOffsetDates || (a.value = y.value);
  }, u = () => {
    a.value = null;
  }, d = (y) => Array.isArray(e.value) && t.range && e.value[0] && a.value ? y ? vr(a.value, e.value[0]) : rr(a.value, e.value[0]) : !0, f = (y, H) => {
    const ie = () => e.value ? H ? e.value[0] || null : e.value[1] : null, ne = e.value && Array.isArray(e.value) ? ie() : null;
    return un(be(y.value), ne);
  }, p = (y) => {
    const H = Array.isArray(e.value) ? e.value[0] : null;
    return y ? !rr(a.value || null, H) : !0;
  }, m = (y, H = !0) => (t.range || t.weekPicker) && Array.isArray(e.value) ? t.hideOffsetDates && !y.current ? !1 : un(be(y.value), e.value[H ? 0 : 1]) : t.range ? f(y, H) && p(H) || un(y.value, Array.isArray(e.value) ? e.value[0] : null) && d(H) : !1, g = (y, H, ie) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? y ? !1 : ie ? vr(e.value[0], H.value) : rr(e.value[0], H.value) : !1, v = (y) => !e.value || t.hideOffsetDates && !y.current ? !1 : t.range ? t.modelAuto && Array.isArray(e.value) ? un(y.value, e.value[0] ? e.value[0] : o.value) : !1 : t.multiDates && Array.isArray(e.value) ? e.value.some((H) => un(H, y.value)) : un(y.value, e.value ? e.value : o.value), b = (y) => {
    if (t.autoRange || t.weekPicker) {
      if (a.value) {
        if (t.hideOffsetDates && !y.current)
          return !1;
        const H = pa(a.value, +t.autoRange), ie = i(be(a.value));
        return t.weekPicker ? un(ie[1], be(y.value)) : un(H, be(y.value));
      }
      return !1;
    }
    return !1;
  }, w = (y) => {
    if (t.autoRange || t.weekPicker) {
      if (a.value) {
        const H = pa(a.value, +t.autoRange);
        if (t.hideOffsetDates && !y.current)
          return !1;
        const ie = i(be(a.value));
        return t.weekPicker ? vr(y.value, ie[0]) && rr(y.value, ie[1]) : vr(y.value, a.value) && rr(y.value, H);
      }
      return !1;
    }
    return !1;
  }, T = (y) => {
    if (t.autoRange || t.weekPicker) {
      if (a.value) {
        if (t.hideOffsetDates && !y.current)
          return !1;
        const H = i(be(a.value));
        return t.weekPicker ? un(H[0], y.value) : un(a.value, y.value);
      }
      return !1;
    }
    return !1;
  }, S = (y) => vE(e.value, a.value, y.value), x = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, O = () => t.modelAuto ? wE(t.internalModelValue) : !0, C = (y) => {
    if (Array.isArray(e.value) && e.value.length || t.weekPicker)
      return !1;
    const H = t.range ? !m(y) && !m(y, !1) : !0;
    return !n(y.value) && !v(y) && !(!y.current && t.hideOffsetDates) && H;
  }, P = (y) => t.range ? t.modelAuto ? x() && v(y) : !1 : v(y), k = (y) => t.highlight ? r(y.value, t.highlight) : !1, M = (y) => n(y.value) && t.highlightDisabledDays === !1, N = (y) => t.highlightWeekDays && t.highlightWeekDays.includes(y.value.getDay()), X = (y) => (t.range || t.weekPicker) && (!(t.multiCalendars > 0) || y.current) && O() && !(!y.current && t.hideOffsetDates) && !v(y) ? S(y) : !1, Z = (y) => ({
    dp__cell_offset: !y.current,
    dp__pointer: !t.disabled && !(!y.current && t.hideOffsetDates) && !n(y.value),
    dp__cell_disabled: n(y.value),
    dp__cell_highlight: !M(y) && (k(y) || N(y)) && !P(y),
    dp__cell_highlight_active: !M(y) && (k(y) || N(y)) && P(y),
    dp__today: !t.noToday && un(y.value, o.value) && y.current
  }), te = (y) => ({
    dp__active_date: P(y),
    dp__date_hover: C(y)
  }), ce = (y) => ({
    ...we(y),
    ...G(y),
    dp__range_between_week: X(y) && t.weekPicker
  }), we = (y) => ({
    dp__range_start: t.multiCalendars > 0 ? y.current && m(y) && O() : m(y) && O(),
    dp__range_end: t.multiCalendars > 0 ? y.current && m(y, !1) && O() : m(y, !1) && O(),
    dp__range_between: X(y) && !t.weekPicker,
    dp__date_hover_start: g(C(y), y, !0),
    dp__date_hover_end: g(C(y), y, !1)
  }), G = (y) => ({
    ...we(y),
    dp__cell_auto_range: w(y),
    dp__cell_auto_range_start: T(y),
    dp__cell_auto_range_end: b(y)
  }), Q = (y) => t.range ? t.autoRange ? G(y) : t.modelAuto ? { ...te(y), ...we(y) } : we(y) : t.weekPicker ? ce(y) : te(y);
  return {
    setHoverDate: s,
    clearHoverDate: u,
    getDayClassData: (y) => ({
      ...Z(y),
      ...Q(y),
      [t.dayClass ? t.dayClass(y.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    })
  };
}, g4 = ["id", "onKeydown"], v4 = {
  key: 0,
  class: "dp__sidebar_left"
}, _4 = {
  key: 1,
  class: "dp__preset_ranges"
}, y4 = ["onClick"], b4 = {
  key: 2,
  class: "dp__sidebar_right"
}, w4 = {
  key: 3,
  class: "dp__now_wrap"
}, x4 = /* @__PURE__ */ Tt({
  __name: "DatepickerMenu",
  props: {
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    ...Xa
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { setMenuFocused: i, setShiftKey: a, control: o } = _E(), { getCalendarDays: s, defaults: u } = Gr(r), d = fm(), f = fe(null), p = Uo({
      timePicker: !!(!r.enableTimePicker || r.timePicker || r.monthPicker),
      monthYearInput: !!r.timePicker,
      calendar: !1
    }), m = fe([]), g = fe([]), v = fe(null), b = fe(null), w = fe(0), T = fe(!1), S = fe(0);
    Mt(() => {
      var de;
      T.value = !0, !((de = r.presetRanges) != null && de.length) && !d["left-sidebar"] && !d["right-sidebar"] && qt();
      const Ne = Nn(b);
      if (Ne && !r.textInput && !r.inline && (i(!0), M()), Ne) {
        const Wn = (Xn) => {
          !r.monthYearComponent && !r.timePickerComponent && !Object.keys(d).length && Xn.preventDefault(), Xn.stopImmediatePropagation(), Xn.stopPropagation();
        };
        Ne.addEventListener("pointerdown", Wn), Ne.addEventListener("mousedown", Wn);
      }
      window.addEventListener("resize", qt);
    }), Bn(() => {
      window.removeEventListener("resize", qt);
    });
    const { arrowRight: x, arrowLeft: O, arrowDown: C, arrowUp: P } = Ka(), k = (de) => {
      de || de === 0 ? g.value[de].triggerTransition(
        ce.value(de),
        we.value(de)
      ) : g.value.forEach(
        (Ne, Wn) => Ne.triggerTransition(ce.value(Wn), we.value(Wn))
      );
    }, M = () => {
      const de = Nn(b);
      de && de.focus({ preventScroll: !0 });
    }, N = () => {
      var de;
      (de = r.flow) != null && de.length && S.value !== -1 && (S.value += 1, n("flow-step", S.value), gt());
    }, X = () => {
      S.value = -1;
    }, {
      calendars: Z,
      modelValue: te,
      month: ce,
      year: we,
      time: G,
      updateTime: Q,
      updateMonthYear: y,
      selectDate: H,
      getWeekNum: ie,
      monthYearSelect: ne,
      handleScroll: J,
      handleArrow: me,
      handleSwipe: xe,
      getMarker: U,
      selectCurrentDate: $,
      presetDateRange: Y
    } = _V(r, n, N, k, S), { setHoverDate: Re, clearHoverDate: it, getDayClassData: He } = m4(te, r);
    dn(
      Z,
      () => {
        r.openOnTop && setTimeout(() => {
          n("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const Vt = To(d, "calendar"), Bt = To(d, "action"), Be = To(d, "timePicker"), Xe = To(d, "monthYear"), ue = oe(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), Ce = oe(() => lV(r.yearRange)), Pr = oe(() => uV(r.locale, r.monthNameFormat)), qt = () => {
      const de = Nn(f);
      de && (w.value = de.getBoundingClientRect().width);
    }, yr = oe(() => (de) => s(ce.value(de), we.value(de))), Mr = oe(
      () => u.value.multiCalendars > 0 && r.range ? [...Array(u.value.multiCalendars).keys()] : [0]
    ), R = oe(
      () => (de) => de === 1
    ), V = oe(() => r.monthPicker || r.timePicker || r.yearPicker), ge = oe(
      () => ({
        dp__flex_display: u.value.multiCalendars > 0
      })
    ), Fe = oe(() => ({
      dp__instance_calendar: u.value.multiCalendars > 0
    })), Pt = oe(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly
    })), mt = oe(
      () => (de) => ae(yr, de)
    ), wt = oe(
      () => ({
        dp__menu: !0,
        dp__menu_index: !r.inline,
        dp__relative: r.inline,
        [r.menuClassName]: !!r.menuClassName
      })
    ), ae = (de, Ne) => de.value(Ne).map((Wn) => ({
      ...Wn,
      days: Wn.days.map((Xn) => (Xn.marker = U(Xn), Xn.classData = He(Xn), Xn))
    })), _e = (de) => {
      de.stopPropagation(), de.stopImmediatePropagation();
    }, F = () => {
      r.escClose && n("close-picker");
    }, se = (de, Ne = !1) => {
      H(de, Ne), r.spaceConfirm && n("select-date");
    }, Pe = (de) => {
      var Ne;
      (Ne = r.flow) != null && Ne.length && (p[de] = !0, Object.keys(p).filter((Wn) => !p[Wn]).length || gt());
    }, Ye = (de, Ne, Wn, Xn, ...Ko) => {
      if (r.flow[S.value] === de) {
        const qe = Xn ? Ne.value[0] : Ne.value;
        qe && qe[Wn](...Ko);
      }
    }, gt = () => {
      Ye("month", m, "toggleMonthPicker", !0, !0), Ye("year", m, "toggleYearPicker", !0, !0), Ye("calendar", v, "toggleTimePicker", !1, !1, !0), Ye("time", v, "toggleTimePicker", !1, !0, !0);
      const de = r.flow[S.value];
      (de === "hours" || de === "minutes" || de === "seconds") && Ye(de, v, "toggleTimePicker", !1, !0, !0, de);
    }, mn = (de) => {
      if (r.arrowNavigation) {
        if (de === "up")
          return P();
        if (de === "down")
          return C();
        if (de === "left")
          return O();
        if (de === "right")
          return x();
      } else
        de === "left" || de === "up" ? me("left", 0, de === "up") : me("right", 0, de === "down");
    }, Ir = (de) => {
      a(de.shiftKey), !r.disableMonthYearSelect && de.code === "Tab" && de.target.classList.contains("dp__menu") && o.value.shiftKeyInMenu && (de.preventDefault(), de.stopImmediatePropagation(), n("close-picker"));
    };
    return t({
      updateMonthYear: y
    }), (de, Ne) => {
      var Wn;
      return I(), Oe(Wo, {
        appear: "",
        name: (Wn = j(u).transitions) == null ? void 0 : Wn.menuAppear,
        mode: "out-in",
        css: !!de.transitions
      }, {
        default: Ve(() => {
          var Xn, Ko;
          return [
            K("div", {
              id: de.uid ? `dp-menu-${de.uid}` : void 0,
              tabindex: "0",
              ref_key: "dpMenuRef",
              ref: b,
              role: "dialog",
              class: ze(j(wt)),
              onMouseleave: Ne[14] || (Ne[14] = //@ts-ignore
              (...qe) => j(it) && j(it)(...qe)),
              onClick: _e,
              onKeydown: [
                _t(F, ["esc"]),
                Ne[15] || (Ne[15] = _t(nr((qe) => mn("left"), ["prevent"]), ["left"])),
                Ne[16] || (Ne[16] = _t(nr((qe) => mn("up"), ["prevent"]), ["up"])),
                Ne[17] || (Ne[17] = _t(nr((qe) => mn("down"), ["prevent"]), ["down"])),
                Ne[18] || (Ne[18] = _t(nr((qe) => mn("right"), ["prevent"]), ["right"])),
                Ir
              ]
            }, [
              (de.disabled || de.readonly) && de.inline ? (I(), W("div", {
                key: 0,
                class: ze(j(Pt))
              }, null, 2)) : ee("", !0),
              !de.inline && !de.teleportCenter ? (I(), W("div", {
                key: 1,
                class: ze(j(ue))
              }, null, 2)) : ee("", !0),
              K("div", {
                class: ze({
                  dp__menu_content_wrapper: ((Xn = de.presetRanges) == null ? void 0 : Xn.length) || !!de.$slots["left-sidebar"] || !!de.$slots["right-sidebar"]
                })
              }, [
                de.$slots["left-sidebar"] ? (I(), W("div", v4, [
                  Ee(de.$slots, "left-sidebar")
                ])) : ee("", !0),
                (Ko = de.presetRanges) != null && Ko.length ? (I(), W("div", _4, [
                  (I(!0), W(Ge, null, Nt(de.presetRanges, (qe, Wi) => (I(), W("div", {
                    key: Wi,
                    style: ca(qe.style || {}),
                    class: "dp__preset_range",
                    onClick: (ft) => j(Y)(qe.range, !!qe.slot)
                  }, [
                    qe.slot ? Ee(de.$slots, qe.slot, {
                      key: 0,
                      presetDateRange: j(Y),
                      label: qe.label,
                      range: qe.range
                    }) : (I(), W(Ge, { key: 1 }, [
                      Xt(ke(qe.label), 1)
                    ], 64))
                  ], 12, y4))), 128))
                ])) : ee("", !0),
                K("div", {
                  class: "dp__instance_calendar",
                  ref_key: "calendarWrapperRef",
                  ref: f,
                  role: "document"
                }, [
                  K("div", {
                    class: ze(j(ge))
                  }, [
                    (I(!0), W(Ge, null, Nt(j(Mr), (qe, Wi) => (I(), W("div", {
                      key: qe,
                      class: ze(j(Fe))
                    }, [
                      !de.disableMonthYearSelect && !de.timePicker ? (I(), Oe(Sl(de.monthYearComponent ? de.monthYearComponent : n4), zn({
                        key: 0,
                        ref_for: !0,
                        ref: (ft) => {
                          ft && (m.value[Wi] = ft);
                        },
                        months: j(Pr),
                        years: j(Ce),
                        month: j(ce)(qe),
                        year: j(we)(qe),
                        instance: qe,
                        "internal-model-value": e.internalModelValue
                      }, de.$props, {
                        onMount: Ne[0] || (Ne[0] = (ft) => Pe("monthYearInput")),
                        onResetFlow: X,
                        onUpdateMonthYear: (ft) => j(y)(qe, ft),
                        onMonthYearSelect: j(ne),
                        onOverlayClosed: M
                      }), Or({ _: 2 }, [
                        Nt(j(Xe), (ft, uf) => ({
                          name: ft,
                          fn: Ve((Ys) => [
                            Ee(de.$slots, ft, Wr(ua(Ys)))
                          ])
                        }))
                      ]), 1040, ["months", "years", "month", "year", "instance", "internal-model-value", "onUpdateMonthYear", "onMonthYearSelect"])) : ee("", !0),
                      Ae(HV, zn({
                        ref_for: !0,
                        ref: (ft) => {
                          ft && (g.value[Wi] = ft);
                        },
                        "specific-mode": j(V),
                        "get-week-num": j(ie),
                        instance: qe,
                        "mapped-dates": j(mt)(qe),
                        month: j(ce)(qe),
                        year: j(we)(qe)
                      }, de.$props, {
                        "flow-step": S.value,
                        "onUpdate:flowStep": Ne[1] || (Ne[1] = (ft) => S.value = ft),
                        onSelectDate: (ft) => j(H)(ft, !j(R)(qe)),
                        onHandleSpace: (ft) => se(ft, !j(R)(qe)),
                        onSetHoverDate: Ne[2] || (Ne[2] = (ft) => j(Re)(ft)),
                        onHandleScroll: (ft) => j(J)(ft, qe),
                        onHandleSwipe: (ft) => j(xe)(ft, qe),
                        onMount: Ne[3] || (Ne[3] = (ft) => Pe("calendar")),
                        onResetFlow: X,
                        onTooltipOpen: Ne[4] || (Ne[4] = (ft) => de.$emit("tooltip-open", ft)),
                        onTooltipClose: Ne[5] || (Ne[5] = (ft) => de.$emit("tooltip-close", ft))
                      }), Or({ _: 2 }, [
                        Nt(j(Vt), (ft, uf) => ({
                          name: ft,
                          fn: Ve((Ys) => [
                            Ee(de.$slots, ft, Wr(ua({ ...Ys })))
                          ])
                        }))
                      ]), 1040, ["specific-mode", "get-week-num", "instance", "mapped-dates", "month", "year", "flow-step", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
                    ], 2))), 128))
                  ], 2),
                  K("div", null, [
                    de.$slots["time-picker"] ? Ee(de.$slots, "time-picker", Wr(zn({ key: 0 }, { time: j(G), updateTime: j(Q) }))) : (I(), W(Ge, { key: 1 }, [
                      de.enableTimePicker && !de.monthPicker && !de.weekPicker ? (I(), Oe(Sl(de.timePickerComponent ? de.timePickerComponent : p4), zn({
                        key: 0,
                        ref_key: "timePickerRef",
                        ref: v,
                        hours: j(G).hours,
                        minutes: j(G).minutes,
                        seconds: j(G).seconds,
                        "internal-model-value": e.internalModelValue
                      }, de.$props, {
                        onMount: Ne[6] || (Ne[6] = (qe) => Pe("timePicker")),
                        "onUpdate:hours": Ne[7] || (Ne[7] = (qe) => j(Q)(qe)),
                        "onUpdate:minutes": Ne[8] || (Ne[8] = (qe) => j(Q)(qe, !1)),
                        "onUpdate:seconds": Ne[9] || (Ne[9] = (qe) => j(Q)(qe, !1, !0)),
                        onResetFlow: X,
                        onOverlayClosed: M
                      }), Or({ _: 2 }, [
                        Nt(j(Be), (qe, Wi) => ({
                          name: qe,
                          fn: Ve((ft) => [
                            Ee(de.$slots, qe, Wr(ua(ft)))
                          ])
                        }))
                      ]), 1040, ["hours", "minutes", "seconds", "internal-model-value"])) : ee("", !0)
                    ], 64))
                  ])
                ], 512),
                de.$slots["right-sidebar"] ? (I(), W("div", b4, [
                  Ee(de.$slots, "right-sidebar")
                ])) : ee("", !0),
                de.showNowButton ? (I(), W("div", w4, [
                  de.$slots["now-button"] ? Ee(de.$slots, "now-button", {
                    key: 0,
                    selectCurrentDate: j($)
                  }) : ee("", !0),
                  de.$slots["now-button"] ? ee("", !0) : (I(), W("button", {
                    key: 1,
                    type: "button",
                    role: "button",
                    class: "dp__now_button",
                    onClick: Ne[10] || (Ne[10] = //@ts-ignore
                    (...qe) => j($) && j($)(...qe))
                  }, ke(de.nowButtonLabel), 1))
                ])) : ee("", !0)
              ], 2),
              !de.autoApply || de.keepActionRow ? (I(), Oe(Sl(de.actionRowComponent ? de.actionRowComponent : IV), zn({
                key: 2,
                "menu-mount": T.value,
                "calendar-width": w.value,
                "internal-model-value": e.internalModelValue
              }, de.$props, {
                onClosePicker: Ne[11] || (Ne[11] = (qe) => de.$emit("close-picker")),
                onSelectDate: Ne[12] || (Ne[12] = (qe) => de.$emit("select-date")),
                onInvalidSelect: Ne[13] || (Ne[13] = (qe) => de.$emit("invalid-select"))
              }), Or({ _: 2 }, [
                Nt(j(Bt), (qe, Wi) => ({
                  name: qe,
                  fn: Ve((ft) => [
                    Ee(de.$slots, qe, Wr(ua({ ...ft })))
                  ])
                }))
              ]), 1040, ["menu-mount", "calendar-width", "internal-model-value"])) : ee("", !0)
            ], 42, g4)
          ];
        }),
        _: 3
      }, 8, ["name", "css"]);
    };
  }
}), E4 = typeof window < "u" ? window : void 0, Rh = () => {
}, T4 = (e) => rI() ? (iI(e), !0) : !1, k4 = (e, t, n, r) => {
  if (!e)
    return Rh;
  let i = Rh;
  const a = dn(
    () => j(e),
    (s) => {
      i(), s && (s.addEventListener(t, n, r), i = () => {
        s.removeEventListener(t, n, r), i = Rh;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    a(), i();
  };
  return T4(o), o;
}, S4 = (e, t, n, r = {}) => {
  const { window: i = E4, event: a = "pointerdown" } = r;
  return i ? k4(i, a, (o) => {
    const s = Nn(e), u = Nn(t);
    !s || !u || s === o.target || o.composedPath().includes(s) || o.composedPath().includes(u) || n(o);
  }, { passive: !0 }) : void 0;
}, O4 = /* @__PURE__ */ Tt({
  __name: "VueDatePicker",
  props: {
    ...Xa
  },
  emits: [
    "update:model-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = fm(), a = fe(!1), o = aa(r, "modelValue"), s = aa(r, "timezone"), u = fe(null), d = fe(null), f = fe(!1), { setMenuFocused: p, setShiftKey: m } = _E(), { clearArrowNav: g } = Ka(), { validateDate: v, isValidTime: b, defaults: w } = Gr(r);
    Mt(() => {
      N(r.modelValue), r.inline || (window.addEventListener("scroll", G), window.addEventListener("resize", Q)), r.inline && (a.value = !0);
    }), Bn(() => {
      r.inline || (window.removeEventListener("scroll", G), window.removeEventListener("resize", Q));
    });
    const T = To(i, "all", r.presetRanges), S = To(i, "input");
    dn(
      [o, s],
      () => {
        N(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: x, menuPosition: O, setMenuPosition: C, setInitialPosition: P } = wV(
      u,
      d,
      n,
      r
    ), {
      inputValue: k,
      internalModelValue: M,
      parseExternalModelValue: N,
      emitModelValue: X,
      formatInputValue: Z,
      checkBeforeEmit: te
    } = yV(n, r, f), ce = oe(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: r.inline,
        dp__flex_display_with_input: r.inlineWithInput
      })
    ), we = oe(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), G = () => {
      a.value && (r.closeOnScroll ? U() : r.autoPosition && C());
    }, Q = () => {
      a.value && C();
    }, y = () => {
      !r.disabled && !r.readonly && (P(), a.value = !0, $a().then(() => {
        C(), a.value && n("open");
      }), a.value || xe(), N(r.modelValue));
    }, H = () => {
      k.value = "", xe(), n("update:model-value", null), n("cleared"), U();
    }, ie = () => {
      const Xe = M.value;
      return !Xe || !Array.isArray(Xe) && v(Xe) ? !0 : Array.isArray(Xe) ? Xe.length === 2 && v(Xe[0]) && v(Xe[1]) ? !0 : v(Xe[0]) : !1;
    }, ne = () => {
      te() && ie() ? (X(), U()) : n("invalid-select", M.value);
    }, J = (Xe) => {
      X(), r.closeOnAutoApply && !Xe && U();
    }, me = (Xe = !1) => {
      r.autoApply && b(M.value) && ie() && (r.range && Array.isArray(M.value) ? (r.partialRange || M.value.length === 2) && J(Xe) : J(Xe));
    }, xe = () => {
      r.textInput || (M.value = null);
    }, U = () => {
      r.inline || (a.value && (a.value = !1, p(!1), m(!1), g(), n("closed"), P(), k.value && N(o.value)), xe(), d.value && d.value.focusInput());
    }, $ = (Xe, ue) => {
      if (!Xe) {
        M.value = null;
        return;
      }
      M.value = Xe, ue && (ne(), n("text-submit"));
    }, Y = () => {
      r.autoApply && b(M.value) && X();
    }, Re = () => a.value ? U() : y(), it = (Xe) => {
      M.value = Xe;
    }, He = oe(() => r.textInput && w.value.textInputOptions.format), Vt = () => {
      He.value && (f.value = !0, Z()), n("focus");
    }, Bt = () => {
      He.value && (f.value = !1, Z()), n("blur");
    }, Be = (Xe) => {
      u.value && u.value.updateMonthYear(0, {
        month: Gy(Xe.month),
        year: Gy(Xe.year)
      });
    };
    return S4(
      u,
      d,
      r.onClickOutside ? () => r.onClickOutside(ie) : U
    ), t({
      closeMenu: U,
      selectDate: ne,
      clearValue: H,
      openMenu: y,
      onScroll: G,
      formatInputValue: Z,
      // exposed for testing purposes
      updateInternalModelValue: it,
      // modify internal modelValue
      setMonthYear: Be
    }), (Xe, ue) => (I(), W("div", {
      class: ze(j(ce))
    }, [
      Ae(AV, zn({
        ref_key: "inputRef",
        ref: d,
        "is-menu-open": a.value,
        "input-value": j(k),
        "onUpdate:inputValue": ue[0] || (ue[0] = (Ce) => Si(k) ? k.value = Ce : null)
      }, Xe.$props, {
        onClear: H,
        onOpen: y,
        onSetInputDate: $,
        onSetEmptyDate: j(X),
        onSelectDate: ne,
        onToggle: Re,
        onClose: U,
        onFocus: Vt,
        onBlur: Bt
      }), Or({ _: 2 }, [
        Nt(j(S), (Ce, Pr) => ({
          name: Ce,
          fn: Ve((qt) => [
            Ee(Xe.$slots, Ce, Wr(ua(qt)))
          ])
        }))
      ]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]),
      a.value ? (I(), Oe(Kw, {
        key: 0,
        to: Xe.teleport,
        disabled: Xe.inline
      }, [
        a.value ? (I(), Oe(x4, zn({
          key: 0,
          ref_key: "dpMenuRef",
          ref: u,
          class: j(we),
          style: j(O),
          "open-on-top": j(x)
        }, Xe.$props, {
          "internal-model-value": j(M),
          "onUpdate:internalModelValue": ue[1] || (ue[1] = (Ce) => Si(M) ? M.value = Ce : null),
          onClosePicker: U,
          onSelectDate: ne,
          onAutoApply: me,
          onTimeUpdate: Y,
          onFlowStep: ue[2] || (ue[2] = (Ce) => Xe.$emit("flow-step", Ce)),
          onUpdateMonthYear: ue[3] || (ue[3] = (Ce) => Xe.$emit("update-month-year", Ce)),
          onInvalidSelect: ue[4] || (ue[4] = (Ce) => Xe.$emit("invalid-select", j(M))),
          onInvalidFixedRange: ue[5] || (ue[5] = (Ce) => Xe.$emit("invalid-fixed-range", Ce)),
          onRecalculatePosition: j(C),
          onTooltipOpen: ue[6] || (ue[6] = (Ce) => Xe.$emit("tooltip-open", Ce)),
          onTooltipClose: ue[7] || (ue[7] = (Ce) => Xe.$emit("tooltip-close", Ce))
        }), Or({ _: 2 }, [
          Nt(j(T), (Ce, Pr) => ({
            name: Ce,
            fn: Ve((qt) => [
              Ee(Xe.$slots, Ce, Wr(ua({ ...qt })))
            ])
          }))
        ]), 1040, ["class", "style", "open-on-top", "internal-model-value", "onRecalculatePosition"])) : ee("", !0)
      ], 8, ["to", "disabled"])) : ee("", !0)
    ], 2));
  }
}), du = /* @__PURE__ */ (() => {
  const e = O4;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), C4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: du
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(C4).forEach(([e, t]) => {
  e !== "default" && (du[e] = t);
});
function sr(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function Bm(e, t) {
  const n = /* @__PURE__ */ new Date();
  return sr(e, cu(n)) && sr(t, n);
}
function A4(e, t) {
  const n = /* @__PURE__ */ new Date(), r = cu(li(n, 1)), i = Cm(li(n, 1));
  return sr(e, r) && sr(t, i);
}
function Um(e, t) {
  const n = /* @__PURE__ */ new Date();
  return sr(e, Po(n, { weekStartsOn: 1 })) && sr(t, n);
}
function D4(e, t) {
  const n = /* @__PURE__ */ new Date(), r = Os(Po(n, { weekStartsOn: 1 }), 1), i = Os(Am(n, { weekStartsOn: 1 }), 1);
  return sr(e, r) && sr(t, i);
}
function Wm() {
  const e = /* @__PURE__ */ new Date();
  return [cu(e), e];
}
function P4() {
  return [
    cu(li(/* @__PURE__ */ new Date(), 1)),
    Cm(li(/* @__PURE__ */ new Date(), 1))
  ];
}
function xE() {
  return [Po(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }), /* @__PURE__ */ new Date()];
}
function M4() {
  return [
    Os(Po(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }), 1),
    Os(Am(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }), 1)
  ];
}
function I4(e, t) {
  const n = /* @__PURE__ */ new Date();
  return sr(e, Lm(n, 6)) && sr(t, n);
}
function N4() {
  return [Lm(/* @__PURE__ */ new Date(), 6), /* @__PURE__ */ new Date()];
}
function L4(e, t) {
  const n = /* @__PURE__ */ new Date();
  return sr(e, Os(n, 4)) && sr(t, n);
}
function R4() {
  return [Os(/* @__PURE__ */ new Date(), 4), /* @__PURE__ */ new Date()];
}
function F4(e, t) {
  const n = /* @__PURE__ */ new Date();
  return sr(e, li(n, 3)) && sr(t, n);
}
function $4() {
  return [li(/* @__PURE__ */ new Date(), 3), /* @__PURE__ */ new Date()];
}
function EE(e, t) {
  const n = /* @__PURE__ */ new Date();
  return sr(e, Gx(n)) && sr(t, n);
}
function V4() {
  return [Gx(/* @__PURE__ */ new Date()), /* @__PURE__ */ new Date()];
}
function Gl(e) {
  return Li(e, "yyyy-MM-dd");
}
const B4 = {
  components: { Datepicker: du },
  props: {
    placeholder: {
      type: String
    },
    modelValue: {
      type: Array,
      required: !0
    },
    useQueryParams: {
      type: Boolean,
      default: !1
      // Store values in query params (start_date, end_date), useful for navigation persistence/link sharing
    },
    ranges: {
      type: Array,
      default: () => []
    }
  },
  beforeMount() {
    this.useQueryParams && this.loadQueryParams();
  },
  data: () => ({
    defaultRanges: [
      {
        id: 1,
        label: "Mois en cours",
        range: Wm()
      },
      {
        id: 2,
        label: "Semaine en cours",
        range: xE()
      },
      {
        id: 3,
        label: "Mois précédent",
        range: P4()
      },
      {
        id: 4,
        label: "Semaine précédente",
        range: M4()
      }
    ]
  }),
  computed: {
    presetRanges() {
      const e = this.ranges.map((t, n) => ({
        id: n + this.defaultRanges.length + 1,
        label: t.label,
        range: t.range
      }));
      return [...this.defaultRanges, ...e];
    },
    internalValue: {
      get() {
        var e;
        return (e = this.modelValue) != null && e.every((t) => t == null) ? null : this.modelValue;
      },
      set(e) {
        let t = null, n = null;
        e && (t = Gl(e[0]), n = Gl(e[1])), this.useQueryParams && this.updateQueryParams(t, n), this.$emit("update:modelValue", [t, n]);
      }
    }
  },
  methods: {
    datePickerFormat(e) {
      const t = e[0], n = e[1];
      if (!t || !n) return "";
      if (t instanceof Date && n instanceof Date) {
        if (Bm(t, n)) return "Mois en cours";
        if (A4(t, n)) return "Mois précédent";
        if (Um(t, n)) return "Semaine en cours";
        if (D4(t, n)) return "Semaine précédente";
      }
      const r = Li(t, "dd/MM/yyyy"), i = Li(n, "dd/MM/yyyy");
      return `Du ${r} au ${i}`;
    },
    loadQueryParams() {
      const e = this.$route.query.start_date, t = this.$route.query.end_date;
      e && t && (this.internalValue = [new Date(e), new Date(t)]);
    },
    updateQueryParams(e, t) {
      const n = { ...this.$route.query };
      !e || !t ? (delete n.start_date, delete n.end_date) : (n.start_date = e, n.end_date = t), this.$router.push({ query: n });
    }
  }
};
function U4(e, t, n, r, i, a) {
  const o = je("Datepicker");
  return I(), Oe(o, {
    placeholder: n.placeholder,
    class: "text-sm w-full rounded-md",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s),
    range: "",
    multiCalendars: "",
    presetRanges: a.presetRanges,
    autoApply: "",
    enableTimePicker: !1,
    format: a.datePickerFormat,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date()
  }, null, 8, ["placeholder", "modelValue", "presetRanges", "format", "max-date"]);
}
const Pee = /* @__PURE__ */ pt(B4, [["render", U4]]);
function W4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 9l-7 7-7-7"
    })
  ]);
}
function H4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 15l7-7 7 7"
    })
  ]);
}
function j4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    })
  ]);
}
function Y4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    })
  ]);
}
function z4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    })
  ]);
}
function G4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }),
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    })
  ]);
}
function fu(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]);
}
function q4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    })
  ]);
}
function K4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    })
  ]);
}
function TE(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    })
  ]);
}
function X4(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18L18 6M6 6l12 12"
    })
  ]);
}
function Z4(e) {
  return e == null;
}
function Q4(e) {
  return !e && e !== 0 || e.length === 0 || Object.getPrototypeOf(e) === Object.prototype && Object.getOwnPropertyNames(e).length === 0;
}
function J4(e) {
  return Z4(e) || Q4(e);
}
function ar(e) {
  return !J4(e);
}
const eB = {
  components: {
    CloudUploadIcon: j4,
    TrashIcon: TE,
    Field: Dd
  },
  props: {
    formData: {
      type: Object,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      files: []
    };
  },
  mounted() {
    for (const e of this.formData.entries())
      e[0] === this.id && (this.files = e[1]);
  },
  methods: {
    isPresent: ar,
    handleFileUpload(e) {
      const t = e.target.files;
      for (let n = 0; n < t.length; n++)
        this.files.push(t[n]);
      this.updateFormData();
    },
    removeFile(e) {
      this.files.splice(e, 1), this.updateFormData();
    },
    updateFormData() {
      this.formData.delete(this.id);
      for (let e = 0; e < this.files.length; e++)
        this.formData.append(this.id, this.files[e], this.files[e].name);
      this.$emit("files");
    }
  }
}, tB = ["for"], nB = {
  key: 0,
  class: "text-red-600"
}, rB = ["id"], iB = { class: "flex flex-col justify-center px-6 pt-5 pb-6 space-y-1 border-2 border-primary border-dashed rounded-md bg-white text-center text-sm text-primary-dark font-medium focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-black-600" }, aB = ["id", "multiple"], oB = { class: "text-xs text-primary-dark" }, sB = {
  key: 1,
  class: "mt-4 grid grid-cols-1 gap-1 place-items-center"
}, lB = { class: "text-sm font-medium text-gray-900" }, uB = ["onClick"];
function cB(e, t, n, r, i, a) {
  const o = je("CloudUploadIcon"), s = je("TrashIcon");
  return I(), W("div", null, [
    a.isPresent(n.label) ? (I(), W("label", {
      key: 0,
      for: n.id,
      class: ze(`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 ${n.labelClass}`)
    }, [
      Xt(ke(e.$t(n.label)) + " ", 1),
      n.required ? (I(), W("span", nB, "*")) : ee("", !0)
    ], 10, tB)) : ee("", !0),
    K("label", {
      id: n.id,
      class: "cursor-pointer"
    }, [
      K("div", iB, [
        Ae(o, { class: "mx-auto h-12 w-12 text-primary-dark" }),
        K("span", null, ke(n.placeholder), 1),
        K("input", {
          id: n.id,
          type: "file",
          class: "sr-only",
          multiple: n.multiple,
          onChange: t[0] || (t[0] = (...u) => a.handleFileUpload && a.handleFileUpload(...u))
        }, null, 40, aB),
        K("p", oB, ke(e.$t("PNG, JPG, GIF up to 10MB")), 1)
      ])
    ], 8, rB),
    a.isPresent(i.files) ? (I(), W("div", sB, [
      K("legend", lB, ke(e.$t("Uploaded files")), 1),
      (I(!0), W(Ge, null, Nt(i.files, (u, d) => (I(), W("div", {
        class: "border-t border-gray-200 px-4 py-5 sm:p-0 flex",
        key: u
      }, [
        K("span", null, ke(u.name), 1),
        K("button", {
          onClick: (f) => a.removeFile(d),
          class: "pl-2",
          style: { width: "0px", overflow: "display" }
        }, [
          Ae(s, {
            class: "h-5 w-5 text-primary",
            "aria-hidden": "true"
          })
        ], 8, uB)
      ]))), 128))
    ])) : ee("", !0)
  ]);
}
const Mee = /* @__PURE__ */ pt(eB, [["render", cB]]), dB = {
  components: {
    Field: Dd
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    labelStyle: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      required: !1,
      default: (e) => e.id
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    fieldClass: {
      type: String,
      default: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
    },
    trailingAddOns: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  computed: {
    isLabelPresent() {
      return !(this.label == null || this.label.length === 0);
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, fB = ["for"], hB = {
  key: 0,
  class: "text-red-600"
}, pB = { class: "relative" }, mB = {
  key: 0,
  class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
}, gB = {
  key: 1,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}, vB = { class: "text-gray-500 sm:text-sm" };
function _B(e, t, n, r, i, a) {
  const o = je("Field");
  return I(), W("div", null, [
    a.isLabelPresent ? (I(), W("label", {
      key: 0,
      for: n.id,
      class: ze(`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 ${n.labelClass}`),
      style: ca(n.labelStyle)
    }, [
      Xt(ke(e.$t(n.label)) + " ", 1),
      n.required ? (I(), W("span", hB, "*")) : ee("", !0)
    ], 14, fB)) : ee("", !0),
    K("div", pB, [
      e.$slots.prependIcon ? (I(), W("div", mB, [
        Ee(e.$slots, "prependIcon")
      ])) : ee("", !0),
      Ae(o, {
        id: n.id,
        name: n.name,
        type: n.type,
        class: ze([n.fieldClass, e.$slots.prependIcon ? "pl-10" : "", n.disabled ? "bg-gray-200" : ""]),
        placeholder: n.placeholder,
        disabled: n.disabled,
        modelValue: a.internalValue,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s)
      }, null, 8, ["id", "name", "type", "class", "placeholder", "disabled", "modelValue"]),
      n.trailingAddOns ? (I(), W("div", gB, [
        K("span", vB, ke(n.trailingAddOns), 1)
      ])) : ee("", !0)
    ])
  ]);
}
const Iee = /* @__PURE__ */ pt(dB, [["render", _B]]);
function yB(e) {
  if (!e) return "";
  let t = e.address1;
  return ar(e.address2) && (t += `, ${e.address2}`), ar(e.city) && (t += `, ${e.city}`), ar(e.zipCode) && (t += `, ${e.zipCode}`), ar(e.country) && (t += `, ${e.country}`), t;
}
const bB = {
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    labelClass: {
      type: String,
      default: "block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2"
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Object,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      countries: ["fr", "mq", "gp", "re"]
      // restrict the country
    };
  },
  mounted() {
    this.setupAutocomplete();
  },
  computed: {
    isLabelPresent() {
      return !(this.label == null || this.label.length === 0);
    },
    internalValue: {
      get() {
        return typeof this.modelValue != "object" ? this.modelValue : yB(this.modelValue);
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    input() {
      return document.getElementById(this.id);
    }
  },
  methods: {
    setupAutocomplete() {
      if (!window.google) return console.error("Google API not loaded");
      const e = window.google;
      this.autocomplete = new e.maps.places.Autocomplete(this.input), this.autocomplete.setComponentRestrictions({ country: this.countries }), this.autocomplete.addListener("place_changed", () => {
        let t = this.autocomplete.getPlace(), n = t.address_components;
        const r = this.findDataShortName(n, "street_number"), i = this.findDataShortName(n, "route"), a = ar(r) && ar(i) ? `${r} ${i}` : t.formatted_address, o = this.findDataShortName(n, "locality"), s = this.findDataShortName(
          n,
          "administrative_area_level_1"
        ), u = this.findDataShortName(n, "country"), d = this.findDataShortName(n, "postal_code");
        let f = this.findDataShortName(n, "subpremise") || t.name;
        f === a && (f = ""), this.internalValue = {
          address1: a,
          address2: f,
          city: o,
          province: s,
          country: u,
          zipCode: d
        };
      });
    },
    findDataShortName(e, t) {
      var n;
      return (n = e == null ? void 0 : e.find((r) => r.types.includes(t))) == null ? void 0 : n.short_name;
    },
    resetLocation() {
      this.internalValue = {
        address1: "",
        address2: "",
        city: "",
        province: "",
        country: "",
        zipCode: ""
      };
    }
  }
}, wB = ["for"], xB = {
  key: 0,
  class: "text-red-600"
}, EB = { class: "relative" }, TB = ["id", "placeholder"];
function kB(e, t, n, r, i, a) {
  return I(), W("div", null, [
    a.isLabelPresent ? (I(), W("label", {
      key: 0,
      for: n.id,
      class: ze(n.labelClass)
    }, [
      Xt(ke(e.$t(n.label)) + " ", 1),
      n.required ? (I(), W("span", xB, "*")) : ee("", !0)
    ], 10, wB)) : ee("", !0),
    K("div", EB, [
      Ni(K("input", {
        id: n.id,
        placeholder: n.placeholder,
        "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
        type: "text",
        class: "shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md",
        onKeydown: t[1] || (t[1] = _t(nr(() => {
        }, ["prevent"]), ["enter"]))
      }, null, 40, TB), [
        [dm, a.internalValue]
      ])
    ])
  ]);
}
const Nee = /* @__PURE__ */ pt(bB, [["render", kB]]);
function Hm(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function hu() {
  let e = [], t = { addEventListener(n, r, i, a) {
    return n.addEventListener(r, i, a), t.add(() => n.removeEventListener(r, i, a));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Hm(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, i) {
    let a = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: i }), this.add(() => {
      Object.assign(n.style, { [r]: a });
    });
  }, group(n) {
    let r = hu();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0) for (let i of e.splice(r, 1)) i();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return t;
}
var Qy;
let SB = Symbol("headlessui.useid"), OB = 0;
const zr = (Qy = m_.useId) != null ? Qy : function() {
  return m_.inject(SB, () => `${++OB}`)();
};
function $e(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function lr(e, t, ...n) {
  if (e in t) {
    let i = t[e];
    return typeof i == "function" ? i(...n) : i;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, lr), r;
}
var CB = Object.defineProperty, AB = (e, t, n) => t in e ? CB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Jy = (e, t, n) => (AB(e, typeof t != "symbol" ? t + "" : t, n), n);
let DB = class {
  constructor() {
    Jy(this, "current", this.detect()), Jy(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, pu = new DB();
function Vi(e) {
  if (pu.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = $e(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let Cp = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var ir = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(ir || {}), ql = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(ql || {}), PB = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(PB || {});
function Id(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Cp)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var jm = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(jm || {});
function kE(e, t = 0) {
  var n;
  return e === ((n = Vi(e)) == null ? void 0 : n.body) ? !1 : lr(t, { 0() {
    return e.matches(Cp);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Cp)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var MB = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(MB || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Co(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let IB = ["textarea", "input"].join(",");
function NB(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, IB)) != null ? n : !1;
}
function LB(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let i = t(n), a = t(r);
    if (i === null || a === null) return 0;
    let o = i.compareDocumentPosition(a);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function gi(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: i = [] } = {}) {
  var a;
  let o = (a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? a : document, s = Array.isArray(e) ? n ? LB(e) : e : Id(e);
  i.length > 0 && s.length > 1 && (s = s.filter((v) => !i.includes(v))), r = r ?? o.activeElement;
  let u = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, s.indexOf(r)) - 1;
    if (t & 4) return Math.max(0, s.indexOf(r)) + 1;
    if (t & 8) return s.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), f = t & 32 ? { preventScroll: !0 } : {}, p = 0, m = s.length, g;
  do {
    if (p >= m || p + m <= 0) return 0;
    let v = d + p;
    if (t & 16) v = (v + m) % m;
    else {
      if (v < 0) return 3;
      if (v >= m) return 1;
    }
    g = s[v], g == null || g.focus(f), p += u;
  } while (g !== o.activeElement);
  return t & 6 && NB(g) && g.select(), 2;
}
function SE() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function RB() {
  return /Android/gi.test(window.navigator.userAgent);
}
function FB() {
  return SE() || RB();
}
function xc(e, t, n) {
  pu.isServer || _r((r) => {
    document.addEventListener(e, t, n), r(() => document.removeEventListener(e, t, n));
  });
}
function OE(e, t, n) {
  pu.isServer || _r((r) => {
    window.addEventListener(e, t, n), r(() => window.removeEventListener(e, t, n));
  });
}
function CE(e, t, n = oe(() => !0)) {
  function r(a, o) {
    if (!n.value || a.defaultPrevented) return;
    let s = o(a);
    if (s === null || !s.getRootNode().contains(s)) return;
    let u = function d(f) {
      return typeof f == "function" ? d(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    }(e);
    for (let d of u) {
      if (d === null) continue;
      let f = d instanceof HTMLElement ? d : $e(d);
      if (f != null && f.contains(s) || a.composed && a.composedPath().includes(f)) return;
    }
    return !kE(s, jm.Loose) && s.tabIndex !== -1 && a.preventDefault(), t(a, s);
  }
  let i = fe(null);
  xc("pointerdown", (a) => {
    var o, s;
    n.value && (i.value = ((s = (o = a.composedPath) == null ? void 0 : o.call(a)) == null ? void 0 : s[0]) || a.target);
  }, !0), xc("mousedown", (a) => {
    var o, s;
    n.value && (i.value = ((s = (o = a.composedPath) == null ? void 0 : o.call(a)) == null ? void 0 : s[0]) || a.target);
  }, !0), xc("click", (a) => {
    FB() || i.value && (r(a, () => i.value), i.value = null);
  }, !0), xc("touchend", (a) => r(a, () => a.target instanceof HTMLElement ? a.target : null), !0), OE("blur", (a) => r(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function eb(e, t) {
  if (e) return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function $B(e, t) {
  let n = fe(eb(e.value.type, e.value.as));
  return Mt(() => {
    n.value = eb(e.value.type, e.value.as);
  }), _r(() => {
    var r;
    n.value || $e(t) && $e(t) instanceof HTMLButtonElement && !((r = $e(t)) != null && r.hasAttribute("type")) && (n.value = "button");
  }), n;
}
var Ba = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Ba || {}), Pa = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Pa || {});
function Un({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...i }) {
  var a;
  let o = DE(r, n), s = Object.assign(i, { props: o });
  if (e || t & 2 && o.static) return Fh(s);
  if (t & 1) {
    let u = (a = o.unmount) == null || a ? 0 : 1;
    return lr(u, { 0() {
      return null;
    }, 1() {
      return Fh({ ...i, props: { ...o, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Fh(s);
}
function Fh({ props: e, attrs: t, slots: n, slot: r, name: i }) {
  var a, o;
  let { as: s, ...u } = PE(e, ["unmount", "static"]), d = (a = n.default) == null ? void 0 : a.call(n, r), f = {};
  if (r) {
    let p = !1, m = [];
    for (let [g, v] of Object.entries(r)) typeof v == "boolean" && (p = !0), v === !0 && m.push(g);
    p && (f["data-headlessui-state"] = m.join(" "));
  }
  if (s === "template") {
    if (d = AE(d ?? []), Object.keys(u).length > 0 || Object.keys(t).length > 0) {
      let [p, ...m] = d ?? [];
      if (!VB(p) || m.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(u).concat(Object.keys(t)).map((b) => b.trim()).filter((b, w, T) => T.indexOf(b) === w).sort((b, w) => b.localeCompare(w)).map((b) => `  - ${b}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((b) => `  - ${b}`).join(`
`)].join(`
`));
      let g = DE((o = p.props) != null ? o : {}, u, f), v = aI(p, g, !0);
      for (let b in g) b.startsWith("on") && (v.props || (v.props = {}), v.props[b] = g[b]);
      return v;
    }
    return Array.isArray(d) && d.length === 1 ? d[0] : d;
  }
  return Ct(s, Object.assign({}, u, f), { default: () => d });
}
function AE(e) {
  return e.flatMap((t) => t.type === Ge ? AE(t.children) : [t]);
}
function DE(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let i in r) i.startsWith("on") && typeof r[i] == "function" ? (n[i] != null || (n[i] = []), n[i].push(r[i])) : t[i] = r[i];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](i, ...a) {
    let o = n[r];
    for (let s of o) {
      if (i instanceof Event && i.defaultPrevented) return;
      s(i, ...a);
    }
  } });
  return t;
}
function PE(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function VB(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Ua = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Ua || {});
let Io = Tt({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var r;
    let { features: i, ...a } = e, o = { "aria-hidden": (i & 2) === 2 ? !0 : (r = a["aria-hidden"]) != null ? r : void 0, hidden: (i & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return Un({ ourProps: o, theirProps: a, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} }), ME = Symbol("Context");
var Mn = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Mn || {});
function BB() {
  return mu() !== null;
}
function mu() {
  return qn(ME, null);
}
function IE(e) {
  Dr(ME, e);
}
var ra = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ra || {});
function UB(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let wo = [];
UB(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && wo[0] !== t.target && (wo.unshift(t.target), wo = wo.filter((n) => n != null && n.isConnected), wo.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Ym(e, t, n, r) {
  pu.isServer || _r((i) => {
    e = e ?? window, e.addEventListener(t, n, r), i(() => e.removeEventListener(t, n, r));
  });
}
var Hr = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Hr || {});
function zm() {
  let e = fe(0);
  return OE("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function NE(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.value) {
    let r = $e(n);
    r instanceof HTMLElement && t.add(r);
  }
  return t;
}
var LE = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(LE || {});
let ul = Object.assign(Tt({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: fe(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  let i = fe(null);
  r({ el: i, $el: i });
  let a = oe(() => Vi(i)), o = fe(!1);
  Mt(() => o.value = !0), Bn(() => o.value = !1), HB({ ownerDocument: a }, oe(() => o.value && !!(e.features & 16)));
  let s = jB({ ownerDocument: a, container: i, initialFocus: oe(() => e.initialFocus) }, oe(() => o.value && !!(e.features & 2)));
  YB({ ownerDocument: a, container: i, containers: e.containers, previousActiveElement: s }, oe(() => o.value && !!(e.features & 8)));
  let u = zm();
  function d(g) {
    let v = $e(i);
    v && ((b) => b())(() => {
      lr(u.value, { [Hr.Forwards]: () => {
        gi(v, ir.First, { skipElements: [g.relatedTarget] });
      }, [Hr.Backwards]: () => {
        gi(v, ir.Last, { skipElements: [g.relatedTarget] });
      } });
    });
  }
  let f = fe(!1);
  function p(g) {
    g.key === "Tab" && (f.value = !0, requestAnimationFrame(() => {
      f.value = !1;
    }));
  }
  function m(g) {
    if (!o.value) return;
    let v = NE(e.containers);
    $e(i) instanceof HTMLElement && v.add($e(i));
    let b = g.relatedTarget;
    b instanceof HTMLElement && b.dataset.headlessuiFocusGuard !== "true" && (RE(v, b) || (f.value ? gi($e(i), lr(u.value, { [Hr.Forwards]: () => ir.Next, [Hr.Backwards]: () => ir.Previous }) | ir.WrapAround, { relativeTo: g.target }) : g.target instanceof HTMLElement && Co(g.target)));
  }
  return () => {
    let g = {}, v = { ref: i, onKeydown: p, onFocusout: m }, { features: b, initialFocus: w, containers: T, ...S } = e;
    return Ct(Ge, [!!(b & 4) && Ct(Io, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: d, features: Ua.Focusable }), Un({ ourProps: v, theirProps: { ...t, ...S }, slot: g, attrs: t, slots: n, name: "FocusTrap" }), !!(b & 4) && Ct(Io, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: d, features: Ua.Focusable })]);
  };
} }), { features: LE });
function WB(e) {
  let t = fe(wo.slice());
  return dn([e], ([n], [r]) => {
    r === !0 && n === !1 ? Hm(() => {
      t.value.splice(0);
    }) : r === !1 && n === !0 && (t.value = wo.slice());
  }, { flush: "post" }), () => {
    var n;
    return (n = t.value.find((r) => r != null && r.isConnected)) != null ? n : null;
  };
}
function HB({ ownerDocument: e }, t) {
  let n = WB(t);
  Mt(() => {
    _r(() => {
      var r, i;
      t.value || ((r = e.value) == null ? void 0 : r.activeElement) === ((i = e.value) == null ? void 0 : i.body) && Co(n());
    }, { flush: "post" });
  }), Bn(() => {
    t.value && Co(n());
  });
}
function jB({ ownerDocument: e, container: t, initialFocus: n }, r) {
  let i = fe(null), a = fe(!1);
  return Mt(() => a.value = !0), Bn(() => a.value = !1), Mt(() => {
    dn([t, n, r], (o, s) => {
      if (o.every((d, f) => (s == null ? void 0 : s[f]) === d) || !r.value) return;
      let u = $e(t);
      u && Hm(() => {
        var d, f;
        if (!a.value) return;
        let p = $e(n), m = (d = e.value) == null ? void 0 : d.activeElement;
        if (p) {
          if (p === m) {
            i.value = m;
            return;
          }
        } else if (u.contains(m)) {
          i.value = m;
          return;
        }
        p ? Co(p) : gi(u, ir.First | ir.NoScroll) === ql.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), i.value = (f = e.value) == null ? void 0 : f.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), i;
}
function YB({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, i) {
  var a;
  Ym((a = e.value) == null ? void 0 : a.defaultView, "focus", (o) => {
    if (!i.value) return;
    let s = NE(n);
    $e(t) instanceof HTMLElement && s.add($e(t));
    let u = r.value;
    if (!u) return;
    let d = o.target;
    d && d instanceof HTMLElement ? RE(s, d) ? (r.value = d, Co(d)) : (o.preventDefault(), o.stopPropagation(), Co(u)) : Co(r.value);
  }, !0);
}
function RE(e, t) {
  for (let n of e) if (n.contains(t)) return !0;
  return !1;
}
function zB(e) {
  let t = su(e.getSnapshot());
  return Bn(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function GB(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(i) {
    return r.add(i), () => r.delete(i);
  }, dispatch(i, ...a) {
    let o = t[i].call(n, ...a);
    o && (n = o, r.forEach((s) => s()));
  } };
}
function qB() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - r.clientWidth;
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, i = r.clientWidth - r.offsetWidth, a = e - i;
    n.style(r, "paddingRight", `${a}px`);
  } };
}
function KB() {
  return SE() ? { before({ doc: e, d: t, meta: n }) {
    function r(i) {
      return n.containers.flatMap((a) => a()).some((a) => a.contains(i));
    }
    t.microTask(() => {
      var i;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let s = hu();
        s.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => s.dispose()));
      }
      let a = (i = window.scrollY) != null ? i : window.pageYOffset, o = null;
      t.addEventListener(e, "click", (s) => {
        if (s.target instanceof HTMLElement) try {
          let u = s.target.closest("a");
          if (!u) return;
          let { hash: d } = new URL(u.href), f = e.querySelector(d);
          f && !r(f) && (o = f);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (s) => {
        if (s.target instanceof HTMLElement) if (r(s.target)) {
          let u = s.target;
          for (; u.parentElement && r(u.parentElement); ) u = u.parentElement;
          t.style(u, "overscrollBehavior", "contain");
        } else t.style(s.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (s) => {
        if (s.target instanceof HTMLElement) {
          if (s.target.tagName === "INPUT") return;
          if (r(s.target)) {
            let u = s.target;
            for (; u.parentElement && u.dataset.headlessuiPortal !== "" && !(u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth); ) u = u.parentElement;
            u.dataset.headlessuiPortal === "" && s.preventDefault();
          } else s.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var s;
        let u = (s = window.scrollY) != null ? s : window.pageYOffset;
        a !== u && window.scrollTo(0, a), o && o.isConnected && (o.scrollIntoView({ block: "nearest" }), o = null);
      });
    });
  } } : {};
}
function XB() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function ZB(e) {
  let t = {};
  for (let n of e) Object.assign(t, n(t));
  return t;
}
let ko = GB(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: hu(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: ZB(n) }, i = [KB(), qB(), XB()];
  i.forEach(({ before: a }) => a == null ? void 0 : a(r)), i.forEach(({ after: a }) => a == null ? void 0 : a(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
ko.subscribe(() => {
  let e = ko.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e) t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", i = n.count !== 0;
    (i && !r || !i && r) && ko.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && ko.dispatch("TEARDOWN", n);
  }
});
function QB(e, t, n) {
  let r = zB(ko), i = oe(() => {
    let a = e.value ? r.value.get(e.value) : void 0;
    return a ? a.count > 0 : !1;
  });
  return dn([e, t], ([a, o], [s], u) => {
    if (!a || !o) return;
    ko.dispatch("PUSH", a, n);
    let d = !1;
    u(() => {
      d || (ko.dispatch("POP", s ?? a, n), d = !0);
    });
  }, { immediate: !0 }), i;
}
let $h = /* @__PURE__ */ new Map(), cl = /* @__PURE__ */ new Map();
function tb(e, t = fe(!0)) {
  _r((n) => {
    var r;
    if (!t.value) return;
    let i = $e(e);
    if (!i) return;
    n(function() {
      var o;
      if (!i) return;
      let s = (o = cl.get(i)) != null ? o : 1;
      if (s === 1 ? cl.delete(i) : cl.set(i, s - 1), s !== 1) return;
      let u = $h.get(i);
      u && (u["aria-hidden"] === null ? i.removeAttribute("aria-hidden") : i.setAttribute("aria-hidden", u["aria-hidden"]), i.inert = u.inert, $h.delete(i));
    });
    let a = (r = cl.get(i)) != null ? r : 0;
    cl.set(i, a + 1), a === 0 && ($h.set(i, { "aria-hidden": i.getAttribute("aria-hidden"), inert: i.inert }), i.setAttribute("aria-hidden", "true"), i.inert = !0);
  });
}
function FE({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  let r = fe(null), i = Vi(r);
  function a() {
    var o, s, u;
    let d = [];
    for (let f of e) f !== null && (f instanceof HTMLElement ? d.push(f) : "value" in f && f.value instanceof HTMLElement && d.push(f.value));
    if (t != null && t.value) for (let f of t.value) d.push(f);
    for (let f of (o = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? o : []) f !== document.body && f !== document.head && f instanceof HTMLElement && f.id !== "headlessui-portal-root" && (f.contains($e(r)) || f.contains((u = (s = $e(r)) == null ? void 0 : s.getRootNode()) == null ? void 0 : u.host) || d.some((p) => f.contains(p)) || d.push(f));
    return d;
  }
  return { resolveContainers: a, contains(o) {
    return a().some((s) => s.contains(o));
  }, mainTreeNodeRef: r, MainTreeNode() {
    return n != null ? null : Ct(Io, { features: Ua.Hidden, ref: r });
  } };
}
function JB() {
  let e = fe(null);
  return { mainTreeNodeRef: e, MainTreeNode() {
    return Ct(Io, { features: Ua.Hidden, ref: e });
  } };
}
let $E = Symbol("ForcePortalRootContext");
function eU() {
  return qn($E, !1);
}
let Ap = Tt({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: n }) {
  return Dr($E, e.force), () => {
    let { force: r, ...i } = e;
    return Un({ theirProps: i, ourProps: {}, slot: {}, slots: t, attrs: n, name: "ForcePortalRoot" });
  };
} }), VE = Symbol("StackContext");
var Dp = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Dp || {});
function tU() {
  return qn(VE, () => {
  });
}
function nU({ type: e, enabled: t, element: n, onUpdate: r }) {
  let i = tU();
  function a(...o) {
    r == null || r(...o), i(...o);
  }
  Mt(() => {
    dn(t, (o, s) => {
      o ? a(0, e, n) : s === !0 && a(1, e, n);
    }, { immediate: !0, flush: "sync" });
  }), Bn(() => {
    t.value && a(1, e, n);
  }), Dr(VE, a);
}
let BE = Symbol("DescriptionContext");
function rU() {
  let e = qn(BE, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function iU({ slot: e = fe({}), name: t = "Description", props: n = {} } = {}) {
  let r = fe([]);
  function i(a) {
    return r.value.push(a), () => {
      let o = r.value.indexOf(a);
      o !== -1 && r.value.splice(o, 1);
    };
  }
  return Dr(BE, { register: i, slot: e, name: t, props: n }), oe(() => r.value.length > 0 ? r.value.join(" ") : void 0);
}
Tt({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-description-${zr()}`, a = rU();
  return Mt(() => Bn(a.register(i))), () => {
    let { name: o = "Description", slot: s = fe({}), props: u = {} } = a, { ...d } = e, f = { ...Object.entries(u).reduce((p, [m, g]) => Object.assign(p, { [m]: j(g) }), {}), id: i };
    return Un({ ourProps: f, theirProps: d, slot: s.value, attrs: t, slots: n, name: o });
  };
} });
function aU(e) {
  let t = Vi(e);
  if (!t) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let n = t.getElementById("headlessui-portal-root");
  if (n) return n;
  let r = t.createElement("div");
  return r.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(r);
}
const Pp = /* @__PURE__ */ new WeakMap();
function oU(e) {
  var t;
  return (t = Pp.get(e)) != null ? t : 0;
}
function nb(e, t) {
  let n = t(oU(e));
  return n <= 0 ? Pp.delete(e) : Pp.set(e, n), n;
}
let UE = Tt({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n }) {
  let r = fe(null), i = oe(() => Vi(r)), a = eU(), o = qn(HE, null), s = fe(a === !0 || o == null ? aU(r.value) : o.resolveTarget());
  s.value && nb(s.value, (m) => m + 1);
  let u = fe(!1);
  Mt(() => {
    u.value = !0;
  }), _r(() => {
    a || o != null && (s.value = o.resolveTarget());
  });
  let d = qn(Mp, null), f = !1, p = ui();
  return dn(r, () => {
    if (f || !d) return;
    let m = $e(r);
    m && (Bn(d.register(m), p), f = !0);
  }), Bn(() => {
    var m, g;
    let v = (m = i.value) == null ? void 0 : m.getElementById("headlessui-portal-root");
    !v || s.value !== v || nb(s.value, (b) => b - 1) || s.value.children.length > 0 || (g = s.value.parentElement) == null || g.removeChild(s.value);
  }), () => {
    if (!u.value || s.value === null) return null;
    let m = { ref: r, "data-headlessui-portal": "" };
    return Ct(Kw, { to: s.value }, Un({ ourProps: m, theirProps: e, slot: {}, attrs: n, slots: t, name: "Portal" }));
  };
} }), Mp = Symbol("PortalParentContext");
function WE() {
  let e = qn(Mp, null), t = fe([]);
  function n(a) {
    return t.value.push(a), e && e.register(a), () => r(a);
  }
  function r(a) {
    let o = t.value.indexOf(a);
    o !== -1 && t.value.splice(o, 1), e && e.unregister(a);
  }
  let i = { register: n, unregister: r, portals: t };
  return [t, Tt({ name: "PortalWrapper", setup(a, { slots: o }) {
    return Dr(Mp, i), () => {
      var s;
      return (s = o.default) == null ? void 0 : s.call(o);
    };
  } })];
}
let HE = Symbol("PortalGroupContext"), sU = Tt({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: n }) {
  let r = Uo({ resolveTarget() {
    return e.target;
  } });
  return Dr(HE, r), () => {
    let { target: i, ...a } = e;
    return Un({ theirProps: a, ourProps: {}, slot: {}, attrs: t, slots: n, name: "PortalGroup" });
  };
} });
var lU = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(lU || {});
let Ip = Symbol("DialogContext");
function gu(e) {
  let t = qn(Ip, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, gu), n;
  }
  return t;
}
let Ec = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", uU = Tt({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: Ec }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
  var a, o;
  let s = (a = e.id) != null ? a : `headlessui-dialog-${zr()}`, u = fe(!1);
  Mt(() => {
    u.value = !0;
  });
  let d = !1, f = oe(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (d || (d = !0, console.warn(`Invalid role [${f}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), p = fe(0), m = mu(), g = oe(() => e.open === Ec && m !== null ? (m.value & Mn.Open) === Mn.Open : e.open), v = fe(null), b = oe(() => Vi(v));
  if (i({ el: v, $el: v }), !(e.open !== Ec || m !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof g.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${g.value === Ec ? void 0 : e.open}`);
  let w = oe(() => u.value && g.value ? 0 : 1), T = oe(() => w.value === 0), S = oe(() => p.value > 1), x = qn(Ip, null) !== null, [O, C] = WE(), { resolveContainers: P, mainTreeNodeRef: k, MainTreeNode: M } = FE({ portals: O, defaultContainers: [oe(() => {
    var J;
    return (J = y.panelRef.value) != null ? J : v.value;
  })] }), N = oe(() => S.value ? "parent" : "leaf"), X = oe(() => m !== null ? (m.value & Mn.Closing) === Mn.Closing : !1), Z = oe(() => x || X.value ? !1 : T.value), te = oe(() => {
    var J, me, xe;
    return (xe = Array.from((me = (J = b.value) == null ? void 0 : J.querySelectorAll("body > *")) != null ? me : []).find((U) => U.id === "headlessui-portal-root" ? !1 : U.contains($e(k)) && U instanceof HTMLElement)) != null ? xe : null;
  });
  tb(te, Z);
  let ce = oe(() => S.value ? !0 : T.value), we = oe(() => {
    var J, me, xe;
    return (xe = Array.from((me = (J = b.value) == null ? void 0 : J.querySelectorAll("[data-headlessui-portal]")) != null ? me : []).find((U) => U.contains($e(k)) && U instanceof HTMLElement)) != null ? xe : null;
  });
  tb(we, ce), nU({ type: "Dialog", enabled: oe(() => w.value === 0), element: v, onUpdate: (J, me) => {
    if (me === "Dialog") return lr(J, { [Dp.Add]: () => p.value += 1, [Dp.Remove]: () => p.value -= 1 });
  } });
  let G = iU({ name: "DialogDescription", slot: oe(() => ({ open: g.value })) }), Q = fe(null), y = { titleId: Q, panelRef: fe(null), dialogState: w, setTitleId(J) {
    Q.value !== J && (Q.value = J);
  }, close() {
    t("close", !1);
  } };
  Dr(Ip, y);
  let H = oe(() => !(!T.value || S.value));
  CE(P, (J, me) => {
    J.preventDefault(), y.close(), $a(() => me == null ? void 0 : me.focus());
  }, H);
  let ie = oe(() => !(S.value || w.value !== 0));
  Ym((o = b.value) == null ? void 0 : o.defaultView, "keydown", (J) => {
    ie.value && (J.defaultPrevented || J.key === ra.Escape && (J.preventDefault(), J.stopPropagation(), y.close()));
  });
  let ne = oe(() => !(X.value || w.value !== 0 || x));
  return QB(b, ne, (J) => {
    var me;
    return { containers: [...(me = J.containers) != null ? me : [], P] };
  }), _r((J) => {
    if (w.value !== 0) return;
    let me = $e(v);
    if (!me) return;
    let xe = new ResizeObserver((U) => {
      for (let $ of U) {
        let Y = $.target.getBoundingClientRect();
        Y.x === 0 && Y.y === 0 && Y.width === 0 && Y.height === 0 && y.close();
      }
    });
    xe.observe(me), J(() => xe.disconnect());
  }), () => {
    let { open: J, initialFocus: me, ...xe } = e, U = { ...n, ref: v, id: s, role: f.value, "aria-modal": w.value === 0 ? !0 : void 0, "aria-labelledby": Q.value, "aria-describedby": G.value }, $ = { open: w.value === 0 };
    return Ct(Ap, { force: !0 }, () => [Ct(UE, () => Ct(sU, { target: v.value }, () => Ct(Ap, { force: !1 }, () => Ct(ul, { initialFocus: me, containers: P, features: T.value ? lr(N.value, { parent: ul.features.RestoreFocus, leaf: ul.features.All & ~ul.features.FocusLock }) : ul.features.None }, () => Ct(C, {}, () => Un({ ourProps: U, theirProps: { ...xe, ...n }, slot: $, attrs: n, slots: r, visible: w.value === 0, features: Ba.RenderStrategy | Ba.Static, name: "Dialog" })))))), Ct(M)]);
  };
} });
Tt({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-dialog-overlay-${zr()}`, a = gu("DialogOverlay");
  function o(s) {
    s.target === s.currentTarget && (s.preventDefault(), s.stopPropagation(), a.close());
  }
  return () => {
    let { ...s } = e;
    return Un({ ourProps: { id: i, "aria-hidden": !0, onClick: o }, theirProps: s, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogOverlay" });
  };
} });
Tt({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-dialog-backdrop-${zr()}`, o = gu("DialogBackdrop"), s = fe(null);
  return r({ el: s, $el: s }), Mt(() => {
    if (o.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...u } = e, d = { id: a, ref: s, "aria-hidden": !0 };
    return Ct(Ap, { force: !0 }, () => Ct(UE, () => Un({ ourProps: d, theirProps: { ...t, ...u }, slot: { open: o.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogBackdrop" })));
  };
} });
let cU = Tt({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-dialog-panel-${zr()}`, o = gu("DialogPanel");
  r({ el: o.panelRef, $el: o.panelRef });
  function s(u) {
    u.stopPropagation();
  }
  return () => {
    let { ...u } = e, d = { id: a, ref: o.panelRef, onClick: s };
    return Un({ ourProps: d, theirProps: u, slot: { open: o.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogPanel" });
  };
} });
Tt({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-dialog-title-${zr()}`, a = gu("DialogTitle");
  return Mt(() => {
    a.setTitleId(i), Bn(() => a.setTitleId(null));
  }), () => {
    let { ...o } = e;
    return Un({ ourProps: { id: i }, theirProps: o, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogTitle" });
  };
} });
var dU = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(dU || {});
let jE = Symbol("PopoverContext");
function Nd(e) {
  let t = qn(jE, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <${qE.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Nd), n;
  }
  return t;
}
let YE = Symbol("PopoverGroupContext");
function zE() {
  return qn(YE, null);
}
let GE = Symbol("PopoverPanelContext");
function fU() {
  return qn(GE, null);
}
let qE = Tt({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n, expose: r }) {
  var i;
  let a = fe(null);
  r({ el: a, $el: a });
  let o = fe(1), s = fe(null), u = fe(null), d = fe(null), f = fe(null), p = oe(() => Vi(a)), m = oe(() => {
    var C, P;
    if (!$e(s) || !$e(f)) return !1;
    for (let ce of document.querySelectorAll("body > *")) if (Number(ce == null ? void 0 : ce.contains($e(s))) ^ Number(ce == null ? void 0 : ce.contains($e(f)))) return !0;
    let k = Id(), M = k.indexOf($e(s)), N = (M + k.length - 1) % k.length, X = (M + 1) % k.length, Z = k[N], te = k[X];
    return !((C = $e(f)) != null && C.contains(Z)) && !((P = $e(f)) != null && P.contains(te));
  }), g = { popoverState: o, buttonId: fe(null), panelId: fe(null), panel: f, button: s, isPortalled: m, beforePanelSentinel: u, afterPanelSentinel: d, togglePopover() {
    o.value = lr(o.value, { 0: 1, 1: 0 });
  }, closePopover() {
    o.value !== 1 && (o.value = 1);
  }, close(C) {
    g.closePopover();
    let P = C ? C instanceof HTMLElement ? C : C.value instanceof HTMLElement ? $e(C) : $e(g.button) : $e(g.button);
    P == null || P.focus();
  } };
  Dr(jE, g), IE(oe(() => lr(o.value, { 0: Mn.Open, 1: Mn.Closed })));
  let v = { buttonId: g.buttonId, panelId: g.panelId, close() {
    g.closePopover();
  } }, b = zE(), w = b == null ? void 0 : b.registerPopover, [T, S] = WE(), x = FE({ mainTreeNodeRef: b == null ? void 0 : b.mainTreeNodeRef, portals: T, defaultContainers: [s, f] });
  function O() {
    var C, P, k, M;
    return (M = b == null ? void 0 : b.isFocusWithinPopoverGroup()) != null ? M : ((C = p.value) == null ? void 0 : C.activeElement) && (((P = $e(s)) == null ? void 0 : P.contains(p.value.activeElement)) || ((k = $e(f)) == null ? void 0 : k.contains(p.value.activeElement)));
  }
  return _r(() => w == null ? void 0 : w(v)), Ym((i = p.value) == null ? void 0 : i.defaultView, "focus", (C) => {
    var P, k;
    C.target !== window && C.target instanceof HTMLElement && o.value === 0 && (O() || s && f && (x.contains(C.target) || (P = $e(g.beforePanelSentinel)) != null && P.contains(C.target) || (k = $e(g.afterPanelSentinel)) != null && k.contains(C.target) || g.closePopover()));
  }, !0), CE(x.resolveContainers, (C, P) => {
    var k;
    g.closePopover(), kE(P, jm.Loose) || (C.preventDefault(), (k = $e(s)) == null || k.focus());
  }, oe(() => o.value === 0)), () => {
    let C = { open: o.value === 0, close: g.close };
    return Ct(Ge, [Ct(S, {}, () => Un({ theirProps: { ...e, ...n }, ourProps: { ref: a }, slot: C, slots: t, attrs: n, name: "Popover" })), Ct(x.MainTreeNode)]);
  };
} }), hU = Tt({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-popover-button-${zr()}`, o = Nd("PopoverButton"), s = oe(() => Vi(o.button));
  r({ el: o.button, $el: o.button }), Mt(() => {
    o.buttonId.value = a;
  }), Bn(() => {
    o.buttonId.value = null;
  });
  let u = zE(), d = u == null ? void 0 : u.closeOthers, f = fU(), p = oe(() => f === null ? !1 : f.value === o.panelId.value), m = fe(null), g = `headlessui-focus-sentinel-${zr()}`;
  p.value || _r(() => {
    o.button.value = $e(m);
  });
  let v = $B(oe(() => ({ as: e.as, type: t.type })), m);
  function b(C) {
    var P, k, M, N, X;
    if (p.value) {
      if (o.popoverState.value === 1) return;
      switch (C.key) {
        case ra.Space:
        case ra.Enter:
          C.preventDefault(), (k = (P = C.target).click) == null || k.call(P), o.closePopover(), (M = $e(o.button)) == null || M.focus();
          break;
      }
    } else switch (C.key) {
      case ra.Space:
      case ra.Enter:
        C.preventDefault(), C.stopPropagation(), o.popoverState.value === 1 && (d == null || d(o.buttonId.value)), o.togglePopover();
        break;
      case ra.Escape:
        if (o.popoverState.value !== 0) return d == null ? void 0 : d(o.buttonId.value);
        if (!$e(o.button) || (N = s.value) != null && N.activeElement && !((X = $e(o.button)) != null && X.contains(s.value.activeElement))) return;
        C.preventDefault(), C.stopPropagation(), o.closePopover();
        break;
    }
  }
  function w(C) {
    p.value || C.key === ra.Space && C.preventDefault();
  }
  function T(C) {
    var P, k;
    e.disabled || (p.value ? (o.closePopover(), (P = $e(o.button)) == null || P.focus()) : (C.preventDefault(), C.stopPropagation(), o.popoverState.value === 1 && (d == null || d(o.buttonId.value)), o.togglePopover(), (k = $e(o.button)) == null || k.focus()));
  }
  function S(C) {
    C.preventDefault(), C.stopPropagation();
  }
  let x = zm();
  function O() {
    let C = $e(o.panel);
    if (!C) return;
    function P() {
      lr(x.value, { [Hr.Forwards]: () => gi(C, ir.First), [Hr.Backwards]: () => gi(C, ir.Last) }) === ql.Error && gi(Id().filter((k) => k.dataset.headlessuiFocusGuard !== "true"), lr(x.value, { [Hr.Forwards]: ir.Next, [Hr.Backwards]: ir.Previous }), { relativeTo: $e(o.button) });
    }
    P();
  }
  return () => {
    let C = o.popoverState.value === 0, P = { open: C }, { ...k } = e, M = p.value ? { ref: m, type: v.value, onKeydown: b, onClick: T } : { ref: m, id: a, type: v.value, "aria-expanded": o.popoverState.value === 0, "aria-controls": $e(o.panel) ? o.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onKeydown: b, onKeyup: w, onClick: T, onMousedown: S };
    return Ct(Ge, [Un({ ourProps: M, theirProps: { ...t, ...k }, slot: P, attrs: t, slots: n, name: "PopoverButton" }), C && !p.value && o.isPortalled.value && Ct(Io, { id: g, features: Ua.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: O })]);
  };
} });
Tt({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(e, { attrs: t, slots: n }) {
  let r = Nd("PopoverOverlay"), i = `headlessui-popover-overlay-${zr()}`, a = mu(), o = oe(() => a !== null ? (a.value & Mn.Open) === Mn.Open : r.popoverState.value === 0);
  function s() {
    r.closePopover();
  }
  return () => {
    let u = { open: r.popoverState.value === 0 };
    return Un({ ourProps: { id: i, "aria-hidden": !0, onClick: s }, theirProps: e, slot: u, attrs: t, slots: n, features: Ba.RenderStrategy | Ba.Static, visible: o.value, name: "PopoverOverlay" });
  };
} });
let pU = Tt({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-popover-panel-${zr()}`, { focus: o } = e, s = Nd("PopoverPanel"), u = oe(() => Vi(s.panel)), d = `headlessui-focus-sentinel-before-${zr()}`, f = `headlessui-focus-sentinel-after-${zr()}`;
  r({ el: s.panel, $el: s.panel }), Mt(() => {
    s.panelId.value = a;
  }), Bn(() => {
    s.panelId.value = null;
  }), Dr(GE, s.panelId), _r(() => {
    var S, x;
    if (!o || s.popoverState.value !== 0 || !s.panel) return;
    let O = (S = u.value) == null ? void 0 : S.activeElement;
    (x = $e(s.panel)) != null && x.contains(O) || gi($e(s.panel), ir.First);
  });
  let p = mu(), m = oe(() => p !== null ? (p.value & Mn.Open) === Mn.Open : s.popoverState.value === 0);
  function g(S) {
    var x, O;
    switch (S.key) {
      case ra.Escape:
        if (s.popoverState.value !== 0 || !$e(s.panel) || u.value && !((x = $e(s.panel)) != null && x.contains(u.value.activeElement))) return;
        S.preventDefault(), S.stopPropagation(), s.closePopover(), (O = $e(s.button)) == null || O.focus();
        break;
    }
  }
  function v(S) {
    var x, O, C, P, k;
    let M = S.relatedTarget;
    M && $e(s.panel) && ((x = $e(s.panel)) != null && x.contains(M) || (s.closePopover(), ((C = (O = $e(s.beforePanelSentinel)) == null ? void 0 : O.contains) != null && C.call(O, M) || (k = (P = $e(s.afterPanelSentinel)) == null ? void 0 : P.contains) != null && k.call(P, M)) && M.focus({ preventScroll: !0 })));
  }
  let b = zm();
  function w() {
    let S = $e(s.panel);
    if (!S) return;
    function x() {
      lr(b.value, { [Hr.Forwards]: () => {
        var O;
        gi(S, ir.First) === ql.Error && ((O = $e(s.afterPanelSentinel)) == null || O.focus());
      }, [Hr.Backwards]: () => {
        var O;
        (O = $e(s.button)) == null || O.focus({ preventScroll: !0 });
      } });
    }
    x();
  }
  function T() {
    let S = $e(s.panel);
    if (!S) return;
    function x() {
      lr(b.value, { [Hr.Forwards]: () => {
        let O = $e(s.button), C = $e(s.panel);
        if (!O) return;
        let P = Id(), k = P.indexOf(O), M = P.slice(0, k + 1), N = [...P.slice(k + 1), ...M];
        for (let X of N.slice()) if (X.dataset.headlessuiFocusGuard === "true" || C != null && C.contains(X)) {
          let Z = N.indexOf(X);
          Z !== -1 && N.splice(Z, 1);
        }
        gi(N, ir.First, { sorted: !1 });
      }, [Hr.Backwards]: () => {
        var O;
        gi(S, ir.Previous) === ql.Error && ((O = $e(s.button)) == null || O.focus());
      } });
    }
    x();
  }
  return () => {
    let S = { open: s.popoverState.value === 0, close: s.close }, { focus: x, ...O } = e, C = { ref: s.panel, id: a, onKeydown: g, onFocusout: o && s.popoverState.value === 0 ? v : void 0, tabIndex: -1 };
    return Un({ ourProps: C, theirProps: { ...t, ...O }, attrs: t, slot: S, slots: { ...n, default: (...P) => {
      var k;
      return [Ct(Ge, [m.value && s.isPortalled.value && Ct(Io, { id: d, ref: s.beforePanelSentinel, features: Ua.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: w }), (k = n.default) == null ? void 0 : k.call(n, ...P), m.value && s.isPortalled.value && Ct(Io, { id: f, ref: s.afterPanelSentinel, features: Ua.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: T })])];
    } }, features: Ba.RenderStrategy | Ba.Static, visible: m.value, name: "PopoverPanel" });
  };
} });
Tt({ name: "PopoverGroup", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: t, slots: n, expose: r }) {
  let i = fe(null), a = su([]), o = oe(() => Vi(i)), s = JB();
  r({ el: i, $el: i });
  function u(m) {
    let g = a.value.indexOf(m);
    g !== -1 && a.value.splice(g, 1);
  }
  function d(m) {
    return a.value.push(m), () => {
      u(m);
    };
  }
  function f() {
    var m;
    let g = o.value;
    if (!g) return !1;
    let v = g.activeElement;
    return (m = $e(i)) != null && m.contains(v) ? !0 : a.value.some((b) => {
      var w, T;
      return ((w = g.getElementById(b.buttonId.value)) == null ? void 0 : w.contains(v)) || ((T = g.getElementById(b.panelId.value)) == null ? void 0 : T.contains(v));
    });
  }
  function p(m) {
    for (let g of a.value) g.buttonId.value !== m && g.close();
  }
  return Dr(YE, { registerPopover: d, unregisterPopover: u, isFocusWithinPopoverGroup: f, closeOthers: p, mainTreeNodeRef: s.mainTreeNodeRef }), () => Ct(Ge, [Un({ ourProps: { ref: i }, theirProps: { ...e, ...t }, slot: {}, attrs: t, slots: n, name: "PopoverGroup" }), Ct(s.MainTreeNode)]);
} });
function mU(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called) return t.called = !0, e(...n);
  };
}
function Vh(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Tc(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var Np = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Np || {});
function gU(e, t) {
  let n = hu();
  if (!e) return n.dispose;
  let { transitionDuration: r, transitionDelay: i } = getComputedStyle(e), [a, o] = [r, i].map((s) => {
    let [u = 0] = s.split(",").filter(Boolean).map((d) => d.includes("ms") ? parseFloat(d) : parseFloat(d) * 1e3).sort((d, f) => f - d);
    return u;
  });
  return a !== 0 ? n.setTimeout(() => t("finished"), a + o) : t("finished"), n.add(() => t("cancelled")), n.dispose;
}
function rb(e, t, n, r, i, a) {
  let o = hu(), s = a !== void 0 ? mU(a) : () => {
  };
  return Tc(e, ...i), Vh(e, ...t, ...n), o.nextFrame(() => {
    Tc(e, ...n), Vh(e, ...r), o.add(gU(e, (u) => (Tc(e, ...r, ...t), Vh(e, ...i), s(u))));
  }), o.add(() => Tc(e, ...t, ...n, ...r, ...i)), o.add(() => s("cancelled")), o.dispose;
}
function ho(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let Gm = Symbol("TransitionContext");
var vU = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(vU || {});
function _U() {
  return qn(Gm, null) !== null;
}
function yU() {
  let e = qn(Gm, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function bU() {
  let e = qn(qm, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let qm = Symbol("NestingContext");
function Ld(e) {
  return "children" in e ? Ld(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function KE(e) {
  let t = fe([]), n = fe(!1);
  Mt(() => n.value = !0), Bn(() => n.value = !1);
  function r(a, o = Pa.Hidden) {
    let s = t.value.findIndex(({ id: u }) => u === a);
    s !== -1 && (lr(o, { [Pa.Unmount]() {
      t.value.splice(s, 1);
    }, [Pa.Hidden]() {
      t.value[s].state = "hidden";
    } }), !Ld(t) && n.value && (e == null || e()));
  }
  function i(a) {
    let o = t.value.find(({ id: s }) => s === a);
    return o ? o.state !== "visible" && (o.state = "visible") : t.value.push({ id: a, state: "visible" }), () => r(a, Pa.Unmount);
  }
  return { children: t, register: i, unregister: r };
}
let XE = Ba.RenderStrategy, ZE = Tt({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
  let a = fe(0);
  function o() {
    a.value |= Mn.Opening, t("beforeEnter");
  }
  function s() {
    a.value &= ~Mn.Opening, t("afterEnter");
  }
  function u() {
    a.value |= Mn.Closing, t("beforeLeave");
  }
  function d() {
    a.value &= ~Mn.Closing, t("afterLeave");
  }
  if (!_U() && BB()) return () => Ct(QE, { ...e, onBeforeEnter: o, onAfterEnter: s, onBeforeLeave: u, onAfterLeave: d }, r);
  let f = fe(null), p = oe(() => e.unmount ? Pa.Unmount : Pa.Hidden);
  i({ el: f, $el: f });
  let { show: m, appear: g } = yU(), { register: v, unregister: b } = bU(), w = fe(m.value ? "visible" : "hidden"), T = { value: !0 }, S = zr(), x = { value: !1 }, O = KE(() => {
    !x.value && w.value !== "hidden" && (w.value = "hidden", b(S), d());
  });
  Mt(() => {
    let ce = v(S);
    Bn(ce);
  }), _r(() => {
    if (p.value === Pa.Hidden && S) {
      if (m.value && w.value !== "visible") {
        w.value = "visible";
        return;
      }
      lr(w.value, { hidden: () => b(S), visible: () => v(S) });
    }
  });
  let C = ho(e.enter), P = ho(e.enterFrom), k = ho(e.enterTo), M = ho(e.entered), N = ho(e.leave), X = ho(e.leaveFrom), Z = ho(e.leaveTo);
  Mt(() => {
    _r(() => {
      if (w.value === "visible") {
        let ce = $e(f);
        if (ce instanceof Comment && ce.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function te(ce) {
    let we = T.value && !g.value, G = $e(f);
    !G || !(G instanceof HTMLElement) || we || (x.value = !0, m.value && o(), m.value || u(), ce(m.value ? rb(G, C, P, k, M, (Q) => {
      x.value = !1, Q === Np.Finished && s();
    }) : rb(G, N, X, Z, M, (Q) => {
      x.value = !1, Q === Np.Finished && (Ld(O) || (w.value = "hidden", b(S), d()));
    })));
  }
  return Mt(() => {
    dn([m], (ce, we, G) => {
      te(G), T.value = !1;
    }, { immediate: !0 });
  }), Dr(qm, O), IE(oe(() => lr(w.value, { visible: Mn.Open, hidden: Mn.Closed }) | a.value)), () => {
    let { appear: ce, show: we, enter: G, enterFrom: Q, enterTo: y, entered: H, leave: ie, leaveFrom: ne, leaveTo: J, ...me } = e, xe = { ref: f }, U = { ...me, ...g.value && m.value && pu.isServer ? { class: ze([n.class, me.class, ...C, ...P]) } : {} };
    return Un({ theirProps: U, ourProps: xe, slot: {}, slots: r, attrs: n, features: XE, visible: w.value === "visible", name: "TransitionChild" });
  };
} }), wU = ZE, QE = Tt({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: r }) {
  let i = mu(), a = oe(() => e.show === null && i !== null ? (i.value & Mn.Open) === Mn.Open : e.show);
  _r(() => {
    if (![!0, !1].includes(a.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let o = fe(a.value ? "visible" : "hidden"), s = KE(() => {
    o.value = "hidden";
  }), u = fe(!0), d = { show: a, appear: oe(() => e.appear || !u.value) };
  return Mt(() => {
    _r(() => {
      u.value = !1, a.value ? o.value = "visible" : Ld(s) || (o.value = "hidden");
    });
  }), Dr(qm, s), Dr(Gm, d), () => {
    let f = PE(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), p = { unmount: e.unmount };
    return Un({ ourProps: { ...p, as: "template" }, theirProps: {}, slot: {}, slots: { ...r, default: () => [Ct(wU, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...n, ...p, ...f }, r.default)] }, attrs: {}, features: XE, visible: o.value === "visible", name: "Transition" });
  };
} });
function xU(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "fill-rule": "evenodd",
      d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    })
  ]);
}
function EU(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "fill-rule": "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    })
  ]);
}
function TU(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }),
    Ae("path", {
      "fill-rule": "evenodd",
      d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
      "clip-rule": "evenodd"
    })
  ]);
}
function kU(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "fill-rule": "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      "clip-rule": "evenodd"
    })
  ]);
}
function SU(e, t) {
  return I(), Oe("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    Ae("path", {
      "fill-rule": "evenodd",
      d: "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
      "clip-rule": "evenodd"
    })
  ]);
}
const OU = {
  components: {
    Popover: qE,
    PopoverButton: hU,
    PopoverPanel: pU,
    SearchIcon: K4,
    ChevronDownIcon: xU
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: Array,
      required: !0
    },
    enableSelectAll: {
      type: Boolean,
      default: !0
    },
    searchKeywordThreshold: {
      type: Number,
      default: 9
    }
  },
  emits: ["update:modelValue", "keyword"],
  data() {
    return {
      searchKeyword: "",
      debounce: null
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    filteredOptions() {
      return this.searchKeyword === "" ? this.options : this.options.filter((e) => e.label.toLowerCase().includes(this.searchKeyword.toLowerCase()));
    }
  },
  watch: {
    searchKeyword(e) {
      this.$emit("keyword", e);
    }
  },
  methods: {
    debounceSearch(e) {
      clearTimeout(this.debounce), this.debounce = setTimeout(() => {
        this.searchKeyword = e.target.value;
      }, 500);
    },
    clear() {
      this.internalValue = [], this.searchKeyword = "";
    },
    selectAll() {
      this.internalValue = [
        .../* @__PURE__ */ new Set([
          ...this.internalValue,
          ...this.filteredOptions.map((e) => e.value)
        ])
      ];
    }
  }
}, CU = {
  key: 0,
  class: "ml-1.5 rounded py-0.5 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums"
}, AU = {
  key: 0,
  class: "rounded-md shadow-sm mb-2 w-88"
}, DU = { class: "relative flex-grow" }, PU = { class: "absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" }, MU = ["name", "id", "placeholder", "value"], IU = ["name", "id", "placeholder", "value"], NU = { class: "flex gap-2 items-center my-2" }, LU = ["id", "value"], RU = ["for"];
function FU(e, t, n, r, i, a) {
  const o = je("ChevronDownIcon"), s = je("PopoverButton"), u = je("SearchIcon"), d = je("PopoverPanel"), f = je("Popover");
  return I(), W("div", null, [
    Ae(f, {
      as: "div",
      id: "desktop-menu",
      class: "relative inline-block text-left"
    }, {
      default: Ve(() => [
        K("div", null, [
          Ae(s, { class: "z-30 group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900" }, {
            default: Ve(() => [
              K("span", null, ke(e.$t(n.label)), 1),
              a.internalValue.length > 0 ? (I(), W("span", CU, ke(a.internalValue.length), 1)) : ee("", !0),
              Ae(o, {
                class: "flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          })
        ]),
        Ae(Wo, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: Ve(() => [
            Ae(d, { class: "z-40 origin-top-right absolute right-0 mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black ring-opacity-5 focus:outline-none max-h-56 overflow-y-scroll" }, {
              default: Ve(() => [
                n.options.length >= n.searchKeywordThreshold ? (I(), W("div", AU, [
                  K("div", DU, [
                    K("div", PU, [
                      Ae(u, {
                        class: "h-3 w-3 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ]),
                    K("input", {
                      type: "text",
                      name: `search-mobile-filter-${n.name}`,
                      id: `search-mobile-filter-${n.name}`,
                      class: "focus:ring-primary focus:border-primary block w-full rounded-md pl-10 sm:hidden border-gray-300",
                      placeholder: e.$t(`Search ${n.name.toLowerCase()}`),
                      onInput: t[0] || (t[0] = (...p) => a.debounceSearch && a.debounceSearch(...p)),
                      value: i.searchKeyword
                    }, null, 40, MU),
                    K("input", {
                      type: "text",
                      name: `search-desktop-filter-${n.name}`,
                      id: `search-desktop-filter-${n.name}`,
                      class: "hidden focus:ring-primary focus:border-primary min-w-full rounded-md pl-6 sm:block sm:text-xs border-gray-300 py-1",
                      placeholder: e.$t(`Search ${n.name.toLowerCase()}`),
                      onInput: t[1] || (t[1] = (...p) => a.debounceSearch && a.debounceSearch(...p)),
                      value: i.searchKeyword
                    }, null, 40, IU)
                  ])
                ])) : ee("", !0),
                K("div", NU, [
                  a.internalValue.length > 0 ? (I(), W("div", {
                    key: 0,
                    class: "text-center cursor-pointer inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary",
                    onClick: t[2] || (t[2] = (...p) => a.clear && a.clear(...p))
                  }, ke(e.$t("Clear")), 1)) : ee("", !0),
                  n.enableSelectAll && n.options.length !== a.internalValue.length ? (I(), W("div", {
                    key: 1,
                    class: "text-center cursor-pointer px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs rounded text-gray-700 bg-white hover:bg-gray-50",
                    onClick: t[3] || (t[3] = (...p) => a.selectAll && a.selectAll(...p))
                  }, ke(e.$t("Select All")), 1)) : ee("", !0)
                ]),
                (I(!0), W(Ge, null, Nt(a.filteredOptions, (p) => (I(), W("div", {
                  key: p.value,
                  class: "flex items-center w-88"
                }, [
                  Ni(K("input", {
                    id: `filter-${n.name}-${p.value}`,
                    type: "checkbox",
                    class: "h-4 w-4 border-gray-300 rounded text-primary-dark focus:ring-primary",
                    value: p.value,
                    "onUpdate:modelValue": t[4] || (t[4] = (m) => a.internalValue = m)
                  }, null, 8, LU), [
                    [oI, a.internalValue]
                  ]),
                  K("label", {
                    for: `filter-${n.name}-${p.value}`,
                    class: "ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap"
                  }, ke(p.label ? e.$t(p.label) : null), 9, RU)
                ]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const JE = /* @__PURE__ */ pt(OU, [["render", FU]]), $U = {
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    labelStyle: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    defaultOptionText: {
      type: String,
      default: "Choisir une option"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, VU = ["for"], BU = {
  key: 0,
  class: "text-red-600"
}, UU = ["id", "name", "value", "disabled"], WU = {
  disabled: "",
  key: "default",
  value: ""
}, HU = ["value"];
function jU(e, t, n, r, i, a) {
  return I(), W("div", null, [
    n.label ? (I(), W("label", {
      key: 0,
      for: n.id,
      class: ze(`my-2 block text-sm leading-6 text-gray-900 ${n.labelClass}`),
      style: ca(n.labelStyle)
    }, [
      Xt(ke(e.$t(n.label)) + " ", 1),
      n.required ? (I(), W("span", BU, "*")) : ee("", !0)
    ], 14, VU)) : ee("", !0),
    Ni(K("select", {
      id: n.id,
      name: n.name,
      value: n.modelValue,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
      disabled: n.disabled,
      class: ze([
        "block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-300 sm:text-sm sm:leading-6",
        n.disabled ? "bg-gray-200" : ""
      ])
    }, [
      K("option", WU, ke(n.defaultOptionText), 1),
      (I(!0), W(Ge, null, Nt(n.options, (o) => (I(), W("option", {
        key: o.value,
        value: o.value
      }, ke(o.label), 9, HU))), 128))
    ], 10, UU), [
      [sI, a.internalValue]
    ])
  ]);
}
const YU = /* @__PURE__ */ pt($U, [["render", jU]]), zU = {
  components: {
    Field: Dd
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    isPresent: ar
  }
}, GU = ["for"], qU = {
  key: 0,
  class: "text-red-600"
}, KU = { class: "relative" }, XU = ["id", "name", "disabled"];
function ZU(e, t, n, r, i, a) {
  return I(), W("div", null, [
    a.isPresent(n.label) ? (I(), W("label", {
      key: 0,
      for: n.id,
      class: ze(`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 ${n.labelClass}`)
    }, [
      Xt(ke(e.$t(n.label)) + " ", 1),
      n.required ? (I(), W("span", qU, "*")) : ee("", !0)
    ], 10, GU)) : ee("", !0),
    K("div", KU, [
      Ni(K("textarea", {
        id: n.id,
        name: n.id,
        class: ze(["shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md", n.disabled ? "bg-gray-200" : ""]),
        rows: "5",
        disabled: n.disabled,
        "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o)
      }, null, 10, XU), [
        [dm, a.internalValue]
      ])
    ])
  ]);
}
const Ree = /* @__PURE__ */ pt(zU, [["render", ZU]]), QU = {
  components: {
    InformationCircleIcon: kU
  },
  props: {
    type: {
      type: String,
      default: "info"
    }
  },
  computed: {
    color() {
      switch (this.type) {
        case "warning":
          return "yellow";
        case "error":
          return "red";
        case "success":
          return "green";
        default:
          return "blue";
      }
    }
  }
}, JU = { class: "flex items-center" }, e5 = { class: "flex-shrink-0" }, t5 = {
  key: 0,
  class: "card-icon"
}, n5 = { class: "ml-3" };
function r5(e, t, n, r, i, a) {
  const o = je("InformationCircleIcon");
  return I(), W("div", {
    class: ze(`mb-4 rounded-md bg-${a.color}-50 p-4 border-l-4 border-${a.color}-400`)
  }, [
    K("div", JU, [
      K("div", e5, [
        e.$slots.icon ? (I(), W("div", t5, [
          Ee(e.$slots, "icon")
        ])) : (I(), Oe(o, {
          key: 1,
          class: ze(`h-5 w-5 text-${a.color}-400`),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      ]),
      K("div", n5, [
        K("span", {
          class: ze(`text-sm text-${a.color}-700 font-bold`)
        }, [
          Ee(e.$slots, "title")
        ], 2),
        K("span", {
          class: ze(`text-xs text-${a.color}-700`)
        }, [
          Ee(e.$slots, "default")
        ], 2)
      ])
    ])
  ], 2);
}
const i5 = /* @__PURE__ */ pt(QU, [["render", r5]]), a5 = {
  components: { Datepicker: du },
  props: {
    placeholder: {
      type: String
    },
    modelValue: {
      type: Array,
      required: !0
    },
    useQueryParams: {
      type: Boolean,
      default: !1
    },
    ranges: {
      type: Array,
      default: () => []
    }
  },
  beforeMount() {
    this.useQueryParams && this.loadQueryParams();
  },
  data: () => ({
    defaultRanges: [
      {
        id: 1,
        label: "7 derniers jours",
        range: N4()
      },
      {
        id: 2,
        label: "4 dernières semaines",
        range: R4()
      },
      {
        id: 3,
        label: "3 derniers mois",
        range: $4()
      },
      {
        id: 5,
        label: "Semaine en cours",
        range: xE()
      },
      {
        id: 4,
        label: "Mois en cours",
        range: Wm()
      },
      {
        id: 6,
        label: "Année en cours",
        range: V4()
      }
    ]
  }),
  computed: {
    presetRanges() {
      const e = this.ranges.map((t, n) => ({
        id: n + this.defaultRanges.length + 1,
        label: t.label,
        range: t.range
      }));
      return [...this.defaultRanges, ...e];
    },
    internalValue: {
      get() {
        var e;
        return (e = this.modelValue) != null && e.every((t) => t == null) ? null : this.modelValue;
      },
      set(e) {
        let t = null, n = null;
        e && (t = Gl(e[0]), n = Gl(e[1])), this.useQueryParams && this.updateQueryParams(t, n), this.$emit("update:modelValue", [t, n]);
      }
    }
  },
  methods: {
    datePickerFormat(e) {
      const t = e[0], n = e[1];
      if (!t || !n) return "";
      if (t instanceof Date && n instanceof Date) {
        if (I4(t, n)) return "7 derniers jours";
        if (L4(t, n)) return "4 dernières semaines";
        if (F4(t, n)) return "3 derniers mois";
        if (Um(t, n)) return "Semaine en cours";
        if (Bm(t, n)) return "Mois en cours";
        if (EE(t, n)) return "Année en cours";
      }
      const r = this.$d(t, "long"), i = this.$d(n, "long");
      return `${r} → ${i}`;
    },
    loadQueryParams() {
      const e = this.$route.query.start_date, t = this.$route.query.end_date;
      e && t && (this.internalValue = [new Date(e), new Date(t)]);
    },
    updateQueryParams(e, t) {
      const n = { ...this.$route.query };
      !e || !t ? (delete n.start_date, delete n.end_date) : (n.start_date = e, n.end_date = t), this.$router.push({ query: n });
    }
  }
};
function o5(e, t, n, r, i, a) {
  const o = je("Datepicker");
  return I(), Oe(o, {
    placeholder: n.placeholder,
    class: "text-xs rounded-lg border-gray-300 shadow-md",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s),
    range: "",
    multiCalendars: "",
    presetRanges: a.presetRanges,
    autoApply: "",
    enableTimePicker: !1,
    format: a.datePickerFormat,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date()
  }, null, 8, ["placeholder", "modelValue", "presetRanges", "format", "max-date"]);
}
const s5 = /* @__PURE__ */ pt(a5, [["render", o5]]), l5 = {
  components: {
    PaperClipIcon: SU,
    EyeIcon: TU,
    ExclamationCircleIcon: EU
  },
  props: {
    declaration: {
      type: Object,
      required: !0
    },
    showAcknowledgments: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    answers() {
      return [
        {
          label: "Numéro de contrat",
          value: this.declaration.planSaleFriendlyId
        },
        {
          label: "Email",
          value: this.declaration.email
        },
        {
          label: "Produit",
          value: this.declaration.productId
        },
        {
          label: "Prénom",
          value: this.declaration.firstName,
          field: "first_name"
        },
        {
          label: "Nom",
          value: this.declaration.lastName,
          field: "last_name"
        },
        {
          label: "Téléphone",
          value: this.declaration.phone,
          field: "phone"
        },
        {
          label: "Date de naissance",
          value: this.declaration.birthDate,
          type: "date",
          field: "birth_date"
        },
        {
          label: "Carte d'identité",
          value: this.declaration.idCard,
          type: "files",
          field: "id_card"
        },
        {
          label: "Numéro de rue",
          value: this.declaration.streetNumber,
          field: "street_number"
        },
        {
          label: "Rue",
          value: this.declaration.street,
          field: "street"
        },
        {
          label: "Code postal",
          value: this.declaration.zipCode,
          field: "zip_code"
        },
        {
          label: "Ville",
          value: this.declaration.city,
          field: "city"
        },
        {
          label: "Pays",
          value: this.declaration.country,
          field: "country"
        },
        {
          label: "Date du sinistre",
          value: this.declaration.occurrenceDate,
          type: "date",
          field: "occurrence_date"
        },
        {
          label: "Le sinistre a eu lieu à domicile",
          value: this.declaration.occurredAtHome,
          type: "boolean",
          field: "occurred_at_home"
        },
        {
          label: "Lieu du sinistre",
          value: this.declaration.occurrencePlace,
          field: "occurrence_place"
        },
        {
          label: "Couverture",
          value: this.declaration.coverage,
          field: "coverage"
        },
        {
          label: "Type de vol",
          value: this.declaration.theftType,
          field: "theft_type"
        },
        {
          label: "Description",
          value: this.declaration.description,
          field: "description"
        },
        {
          label: "Dépôt de plainte",
          value: this.declaration.complaintsReceipt,
          type: "files",
          field: "complaints_receipt"
        },
        {
          label: "Facture d'achat du produit",
          value: this.declaration.productInvoice,
          type: "files",
          field: "product_invoice"
        },
        {
          label: "Facture d'achat de l'anti-vol",
          value: this.declaration.antiTheftDeviceInvoice,
          type: "files",
          field: "anti_theft_device_invoice"
        },
        {
          label: "Photos du produit",
          value: this.declaration.productPhotos,
          type: "files",
          field: "product_photos"
        },
        {
          label: "Numéro de marquage",
          value: this.declaration.markingNumber,
          field: "marking_number"
        },
        {
          label: "Assurance habitation",
          value: this.declaration.homeInsuranceCertificate,
          type: "files",
          field: "home_insurance_certificate"
        },
        {
          label: "Autre(s) documents",
          // for backward compatibility with the previous version
          value: this.declaration.othersDocuments,
          type: "files",
          field: "others_documents"
        },
        {
          label: "Acceptation conditions sur autre(s) indemnisations",
          value: this.declaration.otherCompensation,
          acknowledgment: !0,
          type: "boolean"
        },
        {
          label: "Acceptation déclaration dûment complétée",
          value: this.declaration.declarationCompleted,
          acknowledgment: !0,
          type: "boolean"
        }
      ].filter((e) => e.value !== null).filter(
        (e) => e.type === "files" ? e.value.length > 0 : !0
      ).filter((e) => this.showAcknowledgments ? !0 : e.acknowledgment !== !0);
    },
    declarationUpdateRequest() {
      return this.declaration.declarationUpdateRequest;
    }
  },
  methods: {
    answerToChange(e) {
      return !this.declarationUpdateRequest || !e.field ? !1 : this.declarationUpdateRequest.fields.includes(e.field);
    }
  }
}, u5 = { class: "bg-gray shadow overflow-hidden sm:rounded-lg" }, c5 = { class: "px-4 py-5 sm:px-6" }, d5 = { class: "border-t border-gray-200" }, f5 = { class: "text-sm font-medium text-gray-500" }, h5 = { class: "flex space-x-2" }, p5 = {
  key: 0,
  class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1"
}, m5 = {
  role: "list",
  class: "border border-gray-200 rounded-md divide-y divide-gray-200"
}, g5 = { class: "w-0 flex-1 flex" }, v5 = { class: "ml-2 flex-1 w-0 truncate" }, _5 = ["href"], y5 = {
  key: 1,
  class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1"
}, b5 = { key: 0 }, w5 = { key: 1 }, x5 = { key: 2 }, E5 = {
  key: 3,
  style: { "white-space": "pre-wrap" }
};
function T5(e, t, n, r, i, a) {
  const o = je("ExclamationCircleIcon"), s = je("PaperClipIcon"), u = je("EyeIcon");
  return I(), W("div", u5, [
    K("div", c5, [
      t[0] || (t[0] = K("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, " Réponses au formulaire de déclaration de sinistre ", -1)),
      Ee(e.$slots, "default")
    ]),
    K("div", d5, [
      K("dl", null, [
        (I(!0), W(Ge, null, Nt(a.answers, (d, f) => (I(), W("div", {
          class: "bg-white px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-2 sm:px-6 border-b border-gray-200",
          key: f
        }, [
          K("dt", f5, [
            K("div", h5, [
              K("p", null, ke(d.label), 1),
              a.answerToChange(d) ? (I(), Oe(o, {
                key: 0,
                class: "h-5 w-5 text-yellow-400",
                "aria-hidden": "true"
              })) : ee("", !0)
            ])
          ]),
          d.type === "files" ? (I(), W("dd", p5, [
            K("ul", m5, [
              (I(!0), W(Ge, null, Nt(d.value, (p) => (I(), W("li", {
                key: p.name,
                class: "pl-3 pr-4 py-3 flex items-center justify-between text-sm"
              }, [
                K("div", g5, [
                  Ae(s, {
                    class: "flex-shrink-0 h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  }),
                  K("span", v5, ke(p.name), 1),
                  K("a", {
                    class: "inline-flex p-1.5 border border-transparent rounded-full shadow-sm text-white bg-primary",
                    href: p.link,
                    target: "_blank"
                  }, [
                    Ae(u, {
                      class: "h-5 w-5",
                      "aria-hidden": "true"
                    })
                  ], 8, _5)
                ])
              ]))), 128))
            ])
          ])) : (I(), W("dd", y5, [
            d.type === "date" ? (I(), W("p", b5, ke(e.$d(d.value)), 1)) : d.type === "boolean" ? (I(), W("p", w5, ke(d.value ? "Oui" : "Non"), 1)) : e.$te(`claim.coverage.${d.value}`) ? (I(), W("p", x5, ke(e.$t(`claim.coverage.${d.value}`)), 1)) : (I(), W("p", E5, ke(d.value), 1))
          ]))
        ]))), 128))
      ])
    ])
  ]);
}
const Fee = /* @__PURE__ */ pt(l5, [["render", T5]]), k5 = {
  props: ["title", "value", "tooltipText"],
  components: {
    InformationCircleIcon: fu
  }
}, S5 = { class: "overflow-hidden rounded-lg bg-white px-2 py-4 shadow sm:p-4" }, O5 = { class: "flex gap-x-2" }, C5 = { class: "truncate text-sm font-medium text-gray-500" }, A5 = { class: "mt-1 text-2xl font-semibold tracking-tight text-gray-900" };
function D5(e, t, n, r, i, a) {
  const o = je("InformationCircleIcon"), s = je("VTooltip");
  return I(), W("div", S5, [
    K("div", O5, [
      K("dt", C5, ke(n.title), 1),
      n.tooltipText || e.$slots.tooltip ? (I(), Oe(s, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: Ve(() => [
          Ee(e.$slots, "tooltip", {}, () => [
            K("span", null, ke(n.tooltipText), 1)
          ])
        ]),
        default: Ve(() => [
          Ae(o, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : ee("", !0)
    ]),
    K("dd", A5, ke(n.value), 1)
  ]);
}
const P5 = /* @__PURE__ */ pt(k5, [["render", D5]]), M5 = {
  components: { ChevronDownIcon: W4, ChevronUpIcon: H4 },
  props: {
    open: {
      type: Boolean,
      default: !0,
      required: !1
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    subtitle: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      collapsed: !1
    };
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed, this.collapsed || this.$emit("openCollapse");
    }
  },
  watch: {
    open: {
      immediate: !0,
      handler() {
        this.collapsed = !this.open;
      }
    }
  }
}, I5 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" }, N5 = { class: "flex items-center items-stretch justify-between px-4 py-4 text-lg leading-6 font-medium text-gray-900" }, L5 = { class: "font-semibold" }, R5 = { class: "text-xs" }, F5 = { class: "flex" }, $5 = {
  key: 0,
  class: "flex flex-col border-t border-gray-200 bg-white"
};
function V5(e, t, n, r, i, a) {
  const o = je("ChevronDownIcon"), s = je("ChevronUpIcon");
  return I(), W("div", I5, [
    K("div", N5, [
      K("div", {
        class: "cursor-pointer flex-grow flex flex-col",
        onClick: t[0] || (t[0] = (...u) => a.toggleCollapse && a.toggleCollapse(...u))
      }, [
        K("h3", L5, ke(n.title), 1),
        K("p", R5, ke(n.subtitle), 1)
      ]),
      K("div", F5, [
        Ee(e.$slots, "header"),
        K("div", {
          class: "w-10 ml-2 cursor-pointer",
          onClick: t[1] || (t[1] = (...u) => a.toggleCollapse && a.toggleCollapse(...u))
        }, [
          i.collapsed ? (I(), Oe(o, { key: 0 })) : (I(), Oe(s, { key: 1 }))
        ])
      ])
    ]),
    i.collapsed ? ee("", !0) : (I(), W("div", $5, [
      Ee(e.$slots, "default")
    ]))
  ]);
}
const $ee = /* @__PURE__ */ pt(M5, [["render", V5]]);
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
function Qi() {
}
const B5 = /* @__PURE__ */ function() {
  let e = 0;
  return function() {
    return e++;
  };
}();
function ht(e) {
  return e === null || typeof e > "u";
}
function jt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function st(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
const pn = (e) => (typeof e == "number" || e instanceof Number) && isFinite(+e);
function ri(e, t) {
  return pn(e) ? e : t;
}
function nt(e, t) {
  return typeof e > "u" ? t : e;
}
const U5 = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : e / t, eT = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Ht(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function $t(e, t, n, r) {
  let i, a, o;
  if (jt(e))
    for (a = e.length, i = 0; i < a; i++)
      t.call(n, e[i], i);
  else if (st(e))
    for (o = Object.keys(e), a = o.length, i = 0; i < a; i++)
      t.call(n, e[o[i]], o[i]);
}
function dd(e, t) {
  let n, r, i, a;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (i = e[n], a = t[n], i.datasetIndex !== a.datasetIndex || i.index !== a.index)
      return !1;
  return !0;
}
function fd(e) {
  if (jt(e))
    return e.map(fd);
  if (st(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let i = 0;
    for (; i < r; ++i)
      t[n[i]] = fd(e[n[i]]);
    return t;
  }
  return e;
}
function tT(e) {
  return ["__proto__", "prototype", "constructor"].indexOf(e) === -1;
}
function W5(e, t, n, r) {
  if (!tT(e))
    return;
  const i = t[e], a = n[e];
  st(i) && st(a) ? $i(i, a, r) : t[e] = fd(a);
}
function $i(e, t, n) {
  const r = jt(t) ? t : [t], i = r.length;
  if (!st(e))
    return e;
  n = n || {};
  const a = n.merger || W5;
  for (let o = 0; o < i; ++o) {
    if (t = r[o], !st(t))
      continue;
    const s = Object.keys(t);
    for (let u = 0, d = s.length; u < d; ++u)
      a(s[u], e, t, n);
  }
  return e;
}
function Ll(e, t) {
  return $i(e, t, { merger: H5 });
}
function H5(e, t, n) {
  if (!tT(e))
    return;
  const r = t[e], i = n[e];
  st(r) && st(i) ? Ll(r, i) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = fd(i));
}
const ib = {
  "": (e) => e,
  x: (e) => e.x,
  y: (e) => e.y
};
function Wa(e, t) {
  return (ib[t] || (ib[t] = j5(t)))(e);
}
function j5(e) {
  const t = Y5(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function Y5(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const i of t)
    r += i, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function Km(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Sn = (e) => typeof e < "u", Ha = (e) => typeof e == "function", ab = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function z5(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Lt = Math.PI, zt = 2 * Lt, G5 = zt + Lt, hd = Number.POSITIVE_INFINITY, nT = Lt / 180, vn = Lt / 2, dl = Lt / 4, ob = Lt * 2 / 3, si = Math.log10, Ri = Math.sign;
function sb(e) {
  const t = Math.round(e);
  e = Rl(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(si(e))), r = e / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function q5(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((i, a) => i - a).pop(), t;
}
function Cs(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function Rl(e, t, n) {
  return Math.abs(e - t) < n;
}
function K5(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function rT(e, t, n) {
  let r, i, a;
  for (r = 0, i = e.length; r < i; r++)
    a = e[r][n], isNaN(a) || (t.min = Math.min(t.min, a), t.max = Math.max(t.max, a));
}
function An(e) {
  return e * (Lt / 180);
}
function Rd(e) {
  return e * (180 / Lt);
}
function lb(e) {
  if (!pn(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function iT(e, t) {
  const n = t.x - e.x, r = t.y - e.y, i = Math.sqrt(n * n + r * r);
  let a = Math.atan2(r, n);
  return a < -0.5 * Lt && (a += zt), {
    angle: a,
    distance: i
  };
}
function Kl(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function X5(e, t) {
  return (e - t + G5) % zt - Lt;
}
function Ur(e) {
  return (e % zt + zt) % zt;
}
function Xl(e, t, n, r) {
  const i = Ur(e), a = Ur(t), o = Ur(n), s = Ur(a - i), u = Ur(o - i), d = Ur(i - a), f = Ur(i - o);
  return i === a || i === o || r && a === o || s > u && d < f;
}
function Vn(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function Z5(e) {
  return Vn(e, -32768, 32767);
}
function da(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function Xm(e, t, n) {
  n = n || ((o) => e[o] < t);
  let r = e.length - 1, i = 0, a;
  for (; r - i > 1; )
    a = i + r >> 1, n(a) ? i = a : r = a;
  return { lo: i, hi: r };
}
const fa = (e, t, n, r) => Xm(e, n, r ? (i) => e[i][t] <= n : (i) => e[i][t] < n), Q5 = (e, t, n) => Xm(e, n, (r) => e[r][t] >= n);
function J5(e, t, n) {
  let r = 0, i = e.length;
  for (; r < i && e[r] < t; )
    r++;
  for (; i > r && e[i - 1] > n; )
    i--;
  return r > 0 || i < e.length ? e.slice(r, i) : e;
}
const aT = ["push", "pop", "shift", "splice", "unshift"];
function e6(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [t]
    }
  }), aT.forEach((n) => {
    const r = "_onData" + Km(n), i = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...a) {
        const o = i.apply(this, a);
        return e._chartjs.listeners.forEach((s) => {
          typeof s[r] == "function" && s[r](...a);
        }), o;
      }
    });
  });
}
function ub(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, i = r.indexOf(t);
  i !== -1 && r.splice(i, 1), !(r.length > 0) && (aT.forEach((a) => {
    delete e[a];
  }), delete e._chartjs);
}
function oT(e) {
  const t = /* @__PURE__ */ new Set();
  let n, r;
  for (n = 0, r = e.length; n < r; ++n)
    t.add(e[n]);
  return t.size === r ? e : Array.from(t);
}
const sT = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function lT(e, t, n) {
  const r = n || ((o) => Array.prototype.slice.call(o));
  let i = !1, a = [];
  return function(...o) {
    a = r(o), i || (i = !0, sT.call(window, () => {
      i = !1, e.apply(t, a);
    }));
  };
}
function t6(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const Zm = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", er = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, n6 = (e, t, n, r) => e === (r ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function uT(e, t, n) {
  const r = t.length;
  let i = 0, a = r;
  if (e._sorted) {
    const { iScale: o, _parsed: s } = e, u = o.axis, { min: d, max: f, minDefined: p, maxDefined: m } = o.getUserBounds();
    p && (i = Vn(
      Math.min(
        fa(s, o.axis, d).lo,
        n ? r : fa(t, u, o.getPixelForValue(d)).lo
      ),
      0,
      r - 1
    )), m ? a = Vn(
      Math.max(
        fa(s, o.axis, f, !0).hi + 1,
        n ? 0 : fa(t, u, o.getPixelForValue(f), !0).hi + 1
      ),
      i,
      r
    ) - i : a = r - i;
  }
  return { start: i, count: a };
}
function cT(e) {
  const { xScale: t, yScale: n, _scaleRanges: r } = e, i = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return e._scaleRanges = i, !0;
  const a = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, i), a;
}
const kc = (e) => e === 0 || e === 1, cb = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * zt / n)), db = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * zt / n) + 1, Fl = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * vn) + 1,
  easeOutSine: (e) => Math.sin(e * vn),
  easeInOutSine: (e) => -0.5 * (Math.cos(Lt * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => kc(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => kc(e) ? e : cb(e, 0.075, 0.3),
  easeOutElastic: (e) => kc(e) ? e : db(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return kc(e) ? e : e < 0.5 ? 0.5 * cb(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * db(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Fl.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Fl.easeInBounce(e * 2) * 0.5 : Fl.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */
function vu(e) {
  return e + 0.5 | 0;
}
const Ma = (e, t, n) => Math.max(Math.min(e, n), t);
function xl(e) {
  return Ma(vu(e * 2.55), 0, 255);
}
function Na(e) {
  return Ma(vu(e * 255), 0, 255);
}
function ia(e) {
  return Ma(vu(e / 2.55) / 100, 0, 1);
}
function fb(e) {
  return Ma(vu(e * 100), 0, 100);
}
const ni = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Lp = [..."0123456789ABCDEF"], r6 = (e) => Lp[e & 15], i6 = (e) => Lp[(e & 240) >> 4] + Lp[e & 15], Sc = (e) => (e & 240) >> 4 === (e & 15), a6 = (e) => Sc(e.r) && Sc(e.g) && Sc(e.b) && Sc(e.a);
function o6(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & ni[e[1]] * 17,
    g: 255 & ni[e[2]] * 17,
    b: 255 & ni[e[3]] * 17,
    a: t === 5 ? ni[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: ni[e[1]] << 4 | ni[e[2]],
    g: ni[e[3]] << 4 | ni[e[4]],
    b: ni[e[5]] << 4 | ni[e[6]],
    a: t === 9 ? ni[e[7]] << 4 | ni[e[8]] : 255
  })), n;
}
const s6 = (e, t) => e < 255 ? t(e) : "";
function l6(e) {
  var t = a6(e) ? r6 : i6;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + s6(e.a, t) : void 0;
}
const u6 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function dT(e, t, n) {
  const r = t * Math.min(n, 1 - n), i = (a, o = (a + e / 30) % 12) => n - r * Math.max(Math.min(o - 3, 9 - o, 1), -1);
  return [i(0), i(8), i(4)];
}
function c6(e, t, n) {
  const r = (i, a = (i + e / 60) % 6) => n - n * t * Math.max(Math.min(a, 4 - a, 1), 0);
  return [r(5), r(3), r(1)];
}
function d6(e, t, n) {
  const r = dT(e, 1, 0.5);
  let i;
  for (t + n > 1 && (i = 1 / (t + n), t *= i, n *= i), i = 0; i < 3; i++)
    r[i] *= 1 - t - n, r[i] += t;
  return r;
}
function f6(e, t, n, r, i) {
  return e === i ? (t - n) / r + (t < n ? 6 : 0) : t === i ? (n - e) / r + 2 : (e - t) / r + 4;
}
function Qm(e) {
  const n = e.r / 255, r = e.g / 255, i = e.b / 255, a = Math.max(n, r, i), o = Math.min(n, r, i), s = (a + o) / 2;
  let u, d, f;
  return a !== o && (f = a - o, d = s > 0.5 ? f / (2 - a - o) : f / (a + o), u = f6(n, r, i, f, a), u = u * 60 + 0.5), [u | 0, d || 0, s];
}
function Jm(e, t, n, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(Na);
}
function eg(e, t, n) {
  return Jm(dT, e, t, n);
}
function h6(e, t, n) {
  return Jm(d6, e, t, n);
}
function p6(e, t, n) {
  return Jm(c6, e, t, n);
}
function fT(e) {
  return (e % 360 + 360) % 360;
}
function m6(e) {
  const t = u6.exec(e);
  let n = 255, r;
  if (!t)
    return;
  t[5] !== r && (n = t[6] ? xl(+t[5]) : Na(+t[5]));
  const i = fT(+t[2]), a = +t[3] / 100, o = +t[4] / 100;
  return t[1] === "hwb" ? r = h6(i, a, o) : t[1] === "hsv" ? r = p6(i, a, o) : r = eg(i, a, o), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function g6(e, t) {
  var n = Qm(e);
  n[0] = fT(n[0] + t), n = eg(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function v6(e) {
  if (!e)
    return;
  const t = Qm(e), n = t[0], r = fb(t[1]), i = fb(t[2]);
  return e.a < 255 ? `hsla(${n}, ${r}%, ${i}%, ${ia(e.a)})` : `hsl(${n}, ${r}%, ${i}%)`;
}
const hb = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, pb = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function _6() {
  const e = {}, t = Object.keys(pb), n = Object.keys(hb);
  let r, i, a, o, s;
  for (r = 0; r < t.length; r++) {
    for (o = s = t[r], i = 0; i < n.length; i++)
      a = n[i], s = s.replace(a, hb[a]);
    a = parseInt(pb[o], 16), e[s] = [a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  return e;
}
let Oc;
function y6(e) {
  Oc || (Oc = _6(), Oc.transparent = [0, 0, 0, 0]);
  const t = Oc[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const b6 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function w6(e) {
  const t = b6.exec(e);
  let n = 255, r, i, a;
  if (t) {
    if (t[7] !== r) {
      const o = +t[7];
      n = t[8] ? xl(o) : Ma(o * 255, 0, 255);
    }
    return r = +t[1], i = +t[3], a = +t[5], r = 255 & (t[2] ? xl(r) : Ma(r, 0, 255)), i = 255 & (t[4] ? xl(i) : Ma(i, 0, 255)), a = 255 & (t[6] ? xl(a) : Ma(a, 0, 255)), {
      r,
      g: i,
      b: a,
      a: n
    };
  }
}
function x6(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${ia(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Bh = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, fs = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function E6(e, t, n) {
  const r = fs(ia(e.r)), i = fs(ia(e.g)), a = fs(ia(e.b));
  return {
    r: Na(Bh(r + n * (fs(ia(t.r)) - r))),
    g: Na(Bh(i + n * (fs(ia(t.g)) - i))),
    b: Na(Bh(a + n * (fs(ia(t.b)) - a))),
    a: e.a + n * (t.a - e.a)
  };
}
function Cc(e, t, n) {
  if (e) {
    let r = Qm(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = eg(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function hT(e, t) {
  return e && Object.assign(t || {}, e);
}
function mb(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Na(e[3]))) : (t = hT(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Na(t.a)), t;
}
function T6(e) {
  return e.charAt(0) === "r" ? w6(e) : m6(e);
}
class pd {
  constructor(t) {
    if (t instanceof pd)
      return t;
    const n = typeof t;
    let r;
    n === "object" ? r = mb(t) : n === "string" && (r = o6(t) || y6(t) || T6(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = hT(this._rgb);
    return t && (t.a = ia(t.a)), t;
  }
  set rgb(t) {
    this._rgb = mb(t);
  }
  rgbString() {
    return this._valid ? x6(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? l6(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? v6(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const r = this.rgb, i = t.rgb;
      let a;
      const o = n === a ? 0.5 : n, s = 2 * o - 1, u = r.a - i.a, d = ((s * u === -1 ? s : (s + u) / (1 + s * u)) + 1) / 2;
      a = 1 - d, r.r = 255 & d * r.r + a * i.r + 0.5, r.g = 255 & d * r.g + a * i.g + 0.5, r.b = 255 & d * r.b + a * i.b + 0.5, r.a = o * r.a + (1 - o) * i.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = E6(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new pd(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Na(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = vu(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Cc(this._rgb, 2, t), this;
  }
  darken(t) {
    return Cc(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Cc(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Cc(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return g6(this._rgb, t), this;
  }
}
function pT(e) {
  return new pd(e);
}
function mT(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function gb(e) {
  return mT(e) ? e : pT(e);
}
function Uh(e) {
  return mT(e) ? e : pT(e).saturate(0.5).darken(0.1).hexString();
}
const No = /* @__PURE__ */ Object.create(null), Rp = /* @__PURE__ */ Object.create(null);
function $l(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, i = n.length; r < i; ++r) {
    const a = n[r];
    e = e[a] || (e[a] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Wh(e, t, n) {
  return typeof t == "string" ? $i($l(e, t), n) : $i($l(e, ""), t);
}
class k6 {
  constructor(t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (n) => n.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (n, r) => Uh(r.backgroundColor), this.hoverBorderColor = (n, r) => Uh(r.borderColor), this.hoverColor = (n, r) => Uh(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t);
  }
  set(t, n) {
    return Wh(this, t, n);
  }
  get(t) {
    return $l(this, t);
  }
  describe(t, n) {
    return Wh(Rp, t, n);
  }
  override(t, n) {
    return Wh(No, t, n);
  }
  route(t, n, r, i) {
    const a = $l(this, t), o = $l(this, r), s = "_" + n;
    Object.defineProperties(a, {
      [s]: {
        value: a[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const u = this[s], d = o[i];
          return st(u) ? Object.assign({}, d, u) : nt(u, d);
        },
        set(u) {
          this[s] = u;
        }
      }
    });
  }
}
var yt = new k6({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
});
function S6(e) {
  return !e || ht(e.size) || ht(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function md(e, t, n, r, i) {
  let a = t[i];
  return a || (a = t[i] = e.measureText(i).width, n.push(i)), a > r && (r = a), r;
}
function O6(e, t, n, r) {
  r = r || {};
  let i = r.data = r.data || {}, a = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (i = r.data = {}, a = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let o = 0;
  const s = n.length;
  let u, d, f, p, m;
  for (u = 0; u < s; u++)
    if (p = n[u], p != null && jt(p) !== !0)
      o = md(e, i, a, o, p);
    else if (jt(p))
      for (d = 0, f = p.length; d < f; d++)
        m = p[d], m != null && !jt(m) && (o = md(e, i, a, o, m));
  e.restore();
  const g = a.length / 2;
  if (g > n.length) {
    for (u = 0; u < g; u++)
      delete i[a[u]];
    a.splice(0, g);
  }
  return o;
}
function po(e, t, n) {
  const r = e.currentDevicePixelRatio, i = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - i) * r) / r + i;
}
function vb(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function gd(e, t, n, r) {
  gT(e, t, n, r, null);
}
function gT(e, t, n, r, i) {
  let a, o, s, u, d, f;
  const p = t.pointStyle, m = t.rotation, g = t.radius;
  let v = (m || 0) * nT;
  if (p && typeof p == "object" && (a = p.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, r), e.rotate(v), e.drawImage(p, -p.width / 2, -p.height / 2, p.width, p.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), p) {
      default:
        i ? e.ellipse(n, r, i / 2, g, 0, 0, zt) : e.arc(n, r, g, 0, zt), e.closePath();
        break;
      case "triangle":
        e.moveTo(n + Math.sin(v) * g, r - Math.cos(v) * g), v += ob, e.lineTo(n + Math.sin(v) * g, r - Math.cos(v) * g), v += ob, e.lineTo(n + Math.sin(v) * g, r - Math.cos(v) * g), e.closePath();
        break;
      case "rectRounded":
        d = g * 0.516, u = g - d, o = Math.cos(v + dl) * u, s = Math.sin(v + dl) * u, e.arc(n - o, r - s, d, v - Lt, v - vn), e.arc(n + s, r - o, d, v - vn, v), e.arc(n + o, r + s, d, v, v + vn), e.arc(n - s, r + o, d, v + vn, v + Lt), e.closePath();
        break;
      case "rect":
        if (!m) {
          u = Math.SQRT1_2 * g, f = i ? i / 2 : u, e.rect(n - f, r - u, 2 * f, 2 * u);
          break;
        }
        v += dl;
      case "rectRot":
        o = Math.cos(v) * g, s = Math.sin(v) * g, e.moveTo(n - o, r - s), e.lineTo(n + s, r - o), e.lineTo(n + o, r + s), e.lineTo(n - s, r + o), e.closePath();
        break;
      case "crossRot":
        v += dl;
      case "cross":
        o = Math.cos(v) * g, s = Math.sin(v) * g, e.moveTo(n - o, r - s), e.lineTo(n + o, r + s), e.moveTo(n + s, r - o), e.lineTo(n - s, r + o);
        break;
      case "star":
        o = Math.cos(v) * g, s = Math.sin(v) * g, e.moveTo(n - o, r - s), e.lineTo(n + o, r + s), e.moveTo(n + s, r - o), e.lineTo(n - s, r + o), v += dl, o = Math.cos(v) * g, s = Math.sin(v) * g, e.moveTo(n - o, r - s), e.lineTo(n + o, r + s), e.moveTo(n + s, r - o), e.lineTo(n - s, r + o);
        break;
      case "line":
        o = i ? i / 2 : Math.cos(v) * g, s = Math.sin(v) * g, e.moveTo(n - o, r - s), e.lineTo(n + o, r + s);
        break;
      case "dash":
        e.moveTo(n, r), e.lineTo(n + Math.cos(v) * g, r + Math.sin(v) * g);
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function Zl(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function _u(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function yu(e) {
  e.restore();
}
function C6(e, t, n, r, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (i === "middle") {
    const a = (t.x + n.x) / 2;
    e.lineTo(a, t.y), e.lineTo(a, n.y);
  } else i === "after" != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function A6(e, t, n, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(
    r ? t.cp1x : t.cp2x,
    r ? t.cp1y : t.cp2y,
    r ? n.cp2x : n.cp1x,
    r ? n.cp2y : n.cp1y,
    n.x,
    n.y
  );
}
function Lo(e, t, n, r, i, a = {}) {
  const o = jt(t) ? t : [t], s = a.strokeWidth > 0 && a.strokeColor !== "";
  let u, d;
  for (e.save(), e.font = i.string, D6(e, a), u = 0; u < o.length; ++u)
    d = o[u], s && (a.strokeColor && (e.strokeStyle = a.strokeColor), ht(a.strokeWidth) || (e.lineWidth = a.strokeWidth), e.strokeText(d, n, r, a.maxWidth)), e.fillText(d, n, r, a.maxWidth), P6(e, n, r, d, a), r += i.lineHeight;
  e.restore();
}
function D6(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), ht(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function P6(e, t, n, r, i) {
  if (i.strikethrough || i.underline) {
    const a = e.measureText(r), o = t - a.actualBoundingBoxLeft, s = t + a.actualBoundingBoxRight, u = n - a.actualBoundingBoxAscent, d = n + a.actualBoundingBoxDescent, f = i.strikethrough ? (u + d) / 2 : d;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(o, f), e.lineTo(s, f), e.stroke();
  }
}
function As(e, t) {
  const { x: n, y: r, w: i, h: a, radius: o } = t;
  e.arc(n + o.topLeft, r + o.topLeft, o.topLeft, -vn, Lt, !0), e.lineTo(n, r + a - o.bottomLeft), e.arc(n + o.bottomLeft, r + a - o.bottomLeft, o.bottomLeft, Lt, vn, !0), e.lineTo(n + i - o.bottomRight, r + a), e.arc(n + i - o.bottomRight, r + a - o.bottomRight, o.bottomRight, vn, 0, !0), e.lineTo(n + i, r + o.topRight), e.arc(n + i - o.topRight, r + o.topRight, o.topRight, 0, -vn, !0), e.lineTo(n + o.topLeft, r);
}
const M6 = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/), I6 = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function N6(e, t) {
  const n = ("" + e).match(M6);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const L6 = (e) => +e || 0;
function tg(e, t) {
  const n = {}, r = st(t), i = r ? Object.keys(t) : t, a = st(e) ? r ? (o) => nt(e[o], e[t[o]]) : (o) => e[o] : () => e;
  for (const o of i)
    n[o] = L6(a(o));
  return n;
}
function vT(e) {
  return tg(e, { top: "y", right: "x", bottom: "y", left: "x" });
}
function La(e) {
  return tg(e, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
}
function On(e) {
  const t = vT(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function _n(e, t) {
  e = e || {}, t = t || yt.font;
  let n = nt(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = nt(e.style, t.style);
  r && !("" + r).match(I6) && (console.warn('Invalid font style specified: "' + r + '"'), r = "");
  const i = {
    family: nt(e.family, t.family),
    lineHeight: N6(nt(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: nt(e.weight, t.weight),
    string: ""
  };
  return i.string = S6(i), i;
}
function rn(e, t, n, r) {
  let i, a, o;
  for (i = 0, a = e.length; i < a; ++i)
    if (o = e[i], o !== void 0 && (t !== void 0 && typeof o == "function" && (o = o(t)), n !== void 0 && jt(o) && (o = o[n % o.length]), o !== void 0))
      return o;
}
function R6(e, t, n) {
  const { min: r, max: i } = e, a = eT(t, (i - r) / 2), o = (s, u) => n && s === 0 ? 0 : s + u;
  return {
    min: o(r, -Math.abs(a)),
    max: o(i, a)
  };
}
function Za(e, t) {
  return Object.assign(Object.create(e), t);
}
function ng(e, t = [""], n = e, r, i = () => e[0]) {
  Sn(r) || (r = wT("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: n,
    _fallback: r,
    _getTarget: i,
    override: (o) => ng([o, ...e], t, n, r)
  };
  return new Proxy(a, {
    deleteProperty(o, s) {
      return delete o[s], delete o._keys, delete e[0][s], !0;
    },
    get(o, s) {
      return yT(
        o,
        s,
        () => j6(s, t, e, o)
      );
    },
    getOwnPropertyDescriptor(o, s) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], s);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    has(o, s) {
      return yb(o).includes(s);
    },
    ownKeys(o) {
      return yb(o);
    },
    set(o, s, u) {
      const d = o._storage || (o._storage = i());
      return o[s] = d[s] = u, delete o._keys, !0;
    }
  });
}
function Ds(e, t, n, r) {
  const i = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _T(e, r),
    setContext: (a) => Ds(e, a, n, r),
    override: (a) => Ds(e.override(a), t, n, r)
  };
  return new Proxy(i, {
    deleteProperty(a, o) {
      return delete a[o], delete e[o], !0;
    },
    get(a, o, s) {
      return yT(
        a,
        o,
        () => $6(a, o, s)
      );
    },
    getOwnPropertyDescriptor(a, o) {
      return a._descriptors.allKeys ? Reflect.has(e, o) ? { enumerable: !0, configurable: !0 } : void 0 : Reflect.getOwnPropertyDescriptor(e, o);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    has(a, o) {
      return Reflect.has(e, o);
    },
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    set(a, o, s) {
      return e[o] = s, delete a[o], !0;
    }
  });
}
function _T(e, t = { scriptable: !0, indexable: !0 }) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: i = t.allKeys } = e;
  return {
    allKeys: i,
    scriptable: n,
    indexable: r,
    isScriptable: Ha(n) ? n : () => n,
    isIndexable: Ha(r) ? r : () => r
  };
}
const F6 = (e, t) => e ? e + Km(t) : t, rg = (e, t) => st(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function yT(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function $6(e, t, n) {
  const { _proxy: r, _context: i, _subProxy: a, _descriptors: o } = e;
  let s = r[t];
  return Ha(s) && o.isScriptable(t) && (s = V6(t, s, e, n)), jt(s) && s.length && (s = B6(t, s, e, o.isIndexable)), rg(t, s) && (s = Ds(s, i, a && a[t], o)), s;
}
function V6(e, t, n, r) {
  const { _proxy: i, _context: a, _subProxy: o, _stack: s } = n;
  if (s.has(e))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + e);
  return s.add(e), t = t(a, o || r), s.delete(e), rg(e, t) && (t = ig(i._scopes, i, e, t)), t;
}
function B6(e, t, n, r) {
  const { _proxy: i, _context: a, _subProxy: o, _descriptors: s } = n;
  if (Sn(a.index) && r(e))
    t = t[a.index % t.length];
  else if (st(t[0])) {
    const u = t, d = i._scopes.filter((f) => f !== u);
    t = [];
    for (const f of u) {
      const p = ig(d, i, e, f);
      t.push(Ds(p, a, o && o[e], s));
    }
  }
  return t;
}
function bT(e, t, n) {
  return Ha(e) ? e(t, n) : e;
}
const U6 = (e, t) => e === !0 ? t : typeof e == "string" ? Wa(t, e) : void 0;
function W6(e, t, n, r, i) {
  for (const a of t) {
    const o = U6(n, a);
    if (o) {
      e.add(o);
      const s = bT(o._fallback, n, i);
      if (Sn(s) && s !== n && s !== r)
        return s;
    } else if (o === !1 && Sn(r) && n !== r)
      return null;
  }
  return !1;
}
function ig(e, t, n, r) {
  const i = t._rootScopes, a = bT(t._fallback, n, r), o = [...e, ...i], s = /* @__PURE__ */ new Set();
  s.add(r);
  let u = _b(s, o, n, a || n, r);
  return u === null || Sn(a) && a !== n && (u = _b(s, o, a, u, r), u === null) ? !1 : ng(
    Array.from(s),
    [""],
    i,
    a,
    () => H6(t, n, r)
  );
}
function _b(e, t, n, r, i) {
  for (; n; )
    n = W6(e, t, n, r, i);
  return n;
}
function H6(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const i = r[t];
  return jt(i) && st(n) ? n : i;
}
function j6(e, t, n, r) {
  let i;
  for (const a of t)
    if (i = wT(F6(a, e), n), Sn(i))
      return rg(e, i) ? ig(n, r, e, i) : i;
}
function wT(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (Sn(r))
      return r;
  }
}
function yb(e) {
  let t = e._keys;
  return t || (t = e._keys = Y6(e._scopes)), t;
}
function Y6(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((i) => !i.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
function xT(e, t, n, r) {
  const { iScale: i } = e, { key: a = "r" } = this._parsing, o = new Array(r);
  let s, u, d, f;
  for (s = 0, u = r; s < u; ++s)
    d = s + n, f = t[d], o[s] = {
      r: i.parse(Wa(f, a), d)
    };
  return o;
}
const z6 = Number.EPSILON || 1e-14, Ps = (e, t) => t < e.length && !e[t].skip && e[t], ET = (e) => e === "x" ? "y" : "x";
function G6(e, t, n, r) {
  const i = e.skip ? t : e, a = t, o = n.skip ? t : n, s = Kl(a, i), u = Kl(o, a);
  let d = s / (s + u), f = u / (s + u);
  d = isNaN(d) ? 0 : d, f = isNaN(f) ? 0 : f;
  const p = r * d, m = r * f;
  return {
    previous: {
      x: a.x - p * (o.x - i.x),
      y: a.y - p * (o.y - i.y)
    },
    next: {
      x: a.x + m * (o.x - i.x),
      y: a.y + m * (o.y - i.y)
    }
  };
}
function q6(e, t, n) {
  const r = e.length;
  let i, a, o, s, u, d = Ps(e, 0);
  for (let f = 0; f < r - 1; ++f)
    if (u = d, d = Ps(e, f + 1), !(!u || !d)) {
      if (Rl(t[f], 0, z6)) {
        n[f] = n[f + 1] = 0;
        continue;
      }
      i = n[f] / t[f], a = n[f + 1] / t[f], s = Math.pow(i, 2) + Math.pow(a, 2), !(s <= 9) && (o = 3 / Math.sqrt(s), n[f] = i * o * t[f], n[f + 1] = a * o * t[f]);
    }
}
function K6(e, t, n = "x") {
  const r = ET(n), i = e.length;
  let a, o, s, u = Ps(e, 0);
  for (let d = 0; d < i; ++d) {
    if (o = s, s = u, u = Ps(e, d + 1), !s)
      continue;
    const f = s[n], p = s[r];
    o && (a = (f - o[n]) / 3, s[`cp1${n}`] = f - a, s[`cp1${r}`] = p - a * t[d]), u && (a = (u[n] - f) / 3, s[`cp2${n}`] = f + a, s[`cp2${r}`] = p + a * t[d]);
  }
}
function X6(e, t = "x") {
  const n = ET(t), r = e.length, i = Array(r).fill(0), a = Array(r);
  let o, s, u, d = Ps(e, 0);
  for (o = 0; o < r; ++o)
    if (s = u, u = d, d = Ps(e, o + 1), !!u) {
      if (d) {
        const f = d[t] - u[t];
        i[o] = f !== 0 ? (d[n] - u[n]) / f : 0;
      }
      a[o] = s ? d ? Ri(i[o - 1]) !== Ri(i[o]) ? 0 : (i[o - 1] + i[o]) / 2 : i[o - 1] : i[o];
    }
  q6(e, i, a), K6(e, a, t);
}
function Ac(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function Z6(e, t) {
  let n, r, i, a, o, s = Zl(e[0], t);
  for (n = 0, r = e.length; n < r; ++n)
    o = a, a = s, s = n < r - 1 && Zl(e[n + 1], t), a && (i = e[n], o && (i.cp1x = Ac(i.cp1x, t.left, t.right), i.cp1y = Ac(i.cp1y, t.top, t.bottom)), s && (i.cp2x = Ac(i.cp2x, t.left, t.right), i.cp2y = Ac(i.cp2y, t.top, t.bottom)));
}
function Q6(e, t, n, r, i) {
  let a, o, s, u;
  if (t.spanGaps && (e = e.filter((d) => !d.skip)), t.cubicInterpolationMode === "monotone")
    X6(e, i);
  else {
    let d = r ? e[e.length - 1] : e[0];
    for (a = 0, o = e.length; a < o; ++a)
      s = e[a], u = G6(
        d,
        s,
        e[Math.min(a + 1, o - (r ? 0 : 1)) % o],
        t.tension
      ), s.cp1x = u.previous.x, s.cp1y = u.previous.y, s.cp2x = u.next.x, s.cp2y = u.next.y, d = s;
  }
  t.capBezierPoints && Z6(e, n);
}
function TT() {
  return typeof window < "u" && typeof document < "u";
}
function ag(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function vd(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const Fd = (e) => window.getComputedStyle(e, null);
function J6(e, t) {
  return Fd(e).getPropertyValue(t);
}
const eW = ["top", "right", "bottom", "left"];
function Ao(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let i = 0; i < 4; i++) {
    const a = eW[i];
    r[a] = parseFloat(e[t + "-" + a + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const tW = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function nW(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: i, offsetY: a } = r;
  let o = !1, s, u;
  if (tW(i, a, e.target))
    s = i, u = a;
  else {
    const d = t.getBoundingClientRect();
    s = r.clientX - d.left, u = r.clientY - d.top, o = !0;
  }
  return { x: s, y: u, box: o };
}
function yo(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, i = Fd(n), a = i.boxSizing === "border-box", o = Ao(i, "padding"), s = Ao(i, "border", "width"), { x: u, y: d, box: f } = nW(e, n), p = o.left + (f && s.left), m = o.top + (f && s.top);
  let { width: g, height: v } = t;
  return a && (g -= o.width + s.width, v -= o.height + s.height), {
    x: Math.round((u - p) / g * n.width / r),
    y: Math.round((d - m) / v * n.height / r)
  };
}
function rW(e, t, n) {
  let r, i;
  if (t === void 0 || n === void 0) {
    const a = ag(e);
    if (!a)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const o = a.getBoundingClientRect(), s = Fd(a), u = Ao(s, "border", "width"), d = Ao(s, "padding");
      t = o.width - d.width - u.width, n = o.height - d.height - u.height, r = vd(s.maxWidth, a, "clientWidth"), i = vd(s.maxHeight, a, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || hd,
    maxHeight: i || hd
  };
}
const Hh = (e) => Math.round(e * 10) / 10;
function iW(e, t, n, r) {
  const i = Fd(e), a = Ao(i, "margin"), o = vd(i.maxWidth, e, "clientWidth") || hd, s = vd(i.maxHeight, e, "clientHeight") || hd, u = rW(e, t, n);
  let { width: d, height: f } = u;
  if (i.boxSizing === "content-box") {
    const p = Ao(i, "border", "width"), m = Ao(i, "padding");
    d -= m.width + p.width, f -= m.height + p.height;
  }
  return d = Math.max(0, d - a.width), f = Math.max(0, r ? Math.floor(d / r) : f - a.height), d = Hh(Math.min(d, o, u.maxWidth)), f = Hh(Math.min(f, s, u.maxHeight)), d && !f && (f = Hh(d / 2)), {
    width: d,
    height: f
  };
}
function bb(e, t, n) {
  const r = t || 1, i = Math.floor(e.height * r), a = Math.floor(e.width * r);
  e.height = i / r, e.width = a / r;
  const o = e.canvas;
  return o.style && (n || !o.style.height && !o.style.width) && (o.style.height = `${e.height}px`, o.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || o.height !== i || o.width !== a ? (e.currentDevicePixelRatio = r, o.height = i, o.width = a, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const aW = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
}();
function wb(e, t) {
  const n = J6(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function bo(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function oW(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: r === "middle" ? n < 0.5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function sW(e, t, n, r) {
  const i = { x: e.cp2x, y: e.cp2y }, a = { x: t.cp1x, y: t.cp1y }, o = bo(e, i, n), s = bo(i, a, n), u = bo(a, t, n), d = bo(o, s, n), f = bo(s, u, n);
  return bo(d, f, n);
}
const xb = /* @__PURE__ */ new Map();
function lW(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = xb.get(n);
  return r || (r = new Intl.NumberFormat(e, t), xb.set(n, r)), r;
}
function bu(e, t, n) {
  return lW(t, n).format(e);
}
const uW = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, cW = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function ys(e, t, n) {
  return e ? uW(t, n) : cW();
}
function kT(e, t) {
  let n, r;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function ST(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function OT(e) {
  return e === "angle" ? {
    between: Xl,
    compare: X5,
    normalize: Ur
  } : {
    between: da,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Eb({ start: e, end: t, count: n, loop: r, style: i }) {
  return {
    start: e % n,
    end: t % n,
    loop: r && (t - e + 1) % n === 0,
    style: i
  };
}
function dW(e, t, n) {
  const { property: r, start: i, end: a } = n, { between: o, normalize: s } = OT(r), u = t.length;
  let { start: d, end: f, loop: p } = e, m, g;
  if (p) {
    for (d += u, f += u, m = 0, g = u; m < g && o(s(t[d % u][r]), i, a); ++m)
      d--, f--;
    d %= u, f %= u;
  }
  return f < d && (f += u), { start: d, end: f, loop: p, style: e.style };
}
function CT(e, t, n) {
  if (!n)
    return [e];
  const { property: r, start: i, end: a } = n, o = t.length, { compare: s, between: u, normalize: d } = OT(r), { start: f, end: p, loop: m, style: g } = dW(e, t, n), v = [];
  let b = !1, w = null, T, S, x;
  const O = () => u(i, x, T) && s(i, x) !== 0, C = () => s(a, T) === 0 || u(a, x, T), P = () => b || O(), k = () => !b || C();
  for (let M = f, N = f; M <= p; ++M)
    S = t[M % o], !S.skip && (T = d(S[r]), T !== x && (b = u(T, i, a), w === null && P() && (w = s(T, i) === 0 ? M : N), w !== null && k() && (v.push(Eb({ start: w, end: M, loop: m, count: o, style: g })), w = null), N = M, x = T));
  return w !== null && v.push(Eb({ start: w, end: p, loop: m, count: o, style: g })), v;
}
function AT(e, t) {
  const n = [], r = e.segments;
  for (let i = 0; i < r.length; i++) {
    const a = CT(r[i], e.points, t);
    a.length && n.push(...a);
  }
  return n;
}
function fW(e, t, n, r) {
  let i = 0, a = t - 1;
  if (n && !r)
    for (; i < t && !e[i].skip; )
      i++;
  for (; i < t && e[i].skip; )
    i++;
  for (i %= t, n && (a += i); a > i && e[a % t].skip; )
    a--;
  return a %= t, { start: i, end: a };
}
function hW(e, t, n, r) {
  const i = e.length, a = [];
  let o = t, s = e[t], u;
  for (u = t + 1; u <= n; ++u) {
    const d = e[u % i];
    d.skip || d.stop ? s.skip || (r = !1, a.push({ start: t % i, end: (u - 1) % i, loop: r }), t = o = d.stop ? u : null) : (o = u, s.skip && (t = u)), s = d;
  }
  return o !== null && a.push({ start: t % i, end: o % i, loop: r }), a;
}
function pW(e, t) {
  const n = e.points, r = e.options.spanGaps, i = n.length;
  if (!i)
    return [];
  const a = !!e._loop, { start: o, end: s } = fW(n, i, a, r);
  if (r === !0)
    return Tb(e, [{ start: o, end: s, loop: a }], n, t);
  const u = s < o ? s + i : s, d = !!e._fullLoop && o === 0 && s === i - 1;
  return Tb(e, hW(n, o, u, d), n, t);
}
function Tb(e, t, n, r) {
  return !r || !r.setContext || !n ? t : mW(e, t, n, r);
}
function mW(e, t, n, r) {
  const i = e._chart.getContext(), a = kb(e.options), { _datasetIndex: o, options: { spanGaps: s } } = e, u = n.length, d = [];
  let f = a, p = t[0].start, m = p;
  function g(v, b, w, T) {
    const S = s ? -1 : 1;
    if (v !== b) {
      for (v += u; n[v % u].skip; )
        v -= S;
      for (; n[b % u].skip; )
        b += S;
      v % u !== b % u && (d.push({ start: v % u, end: b % u, loop: w, style: T }), f = T, p = b % u);
    }
  }
  for (const v of t) {
    p = s ? p : v.start;
    let b = n[p % u], w;
    for (m = p + 1; m <= v.end; m++) {
      const T = n[m % u];
      w = kb(r.setContext(Za(i, {
        type: "segment",
        p0: b,
        p1: T,
        p0DataIndex: (m - 1) % u,
        p1DataIndex: m % u,
        datasetIndex: o
      }))), gW(w, f) && g(p, m - 1, v.loop, f), b = T, f = w;
    }
    p < m - 1 && g(p, m - 1, v.loop, f);
  }
  return d;
}
function kb(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function gW(e, t) {
  return t && JSON.stringify(e) !== JSON.stringify(t);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
class vW {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, r, i) {
    const a = n.listeners[i], o = n.duration;
    a.forEach((s) => s({
      chart: t,
      initial: n.initial,
      numSteps: o,
      currentStep: Math.min(r - n.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = sT.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((r, i) => {
      if (!r.running || !r.items.length)
        return;
      const a = r.items;
      let o = a.length - 1, s = !1, u;
      for (; o >= 0; --o)
        u = a[o], u._active ? (u._total > r.duration && (r.duration = u._total), u.tick(t), s = !0) : (a[o] = a[a.length - 1], a.pop());
      s && (i.draw(), this._notify(i, r, t, "progress")), a.length || (r.running = !1, this._notify(i, r, t, "complete"), r.initial = !1), n += a.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let r = n.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, r)), r;
  }
  listen(t, n, r) {
    this._getAnims(t).listeners[n].push(r);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, i) => Math.max(r, i._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let i = r.length - 1;
    for (; i >= 0; --i)
      r[i].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var ta = new vW();
const Sb = "transparent", _W = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const r = gb(e || Sb), i = r.valid && gb(t || Sb);
    return i && i.valid ? i.mix(r, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class yW {
  constructor(t, n, r, i) {
    const a = n[r];
    i = rn([t.to, i, a, t.from]);
    const o = rn([t.from, a, i]);
    this._active = !0, this._fn = t.fn || _W[t.type || typeof o], this._easing = Fl[t.easing] || Fl.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = r, this._from = o, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, r) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], a = r - this._start, o = this._duration - a;
      this._start = r, this._duration = Math.floor(Math.max(o, t.duration)), this._total += a, this._loop = !!t.loop, this._to = rn([t.to, n, i, t.from]), this._from = rn([t.from, i, n]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, r = this._duration, i = this._prop, a = this._from, o = this._loop, s = this._to;
    let u;
    if (this._active = a !== s && (o || n < r), !this._active) {
      this._target[i] = s, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[i] = a;
      return;
    }
    u = n / r % 2, u = o && u > 1 ? 2 - u : u, u = this._easing(Math.min(1, Math.max(0, u))), this._target[i] = this._fn(a, s, u);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      t.push({ res: n, rej: r });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", r = this._promises || [];
    for (let i = 0; i < r.length; i++)
      r[i][n]();
  }
}
const bW = ["x", "y", "borderWidth", "radius", "tension"], wW = ["color", "borderColor", "backgroundColor"];
yt.set("animation", {
  delay: void 0,
  duration: 1e3,
  easing: "easeOutQuart",
  fn: void 0,
  from: void 0,
  loop: void 0,
  to: void 0,
  type: void 0
});
const xW = Object.keys(yt.animation);
yt.describe("animation", {
  _fallback: !1,
  _indexable: !1,
  _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
});
yt.set("animations", {
  colors: {
    type: "color",
    properties: wW
  },
  numbers: {
    type: "number",
    properties: bW
  }
});
yt.describe("animations", {
  _fallback: "animation"
});
yt.set("transitions", {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: "transparent"
      },
      visible: {
        type: "boolean",
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: "transparent"
      },
      visible: {
        type: "boolean",
        easing: "linear",
        fn: (e) => e | 0
      }
    }
  }
});
class og {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!st(t))
      return;
    const n = this._properties;
    Object.getOwnPropertyNames(t).forEach((r) => {
      const i = t[r];
      if (!st(i))
        return;
      const a = {};
      for (const o of xW)
        a[o] = i[o];
      (jt(i.properties) && i.properties || [r]).forEach((o) => {
        (o === r || !n.has(o)) && n.set(o, a);
      });
    });
  }
  _animateOptions(t, n) {
    const r = n.options, i = TW(t, r);
    if (!i)
      return [];
    const a = this._createAnimations(i, r);
    return r.$shared && EW(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), a;
  }
  _createAnimations(t, n) {
    const r = this._properties, i = [], a = t.$animations || (t.$animations = {}), o = Object.keys(n), s = Date.now();
    let u;
    for (u = o.length - 1; u >= 0; --u) {
      const d = o[u];
      if (d.charAt(0) === "$")
        continue;
      if (d === "options") {
        i.push(...this._animateOptions(t, n));
        continue;
      }
      const f = n[d];
      let p = a[d];
      const m = r.get(d);
      if (p)
        if (m && p.active()) {
          p.update(m, f, s);
          continue;
        } else
          p.cancel();
      if (!m || !m.duration) {
        t[d] = f;
        continue;
      }
      a[d] = p = new yW(m, t, d, f), i.push(p);
    }
    return i;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const r = this._createAnimations(t, n);
    if (r.length)
      return ta.add(this._chart, r), !0;
  }
}
function EW(e, t) {
  const n = [], r = Object.keys(t);
  for (let i = 0; i < r.length; i++) {
    const a = e[r[i]];
    a && a.active() && n.push(a.wait());
  }
  return Promise.all(n);
}
function TW(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, { $shared: !1, $animations: {} })), n;
}
function Ob(e, t) {
  const n = e && e.options || {}, r = n.reverse, i = n.min === void 0 ? t : 0, a = n.max === void 0 ? t : 0;
  return {
    start: r ? a : i,
    end: r ? i : a
  };
}
function kW(e, t, n) {
  if (n === !1)
    return !1;
  const r = Ob(e, n), i = Ob(t, n);
  return {
    top: i.end,
    right: r.end,
    bottom: i.start,
    left: r.start
  };
}
function SW(e) {
  let t, n, r, i;
  return st(e) ? (t = e.top, n = e.right, r = e.bottom, i = e.left) : t = n = r = i = e, {
    top: t,
    right: n,
    bottom: r,
    left: i,
    disabled: e === !1
  };
}
function DT(e, t) {
  const n = [], r = e._getSortedDatasetMetas(t);
  let i, a;
  for (i = 0, a = r.length; i < a; ++i)
    n.push(r[i].index);
  return n;
}
function Cb(e, t, n, r = {}) {
  const i = e.keys, a = r.mode === "single";
  let o, s, u, d;
  if (t !== null) {
    for (o = 0, s = i.length; o < s; ++o) {
      if (u = +i[o], u === n) {
        if (r.all)
          continue;
        break;
      }
      d = e.values[u], pn(d) && (a || t === 0 || Ri(t) === Ri(d)) && (t += d);
    }
    return t;
  }
}
function OW(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let r, i, a;
  for (r = 0, i = t.length; r < i; ++r)
    a = t[r], n[r] = {
      x: a,
      y: e[a]
    };
  return n;
}
function Ab(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function CW(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function AW(e) {
  const { min: t, max: n, minDefined: r, maxDefined: i } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: i ? n : Number.POSITIVE_INFINITY
  };
}
function DW(e, t, n) {
  const r = e[t] || (e[t] = {});
  return r[n] || (r[n] = {});
}
function Db(e, t, n, r) {
  for (const i of t.getMatchingVisibleMetas(r).reverse()) {
    const a = e[i.index];
    if (n && a > 0 || !n && a < 0)
      return i.index;
  }
  return null;
}
function Pb(e, t) {
  const { chart: n, _cachedMeta: r } = e, i = n._stacks || (n._stacks = {}), { iScale: a, vScale: o, index: s } = r, u = a.axis, d = o.axis, f = CW(a, o, r), p = t.length;
  let m;
  for (let g = 0; g < p; ++g) {
    const v = t[g], { [u]: b, [d]: w } = v, T = v._stacks || (v._stacks = {});
    m = T[d] = DW(i, f, b), m[s] = w, m._top = Db(m, o, !0, r.type), m._bottom = Db(m, o, !1, r.type);
  }
}
function jh(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((r) => n[r].axis === t).shift();
}
function PW(e, t) {
  return Za(
    e,
    {
      active: !1,
      dataset: void 0,
      datasetIndex: t,
      index: t,
      mode: "default",
      type: "dataset"
    }
  );
}
function MW(e, t, n) {
  return Za(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function fl(e, t) {
  const n = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const i of t) {
      const a = i._stacks;
      if (!a || a[r] === void 0 || a[r][n] === void 0)
        return;
      delete a[r][n];
    }
  }
}
const Yh = (e) => e === "reset" || e === "none", Mb = (e, t) => t ? e : Object.assign({}, e), IW = (e, t, n) => e && !t.hidden && t._stacked && { keys: DT(n, !0), values: null };
class bi {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = Ab(t.vScale, t), this.addElements();
  }
  updateIndex(t) {
    this.index !== t && fl(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, r = this.getDataset(), i = (p, m, g, v) => p === "x" ? m : p === "r" ? v : g, a = n.xAxisID = nt(r.xAxisID, jh(t, "x")), o = n.yAxisID = nt(r.yAxisID, jh(t, "y")), s = n.rAxisID = nt(r.rAxisID, jh(t, "r")), u = n.indexAxis, d = n.iAxisID = i(u, a, o, s), f = n.vAxisID = i(u, o, a, s);
    n.xScale = this.getScaleForId(a), n.yScale = this.getScaleForId(o), n.rScale = this.getScaleForId(s), n.iScale = this.getScaleForId(d), n.vScale = this.getScaleForId(f);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && ub(this._data, this), t._stacked && fl(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), r = this._data;
    if (st(n))
      this._data = OW(n);
    else if (r !== n) {
      if (r) {
        ub(r, this);
        const i = this._cachedMeta;
        fl(i), i._parsed = [];
      }
      n && Object.isExtensible(n) && e6(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, r = this.getDataset();
    let i = !1;
    this._dataCheck();
    const a = n._stacked;
    n._stacked = Ab(n.vScale, n), n.stack !== r.stack && (i = !0, fl(n), n.stack = r.stack), this._resyncElements(t), (i || a !== n._stacked) && Pb(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: r, _data: i } = this, { iScale: a, _stacked: o } = r, s = a.axis;
    let u = t === 0 && n === i.length ? !0 : r._sorted, d = t > 0 && r._parsed[t - 1], f, p, m;
    if (this._parsing === !1)
      r._parsed = i, r._sorted = !0, m = i;
    else {
      jt(i[t]) ? m = this.parseArrayData(r, i, t, n) : st(i[t]) ? m = this.parseObjectData(r, i, t, n) : m = this.parsePrimitiveData(r, i, t, n);
      const g = () => p[s] === null || d && p[s] < d[s];
      for (f = 0; f < n; ++f)
        r._parsed[f + t] = p = m[f], u && (g() && (u = !1), d = p);
      r._sorted = u;
    }
    o && Pb(this, m);
  }
  parsePrimitiveData(t, n, r, i) {
    const { iScale: a, vScale: o } = t, s = a.axis, u = o.axis, d = a.getLabels(), f = a === o, p = new Array(i);
    let m, g, v;
    for (m = 0, g = i; m < g; ++m)
      v = m + r, p[m] = {
        [s]: f || a.parse(d[v], v),
        [u]: o.parse(n[v], v)
      };
    return p;
  }
  parseArrayData(t, n, r, i) {
    const { xScale: a, yScale: o } = t, s = new Array(i);
    let u, d, f, p;
    for (u = 0, d = i; u < d; ++u)
      f = u + r, p = n[f], s[u] = {
        x: a.parse(p[0], f),
        y: o.parse(p[1], f)
      };
    return s;
  }
  parseObjectData(t, n, r, i) {
    const { xScale: a, yScale: o } = t, { xAxisKey: s = "x", yAxisKey: u = "y" } = this._parsing, d = new Array(i);
    let f, p, m, g;
    for (f = 0, p = i; f < p; ++f)
      m = f + r, g = n[m], d[f] = {
        x: a.parse(Wa(g, s), m),
        y: o.parse(Wa(g, u), m)
      };
    return d;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, r) {
    const i = this.chart, a = this._cachedMeta, o = n[t.axis], s = {
      keys: DT(i, !0),
      values: n._stacks[t.axis]
    };
    return Cb(s, o, a.index, { mode: r });
  }
  updateRangeFromParsed(t, n, r, i) {
    const a = r[n.axis];
    let o = a === null ? NaN : a;
    const s = i && r._stacks[n.axis];
    i && s && (i.values = s, o = Cb(i, a, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
  }
  getMinMax(t, n) {
    const r = this._cachedMeta, i = r._parsed, a = r._sorted && t === r.iScale, o = i.length, s = this._getOtherScale(t), u = IW(n, r, this.chart), d = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY }, { min: f, max: p } = AW(s);
    let m, g;
    function v() {
      g = i[m];
      const b = g[s.axis];
      return !pn(g[t.axis]) || f > b || p < b;
    }
    for (m = 0; m < o && !(!v() && (this.updateRangeFromParsed(d, t, g, u), a)); ++m)
      ;
    if (a) {
      for (m = o - 1; m >= 0; --m)
        if (!v()) {
          this.updateRangeFromParsed(d, t, g, u);
          break;
        }
    }
    return d;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, r = [];
    let i, a, o;
    for (i = 0, a = n.length; i < a; ++i)
      o = n[i][t.axis], pn(o) && r.push(o);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = n.iScale, i = n.vScale, a = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(a[r.axis]) : "",
      value: i ? "" + i.getLabelForValue(a[i.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = SW(nt(this.options.clip, kW(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, r = this._cachedMeta, i = r.data || [], a = n.chartArea, o = [], s = this._drawStart || 0, u = this._drawCount || i.length - s, d = this.options.drawActiveElementsOnTop;
    let f;
    for (r.dataset && r.dataset.draw(t, a, s, u), f = s; f < s + u; ++f) {
      const p = i[f];
      p.hidden || (p.active && d ? o.push(p) : p.draw(t, a));
    }
    for (f = 0; f < o.length; ++f)
      o[f].draw(t, a);
  }
  getStyle(t, n) {
    const r = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, n, r) {
    const i = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[t];
      a = o.$context || (o.$context = MW(this.getContext(), t, o)), a.parsed = this.getParsed(t), a.raw = i.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = PW(this.chart.getContext(), this.index)), a.dataset = i, a.index = a.datasetIndex = this.index;
    return a.active = !!n, a.mode = r, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", r) {
    const i = n === "active", a = this._cachedDataOpts, o = t + "-" + n, s = a[o], u = this.enableOptionSharing && Sn(r);
    if (s)
      return Mb(s, u);
    const d = this.chart.config, f = d.datasetElementScopeKeys(this._type, t), p = i ? [`${t}Hover`, "hover", t, ""] : [t, ""], m = d.getOptionScopes(this.getDataset(), f), g = Object.keys(yt.elements[t]), v = () => this.getContext(r, i), b = d.resolveNamedOptions(m, g, v, p);
    return b.$shared && (b.$shared = u, a[o] = Object.freeze(Mb(b, u))), b;
  }
  _resolveAnimations(t, n, r) {
    const i = this.chart, a = this._cachedDataOpts, o = `animation-${n}`, s = a[o];
    if (s)
      return s;
    let u;
    if (i.options.animation !== !1) {
      const f = this.chart.config, p = f.datasetAnimationScopeKeys(this._type, n), m = f.getOptionScopes(this.getDataset(), p);
      u = f.createResolver(m, this.getContext(t, r, n));
    }
    const d = new og(i, u && u.animations);
    return u && u._cacheable && (a[o] = Object.freeze(d)), d;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Yh(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const r = this.resolveDataElementOptions(t, n), i = this._sharedOptions, a = this.getSharedOptions(r), o = this.includeOptions(n, a) || a !== i;
    return this.updateSharedOptions(a, n, r), { sharedOptions: a, includeOptions: o };
  }
  updateElement(t, n, r, i) {
    Yh(i) ? Object.assign(t, r) : this._resolveAnimations(n, i).update(t, r);
  }
  updateSharedOptions(t, n, r) {
    t && !Yh(n) && this._resolveAnimations(void 0, n).update(t, r);
  }
  _setStyle(t, n, r, i) {
    t.active = i;
    const a = this.getStyle(n, i);
    this._resolveAnimations(n, r, i).update(t, {
      options: !i && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [s, u, d] of this._syncList)
      this[s](u, d);
    this._syncList = [];
    const i = r.length, a = n.length, o = Math.min(a, i);
    o && this.parse(0, o), a > i ? this._insertElements(i, a - i, t) : a < i && this._removeElements(a, i - a);
  }
  _insertElements(t, n, r = !0) {
    const i = this._cachedMeta, a = i.data, o = t + n;
    let s;
    const u = (d) => {
      for (d.length += n, s = d.length - 1; s >= o; s--)
        d[s] = d[s - n];
    };
    for (u(a), s = t; s < o; ++s)
      a[s] = new this.dataElementType();
    this._parsing && u(i._parsed), this.parse(t, n), r && this.updateElements(a, t, n, "reset");
  }
  updateElements(t, n, r, i) {
  }
  _removeElements(t, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const i = r._parsed.splice(t, n);
      r._stacked && fl(r, i);
    }
    r.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, r, i] = t;
      this[n](r, i);
    }
    this.chart._dataChanges.push([this.index, ...t]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync(["_insertElements", this.getDataset().data.length - t, t]);
  }
  _onDataPop() {
    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(["_removeElements", 0, 1]);
  }
  _onDataSplice(t, n) {
    n && this._sync(["_removeElements", t, n]);
    const r = arguments.length - 2;
    r && this._sync(["_insertElements", t, r]);
  }
  _onDataUnshift() {
    this._sync(["_insertElements", 0, arguments.length]);
  }
}
bi.defaults = {};
bi.prototype.datasetElementType = null;
bi.prototype.dataElementType = null;
function NW(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let i = 0, a = n.length; i < a; i++)
      r = r.concat(n[i].controller.getAllParsedValues(e));
    e._cache.$bar = oT(r.sort((i, a) => i - a));
  }
  return e._cache.$bar;
}
function LW(e) {
  const t = e.iScale, n = NW(t, e.type);
  let r = t._length, i, a, o, s;
  const u = () => {
    o === 32767 || o === -32768 || (Sn(s) && (r = Math.min(r, Math.abs(o - s) || r)), s = o);
  };
  for (i = 0, a = n.length; i < a; ++i)
    o = t.getPixelForValue(n[i]), u();
  for (s = void 0, i = 0, a = t.ticks.length; i < a; ++i)
    o = t.getPixelForTick(i), u();
  return r;
}
function RW(e, t, n, r) {
  const i = n.barThickness;
  let a, o;
  return ht(i) ? (a = t.min * n.categoryPercentage, o = n.barPercentage) : (a = i * r, o = 1), {
    chunk: a / r,
    ratio: o,
    start: t.pixels[e] - a / 2
  };
}
function FW(e, t, n, r) {
  const i = t.pixels, a = i[e];
  let o = e > 0 ? i[e - 1] : null, s = e < i.length - 1 ? i[e + 1] : null;
  const u = n.categoryPercentage;
  o === null && (o = a - (s === null ? t.end - t.start : s - a)), s === null && (s = a + a - o);
  const d = a - (a - Math.min(o, s)) / 2 * u;
  return {
    chunk: Math.abs(s - o) / 2 * u / r,
    ratio: n.barPercentage,
    start: d
  };
}
function $W(e, t, n, r) {
  const i = n.parse(e[0], r), a = n.parse(e[1], r), o = Math.min(i, a), s = Math.max(i, a);
  let u = o, d = s;
  Math.abs(o) > Math.abs(s) && (u = s, d = o), t[n.axis] = d, t._custom = {
    barStart: u,
    barEnd: d,
    start: i,
    end: a,
    min: o,
    max: s
  };
}
function PT(e, t, n, r) {
  return jt(e) ? $W(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function Ib(e, t, n, r) {
  const i = e.iScale, a = e.vScale, o = i.getLabels(), s = i === a, u = [];
  let d, f, p, m;
  for (d = n, f = n + r; d < f; ++d)
    m = t[d], p = {}, p[i.axis] = s || i.parse(o[d], d), u.push(PT(m, p, a, d));
  return u;
}
function zh(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function VW(e, t, n) {
  return e !== 0 ? Ri(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function BW(e) {
  let t, n, r, i, a;
  return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (i = "end", a = "start") : (i = "start", a = "end"), { start: n, end: r, reverse: t, top: i, bottom: a };
}
function UW(e, t, n, r) {
  let i = t.borderSkipped;
  const a = {};
  if (!i) {
    e.borderSkipped = a;
    return;
  }
  if (i === !0) {
    e.borderSkipped = { top: !0, right: !0, bottom: !0, left: !0 };
    return;
  }
  const { start: o, end: s, reverse: u, top: d, bottom: f } = BW(e);
  i === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? i = d : (n._bottom || 0) === r ? i = f : (a[Nb(f, o, s, u)] = !0, i = d)), a[Nb(i, o, s, u)] = !0, e.borderSkipped = a;
}
function Nb(e, t, n, r) {
  return r ? (e = WW(e, t, n), e = Lb(e, n, t)) : e = Lb(e, t, n), e;
}
function WW(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function Lb(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function HW(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class $d extends bi {
  parsePrimitiveData(t, n, r, i) {
    return Ib(t, n, r, i);
  }
  parseArrayData(t, n, r, i) {
    return Ib(t, n, r, i);
  }
  parseObjectData(t, n, r, i) {
    const { iScale: a, vScale: o } = t, { xAxisKey: s = "x", yAxisKey: u = "y" } = this._parsing, d = a.axis === "x" ? s : u, f = o.axis === "x" ? s : u, p = [];
    let m, g, v, b;
    for (m = r, g = r + i; m < g; ++m)
      b = n[m], v = {}, v[a.axis] = a.parse(Wa(b, d), m), p.push(PT(Wa(b, f), v, o, m));
    return p;
  }
  updateRangeFromParsed(t, n, r, i) {
    super.updateRangeFromParsed(t, n, r, i);
    const a = r._custom;
    a && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, a.min), t.max = Math.max(t.max, a.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: r, vScale: i } = n, a = this.getParsed(t), o = a._custom, s = zh(o) ? "[" + o.start + ", " + o.end + "]" : "" + i.getLabelForValue(a[i.axis]);
    return {
      label: "" + r.getLabelForValue(a[r.axis]),
      value: s
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { index: o, _cachedMeta: { vScale: s } } = this, u = s.getBasePixel(), d = s.isHorizontal(), f = this._getRuler(), { sharedOptions: p, includeOptions: m } = this._getSharedOptions(n, i);
    for (let g = n; g < n + r; g++) {
      const v = this.getParsed(g), b = a || ht(v[s.axis]) ? { base: u, head: u } : this._calculateBarValuePixels(g), w = this._calculateBarIndexPixels(g, f), T = (v._stacks || {})[s.axis], S = {
        horizontal: d,
        base: b.base,
        enableBorderRadius: !T || zh(v._custom) || o === T._top || o === T._bottom,
        x: d ? b.head : w.center,
        y: d ? w.center : b.head,
        height: d ? w.size : Math.abs(b.size),
        width: d ? Math.abs(b.size) : w.size
      };
      m && (S.options = p || this.resolveDataElementOptions(g, t[g].active ? "active" : i));
      const x = S.options || t[g].options;
      UW(S, x, T, o), HW(S, x, f.ratio), this.updateElement(t[g], g, S, i);
    }
  }
  _getStacks(t, n) {
    const { iScale: r } = this._cachedMeta, i = r.getMatchingVisibleMetas(this._type).filter((u) => u.controller.options.grouped), a = r.options.stacked, o = [], s = (u) => {
      const d = u.controller.getParsed(n), f = d && d[u.vScale.axis];
      if (ht(f) || isNaN(f))
        return !0;
    };
    for (const u of i)
      if (!(n !== void 0 && s(u)) && ((a === !1 || o.indexOf(u.stack) === -1 || a === void 0 && u.stack === void 0) && o.push(u.stack), u.index === t))
        break;
    return o.length || o.push(void 0), o;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, r) {
    const i = this._getStacks(t, r), a = n !== void 0 ? i.indexOf(n) : -1;
    return a === -1 ? i.length - 1 : a;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, r = n.iScale, i = [];
    let a, o;
    for (a = 0, o = n.data.length; a < o; ++a)
      i.push(r.getPixelForValue(this.getParsed(a)[r.axis], a));
    const s = t.barThickness;
    return {
      min: s || LW(n),
      pixels: i,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: s ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: r }, options: { base: i, minBarLength: a } } = this, o = i || 0, s = this.getParsed(t), u = s._custom, d = zh(u);
    let f = s[n.axis], p = 0, m = r ? this.applyStack(n, s, r) : f, g, v;
    m !== f && (p = m - f, m = f), d && (f = u.barStart, m = u.barEnd - u.barStart, f !== 0 && Ri(f) !== Ri(u.barEnd) && (p = 0), p += f);
    const b = !ht(i) && !d ? i : p;
    let w = n.getPixelForValue(b);
    if (this.chart.getDataVisibility(t) ? g = n.getPixelForValue(p + m) : g = w, v = g - w, Math.abs(v) < a) {
      v = VW(v, n, o) * a, f === o && (w -= v / 2);
      const T = n.getPixelForDecimal(0), S = n.getPixelForDecimal(1), x = Math.min(T, S), O = Math.max(T, S);
      w = Math.max(Math.min(w, O), x), g = w + v;
    }
    if (w === n.getPixelForValue(o)) {
      const T = Ri(v) * n.getLineWidthForValue(o) / 2;
      w += T, v -= T;
    }
    return {
      size: v,
      base: w,
      head: g,
      center: g + v / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const r = n.scale, i = this.options, a = i.skipNull, o = nt(i.maxBarThickness, 1 / 0);
    let s, u;
    if (n.grouped) {
      const d = a ? this._getStackCount(t) : n.stackCount, f = i.barThickness === "flex" ? FW(t, n, i, d) : RW(t, n, i, d), p = this._getStackIndex(this.index, this._cachedMeta.stack, a ? t : void 0);
      s = f.start + f.chunk * p + f.chunk / 2, u = Math.min(o, f.chunk * f.ratio);
    } else
      s = r.getPixelForValue(this.getParsed(t)[r.axis], t), u = Math.min(o, n.min * n.ratio);
    return {
      base: s - u / 2,
      head: s + u / 2,
      center: s,
      size: u
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, r = t.data, i = r.length;
    let a = 0;
    for (; a < i; ++a)
      this.getParsed(a)[n.axis] !== null && r[a].draw(this._ctx);
  }
}
$d.id = "bar";
$d.defaults = {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "height"]
    }
  }
};
$d.overrides = {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
};
class Vd extends bi {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, n, r, i) {
    const a = super.parsePrimitiveData(t, n, r, i);
    for (let o = 0; o < a.length; o++)
      a[o]._custom = this.resolveDataElementOptions(o + r).radius;
    return a;
  }
  parseArrayData(t, n, r, i) {
    const a = super.parseArrayData(t, n, r, i);
    for (let o = 0; o < a.length; o++) {
      const s = n[r + o];
      a[o]._custom = nt(s[2], this.resolveDataElementOptions(o + r).radius);
    }
    return a;
  }
  parseObjectData(t, n, r, i) {
    const a = super.parseObjectData(t, n, r, i);
    for (let o = 0; o < a.length; o++) {
      const s = n[r + o];
      a[o]._custom = nt(s && s.r && +s.r, this.resolveDataElementOptions(o + r).radius);
    }
    return a;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let n = 0;
    for (let r = t.length - 1; r >= 0; --r)
      n = Math.max(n, t[r].size(this.resolveDataElementOptions(r)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { xScale: r, yScale: i } = n, a = this.getParsed(t), o = r.getLabelForValue(a.x), s = i.getLabelForValue(a.y), u = a._custom;
    return {
      label: n.label,
      value: "(" + o + ", " + s + (u ? ", " + u : "") + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { iScale: o, vScale: s } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, i), f = o.axis, p = s.axis;
    for (let m = n; m < n + r; m++) {
      const g = t[m], v = !a && this.getParsed(m), b = {}, w = b[f] = a ? o.getPixelForDecimal(0.5) : o.getPixelForValue(v[f]), T = b[p] = a ? s.getBasePixel() : s.getPixelForValue(v[p]);
      b.skip = isNaN(w) || isNaN(T), d && (b.options = u || this.resolveDataElementOptions(m, g.active ? "active" : i), a && (b.options.radius = 0)), this.updateElement(g, m, b, i);
    }
  }
  resolveDataElementOptions(t, n) {
    const r = this.getParsed(t);
    let i = super.resolveDataElementOptions(t, n);
    i.$shared && (i = Object.assign({}, i, { $shared: !1 }));
    const a = i.radius;
    return n !== "active" && (i.radius = 0), i.radius += nt(r && r._custom, a), i;
  }
}
Vd.id = "bubble";
Vd.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "borderWidth", "radius"]
    }
  }
};
Vd.overrides = {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        }
      }
    }
  }
};
function jW(e, t, n) {
  let r = 1, i = 1, a = 0, o = 0;
  if (t < zt) {
    const s = e, u = s + t, d = Math.cos(s), f = Math.sin(s), p = Math.cos(u), m = Math.sin(u), g = (x, O, C) => Xl(x, s, u, !0) ? 1 : Math.max(O, O * n, C, C * n), v = (x, O, C) => Xl(x, s, u, !0) ? -1 : Math.min(O, O * n, C, C * n), b = g(0, d, p), w = g(vn, f, m), T = v(Lt, d, p), S = v(Lt + vn, f, m);
    r = (b - T) / 2, i = (w - S) / 2, a = -(b + T) / 2, o = -(w + S) / 2;
  }
  return { ratioX: r, ratioY: i, offsetX: a, offsetY: o };
}
class Bs extends bi {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const r = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = r;
    else {
      let a = (u) => +r[u];
      if (st(r[t])) {
        const { key: u = "value" } = this._parsing;
        a = (d) => +Wa(r[d], u);
      }
      let o, s;
      for (o = t, s = t + n; o < s; ++o)
        i._parsed[o] = a(o);
    }
  }
  _getRotation() {
    return An(this.options.rotation - 90);
  }
  _getCircumference() {
    return An(this.options.circumference);
  }
  _getRotationExtents() {
    let t = zt, n = -zt;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r)) {
        const i = this.chart.getDatasetMeta(r).controller, a = i._getRotation(), o = i._getCircumference();
        t = Math.min(t, a), n = Math.max(n, a + o);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: r } = n, i = this._cachedMeta, a = i.data, o = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, s = Math.max((Math.min(r.width, r.height) - o) / 2, 0), u = Math.min(U5(this.options.cutout, s), 1), d = this._getRingWeight(this.index), { circumference: f, rotation: p } = this._getRotationExtents(), { ratioX: m, ratioY: g, offsetX: v, offsetY: b } = jW(p, f, u), w = (r.width - o) / m, T = (r.height - o) / g, S = Math.max(Math.min(w, T) / 2, 0), x = eT(this.options.radius, S), O = Math.max(x * u, 0), C = (x - O) / this._getVisibleDatasetWeightTotal();
    this.offsetX = v * x, this.offsetY = b * x, i.total = this.calculateTotal(), this.outerRadius = x - C * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - C * d, 0), this.updateElements(a, 0, a.length, t);
  }
  _circumference(t, n) {
    const r = this.options, i = this._cachedMeta, a = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(t) || i._parsed[t] === null || i.data[t].hidden ? 0 : this.calculateCircumference(i._parsed[t] * a / zt);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", o = this.chart, s = o.chartArea, d = o.options.animation, f = (s.left + s.right) / 2, p = (s.top + s.bottom) / 2, m = a && d.animateScale, g = m ? 0 : this.innerRadius, v = m ? 0 : this.outerRadius, { sharedOptions: b, includeOptions: w } = this._getSharedOptions(n, i);
    let T = this._getRotation(), S;
    for (S = 0; S < n; ++S)
      T += this._circumference(S, a);
    for (S = n; S < n + r; ++S) {
      const x = this._circumference(S, a), O = t[S], C = {
        x: f + this.offsetX,
        y: p + this.offsetY,
        startAngle: T,
        endAngle: T + x,
        circumference: x,
        outerRadius: v,
        innerRadius: g
      };
      w && (C.options = b || this.resolveDataElementOptions(S, O.active ? "active" : i)), T += x, this.updateElement(O, S, C, i);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let r = 0, i;
    for (i = 0; i < n.length; i++) {
      const a = t._parsed[i];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(i) && !n[i].hidden && (r += Math.abs(a));
    }
    return r;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? zt * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, i = r.data.labels || [], a = bu(n._parsed[t], r.options.locale);
    return {
      label: i[t] || "",
      value: a
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const r = this.chart;
    let i, a, o, s, u;
    if (!t) {
      for (i = 0, a = r.data.datasets.length; i < a; ++i)
        if (r.isDatasetVisible(i)) {
          o = r.getDatasetMeta(i), t = o.data, s = o.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (i = 0, a = t.length; i < a; ++i)
      u = s.resolveDataElementOptions(i), u.borderAlign !== "inner" && (n = Math.max(n, u.borderWidth || 0, u.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let r = 0, i = t.length; r < i; ++r) {
      const a = this.resolveDataElementOptions(r);
      n = Math.max(n, a.offset || 0, a.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(nt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Bs.id = "doughnut";
Bs.defaults = {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
};
Bs.descriptors = {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing"
};
Bs.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: n } } = e.legend.options;
            return t.labels.map((r, i) => {
              const o = e.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: r,
                fillStyle: o.backgroundColor,
                strokeStyle: o.borderColor,
                lineWidth: o.borderWidth,
                pointStyle: n,
                hidden: !e.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, n) {
        n.chart.toggleDataVisibility(t.index), n.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(e) {
          let t = e.label;
          const n = ": " + e.formattedValue;
          return jt(t) ? (t = t.slice(), t[0] += n) : t += n, t;
        }
      }
    }
  }
};
class Bd extends bi {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: r, data: i = [], _dataset: a } = n, o = this.chart._animationsDisabled;
    let { start: s, count: u } = uT(n, i, o);
    this._drawStart = s, this._drawCount = u, cT(n) && (s = 0, u = i.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!a._decimated, r.points = i;
    const d = this.resolveDatasetElementOptions(t);
    this.options.showLine || (d.borderWidth = 0), d.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !o,
      options: d
    }, t), this.updateElements(i, s, u, t);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { iScale: o, vScale: s, _stacked: u, _dataset: d } = this._cachedMeta, { sharedOptions: f, includeOptions: p } = this._getSharedOptions(n, i), m = o.axis, g = s.axis, { spanGaps: v, segment: b } = this.options, w = Cs(v) ? v : Number.POSITIVE_INFINITY, T = this.chart._animationsDisabled || a || i === "none";
    let S = n > 0 && this.getParsed(n - 1);
    for (let x = n; x < n + r; ++x) {
      const O = t[x], C = this.getParsed(x), P = T ? O : {}, k = ht(C[g]), M = P[m] = o.getPixelForValue(C[m], x), N = P[g] = a || k ? s.getBasePixel() : s.getPixelForValue(u ? this.applyStack(s, C, u) : C[g], x);
      P.skip = isNaN(M) || isNaN(N) || k, P.stop = x > 0 && Math.abs(C[m] - S[m]) > w, b && (P.parsed = C, P.raw = d.data[x]), p && (P.options = f || this.resolveDataElementOptions(x, O.active ? "active" : i)), T || this.updateElement(O, x, P, i), S = C;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, r = n.options && n.options.borderWidth || 0, i = t.data || [];
    if (!i.length)
      return r;
    const a = i[0].size(this.resolveDataElementOptions(0)), o = i[i.length - 1].size(this.resolveDataElementOptions(i.length - 1));
    return Math.max(r, a, o) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Bd.id = "line";
Bd.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
};
Bd.overrides = {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
};
class Ud extends bi {
  constructor(t, n) {
    super(t, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, i = r.data.labels || [], a = bu(n._parsed[t].r, r.options.locale);
    return {
      label: i[t] || "",
      value: a
    };
  }
  parseObjectData(t, n, r, i) {
    return xT.bind(this)(t, n, r, i);
  }
  update(t) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, n = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    return t.data.forEach((r, i) => {
      const a = this.getParsed(i).r;
      !isNaN(a) && this.chart.getDataVisibility(i) && (a < n.min && (n.min = a), a > n.max && (n.max = a));
    }), n;
  }
  _updateRadius() {
    const t = this.chart, n = t.chartArea, r = t.options, i = Math.min(n.right - n.left, n.bottom - n.top), a = Math.max(i / 2, 0), o = Math.max(r.cutoutPercentage ? a / 100 * r.cutoutPercentage : 1, 0), s = (a - o) / t.getVisibleDatasetCount();
    this.outerRadius = a - s * this.index, this.innerRadius = this.outerRadius - s;
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", o = this.chart, u = o.options.animation, d = this._cachedMeta.rScale, f = d.xCenter, p = d.yCenter, m = d.getIndexAngle(0) - 0.5 * Lt;
    let g = m, v;
    const b = 360 / this.countVisibleElements();
    for (v = 0; v < n; ++v)
      g += this._computeAngle(v, i, b);
    for (v = n; v < n + r; v++) {
      const w = t[v];
      let T = g, S = g + this._computeAngle(v, i, b), x = o.getDataVisibility(v) ? d.getDistanceFromCenterForValue(this.getParsed(v).r) : 0;
      g = S, a && (u.animateScale && (x = 0), u.animateRotate && (T = S = m));
      const O = {
        x: f,
        y: p,
        innerRadius: 0,
        outerRadius: x,
        startAngle: T,
        endAngle: S,
        options: this.resolveDataElementOptions(v, w.active ? "active" : i)
      };
      this.updateElement(w, v, O, i);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let n = 0;
    return t.data.forEach((r, i) => {
      !isNaN(this.getParsed(i).r) && this.chart.getDataVisibility(i) && n++;
    }), n;
  }
  _computeAngle(t, n, r) {
    return this.chart.getDataVisibility(t) ? An(this.resolveDataElementOptions(t, n).angle || r) : 0;
  }
}
Ud.id = "polarArea";
Ud.defaults = {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
    }
  },
  indexAxis: "r",
  startAngle: 0
};
Ud.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: n } } = e.legend.options;
            return t.labels.map((r, i) => {
              const o = e.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: r,
                fillStyle: o.backgroundColor,
                strokeStyle: o.borderColor,
                lineWidth: o.borderWidth,
                pointStyle: n,
                hidden: !e.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, n) {
        n.chart.toggleDataVisibility(t.index), n.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(e) {
          return e.chart.data.labels[e.dataIndex] + ": " + e.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
};
class sg extends Bs {
}
sg.id = "pie";
sg.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
};
class Wd extends bi {
  getLabelAndValue(t) {
    const n = this._cachedMeta.vScale, r = this.getParsed(t);
    return {
      label: n.getLabels()[t],
      value: "" + n.getLabelForValue(r[n.axis])
    };
  }
  parseObjectData(t, n, r, i) {
    return xT.bind(this)(t, n, r, i);
  }
  update(t) {
    const n = this._cachedMeta, r = n.dataset, i = n.data || [], a = n.iScale.getLabels();
    if (r.points = i, t !== "resize") {
      const o = this.resolveDatasetElementOptions(t);
      this.options.showLine || (o.borderWidth = 0);
      const s = {
        _loop: !0,
        _fullLoop: a.length === i.length,
        options: o
      };
      this.updateElement(r, void 0, s, t);
    }
    this.updateElements(i, 0, i.length, t);
  }
  updateElements(t, n, r, i) {
    const a = this._cachedMeta.rScale, o = i === "reset";
    for (let s = n; s < n + r; s++) {
      const u = t[s], d = this.resolveDataElementOptions(s, u.active ? "active" : i), f = a.getPointPositionForValue(s, this.getParsed(s).r), p = o ? a.xCenter : f.x, m = o ? a.yCenter : f.y, g = {
        x: p,
        y: m,
        angle: f.angle,
        skip: isNaN(p) || isNaN(m),
        options: d
      };
      this.updateElement(u, s, g, i);
    }
  }
}
Wd.id = "radar";
Wd.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
};
Wd.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
};
class Kn {
  constructor() {
    this.x = void 0, this.y = void 0, this.active = !1, this.options = void 0, this.$animations = void 0;
  }
  tooltipPosition(t) {
    const { x: n, y: r } = this.getProps(["x", "y"], t);
    return { x: n, y: r };
  }
  hasValue() {
    return Cs(this.x) && Cs(this.y);
  }
  getProps(t, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const i = {};
    return t.forEach((a) => {
      i[a] = r[a] && r[a].active() ? r[a]._to : this[a];
    }), i;
  }
}
Kn.defaults = {};
Kn.defaultRoutes = void 0;
const MT = {
  values(e) {
    return jt(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let i, a = e;
    if (n.length > 1) {
      const d = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (d < 1e-4 || d > 1e15) && (i = "scientific"), a = YW(e, n);
    }
    const o = si(Math.abs(a)), s = Math.max(Math.min(-1 * Math.floor(o), 20), 0), u = { notation: i, minimumFractionDigits: s, maximumFractionDigits: s };
    return Object.assign(u, this.options.ticks.format), bu(e, r, u);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const r = e / Math.pow(10, Math.floor(si(e)));
    return r === 1 || r === 2 || r === 5 ? MT.numeric.call(this, e, t, n) : "";
  }
};
function YW(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var Hd = { formatters: MT };
yt.set("scale", {
  display: !0,
  offset: !1,
  reverse: !1,
  beginAtZero: !1,
  bounds: "ticks",
  grace: 0,
  grid: {
    display: !0,
    lineWidth: 1,
    drawBorder: !0,
    drawOnChartArea: !0,
    drawTicks: !0,
    tickLength: 8,
    tickWidth: (e, t) => t.lineWidth,
    tickColor: (e, t) => t.color,
    offset: !1,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1
  },
  title: {
    display: !1,
    text: "",
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: !1,
    textStrokeWidth: 0,
    textStrokeColor: "",
    padding: 3,
    display: !0,
    autoSkip: !0,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Hd.formatters.values,
    minor: {},
    major: {},
    align: "center",
    crossAlign: "near",
    showLabelBackdrop: !1,
    backdropColor: "rgba(255, 255, 255, 0.75)",
    backdropPadding: 2
  }
});
yt.route("scale.ticks", "color", "", "color");
yt.route("scale.grid", "color", "", "borderColor");
yt.route("scale.grid", "borderColor", "", "borderColor");
yt.route("scale.title", "color", "", "color");
yt.describe("scale", {
  _fallback: !1,
  _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
  _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash"
});
yt.describe("scales", {
  _fallback: "scale"
});
yt.describe("scale.ticks", {
  _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
  _indexable: (e) => e !== "backdropPadding"
});
function zW(e, t) {
  const n = e.options.ticks, r = n.maxTicksLimit || GW(e), i = n.major.enabled ? KW(t) : [], a = i.length, o = i[0], s = i[a - 1], u = [];
  if (a > r)
    return XW(t, u, i, a / r), u;
  const d = qW(i, t, r);
  if (a > 0) {
    let f, p;
    const m = a > 1 ? Math.round((s - o) / (a - 1)) : null;
    for (Dc(t, u, d, ht(m) ? 0 : o - m, o), f = 0, p = a - 1; f < p; f++)
      Dc(t, u, d, i[f], i[f + 1]);
    return Dc(t, u, d, s, ht(m) ? t.length : s + m), u;
  }
  return Dc(t, u, d), u;
}
function GW(e) {
  const t = e.options.offset, n = e._tickSize(), r = e._length / n + (t ? 0 : 1), i = e._maxLength / n;
  return Math.floor(Math.min(r, i));
}
function qW(e, t, n) {
  const r = ZW(e), i = t.length / n;
  if (!r)
    return Math.max(i, 1);
  const a = q5(r);
  for (let o = 0, s = a.length - 1; o < s; o++) {
    const u = a[o];
    if (u > i)
      return u;
  }
  return Math.max(i, 1);
}
function KW(e) {
  const t = [];
  let n, r;
  for (n = 0, r = e.length; n < r; n++)
    e[n].major && t.push(n);
  return t;
}
function XW(e, t, n, r) {
  let i = 0, a = n[0], o;
  for (r = Math.ceil(r), o = 0; o < e.length; o++)
    o === a && (t.push(e[o]), i++, a = n[i * r]);
}
function Dc(e, t, n, r, i) {
  const a = nt(r, 0), o = Math.min(nt(i, e.length), e.length);
  let s = 0, u, d, f;
  for (n = Math.ceil(n), i && (u = i - r, n = u / Math.floor(u / n)), f = a; f < 0; )
    s++, f = Math.round(a + s * n);
  for (d = Math.max(a, 0); d < o; d++)
    d === f && (t.push(e[d]), s++, f = Math.round(a + s * n));
}
function ZW(e) {
  const t = e.length;
  let n, r;
  if (t < 2)
    return !1;
  for (r = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== r)
      return !1;
  return r;
}
const QW = (e) => e === "left" ? "right" : e === "right" ? "left" : e, Rb = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n;
function Fb(e, t) {
  const n = [], r = e.length / t, i = e.length;
  let a = 0;
  for (; a < i; a += r)
    n.push(e[Math.floor(a)]);
  return n;
}
function JW(e, t, n) {
  const r = e.ticks.length, i = Math.min(t, r - 1), a = e._startPixel, o = e._endPixel, s = 1e-6;
  let u = e.getPixelForTick(i), d;
  if (!(n && (r === 1 ? d = Math.max(u - a, o - u) : t === 0 ? d = (e.getPixelForTick(1) - u) / 2 : d = (u - e.getPixelForTick(i - 1)) / 2, u += i < t ? d : -d, u < a - s || u > o + s)))
    return u;
}
function e8(e, t) {
  $t(e, (n) => {
    const r = n.gc, i = r.length / 2;
    let a;
    if (i > t) {
      for (a = 0; a < i; ++a)
        delete n.data[r[a]];
      r.splice(0, i);
    }
  });
}
function hl(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function $b(e, t) {
  if (!e.display)
    return 0;
  const n = _n(e.font, t), r = On(e.padding);
  return (jt(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function t8(e, t) {
  return Za(e, {
    scale: t,
    type: "scale"
  });
}
function n8(e, t, n) {
  return Za(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function r8(e, t, n) {
  let r = Zm(e);
  return (n && t !== "right" || !n && t === "right") && (r = QW(r)), r;
}
function i8(e, t, n, r) {
  const { top: i, left: a, bottom: o, right: s, chart: u } = e, { chartArea: d, scales: f } = u;
  let p = 0, m, g, v;
  const b = o - i, w = s - a;
  if (e.isHorizontal()) {
    if (g = er(r, a, s), st(n)) {
      const T = Object.keys(n)[0], S = n[T];
      v = f[T].getPixelForValue(S) + b - t;
    } else n === "center" ? v = (d.bottom + d.top) / 2 + b - t : v = Rb(e, n, t);
    m = s - a;
  } else {
    if (st(n)) {
      const T = Object.keys(n)[0], S = n[T];
      g = f[T].getPixelForValue(S) - w + t;
    } else n === "center" ? g = (d.left + d.right) / 2 - w + t : g = Rb(e, n, t);
    v = er(r, o, i), p = n === "left" ? -vn : vn;
  }
  return { titleX: g, titleY: v, maxWidth: m, rotation: p };
}
class jo extends Kn {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: r, _suggestedMax: i } = this;
    return t = ri(t, Number.POSITIVE_INFINITY), n = ri(n, Number.NEGATIVE_INFINITY), r = ri(r, Number.POSITIVE_INFINITY), i = ri(i, Number.NEGATIVE_INFINITY), {
      min: ri(t, r),
      max: ri(n, i),
      minDefined: pn(t),
      maxDefined: pn(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: r, minDefined: i, maxDefined: a } = this.getUserBounds(), o;
    if (i && a)
      return { min: n, max: r };
    const s = this.getMatchingVisibleMetas();
    for (let u = 0, d = s.length; u < d; ++u)
      o = s[u].controller.getMinMax(this, t), i || (n = Math.min(n, o.min)), a || (r = Math.max(r, o.max));
    return n = a && n > r ? r : n, r = i && n > r ? n : r, {
      min: ri(n, ri(r, n)),
      max: ri(r, ri(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Ht(this.options.beforeUpdate, [this]);
  }
  update(t, n, r) {
    const { beginAtZero: i, grace: a, ticks: o } = this.options, s = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = R6(this, a, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const u = s < this.ticks.length;
    this._convertTicksToLabels(u ? Fb(this.ticks, s) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = zW(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), u && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, t = !t), this._startPixel = n, this._endPixel = r, this._reversePixels = t, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Ht(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    Ht(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Ht(this.options.afterSetDimensions, [this]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Ht(this.options[t], [this]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Ht(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let r, i, a;
    for (r = 0, i = t.length; r < i; r++)
      a = t[r], a.label = Ht(n.callback, [a.value, r, t], this);
  }
  afterTickToLabelConversion() {
    Ht(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    Ht(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, r = this.ticks.length, i = n.minRotation || 0, a = n.maxRotation;
    let o = i, s, u, d;
    if (!this._isVisible() || !n.display || i >= a || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const f = this._getLabelSizes(), p = f.widest.width, m = f.highest.height, g = Vn(this.chart.width - p, 0, this.maxWidth);
    s = t.offset ? this.maxWidth / r : g / (r - 1), p + 6 > s && (s = g / (r - (t.offset ? 0.5 : 1)), u = this.maxHeight - hl(t.grid) - n.padding - $b(t.title, this.chart.options.font), d = Math.sqrt(p * p + m * m), o = Rd(Math.min(
      Math.asin(Vn((f.highest.height + 6) / s, -1, 1)),
      Math.asin(Vn(u / d, -1, 1)) - Math.asin(Vn(m / d, -1, 1))
    )), o = Math.max(i, Math.min(a, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    Ht(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Ht(this.options.beforeFit, [this]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: i, grid: a } } = this, o = this._isVisible(), s = this.isHorizontal();
    if (o) {
      const u = $b(i, n.options.font);
      if (s ? (t.width = this.maxWidth, t.height = hl(a) + u) : (t.height = this.maxHeight, t.width = hl(a) + u), r.display && this.ticks.length) {
        const { first: d, last: f, widest: p, highest: m } = this._getLabelSizes(), g = r.padding * 2, v = An(this.labelRotation), b = Math.cos(v), w = Math.sin(v);
        if (s) {
          const T = r.mirror ? 0 : w * p.width + b * m.height;
          t.height = Math.min(this.maxHeight, t.height + T + g);
        } else {
          const T = r.mirror ? 0 : b * p.width + w * m.height;
          t.width = Math.min(this.maxWidth, t.width + T + g);
        }
        this._calculatePadding(d, f, w, b);
      }
    }
    this._handleMargins(), s ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, r, i) {
    const { ticks: { align: a, padding: o }, position: s } = this.options, u = this.labelRotation !== 0, d = s !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const f = this.getPixelForTick(0) - this.left, p = this.right - this.getPixelForTick(this.ticks.length - 1);
      let m = 0, g = 0;
      u ? d ? (m = i * t.width, g = r * n.height) : (m = r * t.height, g = i * n.width) : a === "start" ? g = n.width : a === "end" ? m = t.width : a !== "inner" && (m = t.width / 2, g = n.width / 2), this.paddingLeft = Math.max((m - f + o) * this.width / (this.width - f), 0), this.paddingRight = Math.max((g - p + o) * this.width / (this.width - p), 0);
    } else {
      let f = n.height / 2, p = t.height / 2;
      a === "start" ? (f = 0, p = t.height) : a === "end" && (f = n.height, p = 0), this.paddingTop = f + o, this.paddingBottom = p + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Ht(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, r;
    for (n = 0, r = t.length; n < r; n++)
      ht(t[n].label) && (t.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = Fb(r, n)), this._labelSizes = t = this._computeLabelSizes(r, r.length);
    }
    return t;
  }
  _computeLabelSizes(t, n) {
    const { ctx: r, _longestTextCache: i } = this, a = [], o = [];
    let s = 0, u = 0, d, f, p, m, g, v, b, w, T, S, x;
    for (d = 0; d < n; ++d) {
      if (m = t[d].label, g = this._resolveTickFontOptions(d), r.font = v = g.string, b = i[v] = i[v] || { data: {}, gc: [] }, w = g.lineHeight, T = S = 0, !ht(m) && !jt(m))
        T = md(r, b.data, b.gc, T, m), S = w;
      else if (jt(m))
        for (f = 0, p = m.length; f < p; ++f)
          x = m[f], !ht(x) && !jt(x) && (T = md(r, b.data, b.gc, T, x), S += w);
      a.push(T), o.push(S), s = Math.max(T, s), u = Math.max(S, u);
    }
    e8(i, n);
    const O = a.indexOf(s), C = o.indexOf(u), P = (k) => ({ width: a[k] || 0, height: o[k] || 0 });
    return {
      first: P(0),
      last: P(n - 1),
      widest: P(O),
      highest: P(C),
      widths: a,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return Z5(this._alignToPixels ? po(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return r.$context || (r.$context = n8(this.getContext(), t, r));
    }
    return this.$context || (this.$context = t8(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = An(this.labelRotation), r = Math.abs(Math.cos(n)), i = Math.abs(Math.sin(n)), a = this._getLabelSizes(), o = t.autoSkipPadding || 0, s = a ? a.widest.width + o : 0, u = a ? a.highest.height + o : 0;
    return this.isHorizontal() ? u * r > s * i ? s / r : u / i : u * i < s * r ? u / r : s / i;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, r = this.chart, i = this.options, { grid: a, position: o } = i, s = a.offset, u = this.isHorizontal(), f = this.ticks.length + (s ? 1 : 0), p = hl(a), m = [], g = a.setContext(this.getContext()), v = g.drawBorder ? g.borderWidth : 0, b = v / 2, w = function(G) {
      return po(r, G, v);
    };
    let T, S, x, O, C, P, k, M, N, X, Z, te;
    if (o === "top")
      T = w(this.bottom), P = this.bottom - p, M = T - b, X = w(t.top) + b, te = t.bottom;
    else if (o === "bottom")
      T = w(this.top), X = t.top, te = w(t.bottom) - b, P = T + b, M = this.top + p;
    else if (o === "left")
      T = w(this.right), C = this.right - p, k = T - b, N = w(t.left) + b, Z = t.right;
    else if (o === "right")
      T = w(this.left), N = t.left, Z = w(t.right) - b, C = T + b, k = this.left + p;
    else if (n === "x") {
      if (o === "center")
        T = w((t.top + t.bottom) / 2 + 0.5);
      else if (st(o)) {
        const G = Object.keys(o)[0], Q = o[G];
        T = w(this.chart.scales[G].getPixelForValue(Q));
      }
      X = t.top, te = t.bottom, P = T + b, M = P + p;
    } else if (n === "y") {
      if (o === "center")
        T = w((t.left + t.right) / 2);
      else if (st(o)) {
        const G = Object.keys(o)[0], Q = o[G];
        T = w(this.chart.scales[G].getPixelForValue(Q));
      }
      C = T - b, k = C - p, N = t.left, Z = t.right;
    }
    const ce = nt(i.ticks.maxTicksLimit, f), we = Math.max(1, Math.ceil(f / ce));
    for (S = 0; S < f; S += we) {
      const G = a.setContext(this.getContext(S)), Q = G.lineWidth, y = G.color, H = G.borderDash || [], ie = G.borderDashOffset, ne = G.tickWidth, J = G.tickColor, me = G.tickBorderDash || [], xe = G.tickBorderDashOffset;
      x = JW(this, S, s), x !== void 0 && (O = po(r, x, Q), u ? C = k = N = Z = O : P = M = X = te = O, m.push({
        tx1: C,
        ty1: P,
        tx2: k,
        ty2: M,
        x1: N,
        y1: X,
        x2: Z,
        y2: te,
        width: Q,
        color: y,
        borderDash: H,
        borderDashOffset: ie,
        tickWidth: ne,
        tickColor: J,
        tickBorderDash: me,
        tickBorderDashOffset: xe
      }));
    }
    return this._ticksLength = f, this._borderValue = T, m;
  }
  _computeLabelItems(t) {
    const n = this.axis, r = this.options, { position: i, ticks: a } = r, o = this.isHorizontal(), s = this.ticks, { align: u, crossAlign: d, padding: f, mirror: p } = a, m = hl(r.grid), g = m + f, v = p ? -f : g, b = -An(this.labelRotation), w = [];
    let T, S, x, O, C, P, k, M, N, X, Z, te, ce = "middle";
    if (i === "top")
      P = this.bottom - v, k = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      P = this.top + v, k = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const G = this._getYAxisLabelAlignment(m);
      k = G.textAlign, C = G.x;
    } else if (i === "right") {
      const G = this._getYAxisLabelAlignment(m);
      k = G.textAlign, C = G.x;
    } else if (n === "x") {
      if (i === "center")
        P = (t.top + t.bottom) / 2 + g;
      else if (st(i)) {
        const G = Object.keys(i)[0], Q = i[G];
        P = this.chart.scales[G].getPixelForValue(Q) + g;
      }
      k = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (i === "center")
        C = (t.left + t.right) / 2 - g;
      else if (st(i)) {
        const G = Object.keys(i)[0], Q = i[G];
        C = this.chart.scales[G].getPixelForValue(Q);
      }
      k = this._getYAxisLabelAlignment(m).textAlign;
    }
    n === "y" && (u === "start" ? ce = "top" : u === "end" && (ce = "bottom"));
    const we = this._getLabelSizes();
    for (T = 0, S = s.length; T < S; ++T) {
      x = s[T], O = x.label;
      const G = a.setContext(this.getContext(T));
      M = this.getPixelForTick(T) + a.labelOffset, N = this._resolveTickFontOptions(T), X = N.lineHeight, Z = jt(O) ? O.length : 1;
      const Q = Z / 2, y = G.color, H = G.textStrokeColor, ie = G.textStrokeWidth;
      let ne = k;
      o ? (C = M, k === "inner" && (T === S - 1 ? ne = this.options.reverse ? "left" : "right" : T === 0 ? ne = this.options.reverse ? "right" : "left" : ne = "center"), i === "top" ? d === "near" || b !== 0 ? te = -Z * X + X / 2 : d === "center" ? te = -we.highest.height / 2 - Q * X + X : te = -we.highest.height + X / 2 : d === "near" || b !== 0 ? te = X / 2 : d === "center" ? te = we.highest.height / 2 - Q * X : te = we.highest.height - Z * X, p && (te *= -1)) : (P = M, te = (1 - Z) * X / 2);
      let J;
      if (G.showLabelBackdrop) {
        const me = On(G.backdropPadding), xe = we.heights[T], U = we.widths[T];
        let $ = P + te - me.top, Y = C - me.left;
        switch (ce) {
          case "middle":
            $ -= xe / 2;
            break;
          case "bottom":
            $ -= xe;
            break;
        }
        switch (k) {
          case "center":
            Y -= U / 2;
            break;
          case "right":
            Y -= U;
            break;
        }
        J = {
          left: Y,
          top: $,
          width: U + me.width,
          height: xe + me.height,
          color: G.backdropColor
        };
      }
      w.push({
        rotation: b,
        label: O,
        font: N,
        color: y,
        strokeColor: H,
        strokeWidth: ie,
        textOffset: te,
        textAlign: ne,
        textBaseline: ce,
        translation: [C, P],
        backdrop: J
      });
    }
    return w;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-An(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return n.align === "start" ? i = "left" : n.align === "end" ? i = "right" : n.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: r, mirror: i, padding: a } } = this.options, o = this._getLabelSizes(), s = t + a, u = o.widest.width;
    let d, f;
    return n === "left" ? i ? (f = this.right + a, r === "near" ? d = "left" : r === "center" ? (d = "center", f += u / 2) : (d = "right", f += u)) : (f = this.right - s, r === "near" ? d = "right" : r === "center" ? (d = "center", f -= u / 2) : (d = "left", f = this.left)) : n === "right" ? i ? (f = this.left + a, r === "near" ? d = "right" : r === "center" ? (d = "center", f -= u / 2) : (d = "left", f -= u)) : (f = this.left + s, r === "near" ? d = "left" : r === "center" ? (d = "center", f += u / 2) : (d = "right", f = this.right)) : d = "right", { textAlign: d, x: f };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return { top: 0, left: this.left, bottom: t.height, right: this.right };
    if (n === "top" || n === "bottom")
      return { top: this.top, left: 0, bottom: this.bottom, right: t.width };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: r, top: i, width: a, height: o } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(r, i, a, o), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const i = this.ticks.findIndex((a) => a.value === t);
    return i >= 0 ? n.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, r = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, o;
    const s = (u, d, f) => {
      !f.width || !f.color || (r.save(), r.lineWidth = f.width, r.strokeStyle = f.color, r.setLineDash(f.borderDash || []), r.lineDashOffset = f.borderDashOffset, r.beginPath(), r.moveTo(u.x, u.y), r.lineTo(d.x, d.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (a = 0, o = i.length; a < o; ++a) {
        const u = i[a];
        n.drawOnChartArea && s(
          { x: u.x1, y: u.y1 },
          { x: u.x2, y: u.y2 },
          u
        ), n.drawTicks && s(
          { x: u.tx1, y: u.ty1 },
          { x: u.tx2, y: u.ty2 },
          {
            color: u.tickColor,
            width: u.tickWidth,
            borderDash: u.tickBorderDash,
            borderDashOffset: u.tickBorderDashOffset
          }
        );
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { grid: r } } = this, i = r.setContext(this.getContext()), a = r.drawBorder ? i.borderWidth : 0;
    if (!a)
      return;
    const o = r.setContext(this.getContext(0)).lineWidth, s = this._borderValue;
    let u, d, f, p;
    this.isHorizontal() ? (u = po(t, this.left, a) - a / 2, d = po(t, this.right, o) + o / 2, f = p = s) : (f = po(t, this.top, a) - a / 2, p = po(t, this.bottom, o) + o / 2, u = d = s), n.save(), n.lineWidth = i.borderWidth, n.strokeStyle = i.borderColor, n.beginPath(), n.moveTo(u, f), n.lineTo(d, p), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, i = this._computeLabelArea();
    i && _u(r, i);
    const a = this._labelItems || (this._labelItems = this._computeLabelItems(t));
    let o, s;
    for (o = 0, s = a.length; o < s; ++o) {
      const u = a[o], d = u.font, f = u.label;
      u.backdrop && (r.fillStyle = u.backdrop.color, r.fillRect(u.backdrop.left, u.backdrop.top, u.backdrop.width, u.backdrop.height));
      let p = u.textOffset;
      Lo(r, f, 0, p, d, u);
    }
    i && yu(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: r, reverse: i } } = this;
    if (!r.display)
      return;
    const a = _n(r.font), o = On(r.padding), s = r.align;
    let u = a.lineHeight / 2;
    n === "bottom" || n === "center" || st(n) ? (u += o.bottom, jt(r.text) && (u += a.lineHeight * (r.text.length - 1))) : u += o.top;
    const { titleX: d, titleY: f, maxWidth: p, rotation: m } = i8(this, u, n, s);
    Lo(t, r.text, 0, 0, a, {
      color: r.color,
      maxWidth: p,
      rotation: m,
      textAlign: r8(s, n, i),
      textBaseline: "middle",
      translation: [d, f]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, r = nt(t.grid && t.grid.z, -1);
    return !this._isVisible() || this.draw !== jo.prototype.draw ? [{
      z: n,
      draw: (i) => {
        this.draw(i);
      }
    }] : [{
      z: r,
      draw: (i) => {
        this.drawBackground(), this.drawGrid(i), this.drawTitle();
      }
    }, {
      z: r + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: n,
      draw: (i) => {
        this.drawLabels(i);
      }
    }];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", i = [];
    let a, o;
    for (a = 0, o = n.length; a < o; ++a) {
      const s = n[a];
      s[r] === this.id && (!t || s.type === t) && i.push(s);
    }
    return i;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return _n(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Pc {
  constructor(t, n, r) {
    this.type = t, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let r;
    s8(n) && (r = this.register(n));
    const i = this.items, a = t.id, o = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in i || (i[a] = t, a8(t, o, r), this.override && yt.override(t.id, t.overrides)), o;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, r = t.id, i = this.scope;
    r in n && delete n[r], i && r in yt[i] && (delete yt[i][r], this.override && delete No[r]);
  }
}
function a8(e, t, n) {
  const r = $i(/* @__PURE__ */ Object.create(null), [
    n ? yt.get(n) : {},
    yt.get(t),
    e.defaults
  ]);
  yt.set(t, r), e.defaultRoutes && o8(t, e.defaultRoutes), e.descriptors && yt.describe(t, e.descriptors);
}
function o8(e, t) {
  Object.keys(t).forEach((n) => {
    const r = n.split("."), i = r.pop(), a = [e].concat(r).join("."), o = t[n].split("."), s = o.pop(), u = o.join(".");
    yt.route(a, i, u, s);
  });
}
function s8(e) {
  return "id" in e && "defaults" in e;
}
class l8 {
  constructor() {
    this.controllers = new Pc(bi, "datasets", !0), this.elements = new Pc(Kn, "elements"), this.plugins = new Pc(Object, "plugins"), this.scales = new Pc(jo, "scales"), this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, r) {
    [...n].forEach((i) => {
      const a = r || this._getRegistryForType(i);
      r || a.isForType(i) || a === this.plugins && i.id ? this._exec(t, a, i) : $t(i, (o) => {
        const s = r || this._getRegistryForType(o);
        this._exec(t, s, o);
      });
    });
  }
  _exec(t, n, r) {
    const i = Km(t);
    Ht(r["before" + i], [], r), n[t](r), Ht(r["after" + i], [], r);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, n, r) {
    const i = n.get(t);
    if (i === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return i;
  }
}
var Mi = new l8();
class jd extends bi {
  update(t) {
    const n = this._cachedMeta, { data: r = [] } = n, i = this.chart._animationsDisabled;
    let { start: a, count: o } = uT(n, r, i);
    if (this._drawStart = a, this._drawCount = o, cT(n) && (a = 0, o = r.length), this.options.showLine) {
      const { dataset: s, _dataset: u } = n;
      s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!u._decimated, s.points = r;
      const d = this.resolveDatasetElementOptions(t);
      d.segment = this.options.segment, this.updateElement(s, void 0, {
        animated: !i,
        options: d
      }, t);
    }
    this.updateElements(r, a, o, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = Mi.getElement("line")), super.addElements();
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { iScale: o, vScale: s, _stacked: u, _dataset: d } = this._cachedMeta, f = this.resolveDataElementOptions(n, i), p = this.getSharedOptions(f), m = this.includeOptions(i, p), g = o.axis, v = s.axis, { spanGaps: b, segment: w } = this.options, T = Cs(b) ? b : Number.POSITIVE_INFINITY, S = this.chart._animationsDisabled || a || i === "none";
    let x = n > 0 && this.getParsed(n - 1);
    for (let O = n; O < n + r; ++O) {
      const C = t[O], P = this.getParsed(O), k = S ? C : {}, M = ht(P[v]), N = k[g] = o.getPixelForValue(P[g], O), X = k[v] = a || M ? s.getBasePixel() : s.getPixelForValue(u ? this.applyStack(s, P, u) : P[v], O);
      k.skip = isNaN(N) || isNaN(X) || M, k.stop = O > 0 && Math.abs(P[g] - x[g]) > T, w && (k.parsed = P, k.raw = d.data[O]), m && (k.options = p || this.resolveDataElementOptions(O, C.active ? "active" : i)), S || this.updateElement(C, O, k, i), x = P;
    }
    this.updateSharedOptions(p, i, f);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let s = 0;
      for (let u = n.length - 1; u >= 0; --u)
        s = Math.max(s, n[u].size(this.resolveDataElementOptions(u)) / 2);
      return s > 0 && s;
    }
    const r = t.dataset, i = r.options && r.options.borderWidth || 0;
    if (!n.length)
      return i;
    const a = n[0].size(this.resolveDataElementOptions(0)), o = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(i, a, o) / 2;
  }
}
jd.id = "scatter";
jd.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
};
jd.overrides = {
  interaction: {
    mode: "point"
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(e) {
          return "(" + e.label + ", " + e.formattedValue + ")";
        }
      }
    }
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
};
var u8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: $d,
  BubbleController: Vd,
  DoughnutController: Bs,
  LineController: Bd,
  PolarAreaController: Ud,
  PieController: sg,
  RadarController: Wd,
  ScatterController: jd
});
function mo() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Fp {
  constructor(t) {
    this.options = t || {};
  }
  init(t) {
  }
  formats() {
    return mo();
  }
  parse(t, n) {
    return mo();
  }
  format(t, n) {
    return mo();
  }
  add(t, n, r) {
    return mo();
  }
  diff(t, n, r) {
    return mo();
  }
  startOf(t, n, r) {
    return mo();
  }
  endOf(t, n) {
    return mo();
  }
}
Fp.override = function(e) {
  Object.assign(Fp.prototype, e);
};
var c8 = {
  _date: Fp
};
function d8(e, t, n, r) {
  const { controller: i, data: a, _sorted: o } = e, s = i._cachedMeta.iScale;
  if (s && t === s.axis && t !== "r" && o && a.length) {
    const u = s._reversePixels ? Q5 : fa;
    if (r) {
      if (i._sharedOptions) {
        const d = a[0], f = typeof d.getRange == "function" && d.getRange(t);
        if (f) {
          const p = u(a, t, n - f), m = u(a, t, n + f);
          return { lo: p.lo, hi: m.hi };
        }
      }
    } else return u(a, t, n);
  }
  return { lo: 0, hi: a.length - 1 };
}
function wu(e, t, n, r, i) {
  const a = e.getSortedVisibleDatasetMetas(), o = n[t];
  for (let s = 0, u = a.length; s < u; ++s) {
    const { index: d, data: f } = a[s], { lo: p, hi: m } = d8(a[s], t, o, i);
    for (let g = p; g <= m; ++g) {
      const v = f[g];
      v.skip || r(v, d, g);
    }
  }
}
function f8(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(r, i) {
    const a = t ? Math.abs(r.x - i.x) : 0, o = n ? Math.abs(r.y - i.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(o, 2));
  };
}
function Gh(e, t, n, r, i) {
  const a = [];
  return !i && !e.isPointInArea(t) || wu(e, n, t, function(s, u, d) {
    !i && !Zl(s, e.chartArea, 0) || s.inRange(t.x, t.y, r) && a.push({ element: s, datasetIndex: u, index: d });
  }, !0), a;
}
function h8(e, t, n, r) {
  let i = [];
  function a(o, s, u) {
    const { startAngle: d, endAngle: f } = o.getProps(["startAngle", "endAngle"], r), { angle: p } = iT(o, { x: t.x, y: t.y });
    Xl(p, d, f) && i.push({ element: o, datasetIndex: s, index: u });
  }
  return wu(e, n, t, a), i;
}
function p8(e, t, n, r, i, a) {
  let o = [];
  const s = f8(n);
  let u = Number.POSITIVE_INFINITY;
  function d(f, p, m) {
    const g = f.inRange(t.x, t.y, i);
    if (r && !g)
      return;
    const v = f.getCenterPoint(i);
    if (!(!!a || e.isPointInArea(v)) && !g)
      return;
    const w = s(t, v);
    w < u ? (o = [{ element: f, datasetIndex: p, index: m }], u = w) : w === u && o.push({ element: f, datasetIndex: p, index: m });
  }
  return wu(e, n, t, d), o;
}
function qh(e, t, n, r, i, a) {
  return !a && !e.isPointInArea(t) ? [] : n === "r" && !r ? h8(e, t, n, i) : p8(e, t, n, r, i, a);
}
function Vb(e, t, n, r, i) {
  const a = [], o = n === "x" ? "inXRange" : "inYRange";
  let s = !1;
  return wu(e, n, t, (u, d, f) => {
    u[o](t[n], i) && (a.push({ element: u, datasetIndex: d, index: f }), s = s || u.inRange(t.x, t.y, i));
  }), r && !s ? [] : a;
}
var m8 = {
  evaluateInteractionItems: wu,
  modes: {
    index(e, t, n, r) {
      const i = yo(t, e), a = n.axis || "x", o = n.includeInvisible || !1, s = n.intersect ? Gh(e, i, a, r, o) : qh(e, i, a, !1, r, o), u = [];
      return s.length ? (e.getSortedVisibleDatasetMetas().forEach((d) => {
        const f = s[0].index, p = d.data[f];
        p && !p.skip && u.push({ element: p, datasetIndex: d.index, index: f });
      }), u) : [];
    },
    dataset(e, t, n, r) {
      const i = yo(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
      let s = n.intersect ? Gh(e, i, a, r, o) : qh(e, i, a, !1, r, o);
      if (s.length > 0) {
        const u = s[0].datasetIndex, d = e.getDatasetMeta(u).data;
        s = [];
        for (let f = 0; f < d.length; ++f)
          s.push({ element: d[f], datasetIndex: u, index: f });
      }
      return s;
    },
    point(e, t, n, r) {
      const i = yo(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
      return Gh(e, i, a, r, o);
    },
    nearest(e, t, n, r) {
      const i = yo(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
      return qh(e, i, a, n.intersect, r, o);
    },
    x(e, t, n, r) {
      const i = yo(t, e);
      return Vb(e, i, "x", n.intersect, r);
    },
    y(e, t, n, r) {
      const i = yo(t, e);
      return Vb(e, i, "y", n.intersect, r);
    }
  }
};
const IT = ["left", "top", "right", "bottom"];
function pl(e, t) {
  return e.filter((n) => n.pos === t);
}
function Bb(e, t) {
  return e.filter((n) => IT.indexOf(n.pos) === -1 && n.box.axis === t);
}
function ml(e, t) {
  return e.sort((n, r) => {
    const i = t ? r : n, a = t ? n : r;
    return i.weight === a.weight ? i.index - a.index : i.weight - a.weight;
  });
}
function g8(e) {
  const t = [];
  let n, r, i, a, o, s;
  for (n = 0, r = (e || []).length; n < r; ++n)
    i = e[n], { position: a, options: { stack: o, stackWeight: s = 1 } } = i, t.push({
      index: n,
      box: i,
      pos: a,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: o && a + o,
      stackWeight: s
    });
  return t;
}
function v8(e) {
  const t = {};
  for (const n of e) {
    const { stack: r, pos: i, stackWeight: a } = n;
    if (!r || !IT.includes(i))
      continue;
    const o = t[r] || (t[r] = { count: 0, placed: 0, weight: 0, size: 0 });
    o.count++, o.weight += a;
  }
  return t;
}
function _8(e, t) {
  const n = v8(e), { vBoxMaxWidth: r, hBoxMaxHeight: i } = t;
  let a, o, s;
  for (a = 0, o = e.length; a < o; ++a) {
    s = e[a];
    const { fullSize: u } = s.box, d = n[s.stack], f = d && s.stackWeight / d.weight;
    s.horizontal ? (s.width = f ? f * r : u && t.availableWidth, s.height = i) : (s.width = r, s.height = f ? f * i : u && t.availableHeight);
  }
  return n;
}
function y8(e) {
  const t = g8(e), n = ml(t.filter((d) => d.box.fullSize), !0), r = ml(pl(t, "left"), !0), i = ml(pl(t, "right")), a = ml(pl(t, "top"), !0), o = ml(pl(t, "bottom")), s = Bb(t, "x"), u = Bb(t, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(a),
    rightAndBottom: i.concat(u).concat(o).concat(s),
    chartArea: pl(t, "chartArea"),
    vertical: r.concat(i).concat(u),
    horizontal: a.concat(o).concat(s)
  };
}
function Ub(e, t, n, r) {
  return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function NT(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function b8(e, t, n, r) {
  const { pos: i, box: a } = n, o = e.maxPadding;
  if (!st(i)) {
    n.size && (e[i] -= n.size);
    const p = r[n.stack] || { size: 0, count: 1 };
    p.size = Math.max(p.size, n.horizontal ? a.height : a.width), n.size = p.size / p.count, e[i] += n.size;
  }
  a.getPadding && NT(o, a.getPadding());
  const s = Math.max(0, t.outerWidth - Ub(o, e, "left", "right")), u = Math.max(0, t.outerHeight - Ub(o, e, "top", "bottom")), d = s !== e.w, f = u !== e.h;
  return e.w = s, e.h = u, n.horizontal ? { same: d, other: f } : { same: f, other: d };
}
function w8(e) {
  const t = e.maxPadding;
  function n(r) {
    const i = Math.max(t[r] - e[r], 0);
    return e[r] += i, i;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function x8(e, t) {
  const n = t.maxPadding;
  function r(i) {
    const a = { left: 0, top: 0, right: 0, bottom: 0 };
    return i.forEach((o) => {
      a[o] = Math.max(t[o], n[o]);
    }), a;
  }
  return r(e ? ["left", "right"] : ["top", "bottom"]);
}
function El(e, t, n, r) {
  const i = [];
  let a, o, s, u, d, f;
  for (a = 0, o = e.length, d = 0; a < o; ++a) {
    s = e[a], u = s.box, u.update(
      s.width || t.w,
      s.height || t.h,
      x8(s.horizontal, t)
    );
    const { same: p, other: m } = b8(t, n, s, r);
    d |= p && i.length, f = f || m, u.fullSize || i.push(s);
  }
  return d && El(i, t, n, r) || f;
}
function Mc(e, t, n, r, i) {
  e.top = n, e.left = t, e.right = t + r, e.bottom = n + i, e.width = r, e.height = i;
}
function Wb(e, t, n, r) {
  const i = n.padding;
  let { x: a, y: o } = t;
  for (const s of e) {
    const u = s.box, d = r[s.stack] || { count: 1, placed: 0, weight: 1 }, f = s.stackWeight / d.weight || 1;
    if (s.horizontal) {
      const p = t.w * f, m = d.size || u.height;
      Sn(d.start) && (o = d.start), u.fullSize ? Mc(u, i.left, o, n.outerWidth - i.right - i.left, m) : Mc(u, t.left + d.placed, o, p, m), d.start = o, d.placed += p, o = u.bottom;
    } else {
      const p = t.h * f, m = d.size || u.width;
      Sn(d.start) && (a = d.start), u.fullSize ? Mc(u, a, i.top, m, n.outerHeight - i.bottom - i.top) : Mc(u, a, t.top + d.placed, m, p), d.start = a, d.placed += p, a = u.right;
    }
  }
  t.x = a, t.y = o;
}
yt.set("layout", {
  autoPadding: !0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var or = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [{
        z: 0,
        draw(n) {
          t.draw(n);
        }
      }];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, r) {
    if (!e)
      return;
    const i = On(e.options.layout.padding), a = Math.max(t - i.width, 0), o = Math.max(n - i.height, 0), s = y8(e.boxes), u = s.vertical, d = s.horizontal;
    $t(e.boxes, (b) => {
      typeof b.beforeLayout == "function" && b.beforeLayout();
    });
    const f = u.reduce((b, w) => w.box.options && w.box.options.display === !1 ? b : b + 1, 0) || 1, p = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: i,
      availableWidth: a,
      availableHeight: o,
      vBoxMaxWidth: a / 2 / f,
      hBoxMaxHeight: o / 2
    }), m = Object.assign({}, i);
    NT(m, On(r));
    const g = Object.assign({
      maxPadding: m,
      w: a,
      h: o,
      x: i.left,
      y: i.top
    }, i), v = _8(u.concat(d), p);
    El(s.fullSize, g, p, v), El(u, g, p, v), El(d, g, p, v) && El(u, g, p, v), w8(g), Wb(s.leftAndTop, g, p, v), g.x += g.w, g.y += g.h, Wb(s.rightAndBottom, g, p, v), e.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, $t(s.chartArea, (b) => {
      const w = b.box;
      Object.assign(w, e.chartArea), w.update(g.w, g.h, { left: 0, top: 0, right: 0, bottom: 0 });
    });
  }
};
class LT {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, r) {
  }
  removeEventListener(t, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, r, i) {
    return n = Math.max(0, n || t.width), r = r || t.height, {
      width: n,
      height: Math.max(0, i ? Math.floor(n / i) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class E8 extends LT {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Kc = "$chartjs", T8 = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Hb = (e) => e === null || e === "";
function k8(e, t) {
  const n = e.style, r = e.getAttribute("height"), i = e.getAttribute("width");
  if (e[Kc] = {
    initial: {
      height: r,
      width: i,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", Hb(i)) {
    const a = wb(e, "width");
    a !== void 0 && (e.width = a);
  }
  if (Hb(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const a = wb(e, "height");
      a !== void 0 && (e.height = a);
    }
  return e;
}
const RT = aW ? { passive: !0 } : !1;
function S8(e, t, n) {
  e.addEventListener(t, n, RT);
}
function O8(e, t, n) {
  e.canvas.removeEventListener(t, n, RT);
}
function C8(e, t) {
  const n = T8[e.type] || e.type, { x: r, y: i } = yo(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: i !== void 0 ? i : null
  };
}
function _d(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function A8(e, t, n) {
  const r = e.canvas, i = new MutationObserver((a) => {
    let o = !1;
    for (const s of a)
      o = o || _d(s.addedNodes, r), o = o && !_d(s.removedNodes, r);
    o && n();
  });
  return i.observe(document, { childList: !0, subtree: !0 }), i;
}
function D8(e, t, n) {
  const r = e.canvas, i = new MutationObserver((a) => {
    let o = !1;
    for (const s of a)
      o = o || _d(s.removedNodes, r), o = o && !_d(s.addedNodes, r);
    o && n();
  });
  return i.observe(document, { childList: !0, subtree: !0 }), i;
}
const Ql = /* @__PURE__ */ new Map();
let jb = 0;
function FT() {
  const e = window.devicePixelRatio;
  e !== jb && (jb = e, Ql.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function P8(e, t) {
  Ql.size || window.addEventListener("resize", FT), Ql.set(e, t);
}
function M8(e) {
  Ql.delete(e), Ql.size || window.removeEventListener("resize", FT);
}
function I8(e, t, n) {
  const r = e.canvas, i = r && ag(r);
  if (!i)
    return;
  const a = lT((s, u) => {
    const d = i.clientWidth;
    n(s, u), d < i.clientWidth && n();
  }, window), o = new ResizeObserver((s) => {
    const u = s[0], d = u.contentRect.width, f = u.contentRect.height;
    d === 0 && f === 0 || a(d, f);
  });
  return o.observe(i), P8(e, a), o;
}
function Kh(e, t, n) {
  n && n.disconnect(), t === "resize" && M8(e);
}
function N8(e, t, n) {
  const r = e.canvas, i = lT((a) => {
    e.ctx !== null && n(C8(a, e));
  }, e, (a) => {
    const o = a[0];
    return [o, o.offsetX, o.offsetY];
  });
  return S8(r, t, i), i;
}
class L8 extends LT {
  acquireContext(t, n) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (k8(t, n), r) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[Kc])
      return !1;
    const r = n[Kc].initial;
    ["height", "width"].forEach((a) => {
      const o = r[a];
      ht(o) ? n.removeAttribute(a) : n.setAttribute(a, o);
    });
    const i = r.style || {};
    return Object.keys(i).forEach((a) => {
      n.style[a] = i[a];
    }), n.width = n.width, delete n[Kc], !0;
  }
  addEventListener(t, n, r) {
    this.removeEventListener(t, n);
    const i = t.$proxies || (t.$proxies = {}), o = {
      attach: A8,
      detach: D8,
      resize: I8
    }[n] || N8;
    i[n] = o(t, n, r);
  }
  removeEventListener(t, n) {
    const r = t.$proxies || (t.$proxies = {}), i = r[n];
    if (!i)
      return;
    ({
      attach: Kh,
      detach: Kh,
      resize: Kh
    }[n] || O8)(t, n, i), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, r, i) {
    return iW(t, n, r, i);
  }
  isAttached(t) {
    const n = ag(t);
    return !!(n && n.isConnected);
  }
}
function R8(e) {
  return !TT() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? E8 : L8;
}
class F8 {
  constructor() {
    this._init = [];
  }
  notify(t, n, r, i) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = i ? this._descriptors(t).filter(i) : this._descriptors(t), o = this._notify(a, t, n, r);
    return n === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), o;
  }
  _notify(t, n, r, i) {
    i = i || {};
    for (const a of t) {
      const o = a.plugin, s = o[r], u = [n, i, a.options];
      if (Ht(s, u, o) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    ht(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const r = t && t.config, i = nt(r.options && r.options.plugins, {}), a = $8(r);
    return i === !1 && !n ? [] : B8(t, a, i, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], r = this._cache, i = (a, o) => a.filter((s) => !o.some((u) => s.plugin.id === u.plugin.id));
    this._notify(i(n, r), t, "stop"), this._notify(i(r, n), t, "start");
  }
}
function $8(e) {
  const t = {}, n = [], r = Object.keys(Mi.plugins.items);
  for (let a = 0; a < r.length; a++)
    n.push(Mi.getPlugin(r[a]));
  const i = e.plugins || [];
  for (let a = 0; a < i.length; a++) {
    const o = i[a];
    n.indexOf(o) === -1 && (n.push(o), t[o.id] = !0);
  }
  return { plugins: n, localIds: t };
}
function V8(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function B8(e, { plugins: t, localIds: n }, r, i) {
  const a = [], o = e.getContext();
  for (const s of t) {
    const u = s.id, d = V8(r[u], i);
    d !== null && a.push({
      plugin: s,
      options: U8(e.config, { plugin: s, local: n[u] }, d, o)
    });
  }
  return a;
}
function U8(e, { plugin: t, local: n }, r, i) {
  const a = e.pluginScopeKeys(t), o = e.getOptionScopes(r, a);
  return n && t.defaults && o.push(t.defaults), e.createResolver(o, i, [""], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function $p(e, t) {
  const n = yt.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function W8(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function H8(e, t) {
  return e === t ? "_index_" : "_value_";
}
function j8(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Vp(e, t) {
  return e === "x" || e === "y" ? e : t.axis || j8(t.position) || e.charAt(0).toLowerCase();
}
function Y8(e, t) {
  const n = No[e.type] || { scales: {} }, r = t.scales || {}, i = $p(e.type, t), a = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((s) => {
    const u = r[s];
    if (!st(u))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (u._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const d = Vp(s, u), f = H8(d, i), p = n.scales || {};
    a[d] = a[d] || s, o[s] = Ll(/* @__PURE__ */ Object.create(null), [{ axis: d }, u, p[d], p[f]]);
  }), e.data.datasets.forEach((s) => {
    const u = s.type || e.type, d = s.indexAxis || $p(u, t), p = (No[u] || {}).scales || {};
    Object.keys(p).forEach((m) => {
      const g = W8(m, d), v = s[g + "AxisID"] || a[g] || g;
      o[v] = o[v] || /* @__PURE__ */ Object.create(null), Ll(o[v], [{ axis: g }, r[v], p[m]]);
    });
  }), Object.keys(o).forEach((s) => {
    const u = o[s];
    Ll(u, [yt.scales[u.type], yt.scale]);
  }), o;
}
function $T(e) {
  const t = e.options || (e.options = {});
  t.plugins = nt(t.plugins, {}), t.scales = Y8(e, t);
}
function VT(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function z8(e) {
  return e = e || {}, e.data = VT(e.data), $T(e), e;
}
const Yb = /* @__PURE__ */ new Map(), BT = /* @__PURE__ */ new Set();
function Ic(e, t) {
  let n = Yb.get(e);
  return n || (n = t(), Yb.set(e, n), BT.add(n)), n;
}
const gl = (e, t, n) => {
  const r = Wa(t, n);
  r !== void 0 && e.add(r);
};
class G8 {
  constructor(t) {
    this._config = z8(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = VT(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), $T(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Ic(
      t,
      () => [[
        `datasets.${t}`,
        ""
      ]]
    );
  }
  datasetAnimationScopeKeys(t, n) {
    return Ic(
      `${t}.transition.${n}`,
      () => [
        [
          `datasets.${t}.transitions.${n}`,
          `transitions.${n}`
        ],
        [
          `datasets.${t}`,
          ""
        ]
      ]
    );
  }
  datasetElementScopeKeys(t, n) {
    return Ic(
      `${t}-${n}`,
      () => [[
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]]
    );
  }
  pluginScopeKeys(t) {
    const n = t.id, r = this.type;
    return Ic(
      `${r}-plugin-${n}`,
      () => [[
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]]
    );
  }
  _cachedScopes(t, n) {
    const r = this._scopeCache;
    let i = r.get(t);
    return (!i || n) && (i = /* @__PURE__ */ new Map(), r.set(t, i)), i;
  }
  getOptionScopes(t, n, r) {
    const { options: i, type: a } = this, o = this._cachedScopes(t, r), s = o.get(n);
    if (s)
      return s;
    const u = /* @__PURE__ */ new Set();
    n.forEach((f) => {
      t && (u.add(t), f.forEach((p) => gl(u, t, p))), f.forEach((p) => gl(u, i, p)), f.forEach((p) => gl(u, No[a] || {}, p)), f.forEach((p) => gl(u, yt, p)), f.forEach((p) => gl(u, Rp, p));
    });
    const d = Array.from(u);
    return d.length === 0 && d.push(/* @__PURE__ */ Object.create(null)), BT.has(n) && o.set(n, d), d;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      No[n] || {},
      yt.datasets[n] || {},
      { type: n },
      yt,
      Rp
    ];
  }
  resolveNamedOptions(t, n, r, i = [""]) {
    const a = { $shared: !0 }, { resolver: o, subPrefixes: s } = zb(this._resolverCache, t, i);
    let u = o;
    if (K8(o, n)) {
      a.$shared = !1, r = Ha(r) ? r() : r;
      const d = this.createResolver(t, r, s);
      u = Ds(o, r, d);
    }
    for (const d of n)
      a[d] = u[d];
    return a;
  }
  createResolver(t, n, r = [""], i) {
    const { resolver: a } = zb(this._resolverCache, t, r);
    return st(n) ? Ds(a, n, void 0, i) : a;
  }
}
function zb(e, t, n) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const i = n.join();
  let a = r.get(i);
  return a || (a = {
    resolver: ng(t, n),
    subPrefixes: n.filter((s) => !s.toLowerCase().includes("hover"))
  }, r.set(i, a)), a;
}
const q8 = (e) => st(e) && Object.getOwnPropertyNames(e).reduce((t, n) => t || Ha(e[n]), !1);
function K8(e, t) {
  const { isScriptable: n, isIndexable: r } = _T(e);
  for (const i of t) {
    const a = n(i), o = r(i), s = (o || a) && e[i];
    if (a && (Ha(s) || q8(s)) || o && jt(s))
      return !0;
  }
  return !1;
}
var X8 = "3.9.1";
const Z8 = ["top", "bottom", "left", "right", "chartArea"];
function Gb(e, t) {
  return e === "top" || e === "bottom" || Z8.indexOf(e) === -1 && t === "x";
}
function qb(e, t) {
  return function(n, r) {
    return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
  };
}
function Kb(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), Ht(n && n.onComplete, [e], t);
}
function Q8(e) {
  const t = e.chart, n = t.options.animation;
  Ht(n && n.onProgress, [e], t);
}
function UT(e) {
  return TT() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const yd = {}, WT = (e) => {
  const t = UT(e);
  return Object.values(yd).filter((n) => n.canvas === t).pop();
};
function J8(e, t, n) {
  const r = Object.keys(e);
  for (const i of r) {
    const a = +i;
    if (a >= t) {
      const o = e[i];
      delete e[i], (n > 0 || a > t) && (e[a + n] = o);
    }
  }
}
function eH(e, t, n, r) {
  return !n || e.type === "mouseout" ? null : r ? t : e;
}
class Ra {
  constructor(t, n) {
    const r = this.config = new G8(n), i = UT(t), a = WT(i);
    if (a)
      throw new Error(
        "Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused."
      );
    const o = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || R8(i))(), this.platform.updateConfig(r);
    const s = this.platform.acquireContext(i, o.aspectRatio), u = s && s.canvas, d = u && u.height, f = u && u.width;
    if (this.id = B5(), this.ctx = s, this.canvas = u, this.width = f, this.height = d, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new F8(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = t6((p) => this.update(p), o.resizeDelay || 0), this._dataChanges = [], yd[this.id] = this, !s || !u) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    ta.listen(this, "complete", Kb), ta.listen(this, "progress", Q8), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: r, height: i, _aspectRatio: a } = this;
    return ht(t) ? n && a ? a : i ? r / i : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : bb(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return vb(this.canvas, this.ctx), this;
  }
  stop() {
    return ta.stop(this), this;
  }
  resize(t, n) {
    ta.running(this) ? this._resizeBeforeDraw = { width: t, height: n } : this._resize(t, n);
  }
  _resize(t, n) {
    const r = this.options, i = this.canvas, a = r.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(i, t, n, a), s = r.devicePixelRatio || this.platform.getDevicePixelRatio(), u = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, bb(this, s, !0) && (this.notifyPlugins("resize", { size: o }), Ht(r.onResize, [this, o], this), this.attached && this._doResize(u) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    $t(n, (r, i) => {
      r.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, r = this.scales, i = Object.keys(r).reduce((o, s) => (o[s] = !1, o), {});
    let a = [];
    n && (a = a.concat(
      Object.keys(n).map((o) => {
        const s = n[o], u = Vp(o, s), d = u === "r", f = u === "x";
        return {
          options: s,
          dposition: d ? "chartArea" : f ? "bottom" : "left",
          dtype: d ? "radialLinear" : f ? "category" : "linear"
        };
      })
    )), $t(a, (o) => {
      const s = o.options, u = s.id, d = Vp(u, s), f = nt(s.type, o.dtype);
      (s.position === void 0 || Gb(s.position, d) !== Gb(o.dposition)) && (s.position = o.dposition), i[u] = !0;
      let p = null;
      if (u in r && r[u].type === f)
        p = r[u];
      else {
        const m = Mi.getScale(f);
        p = new m({
          id: u,
          type: f,
          ctx: this.ctx,
          chart: this
        }), r[p.id] = p;
      }
      p.init(s, t);
    }), $t(i, (o, s) => {
      o || delete r[s];
    }), $t(r, (o) => {
      or.configure(this, o, o.options), or.addBox(this, o);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, r = t.length;
    if (t.sort((i, a) => i.index - a.index), r > n) {
      for (let i = n; i < r; ++i)
        this._destroyDatasetMeta(i);
      t.splice(n, r - n);
    }
    this._sortedMetasets = t.slice(0).sort(qb("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((r, i) => {
      n.filter((a) => a === r._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let r, i;
    for (this._removeUnreferencedMetasets(), r = 0, i = n.length; r < i; r++) {
      const a = n[r];
      let o = this.getDatasetMeta(r);
      const s = a.type || this.config.type;
      if (o.type && o.type !== s && (this._destroyDatasetMeta(r), o = this.getDatasetMeta(r)), o.type = s, o.indexAxis = a.indexAxis || $p(s, this.options), o.order = a.order || 0, o.index = r, o.label = "" + a.label, o.visible = this.isDatasetVisible(r), o.controller)
        o.controller.updateIndex(r), o.controller.linkScales();
      else {
        const u = Mi.getController(s), { datasetElementType: d, dataElementType: f } = yt.datasets[s];
        Object.assign(u.prototype, {
          dataElementType: Mi.getElement(f),
          datasetElementType: d && Mi.getElement(d)
        }), o.controller = new u(this, r), t.push(o.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    $t(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", { mode: t, cancelable: !0 }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let d = 0, f = this.data.datasets.length; d < f; d++) {
      const { controller: p } = this.getDatasetMeta(d), m = !i && a.indexOf(p) === -1;
      p.buildOrUpdateElements(m), o = Math.max(+p.getMaxOverflow(), o);
    }
    o = this._minPadding = r.layout.autoPadding ? o : 0, this._updateLayout(o), i || $t(a, (d) => {
      d.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", { mode: t }), this._layers.sort(qb("z", "_idx"));
    const { _active: s, _lastEvent: u } = this;
    u ? this._eventHandler(u, !0) : s.length && this._updateHoverStyles(s, s, !0), this.render();
  }
  _updateScales() {
    $t(this.scales, (t) => {
      or.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!ab(n, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: i, count: a } of n) {
      const o = r === "_removeElements" ? -a : a;
      J8(t, i, o);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (a) => new Set(
      t.filter((o) => o[0] === a).map((o, s) => s + "," + o.splice(1).join(","))
    ), i = r(0);
    for (let a = 1; a < n; a++)
      if (!ab(i, r(a)))
        return;
    return Array.from(i).map((a) => a.split(",")).map((a) => ({ method: a[1], start: +a[2], count: +a[3] }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", { cancelable: !0 }) === !1)
      return;
    or.update(this, this.width, this.height, t);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], $t(this.boxes, (i) => {
      r && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, a) => {
      i._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", { mode: t, cancelable: !0 }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Ha(t) ? t({ datasetIndex: n }) : t);
      this.notifyPlugins("afterDatasetsUpdate", { mode: t });
    }
  }
  _updateDataset(t, n) {
    const r = this.getDatasetMeta(t), i = { meta: r, index: t, mode: n, cancelable: !0 };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (r.controller._update(n), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", { cancelable: !0 }) !== !1 && (ta.has(this) ? this.attached && !ta.running(this) && ta.start(this) : (this.draw(), Kb({ chart: this })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: i } = this._resizeBeforeDraw;
      this._resize(r, i), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", { cancelable: !0 }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, r = [];
    let i, a;
    for (i = 0, a = n.length; i < a; ++i) {
      const o = n[i];
      (!t || o.visible) && r.push(o);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, r = t._clip, i = !r.disabled, a = this.chartArea, o = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (i && _u(n, {
      left: r.left === !1 ? 0 : a.left - r.left,
      right: r.right === !1 ? this.width : a.right + r.right,
      top: r.top === !1 ? 0 : a.top - r.top,
      bottom: r.bottom === !1 ? this.height : a.bottom + r.bottom
    }), t.controller.draw(), i && yu(n), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(t) {
    return Zl(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, r, i) {
    const a = m8.modes[n];
    return typeof a == "function" ? a(this, t, r, i) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], r = this._metasets;
    let i = r.filter((a) => a && a._dataset === n).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Za(null, { chart: this, type: "chart" }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const r = this.getDatasetMeta(t);
    r.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, r) {
    const i = r ? "show" : "hide", a = this.getDatasetMeta(t), o = a.controller._resolveAnimations(void 0, i);
    Sn(n) ? (a.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), o.update(a, { visible: r }), this.update((s) => s.datasetIndex === t ? i : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), ta.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), vb(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), this.notifyPlugins("destroy"), delete yd[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, r = (a, o) => {
      n.addEventListener(this, a, o), t[a] = o;
    }, i = (a, o, s) => {
      a.offsetX = o, a.offsetY = s, this._eventHandler(a);
    };
    $t(this.options.events, (a) => r(a, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, r = (u, d) => {
      n.addEventListener(this, u, d), t[u] = d;
    }, i = (u, d) => {
      t[u] && (n.removeEventListener(this, u, d), delete t[u]);
    }, a = (u, d) => {
      this.canvas && this.resize(u, d);
    };
    let o;
    const s = () => {
      i("attach", s), this.attached = !0, this.resize(), r("resize", a), r("detach", o);
    };
    o = () => {
      this.attached = !1, i("resize", a), this._stop(), this._resize(0, 0), r("attach", s);
    }, n.isAttached(this.canvas) ? s() : o();
  }
  unbindEvents() {
    $t(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, $t(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, r) {
    const i = r ? "set" : "remove";
    let a, o, s, u;
    for (n === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + i + "DatasetHoverStyle"]()), s = 0, u = t.length; s < u; ++s) {
      o = t[s];
      const d = o && this.getDatasetMeta(o.datasetIndex).controller;
      d && d[i + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], r = t.map(({ datasetIndex: a, index: o }) => {
      const s = this.getDatasetMeta(a);
      if (!s)
        throw new Error("No dataset found at index " + a);
      return {
        datasetIndex: a,
        element: s.data[o],
        index: o
      };
    });
    !dd(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(t, n, r) {
    return this._plugins.notify(this, t, n, r);
  }
  _updateHoverStyles(t, n, r) {
    const i = this.options.hover, a = (u, d) => u.filter((f) => !d.some((p) => f.datasetIndex === p.datasetIndex && f.index === p.index)), o = a(n, t), s = r ? t : a(t, n);
    o.length && this.updateHoverStyle(o, i.mode, !1), s.length && i.mode && this.updateHoverStyle(s, i.mode, !0);
  }
  _eventHandler(t, n) {
    const r = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, i = (o) => (o.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, i) === !1)
      return;
    const a = this._handleEvent(t, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, i), (a || r.changed) && this.render(), this;
  }
  _handleEvent(t, n, r) {
    const { _active: i = [], options: a } = this, o = n, s = this._getActiveElements(t, i, r, o), u = z5(t), d = eH(t, this._lastEvent, r, u);
    r && (this._lastEvent = null, Ht(a.onHover, [t, s, this], this), u && Ht(a.onClick, [t, s, this], this));
    const f = !dd(s, i);
    return (f || n) && (this._active = s, this._updateHoverStyles(s, i, n)), this._lastEvent = d, f;
  }
  _getActiveElements(t, n, r, i) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, i);
  }
}
const Xb = () => $t(Ra.instances, (e) => e._plugins.invalidate()), Oa = !0;
Object.defineProperties(Ra, {
  defaults: {
    enumerable: Oa,
    value: yt
  },
  instances: {
    enumerable: Oa,
    value: yd
  },
  overrides: {
    enumerable: Oa,
    value: No
  },
  registry: {
    enumerable: Oa,
    value: Mi
  },
  version: {
    enumerable: Oa,
    value: X8
  },
  getChart: {
    enumerable: Oa,
    value: WT
  },
  register: {
    enumerable: Oa,
    value: (...e) => {
      Mi.add(...e), Xb();
    }
  },
  unregister: {
    enumerable: Oa,
    value: (...e) => {
      Mi.remove(...e), Xb();
    }
  }
});
function HT(e, t, n) {
  const { startAngle: r, pixelMargin: i, x: a, y: o, outerRadius: s, innerRadius: u } = t;
  let d = i / s;
  e.beginPath(), e.arc(a, o, s, r - d, n + d), u > i ? (d = i / u, e.arc(a, o, u, n + d, r - d, !0)) : e.arc(a, o, i, n + vn, r - vn), e.closePath(), e.clip();
}
function tH(e) {
  return tg(e, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
}
function nH(e, t, n, r) {
  const i = tH(e.options.borderRadius), a = (n - t) / 2, o = Math.min(a, r * t / 2), s = (u) => {
    const d = (n - Math.min(a, u)) * r / 2;
    return Vn(u, 0, Math.min(a, d));
  };
  return {
    outerStart: s(i.outerStart),
    outerEnd: s(i.outerEnd),
    innerStart: Vn(i.innerStart, 0, o),
    innerEnd: Vn(i.innerEnd, 0, o)
  };
}
function hs(e, t, n, r) {
  return {
    x: n + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function Bp(e, t, n, r, i, a) {
  const { x: o, y: s, startAngle: u, pixelMargin: d, innerRadius: f } = t, p = Math.max(t.outerRadius + r + n - d, 0), m = f > 0 ? f + r + n + d : 0;
  let g = 0;
  const v = i - u;
  if (r) {
    const G = f > 0 ? f - r : 0, Q = p > 0 ? p - r : 0, y = (G + Q) / 2, H = y !== 0 ? v * y / (y + r) : v;
    g = (v - H) / 2;
  }
  const b = Math.max(1e-3, v * p - n / Lt) / p, w = (v - b) / 2, T = u + w + g, S = i - w - g, { outerStart: x, outerEnd: O, innerStart: C, innerEnd: P } = nH(t, m, p, S - T), k = p - x, M = p - O, N = T + x / k, X = S - O / M, Z = m + C, te = m + P, ce = T + C / Z, we = S - P / te;
  if (e.beginPath(), a) {
    if (e.arc(o, s, p, N, X), O > 0) {
      const y = hs(M, X, o, s);
      e.arc(y.x, y.y, O, X, S + vn);
    }
    const G = hs(te, S, o, s);
    if (e.lineTo(G.x, G.y), P > 0) {
      const y = hs(te, we, o, s);
      e.arc(y.x, y.y, P, S + vn, we + Math.PI);
    }
    if (e.arc(o, s, m, S - P / m, T + C / m, !0), C > 0) {
      const y = hs(Z, ce, o, s);
      e.arc(y.x, y.y, C, ce + Math.PI, T - vn);
    }
    const Q = hs(k, T, o, s);
    if (e.lineTo(Q.x, Q.y), x > 0) {
      const y = hs(k, N, o, s);
      e.arc(y.x, y.y, x, T - vn, N);
    }
  } else {
    e.moveTo(o, s);
    const G = Math.cos(N) * p + o, Q = Math.sin(N) * p + s;
    e.lineTo(G, Q);
    const y = Math.cos(X) * p + o, H = Math.sin(X) * p + s;
    e.lineTo(y, H);
  }
  e.closePath();
}
function rH(e, t, n, r, i) {
  const { fullCircles: a, startAngle: o, circumference: s } = t;
  let u = t.endAngle;
  if (a) {
    Bp(e, t, n, r, o + zt, i);
    for (let d = 0; d < a; ++d)
      e.fill();
    isNaN(s) || (u = o + s % zt, s % zt === 0 && (u += zt));
  }
  return Bp(e, t, n, r, u, i), e.fill(), u;
}
function iH(e, t, n) {
  const { x: r, y: i, startAngle: a, pixelMargin: o, fullCircles: s } = t, u = Math.max(t.outerRadius - o, 0), d = t.innerRadius + o;
  let f;
  for (n && HT(e, t, a + zt), e.beginPath(), e.arc(r, i, d, a + zt, a, !0), f = 0; f < s; ++f)
    e.stroke();
  for (e.beginPath(), e.arc(r, i, u, a, a + zt), f = 0; f < s; ++f)
    e.stroke();
}
function aH(e, t, n, r, i, a) {
  const { options: o } = t, { borderWidth: s, borderJoinStyle: u } = o, d = o.borderAlign === "inner";
  s && (d ? (e.lineWidth = s * 2, e.lineJoin = u || "round") : (e.lineWidth = s, e.lineJoin = u || "bevel"), t.fullCircles && iH(e, t, d), d && HT(e, t, i), Bp(e, t, n, r, i, a), e.stroke());
}
class xu extends Kn {
  constructor(t) {
    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, n, r) {
    const i = this.getProps(["x", "y"], r), { angle: a, distance: o } = iT(i, { x: t, y: n }), { startAngle: s, endAngle: u, innerRadius: d, outerRadius: f, circumference: p } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), m = this.options.spacing / 2, v = nt(p, u - s) >= zt || Xl(a, s, u), b = da(o, d + m, f + m);
    return v && b;
  }
  getCenterPoint(t) {
    const { x: n, y: r, startAngle: i, endAngle: a, innerRadius: o, outerRadius: s } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], t), { offset: u, spacing: d } = this.options, f = (i + a) / 2, p = (o + s + d + u) / 2;
    return {
      x: n + Math.cos(f) * p,
      y: r + Math.sin(f) * p
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: n, circumference: r } = this, i = (n.offset || 0) / 2, a = (n.spacing || 0) / 2, o = n.circular;
    if (this.pixelMargin = n.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > zt ? Math.floor(r / zt) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    let s = 0;
    if (i) {
      s = i / 2;
      const d = (this.startAngle + this.endAngle) / 2;
      t.translate(Math.cos(d) * s, Math.sin(d) * s), this.circumference >= Lt && (s = i);
    }
    t.fillStyle = n.backgroundColor, t.strokeStyle = n.borderColor;
    const u = rH(t, this, s, a, o);
    aH(t, this, s, a, u, o), t.restore();
  }
}
xu.id = "arc";
xu.defaults = {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
};
xu.defaultRoutes = {
  backgroundColor: "backgroundColor"
};
function jT(e, t, n = t) {
  e.lineCap = nt(n.borderCapStyle, t.borderCapStyle), e.setLineDash(nt(n.borderDash, t.borderDash)), e.lineDashOffset = nt(n.borderDashOffset, t.borderDashOffset), e.lineJoin = nt(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = nt(n.borderWidth, t.borderWidth), e.strokeStyle = nt(n.borderColor, t.borderColor);
}
function oH(e, t, n) {
  e.lineTo(n.x, n.y);
}
function sH(e) {
  return e.stepped ? C6 : e.tension || e.cubicInterpolationMode === "monotone" ? A6 : oH;
}
function YT(e, t, n = {}) {
  const r = e.length, { start: i = 0, end: a = r - 1 } = n, { start: o, end: s } = t, u = Math.max(i, o), d = Math.min(a, s), f = i < o && a < o || i > s && a > s;
  return {
    count: r,
    start: u,
    loop: t.loop,
    ilen: d < u && !f ? r + d - u : d - u
  };
}
function lH(e, t, n, r) {
  const { points: i, options: a } = t, { count: o, start: s, loop: u, ilen: d } = YT(i, n, r), f = sH(a);
  let { move: p = !0, reverse: m } = r || {}, g, v, b;
  for (g = 0; g <= d; ++g)
    v = i[(s + (m ? d - g : g)) % o], !v.skip && (p ? (e.moveTo(v.x, v.y), p = !1) : f(e, b, v, m, a.stepped), b = v);
  return u && (v = i[(s + (m ? d : 0)) % o], f(e, b, v, m, a.stepped)), !!u;
}
function uH(e, t, n, r) {
  const i = t.points, { count: a, start: o, ilen: s } = YT(i, n, r), { move: u = !0, reverse: d } = r || {};
  let f = 0, p = 0, m, g, v, b, w, T;
  const S = (O) => (o + (d ? s - O : O)) % a, x = () => {
    b !== w && (e.lineTo(f, w), e.lineTo(f, b), e.lineTo(f, T));
  };
  for (u && (g = i[S(0)], e.moveTo(g.x, g.y)), m = 0; m <= s; ++m) {
    if (g = i[S(m)], g.skip)
      continue;
    const O = g.x, C = g.y, P = O | 0;
    P === v ? (C < b ? b = C : C > w && (w = C), f = (p * f + O) / ++p) : (x(), e.lineTo(O, C), v = P, p = 0, b = w = C), T = C;
  }
  x();
}
function Up(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? uH : lH;
}
function cH(e) {
  return e.stepped ? oW : e.tension || e.cubicInterpolationMode === "monotone" ? sW : bo;
}
function dH(e, t, n, r) {
  let i = t._path;
  i || (i = t._path = new Path2D(), t.path(i, n, r) && i.closePath()), jT(e, t.options), e.stroke(i);
}
function fH(e, t, n, r) {
  const { segments: i, options: a } = t, o = Up(t);
  for (const s of i)
    jT(e, a, s.style), e.beginPath(), o(e, t, s, { start: n, end: n + r - 1 }) && e.closePath(), e.stroke();
}
const hH = typeof Path2D == "function";
function pH(e, t, n, r) {
  hH && !t.options.segment ? dH(e, t, n, r) : fH(e, t, n, r);
}
class Qa extends Kn {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const i = r.spanGaps ? this._loop : this._fullLoop;
      Q6(this._points, r, t, i, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = pW(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, r = t.length;
    return r && n[t[r - 1].end];
  }
  interpolate(t, n) {
    const r = this.options, i = t[n], a = this.points, o = AT(this, { property: n, start: i, end: i });
    if (!o.length)
      return;
    const s = [], u = cH(r);
    let d, f;
    for (d = 0, f = o.length; d < f; ++d) {
      const { start: p, end: m } = o[d], g = a[p], v = a[m];
      if (g === v) {
        s.push(g);
        continue;
      }
      const b = Math.abs((i - g[n]) / (v[n] - g[n])), w = u(g, v, b, r.stepped);
      w[n] = t[n], s.push(w);
    }
    return s.length === 1 ? s[0] : s;
  }
  pathSegment(t, n, r) {
    return Up(this)(t, this, n, r);
  }
  path(t, n, r) {
    const i = this.segments, a = Up(this);
    let o = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const s of i)
      o &= a(t, this, s, { start: n, end: n + r - 1 });
    return !!o;
  }
  draw(t, n, r, i) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), pH(t, this, r, i), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
Qa.id = "line";
Qa.defaults = {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
};
Qa.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
Qa.descriptors = {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
};
function Zb(e, t, n, r) {
  const i = e.options, { [n]: a } = e.getProps([n], r);
  return Math.abs(t - a) < i.radius + i.hitRadius;
}
class Eu extends Kn {
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, n, r) {
    const i = this.options, { x: a, y: o } = this.getProps(["x", "y"], r);
    return Math.pow(t - a, 2) + Math.pow(n - o, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(t, n) {
    return Zb(this, t, "x", n);
  }
  inYRange(t, n) {
    return Zb(this, t, "y", n);
  }
  getCenterPoint(t) {
    const { x: n, y: r } = this.getProps(["x", "y"], t);
    return { x: n, y: r };
  }
  size(t) {
    t = t || this.options || {};
    let n = t.radius || 0;
    n = Math.max(n, n && t.hoverRadius || 0);
    const r = n && t.borderWidth || 0;
    return (n + r) * 2;
  }
  draw(t, n) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !Zl(this, n, this.size(r) / 2) || (t.strokeStyle = r.borderColor, t.lineWidth = r.borderWidth, t.fillStyle = r.backgroundColor, gd(t, r, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
Eu.id = "point";
Eu.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
};
Eu.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function zT(e, t) {
  const { x: n, y: r, base: i, width: a, height: o } = e.getProps(["x", "y", "base", "width", "height"], t);
  let s, u, d, f, p;
  return e.horizontal ? (p = o / 2, s = Math.min(n, i), u = Math.max(n, i), d = r - p, f = r + p) : (p = a / 2, s = n - p, u = n + p, d = Math.min(r, i), f = Math.max(r, i)), { left: s, top: d, right: u, bottom: f };
}
function Ia(e, t, n, r) {
  return e ? 0 : Vn(t, n, r);
}
function mH(e, t, n) {
  const r = e.options.borderWidth, i = e.borderSkipped, a = vT(r);
  return {
    t: Ia(i.top, a.top, 0, n),
    r: Ia(i.right, a.right, 0, t),
    b: Ia(i.bottom, a.bottom, 0, n),
    l: Ia(i.left, a.left, 0, t)
  };
}
function gH(e, t, n) {
  const { enableBorderRadius: r } = e.getProps(["enableBorderRadius"]), i = e.options.borderRadius, a = La(i), o = Math.min(t, n), s = e.borderSkipped, u = r || st(i);
  return {
    topLeft: Ia(!u || s.top || s.left, a.topLeft, 0, o),
    topRight: Ia(!u || s.top || s.right, a.topRight, 0, o),
    bottomLeft: Ia(!u || s.bottom || s.left, a.bottomLeft, 0, o),
    bottomRight: Ia(!u || s.bottom || s.right, a.bottomRight, 0, o)
  };
}
function vH(e) {
  const t = zT(e), n = t.right - t.left, r = t.bottom - t.top, i = mH(e, n / 2, r / 2), a = gH(e, n / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: r,
      radius: a
    },
    inner: {
      x: t.left + i.l,
      y: t.top + i.t,
      w: n - i.l - i.r,
      h: r - i.t - i.b,
      radius: {
        topLeft: Math.max(0, a.topLeft - Math.max(i.t, i.l)),
        topRight: Math.max(0, a.topRight - Math.max(i.t, i.r)),
        bottomLeft: Math.max(0, a.bottomLeft - Math.max(i.b, i.l)),
        bottomRight: Math.max(0, a.bottomRight - Math.max(i.b, i.r))
      }
    }
  };
}
function Xh(e, t, n, r) {
  const i = t === null, a = n === null, s = e && !(i && a) && zT(e, r);
  return s && (i || da(t, s.left, s.right)) && (a || da(n, s.top, s.bottom));
}
function _H(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function yH(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function Zh(e, t, n = {}) {
  const r = e.x !== n.x ? -t : 0, i = e.y !== n.y ? -t : 0, a = (e.x + e.w !== n.x + n.w ? t : 0) - r, o = (e.y + e.h !== n.y + n.h ? t : 0) - i;
  return {
    x: e.x + r,
    y: e.y + i,
    w: e.w + a,
    h: e.h + o,
    radius: e.radius
  };
}
class Tu extends Kn {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: i } } = this, { inner: a, outer: o } = vH(this), s = _H(o.radius) ? As : yH;
    t.save(), (o.w !== a.w || o.h !== a.h) && (t.beginPath(), s(t, Zh(o, n, a)), t.clip(), s(t, Zh(a, -n, o)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), s(t, Zh(a, n)), t.fillStyle = i, t.fill(), t.restore();
  }
  inRange(t, n, r) {
    return Xh(this, t, n, r);
  }
  inXRange(t, n) {
    return Xh(this, t, null, n);
  }
  inYRange(t, n) {
    return Xh(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: r, base: i, horizontal: a } = this.getProps(["x", "y", "base", "horizontal"], t);
    return {
      x: a ? (n + i) / 2 : n,
      y: a ? r : (r + i) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
Tu.id = "bar";
Tu.defaults = {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
};
Tu.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
var bH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: xu,
  LineElement: Qa,
  PointElement: Eu,
  BarElement: Tu
});
function wH(e, t, n, r, i) {
  const a = i.samples || r;
  if (a >= n)
    return e.slice(t, t + n);
  const o = [], s = (n - 2) / (a - 2);
  let u = 0;
  const d = t + n - 1;
  let f = t, p, m, g, v, b;
  for (o[u++] = e[f], p = 0; p < a - 2; p++) {
    let w = 0, T = 0, S;
    const x = Math.floor((p + 1) * s) + 1 + t, O = Math.min(Math.floor((p + 2) * s) + 1, n) + t, C = O - x;
    for (S = x; S < O; S++)
      w += e[S].x, T += e[S].y;
    w /= C, T /= C;
    const P = Math.floor(p * s) + 1 + t, k = Math.min(Math.floor((p + 1) * s) + 1, n) + t, { x: M, y: N } = e[f];
    for (g = v = -1, S = P; S < k; S++)
      v = 0.5 * Math.abs(
        (M - w) * (e[S].y - N) - (M - e[S].x) * (T - N)
      ), v > g && (g = v, m = e[S], b = S);
    o[u++] = m, f = b;
  }
  return o[u++] = e[d], o;
}
function xH(e, t, n, r) {
  let i = 0, a = 0, o, s, u, d, f, p, m, g, v, b;
  const w = [], T = t + n - 1, S = e[t].x, O = e[T].x - S;
  for (o = t; o < t + n; ++o) {
    s = e[o], u = (s.x - S) / O * r, d = s.y;
    const C = u | 0;
    if (C === f)
      d < v ? (v = d, p = o) : d > b && (b = d, m = o), i = (a * i + s.x) / ++a;
    else {
      const P = o - 1;
      if (!ht(p) && !ht(m)) {
        const k = Math.min(p, m), M = Math.max(p, m);
        k !== g && k !== P && w.push({
          ...e[k],
          x: i
        }), M !== g && M !== P && w.push({
          ...e[M],
          x: i
        });
      }
      o > 0 && P !== g && w.push(e[P]), w.push(s), f = C, a = 0, v = b = d, p = m = g = o;
    }
  }
  return w;
}
function GT(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", { value: t });
  }
}
function Qb(e) {
  e.data.datasets.forEach((t) => {
    GT(t);
  });
}
function EH(e, t) {
  const n = t.length;
  let r = 0, i;
  const { iScale: a } = e, { min: o, max: s, minDefined: u, maxDefined: d } = a.getUserBounds();
  return u && (r = Vn(fa(t, a.axis, o).lo, 0, n - 1)), d ? i = Vn(fa(t, a.axis, s).hi + 1, r, n) - r : i = n - r, { start: r, count: i };
}
var TH = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, n) => {
    if (!n.enabled) {
      Qb(e);
      return;
    }
    const r = e.width;
    e.data.datasets.forEach((i, a) => {
      const { _data: o, indexAxis: s } = i, u = e.getDatasetMeta(a), d = o || i.data;
      if (rn([s, e.options.indexAxis]) === "y" || !u.controller.supportsDecimation)
        return;
      const f = e.scales[u.xAxisID];
      if (f.type !== "linear" && f.type !== "time" || e.options.parsing)
        return;
      let { start: p, count: m } = EH(u, d);
      const g = n.threshold || 4 * r;
      if (m <= g) {
        GT(i);
        return;
      }
      ht(o) && (i._data = d, delete i.data, Object.defineProperty(i, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(b) {
          this._data = b;
        }
      }));
      let v;
      switch (n.algorithm) {
        case "lttb":
          v = wH(d, p, m, r, n);
          break;
        case "min-max":
          v = xH(d, p, m, r);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      i._decimated = v;
    });
  },
  destroy(e) {
    Qb(e);
  }
};
function kH(e, t, n) {
  const r = e.segments, i = e.points, a = t.points, o = [];
  for (const s of r) {
    let { start: u, end: d } = s;
    d = lg(u, d, i);
    const f = Wp(n, i[u], i[d], s.loop);
    if (!t.segments) {
      o.push({
        source: s,
        target: f,
        start: i[u],
        end: i[d]
      });
      continue;
    }
    const p = AT(t, f);
    for (const m of p) {
      const g = Wp(n, a[m.start], a[m.end], m.loop), v = CT(s, i, g);
      for (const b of v)
        o.push({
          source: b,
          target: m,
          start: {
            [n]: Jb(f, g, "start", Math.max)
          },
          end: {
            [n]: Jb(f, g, "end", Math.min)
          }
        });
    }
  }
  return o;
}
function Wp(e, t, n, r) {
  if (r)
    return;
  let i = t[e], a = n[e];
  return e === "angle" && (i = Ur(i), a = Ur(a)), { property: e, start: i, end: a };
}
function SH(e, t) {
  const { x: n = null, y: r = null } = e || {}, i = t.points, a = [];
  return t.segments.forEach(({ start: o, end: s }) => {
    s = lg(o, s, i);
    const u = i[o], d = i[s];
    r !== null ? (a.push({ x: u.x, y: r }), a.push({ x: d.x, y: r })) : n !== null && (a.push({ x: n, y: u.y }), a.push({ x: n, y: d.y }));
  }), a;
}
function lg(e, t, n) {
  for (; t > e; t--) {
    const r = n[t];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return t;
}
function Jb(e, t, n, r) {
  return e && t ? r(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function qT(e, t) {
  let n = [], r = !1;
  return jt(e) ? (r = !0, n = e) : n = SH(e, t), n.length ? new Qa({
    points: n,
    options: { tension: 0 },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function e1(e) {
  return e && e.fill !== !1;
}
function OH(e, t, n) {
  let i = e[t].fill;
  const a = [t];
  let o;
  if (!n)
    return i;
  for (; i !== !1 && a.indexOf(i) === -1; ) {
    if (!pn(i))
      return i;
    if (o = e[i], !o)
      return !1;
    if (o.visible)
      return i;
    a.push(i), i = o.fill;
  }
  return !1;
}
function CH(e, t, n) {
  const r = MH(e);
  if (st(r))
    return isNaN(r.value) ? !1 : r;
  let i = parseFloat(r);
  return pn(i) && Math.floor(i) === i ? AH(r[0], t, i, n) : ["origin", "start", "end", "stack", "shape"].indexOf(r) >= 0 && r;
}
function AH(e, t, n, r) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= r ? !1 : n;
}
function DH(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : st(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function PH(e, t, n) {
  let r;
  return e === "start" ? r = n : e === "end" ? r = t.options.reverse ? t.min : t.max : st(e) ? r = e.value : r = t.getBaseValue(), r;
}
function MH(e) {
  const t = e.options, n = t.fill;
  let r = nt(n && n.target, n);
  return r === void 0 && (r = !!t.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function IH(e) {
  const { scale: t, index: n, line: r } = e, i = [], a = r.segments, o = r.points, s = NH(t, n);
  s.push(qT({ x: null, y: t.bottom }, r));
  for (let u = 0; u < a.length; u++) {
    const d = a[u];
    for (let f = d.start; f <= d.end; f++)
      LH(i, o[f], s);
  }
  return new Qa({ points: i, options: {} });
}
function NH(e, t) {
  const n = [], r = e.getMatchingVisibleMetas("line");
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (a.index === t)
      break;
    a.hidden || n.unshift(a.dataset);
  }
  return n;
}
function LH(e, t, n) {
  const r = [];
  for (let i = 0; i < n.length; i++) {
    const a = n[i], { first: o, last: s, point: u } = RH(a, t, "x");
    if (!(!u || o && s)) {
      if (o)
        r.unshift(u);
      else if (e.push(u), !s)
        break;
    }
  }
  e.push(...r);
}
function RH(e, t, n) {
  const r = e.interpolate(t, n);
  if (!r)
    return {};
  const i = r[n], a = e.segments, o = e.points;
  let s = !1, u = !1;
  for (let d = 0; d < a.length; d++) {
    const f = a[d], p = o[f.start][n], m = o[f.end][n];
    if (da(i, p, m)) {
      s = i === p, u = i === m;
      break;
    }
  }
  return { first: s, last: u, point: r };
}
class KT {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, r) {
    const { x: i, y: a, radius: o } = this;
    return n = n || { start: 0, end: zt }, t.arc(i, a, o, n.end, n.start, !0), !r.bounds;
  }
  interpolate(t) {
    const { x: n, y: r, radius: i } = this, a = t.angle;
    return {
      x: n + Math.cos(a) * i,
      y: r + Math.sin(a) * i,
      angle: a
    };
  }
}
function FH(e) {
  const { chart: t, fill: n, line: r } = e;
  if (pn(n))
    return $H(t, n);
  if (n === "stack")
    return IH(e);
  if (n === "shape")
    return !0;
  const i = VH(e);
  return i instanceof KT ? i : qT(i, r);
}
function $H(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function VH(e) {
  return (e.scale || {}).getPointPositionForValue ? UH(e) : BH(e);
}
function BH(e) {
  const { scale: t = {}, fill: n } = e, r = DH(n, t);
  if (pn(r)) {
    const i = t.isHorizontal();
    return {
      x: i ? r : null,
      y: i ? null : r
    };
  }
  return null;
}
function UH(e) {
  const { scale: t, fill: n } = e, r = t.options, i = t.getLabels().length, a = r.reverse ? t.max : t.min, o = PH(n, t, a), s = [];
  if (r.grid.circular) {
    const u = t.getPointPositionForValue(0, a);
    return new KT({
      x: u.x,
      y: u.y,
      radius: t.getDistanceFromCenterForValue(o)
    });
  }
  for (let u = 0; u < i; ++u)
    s.push(t.getPointPositionForValue(u, o));
  return s;
}
function Qh(e, t, n) {
  const r = FH(t), { line: i, scale: a, axis: o } = t, s = i.options, u = s.fill, d = s.backgroundColor, { above: f = d, below: p = d } = u || {};
  r && i.points.length && (_u(e, n), WH(e, { line: i, target: r, above: f, below: p, area: n, scale: a, axis: o }), yu(e));
}
function WH(e, t) {
  const { line: n, target: r, above: i, below: a, area: o, scale: s } = t, u = n._loop ? "angle" : t.axis;
  e.save(), u === "x" && a !== i && (t1(e, r, o.top), n1(e, { line: n, target: r, color: i, scale: s, property: u }), e.restore(), e.save(), t1(e, r, o.bottom)), n1(e, { line: n, target: r, color: a, scale: s, property: u }), e.restore();
}
function t1(e, t, n) {
  const { segments: r, points: i } = t;
  let a = !0, o = !1;
  e.beginPath();
  for (const s of r) {
    const { start: u, end: d } = s, f = i[u], p = i[lg(u, d, i)];
    a ? (e.moveTo(f.x, f.y), a = !1) : (e.lineTo(f.x, n), e.lineTo(f.x, f.y)), o = !!t.pathSegment(e, s, { move: o }), o ? e.closePath() : e.lineTo(p.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function n1(e, t) {
  const { line: n, target: r, property: i, color: a, scale: o } = t, s = kH(n, r, i);
  for (const { source: u, target: d, start: f, end: p } of s) {
    const { style: { backgroundColor: m = a } = {} } = u, g = r !== !0;
    e.save(), e.fillStyle = m, HH(e, o, g && Wp(i, f, p)), e.beginPath();
    const v = !!n.pathSegment(e, u);
    let b;
    if (g) {
      v ? e.closePath() : r1(e, r, p, i);
      const w = !!r.pathSegment(e, d, { move: v, reverse: !0 });
      b = v && w, b || r1(e, r, f, i);
    }
    e.closePath(), e.fill(b ? "evenodd" : "nonzero"), e.restore();
  }
}
function HH(e, t, n) {
  const { top: r, bottom: i } = t.chart.chartArea, { property: a, start: o, end: s } = n || {};
  a === "x" && (e.beginPath(), e.rect(o, r, s - o, i - r), e.clip());
}
function r1(e, t, n, r) {
  const i = t.interpolate(n, r);
  i && e.lineTo(i.x, i.y);
}
var jH = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const r = (e.data.datasets || []).length, i = [];
    let a, o, s, u;
    for (o = 0; o < r; ++o)
      a = e.getDatasetMeta(o), s = a.dataset, u = null, s && s.options && s instanceof Qa && (u = {
        visible: e.isDatasetVisible(o),
        index: o,
        fill: CH(s, o, r),
        chart: e,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: s
      }), a.$filler = u, i.push(u);
    for (o = 0; o < r; ++o)
      u = i[o], !(!u || u.fill === !1) && (u.fill = OH(i, o, n.propagate));
  },
  beforeDraw(e, t, n) {
    const r = n.drawTime === "beforeDraw", i = e.getSortedVisibleDatasetMetas(), a = e.chartArea;
    for (let o = i.length - 1; o >= 0; --o) {
      const s = i[o].$filler;
      s && (s.line.updateControlPoints(a, s.axis), r && s.fill && Qh(e.ctx, s, a));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const r = e.getSortedVisibleDatasetMetas();
    for (let i = r.length - 1; i >= 0; --i) {
      const a = r[i].$filler;
      e1(a) && Qh(e.ctx, a, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const r = t.meta.$filler;
    !e1(r) || n.drawTime !== "beforeDatasetDraw" || Qh(e.ctx, r, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const i1 = (e, t) => {
  let { boxHeight: n = t, boxWidth: r = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), r = e.pointStyleWidth || Math.min(r, t)), {
    boxWidth: r,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, YH = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class a1 extends Kn {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, r) {
    this.maxWidth = t, this.maxHeight = n, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = Ht(t.generateLabels, [this.chart], this) || [];
    t.filter && (n = n.filter((r) => t.filter(r, this.chart.data))), t.sort && (n = n.sort((r, i) => t.sort(r, i, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const r = t.labels, i = _n(r.font), a = i.size, o = this._computeTitleHeight(), { boxWidth: s, itemHeight: u } = i1(r, a);
    let d, f;
    n.font = i.string, this.isHorizontal() ? (d = this.maxWidth, f = this._fitRows(o, a, s, u) + 10) : (f = this.maxHeight, d = this._fitCols(o, a, s, u) + 10), this.width = Math.min(d, t.maxWidth || this.maxWidth), this.height = Math.min(f, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, r, i) {
    const { ctx: a, maxWidth: o, options: { labels: { padding: s } } } = this, u = this.legendHitBoxes = [], d = this.lineWidths = [0], f = i + s;
    let p = t;
    a.textAlign = "left", a.textBaseline = "middle";
    let m = -1, g = -f;
    return this.legendItems.forEach((v, b) => {
      const w = r + n / 2 + a.measureText(v.text).width;
      (b === 0 || d[d.length - 1] + w + 2 * s > o) && (p += f, d[d.length - (b > 0 ? 0 : 1)] = 0, g += f, m++), u[b] = { left: 0, top: g, row: m, width: w, height: i }, d[d.length - 1] += w + s;
    }), p;
  }
  _fitCols(t, n, r, i) {
    const { ctx: a, maxHeight: o, options: { labels: { padding: s } } } = this, u = this.legendHitBoxes = [], d = this.columnSizes = [], f = o - t;
    let p = s, m = 0, g = 0, v = 0, b = 0;
    return this.legendItems.forEach((w, T) => {
      const S = r + n / 2 + a.measureText(w.text).width;
      T > 0 && g + i + 2 * s > f && (p += m + s, d.push({ width: m, height: g }), v += m + s, b++, m = g = 0), u[T] = { left: v, top: g, col: b, width: S, height: i }, m = Math.max(m, S), g += i + s;
    }), p += m, d.push({ width: m, height: g }), p;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: r, labels: { padding: i }, rtl: a } } = this, o = ys(a, this.left, this.width);
    if (this.isHorizontal()) {
      let s = 0, u = er(r, this.left + i, this.right - this.lineWidths[s]);
      for (const d of n)
        s !== d.row && (s = d.row, u = er(r, this.left + i, this.right - this.lineWidths[s])), d.top += this.top + t + i, d.left = o.leftForLtr(o.x(u), d.width), u += d.width + i;
    } else {
      let s = 0, u = er(r, this.top + t + i, this.bottom - this.columnSizes[s].height);
      for (const d of n)
        d.col !== s && (s = d.col, u = er(r, this.top + t + i, this.bottom - this.columnSizes[s].height)), d.top = u, d.left += this.left + i, d.left = o.leftForLtr(o.x(d.left), d.width), u += d.height + i;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      _u(t, this), this._draw(), yu(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: r, ctx: i } = this, { align: a, labels: o } = t, s = yt.color, u = ys(t.rtl, this.left, this.width), d = _n(o.font), { color: f, padding: p } = o, m = d.size, g = m / 2;
    let v;
    this.drawTitle(), i.textAlign = u.textAlign("left"), i.textBaseline = "middle", i.lineWidth = 0.5, i.font = d.string;
    const { boxWidth: b, boxHeight: w, itemHeight: T } = i1(o, m), S = function(k, M, N) {
      if (isNaN(b) || b <= 0 || isNaN(w) || w < 0)
        return;
      i.save();
      const X = nt(N.lineWidth, 1);
      if (i.fillStyle = nt(N.fillStyle, s), i.lineCap = nt(N.lineCap, "butt"), i.lineDashOffset = nt(N.lineDashOffset, 0), i.lineJoin = nt(N.lineJoin, "miter"), i.lineWidth = X, i.strokeStyle = nt(N.strokeStyle, s), i.setLineDash(nt(N.lineDash, [])), o.usePointStyle) {
        const Z = {
          radius: w * Math.SQRT2 / 2,
          pointStyle: N.pointStyle,
          rotation: N.rotation,
          borderWidth: X
        }, te = u.xPlus(k, b / 2), ce = M + g;
        gT(i, Z, te, ce, o.pointStyleWidth && b);
      } else {
        const Z = M + Math.max((m - w) / 2, 0), te = u.leftForLtr(k, b), ce = La(N.borderRadius);
        i.beginPath(), Object.values(ce).some((we) => we !== 0) ? As(i, {
          x: te,
          y: Z,
          w: b,
          h: w,
          radius: ce
        }) : i.rect(te, Z, b, w), i.fill(), X !== 0 && i.stroke();
      }
      i.restore();
    }, x = function(k, M, N) {
      Lo(i, N.text, k, M + T / 2, d, {
        strikethrough: N.hidden,
        textAlign: u.textAlign(N.textAlign)
      });
    }, O = this.isHorizontal(), C = this._computeTitleHeight();
    O ? v = {
      x: er(a, this.left + p, this.right - r[0]),
      y: this.top + p + C,
      line: 0
    } : v = {
      x: this.left + p,
      y: er(a, this.top + C + p, this.bottom - n[0].height),
      line: 0
    }, kT(this.ctx, t.textDirection);
    const P = T + p;
    this.legendItems.forEach((k, M) => {
      i.strokeStyle = k.fontColor || f, i.fillStyle = k.fontColor || f;
      const N = i.measureText(k.text).width, X = u.textAlign(k.textAlign || (k.textAlign = o.textAlign)), Z = b + g + N;
      let te = v.x, ce = v.y;
      u.setWidth(this.width), O ? M > 0 && te + Z + p > this.right && (ce = v.y += P, v.line++, te = v.x = er(a, this.left + p, this.right - r[v.line])) : M > 0 && ce + P > this.bottom && (te = v.x = te + n[v.line].width + p, v.line++, ce = v.y = er(a, this.top + C + p, this.bottom - n[v.line].height));
      const we = u.x(te);
      S(we, ce, k), te = n6(X, te + b + g, O ? te + Z : this.right, t.rtl), x(u.x(te), ce, k), O ? v.x += Z + p : v.y += P;
    }), ST(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, r = _n(n.font), i = On(n.padding);
    if (!n.display)
      return;
    const a = ys(t.rtl, this.left, this.width), o = this.ctx, s = n.position, u = r.size / 2, d = i.top + u;
    let f, p = this.left, m = this.width;
    if (this.isHorizontal())
      m = Math.max(...this.lineWidths), f = this.top + d, p = er(t.align, p, this.right - m);
    else {
      const v = this.columnSizes.reduce((b, w) => Math.max(b, w.height), 0);
      f = d + er(t.align, this.top, this.bottom - v - t.labels.padding - this._computeTitleHeight());
    }
    const g = er(s, p, p + m);
    o.textAlign = a.textAlign(Zm(s)), o.textBaseline = "middle", o.strokeStyle = n.color, o.fillStyle = n.color, o.font = r.string, Lo(o, n.text, g, f, r);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = _n(t.font), r = On(t.padding);
    return t.display ? n.lineHeight + r.height : 0;
  }
  _getLegendItemAt(t, n) {
    let r, i, a;
    if (da(t, this.left, this.right) && da(n, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, r = 0; r < a.length; ++r)
        if (i = a[r], da(t, i.left, i.left + i.width) && da(n, i.top, i.top + i.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!zH(t.type, n))
      return;
    const r = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const i = this._hoveredItem, a = YH(i, r);
      i && !a && Ht(n.onLeave, [t, i, this], this), this._hoveredItem = r, r && !a && Ht(n.onHover, [t, r, this], this);
    } else r && Ht(n.onClick, [t, r, this], this);
  }
}
function zH(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var GH = {
  id: "legend",
  _element: a1,
  start(e, t, n) {
    const r = e.legend = new a1({ ctx: e.ctx, options: n, chart: e });
    or.configure(e, r, n), or.addBox(e, r);
  },
  stop(e) {
    or.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const r = e.legend;
    or.configure(e, r, n), r.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const r = t.datasetIndex, i = n.chart;
      i.isDatasetVisible(r) ? (i.hide(r), t.hidden = !0) : (i.show(r), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: i, color: a } } = e.legend.options;
        return e._getSortedDatasetMetas().map((o) => {
          const s = o.controller.getStyle(n ? 0 : void 0), u = On(s.borderWidth);
          return {
            text: t[o.index].label,
            fillStyle: s.backgroundColor,
            fontColor: a,
            hidden: !o.visible,
            lineCap: s.borderCapStyle,
            lineDash: s.borderDash,
            lineDashOffset: s.borderDashOffset,
            lineJoin: s.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: s.borderColor,
            pointStyle: r || s.pointStyle,
            rotation: s.rotation,
            textAlign: i || s.textAlign,
            borderRadius: 0,
            datasetIndex: o.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => !["generateLabels", "filter", "sort"].includes(e)
    }
  }
};
class ug extends Kn {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const i = jt(r.text) ? r.text.length : 1;
    this._padding = On(r.padding);
    const a = i * _n(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = a : this.width = a;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: r, bottom: i, right: a, options: o } = this, s = o.align;
    let u = 0, d, f, p;
    return this.isHorizontal() ? (f = er(s, r, a), p = n + t, d = a - r) : (o.position === "left" ? (f = r + t, p = er(s, i, n), u = Lt * -0.5) : (f = a - t, p = er(s, n, i), u = Lt * 0.5), d = i - n), { titleX: f, titleY: p, maxWidth: d, rotation: u };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const r = _n(n.font), a = r.lineHeight / 2 + this._padding.top, { titleX: o, titleY: s, maxWidth: u, rotation: d } = this._drawArgs(a);
    Lo(t, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: u,
      rotation: d,
      textAlign: Zm(n.align),
      textBaseline: "middle",
      translation: [o, s]
    });
  }
}
function qH(e, t) {
  const n = new ug({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  or.configure(e, n, t), or.addBox(e, n), e.titleBlock = n;
}
var KH = {
  id: "title",
  _element: ug,
  start(e, t, n) {
    qH(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    or.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const r = e.titleBlock;
    or.configure(e, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Nc = /* @__PURE__ */ new WeakMap();
var XH = {
  id: "subtitle",
  start(e, t, n) {
    const r = new ug({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    or.configure(e, r, n), or.addBox(e, r), Nc.set(e, r);
  },
  stop(e) {
    or.removeBox(e, Nc.get(e)), Nc.delete(e);
  },
  beforeUpdate(e, t, n) {
    const r = Nc.get(e);
    or.configure(e, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Vl = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, r = 0, i = 0, a = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const o = e[t].element;
      if (o && o.hasValue()) {
        const s = o.tooltipPosition();
        r += s.x, i += s.y, ++a;
      }
    }
    return {
      x: r / a,
      y: i / a
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, r = t.y, i = Number.POSITIVE_INFINITY, a, o, s;
    for (a = 0, o = e.length; a < o; ++a) {
      const u = e[a].element;
      if (u && u.hasValue()) {
        const d = u.getCenterPoint(), f = Kl(t, d);
        f < i && (i = f, s = u);
      }
    }
    if (s) {
      const u = s.tooltipPosition();
      n = u.x, r = u.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function ki(e, t) {
  return t && (jt(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function na(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function ZH(e, t) {
  const { element: n, datasetIndex: r, index: i } = t, a = e.getDatasetMeta(r).controller, { label: o, value: s } = a.getLabelAndValue(i);
  return {
    chart: e,
    label: o,
    parsed: a.getParsed(i),
    raw: e.data.datasets[r].data[i],
    formattedValue: s,
    dataset: a.getDataset(),
    dataIndex: i,
    datasetIndex: r,
    element: n
  };
}
function o1(e, t) {
  const n = e.chart.ctx, { body: r, footer: i, title: a } = e, { boxWidth: o, boxHeight: s } = t, u = _n(t.bodyFont), d = _n(t.titleFont), f = _n(t.footerFont), p = a.length, m = i.length, g = r.length, v = On(t.padding);
  let b = v.height, w = 0, T = r.reduce((O, C) => O + C.before.length + C.lines.length + C.after.length, 0);
  if (T += e.beforeBody.length + e.afterBody.length, p && (b += p * d.lineHeight + (p - 1) * t.titleSpacing + t.titleMarginBottom), T) {
    const O = t.displayColors ? Math.max(s, u.lineHeight) : u.lineHeight;
    b += g * O + (T - g) * u.lineHeight + (T - 1) * t.bodySpacing;
  }
  m && (b += t.footerMarginTop + m * f.lineHeight + (m - 1) * t.footerSpacing);
  let S = 0;
  const x = function(O) {
    w = Math.max(w, n.measureText(O).width + S);
  };
  return n.save(), n.font = d.string, $t(e.title, x), n.font = u.string, $t(e.beforeBody.concat(e.afterBody), x), S = t.displayColors ? o + 2 + t.boxPadding : 0, $t(r, (O) => {
    $t(O.before, x), $t(O.lines, x), $t(O.after, x);
  }), S = 0, n.font = f.string, $t(e.footer, x), n.restore(), w += v.width, { width: w, height: b };
}
function QH(e, t) {
  const { y: n, height: r } = t;
  return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function JH(e, t, n, r) {
  const { x: i, width: a } = r, o = n.caretSize + n.caretPadding;
  if (e === "left" && i + a + o > t.width || e === "right" && i - a - o < 0)
    return !0;
}
function ej(e, t, n, r) {
  const { x: i, width: a } = n, { width: o, chartArea: { left: s, right: u } } = e;
  let d = "center";
  return r === "center" ? d = i <= (s + u) / 2 ? "left" : "right" : i <= a / 2 ? d = "left" : i >= o - a / 2 && (d = "right"), JH(d, e, t, n) && (d = "center"), d;
}
function s1(e, t, n) {
  const r = n.yAlign || t.yAlign || QH(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || ej(e, t, n, r),
    yAlign: r
  };
}
function tj(e, t) {
  let { x: n, width: r } = e;
  return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function nj(e, t, n) {
  let { y: r, height: i } = e;
  return t === "top" ? r += n : t === "bottom" ? r -= i + n : r -= i / 2, r;
}
function l1(e, t, n, r) {
  const { caretSize: i, caretPadding: a, cornerRadius: o } = e, { xAlign: s, yAlign: u } = n, d = i + a, { topLeft: f, topRight: p, bottomLeft: m, bottomRight: g } = La(o);
  let v = tj(t, s);
  const b = nj(t, u, d);
  return u === "center" ? s === "left" ? v += d : s === "right" && (v -= d) : s === "left" ? v -= Math.max(f, m) + i : s === "right" && (v += Math.max(p, g) + i), {
    x: Vn(v, 0, r.width - t.width),
    y: Vn(b, 0, r.height - t.height)
  };
}
function Lc(e, t, n) {
  const r = On(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function u1(e) {
  return ki([], na(e));
}
function rj(e, t, n) {
  return Za(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function c1(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
class Hp extends Kn {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart || t._chart, this._chart = this.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, r = this.options.setContext(this.getContext()), i = r.enabled && n.options.animation && r.animations, a = new og(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = rj(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: r } = n, i = r.beforeTitle.apply(this, [t]), a = r.title.apply(this, [t]), o = r.afterTitle.apply(this, [t]);
    let s = [];
    return s = ki(s, na(i)), s = ki(s, na(a)), s = ki(s, na(o)), s;
  }
  getBeforeBody(t, n) {
    return u1(n.callbacks.beforeBody.apply(this, [t]));
  }
  getBody(t, n) {
    const { callbacks: r } = n, i = [];
    return $t(t, (a) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, s = c1(r, a);
      ki(o.before, na(s.beforeLabel.call(this, a))), ki(o.lines, s.label.call(this, a)), ki(o.after, na(s.afterLabel.call(this, a))), i.push(o);
    }), i;
  }
  getAfterBody(t, n) {
    return u1(n.callbacks.afterBody.apply(this, [t]));
  }
  getFooter(t, n) {
    const { callbacks: r } = n, i = r.beforeFooter.apply(this, [t]), a = r.footer.apply(this, [t]), o = r.afterFooter.apply(this, [t]);
    let s = [];
    return s = ki(s, na(i)), s = ki(s, na(a)), s = ki(s, na(o)), s;
  }
  _createItems(t) {
    const n = this._active, r = this.chart.data, i = [], a = [], o = [];
    let s = [], u, d;
    for (u = 0, d = n.length; u < d; ++u)
      s.push(ZH(this.chart, n[u]));
    return t.filter && (s = s.filter((f, p, m) => t.filter(f, p, m, r))), t.itemSort && (s = s.sort((f, p) => t.itemSort(f, p, r))), $t(s, (f) => {
      const p = c1(t.callbacks, f);
      i.push(p.labelColor.call(this, f)), a.push(p.labelPointStyle.call(this, f)), o.push(p.labelTextColor.call(this, f));
    }), this.labelColors = i, this.labelPointStyles = a, this.labelTextColors = o, this.dataPoints = s, s;
  }
  update(t, n) {
    const r = this.options.setContext(this.getContext()), i = this._active;
    let a, o = [];
    if (!i.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const s = Vl[r.position].call(this, i, this._eventPosition);
      o = this._createItems(r), this.title = this.getTitle(o, r), this.beforeBody = this.getBeforeBody(o, r), this.body = this.getBody(o, r), this.afterBody = this.getAfterBody(o, r), this.footer = this.getFooter(o, r);
      const u = this._size = o1(this, r), d = Object.assign({}, s, u), f = s1(this.chart, r, d), p = l1(r, d, f, this.chart);
      this.xAlign = f.xAlign, this.yAlign = f.yAlign, a = {
        opacity: 1,
        x: p.x,
        y: p.y,
        width: u.width,
        height: u.height,
        caretX: s.x,
        caretY: s.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && r.external && r.external.call(this, { chart: this.chart, tooltip: this, replay: n });
  }
  drawCaret(t, n, r, i) {
    const a = this.getCaretPosition(t, r, i);
    n.lineTo(a.x1, a.y1), n.lineTo(a.x2, a.y2), n.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, n, r) {
    const { xAlign: i, yAlign: a } = this, { caretSize: o, cornerRadius: s } = r, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: p } = La(s), { x: m, y: g } = t, { width: v, height: b } = n;
    let w, T, S, x, O, C;
    return a === "center" ? (O = g + b / 2, i === "left" ? (w = m, T = w - o, x = O + o, C = O - o) : (w = m + v, T = w + o, x = O - o, C = O + o), S = w) : (i === "left" ? T = m + Math.max(u, f) + o : i === "right" ? T = m + v - Math.max(d, p) - o : T = this.caretX, a === "top" ? (x = g, O = x - o, w = T - o, S = T + o) : (x = g + b, O = x + o, w = T + o, S = T - o), C = x), { x1: w, x2: T, x3: S, y1: x, y2: O, y3: C };
  }
  drawTitle(t, n, r) {
    const i = this.title, a = i.length;
    let o, s, u;
    if (a) {
      const d = ys(r.rtl, this.x, this.width);
      for (t.x = Lc(this, r.titleAlign, r), n.textAlign = d.textAlign(r.titleAlign), n.textBaseline = "middle", o = _n(r.titleFont), s = r.titleSpacing, n.fillStyle = r.titleColor, n.font = o.string, u = 0; u < a; ++u)
        n.fillText(i[u], d.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + s, u + 1 === a && (t.y += r.titleMarginBottom - s);
    }
  }
  _drawColorBox(t, n, r, i, a) {
    const o = this.labelColors[r], s = this.labelPointStyles[r], { boxHeight: u, boxWidth: d, boxPadding: f } = a, p = _n(a.bodyFont), m = Lc(this, "left", a), g = i.x(m), v = u < p.lineHeight ? (p.lineHeight - u) / 2 : 0, b = n.y + v;
    if (a.usePointStyle) {
      const w = {
        radius: Math.min(d, u) / 2,
        pointStyle: s.pointStyle,
        rotation: s.rotation,
        borderWidth: 1
      }, T = i.leftForLtr(g, d) + d / 2, S = b + u / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, gd(t, w, T, S), t.strokeStyle = o.borderColor, t.fillStyle = o.backgroundColor, gd(t, w, T, S);
    } else {
      t.lineWidth = st(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, t.strokeStyle = o.borderColor, t.setLineDash(o.borderDash || []), t.lineDashOffset = o.borderDashOffset || 0;
      const w = i.leftForLtr(g, d - f), T = i.leftForLtr(i.xPlus(g, 1), d - f - 2), S = La(o.borderRadius);
      Object.values(S).some((x) => x !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, As(t, {
        x: w,
        y: b,
        w: d,
        h: u,
        radius: S
      }), t.fill(), t.stroke(), t.fillStyle = o.backgroundColor, t.beginPath(), As(t, {
        x: T,
        y: b + 1,
        w: d - 2,
        h: u - 2,
        radius: S
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(w, b, d, u), t.strokeRect(w, b, d, u), t.fillStyle = o.backgroundColor, t.fillRect(T, b + 1, d - 2, u - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, n, r) {
    const { body: i } = this, { bodySpacing: a, bodyAlign: o, displayColors: s, boxHeight: u, boxWidth: d, boxPadding: f } = r, p = _n(r.bodyFont);
    let m = p.lineHeight, g = 0;
    const v = ys(r.rtl, this.x, this.width), b = function(M) {
      n.fillText(M, v.x(t.x + g), t.y + m / 2), t.y += m + a;
    }, w = v.textAlign(o);
    let T, S, x, O, C, P, k;
    for (n.textAlign = o, n.textBaseline = "middle", n.font = p.string, t.x = Lc(this, w, r), n.fillStyle = r.bodyColor, $t(this.beforeBody, b), g = s && w !== "right" ? o === "center" ? d / 2 + f : d + 2 + f : 0, O = 0, P = i.length; O < P; ++O) {
      for (T = i[O], S = this.labelTextColors[O], n.fillStyle = S, $t(T.before, b), x = T.lines, s && x.length && (this._drawColorBox(n, t, O, v, r), m = Math.max(p.lineHeight, u)), C = 0, k = x.length; C < k; ++C)
        b(x[C]), m = p.lineHeight;
      $t(T.after, b);
    }
    g = 0, m = p.lineHeight, $t(this.afterBody, b), t.y -= a;
  }
  drawFooter(t, n, r) {
    const i = this.footer, a = i.length;
    let o, s;
    if (a) {
      const u = ys(r.rtl, this.x, this.width);
      for (t.x = Lc(this, r.footerAlign, r), t.y += r.footerMarginTop, n.textAlign = u.textAlign(r.footerAlign), n.textBaseline = "middle", o = _n(r.footerFont), n.fillStyle = r.footerColor, n.font = o.string, s = 0; s < a; ++s)
        n.fillText(i[s], u.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, n, r, i) {
    const { xAlign: a, yAlign: o } = this, { x: s, y: u } = t, { width: d, height: f } = r, { topLeft: p, topRight: m, bottomLeft: g, bottomRight: v } = La(i.cornerRadius);
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, n.lineWidth = i.borderWidth, n.beginPath(), n.moveTo(s + p, u), o === "top" && this.drawCaret(t, n, r, i), n.lineTo(s + d - m, u), n.quadraticCurveTo(s + d, u, s + d, u + m), o === "center" && a === "right" && this.drawCaret(t, n, r, i), n.lineTo(s + d, u + f - v), n.quadraticCurveTo(s + d, u + f, s + d - v, u + f), o === "bottom" && this.drawCaret(t, n, r, i), n.lineTo(s + g, u + f), n.quadraticCurveTo(s, u + f, s, u + f - g), o === "center" && a === "left" && this.drawCaret(t, n, r, i), n.lineTo(s, u + p), n.quadraticCurveTo(s, u, s + p, u), n.closePath(), n.fill(), i.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, r = this.$animations, i = r && r.x, a = r && r.y;
    if (i || a) {
      const o = Vl[t.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const s = this._size = o1(this, t), u = Object.assign({}, o, this._size), d = s1(n, t, u), f = l1(t, u, d, n);
      (i._to !== f.x || a._to !== f.y) && (this.xAlign = d.xAlign, this.yAlign = d.yAlign, this.width = s.width, this.height = s.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, f));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const i = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const o = On(n.padding), s = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && s && (t.save(), t.globalAlpha = r, this.drawBackground(a, t, i, n), kT(t, n.textDirection), a.y += o.top, this.drawTitle(a, t, n), this.drawBody(a, t, n), this.drawFooter(a, t, n), ST(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const r = this._active, i = t.map(({ datasetIndex: s, index: u }) => {
      const d = this.chart.getDatasetMeta(s);
      if (!d)
        throw new Error("Cannot find a dataset at index " + s);
      return {
        datasetIndex: s,
        element: d.data[u],
        index: u
      };
    }), a = !dd(r, i), o = this._positionChanged(i, n);
    (a || o) && (this._active = i, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, a = this._active || [], o = this._getActiveElements(t, a, n, r), s = this._positionChanged(o, t), u = n || !dd(o, a) || s;
    return u && (this._active = o, (i.enabled || i.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), u;
  }
  _getActiveElements(t, n, r, i) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n;
    const o = this.chart.getElementsAtEventForMode(t, a.mode, a, r);
    return a.reverse && o.reverse(), o;
  }
  _positionChanged(t, n) {
    const { caretX: r, caretY: i, options: a } = this, o = Vl[a.position].call(this, t, n);
    return o !== !1 && (r !== o.x || i !== o.y);
  }
}
Hp.positioners = Vl;
var ij = {
  id: "tooltip",
  _element: Hp,
  positioners: Vl,
  afterInit(e, t, n) {
    n && (e.tooltip = new Hp({ chart: e, options: n }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", n) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: ["x", "y", "width", "height", "caretX", "caretY"]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: Qi,
      title(e) {
        if (e.length > 0) {
          const t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
          if (this && this.options && this.options.mode === "dataset")
            return t.dataset.label || "";
          if (t.label)
            return t.label;
          if (r > 0 && t.dataIndex < r)
            return n[t.dataIndex];
        }
        return "";
      },
      afterTitle: Qi,
      beforeBody: Qi,
      beforeLabel: Qi,
      label(e) {
        if (this && this.options && this.options.mode === "dataset")
          return e.label + ": " + e.formattedValue || e.formattedValue;
        let t = e.dataset.label || "";
        t && (t += ": ");
        const n = e.formattedValue;
        return ht(n) || (t += n), t;
      },
      labelColor(e) {
        const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
        return {
          borderColor: n.borderColor,
          backgroundColor: n.backgroundColor,
          borderWidth: n.borderWidth,
          borderDash: n.borderDash,
          borderDashOffset: n.borderDashOffset,
          borderRadius: 0
        };
      },
      labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle(e) {
        const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
        return {
          pointStyle: n.pointStyle,
          rotation: n.rotation
        };
      },
      afterLabel: Qi,
      afterBody: Qi,
      beforeFooter: Qi,
      footer: Qi,
      afterFooter: Qi
    }
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: ["interaction"]
}, aj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Decimation: TH,
  Filler: jH,
  Legend: GH,
  SubTitle: XH,
  Title: KH,
  Tooltip: ij
});
const oj = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({ index: n, label: t })) : isNaN(t) && (n = null), n);
function sj(e, t, n, r) {
  const i = e.indexOf(t);
  if (i === -1)
    return oj(e, t, n, r);
  const a = e.lastIndexOf(t);
  return i !== a ? n : i;
}
const lj = (e, t) => e === null ? null : Vn(Math.round(e), 0, t);
class bd extends jo {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: i, label: a } of n)
        r[i] === a && r.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (ht(t))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === t ? n : sj(r, t, nt(n, t), this._addedLabels), lj(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: r, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), n || (i = this.getLabels().length - 1)), this.min = r, this.max = i;
  }
  buildTicks() {
    const t = this.min, n = this.max, r = this.options.offset, i = [];
    let a = this.getLabels();
    a = t === 0 && n === a.length - 1 ? a : a.slice(t, n + 1), this._valueRange = Math.max(a.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let o = t; o <= n; o++)
      i.push({ value: o });
    return i;
  }
  getLabelForValue(t) {
    const n = this.getLabels();
    return t >= 0 && t < n.length ? n[t] : t;
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
bd.id = "category";
bd.defaults = {
  ticks: {
    callback: bd.prototype.getLabelForValue
  }
};
function uj(e, t) {
  const n = [], { bounds: i, step: a, min: o, max: s, precision: u, count: d, maxTicks: f, maxDigits: p, includeBounds: m } = e, g = a || 1, v = f - 1, { min: b, max: w } = t, T = !ht(o), S = !ht(s), x = !ht(d), O = (w - b) / (p + 1);
  let C = sb((w - b) / v / g) * g, P, k, M, N;
  if (C < 1e-14 && !T && !S)
    return [{ value: b }, { value: w }];
  N = Math.ceil(w / C) - Math.floor(b / C), N > v && (C = sb(N * C / v / g) * g), ht(u) || (P = Math.pow(10, u), C = Math.ceil(C * P) / P), i === "ticks" ? (k = Math.floor(b / C) * C, M = Math.ceil(w / C) * C) : (k = b, M = w), T && S && a && K5((s - o) / a, C / 1e3) ? (N = Math.round(Math.min((s - o) / C, f)), C = (s - o) / N, k = o, M = s) : x ? (k = T ? o : k, M = S ? s : M, N = d - 1, C = (M - k) / N) : (N = (M - k) / C, Rl(N, Math.round(N), C / 1e3) ? N = Math.round(N) : N = Math.ceil(N));
  const X = Math.max(
    lb(C),
    lb(k)
  );
  P = Math.pow(10, ht(u) ? X : u), k = Math.round(k * P) / P, M = Math.round(M * P) / P;
  let Z = 0;
  for (T && (m && k !== o ? (n.push({ value: o }), k < o && Z++, Rl(Math.round((k + Z * C) * P) / P, o, d1(o, O, e)) && Z++) : k < o && Z++); Z < N; ++Z)
    n.push({ value: Math.round((k + Z * C) * P) / P });
  return S && m && M !== s ? n.length && Rl(n[n.length - 1].value, s, d1(s, O, e)) ? n[n.length - 1].value = s : n.push({ value: s }) : (!S || M === s) && n.push({ value: M }), n;
}
function d1(e, t, { horizontal: n, minRotation: r }) {
  const i = An(r), a = (n ? Math.sin(i) : Math.cos(i)) || 1e-3, o = 0.75 * t * ("" + e).length;
  return Math.min(t / a, o);
}
class wd extends jo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return ht(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: i, max: a } = this;
    const o = (u) => i = n ? i : u, s = (u) => a = r ? a : u;
    if (t) {
      const u = Ri(i), d = Ri(a);
      u < 0 && d < 0 ? s(0) : u > 0 && d > 0 && o(0);
    }
    if (i === a) {
      let u = 1;
      (a >= Number.MAX_SAFE_INTEGER || i <= Number.MIN_SAFE_INTEGER) && (u = Math.abs(a * 0.05)), s(a + u), t || o(i - u);
    }
    this.min = i, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = t, i;
    return r ? (i = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), n = n || 11), n && (i = Math.min(n, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const i = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, a = this._range || this, o = uj(i, a);
    return t.bounds === "ticks" && rT(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const i = (r - n) / Math.max(t.length - 1, 1) / 2;
      n -= i, r += i;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(t) {
    return bu(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class cg extends wd {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = pn(t) ? t : 0, this.max = pn(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, r = An(this.options.ticks.minRotation), i = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, a.lineHeight / i));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
cg.id = "linear";
cg.defaults = {
  ticks: {
    callback: Hd.formatters.numeric
  }
};
function f1(e) {
  return e / Math.pow(10, Math.floor(si(e))) === 1;
}
function cj(e, t) {
  const n = Math.floor(si(t.max)), r = Math.ceil(t.max / Math.pow(10, n)), i = [];
  let a = ri(e.min, Math.pow(10, Math.floor(si(t.min)))), o = Math.floor(si(a)), s = Math.floor(a / Math.pow(10, o)), u = o < 0 ? Math.pow(10, Math.abs(o)) : 1;
  do
    i.push({ value: a, major: f1(a) }), ++s, s === 10 && (s = 1, ++o, u = o >= 0 ? 1 : u), a = Math.round(s * Math.pow(10, o) * u) / u;
  while (o < n || o === n && s < r);
  const d = ri(e.max, a);
  return i.push({ value: d, major: f1(a) }), i;
}
class dg extends jo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const r = wd.prototype.parse.apply(this, [t, n]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return pn(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = pn(t) ? Math.max(0, t) : null, this.max = pn(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let r = this.min, i = this.max;
    const a = (u) => r = t ? r : u, o = (u) => i = n ? i : u, s = (u, d) => Math.pow(10, Math.floor(si(u)) + d);
    r === i && (r <= 0 ? (a(1), o(10)) : (a(s(r, -1)), o(s(i, 1)))), r <= 0 && a(s(i, -1)), i <= 0 && o(s(r, 1)), this._zero && this.min !== this._suggestedMin && r === s(this.min, 0) && a(s(r, -1)), this.min = r, this.max = i;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = cj(n, this);
    return t.bounds === "ticks" && rT(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : bu(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = si(t), this._valueRange = si(this.max) - si(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (si(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
dg.id = "logarithmic";
dg.defaults = {
  ticks: {
    callback: Hd.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
};
function jp(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = On(t.backdropPadding);
    return nt(t.font && t.font.size, yt.font.size) + n.height;
  }
  return 0;
}
function dj(e, t, n) {
  return n = jt(n) ? n : [n], {
    w: O6(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function h1(e, t, n, r, i) {
  return e === r || e === i ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < r || e > i ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function fj(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), r = [], i = [], a = e._pointLabels.length, o = e.options.pointLabels, s = o.centerPointLabels ? Lt / a : 0;
  for (let u = 0; u < a; u++) {
    const d = o.setContext(e.getPointLabelContext(u));
    i[u] = d.padding;
    const f = e.getPointPosition(u, e.drawingArea + i[u], s), p = _n(d.font), m = dj(e.ctx, p, e._pointLabels[u]);
    r[u] = m;
    const g = Ur(e.getIndexAngle(u) + s), v = Math.round(Rd(g)), b = h1(v, f.x, m.w, 0, 180), w = h1(v, f.y, m.h, 90, 270);
    hj(n, t, g, b, w);
  }
  e.setCenterPoint(
    t.l - n.l,
    n.r - t.r,
    t.t - n.t,
    n.b - t.b
  ), e._pointLabelItems = pj(e, r, i);
}
function hj(e, t, n, r, i) {
  const a = Math.abs(Math.sin(n)), o = Math.abs(Math.cos(n));
  let s = 0, u = 0;
  r.start < t.l ? (s = (t.l - r.start) / a, e.l = Math.min(e.l, t.l - s)) : r.end > t.r && (s = (r.end - t.r) / a, e.r = Math.max(e.r, t.r + s)), i.start < t.t ? (u = (t.t - i.start) / o, e.t = Math.min(e.t, t.t - u)) : i.end > t.b && (u = (i.end - t.b) / o, e.b = Math.max(e.b, t.b + u));
}
function pj(e, t, n) {
  const r = [], i = e._pointLabels.length, a = e.options, o = jp(a) / 2, s = e.drawingArea, u = a.pointLabels.centerPointLabels ? Lt / i : 0;
  for (let d = 0; d < i; d++) {
    const f = e.getPointPosition(d, s + o + n[d], u), p = Math.round(Rd(Ur(f.angle + vn))), m = t[d], g = vj(f.y, m.h, p), v = mj(p), b = gj(f.x, m.w, v);
    r.push({
      x: f.x,
      y: g,
      textAlign: v,
      left: b,
      top: g,
      right: b + m.w,
      bottom: g + m.h
    });
  }
  return r;
}
function mj(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function gj(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function vj(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function _j(e, t) {
  const { ctx: n, options: { pointLabels: r } } = e;
  for (let i = t - 1; i >= 0; i--) {
    const a = r.setContext(e.getPointLabelContext(i)), o = _n(a.font), { x: s, y: u, textAlign: d, left: f, top: p, right: m, bottom: g } = e._pointLabelItems[i], { backdropColor: v } = a;
    if (!ht(v)) {
      const b = La(a.borderRadius), w = On(a.backdropPadding);
      n.fillStyle = v;
      const T = f - w.left, S = p - w.top, x = m - f + w.width, O = g - p + w.height;
      Object.values(b).some((C) => C !== 0) ? (n.beginPath(), As(n, {
        x: T,
        y: S,
        w: x,
        h: O,
        radius: b
      }), n.fill()) : n.fillRect(T, S, x, O);
    }
    Lo(
      n,
      e._pointLabels[i],
      s,
      u + o.lineHeight / 2,
      o,
      {
        color: a.color,
        textAlign: d,
        textBaseline: "middle"
      }
    );
  }
}
function XT(e, t, n, r) {
  const { ctx: i } = e;
  if (n)
    i.arc(e.xCenter, e.yCenter, t, 0, zt);
  else {
    let a = e.getPointPosition(0, t);
    i.moveTo(a.x, a.y);
    for (let o = 1; o < r; o++)
      a = e.getPointPosition(o, t), i.lineTo(a.x, a.y);
  }
}
function yj(e, t, n, r) {
  const i = e.ctx, a = t.circular, { color: o, lineWidth: s } = t;
  !a && !r || !o || !s || n < 0 || (i.save(), i.strokeStyle = o, i.lineWidth = s, i.setLineDash(t.borderDash), i.lineDashOffset = t.borderDashOffset, i.beginPath(), XT(e, n, a, r), i.closePath(), i.stroke(), i.restore());
}
function bj(e, t, n) {
  return Za(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class ku extends wd {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = On(jp(this.options) / 2), n = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = pn(t) && !isNaN(t) ? t : 0, this.max = pn(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / jp(this.options));
  }
  generateTickLabels(t) {
    wd.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, r) => {
      const i = Ht(this.options.pointLabels.callback, [n, r], this);
      return i || i === 0 ? i : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? fj(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, r, i) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((r - i) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, r, i));
  }
  getIndexAngle(t) {
    const n = zt / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return Ur(t * n + An(r));
  }
  getDistanceFromCenterForValue(t) {
    if (ht(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (ht(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return bj(this.getContext(), t, r);
    }
  }
  getPointPosition(t, n, r = 0) {
    const i = this.getIndexAngle(t) - vn + r;
    return {
      x: Math.cos(i) * n + this.xCenter,
      y: Math.sin(i) * n + this.yCenter,
      angle: i
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: r, right: i, bottom: a } = this._pointLabelItems[t];
    return {
      left: n,
      top: r,
      right: i,
      bottom: a
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), XT(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: r, grid: i } = n, a = this._pointLabels.length;
    let o, s, u;
    if (n.pointLabels.display && _j(this, a), i.display && this.ticks.forEach((d, f) => {
      if (f !== 0) {
        s = this.getDistanceFromCenterForValue(d.value);
        const p = i.setContext(this.getContext(f - 1));
        yj(this, p, s, a);
      }
    }), r.display) {
      for (t.save(), o = a - 1; o >= 0; o--) {
        const d = r.setContext(this.getPointLabelContext(o)), { color: f, lineWidth: p } = d;
        !p || !f || (t.lineWidth = p, t.strokeStyle = f, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, s = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), u = this.getPointPosition(o, s), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(u.x, u.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const i = this.getIndexAngle(0);
    let a, o;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(i), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((s, u) => {
      if (u === 0 && !n.reverse)
        return;
      const d = r.setContext(this.getContext(u)), f = _n(d.font);
      if (a = this.getDistanceFromCenterForValue(this.ticks[u].value), d.showLabelBackdrop) {
        t.font = f.string, o = t.measureText(s.label).width, t.fillStyle = d.backdropColor;
        const p = On(d.backdropPadding);
        t.fillRect(
          -o / 2 - p.left,
          -a - f.size / 2 - p.top,
          o + p.width,
          f.size + p.height
        );
      }
      Lo(t, s.label, 0, -a, f, {
        color: d.color
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
ku.id = "radialLinear";
ku.defaults = {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Hd.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
};
ku.defaultRoutes = {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
};
ku.descriptors = {
  angleLines: {
    _fallback: "grid"
  }
};
const Yd = {
  millisecond: { common: !0, size: 1, steps: 1e3 },
  second: { common: !0, size: 1e3, steps: 60 },
  minute: { common: !0, size: 6e4, steps: 60 },
  hour: { common: !0, size: 36e5, steps: 24 },
  day: { common: !0, size: 864e5, steps: 30 },
  week: { common: !1, size: 6048e5, steps: 4 },
  month: { common: !0, size: 2628e6, steps: 12 },
  quarter: { common: !1, size: 7884e6, steps: 4 },
  year: { common: !0, size: 3154e7 }
}, Cr = Object.keys(Yd);
function wj(e, t) {
  return e - t;
}
function p1(e, t) {
  if (ht(t))
    return null;
  const n = e._adapter, { parser: r, round: i, isoWeekday: a } = e._parseOpts;
  let o = t;
  return typeof r == "function" && (o = r(o)), pn(o) || (o = typeof r == "string" ? n.parse(o, r) : n.parse(o)), o === null ? null : (i && (o = i === "week" && (Cs(a) || a === !0) ? n.startOf(o, "isoWeek", a) : n.startOf(o, i)), +o);
}
function m1(e, t, n, r) {
  const i = Cr.length;
  for (let a = Cr.indexOf(e); a < i - 1; ++a) {
    const o = Yd[Cr[a]], s = o.steps ? o.steps : Number.MAX_SAFE_INTEGER;
    if (o.common && Math.ceil((n - t) / (s * o.size)) <= r)
      return Cr[a];
  }
  return Cr[i - 1];
}
function xj(e, t, n, r, i) {
  for (let a = Cr.length - 1; a >= Cr.indexOf(n); a--) {
    const o = Cr[a];
    if (Yd[o].common && e._adapter.diff(i, r, o) >= t - 1)
      return o;
  }
  return Cr[n ? Cr.indexOf(n) : 0];
}
function Ej(e) {
  for (let t = Cr.indexOf(e) + 1, n = Cr.length; t < n; ++t)
    if (Yd[Cr[t]].common)
      return Cr[t];
}
function g1(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: r, hi: i } = Xm(n, t), a = n[r] >= t ? n[r] : n[i];
    e[a] = !0;
  }
}
function Tj(e, t, n, r) {
  const i = e._adapter, a = +i.startOf(t[0].value, r), o = t[t.length - 1].value;
  let s, u;
  for (s = a; s <= o; s = +i.add(s, 1, r))
    u = n[s], u >= 0 && (t[u].major = !0);
  return t;
}
function v1(e, t, n) {
  const r = [], i = {}, a = t.length;
  let o, s;
  for (o = 0; o < a; ++o)
    s = t[o], i[s] = o, r.push({
      value: s,
      major: !1
    });
  return a === 0 || !n ? r : Tj(e, r, i, n);
}
class Su extends jo {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n) {
    const r = t.time || (t.time = {}), i = this._adapter = new c8._date(t.adapters.date);
    i.init(n), Ll(r.displayFormats, i.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : p1(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, r = t.time.unit || "day";
    let { min: i, max: a, minDefined: o, maxDefined: s } = this.getUserBounds();
    function u(d) {
      !o && !isNaN(d.min) && (i = Math.min(i, d.min)), !s && !isNaN(d.max) && (a = Math.max(a, d.max));
    }
    (!o || !s) && (u(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && u(this.getMinMax(!1))), i = pn(i) && !isNaN(i) ? i : +n.startOf(Date.now(), r), a = pn(a) && !isNaN(a) ? a : +n.endOf(Date.now(), r) + 1, this.min = Math.min(i, a - 1), this.max = Math.max(i + 1, a);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], r = t[t.length - 1]), { min: n, max: r };
  }
  buildTicks() {
    const t = this.options, n = t.time, r = t.ticks, i = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const a = this.min, o = this.max, s = J5(i, a, o);
    return this._unit = n.unit || (r.autoSkip ? m1(n.minUnit, this.min, this.max, this._getLabelCapacity(a)) : xj(this, s.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : Ej(this._unit), this.initOffsets(i), t.reverse && s.reverse(), v1(this, s, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t) {
    let n = 0, r = 0, i, a;
    this.options.offset && t.length && (i = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - i : n = (this.getDecimalForValue(t[1]) - i) / 2, a = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = a : r = (a - this.getDecimalForValue(t[t.length - 2])) / 2);
    const o = t.length < 3 ? 0.5 : 0.25;
    n = Vn(n, 0, o), r = Vn(r, 0, o), this._offsets = { start: n, end: r, factor: 1 / (n + 1 + r) };
  }
  _generate() {
    const t = this._adapter, n = this.min, r = this.max, i = this.options, a = i.time, o = a.unit || m1(a.minUnit, n, r, this._getLabelCapacity(n)), s = nt(a.stepSize, 1), u = o === "week" ? a.isoWeekday : !1, d = Cs(u) || u === !0, f = {};
    let p = n, m, g;
    if (d && (p = +t.startOf(p, "isoWeek", u)), p = +t.startOf(p, d ? "day" : o), t.diff(r, n, o) > 1e5 * s)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + s + " " + o);
    const v = i.ticks.source === "data" && this.getDataTimestamps();
    for (m = p, g = 0; m < r; m = +t.add(m, s, o), g++)
      g1(f, m, v);
    return (m === r || i.bounds === "ticks" || g === 1) && g1(f, m, v), Object.keys(f).sort((b, w) => b - w).map((b) => +b);
  }
  getLabelForValue(t) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(t, r.tooltipFormat) : n.format(t, r.displayFormats.datetime);
  }
  _tickFormatFunction(t, n, r, i) {
    const a = this.options, o = a.time.displayFormats, s = this._unit, u = this._majorUnit, d = s && o[s], f = u && o[u], p = r[n], m = u && f && p && p.major, g = this._adapter.format(t, i || (m ? f : d)), v = a.ticks.callback;
    return v ? Ht(v, [g, n, r], this) : g;
  }
  generateTickLabels(t) {
    let n, r, i;
    for (n = 0, r = t.length; n < r; ++n)
      i = t[n], i.label = this._tickFormatFunction(i.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, r = this.ctx.measureText(t).width, i = An(this.isHorizontal() ? n.maxRotation : n.minRotation), a = Math.cos(i), o = Math.sin(i), s = this._resolveTickFontOptions(0).size;
    return {
      w: r * a + s * o,
      h: r * o + s * a
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, r = n.displayFormats, i = r[n.unit] || r.millisecond, a = this._tickFormatFunction(t, 0, v1(this, [t], this._majorUnit), i), o = this._getLabelSize(a), s = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
    return s > 0 ? s : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, r;
    if (t.length)
      return t;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (n = 0, r = i.length; n < r; ++n)
      t = t.concat(i[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, r;
    if (t.length)
      return t;
    const i = this.getLabels();
    for (n = 0, r = i.length; n < r; ++n)
      t.push(p1(this, i[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return oT(t.sort(wj));
  }
}
Su.id = "time";
Su.defaults = {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    major: {
      enabled: !1
    }
  }
};
function Rc(e, t, n) {
  let r = 0, i = e.length - 1, a, o, s, u;
  n ? (t >= e[r].pos && t <= e[i].pos && ({ lo: r, hi: i } = fa(e, "pos", t)), { pos: a, time: s } = e[r], { pos: o, time: u } = e[i]) : (t >= e[r].time && t <= e[i].time && ({ lo: r, hi: i } = fa(e, "time", t)), { time: a, pos: s } = e[r], { time: o, pos: u } = e[i]);
  const d = o - a;
  return d ? s + (u - s) * (t - a) / d : s;
}
class fg extends Su {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Rc(n, this.min), this._tableRange = Rc(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: r } = this, i = [], a = [];
    let o, s, u, d, f;
    for (o = 0, s = t.length; o < s; ++o)
      d = t[o], d >= n && d <= r && i.push(d);
    if (i.length < 2)
      return [
        { time: n, pos: 0 },
        { time: r, pos: 1 }
      ];
    for (o = 0, s = i.length; o < s; ++o)
      f = i[o + 1], u = i[o - 1], d = i[o], Math.round((f + u) / 2) !== d && a.push({ time: d, pos: o / (s - 1) });
    return a;
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? t = this.normalize(n.concat(r)) : t = n.length ? n : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Rc(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return Rc(this._table, r * this._tableRange + this._minPos, !0);
  }
}
fg.id = "timeseries";
fg.defaults = Su.defaults;
var kj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: bd,
  LinearScale: cg,
  LogarithmicScale: dg,
  RadialLinearScale: ku,
  TimeScale: Su,
  TimeSeriesScale: fg
});
const ZT = [
  u8,
  bH,
  aj,
  kj
];
var QT = typeof global == "object" && global && global.Object === Object && global, Sj = typeof self == "object" && self && self.Object === Object && self, Bi = QT || Sj || Function("return this")(), ja = Bi.Symbol, JT = Object.prototype, Oj = JT.hasOwnProperty, Cj = JT.toString, vl = ja ? ja.toStringTag : void 0;
function Aj(e) {
  var t = Oj.call(e, vl), n = e[vl];
  try {
    e[vl] = void 0;
    var r = !0;
  } catch {
  }
  var i = Cj.call(e);
  return r && (t ? e[vl] = n : delete e[vl]), i;
}
var Dj = Object.prototype, Pj = Dj.toString;
function Mj(e) {
  return Pj.call(e);
}
var Ij = "[object Null]", Nj = "[object Undefined]", _1 = ja ? ja.toStringTag : void 0;
function Ou(e) {
  return e == null ? e === void 0 ? Nj : Ij : _1 && _1 in Object(e) ? Aj(e) : Mj(e);
}
function Ro(e) {
  return e != null && typeof e == "object";
}
var Ms = Array.isArray;
function Cu(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Lj = "[object AsyncFunction]", Rj = "[object Function]", Fj = "[object GeneratorFunction]", $j = "[object Proxy]";
function ek(e) {
  if (!Cu(e))
    return !1;
  var t = Ou(e);
  return t == Rj || t == Fj || t == Lj || t == $j;
}
var Jh = Bi["__core-js_shared__"], y1 = function() {
  var e = /[^.]+$/.exec(Jh && Jh.keys && Jh.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Vj(e) {
  return !!y1 && y1 in e;
}
var Bj = Function.prototype, Uj = Bj.toString;
function Yo(e) {
  if (e != null) {
    try {
      return Uj.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Wj = /[\\^$.*+?()[\]{}|]/g, Hj = /^\[object .+?Constructor\]$/, jj = Function.prototype, Yj = Object.prototype, zj = jj.toString, Gj = Yj.hasOwnProperty, qj = RegExp(
  "^" + zj.call(Gj).replace(Wj, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Kj(e) {
  if (!Cu(e) || Vj(e))
    return !1;
  var t = ek(e) ? qj : Hj;
  return t.test(Yo(e));
}
function Xj(e, t) {
  return e == null ? void 0 : e[t];
}
function zo(e, t) {
  var n = Xj(e, t);
  return Kj(n) ? n : void 0;
}
var Yp = zo(Bi, "WeakMap"), b1 = Object.create, Zj = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Cu(t))
      return {};
    if (b1)
      return b1(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Qj(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var w1 = function() {
  try {
    var e = zo(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function Jj(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var e7 = 9007199254740991, t7 = /^(?:0|[1-9]\d*)$/;
function n7(e, t) {
  var n = typeof e;
  return t = t ?? e7, !!t && (n == "number" || n != "symbol" && t7.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function tk(e, t, n) {
  t == "__proto__" && w1 ? w1(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function hg(e, t) {
  return e === t || e !== e && t !== t;
}
var r7 = Object.prototype, i7 = r7.hasOwnProperty;
function nk(e, t, n) {
  var r = e[t];
  (!(i7.call(e, t) && hg(r, n)) || n === void 0 && !(t in e)) && tk(e, t, n);
}
function zd(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var s = t[a], u = void 0;
    u === void 0 && (u = e[s]), i ? tk(n, s, u) : nk(n, s, u);
  }
  return n;
}
var a7 = 9007199254740991;
function rk(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= a7;
}
function pg(e) {
  return e != null && rk(e.length) && !ek(e);
}
var o7 = Object.prototype;
function Gd(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || o7;
  return e === n;
}
function s7(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var l7 = "[object Arguments]";
function x1(e) {
  return Ro(e) && Ou(e) == l7;
}
var ik = Object.prototype, u7 = ik.hasOwnProperty, c7 = ik.propertyIsEnumerable, ak = x1(/* @__PURE__ */ function() {
  return arguments;
}()) ? x1 : function(e) {
  return Ro(e) && u7.call(e, "callee") && !c7.call(e, "callee");
};
function d7() {
  return !1;
}
var ok = typeof exports == "object" && exports && !exports.nodeType && exports, E1 = ok && typeof module == "object" && module && !module.nodeType && module, f7 = E1 && E1.exports === ok, T1 = f7 ? Bi.Buffer : void 0, h7 = T1 ? T1.isBuffer : void 0, Jl = h7 || d7, p7 = "[object Arguments]", m7 = "[object Array]", g7 = "[object Boolean]", v7 = "[object Date]", _7 = "[object Error]", y7 = "[object Function]", b7 = "[object Map]", w7 = "[object Number]", x7 = "[object Object]", E7 = "[object RegExp]", T7 = "[object Set]", k7 = "[object String]", S7 = "[object WeakMap]", O7 = "[object ArrayBuffer]", C7 = "[object DataView]", A7 = "[object Float32Array]", D7 = "[object Float64Array]", P7 = "[object Int8Array]", M7 = "[object Int16Array]", I7 = "[object Int32Array]", N7 = "[object Uint8Array]", L7 = "[object Uint8ClampedArray]", R7 = "[object Uint16Array]", F7 = "[object Uint32Array]", an = {};
an[A7] = an[D7] = an[P7] = an[M7] = an[I7] = an[N7] = an[L7] = an[R7] = an[F7] = !0;
an[p7] = an[m7] = an[O7] = an[g7] = an[C7] = an[v7] = an[_7] = an[y7] = an[b7] = an[w7] = an[x7] = an[E7] = an[T7] = an[k7] = an[S7] = !1;
function $7(e) {
  return Ro(e) && rk(e.length) && !!an[Ou(e)];
}
function mg(e) {
  return function(t) {
    return e(t);
  };
}
var sk = typeof exports == "object" && exports && !exports.nodeType && exports, Bl = sk && typeof module == "object" && module && !module.nodeType && module, V7 = Bl && Bl.exports === sk, ep = V7 && QT.process, Is = function() {
  try {
    var e = Bl && Bl.require && Bl.require("util").types;
    return e || ep && ep.binding && ep.binding("util");
  } catch {
  }
}(), k1 = Is && Is.isTypedArray, gg = k1 ? mg(k1) : $7, B7 = Object.prototype, U7 = B7.hasOwnProperty;
function lk(e, t) {
  var n = Ms(e), r = !n && ak(e), i = !n && !r && Jl(e), a = !n && !r && !i && gg(e), o = n || r || i || a, s = o ? s7(e.length, String) : [], u = s.length;
  for (var d in e)
    (t || U7.call(e, d)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    n7(d, u))) && s.push(d);
  return s;
}
function uk(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var W7 = uk(Object.keys, Object), H7 = Object.prototype, j7 = H7.hasOwnProperty;
function ck(e) {
  if (!Gd(e))
    return W7(e);
  var t = [];
  for (var n in Object(e))
    j7.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function vg(e) {
  return pg(e) ? lk(e) : ck(e);
}
function Y7(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var z7 = Object.prototype, G7 = z7.hasOwnProperty;
function q7(e) {
  if (!Cu(e))
    return Y7(e);
  var t = Gd(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !G7.call(e, r)) || n.push(r);
  return n;
}
function _g(e) {
  return pg(e) ? lk(e, !0) : q7(e);
}
var eu = zo(Object, "create");
function K7() {
  this.__data__ = eu ? eu(null) : {}, this.size = 0;
}
function X7(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Z7 = "__lodash_hash_undefined__", Q7 = Object.prototype, J7 = Q7.hasOwnProperty;
function eY(e) {
  var t = this.__data__;
  if (eu) {
    var n = t[e];
    return n === Z7 ? void 0 : n;
  }
  return J7.call(t, e) ? t[e] : void 0;
}
var tY = Object.prototype, nY = tY.hasOwnProperty;
function rY(e) {
  var t = this.__data__;
  return eu ? t[e] !== void 0 : nY.call(t, e);
}
var iY = "__lodash_hash_undefined__";
function aY(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = eu && t === void 0 ? iY : t, this;
}
function Fo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Fo.prototype.clear = K7;
Fo.prototype.delete = X7;
Fo.prototype.get = eY;
Fo.prototype.has = rY;
Fo.prototype.set = aY;
function oY() {
  this.__data__ = [], this.size = 0;
}
function qd(e, t) {
  for (var n = e.length; n--; )
    if (hg(e[n][0], t))
      return n;
  return -1;
}
var sY = Array.prototype, lY = sY.splice;
function uY(e) {
  var t = this.__data__, n = qd(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : lY.call(t, n, 1), --this.size, !0;
}
function cY(e) {
  var t = this.__data__, n = qd(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function dY(e) {
  return qd(this.__data__, e) > -1;
}
function fY(e, t) {
  var n = this.__data__, r = qd(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function ga(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ga.prototype.clear = oY;
ga.prototype.delete = uY;
ga.prototype.get = cY;
ga.prototype.has = dY;
ga.prototype.set = fY;
var tu = zo(Bi, "Map");
function hY() {
  this.size = 0, this.__data__ = {
    hash: new Fo(),
    map: new (tu || ga)(),
    string: new Fo()
  };
}
function pY(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Kd(e, t) {
  var n = e.__data__;
  return pY(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function mY(e) {
  var t = Kd(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function gY(e) {
  return Kd(this, e).get(e);
}
function vY(e) {
  return Kd(this, e).has(e);
}
function _Y(e, t) {
  var n = Kd(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Go(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Go.prototype.clear = hY;
Go.prototype.delete = mY;
Go.prototype.get = gY;
Go.prototype.has = vY;
Go.prototype.set = _Y;
function dk(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var fk = uk(Object.getPrototypeOf, Object);
function yY() {
  this.__data__ = new ga(), this.size = 0;
}
function bY(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function wY(e) {
  return this.__data__.get(e);
}
function xY(e) {
  return this.__data__.has(e);
}
var EY = 200;
function TY(e, t) {
  var n = this.__data__;
  if (n instanceof ga) {
    var r = n.__data__;
    if (!tu || r.length < EY - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Go(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function ma(e) {
  var t = this.__data__ = new ga(e);
  this.size = t.size;
}
ma.prototype.clear = yY;
ma.prototype.delete = bY;
ma.prototype.get = wY;
ma.prototype.has = xY;
ma.prototype.set = TY;
function kY(e, t) {
  return e && zd(t, vg(t), e);
}
function SY(e, t) {
  return e && zd(t, _g(t), e);
}
var hk = typeof exports == "object" && exports && !exports.nodeType && exports, S1 = hk && typeof module == "object" && module && !module.nodeType && module, OY = S1 && S1.exports === hk, O1 = OY ? Bi.Buffer : void 0, C1 = O1 ? O1.allocUnsafe : void 0;
function CY(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = C1 ? C1(n) : new e.constructor(n);
  return e.copy(r), r;
}
function AY(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (a[i++] = o);
  }
  return a;
}
function pk() {
  return [];
}
var DY = Object.prototype, PY = DY.propertyIsEnumerable, A1 = Object.getOwnPropertySymbols, yg = A1 ? function(e) {
  return e == null ? [] : (e = Object(e), AY(A1(e), function(t) {
    return PY.call(e, t);
  }));
} : pk;
function MY(e, t) {
  return zd(e, yg(e), t);
}
var IY = Object.getOwnPropertySymbols, mk = IY ? function(e) {
  for (var t = []; e; )
    dk(t, yg(e)), e = fk(e);
  return t;
} : pk;
function NY(e, t) {
  return zd(e, mk(e), t);
}
function gk(e, t, n) {
  var r = t(e);
  return Ms(e) ? r : dk(r, n(e));
}
function zp(e) {
  return gk(e, vg, yg);
}
function LY(e) {
  return gk(e, _g, mk);
}
var Gp = zo(Bi, "DataView"), qp = zo(Bi, "Promise"), Kp = zo(Bi, "Set"), D1 = "[object Map]", RY = "[object Object]", P1 = "[object Promise]", M1 = "[object Set]", I1 = "[object WeakMap]", N1 = "[object DataView]", FY = Yo(Gp), $Y = Yo(tu), VY = Yo(qp), BY = Yo(Kp), UY = Yo(Yp), ai = Ou;
(Gp && ai(new Gp(new ArrayBuffer(1))) != N1 || tu && ai(new tu()) != D1 || qp && ai(qp.resolve()) != P1 || Kp && ai(new Kp()) != M1 || Yp && ai(new Yp()) != I1) && (ai = function(e) {
  var t = Ou(e), n = t == RY ? e.constructor : void 0, r = n ? Yo(n) : "";
  if (r)
    switch (r) {
      case FY:
        return N1;
      case $Y:
        return D1;
      case VY:
        return P1;
      case BY:
        return M1;
      case UY:
        return I1;
    }
  return t;
});
var WY = Object.prototype, HY = WY.hasOwnProperty;
function jY(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && HY.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var xd = Bi.Uint8Array;
function bg(e) {
  var t = new e.constructor(e.byteLength);
  return new xd(t).set(new xd(e)), t;
}
function YY(e, t) {
  var n = t ? bg(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var zY = /\w*$/;
function GY(e) {
  var t = new e.constructor(e.source, zY.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var L1 = ja ? ja.prototype : void 0, R1 = L1 ? L1.valueOf : void 0;
function qY(e) {
  return R1 ? Object(R1.call(e)) : {};
}
function KY(e, t) {
  var n = t ? bg(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var XY = "[object Boolean]", ZY = "[object Date]", QY = "[object Map]", JY = "[object Number]", ez = "[object RegExp]", tz = "[object Set]", nz = "[object String]", rz = "[object Symbol]", iz = "[object ArrayBuffer]", az = "[object DataView]", oz = "[object Float32Array]", sz = "[object Float64Array]", lz = "[object Int8Array]", uz = "[object Int16Array]", cz = "[object Int32Array]", dz = "[object Uint8Array]", fz = "[object Uint8ClampedArray]", hz = "[object Uint16Array]", pz = "[object Uint32Array]";
function mz(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case iz:
      return bg(e);
    case XY:
    case ZY:
      return new r(+e);
    case az:
      return YY(e, n);
    case oz:
    case sz:
    case lz:
    case uz:
    case cz:
    case dz:
    case fz:
    case hz:
    case pz:
      return KY(e, n);
    case QY:
      return new r();
    case JY:
    case nz:
      return new r(e);
    case ez:
      return GY(e);
    case tz:
      return new r();
    case rz:
      return qY(e);
  }
}
function gz(e) {
  return typeof e.constructor == "function" && !Gd(e) ? Zj(fk(e)) : {};
}
var vz = "[object Map]";
function _z(e) {
  return Ro(e) && ai(e) == vz;
}
var F1 = Is && Is.isMap, yz = F1 ? mg(F1) : _z, bz = "[object Set]";
function wz(e) {
  return Ro(e) && ai(e) == bz;
}
var $1 = Is && Is.isSet, xz = $1 ? mg($1) : wz, Ez = 1, Tz = 2, kz = 4, vk = "[object Arguments]", Sz = "[object Array]", Oz = "[object Boolean]", Cz = "[object Date]", Az = "[object Error]", _k = "[object Function]", Dz = "[object GeneratorFunction]", Pz = "[object Map]", Mz = "[object Number]", yk = "[object Object]", Iz = "[object RegExp]", Nz = "[object Set]", Lz = "[object String]", Rz = "[object Symbol]", Fz = "[object WeakMap]", $z = "[object ArrayBuffer]", Vz = "[object DataView]", Bz = "[object Float32Array]", Uz = "[object Float64Array]", Wz = "[object Int8Array]", Hz = "[object Int16Array]", jz = "[object Int32Array]", Yz = "[object Uint8Array]", zz = "[object Uint8ClampedArray]", Gz = "[object Uint16Array]", qz = "[object Uint32Array]", Qt = {};
Qt[vk] = Qt[Sz] = Qt[$z] = Qt[Vz] = Qt[Oz] = Qt[Cz] = Qt[Bz] = Qt[Uz] = Qt[Wz] = Qt[Hz] = Qt[jz] = Qt[Pz] = Qt[Mz] = Qt[yk] = Qt[Iz] = Qt[Nz] = Qt[Lz] = Qt[Rz] = Qt[Yz] = Qt[zz] = Qt[Gz] = Qt[qz] = !0;
Qt[Az] = Qt[_k] = Qt[Fz] = !1;
function Xc(e, t, n, r, i, a) {
  var o, s = t & Ez, u = t & Tz, d = t & kz;
  if (o !== void 0)
    return o;
  if (!Cu(e))
    return e;
  var f = Ms(e);
  if (f) {
    if (o = jY(e), !s)
      return Qj(e, o);
  } else {
    var p = ai(e), m = p == _k || p == Dz;
    if (Jl(e))
      return CY(e, s);
    if (p == yk || p == vk || m && !i) {
      if (o = u || m ? {} : gz(e), !s)
        return u ? NY(e, SY(o, e)) : MY(e, kY(o, e));
    } else {
      if (!Qt[p])
        return i ? e : {};
      o = mz(e, p, s);
    }
  }
  a || (a = new ma());
  var g = a.get(e);
  if (g)
    return g;
  a.set(e, o), xz(e) ? e.forEach(function(w) {
    o.add(Xc(w, t, n, w, e, a));
  }) : yz(e) && e.forEach(function(w, T) {
    o.set(T, Xc(w, t, n, T, e, a));
  });
  var v = d ? u ? LY : zp : u ? _g : vg, b = f ? void 0 : v(e);
  return Jj(b || e, function(w, T) {
    b && (T = w, w = e[T]), nk(o, T, Xc(w, t, n, T, e, a));
  }), o;
}
var Kz = 1, Xz = 4;
function _l(e) {
  return Xc(e, Kz | Xz);
}
var Zz = "__lodash_hash_undefined__";
function Qz(e) {
  return this.__data__.set(e, Zz), this;
}
function Jz(e) {
  return this.__data__.has(e);
}
function Ed(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Go(); ++t < n; )
    this.add(e[t]);
}
Ed.prototype.add = Ed.prototype.push = Qz;
Ed.prototype.has = Jz;
function e9(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function t9(e, t) {
  return e.has(t);
}
var n9 = 1, r9 = 2;
function bk(e, t, n, r, i, a) {
  var o = n & n9, s = e.length, u = t.length;
  if (s != u && !(o && u > s))
    return !1;
  var d = a.get(e), f = a.get(t);
  if (d && f)
    return d == t && f == e;
  var p = -1, m = !0, g = n & r9 ? new Ed() : void 0;
  for (a.set(e, t), a.set(t, e); ++p < s; ) {
    var v = e[p], b = t[p];
    if (r)
      var w = o ? r(b, v, p, t, e, a) : r(v, b, p, e, t, a);
    if (w !== void 0) {
      if (w)
        continue;
      m = !1;
      break;
    }
    if (g) {
      if (!e9(t, function(T, S) {
        if (!t9(g, S) && (v === T || i(v, T, n, r, a)))
          return g.push(S);
      })) {
        m = !1;
        break;
      }
    } else if (!(v === b || i(v, b, n, r, a))) {
      m = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), m;
}
function i9(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function a9(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var o9 = 1, s9 = 2, l9 = "[object Boolean]", u9 = "[object Date]", c9 = "[object Error]", d9 = "[object Map]", f9 = "[object Number]", h9 = "[object RegExp]", p9 = "[object Set]", m9 = "[object String]", g9 = "[object Symbol]", v9 = "[object ArrayBuffer]", _9 = "[object DataView]", V1 = ja ? ja.prototype : void 0, tp = V1 ? V1.valueOf : void 0;
function y9(e, t, n, r, i, a, o) {
  switch (n) {
    case _9:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case v9:
      return !(e.byteLength != t.byteLength || !a(new xd(e), new xd(t)));
    case l9:
    case u9:
    case f9:
      return hg(+e, +t);
    case c9:
      return e.name == t.name && e.message == t.message;
    case h9:
    case m9:
      return e == t + "";
    case d9:
      var s = i9;
    case p9:
      var u = r & o9;
      if (s || (s = a9), e.size != t.size && !u)
        return !1;
      var d = o.get(e);
      if (d)
        return d == t;
      r |= s9, o.set(e, t);
      var f = bk(s(e), s(t), r, i, a, o);
      return o.delete(e), f;
    case g9:
      if (tp)
        return tp.call(e) == tp.call(t);
  }
  return !1;
}
var b9 = 1, w9 = Object.prototype, x9 = w9.hasOwnProperty;
function E9(e, t, n, r, i, a) {
  var o = n & b9, s = zp(e), u = s.length, d = zp(t), f = d.length;
  if (u != f && !o)
    return !1;
  for (var p = u; p--; ) {
    var m = s[p];
    if (!(o ? m in t : x9.call(t, m)))
      return !1;
  }
  var g = a.get(e), v = a.get(t);
  if (g && v)
    return g == t && v == e;
  var b = !0;
  a.set(e, t), a.set(t, e);
  for (var w = o; ++p < u; ) {
    m = s[p];
    var T = e[m], S = t[m];
    if (r)
      var x = o ? r(S, T, m, t, e, a) : r(T, S, m, e, t, a);
    if (!(x === void 0 ? T === S || i(T, S, n, r, a) : x)) {
      b = !1;
      break;
    }
    w || (w = m == "constructor");
  }
  if (b && !w) {
    var O = e.constructor, C = t.constructor;
    O != C && "constructor" in e && "constructor" in t && !(typeof O == "function" && O instanceof O && typeof C == "function" && C instanceof C) && (b = !1);
  }
  return a.delete(e), a.delete(t), b;
}
var T9 = 1, B1 = "[object Arguments]", U1 = "[object Array]", Fc = "[object Object]", k9 = Object.prototype, W1 = k9.hasOwnProperty;
function S9(e, t, n, r, i, a) {
  var o = Ms(e), s = Ms(t), u = o ? U1 : ai(e), d = s ? U1 : ai(t);
  u = u == B1 ? Fc : u, d = d == B1 ? Fc : d;
  var f = u == Fc, p = d == Fc, m = u == d;
  if (m && Jl(e)) {
    if (!Jl(t))
      return !1;
    o = !0, f = !1;
  }
  if (m && !f)
    return a || (a = new ma()), o || gg(e) ? bk(e, t, n, r, i, a) : y9(e, t, u, n, r, i, a);
  if (!(n & T9)) {
    var g = f && W1.call(e, "__wrapped__"), v = p && W1.call(t, "__wrapped__");
    if (g || v) {
      var b = g ? e.value() : e, w = v ? t.value() : t;
      return a || (a = new ma()), i(b, w, n, r, a);
    }
  }
  return m ? (a || (a = new ma()), E9(e, t, n, r, i, a)) : !1;
}
function wk(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !Ro(e) && !Ro(t) ? e !== e && t !== t : S9(e, t, n, r, wk, i);
}
var O9 = "[object Map]", C9 = "[object Set]", A9 = Object.prototype, D9 = A9.hasOwnProperty;
function P9(e) {
  if (e == null)
    return !0;
  if (pg(e) && (Ms(e) || typeof e == "string" || typeof e.splice == "function" || Jl(e) || gg(e) || ak(e)))
    return !e.length;
  var t = ai(e);
  if (t == O9 || t == C9)
    return !e.size;
  if (Gd(e))
    return !ck(e).length;
  for (var n in e)
    if (D9.call(e, n))
      return !1;
  return !0;
}
function H1(e, t) {
  return wk(e, t);
}
var M9 = Object.defineProperty, I9 = Object.defineProperties, N9 = Object.getOwnPropertyDescriptors, j1 = Object.getOwnPropertySymbols, L9 = Object.prototype.hasOwnProperty, R9 = Object.prototype.propertyIsEnumerable, Y1 = (e, t, n) => t in e ? M9(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, F9 = (e, t) => {
  for (var n in t || (t = {}))
    L9.call(t, n) && Y1(e, n, t[n]);
  if (j1)
    for (var n of j1(t))
      R9.call(t, n) && Y1(e, n, t[n]);
  return e;
}, $9 = (e, t) => I9(e, N9(t));
function V9(e) {
  return (e.match(/[a-zA-Z0-9]+/g) || []).map((t) => `${t.charAt(0).toUpperCase()}${t.slice(1)}`).join("");
}
var Ja = (e, t) => {
  const n = {
    chartData: { type: Object, required: !0 },
    options: { type: Object, required: !1 },
    chartId: { default: e, type: String },
    width: { default: 400, type: Number },
    height: { default: 400, type: Number },
    cssClasses: { type: String, default: "" },
    styles: { type: Object },
    plugins: { type: Array, default: () => [] },
    onLabelsUpdate: { type: Function },
    onChartUpdate: { type: Function },
    onChartDestroy: { type: Function },
    onChartRender: { type: Function }
  }, r = V9(e);
  return Tt({
    name: r,
    props: n,
    emits: {
      "labels:update": () => !0,
      "chart:update": (i) => !0,
      "chart:destroy": () => !0,
      "chart:render": (i) => !0
    },
    setup(i, { emit: a, expose: o }) {
      const s = fe(null), u = `${i.chartId}`;
      let d = su(null);
      dn(() => i.chartData, f, { deep: !0 }), dn(() => i.options, (w) => {
        d.value && w && (d.value.options = _l(w), v());
      }, { deep: !0 });
      function f(w) {
        if (d.value) {
          let T = d.value;
          H1(w.labels, d.value.data.labels) || (T.data.labels = w.labels, m()), H1(w.datasets, d.value.data.datasets) || w.datasets.forEach((S, x) => {
            var O, C;
            if (P9(S))
              T.data.datasets = [];
            else {
              const P = _l(T.data), k = Object.keys((C = (O = P.datasets) == null ? void 0 : O[x]) != null ? C : {}), M = Object.keys(S);
              k.filter((X) => X !== "_meta" && M.indexOf(X) === -1).forEach((X) => {
                T.data.datasets[x] && delete T.data.datasets[x][X];
              });
              for (const X in S) {
                const Z = _l(S[X]);
                T.data.datasets[x] || (T.data.datasets[x] = {}), S.hasOwnProperty(X) && Z != null && T && (T.data.datasets[x][X] = Z);
              }
            }
          }), v();
        } else
          d.value && b(), p();
      }
      function p() {
        s.value ? (d.value = new Ra(s.value, {
          data: _l(i.chartData),
          type: t,
          options: _l(i.options),
          plugins: i.plugins
        }), g()) : console.error(`Error on component ${r}, canvas cannot be rendered. Check if the render appends server-side`);
      }
      function m() {
        a("labels:update"), i.onLabelsUpdate && i.onLabelsUpdate();
      }
      function g() {
        d.value && (a("chart:render", d.value), i.onChartRender && i.onChartRender(d.value));
      }
      function v() {
        d.value && (d.value.update(), a("chart:update", d.value), i.onChartUpdate && i.onChartUpdate(d.value));
      }
      function b() {
        d.value && d.value.destroy(), a("chart:destroy"), i.onChartDestroy && i.onChartDestroy();
      }
      return Mt(p), qw(() => {
        d.value && d.value.destroy();
      }), o({
        canvasRef: s,
        renderChart: p,
        chartInstance: d,
        canvasId: u,
        update: v
      }), () => Ct("div", {
        style: $9(F9({
          maxWidth: "100%"
        }, i.styles), {
          position: "relative"
        }),
        class: i.cssClasses
      }, [
        Ct("canvas", {
          style: {
            maxWidth: "100%",
            maxHeight: "100%"
          },
          id: u,
          width: i.width,
          height: i.height,
          ref: s
        })
      ]);
    }
  });
};
Ja("bar-chart", "bar");
Ja("doughnut-chart", "doughnut");
var B9 = Ja("line-chart", "line"), U9 = Ja("pie-chart", "pie");
Ja("polar-chart", "polarArea");
Ja("radar-chart", "radar");
Ja("bubble-chart", "bubble");
Ja("scatter-chart", "scatter");
/*!
* chartjs-plugin-annotation v2.0.1
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2022 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */
const z1 = {
  modes: {
    /**
     * Point mode returns all elements that hit test based on the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */
    point(e, t) {
      return Zc(e, t, { intersect: !0 });
    },
    /**
     * Nearest mode returns the element closest to the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */
    nearest(e, t, n) {
      return j9(e, t, n);
    },
    /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    x(e, t, n) {
      return Zc(e, t, { intersect: n.intersect, axis: "x" });
    },
    /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    y(e, t, n) {
      return Zc(e, t, { intersect: n.intersect, axis: "y" });
    }
  }
};
function wg(e, t, n) {
  return (z1.modes[n.mode] || z1.modes.nearest)(e, t, n);
}
function W9(e, t, n) {
  return n !== "x" && n !== "y" ? e.inRange(t.x, t.y, "x", !0) || e.inRange(t.x, t.y, "y", !0) : e.inRange(t.x, t.y, n, !0);
}
function H9(e, t, n) {
  return n === "x" ? { x: e.x, y: t.y } : n === "y" ? { x: t.x, y: e.y } : t;
}
function Zc(e, t, n) {
  return e.visibleElements.filter((r) => n.intersect ? r.inRange(t.x, t.y) : W9(r, t, n.axis));
}
function j9(e, t, n) {
  let r = Number.POSITIVE_INFINITY;
  return Zc(e, t, n).reduce((i, a) => {
    const o = a.getCenterPoint(), s = H9(t, o, n.axis), u = Kl(t, s);
    return u < r ? (i = [a], r = u) : u === r && i.push(a), i;
  }, []).sort((i, a) => i._index - a._index).slice(0, 1);
}
const Xp = ["enter", "leave"], xg = Xp.concat("click");
function Y9(e, t, n) {
  t.listened = !1, t.moveListened = !1, t._getElements = wg, xg.forEach((r) => {
    typeof n[r] == "function" ? (t.listened = !0, t.listeners[r] = n[r]) : Sn(t.listeners[r]) && delete t.listeners[r];
  }), Xp.forEach((r) => {
    typeof n[r] == "function" && (t.moveListened = !0);
  }), (!t.listened || !t.moveListened) && t.annotations.forEach((r) => {
    !t.listened && typeof r.click == "function" && (t.listened = !0), t.moveListened || Xp.forEach((i) => {
      typeof r[i] == "function" && (t.listened = !0, t.moveListened = !0);
    });
  });
}
function z9(e, t, n) {
  if (e.listened)
    switch (t.type) {
      case "mousemove":
      case "mouseout":
        return G9(e, t, n);
      case "click":
        return q9(e, t, n);
    }
}
function G9(e, t, n) {
  if (!e.moveListened)
    return;
  let r;
  t.type === "mousemove" ? r = wg(e, t, n.interaction) : r = [];
  const i = e.hovered;
  e.hovered = r;
  const a = { state: e, event: t };
  let o = G1(a, "leave", i, r);
  return G1(a, "enter", r, i) || o;
}
function G1({ state: e, event: t }, n, r, i) {
  let a;
  for (const o of r)
    i.indexOf(o) < 0 && (a = xk(o.options[n] || e.listeners[n], o, t) || a);
  return a;
}
function q9(e, t, n) {
  const r = e.listeners, i = wg(e, t, n.interaction);
  let a;
  for (const o of i)
    a = xk(o.options.click || r.click, o, t) || a;
  return a;
}
function xk(e, t, n) {
  return Ht(e, [t.$context, n]) === !0;
}
const K9 = (e, t) => t > e || e.length > t.length && e.slice(0, t.length) === t, So = 1e-3, Eg = (e, t, n) => Math.min(n, Math.max(t, e));
function X9(e, t, n) {
  for (const r of Object.keys(e))
    e[r] = Eg(e[r], t, n);
  return e;
}
function Z9(e, t, n, r) {
  if (!e || !t || n <= 0)
    return !1;
  const i = r / 2;
  return Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2) <= Math.pow(n + i, 2);
}
function Ek(e, { x: t, y: n, x2: r, y2: i }, a, o) {
  const s = o / 2, u = e.x >= t - s - So && e.x <= r + s + So, d = e.y >= n - s - So && e.y <= i + s + So;
  return a === "x" ? u : (a === "y" || u) && d;
}
function Us(e, t) {
  const { centerX: n, centerY: r } = e.getProps(["centerX", "centerY"], t);
  return { x: n, y: r };
}
function Q9(e, t, n, r = !0) {
  const i = n.split(".");
  let a = 0;
  for (const o of t.split(".")) {
    const s = i[a++];
    if (parseInt(o, 10) < parseInt(s, 10))
      break;
    if (K9(s, o)) {
      if (r)
        throw new Error(`${e} v${n} is not supported. v${t} or newer is required.`);
      return !1;
    }
  }
  return !0;
}
const Tk = (e) => typeof e == "string" && e.endsWith("%"), kk = (e) => Eg(parseFloat(e) / 100, 0, 1);
function Tg(e, t) {
  return t === "start" ? 0 : t === "end" ? e : Tk(t) ? kk(t) * e : e / 2;
}
function Ns(e, t) {
  return typeof t == "number" ? t : Tk(t) ? kk(t) * e : e;
}
function J9(e, t) {
  const { x: n, width: r } = e, i = t.textAlign;
  return i === "center" ? n + r / 2 : i === "end" || i === "right" ? n + r : n;
}
function Sk(e) {
  return st(e) ? {
    x: nt(e.x, "center"),
    y: nt(e.y, "center")
  } : (e = nt(e, "center"), {
    x: e,
    y: e
  });
}
function Ok(e) {
  return e && (Sn(e.xValue) || Sn(e.yValue));
}
const np = /* @__PURE__ */ new Map();
function kg(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object HTMLImageElement]" || t === "[object HTMLCanvasElement]";
  }
}
function Sg(e, { x: t, y: n }, r) {
  r && (e.translate(t, n), e.rotate(An(r)), e.translate(-t, -n));
}
function qo(e, t) {
  if (t && t.borderWidth)
    return e.lineCap = t.borderCapStyle, e.setLineDash(t.borderDash), e.lineDashOffset = t.borderDashOffset, e.lineJoin = t.borderJoinStyle, e.lineWidth = t.borderWidth, e.strokeStyle = t.borderColor, !0;
}
function Ws(e, t) {
  e.shadowColor = t.backgroundShadowColor, e.shadowBlur = t.shadowBlur, e.shadowOffsetX = t.shadowOffsetX, e.shadowOffsetY = t.shadowOffsetY;
}
function Og(e, t) {
  const n = t.content;
  if (kg(n))
    return {
      width: Ns(n.width, t.width),
      height: Ns(n.height, t.height)
    };
  const r = _n(t.font), i = t.textStrokeWidth, a = jt(n) ? n : [n], o = a.join() + r.string + i + (e._measureText ? "-spriting" : "");
  if (!np.has(o)) {
    e.save(), e.font = r.string;
    const s = a.length;
    let u = 0;
    for (let f = 0; f < s; f++) {
      const p = a[f];
      u = Math.max(u, e.measureText(p).width + i);
    }
    e.restore();
    const d = s * r.lineHeight + i;
    np.set(o, { width: u, height: d });
  }
  return np.get(o);
}
function Ck(e, t, n) {
  const { x: r, y: i, width: a, height: o } = t;
  e.save(), Ws(e, n);
  const s = qo(e, n);
  e.fillStyle = n.backgroundColor, e.beginPath(), As(e, {
    x: r,
    y: i,
    w: a,
    h: o,
    radius: X9(La(n.borderRadius), 0, Math.min(a, o) / 2)
  }), e.closePath(), e.fill(), s && (e.shadowColor = n.borderShadowColor, e.stroke()), e.restore();
}
function eG(e, t, n) {
  const r = n.content;
  if (kg(r)) {
    e.drawImage(r, t.x, t.y, t.width, t.height);
    return;
  }
  const i = jt(r) ? r : [r], a = _n(n.font), o = a.lineHeight, s = J9(t, n), u = t.y + o / 2 + n.textStrokeWidth / 2;
  e.save(), e.font = a.string, e.textBaseline = "middle", e.textAlign = n.textAlign, tG(e, n) && i.forEach((d, f) => e.strokeText(d, s, u + f * o)), e.fillStyle = n.color, i.forEach((d, f) => e.fillText(d, s, u + f * o)), e.restore();
}
function tG(e, t) {
  if (t.textStrokeWidth > 0)
    return e.lineJoin = "round", e.miterLimit = 2, e.lineWidth = t.textStrokeWidth, e.strokeStyle = t.textStrokeColor, !0;
}
function Ls(e, t, n) {
  return t = typeof t == "number" ? t : e.parse(t), pn(t) ? e.getPixelForValue(t) : n;
}
function Ya(e, t, n) {
  const r = t[n];
  if (r || n === "scaleID")
    return r;
  const i = n.charAt(0), a = Object.values(e).filter((o) => o.axis && o.axis === i);
  return a.length ? a[0].id : i;
}
function Ak(e, t) {
  if (e) {
    const n = e.options.reverse, r = Ls(e, t.min, n ? t.end : t.start), i = Ls(e, t.max, n ? t.start : t.end);
    return {
      start: r,
      end: i
    };
  }
}
function Dk(e, t) {
  const { chartArea: n, scales: r } = e, i = r[Ya(r, t, "xScaleID")], a = r[Ya(r, t, "yScaleID")];
  let o = n.width / 2, s = n.height / 2;
  return i && (o = Ls(i, t.xValue, i.left + i.width / 2)), a && (s = Ls(a, t.yValue, a.top + a.height / 2)), { x: o, y: s };
}
function Xd(e, t) {
  const n = e.scales, r = n[Ya(n, t, "xScaleID")], i = n[Ya(n, t, "yScaleID")];
  if (!r && !i)
    return {};
  let { left: a, right: o } = r || e.chartArea, { top: s, bottom: u } = i || e.chartArea;
  const d = q1(r, { min: t.xMin, max: t.xMax, start: a, end: o });
  a = d.start, o = d.end;
  const f = q1(i, { min: t.yMin, max: t.yMax, start: u, end: s });
  return s = f.start, u = f.end, {
    x: a,
    y: s,
    x2: o,
    y2: u,
    width: o - a,
    height: u - s,
    centerX: a + (o - a) / 2,
    centerY: s + (u - s) / 2
  };
}
function Pk(e, t) {
  if (!Ok(t)) {
    const n = Xd(e, t);
    let r = t.radius;
    (!r || isNaN(r)) && (r = Math.min(n.width, n.height) / 2, t.radius = r);
    const i = r * 2;
    return {
      x: n.x + t.xAdjust,
      y: n.y + t.yAdjust,
      x2: n.x + i + t.xAdjust,
      y2: n.y + i + t.yAdjust,
      centerX: n.centerX + t.xAdjust,
      centerY: n.centerY + t.yAdjust,
      width: i,
      height: i
    };
  }
  return nG(e, t);
}
function nG(e, t) {
  const n = Dk(e, t), r = t.radius * 2;
  return {
    x: n.x - t.radius + t.xAdjust,
    y: n.y - t.radius + t.yAdjust,
    x2: n.x + t.radius + t.xAdjust,
    y2: n.y + t.radius + t.yAdjust,
    centerX: n.x + t.xAdjust,
    centerY: n.y + t.yAdjust,
    width: r,
    height: r
  };
}
function q1(e, t) {
  const n = Ak(e, t) || t;
  return {
    start: Math.min(n.start, n.end),
    end: Math.max(n.start, n.end)
  };
}
function Hs(e, t, n) {
  const r = Math.cos(n), i = Math.sin(n), a = t.x, o = t.y;
  return {
    x: a + r * (e.x - a) - i * (e.y - o),
    y: o + i * (e.x - a) + r * (e.y - o)
  };
}
function rG(e, t, n) {
  const r = lG(e.scales, t, n);
  let i = K1(t, r, "min", "suggestedMin");
  i = K1(t, r, "max", "suggestedMax") || i, i && typeof t.handleTickRangeOptions == "function" && t.handleTickRangeOptions();
}
function iG(e, t) {
  for (const n of e)
    oG(n, t);
}
function K1(e, t, n, r) {
  if (pn(t[n]) && !aG(e.options, n, r)) {
    const i = e[n] !== t[n];
    return e[n] = t[n], i;
  }
}
function aG(e, t, n) {
  return Sn(e[t]) || Sn(e[n]);
}
function oG(e, t) {
  for (const n of ["scaleID", "xScaleID", "yScaleID"]) {
    const r = Ya(t, e, n);
    r && !t[r] && sG(e, n) && console.warn(`No scale found with id '${r}' for annotation '${e.id}'`);
  }
}
function sG(e, t) {
  if (t === "scaleID")
    return !0;
  const n = t.charAt(0);
  for (const r of ["Min", "Max", "Value"])
    if (Sn(e[n + r]))
      return !0;
  return !1;
}
function lG(e, t, n) {
  const r = t.axis, i = t.id, a = r + "ScaleID", o = {
    min: nt(t.min, Number.NEGATIVE_INFINITY),
    max: nt(t.max, Number.POSITIVE_INFINITY)
  };
  for (const s of n)
    s.scaleID === i ? X1(s, t, ["value", "endValue"], o) : Ya(e, s, a) === i && X1(s, t, [r + "Min", r + "Max", r + "Value"], o);
  return o;
}
function X1(e, t, n, r) {
  for (const i of n) {
    const a = e[i];
    if (Sn(a)) {
      const o = t.parse(a);
      r.min = Math.min(r.min, o), r.max = Math.max(r.max, o);
    }
  }
}
class Au extends Kn {
  inRange(t, n, r, i) {
    const { x: a, y: o } = Hs({ x: t, y: n }, this.getCenterPoint(i), An(-this.options.rotation));
    return Ek({ x: a, y: o }, this.getProps(["x", "y", "x2", "y2"], i), r, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return Us(this, t);
  }
  draw(t) {
    t.save(), Sg(t, this.getCenterPoint(), this.options.rotation), Ck(t, this, this.options), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    const r = Xd(t, n), { x: i, y: a } = r;
    return r.elements = [{
      type: "label",
      optionScope: "label",
      properties: dG(t, r, n)
    }], r.initProperties = { x: i, y: a }, r;
  }
}
Au.id = "boxAnnotation";
Au.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  label: {
    backgroundColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "black",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    padding: 6,
    position: "center",
    rotation: void 0,
    textAlign: "start",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
Au.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
Au.descriptors = {
  label: {
    _fallback: !0
  }
};
function uG({ properties: e, options: t }, n, r, i) {
  const { x: a, x2: o, width: s } = e;
  return Mk({ start: a, end: o, size: s, borderWidth: t.borderWidth }, {
    position: r.x,
    padding: { start: i.left, end: i.right },
    adjust: t.label.xAdjust,
    size: n.width
  });
}
function cG({ properties: e, options: t }, n, r, i) {
  const { y: a, y2: o, height: s } = e;
  return Mk({ start: a, end: o, size: s, borderWidth: t.borderWidth }, {
    position: r.y,
    padding: { start: i.top, end: i.bottom },
    adjust: t.label.yAdjust,
    size: n.height
  });
}
function Mk(e, t) {
  const { start: n, end: r, borderWidth: i } = e, { position: a, padding: { start: o, end: s }, adjust: u } = t, d = r - i - n - o - s - t.size;
  return n + i / 2 + u + Tg(d, a);
}
function dG(e, t, n) {
  const r = n.label;
  r.backgroundColor = "transparent", r.callout.display = !1;
  const i = Sk(r.position), a = On(r.padding), o = Og(e.ctx, r), s = uG({ properties: t, options: n }, o, i, a), u = cG({ properties: t, options: n }, o, i, a), d = o.width + a.width, f = o.height + a.height;
  return {
    x: s,
    y: u,
    x2: s + d,
    y2: u + f,
    width: d,
    height: f,
    centerX: s + d / 2,
    centerY: u + f / 2,
    rotation: r.rotation
  };
}
const Cg = (e, t, n) => ({ x: e.x + n * (t.x - e.x), y: e.y + n * (t.y - e.y) }), Zp = (e, t, n) => Cg(t, n, Math.abs((e - t.y) / (n.y - t.y))).x, Z1 = (e, t, n) => Cg(t, n, Math.abs((e - t.x) / (n.x - t.x))).y, Tl = (e) => e * e, fG = (e, t, { x: n, y: r, x2: i, y2: a }, o) => o === "y" ? { start: Math.min(r, a), end: Math.max(r, a), value: t } : { start: Math.min(n, i), end: Math.max(n, i), value: e };
class Du extends Kn {
  inRange(t, n, r, i) {
    const a = this.options.borderWidth / 2;
    if (r !== "x" && r !== "y") {
      const s = Tl(a), u = { mouseX: t, mouseY: n };
      return mG(this, u, s, i) || ew(this, u, i);
    }
    const o = fG(t, n, this.getProps(["x", "y", "x2", "y2"], i), r);
    return o.value >= o.start - a && o.value <= o.end + a || ew(this, { mouseX: t, mouseY: n }, i, r);
  }
  getCenterPoint(t) {
    return Us(this, t);
  }
  draw(t) {
    const { x: n, y: r, x2: i, y2: a, options: o } = this;
    if (t.save(), !qo(t, o))
      return t.restore();
    Ws(t, o);
    const s = Math.atan2(a - r, i - n), u = Math.sqrt(Math.pow(i - n, 2) + Math.pow(a - r, 2)), { startOpts: d, endOpts: f, startAdjust: p, endAdjust: m } = xG(this);
    t.translate(n, r), t.rotate(s), t.beginPath(), t.moveTo(0 + p, 0), t.lineTo(u - m, 0), t.shadowColor = o.borderShadowColor, t.stroke(), aw(t, 0, p, d), aw(t, u, -m, f), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    const { scales: r, chartArea: i } = t, a = r[n.scaleID], o = { x: i.left, y: i.top, x2: i.right, y2: i.bottom };
    let s, u;
    if (a)
      s = Ls(a, n.value, NaN), u = Ls(a, n.endValue, s), a.isHorizontal() ? (o.x = s, o.x2 = u) : (o.y = s, o.y2 = u);
    else {
      const w = r[Ya(r, n, "xScaleID")], T = r[Ya(r, n, "yScaleID")];
      w && tw(o, w, { min: n.xMin, max: n.xMax, start: w.left, end: w.right, startProp: "x", endProp: "x2" }), T && tw(o, T, { min: n.yMin, max: n.yMax, start: T.bottom, end: T.top, startProp: "y", endProp: "y2" });
    }
    const { x: d, y: f, x2: p, y2: m } = o, g = hG(o, t.chartArea), v = g ? pG({ x: d, y: f }, { x: p, y: m }, t.chartArea) : { x: d, y: f, x2: p, y2: m, width: Math.abs(p - d), height: Math.abs(m - f) };
    v.centerX = (p + d) / 2, v.centerY = (m + f) / 2;
    const b = gG(t, v, n.label);
    return b._visible = g, v.elements = [{
      type: "label",
      optionScope: "label",
      properties: b
    }], v;
  }
}
Du.id = "lineAnnotation";
const Q1 = {
  backgroundColor: void 0,
  backgroundShadowColor: void 0,
  borderColor: void 0,
  borderDash: void 0,
  borderDashOffset: void 0,
  borderShadowColor: void 0,
  borderWidth: void 0,
  display: void 0,
  fill: void 0,
  length: void 0,
  shadowBlur: void 0,
  shadowOffsetX: void 0,
  shadowOffsetY: void 0,
  width: void 0
};
Du.defaults = {
  adjustScaleRange: !0,
  arrowHeads: {
    display: !1,
    end: Object.assign({}, Q1),
    fill: !1,
    length: 12,
    start: Object.assign({}, Q1),
    width: 6
  },
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 2,
  display: !0,
  endValue: void 0,
  label: {
    backgroundColor: "rgba(0,0,0,0.8)",
    backgroundShadowColor: "transparent",
    borderCapStyle: "butt",
    borderColor: "black",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderRadius: 6,
    borderShadowColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "#fff",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    padding: 6,
    position: "center",
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: "center",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  scaleID: void 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  value: void 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
Du.descriptors = {
  arrowHeads: {
    start: {
      _fallback: !0
    },
    end: {
      _fallback: !0
    },
    _fallback: !0
  }
};
Du.defaultRoutes = {
  borderColor: "color"
};
function hG({ x: e, y: t, x2: n, y2: r }, { top: i, right: a, bottom: o, left: s }) {
  return !(e < s && n < s || e > a && n > a || t < i && r < i || t > o && r > o);
}
function J1({ x: e, y: t }, n, { top: r, right: i, bottom: a, left: o }) {
  return e < o && (t = Z1(o, { x: e, y: t }, n), e = o), e > i && (t = Z1(i, { x: e, y: t }, n), e = i), t < r && (e = Zp(r, { x: e, y: t }, n), t = r), t > a && (e = Zp(a, { x: e, y: t }, n), t = a), { x: e, y: t };
}
function pG(e, t, n) {
  const { x: r, y: i } = J1(e, t, n), { x: a, y: o } = J1(t, e, n);
  return { x: r, y: i, x2: a, y2: o, width: Math.abs(a - r), height: Math.abs(o - i) };
}
function mG(e, { mouseX: t, mouseY: n }, r = So, i) {
  const { x: a, y: o, x2: s, y2: u } = e.getProps(["x", "y", "x2", "y2"], i), d = s - a, f = u - o, p = Tl(d) + Tl(f), m = p === 0 ? -1 : ((t - a) * d + (n - o) * f) / p;
  let g, v;
  return m < 0 ? (g = a, v = o) : m > 1 ? (g = s, v = u) : (g = a + m * d, v = o + m * f), Tl(t - g) + Tl(n - v) <= r;
}
function ew(e, { mouseX: t, mouseY: n }, r, i) {
  const a = e.label;
  return a.options.display && a.inRange(t, n, i, r);
}
function tw(e, t, n) {
  const r = Ak(t, n);
  e[n.startProp] = r.start, e[n.endProp] = r.end;
}
function gG(e, t, n) {
  n.callout.display = !1;
  const r = n.borderWidth, i = On(n.padding), a = Og(e.ctx, n), o = a.width + i.width + r, s = a.height + i.height + r;
  return _G(t, n, { width: o, height: s, padding: i }, e.chartArea);
}
function vG(e) {
  const { x: t, y: n, x2: r, y2: i } = e, a = Math.atan2(i - n, r - t);
  return a > Lt / 2 ? a - Lt : a < Lt / -2 ? a + Lt : a;
}
function _G(e, t, n, r) {
  const { width: i, height: a, padding: o } = n, { xAdjust: s, yAdjust: u } = t, d = { x: e.x, y: e.y }, f = { x: e.x2, y: e.y2 }, p = t.rotation === "auto" ? vG(e) : An(t.rotation), m = yG(i, a, p), g = bG(e, t, { labelSize: m, padding: o }, r), v = Cg(d, f, g), b = { size: m.w, min: r.left, max: r.right, padding: o.left }, w = { size: m.h, min: r.top, max: r.bottom, padding: o.top }, T = rw(v.x, b) + s, S = rw(v.y, w) + u;
  return {
    x: T - i / 2,
    y: S - a / 2,
    x2: T + i / 2,
    y2: S + a / 2,
    centerX: T,
    centerY: S,
    width: i,
    height: a,
    rotation: Rd(p)
  };
}
function yG(e, t, n) {
  const r = Math.cos(n), i = Math.sin(n);
  return {
    w: Math.abs(e * r) + Math.abs(t * i),
    h: Math.abs(e * i) + Math.abs(t * r)
  };
}
function bG(e, t, n, r) {
  let i;
  const a = wG(e, r);
  return t.position === "start" ? i = nw({ w: e.x2 - e.x, h: e.y2 - e.y }, n, t, a) : t.position === "end" ? i = 1 - nw({ w: e.x - e.x2, h: e.y - e.y2 }, n, t, a) : i = Tg(1, t.position), i;
}
function nw(e, t, n, r) {
  const { labelSize: i, padding: a } = t, o = e.w * r.dx, s = e.h * r.dy, u = o > 0 && (i.w / 2 + a.left - r.x) / o, d = s > 0 && (i.h / 2 + a.top - r.y) / s;
  return Eg(Math.max(u, d), 0, 0.25);
}
function wG(e, t) {
  const { x: n, x2: r, y: i, y2: a } = e, o = Math.min(i, a) - t.top, s = Math.min(n, r) - t.left, u = t.bottom - Math.max(i, a), d = t.right - Math.max(n, r);
  return {
    x: Math.min(s, d),
    y: Math.min(o, u),
    dx: s <= d ? 1 : -1,
    dy: o <= u ? 1 : -1
  };
}
function rw(e, t) {
  const { size: n, min: r, max: i, padding: a } = t, o = n / 2;
  return n > i - r ? (i + r) / 2 : (r >= e - a - o && (e = r + a + o), i <= e + a + o && (e = i - a - o), e);
}
function xG(e) {
  const t = e.options, n = t.arrowHeads && t.arrowHeads.start, r = t.arrowHeads && t.arrowHeads.end;
  return {
    startOpts: n,
    endOpts: r,
    startAdjust: iw(e, n),
    endAdjust: iw(e, r)
  };
}
function iw(e, t) {
  if (!t || !t.display)
    return 0;
  const { length: n, width: r } = t, i = e.options.borderWidth / 2, a = { x: n, y: r + i };
  return Math.abs(Zp(0, a, { x: 0, y: i }));
}
function aw(e, t, n, r) {
  if (!r || !r.display)
    return;
  const { length: i, width: a, fill: o, backgroundColor: s, borderColor: u } = r, d = Math.abs(t - i) + n;
  e.beginPath(), Ws(e, r), qo(e, r), e.moveTo(d, -a), e.lineTo(t + n, 0), e.lineTo(d, a), o === !0 ? (e.fillStyle = s || u, e.closePath(), e.fill(), e.shadowColor = "transparent") : e.shadowColor = r.borderShadowColor, e.stroke();
}
class Zd extends Kn {
  inRange(t, n, r, i) {
    const a = this.options.rotation, o = this.options.borderWidth;
    if (r !== "x" && r !== "y")
      return EG({ x: t, y: n }, this.getProps(["width", "height", "centerX", "centerY"], i), a, o);
    const { x: s, y: u, x2: d, y2: f } = this.getProps(["x", "y", "x2", "y2"], i), p = o / 2, m = r === "y" ? { start: u, end: f } : { start: s, end: d }, g = Hs({ x: t, y: n }, this.getCenterPoint(i), An(-a));
    return g[r] >= m.start - p - So && g[r] <= m.end + p + So;
  }
  getCenterPoint(t) {
    return Us(this, t);
  }
  draw(t) {
    const { width: n, height: r, centerX: i, centerY: a, options: o } = this;
    t.save(), Sg(t, this.getCenterPoint(), o.rotation), Ws(t, this.options), t.beginPath(), t.fillStyle = o.backgroundColor;
    const s = qo(t, o);
    t.ellipse(i, a, r / 2, n / 2, Lt / 2, 0, 2 * Lt), t.fill(), s && (t.shadowColor = o.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, n) {
    return Xd(t, n);
  }
}
Zd.id = "ellipseAnnotation";
Zd.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
Zd.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function EG(e, t, n, r) {
  const { width: i, height: a, centerX: o, centerY: s } = t, u = i / 2, d = a / 2;
  if (u <= 0 || d <= 0)
    return !1;
  const f = An(n || 0), p = r / 2 || 0, m = Math.cos(f), g = Math.sin(f), v = Math.pow(m * (e.x - o) + g * (e.y - s), 2), b = Math.pow(g * (e.x - o) - m * (e.y - s), 2);
  return v / Math.pow(u + p, 2) + b / Math.pow(d + p, 2) <= 1.0001;
}
const Ik = ["left", "bottom", "top", "right"];
class Qd extends Kn {
  inRange(t, n, r, i) {
    const { x: a, y: o } = Hs({ x: t, y: n }, this.getCenterPoint(i), An(-this.rotation));
    return Ek({ x: a, y: o }, this.getProps(["x", "y", "x2", "y2"], i), r, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return Us(this, t);
  }
  draw(t) {
    const n = this.options, r = !Sn(this._visible) || this._visible;
    !n.display || !n.content || !r || (t.save(), Sg(t, this.getCenterPoint(), this.rotation), kG(t, this), Ck(t, this, n), eG(t, MG(this), n), t.restore());
  }
  resolveElementProperties(t, n) {
    let r;
    if (Ok(n))
      r = Dk(t, n);
    else {
      const { centerX: s, centerY: u } = Xd(t, n);
      r = { x: s, y: u };
    }
    const i = On(n.padding), a = Og(t.ctx, n), o = TG(r, a, n, i);
    return {
      pointX: r.x,
      pointY: r.y,
      ...o,
      rotation: n.rotation
    };
  }
}
Qd.id = "labelAnnotation";
Qd.defaults = {
  adjustScaleRange: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 0,
  callout: {
    borderCapStyle: "butt",
    borderColor: void 0,
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 1,
    display: !1,
    margin: 5,
    position: "auto",
    side: 5,
    start: "50%"
  },
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  padding: 6,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
Qd.defaultRoutes = {
  borderColor: "color"
};
function TG(e, t, n, r) {
  const i = t.width + r.width + n.borderWidth, a = t.height + r.height + n.borderWidth, o = Sk(n.position), s = ow(e.x, i, n.xAdjust, o.x), u = ow(e.y, a, n.yAdjust, o.y);
  return {
    x: s,
    y: u,
    x2: s + i,
    y2: u + a,
    width: i,
    height: a,
    centerX: s + i / 2,
    centerY: u + a / 2
  };
}
function ow(e, t, n = 0, r) {
  return e - Tg(t, r) + n;
}
function kG(e, t) {
  const { pointX: n, pointY: r, options: i } = t, a = i.callout, o = a && a.display && DG(t, a);
  if (!o || IG(t, a, o))
    return;
  if (e.save(), e.beginPath(), !qo(e, a))
    return e.restore();
  const { separatorStart: u, separatorEnd: d } = SG(t, o), { sideStart: f, sideEnd: p } = CG(t, o, u);
  (a.margin > 0 || i.borderWidth === 0) && (e.moveTo(u.x, u.y), e.lineTo(d.x, d.y)), e.moveTo(f.x, f.y), e.lineTo(p.x, p.y);
  const m = Hs({ x: n, y: r }, t.getCenterPoint(), An(-t.rotation));
  e.lineTo(m.x, m.y), e.stroke(), e.restore();
}
function SG(e, t) {
  const { x: n, y: r, x2: i, y2: a } = e, o = OG(e, t);
  let s, u;
  return t === "left" || t === "right" ? (s = { x: n + o, y: r }, u = { x: s.x, y: a }) : (s = { x: n, y: r + o }, u = { x: i, y: s.y }), { separatorStart: s, separatorEnd: u };
}
function OG(e, t) {
  const { width: n, height: r, options: i } = e, a = i.callout.margin + i.borderWidth / 2;
  return t === "right" ? n + a : t === "bottom" ? r + a : -a;
}
function CG(e, t, n) {
  const { y: r, width: i, height: a, options: o } = e, s = o.callout.start, u = AG(t, o.callout);
  let d, f;
  return t === "left" || t === "right" ? (d = { x: n.x, y: r + Ns(a, s) }, f = { x: d.x + u, y: d.y }) : (d = { x: n.x + Ns(i, s), y: n.y }, f = { x: d.x, y: d.y + u }), { sideStart: d, sideEnd: f };
}
function AG(e, t) {
  const n = t.side;
  return e === "left" || e === "top" ? -n : n;
}
function DG(e, t) {
  const n = t.position;
  return Ik.includes(n) ? n : PG(e, t);
}
function PG(e, t) {
  const { x: n, y: r, x2: i, y2: a, width: o, height: s, pointX: u, pointY: d, centerX: f, centerY: p, rotation: m } = e, g = { x: f, y: p }, v = t.start, b = Ns(o, v), w = Ns(s, v), T = [n, n + b, n + b, i], S = [r + w, a, r, a], x = [];
  for (let O = 0; O < 4; O++) {
    const C = Hs({ x: T[O], y: S[O] }, g, An(m));
    x.push({
      position: Ik[O],
      distance: Kl(C, { x: u, y: d })
    });
  }
  return x.sort((O, C) => O.distance - C.distance)[0].position;
}
function MG({ x: e, y: t, width: n, height: r, options: i }) {
  const a = i.borderWidth / 2, o = On(i.padding);
  return {
    x: e + o.left + a,
    y: t + o.top + a,
    width: n - o.left - o.right - i.borderWidth,
    height: r - o.top - o.bottom - i.borderWidth
  };
}
function IG(e, t, n) {
  const { pointX: r, pointY: i } = e, a = t.margin;
  let o = r, s = i;
  return n === "left" ? o += a : n === "right" ? o -= a : n === "top" ? s += a : n === "bottom" && (s -= a), e.inRange(o, s);
}
class Jd extends Kn {
  inRange(t, n, r, i) {
    const { x: a, y: o, x2: s, y2: u, width: d } = this.getProps(["x", "y", "x2", "y2", "width"], i), f = this.options.borderWidth;
    if (r !== "x" && r !== "y")
      return Z9({ x: t, y: n }, this.getCenterPoint(i), d / 2, f);
    const p = f / 2, m = r === "y" ? { start: o, end: u, value: n } : { start: a, end: s, value: t };
    return m.value >= m.start - p && m.value <= m.end + p;
  }
  getCenterPoint(t) {
    return Us(this, t);
  }
  draw(t) {
    const n = this.options, r = n.borderWidth;
    if (n.radius < 0.1)
      return;
    t.save(), t.fillStyle = n.backgroundColor, Ws(t, n);
    const i = qo(t, n);
    n.borderWidth = 0, gd(t, n, this.centerX, this.centerY), i && !kg(n.pointStyle) && (t.shadowColor = n.borderShadowColor, t.stroke()), t.restore(), n.borderWidth = r;
  }
  resolveElementProperties(t, n) {
    return Pk(t, n);
  }
}
Jd.id = "pointAnnotation";
Jd.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  pointStyle: "circle",
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
Jd.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
class ef extends Kn {
  inRange(t, n, r, i) {
    if (r !== "x" && r !== "y")
      return this.options.radius >= 0.1 && this.elements.length > 1 && LG(this.elements, t, n, i);
    const a = Hs({ x: t, y: n }, this.getCenterPoint(i), An(-this.options.rotation)), o = this.elements.map((d) => r === "y" ? d.bY : d.bX), s = Math.min(...o), u = Math.max(...o);
    return a[r] >= s && a[r] <= u;
  }
  getCenterPoint(t) {
    return Us(this, t);
  }
  draw(t) {
    const { elements: n, options: r } = this;
    t.save(), t.beginPath(), t.fillStyle = r.backgroundColor, Ws(t, r);
    const i = qo(t, r);
    let a = !0;
    for (const o of n)
      a ? (t.moveTo(o.x, o.y), a = !1) : t.lineTo(o.x, o.y);
    t.closePath(), t.fill(), i && (t.shadowColor = r.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, n) {
    const r = Pk(t, n), { x: i, y: a } = r, { sides: o, rotation: s } = n, u = [], d = 2 * Lt / o;
    let f = s * nT;
    for (let p = 0; p < o; p++, f += d)
      u.push(NG(r, n, f));
    return r.elements = u, r.initProperties = { x: i, y: a }, r;
  }
}
ef.id = "polygonAnnotation";
ef.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  point: {
    radius: 0
  },
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  sides: 3,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
ef.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function NG({ centerX: e, centerY: t }, { radius: n, borderWidth: r }, i) {
  const a = r / 2, o = Math.sin(i), s = Math.cos(i), u = { x: e + o * n, y: t - s * n };
  return {
    type: "point",
    optionScope: "point",
    properties: {
      x: u.x,
      y: u.y,
      centerX: u.x,
      centerY: u.y,
      bX: e + o * (n + a),
      bY: t - s * (n + a)
    }
  };
}
function LG(e, t, n, r) {
  let i = !1, a = e[e.length - 1].getProps(["bX", "bY"], r);
  for (const o of e) {
    const s = o.getProps(["bX", "bY"], r);
    s.bY > n != a.bY > n && t < (a.bX - s.bX) * (n - s.bY) / (a.bY - s.bY) + s.bX && (i = !i), a = s;
  }
  return i;
}
const Fa = {
  box: Au,
  ellipse: Zd,
  label: Qd,
  line: Du,
  point: Jd,
  polygon: ef
};
Object.keys(Fa).forEach((e) => {
  yt.describe(`elements.${Fa[e].id}`, {
    _fallback: "plugins.annotation.common"
  });
});
const RG = {
  update: Object.assign
};
function Ag(e = "line") {
  return Fa[e] ? e : (console.warn(`Unknown annotation type: '${e}', defaulting to 'line'`), "line");
}
function FG(e, t, n, r) {
  const i = VG(e, n.animations, r), a = t.annotations, o = WG(t.elements, a);
  for (let s = 0; s < a.length; s++) {
    const u = a[s], d = Nk(o, s, u.type), f = u.setContext(UG(e, d, u)), p = d.resolveElementProperties(e, f);
    p.skip = $G(p), "elements" in p && (BG(d, p, f, i), delete p.elements), Sn(d.x) || Object.assign(d, p), p.options = Lk(f), i.update(d, p);
  }
}
function $G(e) {
  return isNaN(e.x) || isNaN(e.y);
}
function VG(e, t, n) {
  return n === "reset" || n === "none" || n === "resize" ? RG : new og(e, t);
}
function BG(e, { elements: t, initProperties: n }, r, i) {
  const a = e.elements || (e.elements = []);
  a.length = t.length;
  for (let o = 0; o < t.length; o++) {
    const s = t[o], u = s.properties, d = Nk(a, o, s.type, n), f = r[s.optionScope].override(s);
    u.options = Lk(f), i.update(d, u);
  }
}
function Nk(e, t, n, r) {
  const i = Fa[Ag(n)];
  let a = e[t];
  return (!a || !(a instanceof i)) && (a = e[t] = new i(), st(r) && Object.assign(a, r)), a;
}
function Lk(e) {
  const t = Fa[Ag(e.type)], n = {};
  n.id = e.id, n.type = e.type, n.drawTime = e.drawTime, Object.assign(
    n,
    Qp(e, t.defaults),
    Qp(e, t.defaultRoutes)
  );
  for (const r of xg)
    n[r] = e[r];
  return n;
}
function Qp(e, t) {
  const n = {};
  for (const r of Object.keys(t)) {
    const i = t[r], a = e[r];
    n[r] = st(i) ? Qp(a, i) : a;
  }
  return n;
}
function UG(e, t, n) {
  return t.$context || (t.$context = Object.assign(Object.create(e.getContext()), {
    element: t,
    id: n.id,
    type: "annotation"
  }));
}
function WG(e, t) {
  const n = t.length, r = e.length;
  if (r < n) {
    const i = n - r;
    e.splice(r, 0, ...new Array(i));
  } else r > n && e.splice(n, r - n);
  return e;
}
var HG = "2.0.1";
const Aa = /* @__PURE__ */ new Map();
var jG = {
  id: "annotation",
  version: HG,
  beforeRegister() {
    Q9("chart.js", "3.7", Ra.version);
  },
  afterRegister() {
    Ra.register(Fa);
  },
  afterUnregister() {
    Ra.unregister(Fa);
  },
  beforeInit(e) {
    Aa.set(e, {
      annotations: [],
      elements: [],
      visibleElements: [],
      listeners: {},
      listened: !1,
      moveListened: !1,
      hovered: []
    });
  },
  beforeUpdate(e, t, n) {
    const r = Aa.get(e), i = r.annotations = [];
    let a = n.annotations;
    st(a) ? Object.keys(a).forEach((o) => {
      const s = a[o];
      st(s) && (s.id = o, i.push(s));
    }) : jt(a) && i.push(...a), iG(i, e.scales);
  },
  afterDataLimits(e, t) {
    const n = Aa.get(e);
    rG(e, t.scale, n.annotations.filter((r) => r.display && r.adjustScaleRange));
  },
  afterUpdate(e, t, n) {
    const r = Aa.get(e);
    Y9(e, r, n), FG(e, r, n, t.mode), r.visibleElements = r.elements.filter((i) => !i.skip && i.options.display);
  },
  beforeDatasetsDraw(e, t, n) {
    $c(e, "beforeDatasetsDraw", n.clip);
  },
  afterDatasetsDraw(e, t, n) {
    $c(e, "afterDatasetsDraw", n.clip);
  },
  beforeDraw(e, t, n) {
    $c(e, "beforeDraw", n.clip);
  },
  afterDraw(e, t, n) {
    $c(e, "afterDraw", n.clip);
  },
  beforeEvent(e, t, n) {
    const r = Aa.get(e);
    z9(r, t.event, n) && (t.changed = !0);
  },
  destroy(e) {
    Aa.delete(e);
  },
  _getState(e) {
    return Aa.get(e);
  },
  defaults: {
    animations: {
      numbers: {
        properties: ["x", "y", "x2", "y2", "width", "height", "centerX", "centerY", "pointX", "pointY", "radius"],
        type: "number"
      }
    },
    clip: !0,
    interaction: {
      mode: void 0,
      axis: void 0,
      intersect: void 0
    },
    common: {
      drawTime: "afterDatasetsDraw",
      label: {}
    }
  },
  descriptors: {
    _indexable: !1,
    _scriptable: (e) => !xg.includes(e),
    annotations: {
      _allKeys: !1,
      _fallback: (e, t) => `elements.${Fa[Ag(t.type)].id}`
    },
    interaction: {
      _fallback: !0
    },
    common: {
      label: {
        _fallback: !0
      }
    }
  },
  additionalOptionScopes: [""]
};
function $c(e, t, n) {
  const { ctx: r, chartArea: i } = e, { visibleElements: a } = Aa.get(e);
  n && _u(r, i);
  const o = YG(a, t).sort((s, u) => s.options.z - u.options.z);
  for (const s of o)
    s.draw(e.ctx, i);
  n && yu(r);
}
function YG(e, t) {
  const n = [];
  for (const r of e)
    if (r.options.drawTime === t && n.push(r), r.elements && r.elements.length)
      for (const i of r.elements)
        i.options.display && i.options.drawTime === t && n.push(i);
  return n;
}
Ra.register(...ZT, jG);
const zG = {
  props: ["title", "data", "options", "plugins", "tooltipText"],
  components: {
    LineChart: B9,
    InformationCircleIcon: fu
  },
  watch: {
    chartData: {
      handler() {
        this.chartKey = this.chartKey + 1;
      },
      deep: !0
    }
  },
  data: () => ({
    chartKey: 0
  }),
  computed: {
    chartData: function() {
      return {
        datasets: Object.entries(this.data).map(([e, t]) => ({
          borderColor: t.color,
          fill: !1,
          borderWidth: 2,
          pointRadius: 0,
          parsing: !0,
          label: this.$t(e),
          data: t.value.map((n) => ({ x: n.date, y: n.value }))
        }))
      };
    }
  }
}, GG = { class: "bg-white p-6 mt-4 rounded-lg shadow-lg" }, qG = { class: "flex items-center gap-x-2 pb-2" }, KG = { class: "text-xl pl-2 font-bold tracking-tight text-gray-900 text-left" }, XG = {
  key: 0,
  class: "text-lg pb-6 pl-2 tracking-tight text-gray-700 text-left"
};
function ZG(e, t, n, r, i, a) {
  const o = je("InformationCircleIcon"), s = je("VTooltip"), u = je("LineChart", !0);
  return I(), W("div", GG, [
    K("div", qG, [
      K("h1", KG, ke(n.title), 1),
      n.tooltipText || e.tooltipHtml ? (I(), Oe(s, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: Ve(() => [
          Ee(e.$slots, "tooltip", {}, () => [
            K("span", null, ke(n.tooltipText), 1)
          ])
        ]),
        default: Ve(() => [
          Ae(o, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : ee("", !0)
    ]),
    e.$slots.subtitle ? (I(), W("div", XG, [
      Ee(e.$slots, "subtitle")
    ])) : ee("", !0),
    (I(), Oe(u, {
      chartData: a.chartData,
      options: n.options,
      width: 100,
      height: 300,
      key: e.chartKey
    }, null, 8, ["chartData", "options"]))
  ]);
}
const QG = /* @__PURE__ */ pt(zG, [["render", ZG]]);
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var sw = function() {
  if (typeof window < "u") {
    if (window.devicePixelRatio)
      return window.devicePixelRatio;
    var e = window.screen;
    if (e)
      return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
  }
  return 1;
}(), Ul = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: function(e) {
    var t = [], n;
    for (e = [].concat(e); e.length; )
      n = e.pop(), typeof n == "string" ? t.unshift.apply(t, n.split(`
`)) : Array.isArray(n) ? e.push.apply(e, n) : ht(e) || t.unshift("" + n);
    return t;
  },
  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: function(e, t, n) {
    var r = [].concat(t), i = r.length, a = e.font, o = 0, s;
    for (e.font = n.string, s = 0; s < i; ++s)
      o = Math.max(e.measureText(r[s]).width, o);
    return e.font = a, {
      height: i * n.lineHeight,
      width: o
    };
  },
  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: function(e, t, n) {
    return Math.max(e, Math.min(t, n));
  },
  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: function(e, t) {
    var n = e.slice(), r = [], i, a, o, s;
    for (i = 0, o = t.length; i < o; ++i)
      s = t[i], a = n.indexOf(s), a === -1 ? r.push([s, 1]) : n.splice(a, 1);
    for (i = 0, o = n.length; i < o; ++i)
      r.push([n[i], -1]);
    return r;
  },
  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: function(e) {
    return Math.round(e * sw) / sw;
  }
};
function rp(e, t) {
  var n = t.x, r = t.y;
  if (n === null)
    return { x: 0, y: -1 };
  if (r === null)
    return { x: 1, y: 0 };
  var i = e.x - n, a = e.y - r, o = Math.sqrt(i * i + a * a);
  return {
    x: o ? i / o : 0,
    y: o ? a / o : -1
  };
}
function JG(e, t, n, r, i) {
  switch (i) {
    case "center":
      n = r = 0;
      break;
    case "bottom":
      n = 0, r = 1;
      break;
    case "right":
      n = 1, r = 0;
      break;
    case "left":
      n = -1, r = 0;
      break;
    case "top":
      n = 0, r = -1;
      break;
    case "start":
      n = -n, r = -r;
      break;
    case "end":
      break;
    default:
      i *= Math.PI / 180, n = Math.cos(i), r = Math.sin(i);
      break;
  }
  return {
    x: e,
    y: t,
    vx: n,
    vy: r
  };
}
var eq = 0, Rk = 1, Fk = 2, $k = 4, Vk = 8;
function Vc(e, t, n) {
  var r = eq;
  return e < n.left ? r |= Rk : e > n.right && (r |= Fk), t < n.top ? r |= Vk : t > n.bottom && (r |= $k), r;
}
function tq(e, t) {
  for (var n = e.x0, r = e.y0, i = e.x1, a = e.y1, o = Vc(n, r, t), s = Vc(i, a, t), u, d, f; !(!(o | s) || o & s); )
    u = o || s, u & Vk ? (d = n + (i - n) * (t.top - r) / (a - r), f = t.top) : u & $k ? (d = n + (i - n) * (t.bottom - r) / (a - r), f = t.bottom) : u & Fk ? (f = r + (a - r) * (t.right - n) / (i - n), d = t.right) : u & Rk && (f = r + (a - r) * (t.left - n) / (i - n), d = t.left), u === o ? (n = d, r = f, o = Vc(n, r, t)) : (i = d, a = f, s = Vc(i, a, t));
  return {
    x0: n,
    x1: i,
    y0: r,
    y1: a
  };
}
function Bc(e, t) {
  var n = t.anchor, r = e, i, a;
  return t.clamp && (r = tq(r, t.area)), n === "start" ? (i = r.x0, a = r.y0) : n === "end" ? (i = r.x1, a = r.y1) : (i = (r.x0 + r.x1) / 2, a = (r.y0 + r.y1) / 2), JG(i, a, e.vx, e.vy, t.align);
}
var Uc = {
  arc: function(e, t) {
    var n = (e.startAngle + e.endAngle) / 2, r = Math.cos(n), i = Math.sin(n), a = e.innerRadius, o = e.outerRadius;
    return Bc({
      x0: e.x + r * a,
      y0: e.y + i * a,
      x1: e.x + r * o,
      y1: e.y + i * o,
      vx: r,
      vy: i
    }, t);
  },
  point: function(e, t) {
    var n = rp(e, t.origin), r = n.x * e.options.radius, i = n.y * e.options.radius;
    return Bc({
      x0: e.x - r,
      y0: e.y - i,
      x1: e.x + r,
      y1: e.y + i,
      vx: n.x,
      vy: n.y
    }, t);
  },
  bar: function(e, t) {
    var n = rp(e, t.origin), r = e.x, i = e.y, a = 0, o = 0;
    return e.horizontal ? (r = Math.min(e.x, e.base), a = Math.abs(e.base - e.x)) : (i = Math.min(e.y, e.base), o = Math.abs(e.base - e.y)), Bc({
      x0: r,
      y0: i + o,
      x1: r + a,
      y1: i,
      vx: n.x,
      vy: n.y
    }, t);
  },
  fallback: function(e, t) {
    var n = rp(e, t.origin);
    return Bc({
      x0: e.x,
      y0: e.y,
      x1: e.x + (e.width || 0),
      y1: e.y + (e.height || 0),
      vx: n.x,
      vy: n.y
    }, t);
  }
}, ha = Ul.rasterize;
function nq(e) {
  var t = e.borderWidth || 0, n = e.padding, r = e.size.height, i = e.size.width, a = -i / 2, o = -r / 2;
  return {
    frame: {
      x: a - n.left - t,
      y: o - n.top - t,
      w: i + n.width + t * 2,
      h: r + n.height + t * 2
    },
    text: {
      x: a,
      y: o,
      w: i,
      h: r
    }
  };
}
function rq(e, t) {
  var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
  if (!n)
    return null;
  if (n.xCenter !== void 0 && n.yCenter !== void 0)
    return { x: n.xCenter, y: n.yCenter };
  var r = n.getBasePixel();
  return e.horizontal ? { x: r, y: null } : { x: null, y: r };
}
function iq(e) {
  return e instanceof xu ? Uc.arc : e instanceof Eu ? Uc.point : e instanceof Tu ? Uc.bar : Uc.fallback;
}
function aq(e, t, n, r, i, a) {
  var o = Math.PI / 2;
  if (a) {
    var s = Math.min(a, i / 2, r / 2), u = t + s, d = n + s, f = t + r - s, p = n + i - s;
    e.moveTo(t, d), u < f && d < p ? (e.arc(u, d, s, -Math.PI, -o), e.arc(f, d, s, -o, 0), e.arc(f, p, s, 0, o), e.arc(u, p, s, o, Math.PI)) : u < f ? (e.moveTo(u, n), e.arc(f, d, s, -o, o), e.arc(u, d, s, o, Math.PI + o)) : d < p ? (e.arc(u, d, s, -Math.PI, 0), e.arc(u, p, s, 0, Math.PI)) : e.arc(u, d, s, -Math.PI, Math.PI), e.closePath(), e.moveTo(t, n);
  } else
    e.rect(t, n, r, i);
}
function oq(e, t, n) {
  var r = n.backgroundColor, i = n.borderColor, a = n.borderWidth;
  !r && (!i || !a) || (e.beginPath(), aq(
    e,
    ha(t.x) + a / 2,
    ha(t.y) + a / 2,
    ha(t.w) - a,
    ha(t.h) - a,
    n.borderRadius
  ), e.closePath(), r && (e.fillStyle = r, e.fill()), i && a && (e.strokeStyle = i, e.lineWidth = a, e.lineJoin = "miter", e.stroke()));
}
function sq(e, t, n) {
  var r = n.lineHeight, i = e.w, a = e.x, o = e.y + r / 2;
  return t === "center" ? a += i / 2 : (t === "end" || t === "right") && (a += i), {
    h: r,
    w: i,
    x: a,
    y: o
  };
}
function lq(e, t, n) {
  var r = e.shadowBlur, i = n.stroked, a = ha(n.x), o = ha(n.y), s = ha(n.w);
  i && e.strokeText(t, a, o, s), n.filled && (r && i && (e.shadowBlur = 0), e.fillText(t, a, o, s), r && i && (e.shadowBlur = r));
}
function uq(e, t, n, r) {
  var i = r.textAlign, a = r.color, o = !!a, s = r.font, u = t.length, d = r.textStrokeColor, f = r.textStrokeWidth, p = d && f, m;
  if (!(!u || !o && !p))
    for (n = sq(n, i, s), e.font = s.string, e.textAlign = i, e.textBaseline = "middle", e.shadowBlur = r.textShadowBlur, e.shadowColor = r.textShadowColor, o && (e.fillStyle = a), p && (e.lineJoin = "round", e.lineWidth = f, e.strokeStyle = d), m = 0, u = t.length; m < u; ++m)
      lq(e, t[m], {
        stroked: p,
        filled: o,
        w: n.w,
        x: n.x,
        y: n.y + n.h * m
      });
}
var Bk = function(e, t, n, r) {
  var i = this;
  i._config = e, i._index = r, i._model = null, i._rects = null, i._ctx = t, i._el = n;
};
$i(Bk.prototype, {
  /**
   * @private
   */
  _modelize: function(e, t, n, r) {
    var i = this, a = i._index, o = _n(rn([n.font, {}], r, a)), s = rn([n.color, yt.color], r, a);
    return {
      align: rn([n.align, "center"], r, a),
      anchor: rn([n.anchor, "center"], r, a),
      area: r.chart.chartArea,
      backgroundColor: rn([n.backgroundColor, null], r, a),
      borderColor: rn([n.borderColor, null], r, a),
      borderRadius: rn([n.borderRadius, 0], r, a),
      borderWidth: rn([n.borderWidth, 0], r, a),
      clamp: rn([n.clamp, !1], r, a),
      clip: rn([n.clip, !1], r, a),
      color: s,
      display: e,
      font: o,
      lines: t,
      offset: rn([n.offset, 4], r, a),
      opacity: rn([n.opacity, 1], r, a),
      origin: rq(i._el, r),
      padding: On(rn([n.padding, 4], r, a)),
      positioner: iq(i._el),
      rotation: rn([n.rotation, 0], r, a) * (Math.PI / 180),
      size: Ul.textSize(i._ctx, t, o),
      textAlign: rn([n.textAlign, "start"], r, a),
      textShadowBlur: rn([n.textShadowBlur, 0], r, a),
      textShadowColor: rn([n.textShadowColor, s], r, a),
      textStrokeColor: rn([n.textStrokeColor, s], r, a),
      textStrokeWidth: rn([n.textStrokeWidth, 0], r, a)
    };
  },
  update: function(e) {
    var t = this, n = null, r = null, i = t._index, a = t._config, o, s, u, d = rn([a.display, !0], e, i);
    d && (o = e.dataset.data[i], s = nt(Ht(a.formatter, [o, e]), o), u = ht(s) ? [] : Ul.toTextLines(s), u.length && (n = t._modelize(d, u, a, e), r = nq(n))), t._model = n, t._rects = r;
  },
  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },
  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },
  visible: function() {
    return this._model && this._model.opacity;
  },
  model: function() {
    return this._model;
  },
  draw: function(e, t) {
    var n = this, r = e.ctx, i = n._model, a = n._rects, o;
    this.visible() && (r.save(), i.clip && (o = i.area, r.beginPath(), r.rect(
      o.left,
      o.top,
      o.right - o.left,
      o.bottom - o.top
    ), r.clip()), r.globalAlpha = Ul.bound(0, i.opacity, 1), r.translate(ha(t.x), ha(t.y)), r.rotate(i.rotation), oq(r, a.frame, i), uq(r, i.lines, a.text, i), r.restore());
  }
});
var cq = Number.MIN_SAFE_INTEGER || -9007199254740991, dq = Number.MAX_SAFE_INTEGER || 9007199254740991;
function yl(e, t, n) {
  var r = Math.cos(n), i = Math.sin(n), a = t.x, o = t.y;
  return {
    x: a + r * (e.x - a) - i * (e.y - o),
    y: o + i * (e.x - a) + r * (e.y - o)
  };
}
function lw(e, t) {
  var n = dq, r = cq, i = t.origin, a, o, s, u, d;
  for (a = 0; a < e.length; ++a)
    o = e[a], s = o.x - i.x, u = o.y - i.y, d = t.vx * s + t.vy * u, n = Math.min(n, d), r = Math.max(r, d);
  return {
    min: n,
    max: r
  };
}
function Wc(e, t) {
  var n = t.x - e.x, r = t.y - e.y, i = Math.sqrt(n * n + r * r);
  return {
    vx: (t.x - e.x) / i,
    vy: (t.y - e.y) / i,
    origin: e,
    ln: i
  };
}
var Uk = function() {
  this._rotation = 0, this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};
$i(Uk.prototype, {
  center: function() {
    var e = this._rect;
    return {
      x: e.x + e.w / 2,
      y: e.y + e.h / 2
    };
  },
  update: function(e, t, n) {
    this._rotation = n, this._rect = {
      x: t.x + e.x,
      y: t.y + e.y,
      w: t.w,
      h: t.h
    };
  },
  contains: function(e) {
    var t = this, n = 1, r = t._rect;
    return e = yl(e, t.center(), -t._rotation), !(e.x < r.x - n || e.y < r.y - n || e.x > r.x + r.w + n * 2 || e.y > r.y + r.h + n * 2);
  },
  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: function(e) {
    var t = this._points(), n = e._points(), r = [
      Wc(t[0], t[1]),
      Wc(t[0], t[3])
    ], i, a, o;
    for (this._rotation !== e._rotation && r.push(
      Wc(n[0], n[1]),
      Wc(n[0], n[3])
    ), i = 0; i < r.length; ++i)
      if (a = lw(t, r[i]), o = lw(n, r[i]), a.max < o.min || o.max < a.min)
        return !1;
    return !0;
  },
  /**
   * @private
   */
  _points: function() {
    var e = this, t = e._rect, n = e._rotation, r = e.center();
    return [
      yl({ x: t.x, y: t.y }, r, n),
      yl({ x: t.x + t.w, y: t.y }, r, n),
      yl({ x: t.x + t.w, y: t.y + t.h }, r, n),
      yl({ x: t.x, y: t.y + t.h }, r, n)
    ];
  }
});
function Wk(e, t, n) {
  var r = t.positioner(e, t), i = r.vx, a = r.vy;
  if (!i && !a)
    return { x: r.x, y: r.y };
  var o = n.w, s = n.h, u = t.rotation, d = Math.abs(o / 2 * Math.cos(u)) + Math.abs(s / 2 * Math.sin(u)), f = Math.abs(o / 2 * Math.sin(u)) + Math.abs(s / 2 * Math.cos(u)), p = 1 / Math.max(Math.abs(i), Math.abs(a));
  return d *= i * p, f *= a * p, d += t.offset * i, f += t.offset * a, {
    x: r.x + d,
    y: r.y + f
  };
}
function fq(e, t) {
  var n, r, i, a;
  for (n = e.length - 1; n >= 0; --n)
    for (i = e[n].$layout, r = n - 1; r >= 0 && i._visible; --r)
      a = e[r].$layout, a._visible && i._box.intersects(a._box) && t(i, a);
  return e;
}
function hq(e) {
  var t, n, r, i, a, o, s;
  for (t = 0, n = e.length; t < n; ++t)
    r = e[t], i = r.$layout, i._visible && (s = new Proxy(r._el, { get: (u, d) => u.getProps([d], !0)[d] }), a = r.geometry(), o = Wk(s, r.model(), a), i._box.update(o, a, r.rotation()));
  return fq(e, function(u, d) {
    var f = u._hidable, p = d._hidable;
    f && p || p ? d._visible = !1 : f && (u._visible = !1);
  });
}
var Wl = {
  prepare: function(e) {
    var t = [], n, r, i, a, o;
    for (n = 0, i = e.length; n < i; ++n)
      for (r = 0, a = e[n].length; r < a; ++r)
        o = e[n][r], t.push(o), o.$layout = {
          _box: new Uk(),
          _hidable: !1,
          _visible: !0,
          _set: n,
          _idx: o._index
        };
    return t.sort(function(s, u) {
      var d = s.$layout, f = u.$layout;
      return d._idx === f._idx ? f._set - d._set : f._idx - d._idx;
    }), this.update(t), t;
  },
  update: function(e) {
    var t = !1, n, r, i, a, o;
    for (n = 0, r = e.length; n < r; ++n)
      i = e[n], a = i.model(), o = i.$layout, o._hidable = a && a.display === "auto", o._visible = i.visible(), t |= o._hidable;
    t && hq(e);
  },
  lookup: function(e, t) {
    var n, r;
    for (n = e.length - 1; n >= 0; --n)
      if (r = e[n].$layout, r && r._visible && r._box.contains(t))
        return e[n];
    return null;
  },
  draw: function(e, t) {
    var n, r, i, a, o, s;
    for (n = 0, r = t.length; n < r; ++n)
      i = t[n], a = i.$layout, a._visible && (o = i.geometry(), s = Wk(i._el, i.model(), o), a._box.update(s, o, i.rotation()), i.draw(e, s));
  }
}, pq = function(e) {
  if (ht(e))
    return null;
  var t = e, n, r, i;
  if (st(e))
    if (!ht(e.label))
      t = e.label;
    else if (!ht(e.r))
      t = e.r;
    else
      for (t = "", n = Object.keys(e), i = 0, r = n.length; i < r; ++i)
        t += (i !== 0 ? ", " : "") + n[i] + ": " + e[n[i]];
  return "" + t;
}, mq = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: !1,
  clip: !1,
  color: void 0,
  display: !0,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter: pq,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
}, kr = "$datalabels", Hk = "$default";
function gq(e, t) {
  var n = e.datalabels, r = {}, i = [], a, o;
  return n === !1 ? null : (n === !0 && (n = {}), t = $i({}, [t, n]), a = t.labels || {}, o = Object.keys(a), delete t.labels, o.length ? o.forEach(function(s) {
    a[s] && i.push($i({}, [
      t,
      a[s],
      { _key: s }
    ]));
  }) : i.push(t), r = i.reduce(function(s, u) {
    return $t(u.listeners || {}, function(d, f) {
      s[f] = s[f] || {}, s[f][u._key || Hk] = d;
    }), delete u.listeners, s;
  }, {}), {
    labels: i,
    listeners: r
  });
}
function Jp(e, t, n, r) {
  if (t) {
    var i = n.$context, a = n.$groups, o;
    t[a._set] && (o = t[a._set][a._key], o && Ht(o, [i, r]) === !0 && (e[kr]._dirty = !0, n.update(i)));
  }
}
function vq(e, t, n, r, i) {
  var a, o;
  !n && !r || (n ? r ? n !== r && (o = a = !0) : o = !0 : a = !0, o && Jp(e, t.leave, n, i), a && Jp(e, t.enter, r, i));
}
function _q(e, t) {
  var n = e[kr], r = n._listeners, i, a;
  if (!(!r.enter && !r.leave)) {
    if (t.type === "mousemove")
      a = Wl.lookup(n._labels, t);
    else if (t.type !== "mouseout")
      return;
    i = n._hovered, n._hovered = a, vq(e, r, i, a, t);
  }
}
function yq(e, t) {
  var n = e[kr], r = n._listeners.click, i = r && Wl.lookup(n._labels, t);
  i && Jp(e, r, i, t);
}
var bq = {
  id: "datalabels",
  defaults: mq,
  beforeInit: function(e) {
    e[kr] = {
      _actives: []
    };
  },
  beforeUpdate: function(e) {
    var t = e[kr];
    t._listened = !1, t._listeners = {}, t._datasets = [], t._labels = [];
  },
  afterDatasetUpdate: function(e, t, n) {
    var r = t.index, i = e[kr], a = i._datasets[r] = [], o = e.isDatasetVisible(r), s = e.data.datasets[r], u = gq(s, n), d = t.meta.data || [], f = e.ctx, p, m, g, v, b, w, T, S;
    for (f.save(), p = 0, g = d.length; p < g; ++p)
      if (T = d[p], T[kr] = [], o && T && e.getDataVisibility(p) && !T.skip)
        for (m = 0, v = u.labels.length; m < v; ++m)
          b = u.labels[m], w = b._key, S = new Bk(b, f, T, p), S.$groups = {
            _set: r,
            _key: w || Hk
          }, S.$context = {
            active: !1,
            chart: e,
            dataIndex: p,
            dataset: s,
            datasetIndex: r
          }, S.update(S.$context), T[kr].push(S), a.push(S);
    f.restore(), $i(i._listeners, u.listeners, {
      merger: function(x, O, C) {
        O[x] = O[x] || {}, O[x][t.index] = C[x], i._listened = !0;
      }
    });
  },
  afterUpdate: function(e) {
    e[kr]._labels = Wl.prepare(e[kr]._datasets);
  },
  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: function(e) {
    Wl.draw(e, e[kr]._labels);
  },
  beforeEvent: function(e, t) {
    if (e[kr]._listened) {
      var n = t.event;
      switch (n.type) {
        case "mousemove":
        case "mouseout":
          _q(e, n);
          break;
        case "click":
          yq(e, n);
          break;
      }
    }
  },
  afterEvent: function(e) {
    var t = e[kr], n = t._actives, r = t._actives = e.getActiveElements(), i = Ul.arrayDiff(n, r), a, o, s, u, d, f, p;
    for (a = 0, o = i.length; a < o; ++a)
      if (d = i[a], d[1])
        for (p = d[0].element[kr] || [], s = 0, u = p.length; s < u; ++s)
          f = p[s], f.$context.active = d[1] === 1, f.update(f.$context);
    (t._dirty || i.length) && (Wl.update(t._labels), e.render()), delete t._dirty;
  }
};
Ra.register(...ZT, bq);
const wq = {
  components: { PieChart: U9, InformationCircleIcon: fu },
  props: ["title", "data", "options", "tooltipText", "maxCategories"],
  computed: {
    chartData() {
      const e = this.groupTopCategories(
        this.data,
        this.maxCategories
      );
      return {
        labels: Object.keys(e.data),
        datasets: [
          {
            data: Object.values(e.data),
            backgroundColor: this.generateRandomColors(
              Object.keys(e.data).length
            )
          }
        ]
      };
    },
    chartOptions() {
      const e = this.groupTopCategories(
        this.data,
        this.maxCategories
      ).otherDetails;
      return {
        responsive: !0,
        maintainAspectRatio: !1,
        cutout: "60%",
        plugins: {
          legend: {
            display: !0,
            position: "left",
            labels: {
              usePointStyle: !0,
              pointStyle: "circle",
              generateLabels: (t) => {
                let n = t.data;
                if (n.labels.length && n.datasets.length) {
                  let r = n.datasets[0].data.reduce(
                    (i, a) => i + a,
                    0
                  );
                  return n.labels.map((i, a) => {
                    let s = (n.datasets[0].data[a] / r * 100).toFixed(2) + "%";
                    return {
                      text: `${i} (${s})`,
                      fillStyle: n.datasets[0].backgroundColor[a],
                      hidden: !1
                    };
                  });
                }
                return [];
              }
            }
          },
          tooltip: {
            displayColors: !0,
            callbacks: {
              beforeLabel: () => "",
              afterLabel: () => ""
            },
            padding: 10,
            useHTML: !0,
            callbacks: {
              label: (t) => {
                let n = t.dataset.data.reduce(
                  (a, o) => a + o,
                  0
                ), r = t.raw, i = (r / n * 100).toFixed(2);
                if (t.label === "Autres" && Array.isArray(e) && e.length > 0) {
                  const a = e.map(
                    ([o, s]) => ` • ${o} : ${s} (${(s / n * 100).toFixed(2)}%)`
                  ).join(`\r
`);
                  return [
                    ` Autres : ${r} (${i}%)`,
                    ...a.split(`\r
`)
                  ];
                }
                return ` ${t.label} : ${r} (${i}%)`;
              }
            }
          },
          datalabels: {
            display: !1
          }
        }
      };
    }
  },
  methods: {
    groupTopCategories(e, t = 12) {
      const n = Object.entries(e).sort((s, u) => u[1] - s[1]), r = n.slice(0, t - 1), i = n.slice(t - 1), a = Object.fromEntries(r);
      let o = [];
      return i.length > 0 && (a.Autres = i.reduce((s, [, u]) => s + u, 0), o = i), { data: a, otherDetails: o };
    },
    generateRandomColors(e) {
      const t = [];
      for (let n = 0; n < e; n++) {
        let r;
        do
          r = `rgba(${this.randomMuted255()}, ${this.randomMuted255()}, ${this.randomMuted255()}, 0.6)`;
        while (this.isGray(r));
        t.push(r);
      }
      return t;
    },
    randomMuted255() {
      return Math.floor(Math.random() * 101) + 100;
    },
    isGray(e) {
      const t = e.match(/\d+/g), n = parseInt(t[0]), r = parseInt(t[1]), i = parseInt(t[2]);
      return Math.abs(n - r) < 20 && Math.abs(r - i) < 20 && Math.abs(n - i) < 20;
    }
  }
}, xq = { class: "bg-white px-6 py-4 mt-4 rounded-lg shadow-lg" }, Eq = { class: "flex items-center gap-x-2 pb-4" }, Tq = { class: "text-xl pl-2 font-bold tracking-tight text-gray-900 text-left" };
function kq(e, t, n, r, i, a) {
  const o = je("InformationCircleIcon"), s = je("VTooltip"), u = je("PieChart", !0);
  return I(), W("div", xq, [
    K("div", Eq, [
      K("h1", Tq, ke(n.title), 1),
      n.tooltipText || e.tooltipHtml ? (I(), Oe(s, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: Ve(() => [
          Ee(e.$slots, "tooltip", {}, () => [
            K("span", null, ke(n.tooltipText), 1)
          ])
        ]),
        default: Ve(() => [
          Ae(o, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : ee("", !0)
    ]),
    Ae(u, {
      "chart-data": a.chartData,
      options: a.chartOptions,
      height: "300",
      width: "300"
    }, null, 8, ["chart-data", "options"])
  ]);
}
const Sq = /* @__PURE__ */ pt(wq, [["render", kq]]);
/*!
  * shared v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const yi = typeof window < "u";
let jr, $o;
if (process.env.NODE_ENV !== "production") {
  const e = yi && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (jr = (t) => {
    e.mark(t);
  }, $o = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const Oq = /\{([0-9a-zA-Z]+)\}/g;
function Dg(e, ...t) {
  return t.length === 1 && Et(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Oq, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const Ui = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Cq = (e, t, n) => Aq({ l: e, k: t, s: n }), Aq = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), En = (e) => typeof e == "number" && isFinite(e), Dq = (e) => Yk(e) === "[object Date]", za = (e) => Yk(e) === "[object RegExp]", tf = (e) => rt(e) && Object.keys(e).length === 0, Gn = Object.assign, Pq = Object.create, Gt = (e = null) => Pq(e);
let uw;
const la = () => uw || (uw = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Gt());
function cw(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Mq = Object.prototype.hasOwnProperty;
function vi(e, t) {
  return Mq.call(e, t);
}
const Jt = Array.isArray, Yt = (e) => typeof e == "function", Te = (e) => typeof e == "string", dt = (e) => typeof e == "boolean", Et = (e) => e !== null && typeof e == "object", Iq = (e) => Et(e) && Yt(e.then) && Yt(e.catch), jk = Object.prototype.toString, Yk = (e) => jk.call(e), rt = (e) => {
  if (!Et(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, Nq = (e) => e == null ? "" : Jt(e) || rt(e) && e.toString === jk ? JSON.stringify(e, null, 2) : String(e);
function Lq(e, t = "") {
  return e.reduce((n, r, i) => i === 0 ? n + r : n + t + r, "");
}
const dw = 2;
function Rq(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let i = 0;
  const a = [];
  for (let o = 0; o < r.length; o++)
    if (i += r[o].length + 1, i >= t) {
      for (let s = o - dw; s <= o + dw || n > i; s++) {
        if (s < 0 || s >= r.length)
          continue;
        const u = s + 1;
        a.push(`${u}${" ".repeat(3 - String(u).length)}|  ${r[s]}`);
        const d = r[s].length;
        if (s === o) {
          const f = t - (i - d) + 1, p = Math.max(1, n > i ? d - f : n - t);
          a.push("   |  " + " ".repeat(f) + "^".repeat(p));
        } else if (s > o) {
          if (n > i) {
            const f = Math.max(Math.min(n - i, d), 1);
            a.push("   |  " + "^".repeat(f));
          }
          i += d + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function nf(e) {
  let t = e;
  return () => ++t;
}
function Ln(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const fw = {};
function zk(e) {
  fw[e] || (fw[e] = !0, Ln(e));
}
function Pg() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const i = e.get(n);
      i && i.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const i = e.get(n);
      i && i.splice(i.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((i) => i(r)), (e.get("*") || []).slice().map((i) => i(n, r));
    }
  };
}
const Hc = (e) => !Et(e) || Jt(e);
function Qc(e, t) {
  if (Hc(e) || Hc(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: i } = n.pop();
    Object.keys(r).forEach((a) => {
      a !== "__proto__" && (Et(r[a]) && !Et(i[a]) && (i[a] = Array.isArray(r[a]) ? [] : Gt()), Hc(i[a]) || Hc(r[a]) ? i[a] = r[a] : n.push({ src: r[a], des: i[a] }));
    });
  }
}
/*!
  * message-compiler v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function Fq(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Td(e, t, n) {
  return { start: e, end: t };
}
const $q = /\{([0-9a-zA-Z]+)\}/g;
function Gk(e, ...t) {
  return t.length === 1 && Vq(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace($q, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const qk = Object.assign, hw = (e) => typeof e == "string", Vq = (e) => e !== null && typeof e == "object";
function Kk(e, t = "") {
  return e.reduce((n, r, i) => i === 0 ? n + r : n + t + r, "");
}
const rf = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, Bq = {
  [rf.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function Uq(e, t, ...n) {
  const r = Gk(Bq[e], ...n || []), i = { message: String(r), code: e };
  return t && (i.location = t), i;
}
const tt = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, Wq = {
  // tokenizer error messages
  [tt.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [tt.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [tt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [tt.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [tt.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [tt.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [tt.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [tt.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [tt.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [tt.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [tt.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [tt.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [tt.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [tt.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [tt.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [tt.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function js(e, t, n = {}) {
  const { domain: r, messages: i, args: a } = n, o = Gk((i || Wq)[e] || "", ...a || []), s = new SyntaxError(String(o));
  return s.code = e, t && (s.location = t), s.domain = r, s;
}
function Hq(e) {
  throw e;
}
const jq = /<\/?[\w\s="/.':;#-\/]+>/, Yq = (e) => jq.test(e), Ji = " ", zq = "\r", hr = `
`, Gq = "\u2028", qq = "\u2029";
function Kq(e) {
  const t = e;
  let n = 0, r = 1, i = 1, a = 0;
  const o = (k) => t[k] === zq && t[k + 1] === hr, s = (k) => t[k] === hr, u = (k) => t[k] === qq, d = (k) => t[k] === Gq, f = (k) => o(k) || s(k) || u(k) || d(k), p = () => n, m = () => r, g = () => i, v = () => a, b = (k) => o(k) || u(k) || d(k) ? hr : t[k], w = () => b(n), T = () => b(n + a);
  function S() {
    return a = 0, f(n) && (r++, i = 0), o(n) && n++, n++, i++, t[n];
  }
  function x() {
    return o(n + a) && a++, a++, t[n + a];
  }
  function O() {
    n = 0, r = 1, i = 1, a = 0;
  }
  function C(k = 0) {
    a = k;
  }
  function P() {
    const k = n + a;
    for (; k !== n; )
      S();
    a = 0;
  }
  return {
    index: p,
    line: m,
    column: g,
    peekOffset: v,
    charAt: b,
    currentChar: w,
    currentPeek: T,
    next: S,
    peek: x,
    reset: O,
    resetPeek: C,
    skipToPeek: P
  };
}
const Ca = void 0, Xq = ".", pw = "'", Zq = "tokenizer";
function Qq(e, t = {}) {
  const n = t.location !== !1, r = Kq(e), i = () => r.index(), a = () => Fq(r.line(), r.column(), r.index()), o = a(), s = i(), u = {
    currentType: 14,
    offset: s,
    startLoc: o,
    endLoc: o,
    lastType: 14,
    lastOffset: s,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => u, { onError: f } = t;
  function p(R, V, ge, ...Fe) {
    const Pt = d();
    if (V.column += ge, V.offset += ge, f) {
      const mt = n ? Td(Pt.startLoc, V) : null, wt = js(R, mt, {
        domain: Zq,
        args: Fe
      });
      f(wt);
    }
  }
  function m(R, V, ge) {
    R.endLoc = a(), R.currentType = V;
    const Fe = { type: V };
    return n && (Fe.loc = Td(R.startLoc, R.endLoc)), ge != null && (Fe.value = ge), Fe;
  }
  const g = (R) => m(
    R,
    14
    /* TokenTypes.EOF */
  );
  function v(R, V) {
    return R.currentChar() === V ? (R.next(), V) : (p(tt.EXPECTED_TOKEN, a(), 0, V), "");
  }
  function b(R) {
    let V = "";
    for (; R.currentPeek() === Ji || R.currentPeek() === hr; )
      V += R.currentPeek(), R.peek();
    return V;
  }
  function w(R) {
    const V = b(R);
    return R.skipToPeek(), V;
  }
  function T(R) {
    if (R === Ca)
      return !1;
    const V = R.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V === 95;
  }
  function S(R) {
    if (R === Ca)
      return !1;
    const V = R.charCodeAt(0);
    return V >= 48 && V <= 57;
  }
  function x(R, V) {
    const { currentType: ge } = V;
    if (ge !== 2)
      return !1;
    b(R);
    const Fe = T(R.currentPeek());
    return R.resetPeek(), Fe;
  }
  function O(R, V) {
    const { currentType: ge } = V;
    if (ge !== 2)
      return !1;
    b(R);
    const Fe = R.currentPeek() === "-" ? R.peek() : R.currentPeek(), Pt = S(Fe);
    return R.resetPeek(), Pt;
  }
  function C(R, V) {
    const { currentType: ge } = V;
    if (ge !== 2)
      return !1;
    b(R);
    const Fe = R.currentPeek() === pw;
    return R.resetPeek(), Fe;
  }
  function P(R, V) {
    const { currentType: ge } = V;
    if (ge !== 8)
      return !1;
    b(R);
    const Fe = R.currentPeek() === ".";
    return R.resetPeek(), Fe;
  }
  function k(R, V) {
    const { currentType: ge } = V;
    if (ge !== 9)
      return !1;
    b(R);
    const Fe = T(R.currentPeek());
    return R.resetPeek(), Fe;
  }
  function M(R, V) {
    const { currentType: ge } = V;
    if (!(ge === 8 || ge === 12))
      return !1;
    b(R);
    const Fe = R.currentPeek() === ":";
    return R.resetPeek(), Fe;
  }
  function N(R, V) {
    const { currentType: ge } = V;
    if (ge !== 10)
      return !1;
    const Fe = () => {
      const mt = R.currentPeek();
      return mt === "{" ? T(R.peek()) : mt === "@" || mt === "%" || mt === "|" || mt === ":" || mt === "." || mt === Ji || !mt ? !1 : mt === hr ? (R.peek(), Fe()) : te(R, !1);
    }, Pt = Fe();
    return R.resetPeek(), Pt;
  }
  function X(R) {
    b(R);
    const V = R.currentPeek() === "|";
    return R.resetPeek(), V;
  }
  function Z(R) {
    const V = b(R), ge = R.currentPeek() === "%" && R.peek() === "{";
    return R.resetPeek(), {
      isModulo: ge,
      hasSpace: V.length > 0
    };
  }
  function te(R, V = !0) {
    const ge = (Pt = !1, mt = "", wt = !1) => {
      const ae = R.currentPeek();
      return ae === "{" ? mt === "%" ? !1 : Pt : ae === "@" || !ae ? mt === "%" ? !0 : Pt : ae === "%" ? (R.peek(), ge(Pt, "%", !0)) : ae === "|" ? mt === "%" || wt ? !0 : !(mt === Ji || mt === hr) : ae === Ji ? (R.peek(), ge(!0, Ji, wt)) : ae === hr ? (R.peek(), ge(!0, hr, wt)) : !0;
    }, Fe = ge();
    return V && R.resetPeek(), Fe;
  }
  function ce(R, V) {
    const ge = R.currentChar();
    return ge === Ca ? Ca : V(ge) ? (R.next(), ge) : null;
  }
  function we(R) {
    const V = R.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V >= 48 && V <= 57 || // 0-9
    V === 95 || // _
    V === 36;
  }
  function G(R) {
    return ce(R, we);
  }
  function Q(R) {
    const V = R.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V >= 48 && V <= 57 || // 0-9
    V === 95 || // _
    V === 36 || // $
    V === 45;
  }
  function y(R) {
    return ce(R, Q);
  }
  function H(R) {
    const V = R.charCodeAt(0);
    return V >= 48 && V <= 57;
  }
  function ie(R) {
    return ce(R, H);
  }
  function ne(R) {
    const V = R.charCodeAt(0);
    return V >= 48 && V <= 57 || // 0-9
    V >= 65 && V <= 70 || // A-F
    V >= 97 && V <= 102;
  }
  function J(R) {
    return ce(R, ne);
  }
  function me(R) {
    let V = "", ge = "";
    for (; V = ie(R); )
      ge += V;
    return ge;
  }
  function xe(R) {
    w(R);
    const V = R.currentChar();
    return V !== "%" && p(tt.EXPECTED_TOKEN, a(), 0, V), R.next(), "%";
  }
  function U(R) {
    let V = "";
    for (; ; ) {
      const ge = R.currentChar();
      if (ge === "{" || ge === "}" || ge === "@" || ge === "|" || !ge)
        break;
      if (ge === "%")
        if (te(R))
          V += ge, R.next();
        else
          break;
      else if (ge === Ji || ge === hr)
        if (te(R))
          V += ge, R.next();
        else {
          if (X(R))
            break;
          V += ge, R.next();
        }
      else
        V += ge, R.next();
    }
    return V;
  }
  function $(R) {
    w(R);
    let V = "", ge = "";
    for (; V = y(R); )
      ge += V;
    return R.currentChar() === Ca && p(tt.UNTERMINATED_CLOSING_BRACE, a(), 0), ge;
  }
  function Y(R) {
    w(R);
    let V = "";
    return R.currentChar() === "-" ? (R.next(), V += `-${me(R)}`) : V += me(R), R.currentChar() === Ca && p(tt.UNTERMINATED_CLOSING_BRACE, a(), 0), V;
  }
  function Re(R) {
    return R !== pw && R !== hr;
  }
  function it(R) {
    w(R), v(R, "'");
    let V = "", ge = "";
    for (; V = ce(R, Re); )
      V === "\\" ? ge += He(R) : ge += V;
    const Fe = R.currentChar();
    return Fe === hr || Fe === Ca ? (p(tt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), Fe === hr && (R.next(), v(R, "'")), ge) : (v(R, "'"), ge);
  }
  function He(R) {
    const V = R.currentChar();
    switch (V) {
      case "\\":
      case "'":
        return R.next(), `\\${V}`;
      case "u":
        return Vt(R, V, 4);
      case "U":
        return Vt(R, V, 6);
      default:
        return p(tt.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, V), "";
    }
  }
  function Vt(R, V, ge) {
    v(R, V);
    let Fe = "";
    for (let Pt = 0; Pt < ge; Pt++) {
      const mt = J(R);
      if (!mt) {
        p(tt.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${V}${Fe}${R.currentChar()}`);
        break;
      }
      Fe += mt;
    }
    return `\\${V}${Fe}`;
  }
  function Bt(R) {
    return R !== "{" && R !== "}" && R !== Ji && R !== hr;
  }
  function Be(R) {
    w(R);
    let V = "", ge = "";
    for (; V = ce(R, Bt); )
      ge += V;
    return ge;
  }
  function Xe(R) {
    let V = "", ge = "";
    for (; V = G(R); )
      ge += V;
    return ge;
  }
  function ue(R) {
    const V = (ge) => {
      const Fe = R.currentChar();
      return Fe === "{" || Fe === "%" || Fe === "@" || Fe === "|" || Fe === "(" || Fe === ")" || !Fe || Fe === Ji ? ge : (ge += Fe, R.next(), V(ge));
    };
    return V("");
  }
  function Ce(R) {
    w(R);
    const V = v(
      R,
      "|"
      /* TokenChars.Pipe */
    );
    return w(R), V;
  }
  function Pr(R, V) {
    let ge = null;
    switch (R.currentChar()) {
      case "{":
        return V.braceNest >= 1 && p(tt.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), R.next(), ge = m(
          V,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), w(R), V.braceNest++, ge;
      case "}":
        return V.braceNest > 0 && V.currentType === 2 && p(tt.EMPTY_PLACEHOLDER, a(), 0), R.next(), ge = m(
          V,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), V.braceNest--, V.braceNest > 0 && w(R), V.inLinked && V.braceNest === 0 && (V.inLinked = !1), ge;
      case "@":
        return V.braceNest > 0 && p(tt.UNTERMINATED_CLOSING_BRACE, a(), 0), ge = qt(R, V) || g(V), V.braceNest = 0, ge;
      default: {
        let Pt = !0, mt = !0, wt = !0;
        if (X(R))
          return V.braceNest > 0 && p(tt.UNTERMINATED_CLOSING_BRACE, a(), 0), ge = m(V, 1, Ce(R)), V.braceNest = 0, V.inLinked = !1, ge;
        if (V.braceNest > 0 && (V.currentType === 5 || V.currentType === 6 || V.currentType === 7))
          return p(tt.UNTERMINATED_CLOSING_BRACE, a(), 0), V.braceNest = 0, yr(R, V);
        if (Pt = x(R, V))
          return ge = m(V, 5, $(R)), w(R), ge;
        if (mt = O(R, V))
          return ge = m(V, 6, Y(R)), w(R), ge;
        if (wt = C(R, V))
          return ge = m(V, 7, it(R)), w(R), ge;
        if (!Pt && !mt && !wt)
          return ge = m(V, 13, Be(R)), p(tt.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, ge.value), w(R), ge;
        break;
      }
    }
    return ge;
  }
  function qt(R, V) {
    const { currentType: ge } = V;
    let Fe = null;
    const Pt = R.currentChar();
    switch ((ge === 8 || ge === 9 || ge === 12 || ge === 10) && (Pt === hr || Pt === Ji) && p(tt.INVALID_LINKED_FORMAT, a(), 0), Pt) {
      case "@":
        return R.next(), Fe = m(
          V,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), V.inLinked = !0, Fe;
      case ".":
        return w(R), R.next(), m(
          V,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return w(R), R.next(), m(
          V,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return X(R) ? (Fe = m(V, 1, Ce(R)), V.braceNest = 0, V.inLinked = !1, Fe) : P(R, V) || M(R, V) ? (w(R), qt(R, V)) : k(R, V) ? (w(R), m(V, 12, Xe(R))) : N(R, V) ? (w(R), Pt === "{" ? Pr(R, V) || Fe : m(V, 11, ue(R))) : (ge === 8 && p(tt.INVALID_LINKED_FORMAT, a(), 0), V.braceNest = 0, V.inLinked = !1, yr(R, V));
    }
  }
  function yr(R, V) {
    let ge = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (V.braceNest > 0)
      return Pr(R, V) || g(V);
    if (V.inLinked)
      return qt(R, V) || g(V);
    switch (R.currentChar()) {
      case "{":
        return Pr(R, V) || g(V);
      case "}":
        return p(tt.UNBALANCED_CLOSING_BRACE, a(), 0), R.next(), m(
          V,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return qt(R, V) || g(V);
      default: {
        if (X(R))
          return ge = m(V, 1, Ce(R)), V.braceNest = 0, V.inLinked = !1, ge;
        const { isModulo: Pt, hasSpace: mt } = Z(R);
        if (Pt)
          return mt ? m(V, 0, U(R)) : m(V, 4, xe(R));
        if (te(R))
          return m(V, 0, U(R));
        break;
      }
    }
    return ge;
  }
  function Mr() {
    const { currentType: R, offset: V, startLoc: ge, endLoc: Fe } = u;
    return u.lastType = R, u.lastOffset = V, u.lastStartLoc = ge, u.lastEndLoc = Fe, u.offset = i(), u.startLoc = a(), r.currentChar() === Ca ? m(
      u,
      14
      /* TokenTypes.EOF */
    ) : yr(r, u);
  }
  return {
    nextToken: Mr,
    currentOffset: i,
    currentPosition: a,
    context: d
  };
}
const Jq = "parser", eK = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function tK(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function nK(e = {}) {
  const t = e.location !== !1, { onError: n, onWarn: r } = e;
  function i(x, O, C, P, ...k) {
    const M = x.currentPosition();
    if (M.offset += P, M.column += P, n) {
      const N = t ? Td(C, M) : null, X = js(O, N, {
        domain: Jq,
        args: k
      });
      n(X);
    }
  }
  function a(x, O, C, P, ...k) {
    const M = x.currentPosition();
    if (M.offset += P, M.column += P, r) {
      const N = t ? Td(C, M) : null;
      r(Uq(O, N, k));
    }
  }
  function o(x, O, C) {
    const P = { type: x };
    return t && (P.start = O, P.end = O, P.loc = { start: C, end: C }), P;
  }
  function s(x, O, C, P) {
    t && (x.end = O, x.loc && (x.loc.end = C));
  }
  function u(x, O) {
    const C = x.context(), P = o(3, C.offset, C.startLoc);
    return P.value = O, s(P, x.currentOffset(), x.currentPosition()), P;
  }
  function d(x, O) {
    const C = x.context(), { lastOffset: P, lastStartLoc: k } = C, M = o(5, P, k);
    return M.index = parseInt(O, 10), x.nextToken(), s(M, x.currentOffset(), x.currentPosition()), M;
  }
  function f(x, O, C) {
    const P = x.context(), { lastOffset: k, lastStartLoc: M } = P, N = o(4, k, M);
    return N.key = O, C === !0 && (N.modulo = !0), x.nextToken(), s(N, x.currentOffset(), x.currentPosition()), N;
  }
  function p(x, O) {
    const C = x.context(), { lastOffset: P, lastStartLoc: k } = C, M = o(9, P, k);
    return M.value = O.replace(eK, tK), x.nextToken(), s(M, x.currentOffset(), x.currentPosition()), M;
  }
  function m(x) {
    const O = x.nextToken(), C = x.context(), { lastOffset: P, lastStartLoc: k } = C, M = o(8, P, k);
    return O.type !== 12 ? (i(x, tt.UNEXPECTED_EMPTY_LINKED_MODIFIER, C.lastStartLoc, 0), M.value = "", s(M, P, k), {
      nextConsumeToken: O,
      node: M
    }) : (O.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, mi(O)), M.value = O.value || "", s(M, x.currentOffset(), x.currentPosition()), {
      node: M
    });
  }
  function g(x, O) {
    const C = x.context(), P = o(7, C.offset, C.startLoc);
    return P.value = O, s(P, x.currentOffset(), x.currentPosition()), P;
  }
  function v(x) {
    const O = x.context(), C = o(6, O.offset, O.startLoc);
    let P = x.nextToken();
    if (P.type === 9) {
      const k = m(x);
      C.modifier = k.node, P = k.nextConsumeToken || x.nextToken();
    }
    switch (P.type !== 10 && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(P)), P = x.nextToken(), P.type === 2 && (P = x.nextToken()), P.type) {
      case 11:
        P.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(P)), C.key = g(x, P.value || "");
        break;
      case 5:
        P.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(P)), C.key = f(x, P.value || "");
        break;
      case 6:
        P.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(P)), C.key = d(x, P.value || "");
        break;
      case 7:
        P.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(P)), C.key = p(x, P.value || "");
        break;
      default: {
        i(x, tt.UNEXPECTED_EMPTY_LINKED_KEY, O.lastStartLoc, 0);
        const k = x.context(), M = o(7, k.offset, k.startLoc);
        return M.value = "", s(M, k.offset, k.startLoc), C.key = M, s(C, k.offset, k.startLoc), {
          nextConsumeToken: P,
          node: C
        };
      }
    }
    return s(C, x.currentOffset(), x.currentPosition()), {
      node: C
    };
  }
  function b(x) {
    const O = x.context(), C = O.currentType === 1 ? x.currentOffset() : O.offset, P = O.currentType === 1 ? O.endLoc : O.startLoc, k = o(2, C, P);
    k.items = [];
    let M = null, N = null;
    do {
      const te = M || x.nextToken();
      switch (M = null, te.type) {
        case 0:
          te.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(te)), k.items.push(u(x, te.value || ""));
          break;
        case 6:
          te.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(te)), k.items.push(d(x, te.value || ""));
          break;
        case 4:
          N = !0;
          break;
        case 5:
          te.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(te)), k.items.push(f(x, te.value || "", !!N)), N && (a(x, rf.USE_MODULO_SYNTAX, O.lastStartLoc, 0, mi(te)), N = null);
          break;
        case 7:
          te.value == null && i(x, tt.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, mi(te)), k.items.push(p(x, te.value || ""));
          break;
        case 8: {
          const ce = v(x);
          k.items.push(ce.node), M = ce.nextConsumeToken || null;
          break;
        }
      }
    } while (O.currentType !== 14 && O.currentType !== 1);
    const X = O.currentType === 1 ? O.lastOffset : x.currentOffset(), Z = O.currentType === 1 ? O.lastEndLoc : x.currentPosition();
    return s(k, X, Z), k;
  }
  function w(x, O, C, P) {
    const k = x.context();
    let M = P.items.length === 0;
    const N = o(1, O, C);
    N.cases = [], N.cases.push(P);
    do {
      const X = b(x);
      M || (M = X.items.length === 0), N.cases.push(X);
    } while (k.currentType !== 14);
    return M && i(x, tt.MUST_HAVE_MESSAGES_IN_PLURAL, C, 0), s(N, x.currentOffset(), x.currentPosition()), N;
  }
  function T(x) {
    const O = x.context(), { offset: C, startLoc: P } = O, k = b(x);
    return O.currentType === 14 ? k : w(x, C, P, k);
  }
  function S(x) {
    const O = Qq(x, qk({}, e)), C = O.context(), P = o(0, C.offset, C.startLoc);
    return t && P.loc && (P.loc.source = x), P.body = T(O), e.onCacheKey && (P.cacheKey = e.onCacheKey(x)), C.currentType !== 14 && i(O, tt.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, x[C.offset] || ""), s(P, O.currentOffset(), O.currentPosition()), P;
  }
  return { parse: S };
}
function mi(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function rK(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function mw(e, t) {
  for (let n = 0; n < e.length; n++)
    Mg(e[n], t);
}
function Mg(e, t) {
  switch (e.type) {
    case 1:
      mw(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      mw(e.items, t);
      break;
    case 6: {
      Mg(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function iK(e, t = {}) {
  const n = rK(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Mg(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function aK(e) {
  const t = e.body;
  return t.type === 2 ? gw(t) : t.cases.forEach((n) => gw(n)), e;
}
function gw(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = Kk(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const oK = "minifier";
function ms(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      ms(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        ms(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        ms(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      ms(t.key), t.k = t.key, delete t.key, t.modifier && (ms(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw js(tt.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: oK,
        args: [e.type]
      });
  }
  delete e.type;
}
const sK = "parser";
function lK(e, t) {
  const { sourceMap: n, filename: r, breakLineCode: i, needIndent: a } = t, o = t.location !== !1, s = {
    filename: r,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: i,
    needIndent: a,
    indentLevel: 0
  };
  o && e.loc && (s.source = e.loc.source);
  const u = () => s;
  function d(w, T) {
    s.code += w;
  }
  function f(w, T = !0) {
    const S = T ? i : "";
    d(a ? S + "  ".repeat(w) : S);
  }
  function p(w = !0) {
    const T = ++s.indentLevel;
    w && f(T);
  }
  function m(w = !0) {
    const T = --s.indentLevel;
    w && f(T);
  }
  function g() {
    f(s.indentLevel);
  }
  return {
    context: u,
    push: d,
    indent: p,
    deindent: m,
    newline: g,
    helper: (w) => `_${w}`,
    needIndent: () => s.needIndent
  };
}
function uK(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Rs(e, t.key), t.modifier ? (e.push(", "), Rs(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function cK(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const i = t.items.length;
  for (let a = 0; a < i && (Rs(e, t.items[a]), a !== i - 1); a++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function dK(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const i = t.cases.length;
    for (let a = 0; a < i && (Rs(e, t.cases[a]), a !== i - 1); a++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function fK(e, t) {
  t.body ? Rs(e, t.body) : e.push("null");
}
function Rs(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      fK(e, t);
      break;
    case 1:
      dK(e, t);
      break;
    case 2:
      cK(e, t);
      break;
    case 6:
      uK(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw js(tt.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: sK,
        args: [t.type]
      });
  }
}
const hK = (e, t = {}) => {
  const n = hw(t.mode) ? t.mode : "normal", r = hw(t.filename) ? t.filename : "message.intl", i = !!t.sourceMap, a = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : n !== "arrow", s = e.helpers || [], u = lK(e, {
    mode: n,
    filename: r,
    sourceMap: i,
    breakLineCode: a,
    needIndent: o
  });
  u.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), u.indent(o), s.length > 0 && (u.push(`const { ${Kk(s.map((p) => `${p}: _${p}`), ", ")} } = ctx`), u.newline()), u.push("return "), Rs(u, e), u.deindent(o), u.push("}"), delete e.helpers;
  const { code: d, map: f } = u.context();
  return {
    ast: e,
    code: d,
    map: f ? f.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function pK(e, t = {}) {
  const n = qk({}, t), r = !!n.jit, i = !!n.minify, a = n.optimize == null ? !0 : n.optimize, s = nK(n).parse(e);
  return r ? (a && aK(s), i && ms(s), { ast: s, code: "" }) : (iK(s, n), hK(s, n));
}
/*!
  * core-base v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function mK() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (la().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (la().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (la().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const eo = [];
eo[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
eo[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
eo[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
eo[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
eo[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
eo[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
eo[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const gK = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function vK(e) {
  return gK.test(e);
}
function _K(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function yK(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function bK(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : vK(t) ? _K(t) : "*" + t;
}
function wK(e) {
  const t = [];
  let n = -1, r = 0, i = 0, a, o, s, u, d, f, p;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = s : o += s;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (t.push(o), o = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), i++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, r = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (i = 0, o === void 0 || (o = bK(o), o === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function g() {
    const v = e[n + 1];
    if (r === 5 && v === "'" || r === 6 && v === '"')
      return n++, s = "\\" + v, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = e[n], !(a === "\\" && g())) {
      if (u = yK(a), p = eo[r], d = p[u] || p.l || 8, d === 8 || (r = d[0], d[1] !== void 0 && (f = m[d[1]], f && (s = a, f() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const vw = /* @__PURE__ */ new Map();
function xK(e, t) {
  return Et(e) ? e[t] : null;
}
function EK(e, t) {
  if (!Et(e))
    return null;
  let n = vw.get(t);
  if (n || (n = wK(t), n && vw.set(t, n)), !n)
    return null;
  const r = n.length;
  let i = e, a = 0;
  for (; a < r; ) {
    const o = i[n[a]];
    if (o === void 0 || Yt(i))
      return null;
    i = o, a++;
  }
  return i;
}
const TK = (e) => e, kK = (e) => "", SK = "text", OK = (e) => e.length === 0 ? "" : Lq(e), CK = Nq;
function _w(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function AK(e) {
  const t = En(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (En(e.named.count) || En(e.named.n)) ? En(e.named.count) ? e.named.count : En(e.named.n) ? e.named.n : t : t;
}
function DK(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function PK(e = {}) {
  const t = e.locale, n = AK(e), r = Et(e.pluralRules) && Te(t) && Yt(e.pluralRules[t]) ? e.pluralRules[t] : _w, i = Et(e.pluralRules) && Te(t) && Yt(e.pluralRules[t]) ? _w : void 0, a = (T) => T[r(n, T.length, i)], o = e.list || [], s = (T) => o[T], u = e.named || Gt();
  En(e.pluralIndex) && DK(n, u);
  const d = (T) => u[T];
  function f(T) {
    const S = Yt(e.messages) ? e.messages(T) : Et(e.messages) ? e.messages[T] : !1;
    return S || (e.parent ? e.parent.message(T) : kK);
  }
  const p = (T) => e.modifiers ? e.modifiers[T] : TK, m = rt(e.processor) && Yt(e.processor.normalize) ? e.processor.normalize : OK, g = rt(e.processor) && Yt(e.processor.interpolate) ? e.processor.interpolate : CK, v = rt(e.processor) && Te(e.processor.type) ? e.processor.type : SK, w = {
    list: s,
    named: d,
    plural: a,
    linked: (T, ...S) => {
      const [x, O] = S;
      let C = "text", P = "";
      S.length === 1 ? Et(x) ? (P = x.modifier || P, C = x.type || C) : Te(x) && (P = x || P) : S.length === 2 && (Te(x) && (P = x || P), Te(O) && (C = O || C));
      const k = f(T)(w), M = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        C === "vnode" && Jt(k) && P ? k[0] : k
      );
      return P ? p(P)(M, C) : M;
    },
    message: f,
    type: v,
    interpolate: g,
    normalize: m,
    values: Gn(Gt(), o, u)
  };
  return w;
}
let nu = null;
function MK(e) {
  nu = e;
}
function IK(e, t, n) {
  nu && nu.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const NK = /* @__PURE__ */ LK(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function LK(e) {
  return (t) => nu && nu.emit(e, t);
}
const Xk = rf.__EXTEND_POINT__, go = nf(Xk), pr = {
  NOT_FOUND_KEY: Xk,
  // 2
  FALLBACK_TO_TRANSLATE: go(),
  // 3
  CANNOT_FORMAT_NUMBER: go(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: go(),
  // 5
  CANNOT_FORMAT_DATE: go(),
  // 6
  FALLBACK_TO_DATE_FORMAT: go(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: go(),
  // 8
  __EXTEND_POINT__: go()
  // 9
}, RK = {
  [pr.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [pr.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [pr.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [pr.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [pr.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [pr.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [pr.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Vo(e, ...t) {
  return Dg(RK[e], ...t);
}
const Zk = tt.__EXTEND_POINT__, vo = nf(Zk), $n = {
  INVALID_ARGUMENT: Zk,
  // 17
  INVALID_DATE_ARGUMENT: vo(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: vo(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: vo(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: vo(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: vo(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: vo(),
  // 23
  __EXTEND_POINT__: vo()
  // 24
};
function Ii(e) {
  return js(e, null, process.env.NODE_ENV !== "production" ? { messages: FK } : void 0);
}
const FK = {
  [$n.INVALID_ARGUMENT]: "Invalid arguments",
  [$n.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [$n.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [$n.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [$n.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [$n.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [$n.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Ig(e, t) {
  return t.locale != null ? yw(t.locale) : yw(e.locale);
}
let ip;
function yw(e) {
  if (Te(e))
    return e;
  if (Yt(e)) {
    if (e.resolvedOnce && ip != null)
      return ip;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Iq(t))
        throw Ii($n.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return ip = t;
    } else
      throw Ii($n.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Ii($n.NOT_SUPPORT_LOCALE_TYPE);
}
function $K(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Jt(t) ? t : Et(t) ? Object.keys(t) : Te(t) ? [t] : [n]
  ])];
}
function Qk(e, t, n) {
  const r = Te(n) ? n : Fs, i = e;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let a = i.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let o = [n];
    for (; Jt(o); )
      o = bw(a, o, t);
    const s = Jt(t) || !rt(t) ? t : t.default ? t.default : null;
    o = Te(s) ? [s] : s, Jt(o) && bw(a, o, !1), i.__localeChainCache.set(r, a);
  }
  return a;
}
function bw(e, t, n) {
  let r = !0;
  for (let i = 0; i < t.length && dt(r); i++) {
    const a = t[i];
    Te(a) && (r = VK(e, t[i], n));
  }
  return r;
}
function VK(e, t, n) {
  let r;
  const i = t.split("-");
  do {
    const a = i.join("-");
    r = BK(e, a, n), i.splice(-1, 1);
  } while (i.length && r === !0);
  return r;
}
function BK(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const i = t.replace(/!/g, "");
    e.push(i), (Jt(n) || rt(n)) && n[i] && (r = n[i]);
  }
  return r;
}
const UK = "9.14.2", af = -1, Fs = "en-US", kd = "", ww = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function WK() {
  return {
    upper: (e, t) => t === "text" && Te(e) ? e.toUpperCase() : t === "vnode" && Et(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && Te(e) ? e.toLowerCase() : t === "vnode" && Et(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && Te(e) ? ww(e) : t === "vnode" && Et(e) && "__v_isVNode" in e ? ww(e.children) : e
  };
}
let Jk;
function xw(e) {
  Jk = e;
}
let eS;
function HK(e) {
  eS = e;
}
let tS;
function jK(e) {
  tS = e;
}
let nS = null;
const YK = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  nS = e;
}, zK = /* @__NO_SIDE_EFFECTS__ */ () => nS;
let rS = null;
const Ew = (e) => {
  rS = e;
}, GK = () => rS;
let Tw = 0;
function qK(e = {}) {
  const t = Yt(e.onWarn) ? e.onWarn : Ln, n = Te(e.version) ? e.version : UK, r = Te(e.locale) || Yt(e.locale) ? e.locale : Fs, i = Yt(r) ? Fs : r, a = Jt(e.fallbackLocale) || rt(e.fallbackLocale) || Te(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i, o = rt(e.messages) ? e.messages : ap(i), s = rt(e.datetimeFormats) ? e.datetimeFormats : ap(i), u = rt(e.numberFormats) ? e.numberFormats : ap(i), d = Gn(Gt(), e.modifiers, WK()), f = e.pluralRules || Gt(), p = Yt(e.missing) ? e.missing : null, m = dt(e.missingWarn) || za(e.missingWarn) ? e.missingWarn : !0, g = dt(e.fallbackWarn) || za(e.fallbackWarn) ? e.fallbackWarn : !0, v = !!e.fallbackFormat, b = !!e.unresolving, w = Yt(e.postTranslation) ? e.postTranslation : null, T = rt(e.processor) ? e.processor : null, S = dt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, x = !!e.escapeParameter, O = Yt(e.messageCompiler) ? e.messageCompiler : Jk;
  process.env.NODE_ENV !== "production" && Yt(e.messageCompiler) && zk(Vo(pr.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const C = Yt(e.messageResolver) ? e.messageResolver : eS || xK, P = Yt(e.localeFallbacker) ? e.localeFallbacker : tS || $K, k = Et(e.fallbackContext) ? e.fallbackContext : void 0, M = e, N = Et(M.__datetimeFormatters) ? M.__datetimeFormatters : /* @__PURE__ */ new Map(), X = Et(M.__numberFormatters) ? M.__numberFormatters : /* @__PURE__ */ new Map(), Z = Et(M.__meta) ? M.__meta : {};
  Tw++;
  const te = {
    version: n,
    cid: Tw,
    locale: r,
    fallbackLocale: a,
    messages: o,
    modifiers: d,
    pluralRules: f,
    missing: p,
    missingWarn: m,
    fallbackWarn: g,
    fallbackFormat: v,
    unresolving: b,
    postTranslation: w,
    processor: T,
    warnHtmlMessage: S,
    escapeParameter: x,
    messageCompiler: O,
    messageResolver: C,
    localeFallbacker: P,
    fallbackContext: k,
    onWarn: t,
    __meta: Z
  };
  return te.datetimeFormats = s, te.numberFormats = u, te.__datetimeFormatters = N, te.__numberFormatters = X, process.env.NODE_ENV !== "production" && (te.__v_emitter = M.__v_emitter != null ? M.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && IK(te, n, Z), te;
}
const ap = (e) => ({ [e]: Gt() });
function of(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function iS(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Ng(e, t, n, r, i) {
  const { missing: a, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const s = e.__v_emitter;
    s && s.emit("missing", {
      locale: n,
      key: t,
      type: i,
      groupId: `${i}:${t}`
    });
  }
  if (a !== null) {
    const s = a(e, n, t, i);
    return Te(s) ? s : t;
  } else
    return process.env.NODE_ENV !== "production" && iS(r, t) && o(Vo(pr.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function bl(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function aS(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function KK(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (aS(e, t[r]))
      return !0;
  return !1;
}
function op(e) {
  return (n) => XK(n, e);
}
function XK(e, t) {
  const n = QK(t);
  if (n == null)
    throw ru(
      0
      /* NodeTypes.Resource */
    );
  if (Lg(n) === 1) {
    const a = eX(n);
    return e.plural(a.reduce((o, s) => [
      ...o,
      kw(e, s)
    ], []));
  } else
    return kw(e, n);
}
const ZK = ["b", "body"];
function QK(e) {
  return to(e, ZK);
}
const JK = ["c", "cases"];
function eX(e) {
  return to(e, JK, []);
}
function kw(e, t) {
  const n = nX(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = iX(t).reduce((i, a) => [...i, em(e, a)], []);
    return e.normalize(r);
  }
}
const tX = ["s", "static"];
function nX(e) {
  return to(e, tX);
}
const rX = ["i", "items"];
function iX(e) {
  return to(e, rX, []);
}
function em(e, t) {
  const n = Lg(t);
  switch (n) {
    case 3:
      return jc(t, n);
    case 9:
      return jc(t, n);
    case 4: {
      const r = t;
      if (vi(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (vi(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw ru(n);
    }
    case 5: {
      const r = t;
      if (vi(r, "i") && En(r.i))
        return e.interpolate(e.list(r.i));
      if (vi(r, "index") && En(r.index))
        return e.interpolate(e.list(r.index));
      throw ru(n);
    }
    case 6: {
      const r = t, i = lX(r), a = cX(r);
      return e.linked(em(e, a), i ? em(e, i) : void 0, e.type);
    }
    case 7:
      return jc(t, n);
    case 8:
      return jc(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const aX = ["t", "type"];
function Lg(e) {
  return to(e, aX);
}
const oX = ["v", "value"];
function jc(e, t) {
  const n = to(e, oX);
  if (n)
    return n;
  throw ru(t);
}
const sX = ["m", "modifier"];
function lX(e) {
  return to(e, sX);
}
const uX = ["k", "key"];
function cX(e) {
  const t = to(e, uX);
  if (t)
    return t;
  throw ru(
    6
    /* NodeTypes.Linked */
  );
}
function to(e, t, n) {
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    if (vi(e, i) && e[i] != null)
      return e[i];
  }
  return n;
}
function ru(e) {
  return new Error(`unhandled node type: ${e}`);
}
const dX = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function oS(e, t) {
  t && Yq(e) && Ln(Dg(dX, { source: e }));
}
const sS = (e) => e;
let vs = Gt();
function lS(e) {
  e.code === rf.USE_MODULO_SYNTAX && Ln(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
function Ga(e) {
  return Et(e) && Lg(e) === 0 && (vi(e, "b") || vi(e, "body"));
}
function uS(e, t = {}) {
  let n = !1;
  const r = t.onError || Hq;
  return t.onError = (i) => {
    n = !0, r(i);
  }, { ...pK(e, t), detectError: n };
}
const fX = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!Te(e))
    throw Ii($n.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (t.onWarn = lS);
  {
    const n = dt(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && oS(e, n);
    const i = (t.onCacheKey || sS)(e), a = vs[i];
    if (a)
      return a;
    const { code: o, detectError: s } = uS(e, t), u = new Function(`return ${o}`)();
    return s ? u : vs[i] = u;
  }
};
function hX(e, t) {
  if (process.env.NODE_ENV !== "production" && (t.onWarn = lS), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && Te(e)) {
    const n = dt(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && oS(e, n);
    const i = (t.onCacheKey || sS)(e), a = vs[i];
    if (a)
      return a;
    const { ast: o, detectError: s } = uS(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), u = op(o);
    return s ? u : vs[i] = u;
  } else {
    if (process.env.NODE_ENV !== "production" && !Ga(e))
      return Ln(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = vs[n];
      return r || (vs[n] = op(e));
    } else
      return op(e);
  }
}
const Sw = () => "", oi = (e) => Yt(e);
function Ow(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: i, messageCompiler: a, fallbackLocale: o, messages: s } = e, [u, d] = tm(...t), f = dt(d.missingWarn) ? d.missingWarn : e.missingWarn, p = dt(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, m = dt(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, g = !!d.resolvedMessage, v = Te(d.default) || dt(d.default) ? dt(d.default) ? a ? u : () => u : d.default : n ? a ? u : () => u : "", b = n || v !== "", w = Ig(e, d);
  m && pX(d);
  let [T, S, x] = g ? [
    u,
    w,
    s[w] || Gt()
  ] : cS(e, u, w, o, p, f), O = T, C = u;
  if (!g && !(Te(O) || Ga(O) || oi(O)) && b && (O = v, C = O), !g && (!(Te(O) || Ga(O) || oi(O)) || !Te(S)))
    return i ? af : u;
  if (process.env.NODE_ENV !== "production" && Te(O) && e.messageCompiler == null)
    return Ln(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let P = !1;
  const k = () => {
    P = !0;
  }, M = oi(O) ? O : dS(e, u, S, O, C, k);
  if (P)
    return O;
  const N = _X(e, S, x, d), X = PK(N), Z = mX(e, M, X), te = r ? r(Z, u) : Z;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const ce = {
      timestamp: Date.now(),
      key: Te(u) ? u : oi(O) ? O.key : "",
      locale: S || (oi(O) ? O.locale : ""),
      format: Te(O) ? O : oi(O) ? O.source : "",
      message: te
    };
    ce.meta = Gn({}, e.__meta, /* @__PURE__ */ zK() || {}), NK(ce);
  }
  return te;
}
function pX(e) {
  Jt(e.list) ? e.list = e.list.map((t) => Te(t) ? cw(t) : t) : Et(e.named) && Object.keys(e.named).forEach((t) => {
    Te(e.named[t]) && (e.named[t] = cw(e.named[t]));
  });
}
function cS(e, t, n, r, i, a) {
  const { messages: o, onWarn: s, messageResolver: u, localeFallbacker: d } = e, f = d(e, r, n);
  let p = Gt(), m, g = null, v = n, b = null;
  const w = "translate";
  for (let T = 0; T < f.length; T++) {
    if (m = b = f[T], process.env.NODE_ENV !== "production" && n !== m && !aS(n, m) && of(i, t) && s(Vo(pr.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && n !== m) {
      const C = e.__v_emitter;
      C && C.emit("fallback", {
        type: w,
        key: t,
        from: v,
        to: b,
        groupId: `${w}:${t}`
      });
    }
    p = o[m] || Gt();
    let S = null, x, O;
    if (process.env.NODE_ENV !== "production" && yi && (S = window.performance.now(), x = "intlify-message-resolve-start", O = "intlify-message-resolve-end", jr && jr(x)), (g = u(p, t)) === null && (g = p[t]), process.env.NODE_ENV !== "production" && yi) {
      const C = window.performance.now(), P = e.__v_emitter;
      P && S && g && P.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: g,
        time: C - S,
        groupId: `${w}:${t}`
      }), x && O && jr && $o && (jr(O), $o("intlify message resolve", x, O));
    }
    if (Te(g) || Ga(g) || oi(g))
      break;
    if (!KK(m, f)) {
      const C = Ng(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        a,
        w
      );
      C !== t && (g = C);
    }
    v = b;
  }
  return [g, m, p];
}
function dS(e, t, n, r, i, a) {
  const { messageCompiler: o, warnHtmlMessage: s } = e;
  if (oi(r)) {
    const m = r;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (o == null) {
    const m = () => r;
    return m.locale = n, m.key = t, m;
  }
  let u = null, d, f;
  process.env.NODE_ENV !== "production" && yi && (u = window.performance.now(), d = "intlify-message-compilation-start", f = "intlify-message-compilation-end", jr && jr(d));
  const p = o(r, gX(e, n, i, r, s, a));
  if (process.env.NODE_ENV !== "production" && yi) {
    const m = window.performance.now(), g = e.__v_emitter;
    g && u && g.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: m - u,
      groupId: `translate:${t}`
    }), d && f && jr && $o && (jr(f), $o("intlify message compilation", d, f));
  }
  return p.locale = n, p.key = t, p.source = r, p;
}
function mX(e, t, n) {
  let r = null, i, a;
  process.env.NODE_ENV !== "production" && yi && (r = window.performance.now(), i = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", jr && jr(i));
  const o = t(n);
  if (process.env.NODE_ENV !== "production" && yi) {
    const s = window.performance.now(), u = e.__v_emitter;
    u && r && u.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: s - r,
      groupId: `translate:${t.key}`
    }), i && a && jr && $o && (jr(a), $o("intlify message evaluation", i, a));
  }
  return o;
}
function tm(...e) {
  const [t, n, r] = e, i = Gt();
  if (!Te(t) && !En(t) && !oi(t) && !Ga(t))
    throw Ii($n.INVALID_ARGUMENT);
  const a = En(t) ? String(t) : (oi(t), t);
  return En(n) ? i.plural = n : Te(n) ? i.default = n : rt(n) && !tf(n) ? i.named = n : Jt(n) && (i.list = n), En(r) ? i.plural = r : Te(r) ? i.default = r : rt(r) && Gn(i, r), [a, i];
}
function gX(e, t, n, r, i, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: i,
    onError: (o) => {
      if (a && a(o), process.env.NODE_ENV !== "production") {
        const s = vX(r), u = `Message compilation error: ${o.message}`, d = o.location && s && Rq(s, o.location.start.offset, o.location.end.offset), f = e.__v_emitter;
        f && s && f.emit("compile-error", {
          message: s,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(d ? `${u}
${d}` : u);
      } else
        throw o;
    },
    onCacheKey: (o) => Cq(t, n, o)
  };
}
function vX(e) {
  if (Te(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function _X(e, t, n, r) {
  const { modifiers: i, pluralRules: a, messageResolver: o, fallbackLocale: s, fallbackWarn: u, missingWarn: d, fallbackContext: f } = e, m = {
    locale: t,
    modifiers: i,
    pluralRules: a,
    messages: (g) => {
      let v = o(n, g);
      if (v == null && f) {
        const [, , b] = cS(f, g, t, s, u, d);
        v = o(b, g);
      }
      if (Te(v) || Ga(v)) {
        let b = !1;
        const T = dS(e, g, t, v, g, () => {
          b = !0;
        });
        return b ? Sw : T;
      } else return oi(v) ? v : Sw;
    }
  };
  return e.processor && (m.processor = e.processor), r.list && (m.list = r.list), r.named && (m.named = r.named), En(r.plural) && (m.pluralIndex = r.plural), m;
}
const Cw = typeof Intl < "u", fS = {
  dateTimeFormat: Cw && typeof Intl.DateTimeFormat < "u",
  numberFormat: Cw && typeof Intl.NumberFormat < "u"
};
function Aw(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: i, onWarn: a, localeFallbacker: o } = e, { __datetimeFormatters: s } = e;
  if (process.env.NODE_ENV !== "production" && !fS.dateTimeFormat)
    return a(Vo(pr.CANNOT_FORMAT_DATE)), kd;
  const [u, d, f, p] = nm(...t), m = dt(f.missingWarn) ? f.missingWarn : e.missingWarn, g = dt(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, v = !!f.part, b = Ig(e, f), w = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    b
  );
  if (!Te(u) || u === "")
    return new Intl.DateTimeFormat(b, p).format(d);
  let T = {}, S, x = null, O = b, C = null;
  const P = "datetime format";
  for (let N = 0; N < w.length; N++) {
    if (S = C = w[N], process.env.NODE_ENV !== "production" && b !== S && of(g, u) && a(Vo(pr.FALLBACK_TO_DATE_FORMAT, {
      key: u,
      target: S
    })), process.env.NODE_ENV !== "production" && b !== S) {
      const X = e.__v_emitter;
      X && X.emit("fallback", {
        type: P,
        key: u,
        from: O,
        to: C,
        groupId: `${P}:${u}`
      });
    }
    if (T = n[S] || {}, x = T[u], rt(x))
      break;
    Ng(e, u, S, m, P), O = C;
  }
  if (!rt(x) || !Te(S))
    return r ? af : u;
  let k = `${S}__${u}`;
  tf(p) || (k = `${k}__${JSON.stringify(p)}`);
  let M = s.get(k);
  return M || (M = new Intl.DateTimeFormat(S, Gn({}, x, p)), s.set(k, M)), v ? M.formatToParts(d) : M.format(d);
}
const hS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function nm(...e) {
  const [t, n, r, i] = e, a = Gt();
  let o = Gt(), s;
  if (Te(t)) {
    const u = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!u)
      throw Ii($n.INVALID_ISO_DATE_ARGUMENT);
    const d = u[3] ? u[3].trim().startsWith("T") ? `${u[1].trim()}${u[3].trim()}` : `${u[1].trim()}T${u[3].trim()}` : u[1].trim();
    s = new Date(d);
    try {
      s.toISOString();
    } catch {
      throw Ii($n.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Dq(t)) {
    if (isNaN(t.getTime()))
      throw Ii($n.INVALID_DATE_ARGUMENT);
    s = t;
  } else if (En(t))
    s = t;
  else
    throw Ii($n.INVALID_ARGUMENT);
  return Te(n) ? a.key = n : rt(n) && Object.keys(n).forEach((u) => {
    hS.includes(u) ? o[u] = n[u] : a[u] = n[u];
  }), Te(r) ? a.locale = r : rt(r) && (o = r), rt(i) && (o = i), [a.key || "", s, a, o];
}
function Dw(e, t, n) {
  const r = e;
  for (const i in n) {
    const a = `${t}__${i}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function Pw(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: i, onWarn: a, localeFallbacker: o } = e, { __numberFormatters: s } = e;
  if (process.env.NODE_ENV !== "production" && !fS.numberFormat)
    return a(Vo(pr.CANNOT_FORMAT_NUMBER)), kd;
  const [u, d, f, p] = rm(...t), m = dt(f.missingWarn) ? f.missingWarn : e.missingWarn, g = dt(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, v = !!f.part, b = Ig(e, f), w = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    b
  );
  if (!Te(u) || u === "")
    return new Intl.NumberFormat(b, p).format(d);
  let T = {}, S, x = null, O = b, C = null;
  const P = "number format";
  for (let N = 0; N < w.length; N++) {
    if (S = C = w[N], process.env.NODE_ENV !== "production" && b !== S && of(g, u) && a(Vo(pr.FALLBACK_TO_NUMBER_FORMAT, {
      key: u,
      target: S
    })), process.env.NODE_ENV !== "production" && b !== S) {
      const X = e.__v_emitter;
      X && X.emit("fallback", {
        type: P,
        key: u,
        from: O,
        to: C,
        groupId: `${P}:${u}`
      });
    }
    if (T = n[S] || {}, x = T[u], rt(x))
      break;
    Ng(e, u, S, m, P), O = C;
  }
  if (!rt(x) || !Te(S))
    return r ? af : u;
  let k = `${S}__${u}`;
  tf(p) || (k = `${k}__${JSON.stringify(p)}`);
  let M = s.get(k);
  return M || (M = new Intl.NumberFormat(S, Gn({}, x, p)), s.set(k, M)), v ? M.formatToParts(d) : M.format(d);
}
const pS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function rm(...e) {
  const [t, n, r, i] = e, a = Gt();
  let o = Gt();
  if (!En(t))
    throw Ii($n.INVALID_ARGUMENT);
  const s = t;
  return Te(n) ? a.key = n : rt(n) && Object.keys(n).forEach((u) => {
    pS.includes(u) ? o[u] = n[u] : a[u] = n[u];
  }), Te(r) ? a.locale = r : rt(r) && (o = r), rt(i) && (o = i), [a.key || "", s, a, o];
}
function Mw(e, t, n) {
  const r = e;
  for (const i in n) {
    const a = `${t}__${i}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
mK();
function yX() {
  return mS().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function mS() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const bX = typeof Proxy == "function", wX = "devtools-plugin:setup", xX = "plugin:settings:set";
let ps, im;
function EX() {
  var e;
  return ps !== void 0 || (typeof window < "u" && window.performance ? (ps = !0, im = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (ps = !0, im = globalThis.perf_hooks.performance) : ps = !1), ps;
}
function TX() {
  return EX() ? im.now() : Date.now();
}
class kX {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const r = {};
    if (t.settings)
      for (const o in t.settings) {
        const s = t.settings[o];
        r[o] = s.defaultValue;
      }
    const i = `__vue-devtools-plugin-settings__${t.id}`;
    let a = Object.assign({}, r);
    try {
      const o = localStorage.getItem(i), s = JSON.parse(o);
      Object.assign(a, s);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(o) {
        try {
          localStorage.setItem(i, JSON.stringify(o));
        } catch {
        }
        a = o;
      },
      now() {
        return TX();
      }
    }, n && n.on(xX, (o, s) => {
      o === this.plugin.id && this.fallbacks.setSettings(s);
    }), this.proxiedOn = new Proxy({}, {
      get: (o, s) => this.target ? this.target.on[s] : (...u) => {
        this.onQueue.push({
          method: s,
          args: u
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (o, s) => this.target ? this.target[s] : s === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(s) ? (...u) => (this.targetQueue.push({
        method: s,
        args: u,
        resolve: () => {
        }
      }), this.fallbacks[s](...u)) : (...u) => new Promise((d) => {
        this.targetQueue.push({
          method: s,
          args: u,
          resolve: d
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function SX(e, t) {
  const n = e, r = mS(), i = yX(), a = bX && n.enableEarlyProxy;
  if (i && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    i.emit(wX, e, t);
  else {
    const o = a ? new kX(n, i) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: o
    }), o && t(o.proxiedTarget);
  }
}
/*!
  * vue-i18n v9.14.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const OX = "9.14.2";
function CX() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (la().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (la().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (la().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (la().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (la().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const gS = pr.__EXTEND_POINT__, ea = nf(gS), cn = {
  FALLBACK_TO_ROOT: gS,
  // 9
  NOT_SUPPORTED_PRESERVE: ea(),
  // 10
  NOT_SUPPORTED_FORMATTER: ea(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: ea(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: ea(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: ea(),
  // 14
  NOT_FOUND_PARENT_SCOPE: ea(),
  // 15
  IGNORE_OBJ_FLATTEN: ea(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: ea(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: ea()
  // 18
}, AX = {
  [cn.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [cn.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [cn.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [cn.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [cn.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [cn.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [cn.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [cn.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [cn.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [cn.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function Ar(e, ...t) {
  return Dg(AX[e], ...t);
}
const vS = $n.__EXTEND_POINT__, Tr = nf(vS), Ot = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: vS,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: Tr(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Tr(),
  // 26
  NOT_INSTALLED: Tr(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: Tr(),
  // 28
  // directive module errors
  REQUIRED_VALUE: Tr(),
  // 29
  INVALID_VALUE: Tr(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Tr(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: Tr(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: Tr(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Tr(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Tr(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Tr(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Tr(),
  // 37
  // for enhancement
  __EXTEND_POINT__: Tr()
  // 38
};
function Rn(e, ...t) {
  return js(e, null, process.env.NODE_ENV !== "production" ? { messages: DX, args: t } : void 0);
}
const DX = {
  [Ot.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ot.INVALID_ARGUMENT]: "Invalid argument",
  [Ot.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ot.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Ot.UNEXPECTED_ERROR]: "Unexpected error",
  [Ot.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [Ot.REQUIRED_VALUE]: "Required in value: {0}",
  [Ot.INVALID_VALUE]: "Invalid value",
  [Ot.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ot.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ot.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ot.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [Ot.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [Ot.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, am = /* @__PURE__ */ Ui("__translateVNode"), om = /* @__PURE__ */ Ui("__datetimeParts"), sm = /* @__PURE__ */ Ui("__numberParts"), Bo = /* @__PURE__ */ Ui("__enableEmitter"), iu = /* @__PURE__ */ Ui("__disableEmitter"), _S = Ui("__setPluralRules"), yS = /* @__PURE__ */ Ui("__injectWithOption"), lm = /* @__PURE__ */ Ui("__dispose");
function au(e) {
  if (!Et(e))
    return e;
  for (const t in e)
    if (vi(e, t))
      if (!t.includes("."))
        Et(e[t]) && au(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let i = e, a = !1;
        for (let o = 0; o < r; o++) {
          if (n[o] in i || (i[n[o]] = Gt()), !Et(i[n[o]])) {
            process.env.NODE_ENV !== "production" && Ln(Ar(cn.IGNORE_OBJ_FLATTEN, {
              key: n[o]
            })), a = !0;
            break;
          }
          i = i[n[o]];
        }
        a || (i[n[r]] = e[t], delete e[t]), Et(i[n[r]]) && au(i[n[r]]);
      }
  return e;
}
function sf(e, t) {
  const { messages: n, __i18n: r, messageResolver: i, flatJson: a } = t, o = rt(n) ? n : Jt(r) ? Gt() : { [e]: Gt() };
  if (Jt(r) && r.forEach((s) => {
    if ("locale" in s && "resource" in s) {
      const { locale: u, resource: d } = s;
      u ? (o[u] = o[u] || Gt(), Qc(d, o[u])) : Qc(d, o);
    } else
      Te(s) && Qc(JSON.parse(s), o);
  }), i == null && a)
    for (const s in o)
      vi(o, s) && au(o[s]);
  return o;
}
function bS(e) {
  return e.type;
}
function wS(e, t, n) {
  let r = Et(t.messages) ? t.messages : Gt();
  "__i18nGlobal" in n && (r = sf(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const i = Object.keys(r);
  i.length && i.forEach((a) => {
    e.mergeLocaleMessage(a, r[a]);
  });
  {
    if (Et(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((o) => {
        e.mergeDateTimeFormat(o, t.datetimeFormats[o]);
      });
    }
    if (Et(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((o) => {
        e.mergeNumberFormat(o, t.numberFormats[o]);
      });
    }
  }
}
function Iw(e) {
  return Ae(cI, null, e, 0);
}
const Nw = "__INTLIFY_META__", Lw = () => [], PX = () => !1;
let Rw = 0;
function Fw(e) {
  return (t, n, r, i) => e(n, r, ui() || void 0, i);
}
const MX = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ui();
  let t = null;
  return e && (t = bS(e)[Nw]) ? { [Nw]: t } : null;
};
function Rg(e = {}, t) {
  const { __root: n, __injectWithOption: r } = e, i = n === void 0, a = e.flatJson, o = yi ? fe : su, s = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && s && zk(Ar(cn.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let u = dt(e.inheritLocale) ? e.inheritLocale : !0;
  const d = o(
    // prettier-ignore
    n && u ? n.locale.value : Te(e.locale) ? e.locale : Fs
  ), f = o(
    // prettier-ignore
    n && u ? n.fallbackLocale.value : Te(e.fallbackLocale) || Jt(e.fallbackLocale) || rt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : d.value
  ), p = o(sf(d.value, e)), m = o(rt(e.datetimeFormats) ? e.datetimeFormats : { [d.value]: {} }), g = o(rt(e.numberFormats) ? e.numberFormats : { [d.value]: {} });
  let v = n ? n.missingWarn : dt(e.missingWarn) || za(e.missingWarn) ? e.missingWarn : !0, b = n ? n.fallbackWarn : dt(e.fallbackWarn) || za(e.fallbackWarn) ? e.fallbackWarn : !0, w = n ? n.fallbackRoot : dt(e.fallbackRoot) ? e.fallbackRoot : !0, T = !!e.fallbackFormat, S = Yt(e.missing) ? e.missing : null, x = Yt(e.missing) ? Fw(e.missing) : null, O = Yt(e.postTranslation) ? e.postTranslation : null, C = n ? n.warnHtmlMessage : dt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, P = !!e.escapeParameter;
  const k = n ? n.modifiers : rt(e.modifiers) ? e.modifiers : {};
  let M = e.pluralRules || n && n.pluralRules, N;
  N = (() => {
    i && Ew(null);
    const ae = {
      version: OX,
      locale: d.value,
      fallbackLocale: f.value,
      messages: p.value,
      modifiers: k,
      pluralRules: M,
      missing: x === null ? void 0 : x,
      missingWarn: v,
      fallbackWarn: b,
      fallbackFormat: T,
      unresolving: !0,
      postTranslation: O === null ? void 0 : O,
      warnHtmlMessage: C,
      escapeParameter: P,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    ae.datetimeFormats = m.value, ae.numberFormats = g.value, ae.__datetimeFormatters = rt(N) ? N.__datetimeFormatters : void 0, ae.__numberFormatters = rt(N) ? N.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (ae.__v_emitter = rt(N) ? N.__v_emitter : void 0);
    const _e = qK(ae);
    return i && Ew(_e), _e;
  })(), bl(N, d.value, f.value);
  function Z() {
    return [
      d.value,
      f.value,
      p.value,
      m.value,
      g.value
    ];
  }
  const te = oe({
    get: () => d.value,
    set: (ae) => {
      d.value = ae, N.locale = d.value;
    }
  }), ce = oe({
    get: () => f.value,
    set: (ae) => {
      f.value = ae, N.fallbackLocale = f.value, bl(N, d.value, ae);
    }
  }), we = oe(() => p.value), G = /* @__PURE__ */ oe(() => m.value), Q = /* @__PURE__ */ oe(() => g.value);
  function y() {
    return Yt(O) ? O : null;
  }
  function H(ae) {
    O = ae, N.postTranslation = ae;
  }
  function ie() {
    return S;
  }
  function ne(ae) {
    ae !== null && (x = Fw(ae)), S = ae, N.missing = x;
  }
  function J(ae, _e) {
    return ae !== "translate" || !_e.resolvedMessage;
  }
  const me = (ae, _e, F, se, Pe, Ye) => {
    Z();
    let gt;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, i || (N.fallbackContext = n ? GK() : void 0), gt = ae(N);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, i || (N.fallbackContext = void 0);
    }
    if (F !== "translate exists" && // for not `te` (e.g `t`)
    En(gt) && gt === af || F === "translate exists" && !gt) {
      const [mn, Ir] = _e();
      if (process.env.NODE_ENV !== "production" && n && Te(mn) && J(F, Ir) && (w && (of(b, mn) || iS(v, mn)) && Ln(Ar(cn.FALLBACK_TO_ROOT, {
        key: mn,
        type: F
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: de } = N;
        de && w && de.emit("fallback", {
          type: F,
          key: mn,
          to: "global",
          groupId: `${F}:${mn}`
        });
      }
      return n && w ? se(n) : Pe(mn);
    } else {
      if (Ye(gt))
        return gt;
      throw Rn(Ot.UNEXPECTED_RETURN_TYPE);
    }
  };
  function xe(...ae) {
    return me((_e) => Reflect.apply(Ow, null, [_e, ...ae]), () => tm(...ae), "translate", (_e) => Reflect.apply(_e.t, _e, [...ae]), (_e) => _e, (_e) => Te(_e));
  }
  function U(...ae) {
    const [_e, F, se] = ae;
    if (se && !Et(se))
      throw Rn(Ot.INVALID_ARGUMENT);
    return xe(_e, F, Gn({ resolvedMessage: !0 }, se || {}));
  }
  function $(...ae) {
    return me((_e) => Reflect.apply(Aw, null, [_e, ...ae]), () => nm(...ae), "datetime format", (_e) => Reflect.apply(_e.d, _e, [...ae]), () => kd, (_e) => Te(_e));
  }
  function Y(...ae) {
    return me((_e) => Reflect.apply(Pw, null, [_e, ...ae]), () => rm(...ae), "number format", (_e) => Reflect.apply(_e.n, _e, [...ae]), () => kd, (_e) => Te(_e));
  }
  function Re(ae) {
    return ae.map((_e) => Te(_e) || En(_e) || dt(_e) ? Iw(String(_e)) : _e);
  }
  const He = {
    normalize: Re,
    interpolate: (ae) => ae,
    type: "vnode"
  };
  function Vt(...ae) {
    return me(
      (_e) => {
        let F;
        const se = _e;
        try {
          se.processor = He, F = Reflect.apply(Ow, null, [se, ...ae]);
        } finally {
          se.processor = null;
        }
        return F;
      },
      () => tm(...ae),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (_e) => _e[am](...ae),
      (_e) => [Iw(_e)],
      (_e) => Jt(_e)
    );
  }
  function Bt(...ae) {
    return me(
      (_e) => Reflect.apply(Pw, null, [_e, ...ae]),
      () => rm(...ae),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (_e) => _e[sm](...ae),
      Lw,
      (_e) => Te(_e) || Jt(_e)
    );
  }
  function Be(...ae) {
    return me(
      (_e) => Reflect.apply(Aw, null, [_e, ...ae]),
      () => nm(...ae),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (_e) => _e[om](...ae),
      Lw,
      (_e) => Te(_e) || Jt(_e)
    );
  }
  function Xe(ae) {
    M = ae, N.pluralRules = M;
  }
  function ue(ae, _e) {
    return me(() => {
      if (!ae)
        return !1;
      const F = Te(_e) ? _e : d.value, se = qt(F), Pe = N.messageResolver(se, ae);
      return s ? Pe != null : Ga(Pe) || oi(Pe) || Te(Pe);
    }, () => [ae], "translate exists", (F) => Reflect.apply(F.te, F, [ae, _e]), PX, (F) => dt(F));
  }
  function Ce(ae) {
    let _e = null;
    const F = Qk(N, f.value, d.value);
    for (let se = 0; se < F.length; se++) {
      const Pe = p.value[F[se]] || {}, Ye = N.messageResolver(Pe, ae);
      if (Ye != null) {
        _e = Ye;
        break;
      }
    }
    return _e;
  }
  function Pr(ae) {
    const _e = Ce(ae);
    return _e ?? (n ? n.tm(ae) || {} : {});
  }
  function qt(ae) {
    return p.value[ae] || {};
  }
  function yr(ae, _e) {
    if (a) {
      const F = { [ae]: _e };
      for (const se in F)
        vi(F, se) && au(F[se]);
      _e = F[ae];
    }
    p.value[ae] = _e, N.messages = p.value;
  }
  function Mr(ae, _e) {
    p.value[ae] = p.value[ae] || {};
    const F = { [ae]: _e };
    if (a)
      for (const se in F)
        vi(F, se) && au(F[se]);
    _e = F[ae], Qc(_e, p.value[ae]), N.messages = p.value;
  }
  function R(ae) {
    return m.value[ae] || {};
  }
  function V(ae, _e) {
    m.value[ae] = _e, N.datetimeFormats = m.value, Dw(N, ae, _e);
  }
  function ge(ae, _e) {
    m.value[ae] = Gn(m.value[ae] || {}, _e), N.datetimeFormats = m.value, Dw(N, ae, _e);
  }
  function Fe(ae) {
    return g.value[ae] || {};
  }
  function Pt(ae, _e) {
    g.value[ae] = _e, N.numberFormats = g.value, Mw(N, ae, _e);
  }
  function mt(ae, _e) {
    g.value[ae] = Gn(g.value[ae] || {}, _e), N.numberFormats = g.value, Mw(N, ae, _e);
  }
  Rw++, n && yi && (dn(n.locale, (ae) => {
    u && (d.value = ae, N.locale = ae, bl(N, d.value, f.value));
  }), dn(n.fallbackLocale, (ae) => {
    u && (f.value = ae, N.fallbackLocale = ae, bl(N, d.value, f.value));
  }));
  const wt = {
    id: Rw,
    locale: te,
    fallbackLocale: ce,
    get inheritLocale() {
      return u;
    },
    set inheritLocale(ae) {
      u = ae, ae && n && (d.value = n.locale.value, f.value = n.fallbackLocale.value, bl(N, d.value, f.value));
    },
    get availableLocales() {
      return Object.keys(p.value).sort();
    },
    messages: we,
    get modifiers() {
      return k;
    },
    get pluralRules() {
      return M || {};
    },
    get isGlobal() {
      return i;
    },
    get missingWarn() {
      return v;
    },
    set missingWarn(ae) {
      v = ae, N.missingWarn = v;
    },
    get fallbackWarn() {
      return b;
    },
    set fallbackWarn(ae) {
      b = ae, N.fallbackWarn = b;
    },
    get fallbackRoot() {
      return w;
    },
    set fallbackRoot(ae) {
      w = ae;
    },
    get fallbackFormat() {
      return T;
    },
    set fallbackFormat(ae) {
      T = ae, N.fallbackFormat = T;
    },
    get warnHtmlMessage() {
      return C;
    },
    set warnHtmlMessage(ae) {
      C = ae, N.warnHtmlMessage = ae;
    },
    get escapeParameter() {
      return P;
    },
    set escapeParameter(ae) {
      P = ae, N.escapeParameter = ae;
    },
    t: xe,
    getLocaleMessage: qt,
    setLocaleMessage: yr,
    mergeLocaleMessage: Mr,
    getPostTranslationHandler: y,
    setPostTranslationHandler: H,
    getMissingHandler: ie,
    setMissingHandler: ne,
    [_S]: Xe
  };
  return wt.datetimeFormats = G, wt.numberFormats = Q, wt.rt = U, wt.te = ue, wt.tm = Pr, wt.d = $, wt.n = Y, wt.getDateTimeFormat = R, wt.setDateTimeFormat = V, wt.mergeDateTimeFormat = ge, wt.getNumberFormat = Fe, wt.setNumberFormat = Pt, wt.mergeNumberFormat = mt, wt[yS] = r, wt[am] = Vt, wt[om] = Be, wt[sm] = Bt, process.env.NODE_ENV !== "production" && (wt[Bo] = (ae) => {
    N.__v_emitter = ae;
  }, wt[iu] = () => {
    N.__v_emitter = void 0;
  }), wt;
}
function IX(e) {
  const t = Te(e.locale) ? e.locale : Fs, n = Te(e.fallbackLocale) || Jt(e.fallbackLocale) || rt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : t, r = Yt(e.missing) ? e.missing : void 0, i = dt(e.silentTranslationWarn) || za(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, a = dt(e.silentFallbackWarn) || za(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, o = dt(e.fallbackRoot) ? e.fallbackRoot : !0, s = !!e.formatFallbackMessages, u = rt(e.modifiers) ? e.modifiers : {}, d = e.pluralizationRules, f = Yt(e.postTranslation) ? e.postTranslation : void 0, p = Te(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, m = !!e.escapeParameterHtml, g = dt(e.sync) ? e.sync : !0;
  process.env.NODE_ENV !== "production" && e.formatter && Ln(Ar(cn.NOT_SUPPORTED_FORMATTER)), process.env.NODE_ENV !== "production" && e.preserveDirectiveContent && Ln(Ar(cn.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
  let v = e.messages;
  if (rt(e.sharedMessages)) {
    const P = e.sharedMessages;
    v = Object.keys(P).reduce((M, N) => {
      const X = M[N] || (M[N] = {});
      return Gn(X, P[N]), M;
    }, v || {});
  }
  const { __i18n: b, __root: w, __injectWithOption: T } = e, S = e.datetimeFormats, x = e.numberFormats, O = e.flatJson, C = e.translateExistCompatible;
  return {
    locale: t,
    fallbackLocale: n,
    messages: v,
    flatJson: O,
    datetimeFormats: S,
    numberFormats: x,
    missing: r,
    missingWarn: i,
    fallbackWarn: a,
    fallbackRoot: o,
    fallbackFormat: s,
    modifiers: u,
    pluralRules: d,
    postTranslation: f,
    warnHtmlMessage: p,
    escapeParameter: m,
    messageResolver: e.messageResolver,
    inheritLocale: g,
    translateExistCompatible: C,
    __i18n: b,
    __root: w,
    __injectWithOption: T
  };
}
function um(e = {}, t) {
  {
    const n = Rg(IX(e)), { __extender: r } = e, i = {
      // id
      id: n.id,
      // locale
      get locale() {
        return n.locale.value;
      },
      set locale(a) {
        n.locale.value = a;
      },
      // fallbackLocale
      get fallbackLocale() {
        return n.fallbackLocale.value;
      },
      set fallbackLocale(a) {
        n.fallbackLocale.value = a;
      },
      // messages
      get messages() {
        return n.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return n.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return n.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return n.availableLocales;
      },
      // formatter
      get formatter() {
        return process.env.NODE_ENV !== "production" && Ln(Ar(cn.NOT_SUPPORTED_FORMATTER)), {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(a) {
        process.env.NODE_ENV !== "production" && Ln(Ar(cn.NOT_SUPPORTED_FORMATTER));
      },
      // missing
      get missing() {
        return n.getMissingHandler();
      },
      set missing(a) {
        n.setMissingHandler(a);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return dt(n.missingWarn) ? !n.missingWarn : n.missingWarn;
      },
      set silentTranslationWarn(a) {
        n.missingWarn = dt(a) ? !a : a;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return dt(n.fallbackWarn) ? !n.fallbackWarn : n.fallbackWarn;
      },
      set silentFallbackWarn(a) {
        n.fallbackWarn = dt(a) ? !a : a;
      },
      // modifiers
      get modifiers() {
        return n.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return n.fallbackFormat;
      },
      set formatFallbackMessages(a) {
        n.fallbackFormat = a;
      },
      // postTranslation
      get postTranslation() {
        return n.getPostTranslationHandler();
      },
      set postTranslation(a) {
        n.setPostTranslationHandler(a);
      },
      // sync
      get sync() {
        return n.inheritLocale;
      },
      set sync(a) {
        n.inheritLocale = a;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return n.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(a) {
        n.warnHtmlMessage = a !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return n.escapeParameter;
      },
      set escapeParameterHtml(a) {
        n.escapeParameter = a;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return process.env.NODE_ENV !== "production" && Ln(Ar(cn.NOT_SUPPORTED_PRESERVE_DIRECTIVE)), !0;
      },
      set preserveDirectiveContent(a) {
        process.env.NODE_ENV !== "production" && Ln(Ar(cn.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
      },
      // pluralizationRules
      get pluralizationRules() {
        return n.pluralRules || {};
      },
      // for internal
      __composer: n,
      // t
      t(...a) {
        const [o, s, u] = a, d = {};
        let f = null, p = null;
        if (!Te(o))
          throw Rn(Ot.INVALID_ARGUMENT);
        const m = o;
        return Te(s) ? d.locale = s : Jt(s) ? f = s : rt(s) && (p = s), Jt(u) ? f = u : rt(u) && (p = u), Reflect.apply(n.t, n, [
          m,
          f || p || {},
          d
        ]);
      },
      rt(...a) {
        return Reflect.apply(n.rt, n, [...a]);
      },
      // tc
      tc(...a) {
        const [o, s, u] = a, d = { plural: 1 };
        let f = null, p = null;
        if (!Te(o))
          throw Rn(Ot.INVALID_ARGUMENT);
        const m = o;
        return Te(s) ? d.locale = s : En(s) ? d.plural = s : Jt(s) ? f = s : rt(s) && (p = s), Te(u) ? d.locale = u : Jt(u) ? f = u : rt(u) && (p = u), Reflect.apply(n.t, n, [
          m,
          f || p || {},
          d
        ]);
      },
      // te
      te(a, o) {
        return n.te(a, o);
      },
      // tm
      tm(a) {
        return n.tm(a);
      },
      // getLocaleMessage
      getLocaleMessage(a) {
        return n.getLocaleMessage(a);
      },
      // setLocaleMessage
      setLocaleMessage(a, o) {
        n.setLocaleMessage(a, o);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(a, o) {
        n.mergeLocaleMessage(a, o);
      },
      // d
      d(...a) {
        return Reflect.apply(n.d, n, [...a]);
      },
      // getDateTimeFormat
      getDateTimeFormat(a) {
        return n.getDateTimeFormat(a);
      },
      // setDateTimeFormat
      setDateTimeFormat(a, o) {
        n.setDateTimeFormat(a, o);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(a, o) {
        n.mergeDateTimeFormat(a, o);
      },
      // n
      n(...a) {
        return Reflect.apply(n.n, n, [...a]);
      },
      // getNumberFormat
      getNumberFormat(a) {
        return n.getNumberFormat(a);
      },
      // setNumberFormat
      setNumberFormat(a, o) {
        n.setNumberFormat(a, o);
      },
      // mergeNumberFormat
      mergeNumberFormat(a, o) {
        n.mergeNumberFormat(a, o);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(a, o) {
        return process.env.NODE_ENV !== "production" && Ln(Ar(cn.NOT_SUPPORTED_GET_CHOICE_INDEX)), -1;
      }
    };
    return i.__extender = r, process.env.NODE_ENV !== "production" && (i.__enableEmitter = (a) => {
      const o = n;
      o[Bo] && o[Bo](a);
    }, i.__disableEmitter = () => {
      const a = n;
      a[iu] && a[iu]();
    }), i;
  }
}
const Fg = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function NX({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, i) => [
    ...r,
    // prettier-ignore
    ...i.type === Ge ? i.children : [i]
  ], []) : t.reduce((n, r) => {
    const i = e[r];
    return i && (n[r] = i()), n;
  }, Gt());
}
function xS(e) {
  return Ge;
}
const LX = /* @__PURE__ */ Tt({
  /* eslint-disable */
  name: "i18n-t",
  props: Gn({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => En(e) || !isNaN(e)
    }
  }, Fg),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: r } = t, i = e.i18n || Vg({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const a = Object.keys(n).filter((p) => p !== "_"), o = Gt();
      e.locale && (o.locale = e.locale), e.plural !== void 0 && (o.plural = Te(e.plural) ? +e.plural : e.plural);
      const s = NX(t, a), u = i[am](e.keypath, s, o), d = Gn(Gt(), r), f = Te(e.tag) || Et(e.tag) ? e.tag : xS();
      return Ct(f, d, u);
    };
  }
}), sp = LX;
function RX(e) {
  return Jt(e) && !Te(e[0]);
}
function ES(e, t, n, r) {
  const { slots: i, attrs: a } = t;
  return () => {
    const o = { part: !0 };
    let s = Gt();
    e.locale && (o.locale = e.locale), Te(e.format) ? o.key = e.format : Et(e.format) && (Te(e.format.key) && (o.key = e.format.key), s = Object.keys(e.format).reduce((m, g) => n.includes(g) ? Gn(Gt(), m, { [g]: e.format[g] }) : m, Gt()));
    const u = r(e.value, o, s);
    let d = [o.key];
    Jt(u) ? d = u.map((m, g) => {
      const v = i[m.type], b = v ? v({ [m.type]: m.value, index: g, parts: u }) : [m.value];
      return RX(b) && (b[0].key = `${m.type}-${g}`), b;
    }) : Te(u) && (d = [u]);
    const f = Gn(Gt(), a), p = Te(e.tag) || Et(e.tag) ? e.tag : xS();
    return Ct(p, f, d);
  };
}
const FX = /* @__PURE__ */ Tt({
  /* eslint-disable */
  name: "i18n-n",
  props: Gn({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Fg),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || Vg({
      useScope: e.scope,
      __useComponent: !0
    });
    return ES(e, t, pS, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[sm](...r)
    ));
  }
}), $w = FX, $X = /* @__PURE__ */ Tt({
  /* eslint-disable */
  name: "i18n-d",
  props: Gn({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Fg),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || Vg({
      useScope: e.scope,
      __useComponent: !0
    });
    return ES(e, t, hS, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[om](...r)
    ));
  }
}), Vw = $X;
function VX(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const r = n.__getInstance(t);
    return r != null ? r.__composer : e.global.__composer;
  }
}
function BX(e) {
  const t = (o) => {
    const { instance: s, modifiers: u, value: d } = o;
    if (!s || !s.$)
      throw Rn(Ot.UNEXPECTED_ERROR);
    const f = VX(e, s.$);
    process.env.NODE_ENV !== "production" && u.preserve && Ln(Ar(cn.NOT_SUPPORTED_PRESERVE));
    const p = Bw(d);
    return [
      Reflect.apply(f.t, f, [...Uw(p)]),
      f
    ];
  };
  return {
    created: (o, s) => {
      const [u, d] = t(s);
      yi && e.global === d && (o.__i18nWatcher = dn(d.locale, () => {
        s.instance && s.instance.$forceUpdate();
      })), o.__composer = d, o.textContent = u;
    },
    unmounted: (o) => {
      yi && o.__i18nWatcher && (o.__i18nWatcher(), o.__i18nWatcher = void 0, delete o.__i18nWatcher), o.__composer && (o.__composer = void 0, delete o.__composer);
    },
    beforeUpdate: (o, { value: s }) => {
      if (o.__composer) {
        const u = o.__composer, d = Bw(s);
        o.textContent = Reflect.apply(u.t, u, [
          ...Uw(d)
        ]);
      }
    },
    getSSRProps: (o) => {
      const [s] = t(o);
      return { textContent: s };
    }
  };
}
function Bw(e) {
  if (Te(e))
    return { path: e };
  if (rt(e)) {
    if (!("path" in e))
      throw Rn(Ot.REQUIRED_VALUE, "path");
    return e;
  } else
    throw Rn(Ot.INVALID_VALUE);
}
function Uw(e) {
  const { path: t, locale: n, args: r, choice: i, plural: a } = e, o = {}, s = r || {};
  return Te(n) && (o.locale = n), En(i) && (o.plural = i), En(a) && (o.plural = a), [t, s, o];
}
function UX(e, t, ...n) {
  const r = rt(n[0]) ? n[0] : {}, i = !!r.useI18nComponentName, a = dt(r.globalInstall) ? r.globalInstall : !0;
  process.env.NODE_ENV !== "production" && a && i && Ln(Ar(cn.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: sp.name
  })), a && ([i ? "i18n" : sp.name, "I18nT"].forEach((o) => e.component(o, sp)), [$w.name, "I18nN"].forEach((o) => e.component(o, $w)), [Vw.name, "I18nD"].forEach((o) => e.component(o, Vw))), e.directive("t", BX(t));
}
const lp = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, WX = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, HX = {
  "vue-i18n-timeline": 16764185
}, TS = "vue-i18n: composer properties";
let cm;
async function jX(e, t) {
  return new Promise((n, r) => {
    try {
      SX({
        id: "vue-devtools-plugin-vue-i18n",
        label: lp[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [TS],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (i) => {
        cm = i, i.on.visitComponentTree(({ componentInstance: o, treeNode: s }) => {
          YX(o, s, t);
        }), i.on.inspectComponent(({ componentInstance: o, instanceData: s }) => {
          o.vnode.el && o.vnode.el.__VUE_I18N__ && s && (t.mode === "legacy" ? o.vnode.el.__VUE_I18N__ !== t.global.__composer && Ww(s, o.vnode.el.__VUE_I18N__) : Ww(s, o.vnode.el.__VUE_I18N__));
        }), i.addInspector({
          id: "vue-i18n-resource-inspector",
          label: lp[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: WX[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), i.on.getInspectorTree((o) => {
          o.app === e && o.inspectorId === "vue-i18n-resource-inspector" && XX(o, t);
        });
        const a = /* @__PURE__ */ new Map();
        i.on.getInspectorState(async (o) => {
          if (o.app === e && o.inspectorId === "vue-i18n-resource-inspector")
            if (i.unhighlightElement(), QX(o, t), o.nodeId === "global") {
              if (!a.has(o.app)) {
                const [s] = await i.getComponentInstances(o.app);
                a.set(o.app, s);
              }
              i.highlightElement(a.get(o.app));
            } else {
              const s = ZX(o.nodeId, t);
              s && i.highlightElement(s);
            }
        }), i.on.editInspectorState((o) => {
          o.app === e && o.inspectorId === "vue-i18n-resource-inspector" && eZ(o, t);
        }), i.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: lp[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: HX[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), n(!0);
      });
    } catch (i) {
      console.error(i), r(!1);
    }
  });
}
function kS(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function YX(e, t, n) {
  const r = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== r) {
    const i = {
      label: `i18n (${kS(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(i);
  }
}
function Ww(e, t) {
  const n = TS;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: $g(t.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function $g(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    Yt(r) && "source" in r ? t[n] = KX(r) : Ga(r) && r.loc && r.loc.source ? t[n] = r.loc.source : Et(r) ? t[n] = $g(r) : t[n] = r;
  }), t;
}
const zX = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function GX(e) {
  return e.replace(/[<>"&]/g, qX);
}
function qX(e) {
  return zX[e] || e;
}
function KX(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${GX(e.source)}")` : "(?)"}`
    }
  };
}
function XX(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [r, i] of t.__instances) {
    const a = t.mode === "composition" ? i : i.__composer;
    n !== a && e.rootNodes.push({
      id: a.id.toString(),
      label: `${kS(r)} Scope`
    });
  }
}
function ZX(e, t) {
  let n = null;
  if (e !== "global") {
    for (const [r, i] of t.__instances.entries())
      if (i.id.toString() === e) {
        n = r;
        break;
      }
  }
  return n;
}
function SS(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const n = Array.from(t.__instances.values()).find((r) => r.id.toString() === e);
    return n ? t.mode === "composition" ? n : n.__composer : null;
  }
}
function QX(e, t) {
  const n = SS(e.nodeId, t);
  return n && (e.state = JX(n)), null;
}
function JX(e) {
  const t = {}, n = "Locale related info", r = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[n] = r;
  const i = "Locale messages info", a = [
    {
      type: i,
      key: "messages",
      editable: !1,
      value: $g(e.messages.value)
    }
  ];
  t[i] = a;
  {
    const o = "Datetime formats info", s = [
      {
        type: o,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[o] = s;
    const u = "Datetime formats info", d = [
      {
        type: u,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[u] = d;
  }
  return t;
}
function ou(e, t) {
  if (cm) {
    let n;
    t && "groupId" in t && (n = t.groupId, delete t.groupId), cm.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function eZ(e, t) {
  const n = SS(e.nodeId, t);
  if (n) {
    const [r] = e.path;
    r === "locale" && Te(e.state.value) ? n.locale.value = e.state.value : r === "fallbackLocale" && (Te(e.state.value) || Jt(e.state.value) || Et(e.state.value)) ? n.fallbackLocale.value = e.state.value : r === "inheritLocale" && dt(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
function tZ(e, t, n) {
  return {
    beforeCreate() {
      const r = ui();
      if (!r)
        throw Rn(Ot.UNEXPECTED_ERROR);
      const i = this.$options;
      if (i.i18n) {
        const a = i.i18n;
        if (i.__i18n && (a.__i18n = i.__i18n), a.__root = t, this === this.$root)
          this.$i18n = Hw(e, a);
        else {
          a.__injectWithOption = !0, a.__extender = n.__vueI18nExtend, this.$i18n = um(a);
          const o = this.$i18n;
          o.__extender && (o.__disposer = o.__extender(this.$i18n));
        }
      } else if (i.__i18n)
        if (this === this.$root)
          this.$i18n = Hw(e, i);
        else {
          this.$i18n = um({
            __i18n: i.__i18n,
            __injectWithOption: !0,
            __extender: n.__vueI18nExtend,
            __root: t
          });
          const a = this.$i18n;
          a.__extender && (a.__disposer = a.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      i.__i18nGlobal && wS(t, i, i), this.$t = (...a) => this.$i18n.t(...a), this.$rt = (...a) => this.$i18n.rt(...a), this.$tc = (...a) => this.$i18n.tc(...a), this.$te = (a, o) => this.$i18n.te(a, o), this.$d = (...a) => this.$i18n.d(...a), this.$n = (...a) => this.$i18n.n(...a), this.$tm = (a) => this.$i18n.tm(a), n.__setInstance(r, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const r = this.$i18n;
        this.$el.__VUE_I18N__ = r.__composer;
        const i = this.__v_emitter = Pg();
        r.__enableEmitter && r.__enableEmitter(i), i.on("*", ou);
      }
    },
    unmounted() {
      const r = ui();
      if (!r)
        throw Rn(Ot.UNEXPECTED_ERROR);
      const i = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", ou), delete this.__v_emitter), this.$i18n && (i.__disableEmitter && i.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, i.__disposer && (i.__disposer(), delete i.__disposer, delete i.__extender), n.__deleteInstance(r), delete this.$i18n;
    }
  };
}
function Hw(e, t) {
  e.locale = t.locale || e.locale, e.fallbackLocale = t.fallbackLocale || e.fallbackLocale, e.missing = t.missing || e.missing, e.silentTranslationWarn = t.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = t.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = t.postTranslation || e.postTranslation, e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml, e.sync = t.sync || e.sync, e.__composer[_S](t.pluralizationRules || e.pluralizationRules);
  const n = sf(e.locale, {
    messages: t.messages,
    __i18n: t.__i18n
  });
  return Object.keys(n).forEach((r) => e.mergeLocaleMessage(r, n[r])), t.datetimeFormats && Object.keys(t.datetimeFormats).forEach((r) => e.mergeDateTimeFormat(r, t.datetimeFormats[r])), t.numberFormats && Object.keys(t.numberFormats).forEach((r) => e.mergeNumberFormat(r, t.numberFormats[r])), e;
}
const nZ = /* @__PURE__ */ Ui("global-vue-i18n");
function rZ(e = {}, t) {
  const n = __VUE_I18N_LEGACY_API__ && dt(e.legacy) ? e.legacy : __VUE_I18N_LEGACY_API__, r = dt(e.globalInjection) ? e.globalInjection : !0, i = __VUE_I18N_LEGACY_API__ && n ? !!e.allowComposition : !0, a = /* @__PURE__ */ new Map(), [o, s] = iZ(e, n), u = /* @__PURE__ */ Ui(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV !== "production" && n && i && Ln(Ar(cn.NOTICE_DROP_ALLOW_COMPOSITION));
  function d(m) {
    return a.get(m) || null;
  }
  function f(m, g) {
    a.set(m, g);
  }
  function p(m) {
    a.delete(m);
  }
  {
    const m = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && n ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return i;
      },
      // install plugin
      async install(g, ...v) {
        if (process.env.NODE_ENV !== "production" && (g.__VUE_I18N__ = m), g.__VUE_I18N_SYMBOL__ = u, g.provide(g.__VUE_I18N_SYMBOL__, m), rt(v[0])) {
          const T = v[0];
          m.__composerExtend = T.__composerExtend, m.__vueI18nExtend = T.__vueI18nExtend;
        }
        let b = null;
        !n && r && (b = hZ(g, m.global)), __VUE_I18N_FULL_INSTALL__ && UX(g, m, ...v), __VUE_I18N_LEGACY_API__ && n && g.mixin(tZ(s, s.__composer, m));
        const w = g.unmount;
        if (g.unmount = () => {
          b && b(), m.dispose(), w();
        }, process.env.NODE_ENV !== "production") {
          if (!await jX(g, m))
            throw Rn(Ot.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const S = Pg();
          if (n) {
            const x = s;
            x.__enableEmitter && x.__enableEmitter(S);
          } else {
            const x = s;
            x[Bo] && x[Bo](S);
          }
          S.on("*", ou);
        }
      },
      // global accessor
      get global() {
        return s;
      },
      dispose() {
        o.stop();
      },
      // @internal
      __instances: a,
      // @internal
      __getInstance: d,
      // @internal
      __setInstance: f,
      // @internal
      __deleteInstance: p
    };
    return m;
  }
}
function Vg(e = {}) {
  const t = ui();
  if (t == null)
    throw Rn(Ot.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Rn(Ot.NOT_INSTALLED);
  const n = aZ(t), r = sZ(n), i = bS(t), a = oZ(e, i);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw Rn(Ot.NOT_AVAILABLE_IN_LEGACY_MODE);
    return dZ(t, a, r, e);
  }
  if (a === "global")
    return wS(r, e, i), r;
  if (a === "parent") {
    let u = lZ(n, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && Ln(Ar(cn.NOT_FOUND_PARENT_SCOPE)), u = r), u;
  }
  const o = n;
  let s = o.__getInstance(t);
  if (s == null) {
    const u = Gn({}, e);
    "__i18n" in i && (u.__i18n = i.__i18n), r && (u.__root = r), s = Rg(u), o.__composerExtend && (s[lm] = o.__composerExtend(s)), cZ(o, t, s), o.__setInstance(t, s);
  }
  return s;
}
function iZ(e, t, n) {
  const r = lI();
  {
    const i = __VUE_I18N_LEGACY_API__ && t ? r.run(() => um(e)) : r.run(() => Rg(e));
    if (i == null)
      throw Rn(Ot.UNEXPECTED_ERROR);
    return [r, i];
  }
}
function aZ(e) {
  {
    const t = qn(e.isCE ? nZ : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw Rn(e.isCE ? Ot.NOT_INSTALLED_WITH_PROVIDE : Ot.UNEXPECTED_ERROR);
    return t;
  }
}
function oZ(e, t) {
  return tf(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function sZ(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function lZ(e, t, n = !1) {
  let r = null;
  const i = t.root;
  let a = uZ(t, n);
  for (; a != null; ) {
    const o = e;
    if (e.mode === "composition")
      r = o.__getInstance(a);
    else if (__VUE_I18N_LEGACY_API__) {
      const s = o.__getInstance(a);
      s != null && (r = s.__composer, n && r && !r[yS] && (r = null));
    }
    if (r != null || i === a)
      break;
    a = a.parent;
  }
  return r;
}
function uZ(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function cZ(e, t, n) {
  let r = null;
  Mt(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = Pg();
      const i = n;
      i[Bo] && i[Bo](r), r.on("*", ou);
    }
  }, t), Bn(() => {
    const i = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", ou), i[iu] && i[iu](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const a = i[lm];
    a && (a(), delete i[lm]);
  }, t);
}
function dZ(e, t, n, r = {}) {
  const i = t === "local", a = su(null);
  if (i && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw Rn(Ot.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const o = dt(r.inheritLocale) ? r.inheritLocale : !Te(r.locale), s = fe(
    // prettier-ignore
    !i || o ? n.locale.value : Te(r.locale) ? r.locale : Fs
  ), u = fe(
    // prettier-ignore
    !i || o ? n.fallbackLocale.value : Te(r.fallbackLocale) || Jt(r.fallbackLocale) || rt(r.fallbackLocale) || r.fallbackLocale === !1 ? r.fallbackLocale : s.value
  ), d = fe(sf(s.value, r)), f = fe(rt(r.datetimeFormats) ? r.datetimeFormats : { [s.value]: {} }), p = fe(rt(r.numberFormats) ? r.numberFormats : { [s.value]: {} }), m = i ? n.missingWarn : dt(r.missingWarn) || za(r.missingWarn) ? r.missingWarn : !0, g = i ? n.fallbackWarn : dt(r.fallbackWarn) || za(r.fallbackWarn) ? r.fallbackWarn : !0, v = i ? n.fallbackRoot : dt(r.fallbackRoot) ? r.fallbackRoot : !0, b = !!r.fallbackFormat, w = Yt(r.missing) ? r.missing : null, T = Yt(r.postTranslation) ? r.postTranslation : null, S = i ? n.warnHtmlMessage : dt(r.warnHtmlMessage) ? r.warnHtmlMessage : !0, x = !!r.escapeParameter, O = i ? n.modifiers : rt(r.modifiers) ? r.modifiers : {}, C = r.pluralRules || i && n.pluralRules;
  function P() {
    return [
      s.value,
      u.value,
      d.value,
      f.value,
      p.value
    ];
  }
  const k = oe({
    get: () => a.value ? a.value.locale.value : s.value,
    set: (ue) => {
      a.value && (a.value.locale.value = ue), s.value = ue;
    }
  }), M = oe({
    get: () => a.value ? a.value.fallbackLocale.value : u.value,
    set: (ue) => {
      a.value && (a.value.fallbackLocale.value = ue), u.value = ue;
    }
  }), N = oe(() => a.value ? a.value.messages.value : d.value), X = oe(() => f.value), Z = oe(() => p.value);
  function te() {
    return a.value ? a.value.getPostTranslationHandler() : T;
  }
  function ce(ue) {
    a.value && a.value.setPostTranslationHandler(ue);
  }
  function we() {
    return a.value ? a.value.getMissingHandler() : w;
  }
  function G(ue) {
    a.value && a.value.setMissingHandler(ue);
  }
  function Q(ue) {
    return P(), ue();
  }
  function y(...ue) {
    return a.value ? Q(() => Reflect.apply(a.value.t, null, [...ue])) : Q(() => "");
  }
  function H(...ue) {
    return a.value ? Reflect.apply(a.value.rt, null, [...ue]) : "";
  }
  function ie(...ue) {
    return a.value ? Q(() => Reflect.apply(a.value.d, null, [...ue])) : Q(() => "");
  }
  function ne(...ue) {
    return a.value ? Q(() => Reflect.apply(a.value.n, null, [...ue])) : Q(() => "");
  }
  function J(ue) {
    return a.value ? a.value.tm(ue) : {};
  }
  function me(ue, Ce) {
    return a.value ? a.value.te(ue, Ce) : !1;
  }
  function xe(ue) {
    return a.value ? a.value.getLocaleMessage(ue) : {};
  }
  function U(ue, Ce) {
    a.value && (a.value.setLocaleMessage(ue, Ce), d.value[ue] = Ce);
  }
  function $(ue, Ce) {
    a.value && a.value.mergeLocaleMessage(ue, Ce);
  }
  function Y(ue) {
    return a.value ? a.value.getDateTimeFormat(ue) : {};
  }
  function Re(ue, Ce) {
    a.value && (a.value.setDateTimeFormat(ue, Ce), f.value[ue] = Ce);
  }
  function it(ue, Ce) {
    a.value && a.value.mergeDateTimeFormat(ue, Ce);
  }
  function He(ue) {
    return a.value ? a.value.getNumberFormat(ue) : {};
  }
  function Vt(ue, Ce) {
    a.value && (a.value.setNumberFormat(ue, Ce), p.value[ue] = Ce);
  }
  function Bt(ue, Ce) {
    a.value && a.value.mergeNumberFormat(ue, Ce);
  }
  const Be = {
    get id() {
      return a.value ? a.value.id : -1;
    },
    locale: k,
    fallbackLocale: M,
    messages: N,
    datetimeFormats: X,
    numberFormats: Z,
    get inheritLocale() {
      return a.value ? a.value.inheritLocale : o;
    },
    set inheritLocale(ue) {
      a.value && (a.value.inheritLocale = ue);
    },
    get availableLocales() {
      return a.value ? a.value.availableLocales : Object.keys(d.value);
    },
    get modifiers() {
      return a.value ? a.value.modifiers : O;
    },
    get pluralRules() {
      return a.value ? a.value.pluralRules : C;
    },
    get isGlobal() {
      return a.value ? a.value.isGlobal : !1;
    },
    get missingWarn() {
      return a.value ? a.value.missingWarn : m;
    },
    set missingWarn(ue) {
      a.value && (a.value.missingWarn = ue);
    },
    get fallbackWarn() {
      return a.value ? a.value.fallbackWarn : g;
    },
    set fallbackWarn(ue) {
      a.value && (a.value.missingWarn = ue);
    },
    get fallbackRoot() {
      return a.value ? a.value.fallbackRoot : v;
    },
    set fallbackRoot(ue) {
      a.value && (a.value.fallbackRoot = ue);
    },
    get fallbackFormat() {
      return a.value ? a.value.fallbackFormat : b;
    },
    set fallbackFormat(ue) {
      a.value && (a.value.fallbackFormat = ue);
    },
    get warnHtmlMessage() {
      return a.value ? a.value.warnHtmlMessage : S;
    },
    set warnHtmlMessage(ue) {
      a.value && (a.value.warnHtmlMessage = ue);
    },
    get escapeParameter() {
      return a.value ? a.value.escapeParameter : x;
    },
    set escapeParameter(ue) {
      a.value && (a.value.escapeParameter = ue);
    },
    t: y,
    getPostTranslationHandler: te,
    setPostTranslationHandler: ce,
    getMissingHandler: we,
    setMissingHandler: G,
    rt: H,
    d: ie,
    n: ne,
    tm: J,
    te: me,
    getLocaleMessage: xe,
    setLocaleMessage: U,
    mergeLocaleMessage: $,
    getDateTimeFormat: Y,
    setDateTimeFormat: Re,
    mergeDateTimeFormat: it,
    getNumberFormat: He,
    setNumberFormat: Vt,
    mergeNumberFormat: Bt
  };
  function Xe(ue) {
    ue.locale.value = s.value, ue.fallbackLocale.value = u.value, Object.keys(d.value).forEach((Ce) => {
      ue.mergeLocaleMessage(Ce, d.value[Ce]);
    }), Object.keys(f.value).forEach((Ce) => {
      ue.mergeDateTimeFormat(Ce, f.value[Ce]);
    }), Object.keys(p.value).forEach((Ce) => {
      ue.mergeNumberFormat(Ce, p.value[Ce]);
    }), ue.escapeParameter = x, ue.fallbackFormat = b, ue.fallbackRoot = v, ue.fallbackWarn = g, ue.missingWarn = m, ue.warnHtmlMessage = S;
  }
  return uI(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw Rn(Ot.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const ue = a.value = e.proxy.$i18n.__composer;
    t === "global" ? (s.value = ue.locale.value, u.value = ue.fallbackLocale.value, d.value = ue.messages.value, f.value = ue.datetimeFormats.value, p.value = ue.numberFormats.value) : i && Xe(ue);
  }), Be;
}
const fZ = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], jw = ["t", "rt", "d", "n", "tm", "te"];
function hZ(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return fZ.forEach((i) => {
    const a = Object.getOwnPropertyDescriptor(t, i);
    if (!a)
      throw Rn(Ot.UNEXPECTED_ERROR);
    const o = Si(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(s) {
        a.value.value = s;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(n, i, o);
  }), e.config.globalProperties.$i18n = n, jw.forEach((i) => {
    const a = Object.getOwnPropertyDescriptor(t, i);
    if (!a || !a.value)
      throw Rn(Ot.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${i}`, a);
  }), () => {
    delete e.config.globalProperties.$i18n, jw.forEach((i) => {
      delete e.config.globalProperties[`$${i}`];
    });
  };
}
CX();
__INTLIFY_JIT_COMPILATION__ ? xw(hX) : xw(fX);
HK(EK);
jK(Qk);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = la();
  e.__INTLIFY__ = !0, MK(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const pZ = {
  fr: {
    monthly: {
      year: "numeric",
      month: "short"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    shortDate: {
      weekday: "short",
      day: "numeric",
      month: "short"
    }
  },
  "en-US": {
    monthly: {
      year: "numeric",
      month: "short"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    shortDate: {
      weekday: "short",
      day: "numeric",
      month: "short"
    }
  }
}, mZ = {
  fr: {
    currency: {
      style: "currency",
      currency: "EUR",
      useGrouping: !0,
      currencyDisplay: "symbol",
      trailingZeroDisplay: "stripIfInteger"
    },
    decimal: {
      style: "decimal",
      minimumSignificantDigits: 3,
      maximumSignificantDigits: 5
    },
    percent: {
      style: "percent",
      useGrouping: !1
    }
  },
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD",
      notation: "standard"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    percent: {
      style: "percent",
      useGrouping: !1
    }
  }
};
let Yw;
function gZ(e = { locale: "fr" }) {
  return Yw || (Yw = rZ({
    ...e,
    missingWarn: !1,
    legacy: !1,
    globalInjection: !0,
    datetimeFormats: pZ,
    numberFormats: mZ
  })), Yw;
}
function lf(e, t) {
  const n = parseFloat(e);
  if (isNaN(n)) return null;
  let r = {};
  return ar(t) && (r = { currency: t }), gZ().global.n(n, "currency", r);
}
function Bg(e) {
  return ar(e) ? `${Math.round(e * 100)} %` : null;
}
const vZ = {
  props: ["variation"],
  computed: {
    formattedVariation() {
      return this.variation === null || isNaN(this.variation) ? "" : `${this.variation > 0 ? "+" : ""}${this.variation} %`;
    }
  }
};
function _Z(e, t, n, r, i, a) {
  return n.variation !== null ? (I(), W("span", {
    key: 0,
    class: ze(["text-xs font-semibold", {
      "text-green-600 bg-green-50 p-2 rounded-full": n.variation > 0,
      "text-red-600 bg-red-50 p-2 rounded-full": n.variation < 0,
      "text-gray-500 bg-gray-50 p-2 rounded-full": n.variation === 0
    }])
  }, ke(a.formattedVariation), 3)) : ee("", !0);
}
const OS = /* @__PURE__ */ pt(vZ, [["render", _Z]]), yZ = {
  props: {
    title: String,
    data: {
      type: Object,
      required: !0,
      default: () => ({ current: 0, previous: null, variation: null })
    },
    tooltipText: String,
    comparisonType: String
  },
  components: {
    InformationCircleIcon: fu,
    Variation: OS
  },
  computed: {
    shouldShowFooter() {
      return this.data.previous !== null || this.data.variation !== null;
    }
  },
  methods: {
    formatData(e) {
      return this.data.type === "amount" ? lf(e) : this.data.type === "percentage" ? Bg(e) : e;
    }
  }
}, bZ = { class: "overflow-hidden rounded-lg bg-white p-4 shadow" }, wZ = { class: "flex gap-x-2 items-center" }, xZ = { class: "truncate text-sm font-medium text-gray-500" }, EZ = { class: "mt-1 text-3xl font-bold tracking-tight text-gray-900" }, TZ = {
  key: 0,
  class: "flex items-end justify-between"
}, kZ = {
  key: 0,
  class: "text-xs text-gray-500"
};
function SZ(e, t, n, r, i, a) {
  const o = je("InformationCircleIcon"), s = je("VTooltip"), u = je("Variation");
  return I(), W("div", bZ, [
    K("div", wZ, [
      K("dt", xZ, ke(n.title), 1),
      n.tooltipText || e.$slots.tooltip ? (I(), Oe(s, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: Ve(() => [
          Ee(e.$slots, "tooltip", {}, () => [
            K("span", null, ke(n.tooltipText), 1)
          ])
        ]),
        default: Ve(() => [
          Ae(o, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : ee("", !0)
    ]),
    K("dd", EZ, ke(a.formatData(n.data.current)), 1),
    a.shouldShowFooter ? (I(), W("div", TZ, [
      n.data.previous !== null ? (I(), W("span", kZ, ke(a.formatData(n.data.previous)) + " " + ke(n.comparisonType ? e.$t(n.comparisonType) : e.$t("yesterday")), 1)) : ee("", !0),
      Ae(u, {
        variation: n.data.variation
      }, null, 8, ["variation"])
    ])) : ee("", !0)
  ]);
}
const OZ = /* @__PURE__ */ pt(yZ, [["render", SZ]]), CZ = {
  components: { Alert: i5 },
  props: ["selectedRows", "selectableRows"]
}, AZ = { class: "ml-3 flex-1 md:flex md:justify-between" }, DZ = { class: "text-sm text-blue-500" }, PZ = { class: "font-bold" }, MZ = { class: "mt-3 text-sm md:ml-6 md:mt-0" };
function IZ(e, t, n, r, i, a) {
  const o = je("Alert");
  return n.selectedRows.length > 0 ? (I(), Oe(o, { key: 0 }, {
    title: Ve(() => [
      K("div", AZ, [
        K("p", DZ, [
          t[2] || (t[2] = Xt("Vous avez sélectionné ")),
          K("span", PZ, ke(n.selectedRows.length) + " éléments sur " + ke(n.selectableRows.length), 1)
        ]),
        K("p", MZ, [
          n.selectedRows.length < n.selectableRows.length ? (I(), W("button", {
            key: 0,
            type: "button",
            class: "whitespace-nowrap underline font-medium text-blue-500 flex items-center gap-1",
            onClick: t[0] || (t[0] = (s) => e.$emit("selectAll"))
          }, " Tout sélectionner ")) : (I(), W("button", {
            key: 1,
            type: "button",
            class: "whitespace-nowrap underline font-medium text-blue-500 flex items-center gap-1",
            onClick: t[1] || (t[1] = (s) => e.$emit("unselectAll"))
          }, " Tout désélectionner "))
        ])
      ])
    ]),
    _: 1
  })) : ee("", !0);
}
const NZ = /* @__PURE__ */ pt(CZ, [["render", IZ]]), LZ = {}, RZ = { class: "flex items-end m-2" };
function FZ(e, t, n, r, i, a) {
  return I(), W("span", RZ, [
    Xt(ke(e.$t("Loading")) + " ", 1),
    t[0] || (t[0] = dI('<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="3" opacity="1"><animate id="spinner_qYjJ" begin="0;spinner_t4KZ.end-0.25s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"></animate></circle><circle cx="12" cy="12" r="3" opacity=".4"><animate begin="spinner_qYjJ.begin+0.15s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"></animate></circle><circle cx="20" cy="12" r="3" opacity=".3"><animate id="spinner_t4KZ" begin="spinner_qYjJ.begin+0.3s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"></animate></circle></svg>', 1))
  ]);
}
const $Z = /* @__PURE__ */ pt(LZ, [["render", FZ]]), VZ = {
  components: {
    SelectableTableAlert: NZ,
    Loading: $Z,
    TrashIcon: TE,
    DownloadIcon: Y4,
    PencilAltIcon: q4,
    EyeIcon: G4,
    ExclamationIcon: z4
  },
  props: {
    columns: {
      type: Array,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    isDeletable: {
      type: Boolean,
      default: !1
    },
    isDownloadable: {
      type: Boolean,
      default: !1
    },
    isUpdatable: {
      type: Boolean,
      default: !1
    },
    isAccessible: {
      type: Boolean,
      default: !1
    },
    isRowClickable: {
      type: Boolean,
      default: !1
    },
    isSelectable: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    noDataMsg: {
      type: String,
      default: ""
    },
    selectableRowFilter: {
      type: Function,
      required: !1
    },
    order: {
      type: String,
      default: null
    }
  },
  emits: [
    "sort",
    "rowClick",
    "delete",
    "update",
    "view",
    "download",
    "newSelectedRows"
  ],
  data() {
    return {
      headerGroupBorderClass: "border-l border-gray-200",
      selectedRows: []
    };
  },
  watch: {
    selectedRows() {
      const e = this.selectedRows.map(
        (t) => this.data[t]
      );
      this.$emit("newSelectedRows", e);
    },
    data() {
      this.selectedRows = [];
    }
  },
  computed: {
    headerGroups() {
      const e = [];
      let t = { label: void 0, colspan: 0 };
      return this.columns.forEach((n) => {
        n.headerGroup !== t.label ? (t.colspan > 0 && e.push(t), t = { label: n.headerGroup, colspan: 1 }) : t.colspan += 1;
      }), e.push(t), e;
    },
    groupsBordersIndex() {
      return this.headerGroups.reduce((e, t, n) => (e.push(t.colspan + (e[n - 1] || 0)), e), []);
    },
    totalColumns() {
      let e = this.columns.length;
      return this.isDeletable && (e += 1), this.isDownloadable && (e += 1), this.isUpdatable && (e += 1), this.isAccessible && (e += 1), e;
    },
    orderDirection() {
      var e;
      return (e = this.order) != null && e.startsWith("-") ? "desc" : "asc";
    },
    orderField() {
      var e;
      return (e = this.order) == null ? void 0 : e.replace("-", "");
    },
    selectableRows() {
      return this.selectableRowFilter ? this.data.filter((e) => this.selectableRowFilter(e)) : this.data;
    }
  },
  methods: {
    formatPrice: lf,
    formatPercentage: Bg,
    isPresent: ar,
    isHeaderGroupBorder(e) {
      return this.groupsBordersIndex.includes(e);
    },
    isFullRow(e) {
      return e.fullRow;
    },
    formatValue(e, t) {
      if (!ar(e))
        return "—";
      if (typeof e == "number") {
        if (t.price) return this.formatPrice(e);
        if (t.percentage) return this.formatPercentage(e);
      }
      return typeof e == "string" ? t.price ? this.formatPrice(e) : this.$t(e) : e;
    },
    getCellClass(e, t) {
      const n = ["px-3 py-2 whitespace-nowrap font-light"];
      return e.bold && n.push("text-black font-semibold"), (e.numeric || e.price) && n.push("text-right"), this.isHeaderGroupBorder(t) && n.push(this.headerGroupBorderClass), n;
    },
    emitSort(e) {
      e.sortable && this.$emit("sort", e);
    },
    onChangeRowSelection(e, t) {
      e.target.checked ? this.selectedRows.includes(t) || (this.selectedRows = [...this.selectedRows, t]) : this.selectedRows = this.selectedRows.filter(
        (r) => r !== t
      );
    },
    onChangeAllRowsSelection(e) {
      e.target.checked ? this.selectAll() : this.unselectAll();
    },
    selectAll() {
      this.selectableRowFilter ? this.selectedRows = this.data.map((e, t) => this.selectableRowFilter(e) ? t : null).filter((e) => e !== null) : this.selectedRows = this.selectableRows.map((e, t) => t);
    },
    unselectAll() {
      this.selectedRows = [];
    }
  }
}, BZ = { class: "bg-white overflow-x-auto shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" }, UZ = {
  class: /* @__PURE__ */ ze("table-auto min-w-full divide-y divide-gray-300 text-xs")
}, WZ = { key: 0 }, HZ = ["colspan"], jZ = {
  key: 0,
  class: "px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, YZ = {
  key: 1,
  class: "px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, zZ = {
  key: 2,
  class: "px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, GZ = {
  key: 3,
  class: "px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, qZ = { key: 0 }, KZ = { class: "ml-2 flex items-center justify-center" }, XZ = ["checked"], ZZ = ["onClick"], QZ = { key: 0 }, JZ = {
  key: 1,
  class: "w-1 px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, eQ = {
  key: 2,
  class: "w-1 px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, tQ = {
  key: 3,
  class: "w-1 px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, nQ = {
  key: 4,
  class: "w-1 px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto"
}, rQ = { key: 0 }, iQ = { key: 1 }, aQ = ["colspan"], oQ = {
  key: 2,
  class: /* @__PURE__ */ ze("divide-y divide-gray-200")
}, sQ = ["onClick"], lQ = { key: 0 }, uQ = {
  key: 0,
  class: "ml-2 flex items-center justify-center"
}, cQ = ["id", "name", "checked", "onChange"], dQ = ["innerHTML"], fQ = {
  key: 1,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, hQ = {
  key: 1,
  class: "w-5 inline-block"
}, pQ = {
  key: 2,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, mQ = {
  key: 3,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, gQ = {
  key: 4,
  class: "text-right w-1 whitespace-nowrap pr-2"
};
function vQ(e, t, n, r, i, a) {
  const o = je("SelectableTableAlert"), s = je("Loading"), u = je("EyeIcon"), d = je("PencilAltIcon"), f = je("DownloadIcon"), p = je("TrashIcon");
  return I(), W("div", null, [
    n.isSelectable ? (I(), Oe(o, {
      key: 0,
      "selectable-rows": a.selectableRows,
      "selected-rows": i.selectedRows,
      onSelectAll: a.selectAll,
      onUnselectAll: a.unselectAll
    }, null, 8, ["selectable-rows", "selected-rows", "onSelectAll", "onUnselectAll"])) : ee("", !0),
    K("div", BZ, [
      K("table", UZ, [
        K("thead", null, [
          a.headerGroups.length > 1 ? (I(), W("tr", WZ, [
            (I(!0), W(Ge, null, Nt(a.headerGroups, (m, g) => (I(), W("th", {
              key: g,
              colspan: m.colspan,
              scope: "col",
              class: ze(["px-3 py-2 text-center text-black font-bold tracking-wide whitespace-nowrap w-auto", g > 0 ? i.headerGroupBorderClass : ""])
            }, ke(m.label), 11, HZ))), 128)),
            n.isDeletable ? (I(), W("th", jZ)) : ee("", !0),
            n.isDownloadable ? (I(), W("th", YZ)) : ee("", !0),
            n.isUpdatable ? (I(), W("th", zZ)) : ee("", !0),
            n.isAccessible ? (I(), W("th", GZ)) : ee("", !0)
          ])) : ee("", !0),
          K("tr", null, [
            n.isSelectable && a.selectableRows.length > 0 ? (I(), W("th", qZ, [
              K("div", KZ, [
                K("input", {
                  id: "select-all-checkbox",
                  "aria-describedby": "select-all-checkbox",
                  name: "select-all-checkbox",
                  type: "checkbox",
                  onChange: t[0] || (t[0] = (...m) => a.onChangeAllRowsSelection && a.onChangeAllRowsSelection(...m)),
                  class: "col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto",
                  checked: i.selectedRows.length === a.selectableRows.length && a.selectableRows.length > 0
                }, null, 40, XZ)
              ])
            ])) : ee("", !0),
            (I(!0), W(Ge, null, Nt(n.columns, (m, g) => (I(), W("th", {
              key: g,
              scope: "col",
              class: ze([
                "px-3 py-2 text-left text-black font-bold tracking-wide whitespace-nowrap w-auto",
                m.numeric || m.price ? "text-right" : "",
                a.isHeaderGroupBorder(g) ? i.headerGroupBorderClass : "",
                m.sortable ? "cursor-pointer" : ""
              ]),
              onClick: nr((v) => a.emitSort(m), ["stop"])
            }, [
              Xt(ke(m.label) + " ", 1),
              a.orderField === m.field ? (I(), W("span", QZ, [
                t[1] || (t[1] = Xt("   ")),
                a.orderDirection === "asc" ? (I(), W(Ge, { key: 0 }, [
                  Xt("↓")
                ], 64)) : (I(), W(Ge, { key: 1 }, [
                  Xt("↑")
                ], 64))
              ])) : ee("", !0)
            ], 10, ZZ))), 128)),
            n.isDeletable ? (I(), W("th", JZ)) : ee("", !0),
            n.isDownloadable ? (I(), W("th", eQ)) : ee("", !0),
            n.isUpdatable ? (I(), W("th", tQ)) : ee("", !0),
            n.isAccessible ? (I(), W("th", nQ)) : ee("", !0)
          ])
        ]),
        n.isLoading ? (I(), W("tbody", rQ, [
          Ae(s)
        ])) : a.isPresent(n.noDataMsg) && n.data.length === 0 ? (I(), W("tbody", iQ, [
          K("tr", null, [
            K("td", {
              colspan: a.totalColumns,
              class: "text-center text-gray-500 py-4"
            }, ke(n.noDataMsg), 9, aQ)
          ])
        ])) : (I(), W("tbody", oQ, [
          (I(!0), W(Ge, null, Nt(n.data, (m, g) => (I(), W("tr", {
            key: g,
            class: ze([
              ...n.isRowClickable ? ["cursor-pointer", "hover:bg-gray-200"] : [],
              ...!a.selectableRows.includes(m) && a.selectableRows.length > 0 ? ["bg-gray-50"] : [],
              m.rowClass
            ]),
            onClick: (v) => n.isRowClickable ? e.$emit("rowClick", m) : null
          }, [
            a.isFullRow(m) ? Ee(e.$slots, m.slot, {
              key: 0,
              row: m,
              colspan: a.totalColumns
            }) : (I(), W(Ge, { key: 1 }, [
              n.isSelectable && a.selectableRows.length > 0 ? (I(), W("td", lQ, [
                a.selectableRows.includes(m) ? (I(), W("div", uQ, [
                  K("input", {
                    id: "checkbox-" + g,
                    "aria-describedby": "checkbox",
                    name: "checkbox-" + g,
                    type: "checkbox",
                    class: "col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto",
                    checked: i.selectedRows.includes(g),
                    onChange: (v) => a.onChangeRowSelection(v, g)
                  }, null, 40, cQ)
                ])) : ee("", !0)
              ])) : ee("", !0),
              (I(!0), W(Ge, null, Nt(n.columns, (v, b) => (I(), W("td", {
                key: b,
                class: ze(a.getCellClass(v, b))
              }, [
                v.slot ? Ee(e.$slots, v.slot, {
                  key: 0,
                  row: m,
                  column: v
                }) : (I(), W("span", {
                  key: 1,
                  innerHTML: a.formatValue(m[v.field], v),
                  class: ze(v.class ? v.class[m[v.field]] : "")
                }, null, 10, dQ))
              ], 2))), 128)),
              n.isAccessible ? (I(), W("td", fQ, [
                m.isAccessible !== !1 ? (I(), Oe(u, {
                  key: 0,
                  class: "h-5 cursor-pointer inline-block",
                  onClick: nr(() => e.$emit("view", m), ["stop"])
                }, null, 8, ["onClick"])) : (I(), W("span", hQ))
              ])) : ee("", !0),
              n.isUpdatable && m.isUpdatable !== !1 ? (I(), W("td", pQ, [
                Ae(d, {
                  class: "h-5 cursor-pointer inline-block",
                  onClick: nr(() => e.$emit("update", m), ["stop"])
                }, null, 8, ["onClick"])
              ])) : ee("", !0),
              n.isDownloadable ? (I(), W("td", mQ, [
                Ae(f, {
                  class: "h-5 cursor-pointer inline-block",
                  onClick: nr(() => e.$emit("download", m), ["stop"])
                }, null, 8, ["onClick"])
              ])) : ee("", !0),
              n.isDeletable && m.isDeletable !== !1 ? (I(), W("td", gQ, [
                Ae(p, {
                  class: "h-5 cursor-pointer inline-block",
                  onClick: nr(() => e.$emit("delete", m), ["stop"])
                }, null, 8, ["onClick"])
              ])) : ee("", !0)
            ], 64))
          ], 10, sQ))), 128))
        ]))
      ])
    ])
  ]);
}
const Ug = /* @__PURE__ */ pt(VZ, [["render", vQ]]);
var Yc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, kl = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var _Q = kl.exports, zw;
function yQ() {
  return zw || (zw = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", s = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", p = 1, m = 2, g = 4, v = 1, b = 2, w = 1, T = 2, S = 4, x = 8, O = 16, C = 32, P = 64, k = 128, M = 256, N = 512, X = 30, Z = "...", te = 800, ce = 16, we = 1, G = 2, Q = 3, y = 1 / 0, H = 9007199254740991, ie = 17976931348623157e292, ne = NaN, J = 4294967295, me = J - 1, xe = J >>> 1, U = [
        ["ary", k],
        ["bind", w],
        ["bindKey", T],
        ["curry", x],
        ["curryRight", O],
        ["flip", N],
        ["partial", C],
        ["partialRight", P],
        ["rearg", M]
      ], $ = "[object Arguments]", Y = "[object Array]", Re = "[object AsyncFunction]", it = "[object Boolean]", He = "[object Date]", Vt = "[object DOMException]", Bt = "[object Error]", Be = "[object Function]", Xe = "[object GeneratorFunction]", ue = "[object Map]", Ce = "[object Number]", Pr = "[object Null]", qt = "[object Object]", yr = "[object Promise]", Mr = "[object Proxy]", R = "[object RegExp]", V = "[object Set]", ge = "[object String]", Fe = "[object Symbol]", Pt = "[object Undefined]", mt = "[object WeakMap]", wt = "[object WeakSet]", ae = "[object ArrayBuffer]", _e = "[object DataView]", F = "[object Float32Array]", se = "[object Float64Array]", Pe = "[object Int8Array]", Ye = "[object Int16Array]", gt = "[object Int32Array]", mn = "[object Uint8Array]", Ir = "[object Uint8ClampedArray]", de = "[object Uint16Array]", Ne = "[object Uint32Array]", Wn = /\b__p \+= '';/g, Xn = /\b(__p \+=) '' \+/g, Ko = /(__e\(.*?\)|\b__t\)) \+\n'';/g, qe = /&(?:amp|lt|gt|quot|#39);/g, Wi = /[&<>"']/g, ft = RegExp(qe.source), uf = RegExp(Wi.source), Ys = /<%-([\s\S]+?)%>/g, AS = /<%([\s\S]+?)%>/g, Wg = /<%=([\s\S]+?)%>/g, DS = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, PS = /^\w*$/, MS = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, cf = /[\\^$.*+?()[\]{}|]/g, IS = RegExp(cf.source), df = /^\s+/, NS = /\s/, LS = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, RS = /\{\n\/\* \[wrapped with (.+)\] \*/, FS = /,? & /, $S = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, VS = /[()=,{}\[\]\/\s]/, BS = /\\(\\)?/g, US = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Hg = /\w*$/, WS = /^[-+]0x[0-9a-f]+$/i, HS = /^0b[01]+$/i, jS = /^\[object .+?Constructor\]$/, YS = /^0o[0-7]+$/i, zS = /^(?:0|[1-9]\d*)$/, GS = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pu = /($^)/, qS = /['\n\r\u2028\u2029\\]/g, Mu = "\\ud800-\\udfff", KS = "\\u0300-\\u036f", XS = "\\ufe20-\\ufe2f", ZS = "\\u20d0-\\u20ff", jg = KS + XS + ZS, Yg = "\\u2700-\\u27bf", zg = "a-z\\xdf-\\xf6\\xf8-\\xff", QS = "\\xac\\xb1\\xd7\\xf7", JS = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", eO = "\\u2000-\\u206f", tO = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Gg = "A-Z\\xc0-\\xd6\\xd8-\\xde", qg = "\\ufe0e\\ufe0f", Kg = QS + JS + eO + tO, ff = "['’]", nO = "[" + Mu + "]", Xg = "[" + Kg + "]", Iu = "[" + jg + "]", Zg = "\\d+", rO = "[" + Yg + "]", Qg = "[" + zg + "]", Jg = "[^" + Mu + Kg + Zg + Yg + zg + Gg + "]", hf = "\\ud83c[\\udffb-\\udfff]", iO = "(?:" + Iu + "|" + hf + ")", ev = "[^" + Mu + "]", pf = "(?:\\ud83c[\\udde6-\\uddff]){2}", mf = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xo = "[" + Gg + "]", tv = "\\u200d", nv = "(?:" + Qg + "|" + Jg + ")", aO = "(?:" + Xo + "|" + Jg + ")", rv = "(?:" + ff + "(?:d|ll|m|re|s|t|ve))?", iv = "(?:" + ff + "(?:D|LL|M|RE|S|T|VE))?", av = iO + "?", ov = "[" + qg + "]?", oO = "(?:" + tv + "(?:" + [ev, pf, mf].join("|") + ")" + ov + av + ")*", sO = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", lO = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", sv = ov + av + oO, uO = "(?:" + [rO, pf, mf].join("|") + ")" + sv, cO = "(?:" + [ev + Iu + "?", Iu, pf, mf, nO].join("|") + ")", dO = RegExp(ff, "g"), fO = RegExp(Iu, "g"), gf = RegExp(hf + "(?=" + hf + ")|" + cO + sv, "g"), hO = RegExp([
        Xo + "?" + Qg + "+" + rv + "(?=" + [Xg, Xo, "$"].join("|") + ")",
        aO + "+" + iv + "(?=" + [Xg, Xo + nv, "$"].join("|") + ")",
        Xo + "?" + nv + "+" + rv,
        Xo + "+" + iv,
        lO,
        sO,
        Zg,
        uO
      ].join("|"), "g"), pO = RegExp("[" + tv + Mu + jg + qg + "]"), mO = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, gO = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], vO = -1, tn = {};
      tn[F] = tn[se] = tn[Pe] = tn[Ye] = tn[gt] = tn[mn] = tn[Ir] = tn[de] = tn[Ne] = !0, tn[$] = tn[Y] = tn[ae] = tn[it] = tn[_e] = tn[He] = tn[Bt] = tn[Be] = tn[ue] = tn[Ce] = tn[qt] = tn[R] = tn[V] = tn[ge] = tn[mt] = !1;
      var Zt = {};
      Zt[$] = Zt[Y] = Zt[ae] = Zt[_e] = Zt[it] = Zt[He] = Zt[F] = Zt[se] = Zt[Pe] = Zt[Ye] = Zt[gt] = Zt[ue] = Zt[Ce] = Zt[qt] = Zt[R] = Zt[V] = Zt[ge] = Zt[Fe] = Zt[mn] = Zt[Ir] = Zt[de] = Zt[Ne] = !0, Zt[Bt] = Zt[Be] = Zt[mt] = !1;
      var _O = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, yO = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, bO = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, wO = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, xO = parseFloat, EO = parseInt, lv = typeof Yc == "object" && Yc && Yc.Object === Object && Yc, TO = typeof self == "object" && self && self.Object === Object && self, Hn = lv || TO || Function("return this")(), vf = t && !t.nodeType && t, no = vf && !0 && e && !e.nodeType && e, uv = no && no.exports === vf, _f = uv && lv.process, qr = function() {
        try {
          var z = no && no.require && no.require("util").types;
          return z || _f && _f.binding && _f.binding("util");
        } catch {
        }
      }(), cv = qr && qr.isArrayBuffer, dv = qr && qr.isDate, fv = qr && qr.isMap, hv = qr && qr.isRegExp, pv = qr && qr.isSet, mv = qr && qr.isTypedArray;
      function Nr(z, le, re) {
        switch (re.length) {
          case 0:
            return z.call(le);
          case 1:
            return z.call(le, re[0]);
          case 2:
            return z.call(le, re[0], re[1]);
          case 3:
            return z.call(le, re[0], re[1], re[2]);
        }
        return z.apply(le, re);
      }
      function kO(z, le, re, Me) {
        for (var at = -1, It = z == null ? 0 : z.length; ++at < It; ) {
          var Dn = z[at];
          le(Me, Dn, re(Dn), z);
        }
        return Me;
      }
      function Kr(z, le) {
        for (var re = -1, Me = z == null ? 0 : z.length; ++re < Me && le(z[re], re, z) !== !1; )
          ;
        return z;
      }
      function SO(z, le) {
        for (var re = z == null ? 0 : z.length; re-- && le(z[re], re, z) !== !1; )
          ;
        return z;
      }
      function gv(z, le) {
        for (var re = -1, Me = z == null ? 0 : z.length; ++re < Me; )
          if (!le(z[re], re, z))
            return !1;
        return !0;
      }
      function va(z, le) {
        for (var re = -1, Me = z == null ? 0 : z.length, at = 0, It = []; ++re < Me; ) {
          var Dn = z[re];
          le(Dn, re, z) && (It[at++] = Dn);
        }
        return It;
      }
      function Nu(z, le) {
        var re = z == null ? 0 : z.length;
        return !!re && Zo(z, le, 0) > -1;
      }
      function yf(z, le, re) {
        for (var Me = -1, at = z == null ? 0 : z.length; ++Me < at; )
          if (re(le, z[Me]))
            return !0;
        return !1;
      }
      function ln(z, le) {
        for (var re = -1, Me = z == null ? 0 : z.length, at = Array(Me); ++re < Me; )
          at[re] = le(z[re], re, z);
        return at;
      }
      function _a(z, le) {
        for (var re = -1, Me = le.length, at = z.length; ++re < Me; )
          z[at + re] = le[re];
        return z;
      }
      function bf(z, le, re, Me) {
        var at = -1, It = z == null ? 0 : z.length;
        for (Me && It && (re = z[++at]); ++at < It; )
          re = le(re, z[at], at, z);
        return re;
      }
      function OO(z, le, re, Me) {
        var at = z == null ? 0 : z.length;
        for (Me && at && (re = z[--at]); at--; )
          re = le(re, z[at], at, z);
        return re;
      }
      function wf(z, le) {
        for (var re = -1, Me = z == null ? 0 : z.length; ++re < Me; )
          if (le(z[re], re, z))
            return !0;
        return !1;
      }
      var CO = xf("length");
      function AO(z) {
        return z.split("");
      }
      function DO(z) {
        return z.match($S) || [];
      }
      function vv(z, le, re) {
        var Me;
        return re(z, function(at, It, Dn) {
          if (le(at, It, Dn))
            return Me = It, !1;
        }), Me;
      }
      function Lu(z, le, re, Me) {
        for (var at = z.length, It = re + (Me ? 1 : -1); Me ? It-- : ++It < at; )
          if (le(z[It], It, z))
            return It;
        return -1;
      }
      function Zo(z, le, re) {
        return le === le ? WO(z, le, re) : Lu(z, _v, re);
      }
      function PO(z, le, re, Me) {
        for (var at = re - 1, It = z.length; ++at < It; )
          if (Me(z[at], le))
            return at;
        return -1;
      }
      function _v(z) {
        return z !== z;
      }
      function yv(z, le) {
        var re = z == null ? 0 : z.length;
        return re ? Tf(z, le) / re : ne;
      }
      function xf(z) {
        return function(le) {
          return le == null ? n : le[z];
        };
      }
      function Ef(z) {
        return function(le) {
          return z == null ? n : z[le];
        };
      }
      function bv(z, le, re, Me, at) {
        return at(z, function(It, Dn, Kt) {
          re = Me ? (Me = !1, It) : le(re, It, Dn, Kt);
        }), re;
      }
      function MO(z, le) {
        var re = z.length;
        for (z.sort(le); re--; )
          z[re] = z[re].value;
        return z;
      }
      function Tf(z, le) {
        for (var re, Me = -1, at = z.length; ++Me < at; ) {
          var It = le(z[Me]);
          It !== n && (re = re === n ? It : re + It);
        }
        return re;
      }
      function kf(z, le) {
        for (var re = -1, Me = Array(z); ++re < z; )
          Me[re] = le(re);
        return Me;
      }
      function IO(z, le) {
        return ln(le, function(re) {
          return [re, z[re]];
        });
      }
      function wv(z) {
        return z && z.slice(0, kv(z) + 1).replace(df, "");
      }
      function Lr(z) {
        return function(le) {
          return z(le);
        };
      }
      function Sf(z, le) {
        return ln(le, function(re) {
          return z[re];
        });
      }
      function zs(z, le) {
        return z.has(le);
      }
      function xv(z, le) {
        for (var re = -1, Me = z.length; ++re < Me && Zo(le, z[re], 0) > -1; )
          ;
        return re;
      }
      function Ev(z, le) {
        for (var re = z.length; re-- && Zo(le, z[re], 0) > -1; )
          ;
        return re;
      }
      function NO(z, le) {
        for (var re = z.length, Me = 0; re--; )
          z[re] === le && ++Me;
        return Me;
      }
      var LO = Ef(_O), RO = Ef(yO);
      function FO(z) {
        return "\\" + wO[z];
      }
      function $O(z, le) {
        return z == null ? n : z[le];
      }
      function Qo(z) {
        return pO.test(z);
      }
      function VO(z) {
        return mO.test(z);
      }
      function BO(z) {
        for (var le, re = []; !(le = z.next()).done; )
          re.push(le.value);
        return re;
      }
      function Of(z) {
        var le = -1, re = Array(z.size);
        return z.forEach(function(Me, at) {
          re[++le] = [at, Me];
        }), re;
      }
      function Tv(z, le) {
        return function(re) {
          return z(le(re));
        };
      }
      function ya(z, le) {
        for (var re = -1, Me = z.length, at = 0, It = []; ++re < Me; ) {
          var Dn = z[re];
          (Dn === le || Dn === f) && (z[re] = f, It[at++] = re);
        }
        return It;
      }
      function Ru(z) {
        var le = -1, re = Array(z.size);
        return z.forEach(function(Me) {
          re[++le] = Me;
        }), re;
      }
      function UO(z) {
        var le = -1, re = Array(z.size);
        return z.forEach(function(Me) {
          re[++le] = [Me, Me];
        }), re;
      }
      function WO(z, le, re) {
        for (var Me = re - 1, at = z.length; ++Me < at; )
          if (z[Me] === le)
            return Me;
        return -1;
      }
      function HO(z, le, re) {
        for (var Me = re + 1; Me--; )
          if (z[Me] === le)
            return Me;
        return Me;
      }
      function Jo(z) {
        return Qo(z) ? YO(z) : CO(z);
      }
      function di(z) {
        return Qo(z) ? zO(z) : AO(z);
      }
      function kv(z) {
        for (var le = z.length; le-- && NS.test(z.charAt(le)); )
          ;
        return le;
      }
      var jO = Ef(bO);
      function YO(z) {
        for (var le = gf.lastIndex = 0; gf.test(z); )
          ++le;
        return le;
      }
      function zO(z) {
        return z.match(gf) || [];
      }
      function GO(z) {
        return z.match(hO) || [];
      }
      var qO = function z(le) {
        le = le == null ? Hn : es.defaults(Hn.Object(), le, es.pick(Hn, gO));
        var re = le.Array, Me = le.Date, at = le.Error, It = le.Function, Dn = le.Math, Kt = le.Object, Cf = le.RegExp, KO = le.String, Xr = le.TypeError, Fu = re.prototype, XO = It.prototype, ts = Kt.prototype, $u = le["__core-js_shared__"], Vu = XO.toString, Ut = ts.hasOwnProperty, ZO = 0, Sv = function() {
          var l = /[^.]+$/.exec($u && $u.keys && $u.keys.IE_PROTO || "");
          return l ? "Symbol(src)_1." + l : "";
        }(), Bu = ts.toString, QO = Vu.call(Kt), JO = Hn._, eC = Cf(
          "^" + Vu.call(Ut).replace(cf, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Uu = uv ? le.Buffer : n, ba = le.Symbol, Wu = le.Uint8Array, Ov = Uu ? Uu.allocUnsafe : n, Hu = Tv(Kt.getPrototypeOf, Kt), Cv = Kt.create, Av = ts.propertyIsEnumerable, ju = Fu.splice, Dv = ba ? ba.isConcatSpreadable : n, Gs = ba ? ba.iterator : n, ro = ba ? ba.toStringTag : n, Yu = function() {
          try {
            var l = lo(Kt, "defineProperty");
            return l({}, "", {}), l;
          } catch {
          }
        }(), tC = le.clearTimeout !== Hn.clearTimeout && le.clearTimeout, nC = Me && Me.now !== Hn.Date.now && Me.now, rC = le.setTimeout !== Hn.setTimeout && le.setTimeout, zu = Dn.ceil, Gu = Dn.floor, Af = Kt.getOwnPropertySymbols, iC = Uu ? Uu.isBuffer : n, Pv = le.isFinite, aC = Fu.join, oC = Tv(Kt.keys, Kt), Pn = Dn.max, Zn = Dn.min, sC = Me.now, lC = le.parseInt, Mv = Dn.random, uC = Fu.reverse, Df = lo(le, "DataView"), qs = lo(le, "Map"), Pf = lo(le, "Promise"), ns = lo(le, "Set"), Ks = lo(le, "WeakMap"), Xs = lo(Kt, "create"), qu = Ks && new Ks(), rs = {}, cC = uo(Df), dC = uo(qs), fC = uo(Pf), hC = uo(ns), pC = uo(Ks), Ku = ba ? ba.prototype : n, Zs = Ku ? Ku.valueOf : n, Iv = Ku ? Ku.toString : n;
        function A(l) {
          if (gn(l) && !ot(l) && !(l instanceof bt)) {
            if (l instanceof Zr)
              return l;
            if (Ut.call(l, "__wrapped__"))
              return N0(l);
          }
          return new Zr(l);
        }
        var is = /* @__PURE__ */ function() {
          function l() {
          }
          return function(c) {
            if (!fn(c))
              return {};
            if (Cv)
              return Cv(c);
            l.prototype = c;
            var h = new l();
            return l.prototype = n, h;
          };
        }();
        function Xu() {
        }
        function Zr(l, c) {
          this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = n;
        }
        A.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Ys,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: AS,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Wg,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: A
          }
        }, A.prototype = Xu.prototype, A.prototype.constructor = A, Zr.prototype = is(Xu.prototype), Zr.prototype.constructor = Zr;
        function bt(l) {
          this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = J, this.__views__ = [];
        }
        function mC() {
          var l = new bt(this.__wrapped__);
          return l.__actions__ = br(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = br(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = br(this.__views__), l;
        }
        function gC() {
          if (this.__filtered__) {
            var l = new bt(this);
            l.__dir__ = -1, l.__filtered__ = !0;
          } else
            l = this.clone(), l.__dir__ *= -1;
          return l;
        }
        function vC() {
          var l = this.__wrapped__.value(), c = this.__dir__, h = ot(l), _ = c < 0, E = h ? l.length : 0, D = A2(0, E, this.__views__), L = D.start, B = D.end, q = B - L, he = _ ? B : L - 1, pe = this.__iteratees__, ve = pe.length, Se = 0, Ue = Zn(q, this.__takeCount__);
          if (!h || !_ && E == q && Ue == q)
            return r0(l, this.__actions__);
          var Ze = [];
          e:
            for (; q-- && Se < Ue; ) {
              he += c;
              for (var ut = -1, Qe = l[he]; ++ut < ve; ) {
                var vt = pe[ut], xt = vt.iteratee, $r = vt.type, dr = xt(Qe);
                if ($r == G)
                  Qe = dr;
                else if (!dr) {
                  if ($r == we)
                    continue e;
                  break e;
                }
              }
              Ze[Se++] = Qe;
            }
          return Ze;
        }
        bt.prototype = is(Xu.prototype), bt.prototype.constructor = bt;
        function io(l) {
          var c = -1, h = l == null ? 0 : l.length;
          for (this.clear(); ++c < h; ) {
            var _ = l[c];
            this.set(_[0], _[1]);
          }
        }
        function _C() {
          this.__data__ = Xs ? Xs(null) : {}, this.size = 0;
        }
        function yC(l) {
          var c = this.has(l) && delete this.__data__[l];
          return this.size -= c ? 1 : 0, c;
        }
        function bC(l) {
          var c = this.__data__;
          if (Xs) {
            var h = c[l];
            return h === u ? n : h;
          }
          return Ut.call(c, l) ? c[l] : n;
        }
        function wC(l) {
          var c = this.__data__;
          return Xs ? c[l] !== n : Ut.call(c, l);
        }
        function xC(l, c) {
          var h = this.__data__;
          return this.size += this.has(l) ? 0 : 1, h[l] = Xs && c === n ? u : c, this;
        }
        io.prototype.clear = _C, io.prototype.delete = yC, io.prototype.get = bC, io.prototype.has = wC, io.prototype.set = xC;
        function Hi(l) {
          var c = -1, h = l == null ? 0 : l.length;
          for (this.clear(); ++c < h; ) {
            var _ = l[c];
            this.set(_[0], _[1]);
          }
        }
        function EC() {
          this.__data__ = [], this.size = 0;
        }
        function TC(l) {
          var c = this.__data__, h = Zu(c, l);
          if (h < 0)
            return !1;
          var _ = c.length - 1;
          return h == _ ? c.pop() : ju.call(c, h, 1), --this.size, !0;
        }
        function kC(l) {
          var c = this.__data__, h = Zu(c, l);
          return h < 0 ? n : c[h][1];
        }
        function SC(l) {
          return Zu(this.__data__, l) > -1;
        }
        function OC(l, c) {
          var h = this.__data__, _ = Zu(h, l);
          return _ < 0 ? (++this.size, h.push([l, c])) : h[_][1] = c, this;
        }
        Hi.prototype.clear = EC, Hi.prototype.delete = TC, Hi.prototype.get = kC, Hi.prototype.has = SC, Hi.prototype.set = OC;
        function ji(l) {
          var c = -1, h = l == null ? 0 : l.length;
          for (this.clear(); ++c < h; ) {
            var _ = l[c];
            this.set(_[0], _[1]);
          }
        }
        function CC() {
          this.size = 0, this.__data__ = {
            hash: new io(),
            map: new (qs || Hi)(),
            string: new io()
          };
        }
        function AC(l) {
          var c = uc(this, l).delete(l);
          return this.size -= c ? 1 : 0, c;
        }
        function DC(l) {
          return uc(this, l).get(l);
        }
        function PC(l) {
          return uc(this, l).has(l);
        }
        function MC(l, c) {
          var h = uc(this, l), _ = h.size;
          return h.set(l, c), this.size += h.size == _ ? 0 : 1, this;
        }
        ji.prototype.clear = CC, ji.prototype.delete = AC, ji.prototype.get = DC, ji.prototype.has = PC, ji.prototype.set = MC;
        function ao(l) {
          var c = -1, h = l == null ? 0 : l.length;
          for (this.__data__ = new ji(); ++c < h; )
            this.add(l[c]);
        }
        function IC(l) {
          return this.__data__.set(l, u), this;
        }
        function NC(l) {
          return this.__data__.has(l);
        }
        ao.prototype.add = ao.prototype.push = IC, ao.prototype.has = NC;
        function fi(l) {
          var c = this.__data__ = new Hi(l);
          this.size = c.size;
        }
        function LC() {
          this.__data__ = new Hi(), this.size = 0;
        }
        function RC(l) {
          var c = this.__data__, h = c.delete(l);
          return this.size = c.size, h;
        }
        function FC(l) {
          return this.__data__.get(l);
        }
        function $C(l) {
          return this.__data__.has(l);
        }
        function VC(l, c) {
          var h = this.__data__;
          if (h instanceof Hi) {
            var _ = h.__data__;
            if (!qs || _.length < i - 1)
              return _.push([l, c]), this.size = ++h.size, this;
            h = this.__data__ = new ji(_);
          }
          return h.set(l, c), this.size = h.size, this;
        }
        fi.prototype.clear = LC, fi.prototype.delete = RC, fi.prototype.get = FC, fi.prototype.has = $C, fi.prototype.set = VC;
        function Nv(l, c) {
          var h = ot(l), _ = !h && co(l), E = !h && !_ && ka(l), D = !h && !_ && !E && ls(l), L = h || _ || E || D, B = L ? kf(l.length, KO) : [], q = B.length;
          for (var he in l)
            (c || Ut.call(l, he)) && !(L && // Safari 9 has enumerable `arguments.length` in strict mode.
            (he == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            E && (he == "offset" || he == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            D && (he == "buffer" || he == "byteLength" || he == "byteOffset") || // Skip index properties.
            qi(he, q))) && B.push(he);
          return B;
        }
        function Lv(l) {
          var c = l.length;
          return c ? l[Wf(0, c - 1)] : n;
        }
        function BC(l, c) {
          return cc(br(l), oo(c, 0, l.length));
        }
        function UC(l) {
          return cc(br(l));
        }
        function Mf(l, c, h) {
          (h !== n && !hi(l[c], h) || h === n && !(c in l)) && Yi(l, c, h);
        }
        function Qs(l, c, h) {
          var _ = l[c];
          (!(Ut.call(l, c) && hi(_, h)) || h === n && !(c in l)) && Yi(l, c, h);
        }
        function Zu(l, c) {
          for (var h = l.length; h--; )
            if (hi(l[h][0], c))
              return h;
          return -1;
        }
        function WC(l, c, h, _) {
          return wa(l, function(E, D, L) {
            c(_, E, h(E), L);
          }), _;
        }
        function Rv(l, c) {
          return l && xi(c, Fn(c), l);
        }
        function HC(l, c) {
          return l && xi(c, xr(c), l);
        }
        function Yi(l, c, h) {
          c == "__proto__" && Yu ? Yu(l, c, {
            configurable: !0,
            enumerable: !0,
            value: h,
            writable: !0
          }) : l[c] = h;
        }
        function If(l, c) {
          for (var h = -1, _ = c.length, E = re(_), D = l == null; ++h < _; )
            E[h] = D ? n : hh(l, c[h]);
          return E;
        }
        function oo(l, c, h) {
          return l === l && (h !== n && (l = l <= h ? l : h), c !== n && (l = l >= c ? l : c)), l;
        }
        function Qr(l, c, h, _, E, D) {
          var L, B = c & p, q = c & m, he = c & g;
          if (h && (L = E ? h(l, _, E, D) : h(l)), L !== n)
            return L;
          if (!fn(l))
            return l;
          var pe = ot(l);
          if (pe) {
            if (L = P2(l), !B)
              return br(l, L);
          } else {
            var ve = Qn(l), Se = ve == Be || ve == Xe;
            if (ka(l))
              return o0(l, B);
            if (ve == qt || ve == $ || Se && !E) {
              if (L = q || Se ? {} : k0(l), !B)
                return q ? b2(l, HC(L, l)) : y2(l, Rv(L, l));
            } else {
              if (!Zt[ve])
                return E ? l : {};
              L = M2(l, ve, B);
            }
          }
          D || (D = new fi());
          var Ue = D.get(l);
          if (Ue)
            return Ue;
          D.set(l, L), e_(l) ? l.forEach(function(Qe) {
            L.add(Qr(Qe, c, h, Qe, l, D));
          }) : Q0(l) && l.forEach(function(Qe, vt) {
            L.set(vt, Qr(Qe, c, h, vt, l, D));
          });
          var Ze = he ? q ? Jf : Qf : q ? xr : Fn, ut = pe ? n : Ze(l);
          return Kr(ut || l, function(Qe, vt) {
            ut && (vt = Qe, Qe = l[vt]), Qs(L, vt, Qr(Qe, c, h, vt, l, D));
          }), L;
        }
        function jC(l) {
          var c = Fn(l);
          return function(h) {
            return Fv(h, l, c);
          };
        }
        function Fv(l, c, h) {
          var _ = h.length;
          if (l == null)
            return !_;
          for (l = Kt(l); _--; ) {
            var E = h[_], D = c[E], L = l[E];
            if (L === n && !(E in l) || !D(L))
              return !1;
          }
          return !0;
        }
        function $v(l, c, h) {
          if (typeof l != "function")
            throw new Xr(o);
          return al(function() {
            l.apply(n, h);
          }, c);
        }
        function Js(l, c, h, _) {
          var E = -1, D = Nu, L = !0, B = l.length, q = [], he = c.length;
          if (!B)
            return q;
          h && (c = ln(c, Lr(h))), _ ? (D = yf, L = !1) : c.length >= i && (D = zs, L = !1, c = new ao(c));
          e:
            for (; ++E < B; ) {
              var pe = l[E], ve = h == null ? pe : h(pe);
              if (pe = _ || pe !== 0 ? pe : 0, L && ve === ve) {
                for (var Se = he; Se--; )
                  if (c[Se] === ve)
                    continue e;
                q.push(pe);
              } else D(c, ve, _) || q.push(pe);
            }
          return q;
        }
        var wa = d0(wi), Vv = d0(Lf, !0);
        function YC(l, c) {
          var h = !0;
          return wa(l, function(_, E, D) {
            return h = !!c(_, E, D), h;
          }), h;
        }
        function Qu(l, c, h) {
          for (var _ = -1, E = l.length; ++_ < E; ) {
            var D = l[_], L = c(D);
            if (L != null && (B === n ? L === L && !Fr(L) : h(L, B)))
              var B = L, q = D;
          }
          return q;
        }
        function zC(l, c, h, _) {
          var E = l.length;
          for (h = lt(h), h < 0 && (h = -h > E ? 0 : E + h), _ = _ === n || _ > E ? E : lt(_), _ < 0 && (_ += E), _ = h > _ ? 0 : n_(_); h < _; )
            l[h++] = c;
          return l;
        }
        function Bv(l, c) {
          var h = [];
          return wa(l, function(_, E, D) {
            c(_, E, D) && h.push(_);
          }), h;
        }
        function jn(l, c, h, _, E) {
          var D = -1, L = l.length;
          for (h || (h = N2), E || (E = []); ++D < L; ) {
            var B = l[D];
            c > 0 && h(B) ? c > 1 ? jn(B, c - 1, h, _, E) : _a(E, B) : _ || (E[E.length] = B);
          }
          return E;
        }
        var Nf = f0(), Uv = f0(!0);
        function wi(l, c) {
          return l && Nf(l, c, Fn);
        }
        function Lf(l, c) {
          return l && Uv(l, c, Fn);
        }
        function Ju(l, c) {
          return va(c, function(h) {
            return Ki(l[h]);
          });
        }
        function so(l, c) {
          c = Ea(c, l);
          for (var h = 0, _ = c.length; l != null && h < _; )
            l = l[Ei(c[h++])];
          return h && h == _ ? l : n;
        }
        function Wv(l, c, h) {
          var _ = c(l);
          return ot(l) ? _ : _a(_, h(l));
        }
        function ur(l) {
          return l == null ? l === n ? Pt : Pr : ro && ro in Kt(l) ? C2(l) : U2(l);
        }
        function Rf(l, c) {
          return l > c;
        }
        function GC(l, c) {
          return l != null && Ut.call(l, c);
        }
        function qC(l, c) {
          return l != null && c in Kt(l);
        }
        function KC(l, c, h) {
          return l >= Zn(c, h) && l < Pn(c, h);
        }
        function Ff(l, c, h) {
          for (var _ = h ? yf : Nu, E = l[0].length, D = l.length, L = D, B = re(D), q = 1 / 0, he = []; L--; ) {
            var pe = l[L];
            L && c && (pe = ln(pe, Lr(c))), q = Zn(pe.length, q), B[L] = !h && (c || E >= 120 && pe.length >= 120) ? new ao(L && pe) : n;
          }
          pe = l[0];
          var ve = -1, Se = B[0];
          e:
            for (; ++ve < E && he.length < q; ) {
              var Ue = pe[ve], Ze = c ? c(Ue) : Ue;
              if (Ue = h || Ue !== 0 ? Ue : 0, !(Se ? zs(Se, Ze) : _(he, Ze, h))) {
                for (L = D; --L; ) {
                  var ut = B[L];
                  if (!(ut ? zs(ut, Ze) : _(l[L], Ze, h)))
                    continue e;
                }
                Se && Se.push(Ze), he.push(Ue);
              }
            }
          return he;
        }
        function XC(l, c, h, _) {
          return wi(l, function(E, D, L) {
            c(_, h(E), D, L);
          }), _;
        }
        function el(l, c, h) {
          c = Ea(c, l), l = A0(l, c);
          var _ = l == null ? l : l[Ei(ei(c))];
          return _ == null ? n : Nr(_, l, h);
        }
        function Hv(l) {
          return gn(l) && ur(l) == $;
        }
        function ZC(l) {
          return gn(l) && ur(l) == ae;
        }
        function QC(l) {
          return gn(l) && ur(l) == He;
        }
        function tl(l, c, h, _, E) {
          return l === c ? !0 : l == null || c == null || !gn(l) && !gn(c) ? l !== l && c !== c : JC(l, c, h, _, tl, E);
        }
        function JC(l, c, h, _, E, D) {
          var L = ot(l), B = ot(c), q = L ? Y : Qn(l), he = B ? Y : Qn(c);
          q = q == $ ? qt : q, he = he == $ ? qt : he;
          var pe = q == qt, ve = he == qt, Se = q == he;
          if (Se && ka(l)) {
            if (!ka(c))
              return !1;
            L = !0, pe = !1;
          }
          if (Se && !pe)
            return D || (D = new fi()), L || ls(l) ? x0(l, c, h, _, E, D) : S2(l, c, q, h, _, E, D);
          if (!(h & v)) {
            var Ue = pe && Ut.call(l, "__wrapped__"), Ze = ve && Ut.call(c, "__wrapped__");
            if (Ue || Ze) {
              var ut = Ue ? l.value() : l, Qe = Ze ? c.value() : c;
              return D || (D = new fi()), E(ut, Qe, h, _, D);
            }
          }
          return Se ? (D || (D = new fi()), O2(l, c, h, _, E, D)) : !1;
        }
        function e2(l) {
          return gn(l) && Qn(l) == ue;
        }
        function $f(l, c, h, _) {
          var E = h.length, D = E, L = !_;
          if (l == null)
            return !D;
          for (l = Kt(l); E--; ) {
            var B = h[E];
            if (L && B[2] ? B[1] !== l[B[0]] : !(B[0] in l))
              return !1;
          }
          for (; ++E < D; ) {
            B = h[E];
            var q = B[0], he = l[q], pe = B[1];
            if (L && B[2]) {
              if (he === n && !(q in l))
                return !1;
            } else {
              var ve = new fi();
              if (_)
                var Se = _(he, pe, q, l, c, ve);
              if (!(Se === n ? tl(pe, he, v | b, _, ve) : Se))
                return !1;
            }
          }
          return !0;
        }
        function jv(l) {
          if (!fn(l) || R2(l))
            return !1;
          var c = Ki(l) ? eC : jS;
          return c.test(uo(l));
        }
        function t2(l) {
          return gn(l) && ur(l) == R;
        }
        function n2(l) {
          return gn(l) && Qn(l) == V;
        }
        function r2(l) {
          return gn(l) && gc(l.length) && !!tn[ur(l)];
        }
        function Yv(l) {
          return typeof l == "function" ? l : l == null ? Er : typeof l == "object" ? ot(l) ? qv(l[0], l[1]) : Gv(l) : h_(l);
        }
        function Vf(l) {
          if (!il(l))
            return oC(l);
          var c = [];
          for (var h in Kt(l))
            Ut.call(l, h) && h != "constructor" && c.push(h);
          return c;
        }
        function i2(l) {
          if (!fn(l))
            return B2(l);
          var c = il(l), h = [];
          for (var _ in l)
            _ == "constructor" && (c || !Ut.call(l, _)) || h.push(_);
          return h;
        }
        function Bf(l, c) {
          return l < c;
        }
        function zv(l, c) {
          var h = -1, _ = wr(l) ? re(l.length) : [];
          return wa(l, function(E, D, L) {
            _[++h] = c(E, D, L);
          }), _;
        }
        function Gv(l) {
          var c = th(l);
          return c.length == 1 && c[0][2] ? O0(c[0][0], c[0][1]) : function(h) {
            return h === l || $f(h, l, c);
          };
        }
        function qv(l, c) {
          return rh(l) && S0(c) ? O0(Ei(l), c) : function(h) {
            var _ = hh(h, l);
            return _ === n && _ === c ? ph(h, l) : tl(c, _, v | b);
          };
        }
        function ec(l, c, h, _, E) {
          l !== c && Nf(c, function(D, L) {
            if (E || (E = new fi()), fn(D))
              a2(l, c, L, h, ec, _, E);
            else {
              var B = _ ? _(ah(l, L), D, L + "", l, c, E) : n;
              B === n && (B = D), Mf(l, L, B);
            }
          }, xr);
        }
        function a2(l, c, h, _, E, D, L) {
          var B = ah(l, h), q = ah(c, h), he = L.get(q);
          if (he) {
            Mf(l, h, he);
            return;
          }
          var pe = D ? D(B, q, h + "", l, c, L) : n, ve = pe === n;
          if (ve) {
            var Se = ot(q), Ue = !Se && ka(q), Ze = !Se && !Ue && ls(q);
            pe = q, Se || Ue || Ze ? ot(B) ? pe = B : bn(B) ? pe = br(B) : Ue ? (ve = !1, pe = o0(q, !0)) : Ze ? (ve = !1, pe = s0(q, !0)) : pe = [] : ol(q) || co(q) ? (pe = B, co(B) ? pe = r_(B) : (!fn(B) || Ki(B)) && (pe = k0(q))) : ve = !1;
          }
          ve && (L.set(q, pe), E(pe, q, _, D, L), L.delete(q)), Mf(l, h, pe);
        }
        function Kv(l, c) {
          var h = l.length;
          if (h)
            return c += c < 0 ? h : 0, qi(c, h) ? l[c] : n;
        }
        function Xv(l, c, h) {
          c.length ? c = ln(c, function(D) {
            return ot(D) ? function(L) {
              return so(L, D.length === 1 ? D[0] : D);
            } : D;
          }) : c = [Er];
          var _ = -1;
          c = ln(c, Lr(Ke()));
          var E = zv(l, function(D, L, B) {
            var q = ln(c, function(he) {
              return he(D);
            });
            return { criteria: q, index: ++_, value: D };
          });
          return MO(E, function(D, L) {
            return _2(D, L, h);
          });
        }
        function o2(l, c) {
          return Zv(l, c, function(h, _) {
            return ph(l, _);
          });
        }
        function Zv(l, c, h) {
          for (var _ = -1, E = c.length, D = {}; ++_ < E; ) {
            var L = c[_], B = so(l, L);
            h(B, L) && nl(D, Ea(L, l), B);
          }
          return D;
        }
        function s2(l) {
          return function(c) {
            return so(c, l);
          };
        }
        function Uf(l, c, h, _) {
          var E = _ ? PO : Zo, D = -1, L = c.length, B = l;
          for (l === c && (c = br(c)), h && (B = ln(l, Lr(h))); ++D < L; )
            for (var q = 0, he = c[D], pe = h ? h(he) : he; (q = E(B, pe, q, _)) > -1; )
              B !== l && ju.call(B, q, 1), ju.call(l, q, 1);
          return l;
        }
        function Qv(l, c) {
          for (var h = l ? c.length : 0, _ = h - 1; h--; ) {
            var E = c[h];
            if (h == _ || E !== D) {
              var D = E;
              qi(E) ? ju.call(l, E, 1) : Yf(l, E);
            }
          }
          return l;
        }
        function Wf(l, c) {
          return l + Gu(Mv() * (c - l + 1));
        }
        function l2(l, c, h, _) {
          for (var E = -1, D = Pn(zu((c - l) / (h || 1)), 0), L = re(D); D--; )
            L[_ ? D : ++E] = l, l += h;
          return L;
        }
        function Hf(l, c) {
          var h = "";
          if (!l || c < 1 || c > H)
            return h;
          do
            c % 2 && (h += l), c = Gu(c / 2), c && (l += l);
          while (c);
          return h;
        }
        function ct(l, c) {
          return oh(C0(l, c, Er), l + "");
        }
        function u2(l) {
          return Lv(us(l));
        }
        function c2(l, c) {
          var h = us(l);
          return cc(h, oo(c, 0, h.length));
        }
        function nl(l, c, h, _) {
          if (!fn(l))
            return l;
          c = Ea(c, l);
          for (var E = -1, D = c.length, L = D - 1, B = l; B != null && ++E < D; ) {
            var q = Ei(c[E]), he = h;
            if (q === "__proto__" || q === "constructor" || q === "prototype")
              return l;
            if (E != L) {
              var pe = B[q];
              he = _ ? _(pe, q, B) : n, he === n && (he = fn(pe) ? pe : qi(c[E + 1]) ? [] : {});
            }
            Qs(B, q, he), B = B[q];
          }
          return l;
        }
        var Jv = qu ? function(l, c) {
          return qu.set(l, c), l;
        } : Er, d2 = Yu ? function(l, c) {
          return Yu(l, "toString", {
            configurable: !0,
            enumerable: !1,
            value: gh(c),
            writable: !0
          });
        } : Er;
        function f2(l) {
          return cc(us(l));
        }
        function Jr(l, c, h) {
          var _ = -1, E = l.length;
          c < 0 && (c = -c > E ? 0 : E + c), h = h > E ? E : h, h < 0 && (h += E), E = c > h ? 0 : h - c >>> 0, c >>>= 0;
          for (var D = re(E); ++_ < E; )
            D[_] = l[_ + c];
          return D;
        }
        function h2(l, c) {
          var h;
          return wa(l, function(_, E, D) {
            return h = c(_, E, D), !h;
          }), !!h;
        }
        function tc(l, c, h) {
          var _ = 0, E = l == null ? _ : l.length;
          if (typeof c == "number" && c === c && E <= xe) {
            for (; _ < E; ) {
              var D = _ + E >>> 1, L = l[D];
              L !== null && !Fr(L) && (h ? L <= c : L < c) ? _ = D + 1 : E = D;
            }
            return E;
          }
          return jf(l, c, Er, h);
        }
        function jf(l, c, h, _) {
          var E = 0, D = l == null ? 0 : l.length;
          if (D === 0)
            return 0;
          c = h(c);
          for (var L = c !== c, B = c === null, q = Fr(c), he = c === n; E < D; ) {
            var pe = Gu((E + D) / 2), ve = h(l[pe]), Se = ve !== n, Ue = ve === null, Ze = ve === ve, ut = Fr(ve);
            if (L)
              var Qe = _ || Ze;
            else he ? Qe = Ze && (_ || Se) : B ? Qe = Ze && Se && (_ || !Ue) : q ? Qe = Ze && Se && !Ue && (_ || !ut) : Ue || ut ? Qe = !1 : Qe = _ ? ve <= c : ve < c;
            Qe ? E = pe + 1 : D = pe;
          }
          return Zn(D, me);
        }
        function e0(l, c) {
          for (var h = -1, _ = l.length, E = 0, D = []; ++h < _; ) {
            var L = l[h], B = c ? c(L) : L;
            if (!h || !hi(B, q)) {
              var q = B;
              D[E++] = L === 0 ? 0 : L;
            }
          }
          return D;
        }
        function t0(l) {
          return typeof l == "number" ? l : Fr(l) ? ne : +l;
        }
        function Rr(l) {
          if (typeof l == "string")
            return l;
          if (ot(l))
            return ln(l, Rr) + "";
          if (Fr(l))
            return Iv ? Iv.call(l) : "";
          var c = l + "";
          return c == "0" && 1 / l == -y ? "-0" : c;
        }
        function xa(l, c, h) {
          var _ = -1, E = Nu, D = l.length, L = !0, B = [], q = B;
          if (h)
            L = !1, E = yf;
          else if (D >= i) {
            var he = c ? null : T2(l);
            if (he)
              return Ru(he);
            L = !1, E = zs, q = new ao();
          } else
            q = c ? [] : B;
          e:
            for (; ++_ < D; ) {
              var pe = l[_], ve = c ? c(pe) : pe;
              if (pe = h || pe !== 0 ? pe : 0, L && ve === ve) {
                for (var Se = q.length; Se--; )
                  if (q[Se] === ve)
                    continue e;
                c && q.push(ve), B.push(pe);
              } else E(q, ve, h) || (q !== B && q.push(ve), B.push(pe));
            }
          return B;
        }
        function Yf(l, c) {
          return c = Ea(c, l), l = A0(l, c), l == null || delete l[Ei(ei(c))];
        }
        function n0(l, c, h, _) {
          return nl(l, c, h(so(l, c)), _);
        }
        function nc(l, c, h, _) {
          for (var E = l.length, D = _ ? E : -1; (_ ? D-- : ++D < E) && c(l[D], D, l); )
            ;
          return h ? Jr(l, _ ? 0 : D, _ ? D + 1 : E) : Jr(l, _ ? D + 1 : 0, _ ? E : D);
        }
        function r0(l, c) {
          var h = l;
          return h instanceof bt && (h = h.value()), bf(c, function(_, E) {
            return E.func.apply(E.thisArg, _a([_], E.args));
          }, h);
        }
        function zf(l, c, h) {
          var _ = l.length;
          if (_ < 2)
            return _ ? xa(l[0]) : [];
          for (var E = -1, D = re(_); ++E < _; )
            for (var L = l[E], B = -1; ++B < _; )
              B != E && (D[E] = Js(D[E] || L, l[B], c, h));
          return xa(jn(D, 1), c, h);
        }
        function i0(l, c, h) {
          for (var _ = -1, E = l.length, D = c.length, L = {}; ++_ < E; ) {
            var B = _ < D ? c[_] : n;
            h(L, l[_], B);
          }
          return L;
        }
        function Gf(l) {
          return bn(l) ? l : [];
        }
        function qf(l) {
          return typeof l == "function" ? l : Er;
        }
        function Ea(l, c) {
          return ot(l) ? l : rh(l, c) ? [l] : I0(Ft(l));
        }
        var p2 = ct;
        function Ta(l, c, h) {
          var _ = l.length;
          return h = h === n ? _ : h, !c && h >= _ ? l : Jr(l, c, h);
        }
        var a0 = tC || function(l) {
          return Hn.clearTimeout(l);
        };
        function o0(l, c) {
          if (c)
            return l.slice();
          var h = l.length, _ = Ov ? Ov(h) : new l.constructor(h);
          return l.copy(_), _;
        }
        function Kf(l) {
          var c = new l.constructor(l.byteLength);
          return new Wu(c).set(new Wu(l)), c;
        }
        function m2(l, c) {
          var h = c ? Kf(l.buffer) : l.buffer;
          return new l.constructor(h, l.byteOffset, l.byteLength);
        }
        function g2(l) {
          var c = new l.constructor(l.source, Hg.exec(l));
          return c.lastIndex = l.lastIndex, c;
        }
        function v2(l) {
          return Zs ? Kt(Zs.call(l)) : {};
        }
        function s0(l, c) {
          var h = c ? Kf(l.buffer) : l.buffer;
          return new l.constructor(h, l.byteOffset, l.length);
        }
        function l0(l, c) {
          if (l !== c) {
            var h = l !== n, _ = l === null, E = l === l, D = Fr(l), L = c !== n, B = c === null, q = c === c, he = Fr(c);
            if (!B && !he && !D && l > c || D && L && q && !B && !he || _ && L && q || !h && q || !E)
              return 1;
            if (!_ && !D && !he && l < c || he && h && E && !_ && !D || B && h && E || !L && E || !q)
              return -1;
          }
          return 0;
        }
        function _2(l, c, h) {
          for (var _ = -1, E = l.criteria, D = c.criteria, L = E.length, B = h.length; ++_ < L; ) {
            var q = l0(E[_], D[_]);
            if (q) {
              if (_ >= B)
                return q;
              var he = h[_];
              return q * (he == "desc" ? -1 : 1);
            }
          }
          return l.index - c.index;
        }
        function u0(l, c, h, _) {
          for (var E = -1, D = l.length, L = h.length, B = -1, q = c.length, he = Pn(D - L, 0), pe = re(q + he), ve = !_; ++B < q; )
            pe[B] = c[B];
          for (; ++E < L; )
            (ve || E < D) && (pe[h[E]] = l[E]);
          for (; he--; )
            pe[B++] = l[E++];
          return pe;
        }
        function c0(l, c, h, _) {
          for (var E = -1, D = l.length, L = -1, B = h.length, q = -1, he = c.length, pe = Pn(D - B, 0), ve = re(pe + he), Se = !_; ++E < pe; )
            ve[E] = l[E];
          for (var Ue = E; ++q < he; )
            ve[Ue + q] = c[q];
          for (; ++L < B; )
            (Se || E < D) && (ve[Ue + h[L]] = l[E++]);
          return ve;
        }
        function br(l, c) {
          var h = -1, _ = l.length;
          for (c || (c = re(_)); ++h < _; )
            c[h] = l[h];
          return c;
        }
        function xi(l, c, h, _) {
          var E = !h;
          h || (h = {});
          for (var D = -1, L = c.length; ++D < L; ) {
            var B = c[D], q = _ ? _(h[B], l[B], B, h, l) : n;
            q === n && (q = l[B]), E ? Yi(h, B, q) : Qs(h, B, q);
          }
          return h;
        }
        function y2(l, c) {
          return xi(l, nh(l), c);
        }
        function b2(l, c) {
          return xi(l, E0(l), c);
        }
        function rc(l, c) {
          return function(h, _) {
            var E = ot(h) ? kO : WC, D = c ? c() : {};
            return E(h, l, Ke(_, 2), D);
          };
        }
        function as(l) {
          return ct(function(c, h) {
            var _ = -1, E = h.length, D = E > 1 ? h[E - 1] : n, L = E > 2 ? h[2] : n;
            for (D = l.length > 3 && typeof D == "function" ? (E--, D) : n, L && cr(h[0], h[1], L) && (D = E < 3 ? n : D, E = 1), c = Kt(c); ++_ < E; ) {
              var B = h[_];
              B && l(c, B, _, D);
            }
            return c;
          });
        }
        function d0(l, c) {
          return function(h, _) {
            if (h == null)
              return h;
            if (!wr(h))
              return l(h, _);
            for (var E = h.length, D = c ? E : -1, L = Kt(h); (c ? D-- : ++D < E) && _(L[D], D, L) !== !1; )
              ;
            return h;
          };
        }
        function f0(l) {
          return function(c, h, _) {
            for (var E = -1, D = Kt(c), L = _(c), B = L.length; B--; ) {
              var q = L[l ? B : ++E];
              if (h(D[q], q, D) === !1)
                break;
            }
            return c;
          };
        }
        function w2(l, c, h) {
          var _ = c & w, E = rl(l);
          function D() {
            var L = this && this !== Hn && this instanceof D ? E : l;
            return L.apply(_ ? h : this, arguments);
          }
          return D;
        }
        function h0(l) {
          return function(c) {
            c = Ft(c);
            var h = Qo(c) ? di(c) : n, _ = h ? h[0] : c.charAt(0), E = h ? Ta(h, 1).join("") : c.slice(1);
            return _[l]() + E;
          };
        }
        function os(l) {
          return function(c) {
            return bf(d_(c_(c).replace(dO, "")), l, "");
          };
        }
        function rl(l) {
          return function() {
            var c = arguments;
            switch (c.length) {
              case 0:
                return new l();
              case 1:
                return new l(c[0]);
              case 2:
                return new l(c[0], c[1]);
              case 3:
                return new l(c[0], c[1], c[2]);
              case 4:
                return new l(c[0], c[1], c[2], c[3]);
              case 5:
                return new l(c[0], c[1], c[2], c[3], c[4]);
              case 6:
                return new l(c[0], c[1], c[2], c[3], c[4], c[5]);
              case 7:
                return new l(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
            }
            var h = is(l.prototype), _ = l.apply(h, c);
            return fn(_) ? _ : h;
          };
        }
        function x2(l, c, h) {
          var _ = rl(l);
          function E() {
            for (var D = arguments.length, L = re(D), B = D, q = ss(E); B--; )
              L[B] = arguments[B];
            var he = D < 3 && L[0] !== q && L[D - 1] !== q ? [] : ya(L, q);
            if (D -= he.length, D < h)
              return _0(
                l,
                c,
                ic,
                E.placeholder,
                n,
                L,
                he,
                n,
                n,
                h - D
              );
            var pe = this && this !== Hn && this instanceof E ? _ : l;
            return Nr(pe, this, L);
          }
          return E;
        }
        function p0(l) {
          return function(c, h, _) {
            var E = Kt(c);
            if (!wr(c)) {
              var D = Ke(h, 3);
              c = Fn(c), h = function(B) {
                return D(E[B], B, E);
              };
            }
            var L = l(c, h, _);
            return L > -1 ? E[D ? c[L] : L] : n;
          };
        }
        function m0(l) {
          return Gi(function(c) {
            var h = c.length, _ = h, E = Zr.prototype.thru;
            for (l && c.reverse(); _--; ) {
              var D = c[_];
              if (typeof D != "function")
                throw new Xr(o);
              if (E && !L && lc(D) == "wrapper")
                var L = new Zr([], !0);
            }
            for (_ = L ? _ : h; ++_ < h; ) {
              D = c[_];
              var B = lc(D), q = B == "wrapper" ? eh(D) : n;
              q && ih(q[0]) && q[1] == (k | x | C | M) && !q[4].length && q[9] == 1 ? L = L[lc(q[0])].apply(L, q[3]) : L = D.length == 1 && ih(D) ? L[B]() : L.thru(D);
            }
            return function() {
              var he = arguments, pe = he[0];
              if (L && he.length == 1 && ot(pe))
                return L.plant(pe).value();
              for (var ve = 0, Se = h ? c[ve].apply(this, he) : pe; ++ve < h; )
                Se = c[ve].call(this, Se);
              return Se;
            };
          });
        }
        function ic(l, c, h, _, E, D, L, B, q, he) {
          var pe = c & k, ve = c & w, Se = c & T, Ue = c & (x | O), Ze = c & N, ut = Se ? n : rl(l);
          function Qe() {
            for (var vt = arguments.length, xt = re(vt), $r = vt; $r--; )
              xt[$r] = arguments[$r];
            if (Ue)
              var dr = ss(Qe), Vr = NO(xt, dr);
            if (_ && (xt = u0(xt, _, E, Ue)), D && (xt = c0(xt, D, L, Ue)), vt -= Vr, Ue && vt < he) {
              var wn = ya(xt, dr);
              return _0(
                l,
                c,
                ic,
                Qe.placeholder,
                h,
                xt,
                wn,
                B,
                q,
                he - vt
              );
            }
            var pi = ve ? h : this, Zi = Se ? pi[l] : l;
            return vt = xt.length, B ? xt = W2(xt, B) : Ze && vt > 1 && xt.reverse(), pe && q < vt && (xt.length = q), this && this !== Hn && this instanceof Qe && (Zi = ut || rl(Zi)), Zi.apply(pi, xt);
          }
          return Qe;
        }
        function g0(l, c) {
          return function(h, _) {
            return XC(h, l, c(_), {});
          };
        }
        function ac(l, c) {
          return function(h, _) {
            var E;
            if (h === n && _ === n)
              return c;
            if (h !== n && (E = h), _ !== n) {
              if (E === n)
                return _;
              typeof h == "string" || typeof _ == "string" ? (h = Rr(h), _ = Rr(_)) : (h = t0(h), _ = t0(_)), E = l(h, _);
            }
            return E;
          };
        }
        function Xf(l) {
          return Gi(function(c) {
            return c = ln(c, Lr(Ke())), ct(function(h) {
              var _ = this;
              return l(c, function(E) {
                return Nr(E, _, h);
              });
            });
          });
        }
        function oc(l, c) {
          c = c === n ? " " : Rr(c);
          var h = c.length;
          if (h < 2)
            return h ? Hf(c, l) : c;
          var _ = Hf(c, zu(l / Jo(c)));
          return Qo(c) ? Ta(di(_), 0, l).join("") : _.slice(0, l);
        }
        function E2(l, c, h, _) {
          var E = c & w, D = rl(l);
          function L() {
            for (var B = -1, q = arguments.length, he = -1, pe = _.length, ve = re(pe + q), Se = this && this !== Hn && this instanceof L ? D : l; ++he < pe; )
              ve[he] = _[he];
            for (; q--; )
              ve[he++] = arguments[++B];
            return Nr(Se, E ? h : this, ve);
          }
          return L;
        }
        function v0(l) {
          return function(c, h, _) {
            return _ && typeof _ != "number" && cr(c, h, _) && (h = _ = n), c = Xi(c), h === n ? (h = c, c = 0) : h = Xi(h), _ = _ === n ? c < h ? 1 : -1 : Xi(_), l2(c, h, _, l);
          };
        }
        function sc(l) {
          return function(c, h) {
            return typeof c == "string" && typeof h == "string" || (c = ti(c), h = ti(h)), l(c, h);
          };
        }
        function _0(l, c, h, _, E, D, L, B, q, he) {
          var pe = c & x, ve = pe ? L : n, Se = pe ? n : L, Ue = pe ? D : n, Ze = pe ? n : D;
          c |= pe ? C : P, c &= ~(pe ? P : C), c & S || (c &= ~(w | T));
          var ut = [
            l,
            c,
            E,
            Ue,
            ve,
            Ze,
            Se,
            B,
            q,
            he
          ], Qe = h.apply(n, ut);
          return ih(l) && D0(Qe, ut), Qe.placeholder = _, P0(Qe, l, c);
        }
        function Zf(l) {
          var c = Dn[l];
          return function(h, _) {
            if (h = ti(h), _ = _ == null ? 0 : Zn(lt(_), 292), _ && Pv(h)) {
              var E = (Ft(h) + "e").split("e"), D = c(E[0] + "e" + (+E[1] + _));
              return E = (Ft(D) + "e").split("e"), +(E[0] + "e" + (+E[1] - _));
            }
            return c(h);
          };
        }
        var T2 = ns && 1 / Ru(new ns([, -0]))[1] == y ? function(l) {
          return new ns(l);
        } : yh;
        function y0(l) {
          return function(c) {
            var h = Qn(c);
            return h == ue ? Of(c) : h == V ? UO(c) : IO(c, l(c));
          };
        }
        function zi(l, c, h, _, E, D, L, B) {
          var q = c & T;
          if (!q && typeof l != "function")
            throw new Xr(o);
          var he = _ ? _.length : 0;
          if (he || (c &= ~(C | P), _ = E = n), L = L === n ? L : Pn(lt(L), 0), B = B === n ? B : lt(B), he -= E ? E.length : 0, c & P) {
            var pe = _, ve = E;
            _ = E = n;
          }
          var Se = q ? n : eh(l), Ue = [
            l,
            c,
            h,
            _,
            E,
            pe,
            ve,
            D,
            L,
            B
          ];
          if (Se && V2(Ue, Se), l = Ue[0], c = Ue[1], h = Ue[2], _ = Ue[3], E = Ue[4], B = Ue[9] = Ue[9] === n ? q ? 0 : l.length : Pn(Ue[9] - he, 0), !B && c & (x | O) && (c &= ~(x | O)), !c || c == w)
            var Ze = w2(l, c, h);
          else c == x || c == O ? Ze = x2(l, c, B) : (c == C || c == (w | C)) && !E.length ? Ze = E2(l, c, h, _) : Ze = ic.apply(n, Ue);
          var ut = Se ? Jv : D0;
          return P0(ut(Ze, Ue), l, c);
        }
        function b0(l, c, h, _) {
          return l === n || hi(l, ts[h]) && !Ut.call(_, h) ? c : l;
        }
        function w0(l, c, h, _, E, D) {
          return fn(l) && fn(c) && (D.set(c, l), ec(l, c, n, w0, D), D.delete(c)), l;
        }
        function k2(l) {
          return ol(l) ? n : l;
        }
        function x0(l, c, h, _, E, D) {
          var L = h & v, B = l.length, q = c.length;
          if (B != q && !(L && q > B))
            return !1;
          var he = D.get(l), pe = D.get(c);
          if (he && pe)
            return he == c && pe == l;
          var ve = -1, Se = !0, Ue = h & b ? new ao() : n;
          for (D.set(l, c), D.set(c, l); ++ve < B; ) {
            var Ze = l[ve], ut = c[ve];
            if (_)
              var Qe = L ? _(ut, Ze, ve, c, l, D) : _(Ze, ut, ve, l, c, D);
            if (Qe !== n) {
              if (Qe)
                continue;
              Se = !1;
              break;
            }
            if (Ue) {
              if (!wf(c, function(vt, xt) {
                if (!zs(Ue, xt) && (Ze === vt || E(Ze, vt, h, _, D)))
                  return Ue.push(xt);
              })) {
                Se = !1;
                break;
              }
            } else if (!(Ze === ut || E(Ze, ut, h, _, D))) {
              Se = !1;
              break;
            }
          }
          return D.delete(l), D.delete(c), Se;
        }
        function S2(l, c, h, _, E, D, L) {
          switch (h) {
            case _e:
              if (l.byteLength != c.byteLength || l.byteOffset != c.byteOffset)
                return !1;
              l = l.buffer, c = c.buffer;
            case ae:
              return !(l.byteLength != c.byteLength || !D(new Wu(l), new Wu(c)));
            case it:
            case He:
            case Ce:
              return hi(+l, +c);
            case Bt:
              return l.name == c.name && l.message == c.message;
            case R:
            case ge:
              return l == c + "";
            case ue:
              var B = Of;
            case V:
              var q = _ & v;
              if (B || (B = Ru), l.size != c.size && !q)
                return !1;
              var he = L.get(l);
              if (he)
                return he == c;
              _ |= b, L.set(l, c);
              var pe = x0(B(l), B(c), _, E, D, L);
              return L.delete(l), pe;
            case Fe:
              if (Zs)
                return Zs.call(l) == Zs.call(c);
          }
          return !1;
        }
        function O2(l, c, h, _, E, D) {
          var L = h & v, B = Qf(l), q = B.length, he = Qf(c), pe = he.length;
          if (q != pe && !L)
            return !1;
          for (var ve = q; ve--; ) {
            var Se = B[ve];
            if (!(L ? Se in c : Ut.call(c, Se)))
              return !1;
          }
          var Ue = D.get(l), Ze = D.get(c);
          if (Ue && Ze)
            return Ue == c && Ze == l;
          var ut = !0;
          D.set(l, c), D.set(c, l);
          for (var Qe = L; ++ve < q; ) {
            Se = B[ve];
            var vt = l[Se], xt = c[Se];
            if (_)
              var $r = L ? _(xt, vt, Se, c, l, D) : _(vt, xt, Se, l, c, D);
            if (!($r === n ? vt === xt || E(vt, xt, h, _, D) : $r)) {
              ut = !1;
              break;
            }
            Qe || (Qe = Se == "constructor");
          }
          if (ut && !Qe) {
            var dr = l.constructor, Vr = c.constructor;
            dr != Vr && "constructor" in l && "constructor" in c && !(typeof dr == "function" && dr instanceof dr && typeof Vr == "function" && Vr instanceof Vr) && (ut = !1);
          }
          return D.delete(l), D.delete(c), ut;
        }
        function Gi(l) {
          return oh(C0(l, n, F0), l + "");
        }
        function Qf(l) {
          return Wv(l, Fn, nh);
        }
        function Jf(l) {
          return Wv(l, xr, E0);
        }
        var eh = qu ? function(l) {
          return qu.get(l);
        } : yh;
        function lc(l) {
          for (var c = l.name + "", h = rs[c], _ = Ut.call(rs, c) ? h.length : 0; _--; ) {
            var E = h[_], D = E.func;
            if (D == null || D == l)
              return E.name;
          }
          return c;
        }
        function ss(l) {
          var c = Ut.call(A, "placeholder") ? A : l;
          return c.placeholder;
        }
        function Ke() {
          var l = A.iteratee || vh;
          return l = l === vh ? Yv : l, arguments.length ? l(arguments[0], arguments[1]) : l;
        }
        function uc(l, c) {
          var h = l.__data__;
          return L2(c) ? h[typeof c == "string" ? "string" : "hash"] : h.map;
        }
        function th(l) {
          for (var c = Fn(l), h = c.length; h--; ) {
            var _ = c[h], E = l[_];
            c[h] = [_, E, S0(E)];
          }
          return c;
        }
        function lo(l, c) {
          var h = $O(l, c);
          return jv(h) ? h : n;
        }
        function C2(l) {
          var c = Ut.call(l, ro), h = l[ro];
          try {
            l[ro] = n;
            var _ = !0;
          } catch {
          }
          var E = Bu.call(l);
          return _ && (c ? l[ro] = h : delete l[ro]), E;
        }
        var nh = Af ? function(l) {
          return l == null ? [] : (l = Kt(l), va(Af(l), function(c) {
            return Av.call(l, c);
          }));
        } : bh, E0 = Af ? function(l) {
          for (var c = []; l; )
            _a(c, nh(l)), l = Hu(l);
          return c;
        } : bh, Qn = ur;
        (Df && Qn(new Df(new ArrayBuffer(1))) != _e || qs && Qn(new qs()) != ue || Pf && Qn(Pf.resolve()) != yr || ns && Qn(new ns()) != V || Ks && Qn(new Ks()) != mt) && (Qn = function(l) {
          var c = ur(l), h = c == qt ? l.constructor : n, _ = h ? uo(h) : "";
          if (_)
            switch (_) {
              case cC:
                return _e;
              case dC:
                return ue;
              case fC:
                return yr;
              case hC:
                return V;
              case pC:
                return mt;
            }
          return c;
        });
        function A2(l, c, h) {
          for (var _ = -1, E = h.length; ++_ < E; ) {
            var D = h[_], L = D.size;
            switch (D.type) {
              case "drop":
                l += L;
                break;
              case "dropRight":
                c -= L;
                break;
              case "take":
                c = Zn(c, l + L);
                break;
              case "takeRight":
                l = Pn(l, c - L);
                break;
            }
          }
          return { start: l, end: c };
        }
        function D2(l) {
          var c = l.match(RS);
          return c ? c[1].split(FS) : [];
        }
        function T0(l, c, h) {
          c = Ea(c, l);
          for (var _ = -1, E = c.length, D = !1; ++_ < E; ) {
            var L = Ei(c[_]);
            if (!(D = l != null && h(l, L)))
              break;
            l = l[L];
          }
          return D || ++_ != E ? D : (E = l == null ? 0 : l.length, !!E && gc(E) && qi(L, E) && (ot(l) || co(l)));
        }
        function P2(l) {
          var c = l.length, h = new l.constructor(c);
          return c && typeof l[0] == "string" && Ut.call(l, "index") && (h.index = l.index, h.input = l.input), h;
        }
        function k0(l) {
          return typeof l.constructor == "function" && !il(l) ? is(Hu(l)) : {};
        }
        function M2(l, c, h) {
          var _ = l.constructor;
          switch (c) {
            case ae:
              return Kf(l);
            case it:
            case He:
              return new _(+l);
            case _e:
              return m2(l, h);
            case F:
            case se:
            case Pe:
            case Ye:
            case gt:
            case mn:
            case Ir:
            case de:
            case Ne:
              return s0(l, h);
            case ue:
              return new _();
            case Ce:
            case ge:
              return new _(l);
            case R:
              return g2(l);
            case V:
              return new _();
            case Fe:
              return v2(l);
          }
        }
        function I2(l, c) {
          var h = c.length;
          if (!h)
            return l;
          var _ = h - 1;
          return c[_] = (h > 1 ? "& " : "") + c[_], c = c.join(h > 2 ? ", " : " "), l.replace(LS, `{
/* [wrapped with ` + c + `] */
`);
        }
        function N2(l) {
          return ot(l) || co(l) || !!(Dv && l && l[Dv]);
        }
        function qi(l, c) {
          var h = typeof l;
          return c = c ?? H, !!c && (h == "number" || h != "symbol" && zS.test(l)) && l > -1 && l % 1 == 0 && l < c;
        }
        function cr(l, c, h) {
          if (!fn(h))
            return !1;
          var _ = typeof c;
          return (_ == "number" ? wr(h) && qi(c, h.length) : _ == "string" && c in h) ? hi(h[c], l) : !1;
        }
        function rh(l, c) {
          if (ot(l))
            return !1;
          var h = typeof l;
          return h == "number" || h == "symbol" || h == "boolean" || l == null || Fr(l) ? !0 : PS.test(l) || !DS.test(l) || c != null && l in Kt(c);
        }
        function L2(l) {
          var c = typeof l;
          return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? l !== "__proto__" : l === null;
        }
        function ih(l) {
          var c = lc(l), h = A[c];
          if (typeof h != "function" || !(c in bt.prototype))
            return !1;
          if (l === h)
            return !0;
          var _ = eh(h);
          return !!_ && l === _[0];
        }
        function R2(l) {
          return !!Sv && Sv in l;
        }
        var F2 = $u ? Ki : wh;
        function il(l) {
          var c = l && l.constructor, h = typeof c == "function" && c.prototype || ts;
          return l === h;
        }
        function S0(l) {
          return l === l && !fn(l);
        }
        function O0(l, c) {
          return function(h) {
            return h == null ? !1 : h[l] === c && (c !== n || l in Kt(h));
          };
        }
        function $2(l) {
          var c = pc(l, function(_) {
            return h.size === d && h.clear(), _;
          }), h = c.cache;
          return c;
        }
        function V2(l, c) {
          var h = l[1], _ = c[1], E = h | _, D = E < (w | T | k), L = _ == k && h == x || _ == k && h == M && l[7].length <= c[8] || _ == (k | M) && c[7].length <= c[8] && h == x;
          if (!(D || L))
            return l;
          _ & w && (l[2] = c[2], E |= h & w ? 0 : S);
          var B = c[3];
          if (B) {
            var q = l[3];
            l[3] = q ? u0(q, B, c[4]) : B, l[4] = q ? ya(l[3], f) : c[4];
          }
          return B = c[5], B && (q = l[5], l[5] = q ? c0(q, B, c[6]) : B, l[6] = q ? ya(l[5], f) : c[6]), B = c[7], B && (l[7] = B), _ & k && (l[8] = l[8] == null ? c[8] : Zn(l[8], c[8])), l[9] == null && (l[9] = c[9]), l[0] = c[0], l[1] = E, l;
        }
        function B2(l) {
          var c = [];
          if (l != null)
            for (var h in Kt(l))
              c.push(h);
          return c;
        }
        function U2(l) {
          return Bu.call(l);
        }
        function C0(l, c, h) {
          return c = Pn(c === n ? l.length - 1 : c, 0), function() {
            for (var _ = arguments, E = -1, D = Pn(_.length - c, 0), L = re(D); ++E < D; )
              L[E] = _[c + E];
            E = -1;
            for (var B = re(c + 1); ++E < c; )
              B[E] = _[E];
            return B[c] = h(L), Nr(l, this, B);
          };
        }
        function A0(l, c) {
          return c.length < 2 ? l : so(l, Jr(c, 0, -1));
        }
        function W2(l, c) {
          for (var h = l.length, _ = Zn(c.length, h), E = br(l); _--; ) {
            var D = c[_];
            l[_] = qi(D, h) ? E[D] : n;
          }
          return l;
        }
        function ah(l, c) {
          if (!(c === "constructor" && typeof l[c] == "function") && c != "__proto__")
            return l[c];
        }
        var D0 = M0(Jv), al = rC || function(l, c) {
          return Hn.setTimeout(l, c);
        }, oh = M0(d2);
        function P0(l, c, h) {
          var _ = c + "";
          return oh(l, I2(_, H2(D2(_), h)));
        }
        function M0(l) {
          var c = 0, h = 0;
          return function() {
            var _ = sC(), E = ce - (_ - h);
            if (h = _, E > 0) {
              if (++c >= te)
                return arguments[0];
            } else
              c = 0;
            return l.apply(n, arguments);
          };
        }
        function cc(l, c) {
          var h = -1, _ = l.length, E = _ - 1;
          for (c = c === n ? _ : c; ++h < c; ) {
            var D = Wf(h, E), L = l[D];
            l[D] = l[h], l[h] = L;
          }
          return l.length = c, l;
        }
        var I0 = $2(function(l) {
          var c = [];
          return l.charCodeAt(0) === 46 && c.push(""), l.replace(MS, function(h, _, E, D) {
            c.push(E ? D.replace(BS, "$1") : _ || h);
          }), c;
        });
        function Ei(l) {
          if (typeof l == "string" || Fr(l))
            return l;
          var c = l + "";
          return c == "0" && 1 / l == -y ? "-0" : c;
        }
        function uo(l) {
          if (l != null) {
            try {
              return Vu.call(l);
            } catch {
            }
            try {
              return l + "";
            } catch {
            }
          }
          return "";
        }
        function H2(l, c) {
          return Kr(U, function(h) {
            var _ = "_." + h[0];
            c & h[1] && !Nu(l, _) && l.push(_);
          }), l.sort();
        }
        function N0(l) {
          if (l instanceof bt)
            return l.clone();
          var c = new Zr(l.__wrapped__, l.__chain__);
          return c.__actions__ = br(l.__actions__), c.__index__ = l.__index__, c.__values__ = l.__values__, c;
        }
        function j2(l, c, h) {
          (h ? cr(l, c, h) : c === n) ? c = 1 : c = Pn(lt(c), 0);
          var _ = l == null ? 0 : l.length;
          if (!_ || c < 1)
            return [];
          for (var E = 0, D = 0, L = re(zu(_ / c)); E < _; )
            L[D++] = Jr(l, E, E += c);
          return L;
        }
        function Y2(l) {
          for (var c = -1, h = l == null ? 0 : l.length, _ = 0, E = []; ++c < h; ) {
            var D = l[c];
            D && (E[_++] = D);
          }
          return E;
        }
        function z2() {
          var l = arguments.length;
          if (!l)
            return [];
          for (var c = re(l - 1), h = arguments[0], _ = l; _--; )
            c[_ - 1] = arguments[_];
          return _a(ot(h) ? br(h) : [h], jn(c, 1));
        }
        var G2 = ct(function(l, c) {
          return bn(l) ? Js(l, jn(c, 1, bn, !0)) : [];
        }), q2 = ct(function(l, c) {
          var h = ei(c);
          return bn(h) && (h = n), bn(l) ? Js(l, jn(c, 1, bn, !0), Ke(h, 2)) : [];
        }), K2 = ct(function(l, c) {
          var h = ei(c);
          return bn(h) && (h = n), bn(l) ? Js(l, jn(c, 1, bn, !0), n, h) : [];
        });
        function X2(l, c, h) {
          var _ = l == null ? 0 : l.length;
          return _ ? (c = h || c === n ? 1 : lt(c), Jr(l, c < 0 ? 0 : c, _)) : [];
        }
        function Z2(l, c, h) {
          var _ = l == null ? 0 : l.length;
          return _ ? (c = h || c === n ? 1 : lt(c), c = _ - c, Jr(l, 0, c < 0 ? 0 : c)) : [];
        }
        function Q2(l, c) {
          return l && l.length ? nc(l, Ke(c, 3), !0, !0) : [];
        }
        function J2(l, c) {
          return l && l.length ? nc(l, Ke(c, 3), !0) : [];
        }
        function eA(l, c, h, _) {
          var E = l == null ? 0 : l.length;
          return E ? (h && typeof h != "number" && cr(l, c, h) && (h = 0, _ = E), zC(l, c, h, _)) : [];
        }
        function L0(l, c, h) {
          var _ = l == null ? 0 : l.length;
          if (!_)
            return -1;
          var E = h == null ? 0 : lt(h);
          return E < 0 && (E = Pn(_ + E, 0)), Lu(l, Ke(c, 3), E);
        }
        function R0(l, c, h) {
          var _ = l == null ? 0 : l.length;
          if (!_)
            return -1;
          var E = _ - 1;
          return h !== n && (E = lt(h), E = h < 0 ? Pn(_ + E, 0) : Zn(E, _ - 1)), Lu(l, Ke(c, 3), E, !0);
        }
        function F0(l) {
          var c = l == null ? 0 : l.length;
          return c ? jn(l, 1) : [];
        }
        function tA(l) {
          var c = l == null ? 0 : l.length;
          return c ? jn(l, y) : [];
        }
        function nA(l, c) {
          var h = l == null ? 0 : l.length;
          return h ? (c = c === n ? 1 : lt(c), jn(l, c)) : [];
        }
        function rA(l) {
          for (var c = -1, h = l == null ? 0 : l.length, _ = {}; ++c < h; ) {
            var E = l[c];
            _[E[0]] = E[1];
          }
          return _;
        }
        function $0(l) {
          return l && l.length ? l[0] : n;
        }
        function iA(l, c, h) {
          var _ = l == null ? 0 : l.length;
          if (!_)
            return -1;
          var E = h == null ? 0 : lt(h);
          return E < 0 && (E = Pn(_ + E, 0)), Zo(l, c, E);
        }
        function aA(l) {
          var c = l == null ? 0 : l.length;
          return c ? Jr(l, 0, -1) : [];
        }
        var oA = ct(function(l) {
          var c = ln(l, Gf);
          return c.length && c[0] === l[0] ? Ff(c) : [];
        }), sA = ct(function(l) {
          var c = ei(l), h = ln(l, Gf);
          return c === ei(h) ? c = n : h.pop(), h.length && h[0] === l[0] ? Ff(h, Ke(c, 2)) : [];
        }), lA = ct(function(l) {
          var c = ei(l), h = ln(l, Gf);
          return c = typeof c == "function" ? c : n, c && h.pop(), h.length && h[0] === l[0] ? Ff(h, n, c) : [];
        });
        function uA(l, c) {
          return l == null ? "" : aC.call(l, c);
        }
        function ei(l) {
          var c = l == null ? 0 : l.length;
          return c ? l[c - 1] : n;
        }
        function cA(l, c, h) {
          var _ = l == null ? 0 : l.length;
          if (!_)
            return -1;
          var E = _;
          return h !== n && (E = lt(h), E = E < 0 ? Pn(_ + E, 0) : Zn(E, _ - 1)), c === c ? HO(l, c, E) : Lu(l, _v, E, !0);
        }
        function dA(l, c) {
          return l && l.length ? Kv(l, lt(c)) : n;
        }
        var fA = ct(V0);
        function V0(l, c) {
          return l && l.length && c && c.length ? Uf(l, c) : l;
        }
        function hA(l, c, h) {
          return l && l.length && c && c.length ? Uf(l, c, Ke(h, 2)) : l;
        }
        function pA(l, c, h) {
          return l && l.length && c && c.length ? Uf(l, c, n, h) : l;
        }
        var mA = Gi(function(l, c) {
          var h = l == null ? 0 : l.length, _ = If(l, c);
          return Qv(l, ln(c, function(E) {
            return qi(E, h) ? +E : E;
          }).sort(l0)), _;
        });
        function gA(l, c) {
          var h = [];
          if (!(l && l.length))
            return h;
          var _ = -1, E = [], D = l.length;
          for (c = Ke(c, 3); ++_ < D; ) {
            var L = l[_];
            c(L, _, l) && (h.push(L), E.push(_));
          }
          return Qv(l, E), h;
        }
        function sh(l) {
          return l == null ? l : uC.call(l);
        }
        function vA(l, c, h) {
          var _ = l == null ? 0 : l.length;
          return _ ? (h && typeof h != "number" && cr(l, c, h) ? (c = 0, h = _) : (c = c == null ? 0 : lt(c), h = h === n ? _ : lt(h)), Jr(l, c, h)) : [];
        }
        function _A(l, c) {
          return tc(l, c);
        }
        function yA(l, c, h) {
          return jf(l, c, Ke(h, 2));
        }
        function bA(l, c) {
          var h = l == null ? 0 : l.length;
          if (h) {
            var _ = tc(l, c);
            if (_ < h && hi(l[_], c))
              return _;
          }
          return -1;
        }
        function wA(l, c) {
          return tc(l, c, !0);
        }
        function xA(l, c, h) {
          return jf(l, c, Ke(h, 2), !0);
        }
        function EA(l, c) {
          var h = l == null ? 0 : l.length;
          if (h) {
            var _ = tc(l, c, !0) - 1;
            if (hi(l[_], c))
              return _;
          }
          return -1;
        }
        function TA(l) {
          return l && l.length ? e0(l) : [];
        }
        function kA(l, c) {
          return l && l.length ? e0(l, Ke(c, 2)) : [];
        }
        function SA(l) {
          var c = l == null ? 0 : l.length;
          return c ? Jr(l, 1, c) : [];
        }
        function OA(l, c, h) {
          return l && l.length ? (c = h || c === n ? 1 : lt(c), Jr(l, 0, c < 0 ? 0 : c)) : [];
        }
        function CA(l, c, h) {
          var _ = l == null ? 0 : l.length;
          return _ ? (c = h || c === n ? 1 : lt(c), c = _ - c, Jr(l, c < 0 ? 0 : c, _)) : [];
        }
        function AA(l, c) {
          return l && l.length ? nc(l, Ke(c, 3), !1, !0) : [];
        }
        function DA(l, c) {
          return l && l.length ? nc(l, Ke(c, 3)) : [];
        }
        var PA = ct(function(l) {
          return xa(jn(l, 1, bn, !0));
        }), MA = ct(function(l) {
          var c = ei(l);
          return bn(c) && (c = n), xa(jn(l, 1, bn, !0), Ke(c, 2));
        }), IA = ct(function(l) {
          var c = ei(l);
          return c = typeof c == "function" ? c : n, xa(jn(l, 1, bn, !0), n, c);
        });
        function NA(l) {
          return l && l.length ? xa(l) : [];
        }
        function LA(l, c) {
          return l && l.length ? xa(l, Ke(c, 2)) : [];
        }
        function RA(l, c) {
          return c = typeof c == "function" ? c : n, l && l.length ? xa(l, n, c) : [];
        }
        function lh(l) {
          if (!(l && l.length))
            return [];
          var c = 0;
          return l = va(l, function(h) {
            if (bn(h))
              return c = Pn(h.length, c), !0;
          }), kf(c, function(h) {
            return ln(l, xf(h));
          });
        }
        function B0(l, c) {
          if (!(l && l.length))
            return [];
          var h = lh(l);
          return c == null ? h : ln(h, function(_) {
            return Nr(c, n, _);
          });
        }
        var FA = ct(function(l, c) {
          return bn(l) ? Js(l, c) : [];
        }), $A = ct(function(l) {
          return zf(va(l, bn));
        }), VA = ct(function(l) {
          var c = ei(l);
          return bn(c) && (c = n), zf(va(l, bn), Ke(c, 2));
        }), BA = ct(function(l) {
          var c = ei(l);
          return c = typeof c == "function" ? c : n, zf(va(l, bn), n, c);
        }), UA = ct(lh);
        function WA(l, c) {
          return i0(l || [], c || [], Qs);
        }
        function HA(l, c) {
          return i0(l || [], c || [], nl);
        }
        var jA = ct(function(l) {
          var c = l.length, h = c > 1 ? l[c - 1] : n;
          return h = typeof h == "function" ? (l.pop(), h) : n, B0(l, h);
        });
        function U0(l) {
          var c = A(l);
          return c.__chain__ = !0, c;
        }
        function YA(l, c) {
          return c(l), l;
        }
        function dc(l, c) {
          return c(l);
        }
        var zA = Gi(function(l) {
          var c = l.length, h = c ? l[0] : 0, _ = this.__wrapped__, E = function(D) {
            return If(D, l);
          };
          return c > 1 || this.__actions__.length || !(_ instanceof bt) || !qi(h) ? this.thru(E) : (_ = _.slice(h, +h + (c ? 1 : 0)), _.__actions__.push({
            func: dc,
            args: [E],
            thisArg: n
          }), new Zr(_, this.__chain__).thru(function(D) {
            return c && !D.length && D.push(n), D;
          }));
        });
        function GA() {
          return U0(this);
        }
        function qA() {
          return new Zr(this.value(), this.__chain__);
        }
        function KA() {
          this.__values__ === n && (this.__values__ = t_(this.value()));
          var l = this.__index__ >= this.__values__.length, c = l ? n : this.__values__[this.__index__++];
          return { done: l, value: c };
        }
        function XA() {
          return this;
        }
        function ZA(l) {
          for (var c, h = this; h instanceof Xu; ) {
            var _ = N0(h);
            _.__index__ = 0, _.__values__ = n, c ? E.__wrapped__ = _ : c = _;
            var E = _;
            h = h.__wrapped__;
          }
          return E.__wrapped__ = l, c;
        }
        function QA() {
          var l = this.__wrapped__;
          if (l instanceof bt) {
            var c = l;
            return this.__actions__.length && (c = new bt(this)), c = c.reverse(), c.__actions__.push({
              func: dc,
              args: [sh],
              thisArg: n
            }), new Zr(c, this.__chain__);
          }
          return this.thru(sh);
        }
        function JA() {
          return r0(this.__wrapped__, this.__actions__);
        }
        var eD = rc(function(l, c, h) {
          Ut.call(l, h) ? ++l[h] : Yi(l, h, 1);
        });
        function tD(l, c, h) {
          var _ = ot(l) ? gv : YC;
          return h && cr(l, c, h) && (c = n), _(l, Ke(c, 3));
        }
        function nD(l, c) {
          var h = ot(l) ? va : Bv;
          return h(l, Ke(c, 3));
        }
        var rD = p0(L0), iD = p0(R0);
        function aD(l, c) {
          return jn(fc(l, c), 1);
        }
        function oD(l, c) {
          return jn(fc(l, c), y);
        }
        function sD(l, c, h) {
          return h = h === n ? 1 : lt(h), jn(fc(l, c), h);
        }
        function W0(l, c) {
          var h = ot(l) ? Kr : wa;
          return h(l, Ke(c, 3));
        }
        function H0(l, c) {
          var h = ot(l) ? SO : Vv;
          return h(l, Ke(c, 3));
        }
        var lD = rc(function(l, c, h) {
          Ut.call(l, h) ? l[h].push(c) : Yi(l, h, [c]);
        });
        function uD(l, c, h, _) {
          l = wr(l) ? l : us(l), h = h && !_ ? lt(h) : 0;
          var E = l.length;
          return h < 0 && (h = Pn(E + h, 0)), vc(l) ? h <= E && l.indexOf(c, h) > -1 : !!E && Zo(l, c, h) > -1;
        }
        var cD = ct(function(l, c, h) {
          var _ = -1, E = typeof c == "function", D = wr(l) ? re(l.length) : [];
          return wa(l, function(L) {
            D[++_] = E ? Nr(c, L, h) : el(L, c, h);
          }), D;
        }), dD = rc(function(l, c, h) {
          Yi(l, h, c);
        });
        function fc(l, c) {
          var h = ot(l) ? ln : zv;
          return h(l, Ke(c, 3));
        }
        function fD(l, c, h, _) {
          return l == null ? [] : (ot(c) || (c = c == null ? [] : [c]), h = _ ? n : h, ot(h) || (h = h == null ? [] : [h]), Xv(l, c, h));
        }
        var hD = rc(function(l, c, h) {
          l[h ? 0 : 1].push(c);
        }, function() {
          return [[], []];
        });
        function pD(l, c, h) {
          var _ = ot(l) ? bf : bv, E = arguments.length < 3;
          return _(l, Ke(c, 4), h, E, wa);
        }
        function mD(l, c, h) {
          var _ = ot(l) ? OO : bv, E = arguments.length < 3;
          return _(l, Ke(c, 4), h, E, Vv);
        }
        function gD(l, c) {
          var h = ot(l) ? va : Bv;
          return h(l, mc(Ke(c, 3)));
        }
        function vD(l) {
          var c = ot(l) ? Lv : u2;
          return c(l);
        }
        function _D(l, c, h) {
          (h ? cr(l, c, h) : c === n) ? c = 1 : c = lt(c);
          var _ = ot(l) ? BC : c2;
          return _(l, c);
        }
        function yD(l) {
          var c = ot(l) ? UC : f2;
          return c(l);
        }
        function bD(l) {
          if (l == null)
            return 0;
          if (wr(l))
            return vc(l) ? Jo(l) : l.length;
          var c = Qn(l);
          return c == ue || c == V ? l.size : Vf(l).length;
        }
        function wD(l, c, h) {
          var _ = ot(l) ? wf : h2;
          return h && cr(l, c, h) && (c = n), _(l, Ke(c, 3));
        }
        var xD = ct(function(l, c) {
          if (l == null)
            return [];
          var h = c.length;
          return h > 1 && cr(l, c[0], c[1]) ? c = [] : h > 2 && cr(c[0], c[1], c[2]) && (c = [c[0]]), Xv(l, jn(c, 1), []);
        }), hc = nC || function() {
          return Hn.Date.now();
        };
        function ED(l, c) {
          if (typeof c != "function")
            throw new Xr(o);
          return l = lt(l), function() {
            if (--l < 1)
              return c.apply(this, arguments);
          };
        }
        function j0(l, c, h) {
          return c = h ? n : c, c = l && c == null ? l.length : c, zi(l, k, n, n, n, n, c);
        }
        function Y0(l, c) {
          var h;
          if (typeof c != "function")
            throw new Xr(o);
          return l = lt(l), function() {
            return --l > 0 && (h = c.apply(this, arguments)), l <= 1 && (c = n), h;
          };
        }
        var uh = ct(function(l, c, h) {
          var _ = w;
          if (h.length) {
            var E = ya(h, ss(uh));
            _ |= C;
          }
          return zi(l, _, c, h, E);
        }), z0 = ct(function(l, c, h) {
          var _ = w | T;
          if (h.length) {
            var E = ya(h, ss(z0));
            _ |= C;
          }
          return zi(c, _, l, h, E);
        });
        function G0(l, c, h) {
          c = h ? n : c;
          var _ = zi(l, x, n, n, n, n, n, c);
          return _.placeholder = G0.placeholder, _;
        }
        function q0(l, c, h) {
          c = h ? n : c;
          var _ = zi(l, O, n, n, n, n, n, c);
          return _.placeholder = q0.placeholder, _;
        }
        function K0(l, c, h) {
          var _, E, D, L, B, q, he = 0, pe = !1, ve = !1, Se = !0;
          if (typeof l != "function")
            throw new Xr(o);
          c = ti(c) || 0, fn(h) && (pe = !!h.leading, ve = "maxWait" in h, D = ve ? Pn(ti(h.maxWait) || 0, c) : D, Se = "trailing" in h ? !!h.trailing : Se);
          function Ue(wn) {
            var pi = _, Zi = E;
            return _ = E = n, he = wn, L = l.apply(Zi, pi), L;
          }
          function Ze(wn) {
            return he = wn, B = al(vt, c), pe ? Ue(wn) : L;
          }
          function ut(wn) {
            var pi = wn - q, Zi = wn - he, p_ = c - pi;
            return ve ? Zn(p_, D - Zi) : p_;
          }
          function Qe(wn) {
            var pi = wn - q, Zi = wn - he;
            return q === n || pi >= c || pi < 0 || ve && Zi >= D;
          }
          function vt() {
            var wn = hc();
            if (Qe(wn))
              return xt(wn);
            B = al(vt, ut(wn));
          }
          function xt(wn) {
            return B = n, Se && _ ? Ue(wn) : (_ = E = n, L);
          }
          function $r() {
            B !== n && a0(B), he = 0, _ = q = E = B = n;
          }
          function dr() {
            return B === n ? L : xt(hc());
          }
          function Vr() {
            var wn = hc(), pi = Qe(wn);
            if (_ = arguments, E = this, q = wn, pi) {
              if (B === n)
                return Ze(q);
              if (ve)
                return a0(B), B = al(vt, c), Ue(q);
            }
            return B === n && (B = al(vt, c)), L;
          }
          return Vr.cancel = $r, Vr.flush = dr, Vr;
        }
        var TD = ct(function(l, c) {
          return $v(l, 1, c);
        }), kD = ct(function(l, c, h) {
          return $v(l, ti(c) || 0, h);
        });
        function SD(l) {
          return zi(l, N);
        }
        function pc(l, c) {
          if (typeof l != "function" || c != null && typeof c != "function")
            throw new Xr(o);
          var h = function() {
            var _ = arguments, E = c ? c.apply(this, _) : _[0], D = h.cache;
            if (D.has(E))
              return D.get(E);
            var L = l.apply(this, _);
            return h.cache = D.set(E, L) || D, L;
          };
          return h.cache = new (pc.Cache || ji)(), h;
        }
        pc.Cache = ji;
        function mc(l) {
          if (typeof l != "function")
            throw new Xr(o);
          return function() {
            var c = arguments;
            switch (c.length) {
              case 0:
                return !l.call(this);
              case 1:
                return !l.call(this, c[0]);
              case 2:
                return !l.call(this, c[0], c[1]);
              case 3:
                return !l.call(this, c[0], c[1], c[2]);
            }
            return !l.apply(this, c);
          };
        }
        function OD(l) {
          return Y0(2, l);
        }
        var CD = p2(function(l, c) {
          c = c.length == 1 && ot(c[0]) ? ln(c[0], Lr(Ke())) : ln(jn(c, 1), Lr(Ke()));
          var h = c.length;
          return ct(function(_) {
            for (var E = -1, D = Zn(_.length, h); ++E < D; )
              _[E] = c[E].call(this, _[E]);
            return Nr(l, this, _);
          });
        }), ch = ct(function(l, c) {
          var h = ya(c, ss(ch));
          return zi(l, C, n, c, h);
        }), X0 = ct(function(l, c) {
          var h = ya(c, ss(X0));
          return zi(l, P, n, c, h);
        }), AD = Gi(function(l, c) {
          return zi(l, M, n, n, n, c);
        });
        function DD(l, c) {
          if (typeof l != "function")
            throw new Xr(o);
          return c = c === n ? c : lt(c), ct(l, c);
        }
        function PD(l, c) {
          if (typeof l != "function")
            throw new Xr(o);
          return c = c == null ? 0 : Pn(lt(c), 0), ct(function(h) {
            var _ = h[c], E = Ta(h, 0, c);
            return _ && _a(E, _), Nr(l, this, E);
          });
        }
        function MD(l, c, h) {
          var _ = !0, E = !0;
          if (typeof l != "function")
            throw new Xr(o);
          return fn(h) && (_ = "leading" in h ? !!h.leading : _, E = "trailing" in h ? !!h.trailing : E), K0(l, c, {
            leading: _,
            maxWait: c,
            trailing: E
          });
        }
        function ID(l) {
          return j0(l, 1);
        }
        function ND(l, c) {
          return ch(qf(c), l);
        }
        function LD() {
          if (!arguments.length)
            return [];
          var l = arguments[0];
          return ot(l) ? l : [l];
        }
        function RD(l) {
          return Qr(l, g);
        }
        function FD(l, c) {
          return c = typeof c == "function" ? c : n, Qr(l, g, c);
        }
        function $D(l) {
          return Qr(l, p | g);
        }
        function VD(l, c) {
          return c = typeof c == "function" ? c : n, Qr(l, p | g, c);
        }
        function BD(l, c) {
          return c == null || Fv(l, c, Fn(c));
        }
        function hi(l, c) {
          return l === c || l !== l && c !== c;
        }
        var UD = sc(Rf), WD = sc(function(l, c) {
          return l >= c;
        }), co = Hv(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Hv : function(l) {
          return gn(l) && Ut.call(l, "callee") && !Av.call(l, "callee");
        }, ot = re.isArray, HD = cv ? Lr(cv) : ZC;
        function wr(l) {
          return l != null && gc(l.length) && !Ki(l);
        }
        function bn(l) {
          return gn(l) && wr(l);
        }
        function jD(l) {
          return l === !0 || l === !1 || gn(l) && ur(l) == it;
        }
        var ka = iC || wh, YD = dv ? Lr(dv) : QC;
        function zD(l) {
          return gn(l) && l.nodeType === 1 && !ol(l);
        }
        function GD(l) {
          if (l == null)
            return !0;
          if (wr(l) && (ot(l) || typeof l == "string" || typeof l.splice == "function" || ka(l) || ls(l) || co(l)))
            return !l.length;
          var c = Qn(l);
          if (c == ue || c == V)
            return !l.size;
          if (il(l))
            return !Vf(l).length;
          for (var h in l)
            if (Ut.call(l, h))
              return !1;
          return !0;
        }
        function qD(l, c) {
          return tl(l, c);
        }
        function KD(l, c, h) {
          h = typeof h == "function" ? h : n;
          var _ = h ? h(l, c) : n;
          return _ === n ? tl(l, c, n, h) : !!_;
        }
        function dh(l) {
          if (!gn(l))
            return !1;
          var c = ur(l);
          return c == Bt || c == Vt || typeof l.message == "string" && typeof l.name == "string" && !ol(l);
        }
        function XD(l) {
          return typeof l == "number" && Pv(l);
        }
        function Ki(l) {
          if (!fn(l))
            return !1;
          var c = ur(l);
          return c == Be || c == Xe || c == Re || c == Mr;
        }
        function Z0(l) {
          return typeof l == "number" && l == lt(l);
        }
        function gc(l) {
          return typeof l == "number" && l > -1 && l % 1 == 0 && l <= H;
        }
        function fn(l) {
          var c = typeof l;
          return l != null && (c == "object" || c == "function");
        }
        function gn(l) {
          return l != null && typeof l == "object";
        }
        var Q0 = fv ? Lr(fv) : e2;
        function ZD(l, c) {
          return l === c || $f(l, c, th(c));
        }
        function QD(l, c, h) {
          return h = typeof h == "function" ? h : n, $f(l, c, th(c), h);
        }
        function JD(l) {
          return J0(l) && l != +l;
        }
        function eP(l) {
          if (F2(l))
            throw new at(a);
          return jv(l);
        }
        function tP(l) {
          return l === null;
        }
        function nP(l) {
          return l == null;
        }
        function J0(l) {
          return typeof l == "number" || gn(l) && ur(l) == Ce;
        }
        function ol(l) {
          if (!gn(l) || ur(l) != qt)
            return !1;
          var c = Hu(l);
          if (c === null)
            return !0;
          var h = Ut.call(c, "constructor") && c.constructor;
          return typeof h == "function" && h instanceof h && Vu.call(h) == QO;
        }
        var fh = hv ? Lr(hv) : t2;
        function rP(l) {
          return Z0(l) && l >= -H && l <= H;
        }
        var e_ = pv ? Lr(pv) : n2;
        function vc(l) {
          return typeof l == "string" || !ot(l) && gn(l) && ur(l) == ge;
        }
        function Fr(l) {
          return typeof l == "symbol" || gn(l) && ur(l) == Fe;
        }
        var ls = mv ? Lr(mv) : r2;
        function iP(l) {
          return l === n;
        }
        function aP(l) {
          return gn(l) && Qn(l) == mt;
        }
        function oP(l) {
          return gn(l) && ur(l) == wt;
        }
        var sP = sc(Bf), lP = sc(function(l, c) {
          return l <= c;
        });
        function t_(l) {
          if (!l)
            return [];
          if (wr(l))
            return vc(l) ? di(l) : br(l);
          if (Gs && l[Gs])
            return BO(l[Gs]());
          var c = Qn(l), h = c == ue ? Of : c == V ? Ru : us;
          return h(l);
        }
        function Xi(l) {
          if (!l)
            return l === 0 ? l : 0;
          if (l = ti(l), l === y || l === -y) {
            var c = l < 0 ? -1 : 1;
            return c * ie;
          }
          return l === l ? l : 0;
        }
        function lt(l) {
          var c = Xi(l), h = c % 1;
          return c === c ? h ? c - h : c : 0;
        }
        function n_(l) {
          return l ? oo(lt(l), 0, J) : 0;
        }
        function ti(l) {
          if (typeof l == "number")
            return l;
          if (Fr(l))
            return ne;
          if (fn(l)) {
            var c = typeof l.valueOf == "function" ? l.valueOf() : l;
            l = fn(c) ? c + "" : c;
          }
          if (typeof l != "string")
            return l === 0 ? l : +l;
          l = wv(l);
          var h = HS.test(l);
          return h || YS.test(l) ? EO(l.slice(2), h ? 2 : 8) : WS.test(l) ? ne : +l;
        }
        function r_(l) {
          return xi(l, xr(l));
        }
        function uP(l) {
          return l ? oo(lt(l), -H, H) : l === 0 ? l : 0;
        }
        function Ft(l) {
          return l == null ? "" : Rr(l);
        }
        var cP = as(function(l, c) {
          if (il(c) || wr(c)) {
            xi(c, Fn(c), l);
            return;
          }
          for (var h in c)
            Ut.call(c, h) && Qs(l, h, c[h]);
        }), i_ = as(function(l, c) {
          xi(c, xr(c), l);
        }), _c = as(function(l, c, h, _) {
          xi(c, xr(c), l, _);
        }), dP = as(function(l, c, h, _) {
          xi(c, Fn(c), l, _);
        }), fP = Gi(If);
        function hP(l, c) {
          var h = is(l);
          return c == null ? h : Rv(h, c);
        }
        var pP = ct(function(l, c) {
          l = Kt(l);
          var h = -1, _ = c.length, E = _ > 2 ? c[2] : n;
          for (E && cr(c[0], c[1], E) && (_ = 1); ++h < _; )
            for (var D = c[h], L = xr(D), B = -1, q = L.length; ++B < q; ) {
              var he = L[B], pe = l[he];
              (pe === n || hi(pe, ts[he]) && !Ut.call(l, he)) && (l[he] = D[he]);
            }
          return l;
        }), mP = ct(function(l) {
          return l.push(n, w0), Nr(a_, n, l);
        });
        function gP(l, c) {
          return vv(l, Ke(c, 3), wi);
        }
        function vP(l, c) {
          return vv(l, Ke(c, 3), Lf);
        }
        function _P(l, c) {
          return l == null ? l : Nf(l, Ke(c, 3), xr);
        }
        function yP(l, c) {
          return l == null ? l : Uv(l, Ke(c, 3), xr);
        }
        function bP(l, c) {
          return l && wi(l, Ke(c, 3));
        }
        function wP(l, c) {
          return l && Lf(l, Ke(c, 3));
        }
        function xP(l) {
          return l == null ? [] : Ju(l, Fn(l));
        }
        function EP(l) {
          return l == null ? [] : Ju(l, xr(l));
        }
        function hh(l, c, h) {
          var _ = l == null ? n : so(l, c);
          return _ === n ? h : _;
        }
        function TP(l, c) {
          return l != null && T0(l, c, GC);
        }
        function ph(l, c) {
          return l != null && T0(l, c, qC);
        }
        var kP = g0(function(l, c, h) {
          c != null && typeof c.toString != "function" && (c = Bu.call(c)), l[c] = h;
        }, gh(Er)), SP = g0(function(l, c, h) {
          c != null && typeof c.toString != "function" && (c = Bu.call(c)), Ut.call(l, c) ? l[c].push(h) : l[c] = [h];
        }, Ke), OP = ct(el);
        function Fn(l) {
          return wr(l) ? Nv(l) : Vf(l);
        }
        function xr(l) {
          return wr(l) ? Nv(l, !0) : i2(l);
        }
        function CP(l, c) {
          var h = {};
          return c = Ke(c, 3), wi(l, function(_, E, D) {
            Yi(h, c(_, E, D), _);
          }), h;
        }
        function AP(l, c) {
          var h = {};
          return c = Ke(c, 3), wi(l, function(_, E, D) {
            Yi(h, E, c(_, E, D));
          }), h;
        }
        var DP = as(function(l, c, h) {
          ec(l, c, h);
        }), a_ = as(function(l, c, h, _) {
          ec(l, c, h, _);
        }), PP = Gi(function(l, c) {
          var h = {};
          if (l == null)
            return h;
          var _ = !1;
          c = ln(c, function(D) {
            return D = Ea(D, l), _ || (_ = D.length > 1), D;
          }), xi(l, Jf(l), h), _ && (h = Qr(h, p | m | g, k2));
          for (var E = c.length; E--; )
            Yf(h, c[E]);
          return h;
        });
        function MP(l, c) {
          return o_(l, mc(Ke(c)));
        }
        var IP = Gi(function(l, c) {
          return l == null ? {} : o2(l, c);
        });
        function o_(l, c) {
          if (l == null)
            return {};
          var h = ln(Jf(l), function(_) {
            return [_];
          });
          return c = Ke(c), Zv(l, h, function(_, E) {
            return c(_, E[0]);
          });
        }
        function NP(l, c, h) {
          c = Ea(c, l);
          var _ = -1, E = c.length;
          for (E || (E = 1, l = n); ++_ < E; ) {
            var D = l == null ? n : l[Ei(c[_])];
            D === n && (_ = E, D = h), l = Ki(D) ? D.call(l) : D;
          }
          return l;
        }
        function LP(l, c, h) {
          return l == null ? l : nl(l, c, h);
        }
        function RP(l, c, h, _) {
          return _ = typeof _ == "function" ? _ : n, l == null ? l : nl(l, c, h, _);
        }
        var s_ = y0(Fn), l_ = y0(xr);
        function FP(l, c, h) {
          var _ = ot(l), E = _ || ka(l) || ls(l);
          if (c = Ke(c, 4), h == null) {
            var D = l && l.constructor;
            E ? h = _ ? new D() : [] : fn(l) ? h = Ki(D) ? is(Hu(l)) : {} : h = {};
          }
          return (E ? Kr : wi)(l, function(L, B, q) {
            return c(h, L, B, q);
          }), h;
        }
        function $P(l, c) {
          return l == null ? !0 : Yf(l, c);
        }
        function VP(l, c, h) {
          return l == null ? l : n0(l, c, qf(h));
        }
        function BP(l, c, h, _) {
          return _ = typeof _ == "function" ? _ : n, l == null ? l : n0(l, c, qf(h), _);
        }
        function us(l) {
          return l == null ? [] : Sf(l, Fn(l));
        }
        function UP(l) {
          return l == null ? [] : Sf(l, xr(l));
        }
        function WP(l, c, h) {
          return h === n && (h = c, c = n), h !== n && (h = ti(h), h = h === h ? h : 0), c !== n && (c = ti(c), c = c === c ? c : 0), oo(ti(l), c, h);
        }
        function HP(l, c, h) {
          return c = Xi(c), h === n ? (h = c, c = 0) : h = Xi(h), l = ti(l), KC(l, c, h);
        }
        function jP(l, c, h) {
          if (h && typeof h != "boolean" && cr(l, c, h) && (c = h = n), h === n && (typeof c == "boolean" ? (h = c, c = n) : typeof l == "boolean" && (h = l, l = n)), l === n && c === n ? (l = 0, c = 1) : (l = Xi(l), c === n ? (c = l, l = 0) : c = Xi(c)), l > c) {
            var _ = l;
            l = c, c = _;
          }
          if (h || l % 1 || c % 1) {
            var E = Mv();
            return Zn(l + E * (c - l + xO("1e-" + ((E + "").length - 1))), c);
          }
          return Wf(l, c);
        }
        var YP = os(function(l, c, h) {
          return c = c.toLowerCase(), l + (h ? u_(c) : c);
        });
        function u_(l) {
          return mh(Ft(l).toLowerCase());
        }
        function c_(l) {
          return l = Ft(l), l && l.replace(GS, LO).replace(fO, "");
        }
        function zP(l, c, h) {
          l = Ft(l), c = Rr(c);
          var _ = l.length;
          h = h === n ? _ : oo(lt(h), 0, _);
          var E = h;
          return h -= c.length, h >= 0 && l.slice(h, E) == c;
        }
        function GP(l) {
          return l = Ft(l), l && uf.test(l) ? l.replace(Wi, RO) : l;
        }
        function qP(l) {
          return l = Ft(l), l && IS.test(l) ? l.replace(cf, "\\$&") : l;
        }
        var KP = os(function(l, c, h) {
          return l + (h ? "-" : "") + c.toLowerCase();
        }), XP = os(function(l, c, h) {
          return l + (h ? " " : "") + c.toLowerCase();
        }), ZP = h0("toLowerCase");
        function QP(l, c, h) {
          l = Ft(l), c = lt(c);
          var _ = c ? Jo(l) : 0;
          if (!c || _ >= c)
            return l;
          var E = (c - _) / 2;
          return oc(Gu(E), h) + l + oc(zu(E), h);
        }
        function JP(l, c, h) {
          l = Ft(l), c = lt(c);
          var _ = c ? Jo(l) : 0;
          return c && _ < c ? l + oc(c - _, h) : l;
        }
        function eM(l, c, h) {
          l = Ft(l), c = lt(c);
          var _ = c ? Jo(l) : 0;
          return c && _ < c ? oc(c - _, h) + l : l;
        }
        function tM(l, c, h) {
          return h || c == null ? c = 0 : c && (c = +c), lC(Ft(l).replace(df, ""), c || 0);
        }
        function nM(l, c, h) {
          return (h ? cr(l, c, h) : c === n) ? c = 1 : c = lt(c), Hf(Ft(l), c);
        }
        function rM() {
          var l = arguments, c = Ft(l[0]);
          return l.length < 3 ? c : c.replace(l[1], l[2]);
        }
        var iM = os(function(l, c, h) {
          return l + (h ? "_" : "") + c.toLowerCase();
        });
        function aM(l, c, h) {
          return h && typeof h != "number" && cr(l, c, h) && (c = h = n), h = h === n ? J : h >>> 0, h ? (l = Ft(l), l && (typeof c == "string" || c != null && !fh(c)) && (c = Rr(c), !c && Qo(l)) ? Ta(di(l), 0, h) : l.split(c, h)) : [];
        }
        var oM = os(function(l, c, h) {
          return l + (h ? " " : "") + mh(c);
        });
        function sM(l, c, h) {
          return l = Ft(l), h = h == null ? 0 : oo(lt(h), 0, l.length), c = Rr(c), l.slice(h, h + c.length) == c;
        }
        function lM(l, c, h) {
          var _ = A.templateSettings;
          h && cr(l, c, h) && (c = n), l = Ft(l), c = _c({}, c, _, b0);
          var E = _c({}, c.imports, _.imports, b0), D = Fn(E), L = Sf(E, D), B, q, he = 0, pe = c.interpolate || Pu, ve = "__p += '", Se = Cf(
            (c.escape || Pu).source + "|" + pe.source + "|" + (pe === Wg ? US : Pu).source + "|" + (c.evaluate || Pu).source + "|$",
            "g"
          ), Ue = "//# sourceURL=" + (Ut.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++vO + "]") + `
`;
          l.replace(Se, function(Qe, vt, xt, $r, dr, Vr) {
            return xt || (xt = $r), ve += l.slice(he, Vr).replace(qS, FO), vt && (B = !0, ve += `' +
__e(` + vt + `) +
'`), dr && (q = !0, ve += `';
` + dr + `;
__p += '`), xt && (ve += `' +
((__t = (` + xt + `)) == null ? '' : __t) +
'`), he = Vr + Qe.length, Qe;
          }), ve += `';
`;
          var Ze = Ut.call(c, "variable") && c.variable;
          if (!Ze)
            ve = `with (obj) {
` + ve + `
}
`;
          else if (VS.test(Ze))
            throw new at(s);
          ve = (q ? ve.replace(Wn, "") : ve).replace(Xn, "$1").replace(Ko, "$1;"), ve = "function(" + (Ze || "obj") + `) {
` + (Ze ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (B ? ", __e = _.escape" : "") + (q ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ve + `return __p
}`;
          var ut = f_(function() {
            return It(D, Ue + "return " + ve).apply(n, L);
          });
          if (ut.source = ve, dh(ut))
            throw ut;
          return ut;
        }
        function uM(l) {
          return Ft(l).toLowerCase();
        }
        function cM(l) {
          return Ft(l).toUpperCase();
        }
        function dM(l, c, h) {
          if (l = Ft(l), l && (h || c === n))
            return wv(l);
          if (!l || !(c = Rr(c)))
            return l;
          var _ = di(l), E = di(c), D = xv(_, E), L = Ev(_, E) + 1;
          return Ta(_, D, L).join("");
        }
        function fM(l, c, h) {
          if (l = Ft(l), l && (h || c === n))
            return l.slice(0, kv(l) + 1);
          if (!l || !(c = Rr(c)))
            return l;
          var _ = di(l), E = Ev(_, di(c)) + 1;
          return Ta(_, 0, E).join("");
        }
        function hM(l, c, h) {
          if (l = Ft(l), l && (h || c === n))
            return l.replace(df, "");
          if (!l || !(c = Rr(c)))
            return l;
          var _ = di(l), E = xv(_, di(c));
          return Ta(_, E).join("");
        }
        function pM(l, c) {
          var h = X, _ = Z;
          if (fn(c)) {
            var E = "separator" in c ? c.separator : E;
            h = "length" in c ? lt(c.length) : h, _ = "omission" in c ? Rr(c.omission) : _;
          }
          l = Ft(l);
          var D = l.length;
          if (Qo(l)) {
            var L = di(l);
            D = L.length;
          }
          if (h >= D)
            return l;
          var B = h - Jo(_);
          if (B < 1)
            return _;
          var q = L ? Ta(L, 0, B).join("") : l.slice(0, B);
          if (E === n)
            return q + _;
          if (L && (B += q.length - B), fh(E)) {
            if (l.slice(B).search(E)) {
              var he, pe = q;
              for (E.global || (E = Cf(E.source, Ft(Hg.exec(E)) + "g")), E.lastIndex = 0; he = E.exec(pe); )
                var ve = he.index;
              q = q.slice(0, ve === n ? B : ve);
            }
          } else if (l.indexOf(Rr(E), B) != B) {
            var Se = q.lastIndexOf(E);
            Se > -1 && (q = q.slice(0, Se));
          }
          return q + _;
        }
        function mM(l) {
          return l = Ft(l), l && ft.test(l) ? l.replace(qe, jO) : l;
        }
        var gM = os(function(l, c, h) {
          return l + (h ? " " : "") + c.toUpperCase();
        }), mh = h0("toUpperCase");
        function d_(l, c, h) {
          return l = Ft(l), c = h ? n : c, c === n ? VO(l) ? GO(l) : DO(l) : l.match(c) || [];
        }
        var f_ = ct(function(l, c) {
          try {
            return Nr(l, n, c);
          } catch (h) {
            return dh(h) ? h : new at(h);
          }
        }), vM = Gi(function(l, c) {
          return Kr(c, function(h) {
            h = Ei(h), Yi(l, h, uh(l[h], l));
          }), l;
        });
        function _M(l) {
          var c = l == null ? 0 : l.length, h = Ke();
          return l = c ? ln(l, function(_) {
            if (typeof _[1] != "function")
              throw new Xr(o);
            return [h(_[0]), _[1]];
          }) : [], ct(function(_) {
            for (var E = -1; ++E < c; ) {
              var D = l[E];
              if (Nr(D[0], this, _))
                return Nr(D[1], this, _);
            }
          });
        }
        function yM(l) {
          return jC(Qr(l, p));
        }
        function gh(l) {
          return function() {
            return l;
          };
        }
        function bM(l, c) {
          return l == null || l !== l ? c : l;
        }
        var wM = m0(), xM = m0(!0);
        function Er(l) {
          return l;
        }
        function vh(l) {
          return Yv(typeof l == "function" ? l : Qr(l, p));
        }
        function EM(l) {
          return Gv(Qr(l, p));
        }
        function TM(l, c) {
          return qv(l, Qr(c, p));
        }
        var kM = ct(function(l, c) {
          return function(h) {
            return el(h, l, c);
          };
        }), SM = ct(function(l, c) {
          return function(h) {
            return el(l, h, c);
          };
        });
        function _h(l, c, h) {
          var _ = Fn(c), E = Ju(c, _);
          h == null && !(fn(c) && (E.length || !_.length)) && (h = c, c = l, l = this, E = Ju(c, Fn(c)));
          var D = !(fn(h) && "chain" in h) || !!h.chain, L = Ki(l);
          return Kr(E, function(B) {
            var q = c[B];
            l[B] = q, L && (l.prototype[B] = function() {
              var he = this.__chain__;
              if (D || he) {
                var pe = l(this.__wrapped__), ve = pe.__actions__ = br(this.__actions__);
                return ve.push({ func: q, args: arguments, thisArg: l }), pe.__chain__ = he, pe;
              }
              return q.apply(l, _a([this.value()], arguments));
            });
          }), l;
        }
        function OM() {
          return Hn._ === this && (Hn._ = JO), this;
        }
        function yh() {
        }
        function CM(l) {
          return l = lt(l), ct(function(c) {
            return Kv(c, l);
          });
        }
        var AM = Xf(ln), DM = Xf(gv), PM = Xf(wf);
        function h_(l) {
          return rh(l) ? xf(Ei(l)) : s2(l);
        }
        function MM(l) {
          return function(c) {
            return l == null ? n : so(l, c);
          };
        }
        var IM = v0(), NM = v0(!0);
        function bh() {
          return [];
        }
        function wh() {
          return !1;
        }
        function LM() {
          return {};
        }
        function RM() {
          return "";
        }
        function FM() {
          return !0;
        }
        function $M(l, c) {
          if (l = lt(l), l < 1 || l > H)
            return [];
          var h = J, _ = Zn(l, J);
          c = Ke(c), l -= J;
          for (var E = kf(_, c); ++h < l; )
            c(h);
          return E;
        }
        function VM(l) {
          return ot(l) ? ln(l, Ei) : Fr(l) ? [l] : br(I0(Ft(l)));
        }
        function BM(l) {
          var c = ++ZO;
          return Ft(l) + c;
        }
        var UM = ac(function(l, c) {
          return l + c;
        }, 0), WM = Zf("ceil"), HM = ac(function(l, c) {
          return l / c;
        }, 1), jM = Zf("floor");
        function YM(l) {
          return l && l.length ? Qu(l, Er, Rf) : n;
        }
        function zM(l, c) {
          return l && l.length ? Qu(l, Ke(c, 2), Rf) : n;
        }
        function GM(l) {
          return yv(l, Er);
        }
        function qM(l, c) {
          return yv(l, Ke(c, 2));
        }
        function KM(l) {
          return l && l.length ? Qu(l, Er, Bf) : n;
        }
        function XM(l, c) {
          return l && l.length ? Qu(l, Ke(c, 2), Bf) : n;
        }
        var ZM = ac(function(l, c) {
          return l * c;
        }, 1), QM = Zf("round"), JM = ac(function(l, c) {
          return l - c;
        }, 0);
        function eI(l) {
          return l && l.length ? Tf(l, Er) : 0;
        }
        function tI(l, c) {
          return l && l.length ? Tf(l, Ke(c, 2)) : 0;
        }
        return A.after = ED, A.ary = j0, A.assign = cP, A.assignIn = i_, A.assignInWith = _c, A.assignWith = dP, A.at = fP, A.before = Y0, A.bind = uh, A.bindAll = vM, A.bindKey = z0, A.castArray = LD, A.chain = U0, A.chunk = j2, A.compact = Y2, A.concat = z2, A.cond = _M, A.conforms = yM, A.constant = gh, A.countBy = eD, A.create = hP, A.curry = G0, A.curryRight = q0, A.debounce = K0, A.defaults = pP, A.defaultsDeep = mP, A.defer = TD, A.delay = kD, A.difference = G2, A.differenceBy = q2, A.differenceWith = K2, A.drop = X2, A.dropRight = Z2, A.dropRightWhile = Q2, A.dropWhile = J2, A.fill = eA, A.filter = nD, A.flatMap = aD, A.flatMapDeep = oD, A.flatMapDepth = sD, A.flatten = F0, A.flattenDeep = tA, A.flattenDepth = nA, A.flip = SD, A.flow = wM, A.flowRight = xM, A.fromPairs = rA, A.functions = xP, A.functionsIn = EP, A.groupBy = lD, A.initial = aA, A.intersection = oA, A.intersectionBy = sA, A.intersectionWith = lA, A.invert = kP, A.invertBy = SP, A.invokeMap = cD, A.iteratee = vh, A.keyBy = dD, A.keys = Fn, A.keysIn = xr, A.map = fc, A.mapKeys = CP, A.mapValues = AP, A.matches = EM, A.matchesProperty = TM, A.memoize = pc, A.merge = DP, A.mergeWith = a_, A.method = kM, A.methodOf = SM, A.mixin = _h, A.negate = mc, A.nthArg = CM, A.omit = PP, A.omitBy = MP, A.once = OD, A.orderBy = fD, A.over = AM, A.overArgs = CD, A.overEvery = DM, A.overSome = PM, A.partial = ch, A.partialRight = X0, A.partition = hD, A.pick = IP, A.pickBy = o_, A.property = h_, A.propertyOf = MM, A.pull = fA, A.pullAll = V0, A.pullAllBy = hA, A.pullAllWith = pA, A.pullAt = mA, A.range = IM, A.rangeRight = NM, A.rearg = AD, A.reject = gD, A.remove = gA, A.rest = DD, A.reverse = sh, A.sampleSize = _D, A.set = LP, A.setWith = RP, A.shuffle = yD, A.slice = vA, A.sortBy = xD, A.sortedUniq = TA, A.sortedUniqBy = kA, A.split = aM, A.spread = PD, A.tail = SA, A.take = OA, A.takeRight = CA, A.takeRightWhile = AA, A.takeWhile = DA, A.tap = YA, A.throttle = MD, A.thru = dc, A.toArray = t_, A.toPairs = s_, A.toPairsIn = l_, A.toPath = VM, A.toPlainObject = r_, A.transform = FP, A.unary = ID, A.union = PA, A.unionBy = MA, A.unionWith = IA, A.uniq = NA, A.uniqBy = LA, A.uniqWith = RA, A.unset = $P, A.unzip = lh, A.unzipWith = B0, A.update = VP, A.updateWith = BP, A.values = us, A.valuesIn = UP, A.without = FA, A.words = d_, A.wrap = ND, A.xor = $A, A.xorBy = VA, A.xorWith = BA, A.zip = UA, A.zipObject = WA, A.zipObjectDeep = HA, A.zipWith = jA, A.entries = s_, A.entriesIn = l_, A.extend = i_, A.extendWith = _c, _h(A, A), A.add = UM, A.attempt = f_, A.camelCase = YP, A.capitalize = u_, A.ceil = WM, A.clamp = WP, A.clone = RD, A.cloneDeep = $D, A.cloneDeepWith = VD, A.cloneWith = FD, A.conformsTo = BD, A.deburr = c_, A.defaultTo = bM, A.divide = HM, A.endsWith = zP, A.eq = hi, A.escape = GP, A.escapeRegExp = qP, A.every = tD, A.find = rD, A.findIndex = L0, A.findKey = gP, A.findLast = iD, A.findLastIndex = R0, A.findLastKey = vP, A.floor = jM, A.forEach = W0, A.forEachRight = H0, A.forIn = _P, A.forInRight = yP, A.forOwn = bP, A.forOwnRight = wP, A.get = hh, A.gt = UD, A.gte = WD, A.has = TP, A.hasIn = ph, A.head = $0, A.identity = Er, A.includes = uD, A.indexOf = iA, A.inRange = HP, A.invoke = OP, A.isArguments = co, A.isArray = ot, A.isArrayBuffer = HD, A.isArrayLike = wr, A.isArrayLikeObject = bn, A.isBoolean = jD, A.isBuffer = ka, A.isDate = YD, A.isElement = zD, A.isEmpty = GD, A.isEqual = qD, A.isEqualWith = KD, A.isError = dh, A.isFinite = XD, A.isFunction = Ki, A.isInteger = Z0, A.isLength = gc, A.isMap = Q0, A.isMatch = ZD, A.isMatchWith = QD, A.isNaN = JD, A.isNative = eP, A.isNil = nP, A.isNull = tP, A.isNumber = J0, A.isObject = fn, A.isObjectLike = gn, A.isPlainObject = ol, A.isRegExp = fh, A.isSafeInteger = rP, A.isSet = e_, A.isString = vc, A.isSymbol = Fr, A.isTypedArray = ls, A.isUndefined = iP, A.isWeakMap = aP, A.isWeakSet = oP, A.join = uA, A.kebabCase = KP, A.last = ei, A.lastIndexOf = cA, A.lowerCase = XP, A.lowerFirst = ZP, A.lt = sP, A.lte = lP, A.max = YM, A.maxBy = zM, A.mean = GM, A.meanBy = qM, A.min = KM, A.minBy = XM, A.stubArray = bh, A.stubFalse = wh, A.stubObject = LM, A.stubString = RM, A.stubTrue = FM, A.multiply = ZM, A.nth = dA, A.noConflict = OM, A.noop = yh, A.now = hc, A.pad = QP, A.padEnd = JP, A.padStart = eM, A.parseInt = tM, A.random = jP, A.reduce = pD, A.reduceRight = mD, A.repeat = nM, A.replace = rM, A.result = NP, A.round = QM, A.runInContext = z, A.sample = vD, A.size = bD, A.snakeCase = iM, A.some = wD, A.sortedIndex = _A, A.sortedIndexBy = yA, A.sortedIndexOf = bA, A.sortedLastIndex = wA, A.sortedLastIndexBy = xA, A.sortedLastIndexOf = EA, A.startCase = oM, A.startsWith = sM, A.subtract = JM, A.sum = eI, A.sumBy = tI, A.template = lM, A.times = $M, A.toFinite = Xi, A.toInteger = lt, A.toLength = n_, A.toLower = uM, A.toNumber = ti, A.toSafeInteger = uP, A.toString = Ft, A.toUpper = cM, A.trim = dM, A.trimEnd = fM, A.trimStart = hM, A.truncate = pM, A.unescape = mM, A.uniqueId = BM, A.upperCase = gM, A.upperFirst = mh, A.each = W0, A.eachRight = H0, A.first = $0, _h(A, function() {
          var l = {};
          return wi(A, function(c, h) {
            Ut.call(A.prototype, h) || (l[h] = c);
          }), l;
        }(), { chain: !1 }), A.VERSION = r, Kr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
          A[l].placeholder = A;
        }), Kr(["drop", "take"], function(l, c) {
          bt.prototype[l] = function(h) {
            h = h === n ? 1 : Pn(lt(h), 0);
            var _ = this.__filtered__ && !c ? new bt(this) : this.clone();
            return _.__filtered__ ? _.__takeCount__ = Zn(h, _.__takeCount__) : _.__views__.push({
              size: Zn(h, J),
              type: l + (_.__dir__ < 0 ? "Right" : "")
            }), _;
          }, bt.prototype[l + "Right"] = function(h) {
            return this.reverse()[l](h).reverse();
          };
        }), Kr(["filter", "map", "takeWhile"], function(l, c) {
          var h = c + 1, _ = h == we || h == Q;
          bt.prototype[l] = function(E) {
            var D = this.clone();
            return D.__iteratees__.push({
              iteratee: Ke(E, 3),
              type: h
            }), D.__filtered__ = D.__filtered__ || _, D;
          };
        }), Kr(["head", "last"], function(l, c) {
          var h = "take" + (c ? "Right" : "");
          bt.prototype[l] = function() {
            return this[h](1).value()[0];
          };
        }), Kr(["initial", "tail"], function(l, c) {
          var h = "drop" + (c ? "" : "Right");
          bt.prototype[l] = function() {
            return this.__filtered__ ? new bt(this) : this[h](1);
          };
        }), bt.prototype.compact = function() {
          return this.filter(Er);
        }, bt.prototype.find = function(l) {
          return this.filter(l).head();
        }, bt.prototype.findLast = function(l) {
          return this.reverse().find(l);
        }, bt.prototype.invokeMap = ct(function(l, c) {
          return typeof l == "function" ? new bt(this) : this.map(function(h) {
            return el(h, l, c);
          });
        }), bt.prototype.reject = function(l) {
          return this.filter(mc(Ke(l)));
        }, bt.prototype.slice = function(l, c) {
          l = lt(l);
          var h = this;
          return h.__filtered__ && (l > 0 || c < 0) ? new bt(h) : (l < 0 ? h = h.takeRight(-l) : l && (h = h.drop(l)), c !== n && (c = lt(c), h = c < 0 ? h.dropRight(-c) : h.take(c - l)), h);
        }, bt.prototype.takeRightWhile = function(l) {
          return this.reverse().takeWhile(l).reverse();
        }, bt.prototype.toArray = function() {
          return this.take(J);
        }, wi(bt.prototype, function(l, c) {
          var h = /^(?:filter|find|map|reject)|While$/.test(c), _ = /^(?:head|last)$/.test(c), E = A[_ ? "take" + (c == "last" ? "Right" : "") : c], D = _ || /^find/.test(c);
          E && (A.prototype[c] = function() {
            var L = this.__wrapped__, B = _ ? [1] : arguments, q = L instanceof bt, he = B[0], pe = q || ot(L), ve = function(vt) {
              var xt = E.apply(A, _a([vt], B));
              return _ && Se ? xt[0] : xt;
            };
            pe && h && typeof he == "function" && he.length != 1 && (q = pe = !1);
            var Se = this.__chain__, Ue = !!this.__actions__.length, Ze = D && !Se, ut = q && !Ue;
            if (!D && pe) {
              L = ut ? L : new bt(this);
              var Qe = l.apply(L, B);
              return Qe.__actions__.push({ func: dc, args: [ve], thisArg: n }), new Zr(Qe, Se);
            }
            return Ze && ut ? l.apply(this, B) : (Qe = this.thru(ve), Ze ? _ ? Qe.value()[0] : Qe.value() : Qe);
          });
        }), Kr(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
          var c = Fu[l], h = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", _ = /^(?:pop|shift)$/.test(l);
          A.prototype[l] = function() {
            var E = arguments;
            if (_ && !this.__chain__) {
              var D = this.value();
              return c.apply(ot(D) ? D : [], E);
            }
            return this[h](function(L) {
              return c.apply(ot(L) ? L : [], E);
            });
          };
        }), wi(bt.prototype, function(l, c) {
          var h = A[c];
          if (h) {
            var _ = h.name + "";
            Ut.call(rs, _) || (rs[_] = []), rs[_].push({ name: c, func: h });
          }
        }), rs[ic(n, T).name] = [{
          name: "wrapper",
          func: n
        }], bt.prototype.clone = mC, bt.prototype.reverse = gC, bt.prototype.value = vC, A.prototype.at = zA, A.prototype.chain = GA, A.prototype.commit = qA, A.prototype.next = KA, A.prototype.plant = ZA, A.prototype.reverse = QA, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = JA, A.prototype.first = A.prototype.head, Gs && (A.prototype[Gs] = XA), A;
      }, es = qO();
      no ? ((no.exports = es)._ = es, vf._ = es) : Hn._ = es;
    }).call(_Q);
  }(kl, kl.exports)), kl.exports;
}
yQ();
function bQ(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (t) => t.toUpperCase()).toLowerCase().replace(/^\w/, (t) => t.toUpperCase());
}
const wQ = {
  components: { Table: Ug },
  props: ["data"],
  computed: {
    sellersRankingColumns() {
      if (!ar(this.data)) return [];
      const e = Object.keys(this.data[0] || {}), t = [
        "position",
        "name",
        "salesCount",
        "cancellationRate",
        "averageCommission",
        "salesChannel"
      ], n = ["cancellationRate", "averageCommission"], r = ["position"];
      return t.filter((i) => e.includes(i)).map((i) => ({
        field: i,
        label: r.includes(i) ? null : this.$t(bQ(i)),
        numeric: [
          "salesCount",
          "cancellationRate",
          "averageCommission"
        ].includes(i),
        bold: !1,
        slot: n.includes(i) ? i : null,
        percentage: !1
      }));
    }
  },
  methods: { formatPrice: lf }
}, xQ = { class: "text-right" }, EQ = { class: "text-right" };
function TQ(e, t, n, r, i, a) {
  const o = je("Table");
  return I(), W("div", null, [
    Ae(o, {
      class: "mt-5",
      data: n.data,
      columns: a.sellersRankingColumns
    }, {
      cancellationRate: Ve(({ row: s }) => [
        K("p", xQ, ke(s.cancellationRate) + " %", 1)
      ]),
      averageCommission: Ve(({ row: s }) => [
        K("p", EQ, ke(a.formatPrice(s.averageCommission)), 1)
      ]),
      _: 1
    }, 8, ["data", "columns"])
  ]);
}
const CS = /* @__PURE__ */ pt(wQ, [["render", TQ]]), kQ = {
  components: {
    SellerRankingTable: CS,
    PieChart: Sq,
    AnalyticsDateRangePicker: s5,
    MultiSelect: JE,
    LineChart: QG,
    DataCard: P5,
    Table: Ug,
    DataCardWithVariation: OZ,
    Variation: OS,
    Selector: YU,
    InformationCircleIcon: fu
  },
  props: {
    organizationId: {
      type: Number,
      required: !1
    },
    analytics: {
      type: Object,
      default: {}
    },
    availableStores: {
      type: Array,
      default: []
    },
    store: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      dateRange: Wm().map((e) => Gl(e)),
      selectedStoreIds: [],
      requestTimeout: null,
      comparisonType: "previousMonth",
      comparisonTypeOptions: [
        { value: "previousMonth", label: "Mois précédent" },
        { value: "previousPeriod", label: "Période précédente" },
        { value: "previousWeek", label: "Semaine précédente" },
        { value: "previousYear", label: "Année précédente" }
      ]
    };
  },
  mounted() {
    this.requestAnalytics();
  },
  watch: {
    organizationId() {
      this.selectedStoreIds = [];
    },
    selectedStoreIds() {
      this.requestAnalytics();
    }
  },
  computed: {
    previsousPeriodStartDate() {
      var e, t;
      return (t = (e = this.analytics) == null ? void 0 : e.previousPeriod) == null ? void 0 : t.startDate;
    },
    comparisonPeriodFormatted() {
      var i;
      if (!((i = this.analytics) != null && i.previousPeriod)) return;
      const e = kp(
        this.analytics.previousPeriod.startDate
      ), t = kp(
        this.analytics.previousPeriod.endDate
      ), n = this.$d(e, "long"), r = this.$d(t, "long");
      return `${n} → ${r}`;
    },
    apiParams() {
      return {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        stores: this.selectedStoreIds,
        comparisonType: this.comparisonType
      };
    },
    dailyContractsSoldData() {
      const e = this.analytics.sales.dailyPlanSales.current.map(
        (n) => ({
          date: n.date,
          value: n.count
        })
      );
      let t = [];
      return this.analytics.sales.dailyPlanSales.previous && (t = e.map((n, r) => {
        var i;
        return {
          date: n.date,
          value: ((i = this.analytics.sales.dailyPlanSales.previous[r]) == null ? void 0 : i.count) || 0
        };
      })), {
        sold: {
          color: "#8C1EFC",
          value: e
        },
        "previous contracts sold": {
          color: "#D1D5DB",
          value: t
        }
      };
    },
    storeOptions() {
      return this.availableStores.map((e) => ({
        value: e.id,
        label: e.salesChannel
      }));
    },
    dailyContractsSoldOptions() {
      return {
        responsive: !0,
        maintainAspectRatio: !1,
        interaction: {
          mode: "index",
          intersect: !1
        },
        scales: {
          x: {
            grid: {
              display: !1
            },
            title: {
              display: !0,
              text: "Date"
            },
            ticks: {
              maxRotation: 0,
              minRotation: 0,
              align: "center",
              textAlign: "center",
              callback: this.xAxisCallback
            }
          },
          y: {
            grid: {
              display: !1,
              drawBorder: !1
            },
            beginAtZero: !0,
            title: {
              display: !0,
              text: "Ventes"
            },
            ticks: {
              maxTicksLimit: 2,
              callback: this.yAxisCallback
            },
            suggestedMax: Math.max(
              1,
              ...this.dailyContractsSoldData.sold.value.map((e) => e.value),
              ...this.dailyContractsSoldData["previous contracts sold"].value.map((e) => e.value)
            ),
            max: Math.max(
              1,
              ...this.dailyContractsSoldData.sold.value.map((e) => e.value),
              ...this.dailyContractsSoldData["previous contracts sold"].value.map((e) => e.value)
            )
          }
        },
        plugins: {
          annotation: !1,
          datalabels: !1,
          legend: { display: !1 },
          tooltip: {
            callbacks: {
              label: (e) => ` ${e.dataset.label} : ${e.raw.y.toLocaleString()}`
            }
          }
        }
      };
    },
    dailyContractsSoldSubtitle() {
      var e, t, n;
      return (n = (t = (e = this.analytics) == null ? void 0 : e.general) == null ? void 0 : t.periodContracts) == null ? void 0 : n.current;
    }
  },
  methods: {
    formatPrice: lf,
    formatPercentage: Bg,
    isPresent: ar,
    xAxisCallback(e, t, n) {
      var r;
      return t === 0 || t === n.length - 1 || t % 4 === 0 ? ((r = this.dailyContractsSoldData.sold.value[t]) == null ? void 0 : r.date) || e : "";
    },
    yAxisCallback(e) {
      const t = Math.max(
        0,
        ...this.dailyContractsSoldData.sold.value.map((n) => n.value),
        ...this.dailyContractsSoldData["previous contracts sold"].value.map(
          (n) => n.value
        )
      );
      return e === 0 || e === t ? e : "";
    },
    dateRangeUpdated(e) {
      this.dateRange = e;
      const t = this.getDefaultComparisonTypeForRange(e);
      t !== this.comparisonType && (this.comparisonType = t), this.requestAnalytics();
    },
    getDefaultComparisonTypeForRange(e) {
      const [t, n] = e.map((r) => new Date(r));
      return Um(t, n) ? "previousWeek" : EE(t, n) ? "previousYear" : Bm(t, n) ? "previousMonth" : "previousPeriod";
    },
    async requestAnalytics() {
      this.$emit("filtersUpdated", this.apiParams);
    },
    // Example : { sales_channel: { name: "Sales Channel", value: "Store name" }
    // => { "Sales Channel" : "Store name" } for proper data display in DataCard
    format(e) {
      return Object.values(e).reduce((t, { name: n, value: r }) => (t[n] = r, t), {});
    },
    handleComparisonTypeChange(e) {
      this.comparisonType = e, this.requestAnalytics();
    }
  }
}, SQ = { class: "flex flex-col gap-8" }, OQ = { class: "bg-white shadow sm:rounded-t-md py-6 px-4 sm:px-6 lg:px-8" }, CQ = { class: "flex flex-col sm:flex-row justify-between items-center gap-y-4 sm:gap-y-0 w-full" }, AQ = { class: "flex flex-col sm:flex-row items-center gap-y-2 sm:gap-y-0 gap-x-2 w-full sm:w-auto" }, DQ = {
  key: 0,
  class: "text-sm text-gray-700"
}, PQ = {
  key: 2,
  class: "text-xs"
}, MQ = { key: 0 }, IQ = { class: "grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" }, NQ = { class: "mt-8" }, LQ = { class: "text-lg pb-6 pl-2 tracking-tight text-gray-700 text-left" }, RQ = { class: "text-sm ml-4 text-gray-500" }, FQ = { class: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2" }, $Q = {
  key: 0,
  class: "bg-white px-6 py-4 mt-4 rounded-lg shadow-lg"
}, VQ = { class: "px-4 sm:px-6 lg:px-8" }, BQ = { class: "mt-3 flow-root" }, UQ = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }, WQ = { class: "inline-block min-w-full py-2 align-middle" }, HQ = { class: "mt-8" }, jQ = { class: "mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3" };
function YQ(e, t, n, r, i, a) {
  var b, w, T, S, x, O, C;
  const o = je("AnalyticsDateRangePicker"), s = je("Selector"), u = je("MultiSelect"), d = je("DataCardWithVariation"), f = je("Variation"), p = je("LineChart"), m = je("PieChart"), g = je("SellerRankingTable"), v = je("DataCard");
  return I(), W("div", SQ, [
    K("div", OQ, [
      K("div", CQ, [
        K("div", AQ, [
          Ae(o, {
            class: "text-sm w-full sm:w-64 rounded-md",
            placeholder: e.$t("Select a time range"),
            modelValue: i.dateRange,
            "onUpdate:modelValue": [
              t[0] || (t[0] = (P) => i.dateRange = P),
              a.dateRangeUpdated
            ]
          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
          a.previsousPeriodStartDate ? (I(), W("span", DQ, "par rapport à")) : ee("", !0),
          a.previsousPeriodStartDate ? (I(), Oe(s, {
            key: 1,
            id: "comparison-type-selector",
            name: "comparisonType",
            class: "text-xs rounded-lg border-gray-300 shadow-md text-sm w-full sm:w-52 rounded-md",
            modelValue: i.comparisonType,
            options: i.comparisonTypeOptions,
            "onUpdate:modelValue": a.handleComparisonTypeChange
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])) : ee("", !0),
          a.previsousPeriodStartDate ? (I(), W("span", PQ, ke(a.comparisonPeriodFormatted), 1)) : ee("", !0)
        ]),
        n.store ? ee("", !0) : (I(), Oe(u, {
          key: 0,
          name: "stores",
          label: "Points de vente",
          options: a.storeOptions,
          modelValue: i.selectedStoreIds,
          "onUpdate:modelValue": t[1] || (t[1] = (P) => i.selectedStoreIds = P)
        }, null, 8, ["options", "modelValue"]))
      ])
    ]),
    a.isPresent(n.analytics) ? (I(), W("div", MQ, [
      K("div", null, [
        K("dl", IQ, [
          Ae(d, {
            title: "Contrats aujourd'hui",
            tooltipText: "Nombre de contrats vendus aujourd'hui.",
            data: n.analytics.general.todayContracts
          }, null, 8, ["data"]),
          Ae(d, {
            title: "Contrats période",
            tooltipText: "Nombre de contrats vendus pendant la période sélectionnée.",
            data: n.analytics.general.periodContracts,
            comparisonType: i.comparisonType
          }, null, 8, ["data", "comparisonType"]),
          Ae(d, {
            title: "Taux de résiliation",
            tooltipText: "Pourcentage de contrats résiliés par rapport au total des contrats vendus pendant la période sélectionnée.",
            data: n.analytics.general.resiliationRate,
            comparisonType: i.comparisonType
          }, null, 8, ["data", "comparisonType"]),
          a.isPresent((b = n.analytics.general.premium) == null ? void 0 : b.current) ? (I(), Oe(d, {
            key: 0,
            title: "Prime TTC",
            tooltipText: "Montant total des primes TTC générées par les contrats.",
            data: n.analytics.general.premium,
            comparisonType: i.comparisonType
          }, null, 8, ["data", "comparisonType"])) : ee("", !0),
          a.isPresent((w = n.analytics.general.commission) == null ? void 0 : w.current) ? (I(), Oe(d, {
            key: 1,
            title: "Rémunération",
            data: n.analytics.general.commission,
            comparisonType: i.comparisonType
          }, {
            tooltip: Ve(() => t[3] || (t[3] = [
              K("span", null, " Montant total des commissions perçues, incluant la rémunération générée par les nouvelles ventes, la rémunération récurrente et les reprises de commission en cas de résiliation. ", -1),
              K("br", null, null, -1),
              K("br", null, null, -1),
              K("span", null, " Ce montant ne prend pas en compte les décalages de commissions liés à des impayés. ", -1)
            ])),
            _: 1
          }, 8, ["data", "comparisonType"])) : ee("", !0),
          a.isPresent((T = n.analytics.general.averageCommission) == null ? void 0 : T.current) ? (I(), Oe(d, {
            key: 2,
            title: "Rémunération annuelle moyenne",
            tooltipText: "Montant moyen de rémunération annuelle par contrat.",
            data: n.analytics.general.averageCommission,
            comparisonType: i.comparisonType
          }, null, 8, ["data", "comparisonType"])) : ee("", !0),
          a.isPresent((S = n.analytics.general.periodLeads) == null ? void 0 : S.current) ? (I(), Oe(d, {
            key: 3,
            title: "Devis envoyés",
            tooltipText: "Nombre total de devis envoyés durant la période sélectionnée. N'inclut pas les paiements effectués sur l'écran vendeur.",
            data: n.analytics.general.periodLeads,
            comparisonType: i.comparisonType
          }, null, 8, ["data", "comparisonType"])) : ee("", !0),
          a.isPresent((x = n.analytics.general.leadsConversionRate) == null ? void 0 : x.current) ? (I(), Oe(d, {
            key: 4,
            title: "Taux de conversion des devis",
            tooltipText: "Pourcentage de devis convertis en contrats.",
            data: n.analytics.general.leadsConversionRate,
            comparisonType: i.comparisonType
          }, null, 8, ["data", "comparisonType"])) : ee("", !0)
        ])
      ]),
      K("div", NQ, [
        t[5] || (t[5] = K("p", { class: "text-3xl font-bold ml-3" }, "Ventes", -1)),
        Ae(p, {
          class: "mt-8",
          title: "Nouveaux contrats",
          tooltipText: "Nombre de nouveaux contrats vendus par jour durant la période sélectionnée.",
          data: a.dailyContractsSoldData,
          options: a.dailyContractsSoldOptions
        }, {
          subtitle: Ve(() => {
            var P, k, M, N, X, Z, te, ce, we;
            return [
              K("p", LQ, [
                Xt(ke((M = (k = (P = n.analytics) == null ? void 0 : P.general) == null ? void 0 : k.periodContracts) == null ? void 0 : M.current), 1),
                K("span", RQ, ke((Z = (X = (N = n.analytics) == null ? void 0 : N.general) == null ? void 0 : X.periodContracts) == null ? void 0 : Z.previous) + " " + ke(i.comparisonType ? e.$t(i.comparisonType) : ""), 1),
                Ae(f, {
                  class: "ml-2",
                  variation: (we = (ce = (te = n.analytics) == null ? void 0 : te.general) == null ? void 0 : ce.periodContracts) == null ? void 0 : we.variation
                }, null, 8, ["variation"])
              ])
            ];
          }),
          _: 1
        }, 8, ["data", "options"]),
        K("div", FQ, [
          Ae(m, {
            class: "mt-5",
            title: "Répartition par formule",
            data: a.format(n.analytics.sales.verticalRepartition),
            maxCategories: 12,
            tooltipText: "Répartition des ventes selon la formule d'assurance souscrite."
          }, null, 8, ["data"]),
          Ae(m, {
            class: "mt-5",
            title: "Répartition mensuelle/annuelle",
            data: a.format(n.analytics.sales.monthlyAnnuallyRepartition),
            tooltipText: "Proportion des ventes effectuées avec un paiement mensuel ou annuel."
          }, null, 8, ["data"]),
          Ae(m, {
            class: "mt-5",
            title: "Répartition par durée de contrat",
            data: a.format(n.analytics.sales.periodRepartition),
            tooltipText: "Répartition des ventes en fonction de la durée d'engagement des contrats."
          }, null, 8, ["data"]),
          a.isPresent(n.analytics.sales.sellersRanking) ? (I(), W("div", $Q, [
            t[4] || (t[4] = K("h1", { class: "text-xl pb-4 pl-2 font-bold tracking-tight text-gray-900 text-left" }, " Classement des vendeurs ", -1)),
            K("div", VQ, [
              K("div", BQ, [
                K("div", UQ, [
                  K("div", WQ, [
                    Ae(g, {
                      data: (C = (O = n.analytics) == null ? void 0 : O.sales) == null ? void 0 : C.sellersRanking
                    }, null, 8, ["data"]),
                    K("button", {
                      class: "mt-3 hover:underline focus:outline-none text-sm",
                      onClick: t[2] || (t[2] = (P) => e.$emit("viewSellersRanking"))
                    }, " Voir plus ")
                  ])
                ])
              ])
            ])
          ])) : ee("", !0)
        ])
      ]),
      K("div", HQ, [
        t[6] || (t[6] = K("p", { class: "text-3xl font-bold ml-3" }, "Sinistres", -1)),
        K("dl", jQ, [
          Ae(v, {
            title: "Sinistres déclarés",
            value: n.analytics.claims.claimsFiledCount,
            tooltipText: "Nombre de sinistres déclarés pendant la période sélectionnée."
          }, null, 8, ["value"]),
          Ae(v, {
            title: "Taux d'acceptation",
            value: a.formatPercentage(n.analytics.claims.acceptedClaimsRate),
            tooltipText: "Pourcentage de sinistres acceptés par rapport aux sinistres déclarés pendant la période sélectionnée."
          }, null, 8, ["value"]),
          Ae(v, {
            title: "Montant remboursé",
            value: a.formatPrice(n.analytics.claims.reimbursedClaimsAmount),
            tooltipText: "Montant total remboursé pour les sinistres acceptés pendant la période sélectionnée."
          }, null, 8, ["value"])
        ])
      ])
    ])) : ee("", !0)
  ]);
}
const Vee = /* @__PURE__ */ pt(kQ, [["render", YQ]]), zQ = {
  props: {
    secondary: {
      type: Boolean,
      default: !1
    },
    noScaling: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    defaultStyle: {
      type: String,
      default: "bg-primary border-transparent text-button-font-primary"
    }
  },
  computed: {
    cls() {
      return this.disabled ? "bg-gray-300 border-transparent text-gray-700 cursor-not-allowed" : this.secondary ? "bg-white border-gray-300 text-gray-700" : this.defaultStyle;
    }
  }
}, GQ = ["disabled"];
function qQ(e, t, n, r, i, a) {
  return I(), W("button", {
    class: ze([
      "px-4 py-2",
      "border shadow-sm rounded-lg focus:outline-none focus:ring-primary",
      "text-sm font-medium",
      "inline-block",
      n.noScaling ? "" : "transition duration-300 transform hover:scale-105",
      a.cls
    ]),
    disabled: n.disabled
  }, [
    Ee(e.$slots, "default")
  ], 10, GQ);
}
const Bee = /* @__PURE__ */ pt(zQ, [["render", qQ]]), KQ = {
  components: {
    Dialog: uU,
    DialogPanel: cU,
    TransitionChild: ZE,
    TransitionRoot: QE,
    XIcon: X4
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    },
    size: {
      type: String,
      default: "small"
    },
    showCloseButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  computed: {
    modalWidth() {
      switch (this.size) {
        case "small":
          return "max-w-2xl";
        case "medium":
          return "max-w-4xl";
        case "big":
          return "max-w-6xl";
        default:
          return "max-w-2xl";
      }
    }
  }
}, XQ = { class: "fixed z-10 inset-0 overflow-y-auto" }, ZQ = { class: "flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0" };
function QQ(e, t, n, r, i, a) {
  const o = je("TransitionChild"), s = je("XIcon"), u = je("DialogPanel"), d = je("Dialog"), f = je("TransitionRoot");
  return I(), W("div", null, [
    Ae(f, {
      as: "template",
      show: n.open
    }, {
      default: Ve(() => [
        Ae(d, {
          as: "div",
          class: "relative z-30"
        }, {
          default: Ve(() => [
            Ae(o, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: Ve(() => t[1] || (t[1] = [
                K("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            K("div", XQ, [
              K("div", ZQ, [
                Ae(o, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: Ve(() => [
                    Ae(u, {
                      class: ze([
                        "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-visible shadow-xl transform transition-all sm:my-16 sm:max-w-2xl sm:w-full sm:p-8",
                        `sm:${a.modalWidth}`
                      ])
                    }, {
                      default: Ve(() => [
                        n.showCloseButton ? (I(), Oe(s, {
                          key: 0,
                          class: "absolute cursor-pointer top-0 right-0 h-6 w-6 m-2 text-gray-500",
                          onClick: t[0] || (t[0] = (p) => e.$emit("close"))
                        })) : ee("", !0),
                        Ee(e.$slots, "default")
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"])
  ]);
}
const JQ = /* @__PURE__ */ pt(KQ, [["render", QQ]]);
var eJ = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, tJ = function(t, n, r) {
  var i, a = eJ[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + i : "il y a " + i : i;
}, nJ = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, rJ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, iJ = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, aJ = {
  date: _s({
    formats: nJ,
    defaultWidth: "full"
  }),
  time: _s({
    formats: rJ,
    defaultWidth: "full"
  }),
  dateTime: _s({
    formats: iJ,
    defaultWidth: "full"
  })
}, oJ = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, sJ = function(t, n, r, i) {
  return oJ[t];
}, lJ = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, uJ = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, cJ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, dJ = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, fJ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, hJ = function(t, n) {
  var r = Number(t), i = n == null ? void 0 : n.unit;
  if (r === 0) return "0";
  var a = ["year", "week", "hour", "minute", "second"], o;
  return r === 1 ? o = i && a.includes(i) ? "ère" : "er" : o = "ème", r + o;
}, pJ = {
  ordinalNumber: hJ,
  era: Oi({
    values: lJ,
    defaultWidth: "wide"
  }),
  quarter: Oi({
    values: uJ,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Oi({
    values: cJ,
    defaultWidth: "wide"
  }),
  day: Oi({
    values: dJ,
    defaultWidth: "wide"
  }),
  dayPeriod: Oi({
    values: fJ,
    defaultWidth: "wide"
  })
}, mJ = /^(\d+)(ième|ère|ème|er|e)?/i, gJ = /\d+/i, vJ = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, _J = {
  any: [/^av/i, /^ap/i]
}, yJ = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, bJ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wJ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, xJ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, EJ = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, TJ = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, kJ = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, SJ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, OJ = {
  ordinalNumber: tE({
    matchPattern: mJ,
    parsePattern: gJ,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: Ci({
    matchPatterns: vJ,
    defaultMatchWidth: "wide",
    parsePatterns: _J,
    defaultParseWidth: "any"
  }),
  quarter: Ci({
    matchPatterns: yJ,
    defaultMatchWidth: "wide",
    parsePatterns: bJ,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ci({
    matchPatterns: wJ,
    defaultMatchWidth: "wide",
    parsePatterns: xJ,
    defaultParseWidth: "any"
  }),
  day: Ci({
    matchPatterns: EJ,
    defaultMatchWidth: "wide",
    parsePatterns: TJ,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ci({
    matchPatterns: kJ,
    defaultMatchWidth: "any",
    parsePatterns: SJ,
    defaultParseWidth: "any"
  })
}, Gw = {
  code: "fr",
  formatDistance: tJ,
  formatLong: aJ,
  formatRelative: sJ,
  localize: pJ,
  match: OJ,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const CJ = {
  components: { Datepicker: du },
  props: {
    placeholder: {
      type: String,
      default: "Sélectionnez un mois"
    },
    modelValue: {
      type: Array,
      required: !0
    }
  },
  computed: {
    internalValue: {
      get() {
        if (!this.modelValue || this.modelValue.length !== 2)
          return null;
        const [e, t] = this.modelValue;
        return [
          e ? { year: e.getFullYear(), month: e.getMonth() } : null,
          t ? { year: t.getFullYear(), month: t.getMonth() } : null
        ];
      },
      set(e) {
        if (Array.isArray(e) && e.length === 2) {
          const [t, n] = e, r = t ? cu(new Date(t.year, t.month)) : null, i = n ? Cm(new Date(n.year, n.month)) : null;
          r && i ? this.$emit("update:modelValue", [r, i]) : console.warn("Incomplete date range, not emitting update:", e);
        } else
          console.warn("Invalid value passed to setter:", e), this.$emit("update:modelValue", [null, null]);
      }
    }
  },
  methods: {
    formatPicker(e) {
      if (!e || e.length < 2) return "";
      const [t, n] = e;
      if (!t || !n) return "";
      const r = Li(t, "MMM yyyy", { locale: Gw }), i = Li(n, "MMM yyyy", { locale: Gw });
      return r === i ? r : `${r} - ${i}`;
    }
  }
};
function AJ(e, t, n, r, i, a) {
  const o = je("Datepicker");
  return I(), Oe(o, {
    placeholder: n.placeholder,
    class: "text-xs w-full rounded-md",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s),
    "month-picker": !0,
    "auto-apply": !0,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date(),
    clearable: !0,
    range: "",
    format: a.formatPicker
  }, null, 8, ["placeholder", "modelValue", "max-date", "format"]);
}
const Uee = /* @__PURE__ */ pt(CJ, [["render", AJ]]), DJ = {}, PJ = { class: "container mx-auto mt-20" };
function MJ(e, t, n, r, i, a) {
  const o = je("router-link");
  return I(), W("div", PJ, [
    t[1] || (t[1] = K("h1", { class: "text-3xl font-bold text-center" }, "404", -1)),
    t[2] || (t[2] = K("p", { class: "text-center" }, "Page non trouvée", -1)),
    Ae(o, {
      to: "/",
      class: "block text-center mt-4 text-primary"
    }, {
      default: Ve(() => t[0] || (t[0] = [
        Xt(" Retour à l'accueil ")
      ])),
      _: 1
    })
  ]);
}
const Wee = /* @__PURE__ */ pt(DJ, [["render", MJ]]), IJ = {
  props: {
    currentPage: {
      type: Number,
      required: !0
    },
    totalPages: {
      type: Number,
      required: !1
    },
    totalCount: {
      type: Number,
      required: !1
    },
    elementsPerPage: {
      type: Number,
      default: 25
    }
  },
  computed: {
    displayed() {
      return this.displayPaginationDetails && this.totalPages > 1 || !this.displayPaginationDetails;
    },
    displayPaginationDetails() {
      return ar(this.totalPages) && ar(this.totalCount);
    },
    startIdx() {
      return (this.currentPage - 1) * this.elementsPerPage;
    },
    endIdx() {
      return Math.min(this.startIdx + this.elementsPerPage, this.totalCount);
    }
  },
  methods: {
    changePage(e) {
      e === this.currentPage || e === 0 || this.displayPaginationDetails && e > this.totalPages || this.$emit("changePage", e);
    }
  }
}, NJ = {
  key: 0,
  class: "bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 sticky bottom-0 z-10"
}, LJ = { class: "flex-1 flex justify-between" }, RJ = ["disabled"], FJ = { class: "flex text-xs text-gray-700" }, $J = { key: 0 }, VJ = { class: "font-medium" }, BJ = { class: "font-medium" }, UJ = { class: "font-medium" }, WJ = { key: 1 };
function HJ(e, t, n, r, i, a) {
  return a.displayed ? (I(), W("div", NJ, [
    K("div", LJ, [
      K("div", null, [
        K("button", {
          class: ze(["relative inline-flex items-center mr-3 px-2 py-1 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50", { "opacity-50 cursor-not-allowed": n.currentPage === 1 }]),
          onClick: t[0] || (t[0] = (o) => a.changePage(n.currentPage - 1)),
          disabled: n.currentPage === 1
        }, " Précédent ", 10, RJ),
        !a.displayPaginationDetails || n.currentPage < n.totalPages ? (I(), W("button", {
          key: 0,
          class: "relative inline-flex items-center px-2 py-1 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",
          onClick: t[1] || (t[1] = (o) => a.changePage(n.currentPage + 1))
        }, " Suivant ")) : ee("", !0)
      ])
    ]),
    K("div", FJ, [
      a.displayPaginationDetails ? (I(), W("p", $J, [
        t[2] || (t[2] = Xt(" Affichage des éléments ")),
        K("span", VJ, ke(a.startIdx + 1), 1),
        t[3] || (t[3] = Xt(" à ")),
        K("span", BJ, ke(a.endIdx), 1),
        t[4] || (t[4] = Xt(" sur un total de ")),
        K("span", UJ, ke(n.totalCount), 1)
      ])) : (I(), W("p", WJ, "Page : " + ke(n.currentPage), 1))
    ])
  ])) : ee("", !0);
}
const jJ = /* @__PURE__ */ pt(IJ, [["render", HJ]]), YJ = {
  props: {
    max: {
      type: Number,
      required: !0
    },
    value: {
      type: Number,
      required: !0
    }
  }
}, zJ = ["max", "value"];
function GJ(e, t, n, r, i, a) {
  return I(), W("progress", {
    max: n.max,
    value: n.value,
    class: "w-full h-2"
  }, null, 8, zJ);
}
const Hee = /* @__PURE__ */ pt(YJ, [["render", GJ], ["__scopeId", "data-v-19009925"]]);
function qJ(e) {
  return e !== null ? e.charAt(0).toUpperCase() + e.slice(1) : null;
}
function KJ(e) {
  return e.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, "$1").toLowerCase();
}
const XJ = {
  components: {
    MultiSelect: JE
  },
  props: {
    filterName: {
      type: String,
      required: !0
    },
    filterIdx: {
      type: Number,
      required: !0
    },
    availableFilters: {
      type: Array,
      required: !0
    },
    selectedFilters: {
      type: Array,
      required: !0
    },
    enableSelectAll: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data() {
    return {
      searchKeyword: ""
    };
  },
  computed: {
    selectedOptions: {
      get() {
        return this.selectedFilters[this.filterName];
      },
      set(e) {
        this.updateSelectedOptions(e);
      }
    },
    availableOptions() {
      return this.availableFilters[this.filterName].map((e) => this.hasLabelValue(e) ? { label: e.label, value: e.value } : { label: e, value: e });
    },
    cleanFilterName() {
      return qJ(KJ(this.filterName));
    }
  },
  methods: {
    updateSelectedOptions(e) {
      this.$emit("updateFilterSearch", this.filterName, e);
    },
    hasLabelValue(e) {
      return e.label !== void 0 && e.value !== void 0;
    }
  }
};
function ZJ(e, t, n, r, i, a) {
  const o = je("MultiSelect");
  return I(), Oe(o, {
    name: `${n.filterName}${n.filterIdx}`,
    label: e.$t(a.cleanFilterName),
    options: a.availableOptions,
    enableSelectAll: n.enableSelectAll,
    modelValue: a.selectedOptions,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => a.selectedOptions = s)
  }, null, 8, ["name", "label", "options", "enableSelectAll", "modelValue"]);
}
const jee = /* @__PURE__ */ pt(XJ, [["render", ZJ]]), QJ = {}, JJ = {
  class: "motion-reduce:hidden animate-spin -ml-1 mr-3 h-5 w-5 text-primary",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function eee(e, t) {
  return I(), W("svg", JJ, t[0] || (t[0] = [
    K("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }, null, -1),
    K("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }, null, -1)
  ]));
}
const tee = /* @__PURE__ */ pt(QJ, [["render", eee]]), nee = {
  components: {
    Spinner: tee
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, ree = ["disabled"];
function iee(e, t, n, r, i, a) {
  const o = je("Spinner");
  return I(), W("button", {
    type: "button",
    class: "cursor-pointer rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 flex items-center",
    disabled: n.loading || n.disabled
  }, [
    n.loading ? (I(), Oe(o, {
      key: 0,
      class: "mr-2"
    })) : ee("", !0),
    Ee(e.$slots, "default")
  ], 8, ree);
}
const Yee = /* @__PURE__ */ pt(nee, [["render", iee]]), aee = {
  components: { SellerRankingTable: CS, Pagination: jJ, Table: Ug, Modal: JQ },
  props: {
    open: {
      type: Boolean,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    totalCount: {
      type: Number,
      required: !0
    },
    totalPages: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !0
    }
  },
  methods: {
    handleChangePage(e) {
      this.$emit("changePage", e);
    },
    closeModal() {
      this.$emit("closeModal");
    }
  }
};
function oee(e, t, n, r, i, a) {
  const o = je("SellerRankingTable"), s = je("Pagination"), u = je("Modal");
  return I(), Oe(u, {
    open: n.open,
    onClose: a.closeModal,
    size: "medium"
  }, {
    default: Ve(() => [
      t[0] || (t[0] = K("h1", { class: "text-center text-xl font-bold" }, "Classement vendeurs", -1)),
      Ae(o, { data: n.data }, null, 8, ["data"]),
      Ae(s, {
        "current-page": n.currentPage,
        totalCount: n.totalCount,
        totalPages: n.totalPages,
        elementsPerPage: 5,
        onChangePage: a.handleChangePage
      }, null, 8, ["current-page", "totalCount", "totalPages", "onChangePage"])
    ]),
    _: 1
  }, 8, ["open", "onClose"]);
}
const zee = /* @__PURE__ */ pt(aee, [["render", oee]]), see = {
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    tabClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    selectTab(e) {
      this.$emit("tab-selected", e), this.tabs.forEach((t) => {
        t.current = t.name === e.name;
      });
    }
  }
}, lee = { class: "mb-4 border-b border-gray-200" }, uee = {
  class: "-mb-px flex space-x-8",
  "aria-label": "Tabs"
}, cee = ["onClick"];
function dee(e, t, n, r, i, a) {
  return I(), W("div", null, [
    K("div", lee, [
      K("nav", uee, [
        (I(!0), W(Ge, null, Nt(n.tabs, (o) => (I(), W("a", {
          key: o.name,
          onClick: nr((s) => a.selectTab(o), ["prevent"]),
          class: ze([
            o.current ? "border-primary text-primary-dark" : "border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700",
            "whitespace-nowrap border-b-2 py-2 px-1 text-sm font-medium cursor-pointer",
            n.tabClass
          ])
        }, ke(o.displayName), 11, cee))), 128))
      ])
    ]),
    (I(!0), W(Ge, null, Nt(n.tabs, (o) => (I(), W("div", {
      key: o.name
    }, [
      o.current ? Ee(e.$slots, o.name, { key: 0 }) : ee("", !0)
    ]))), 128))
  ]);
}
const fee = /* @__PURE__ */ pt(see, [["render", dee]]), hee = {
  components: { Tabs: fee },
  props: {
    tabs: {
      type: Array,
      required: !0
    }
  },
  computed: {
    tabsWithCurrent() {
      const e = this.tabs.map((t) => ({ ...t, current: this.isCurrent(t) }));
      return e.every((t) => !t.current) && (e[0].current = !0), e;
    }
  },
  methods: {
    goTo(e) {
      this.$router.push({
        path: e.path || this.$route.path,
        query: { ...this.$route.query, ...e.query }
        // 🔥 On fusionne les paramètres
      });
    },
    isCurrent(e) {
      var t;
      return e.path ? this.$route.matched.some((n) => n.path === e.path) : this.$route.query.tab === ((t = e.query) == null ? void 0 : t.tab);
    }
  }
};
function pee(e, t, n, r, i, a) {
  const o = je("Tabs");
  return I(), Oe(o, {
    tabs: a.tabsWithCurrent,
    onTabSelected: a.goTo,
    class: "mb-6"
  }, null, 8, ["tabs", "onTabSelected"]);
}
const Gee = /* @__PURE__ */ pt(hee, [["render", pee]]), mee = {
  props: {
    title: {
      type: String,
      required: !0
    }
  }
}, gee = { class: "flex" }, vee = { class: "text-4xl font-extrabold pl-2 tracking-tight text-gray-900 my-4" };
function _ee(e, t, n, r, i, a) {
  return I(), W("div", gee, [
    K("h1", vee, ke(e.$t(n.title)), 1),
    Ee(e.$slots, "default")
  ]);
}
const qee = /* @__PURE__ */ pt(mee, [["render", _ee]]), yee = {
  mounted(e, t) {
    e._clickOutside = (n) => {
      e === n.target || e.contains(n.target) || t.value(n);
    }, document.addEventListener("click", e._clickOutside);
  },
  unmounted(e) {
    document.removeEventListener("click", e._clickOutside);
  }
}, bee = {
  name: "FilterButton",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, wee = ["disabled"];
function xee(e, t, n, r, i, a) {
  return I(), W("button", {
    type: "button",
    class: "flex items-center px-2 py-1 border border-dashed border-gray-300 rounded-full bg-transparent text-gray-700 font-medium text-base transition-colors duration-150 hover:bg-gray-200 cursor-pointer",
    disabled: n.disabled
  }, [
    Ee(e.$slots, "default")
  ], 8, wee);
}
const Eee = /* @__PURE__ */ pt(bee, [["render", xee]]), Tee = {
  components: { FilterButton: Eee },
  directives: {
    clickOutside: yee
  },
  data() {
    return {
      show: !1
    };
  },
  methods: {
    togglePopover(e) {
      e.stopPropagation(), this.show = !this.show;
    },
    closePopover() {
      this.show = !1;
    }
  }
}, kee = { class: "relative" };
function See(e, t, n, r, i, a) {
  const o = je("FilterButton"), s = fI("click-outside");
  return I(), W("div", kee, [
    Ae(o, { onClick: a.togglePopover }, {
      default: Ve(() => [
        Ee(e.$slots, "button")
      ]),
      _: 3
    }, 8, ["onClick"]),
    Ni((I(), W("div", {
      class: ze([
        "absolute z-2000 inline-block w-64 text-sm transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-xs",
        i.show ? "opacity-100 visible" : "opacity-0 invisible"
      ])
    }, [
      Ee(e.$slots, "content")
    ], 2)), [
      [Ol, i.show],
      [s, a.closePopover]
    ])
  ]);
}
const Kee = /* @__PURE__ */ pt(Tee, [["render", See]]);
export {
  i5 as Alert,
  s5 as AnalyticsDateRangePicker,
  Aee as Checkbox,
  Fee as ClaimDeclaration,
  Kee as ClickPopoverButton,
  $ee as CollapsableContent,
  P5 as DataCart,
  Dee as DataList,
  Pee as DateRangePicker,
  Mee as FileField,
  Eee as FilterButton,
  Iee as FormField,
  Vee as GeneralAnalytics,
  Bee as GenericButton,
  QG as LineChart,
  $Z as Loading,
  Nee as LocationField,
  JQ as Modal,
  Uee as MonthPicker,
  JE as MultiSelect,
  Wee as NotFound,
  qee as PageHeader,
  jJ as Pagination,
  Sq as PieChart,
  Hee as ProgressionBar,
  jee as SearchBarFilter,
  Yee as SecondaryButton,
  YU as Selector,
  zee as SellersRankingModal,
  tee as Spinner,
  Ug as Table,
  fee as Tabs,
  Gee as TabsNavigation,
  Ree as Textarea
};
